export type CityRaw = [
	id: number,
	name: string,
	nameAscii: string,
	country: string,
	countryIso3: string,
	capital: string,
	population: number
];

export const cities: CityRaw[] = [
[1392685764,"Tokyo","Tokyo","Japan","JPN","primary",39105000],
[1360771077,"Jakarta","Jakarta","Indonesia","IDN","primary",35362000],
[1356872604,"Delhi","Delhi","India","IND","admin",31870000],
[1608618140,"Manila","Manila","Philippines","PHL","primary",23971000],
[1076532519,"São Paulo","Sao Paulo","Brazil","BRA","admin",22495000],
[1410836482,"Seoul","Seoul","South Korea","KOR","primary",22394000],
[1356226629,"Mumbai","Mumbai","India","IND","admin",22186000],
[1156073548,"Shanghai","Shanghai","China","CHN","admin",22118000],
[1484247881,"Mexico City","Mexico City","Mexico","MEX","primary",21505000],
[1156237133,"Guangzhou","Guangzhou","China","CHN","admin",21489000],
[1818253931,"Cairo","Cairo","Egypt","EGY","primary",19787000],
[1156228865,"Beijing","Beijing","China","CHN","primary",19437000],
[1840034016,"New York","New York","United States","USA","",18713220],
[1356060520,"Kolkāta","Kolkata","India","IND","admin",18698000],
[1643318494,"Moscow","Moscow","Russia","RUS","primary",17693000],
[1764068610,"Bangkok","Bangkok","Thailand","THA","primary",17573000],
[1050529279,"Dhaka","Dhaka","Bangladesh","BGD","primary",16839000],
[1032717330,"Buenos Aires","Buenos Aires","Argentina","ARG","primary",16216000],
[1392419823,"Ōsaka","Osaka","Japan","JPN","admin",15490000],
[1566593751,"Lagos","Lagos","Nigeria","NGA","minor",15487000],
[1792756324,"Istanbul","Istanbul","Turkey","TUR","admin",15311000],
[1586129469,"Karachi","Karachi","Pakistan","PAK","admin",15292000],
[1180000363,"Kinshasa","Kinshasa","Congo (Kinshasa)","COD","primary",15056000],
[1156158707,"Shenzhen","Shenzhen","China","CHN","minor",14678000],
[1356410365,"Bangalore","Bangalore","India","IND","admin",13999000],
[1704774326,"Ho Chi Minh City","Ho Chi Minh City","Vietnam","VNM","admin",13954000],
[1364305026,"Tehran","Tehran","Iran","IRN","primary",13819000],
[1840020491,"Los Angeles","Los Angeles","United States","USA","",12750807],
[1076887657,"Rio de Janeiro","Rio de Janeiro","Brazil","BRA","admin",12486000],
[1156421555,"Chengdu","Chengdu","China","CHN","admin",11920000],
[1156256829,"Baoding","Baoding","China","CHN","",11860000],
[1356374944,"Chennai","Chennai","India","IND","admin",11564000],
[1586801463,"Lahore","Lahore","Pakistan","PAK","admin",11148000],
[1826645935,"London","London","United Kingdom","GBR","primary",11120000],
[1250015082,"Paris","Paris","France","FRA","primary",11027000],
[1156174046,"Tianjin","Tianjin","China","CHN","admin",10932000],
[1156086320,"Linyi","Linyi","China","CHN","",10820000],
[1156217541,"Shijiazhuang","Shijiazhuang","China","CHN","admin",10784600],
[1156183137,"Zhengzhou","Zhengzhou","China","CHN","admin",10136000],
[1156192287,"Nanyang","Nanyang","China","CHN","",10013600],
[1356871768,"Hyderābād","Hyderabad","India","IND","admin",9840000],
[1156117184,"Wuhan","Wuhan","China","CHN","admin",9729000],
[1156957080,"Handan","Handan","China","CHN","minor",9549700],
[1392407472,"Nagoya","Nagoya","Japan","JPN","admin",9522000],
[1156912965,"Weifang","Weifang","China","CHN","",9373000],
[1604728603,"Lima","Lima","Peru","PER","primary",8992000],
[1156272098,"Zhoukou","Zhoukou","China","CHN","minor",8953172],
[1024949724,"Luanda","Luanda","Angola","AGO","primary",8883000],
[1156832475,"Ganzhou","Ganzhou","China","CHN","minor",8677600],
[1156241678,"Tongshan","Tongshan","China","CHN","minor",8669000],
[1458988644,"Kuala Lumpur","Kuala Lumpur","Malaysia","MYS","primary",8639000],
[1840000494,"Chicago","Chicago","United States","USA","",8604203],
[1156225008,"Heze","Heze","China","CHN","minor",8287693],
[1156936556,"Chongqing","Chongqing","China","CHN","admin",8261000],
[1704413791,"Hanoi","Hanoi","Vietnam","VNM","primary",8246600],
[1156248008,"Fuyang","Fuyang","China","CHN","",8200264],
[1156961497,"Changsha","Changsha","China","CHN","admin",8154700],
[1156478242,"Dongguan","Dongguan","China","CHN","minor",8142000],
[1156504601,"Jining","Jining","China","CHN","",8081905],
[1156972469,"Jinan","Jinan","China","CHN","admin",7967400],
[1356081074,"Pune","Pune","India","IND","",7948000],
[1156738403,"Foshan","Foshan","China","CHN","minor",7905700],
[1170483426,"Bogotá","Bogota","Colombia","COL","primary",7743955],
[1356304381,"Ahmedabad","Ahmedabad","India","IND","minor",7717000],
[1156644065,"Nanjing","Nanjing","China","CHN","admin",7729000],
[1156078103,"Changchun","Changchun","China","CHN","admin",7674439],
[1156904299,"Tangshan","Tangshan","China","CHN","",7577289],
[1156698069,"Cangzhou","Cangzhou","China","CHN","",7544300],
[1834843853,"Dar es Salaam","Dar es Salaam","Tanzania","TZA","primary",7461000],
[1156332710,"Hefei","Hefei","China","CHN","admin",7457027],
[1344982653,"Hong Kong","Hong Kong","Hong Kong","HKG","primary",7398000],
[1156310366,"Shaoyang","Shaoyang","China","CHN","",7370500],
[1156502170,"Zhanjiang","Zhanjiang","China","CHN","minor",7332000],
[1156805441,"Shangqiu","Shangqiu","China","CHN","",7325300],
[1156045365,"Nantong","Nantong","China","CHN","minor",7283622],
[1156995410,"Yancheng","Yancheng","China","CHN","minor",7260240],
[1156605439,"Nanning","Nanning","China","CHN","admin",7254100],
[1156696884,"Hengyang","Hengyang","China","CHN","",7243400],
[1156184822,"Zhumadian","Zhumadian","China","CHN","",7231234],
[1156309382,"Shenyang","Shenyang","China","CHN","admin",7208000],
[1156294952,"Xingtai","Xingtai","China","CHN","",7104103],
[1156244079,"Xi’an","Xi'an","China","CHN","admin",7090000],
[1152554349,"Santiago","Santiago","Chile","CHL","primary",7026000],
[1156932948,"Yantai","Yantai","China","CHN","",6968202],
[1682999334,"Riyadh","Riyadh","Saudi Arabia","SAU","primary",6889000],
[1156069315,"Luoyang","Luoyang","China","CHN","",6888500],
[1156477539,"Kunming","Kunming","China","CHN","admin",6850000],
[1156405492,"Shangrao","Shangrao","China","CHN","minor",6810700],
[1156275243,"Hangzhou","Hangzhou","China","CHN","admin",6713000],
[1156018927,"Bijie","Bijie","China","CHN","",6686100],
[1156829655,"Quanzhou","Quanzhou","China","CHN","minor",6480000],
[1840015149,"Miami","Miami","United States","USA","",6445545],
[1156019650,"Wuxi","Wuxi","China","CHN","minor",6372624],
[1156200037,"Huanggang","Huanggang","China","CHN","minor",6333000],
[1156568722,"Maoming","Maoming","China","CHN","minor",6313200],
[1156762337,"Nanchong","Nanchong","China","CHN","minor",6278614],
[1156539782,"Zunyi","Zunyi","China","CHN","",6270700],
[1156747998,"Qujing","Qujing","China","CHN","",6155400],
[1368596238,"Baghdad","Baghdad","Iraq","IRQ","primary",6107000],
[1156273453,"Xinyang","Xinyang","China","CHN","",6109106],
[1156260378,"Jieyang","Jieyang","China","CHN","minor",6089400],
[1729268475,"Khartoum","Khartoum","Sudan","SDN","primary",6017000],
[1724616994,"Madrid","Madrid","Spain","ESP","primary",6006000],
[1356718332,"Allahābād","Allahabad","India","IND","",5954391],
[1156901312,"Yulin","Yulin","China","CHN","minor",5849700],
[1156449091,"Changde","Changde","China","CHN","minor",5827200],
[1156006600,"Liaocheng","Liaocheng","China","CHN","minor",5789863],
[1156112588,"Qingdao","Qingdao","China","CHN","minor",5775000],
[1840019440,"Dallas","Dallas","United States","USA","",5743938],
[1156127660,"Nangandao","Nangandao","China","CHN","minor",5708191],
[1156107325,"Xiangyang","Xiangyang","China","CHN","minor",5680000],
[1840000673,"Philadelphia","Philadelphia","United States","USA","",5649300],
[1818925479,"Giza","Giza","Egypt","EGY","admin",5598402],
[1156499624,"Lu’an","Lu'an","China","CHN","minor",5611701],
[1156924687,"Zhaotong","Zhaotong","China","CHN","",5591000],
[1156229590,"Yichun","Yichun","China","CHN","minor",5573200],
[1156524080,"Dezhou","Dezhou","China","CHN","minor",5568235],
[1404000661,"Nairobi","Nairobi","Kenya","KEN","primary",5545000],
[1156198892,"Nanchang","Nanchang","China","CHN","admin",5545500],
[1156095188,"Tai’an","Tai'an","China","CHN","",5494207],
[1156834076,"Dazhou","Dazhou","China","CHN","minor",5468097],
[1840020925,"Houston","Houston","United States","USA","",5464251],
[1484950208,"Guadalajara","Guadalajara","Mexico","MEX","admin",5437000],
[1156694479,"Yongzhou","Yongzhou","China","CHN","",5452100],
[1840013660,"Atlanta","Atlanta","United States","USA","admin",5449398],
[1104616656,"Rangoon","Rangoon","Myanmar","MMR","primary",5430000],
[1124279679,"Toronto","Toronto","Canada","CAN","admin",5429524],
[1156235493,"Suihua","Suihua","China","CHN","minor",5418153],
[1643616350,"Saint Petersburg","Saint Petersburg","Russia","RUS","admin",5384342],
[1840006060,"Washington","Washington","United States","USA","primary",5379184],
[1156775905,"Qiqihar","Qiqihar","China","CHN","minor",5367003],
[1156871297,"Suzhou","Suzhou","China","CHN","",5352924],
[1156457499,"Shantou","Shantou","China","CHN","minor",5319028],
[1156903687,"Weinan","Weinan","China","CHN","minor",5286077],
[1156185511,"Changzhou","Changzhou","China","CHN","minor",5278121],
[1702341327,"Singapore","Singapore","Singapore","SGP","primary",5271000],
[1156188037,"Fuzhou","Fuzhou","China","CHN","admin",5245000],
[1156644508,"Pudong","Pudong","China","CHN","minor",5187200],
[1076967355,"Belo Horizonte","Belo Horizonte","Brazil","BRA","admin",5159000],
[1156241637,"Zhangzhou","Zhangzhou","China","CHN","minor",5140000],
[1156705644,"Yuncheng","Yuncheng","China","CHN","",5134779],
[1156029196,"Suzhou","Suzhou","China","CHN","minor",5103000],
[1156120117,"Xianyang","Xianyang","China","CHN","minor",5096001],
[1156235364,"Guilin","Guilin","China","CHN","minor",5085500],
[1156119229,"Taizhou","Taizhou","China","CHN","minor",5031000],
[1384207980,"Abidjan","Abidjan","Côte d'Ivoire","CIV","primary",4980000],
[1156353465,"Huaihua","Huaihua","China","CHN","",4979600],
[1156278215,"Ji’an","Ji'an","China","CHN","minor",4956600],
[1156002290,"Xiaoganzhan","Xiaoganzhan","China","CHN","",4921000],
[1156735124,"Pingdingshan","Pingdingshan","China","CHN","",4904701],
[1156206041,"Jiujiang","Jiujiang","China","CHN","minor",4896800],
[1356758738,"Sūrat","Surat","India","IND","",4875000],
[1156932620,"Guiyang","Guiyang","China","CHN","admin",4881900],
[1818695837,"Alexandria","Alexandria","Egypt","EGY","admin",4870000],
[1156356860,"Bozhou","Bozhou","China","CHN","",4850657],
[1036074917,"Sydney","Sydney","Australia","AUS","admin",4840600],
[1156203268,"Huizhou","Huizhou","China","CHN","minor",4830000],
[1156634228,"Huai’an","Huai'an","China","CHN","",4799889],
[1156291915,"Chenzhou","Chenzhou","China","CHN","minor",4744500],
[1724594040,"Barcelona","Barcelona","Spain","ESP","admin",4735000],
[1156238875,"Anqing","Anqing","China","CHN","minor",4723000],
[1156212349,"Suqian","Suqian","China","CHN","",4719178],
[1840000455,"Boston","Boston","United States","USA","admin",4688346],
[1156105613,"Jiangmen","Jiangmen","China","CHN","minor",4630300],
[1156417758,"Mianyang","Mianyang","China","CHN","minor",4613862],
[1156241528,"Harbin","Harbin","China","CHN","admin",4583000],
[1156198356,"Huanglongsi","Huanglongsi","China","CHN","",4564900],
[1036533631,"Melbourne","Melbourne","Australia","AUS","admin",4529500],
[1156381094,"Zibo","Zibo","China","CHN","",4530597],
[1156175472,"Dalian","Dalian","China","CHN","",4480000],
[1156803028,"Hengshui","Hengshui","China","CHN","",4472000],
[1156107603,"Yibin","Yibin","China","CHN","minor",4471896],
[1156818601,"Yangzhou","Yangzhou","China","CHN","",4459760],
[1170815311,"Timbío","Timbio","Colombia","COL","minor",4444444],
[1710550792,"Johannesburg","Johannesburg","South Africa","ZAF","admin",4434827],
[1156218615,"Yiyang","Yiyang","China","CHN","",4413800],
[1156895251,"Guigang","Guigang","China","CHN","minor",4409200],
[1156035381,"Xinpu","Xinpu","China","CHN","minor",4393482],
[1156361028,"Meizhou","Meizhou","China","CHN","minor",4378800],
[1504175315,"Casablanca","Casablanca","Morocco","MAR","admin",4370000],
[1156109017,"Langfang","Langfang","China","CHN","",4358839],
[1156800221,"Zhangjiakou","Zhangjiakou","China","CHN","",4345485],
[1156277458,"Chifeng","Chifeng","China","CHN","minor",4341245],
[1156416074,"Linfen","Linfen","China","CHN","",4316610],
[1156235735,"Jiangguanchi","Jiangguanchi","China","CHN","minor",4307488],
[1004993580,"Kabul","Kabul","Afghanistan","AFG","primary",4273156],
[1840020568,"Phoenix","Phoenix","United States","USA","admin",4219697],
[1156582079,"Luzhou","Luzhou","China","CHN","minor",4218427],
[1156632014,"Taiyuan","Taiyuan","China","CHN","admin",4201592],
[1156170144,"Zhaoqing","Zhaoqing","China","CHN","minor",4151700],
[1156764447,"Xiaoxita","Xiaoxita","China","CHN","minor",4137900],
[1156212809,"Xiamen","Xiamen","China","CHN","minor",4110000],
[1156915325,"Fuzhou","Fuzhou","China","CHN","",4047200],
[1156360785,"Liuzhou","Liuzhou","China","CHN","minor",4041700],
[1156041962,"Zhuzhou","Zhuzhou","China","CHN","minor",4020800],
[1400522593,"Amman","Amman","Jordan","JOR","primary",4007526],
[1682926944,"Jeddah","Jeddah","Saudi Arabia","SAU","",3976000],
[1156036420,"Chuzhou","Chuzhou","China","CHN","",3937868],
[1156010654,"Loudi","Loudi","China","CHN","",3931800],
[1156127147,"Deyang","Deyang","China","CHN","minor",3877000],
[1156135890,"Qingyuan","Qingyuan","China","CHN","minor",3874000],
[1566422868,"Kano","Kano","Nigeria","NGA","admin",3848885],
[1156315512,"Wuhu","Wuhu","China","CHN","minor",3842100],
[1840021117,"Seattle","Seattle","United States","USA","",3789215],
[1392118339,"Yokohama","Yokohama","Japan","JPN","admin",3757630],
[1156564962,"Binzhou","Binzhou","China","CHN","",3748474],
[1156101096,"Baojishi","Baojishi","China","CHN","",3738700],
[1156796454,"Zaozhuang","Zaozhuang","China","CHN","",3729140],
[1156516335,"Neijiang","Neijiang","China","CHN","minor",3702847],
[1156981113,"Baicheng","Baicheng","China","CHN","minor",3669400],
[1276451290,"Berlin","Berlin","Germany","DEU","primary",3664088],
[1156901825,"Anshan","Anshan","China","CHN","",3645884],
[1156280566,"Lanzhou","Lanzhou","China","CHN","admin",3616163],
[1156431924,"Puyang","Puyang","China","CHN","minor",3598740],
[1840021543,"San Francisco","San Francisco","United States","USA","",3592294],
[1156157854,"Jiaozuo","Jiaozuo","China","CHN","",3590700],
[1156167204,"Hechi","Hechi","China","CHN","minor",3545700],
[1124586170,"Montréal","Montreal","Canada","CAN","",3519595],
[1840003971,"Detroit","Detroit","United States","USA","",3506126],
[1156197800,"Chengde","Chengde","China","CHN","",3473201],
[1410601465,"Busan","Busan","South Korea","KOR","admin",3453198],
[1012973369,"Algiers","Algiers","Algeria","DZA","primary",3415811],
[1156382678,"Hanzhong","Hanzhong","China","CHN","",3416196],
[1156383921,"Shiyan","Shiyan","China","CHN","minor",3398000],
[1356891790,"Lucknow","Lucknow","India","IND","admin",3382000],
[1156063295,"Siping","Siping","China","CHN","",3385156],
[1156280672,"Yulinshi","Yulinshi","China","CHN","",3351436],
[1156057944,"Changzhi","Changzhi","China","CHN","minor",3334565],
[1156106602,"Qinzhou","Qinzhou","China","CHN","minor",3304400],
[1156271365,"Bazhou","Bazhou","China","CHN","minor",3283148],
[1156104017,"Qincheng","Qincheng","China","CHN","minor",3262549],
[1156579621,"Zhongshan","Zhongshan","China","CHN","minor",3260000],
[1156655650,"Suining","Suining","China","CHN","minor",3252619],
[1156203130,"Leshan","Leshan","China","CHN","",3235759],
[1840021990,"San Diego","San Diego","United States","USA","",3220118],
[1586323916,"Faisalabad","Faisalabad","Pakistan","PAK","minor",3203846],
[1156377302,"Guang’an","Guang'an","China","CHN","minor",3205476],
[1156803442,"Tongren","Tongren","China","CHN","",3168800],
[1156440668,"Bengbu","Bengbu","China","CHN","",3164467],
[1068129363,"Santa Cruz","Santa Cruz","Bolivia","BOL","admin",3151676],
[1156091093,"Qinhuangdao","Qinhuangdao","China","CHN","",3146300],
[1156358686,"Tongliao","Tongliao","China","CHN","minor",3139153],
[1156157151,"Jinzhou","Jinzhou","China","CHN","",3126463],
[1156934125,"Zhenjiang","Zhenjiang","China","CHN","minor",3113384],
[1156051276,"Ürümqi","Urumqi","China","CHN","admin",3112559],
[1156665165,"Heyuan","Heyuan","China","CHN","minor",3093900],
[1356293537,"Jaipur","Jaipur","India","IND","admin",3073350],
[1156617534,"Xinzhou","Xinzhou","China","CHN","minor",3067501],
[1156620133,"Wuzhou","Wuzhou","China","CHN","minor",3061100],
[1231824991,"Addis Ababa","Addis Ababa","Ethiopia","ETH","primary",3041002],
[1156706927,"Chaoyang","Chaoyang","China","CHN","",3044641],
[1076144436,"Brasília","Brasilia","Brazil","BRA","primary",3015268],
[1364123206,"Mashhad","Mashhad","Iran","IRN","admin",3001184],
[1156617066,"Shaoguan","Shaoguan","China","CHN","minor",2997600],
[1414102075,"Kuwait City","Kuwait City","Kuwait","KWT","primary",2989000],
[1156939010,"Shanwei","Shanwei","China","CHN","minor",2993600],
[1608974097,"Quezon City","Quezon City","Philippines","PHL","admin",2960048],
[1840007830,"Minneapolis","Minneapolis","United States","USA","",2977172],
[1804382913,"Kyiv","Kyiv","Ukraine","UKR","primary",2963199],
[1887750814,"Sanaa","Sanaa","Yemen","YEM","primary",2957000],
[1156185501,"Meishan","Meishan","China","CHN","",2950545],
[1320197916,"Guatemala City","Guatemala City","Guatemala","GTM","primary",2934841],
[1410160313,"Incheon","Incheon","South Korea","KOR","admin",2913024],
[1156909802,"Ningde","Ningde","China","CHN","minor",2910000],
[1840015982,"Tampa","Tampa","United States","USA","",2908063],
[1156403962,"Daqing","Daqing","China","CHN","",2904532],
[1156811601,"Putian","Putian","China","CHN","minor",2900000],
[1360313023,"Bandung","Bandung","Indonesia","IDN","admin",2875673],
[1360484663,"Surabaya","Surabaya","Indonesia","IDN","admin",2885555],
[1076923789,"Salvador","Salvador","Brazil","BRA","admin",2886698],
[1840018789,"Denver","Denver","United States","USA","admin",2876625],
[1380382862,"Rome","Rome","Italy","ITA","primary",2872800],
[1068000064,"La Paz","La Paz","Bolivia","BOL","primary",2867504],
[1156210167,"Hohhot","Hohhot","China","CHN","admin",2866615],
[1156195684,"Xiangtan","Xiangtan","China","CHN","",2864800],
[1408738594,"Pyongyang","Pyongyang","North Korea","PRK","primary",2863000],
[1158689622,"Taichung","Taichung","Taiwan","TWN","admin",2803894],
[1156473300,"Weihai","Weihai","China","CHN","minor",2804771],
[1156032841,"Rizhao","Rizhao","China","CHN","minor",2801013],
[1156249698,"Mudanjiang","Mudanjiang","China","CHN","minor",2798723],
[1158331334,"Kaohsiung","Kaohsiung","Taiwan","TWN","admin",2773533],
[1218802178,"Guayaquil","Guayaquil","Ecuador","ECU","admin",2723665],
[1156089994,"Tieling","Tieling","China","CHN","",2717732],
[1356575238,"Cawnpore","Cawnpore","India","IND","",2701324],
[1156518274,"Dingxi","Dingxi","China","CHN","minor",2698624],
[1158881289,"Taipei","Taipei","Taiwan","TWN","",2684567],
[1156927445,"Nanping","Nanping","China","CHN","minor",2690000],
[1156023354,"Zigong","Zigong","China","CHN","",2678899],
[1156549118,"Chaozhou","Chaozhou","China","CHN","minor",2656600],
[1156032751,"Baotou","Baotou","China","CHN","",2650364],
[1156680279,"Gulou","Gulou","China","CHN","minor",2606000],
[1156012979,"Longyan","Longyan","China","CHN","minor",2640000],
[1156255711,"Ankang","Ankang","China","CHN","",2629906],
[1156546994,"Baoshan","Baoshan","China","CHN","",2627000],
[1156580218,"Huludao","Huludao","China","CHN","minor",2623541],
[1450978461,"Antananarivo","Antananarivo","Madagascar","MDG","primary",2610000],
[1156217114,"Yanjiang","Yanjiang","China","CHN","minor",2593843],
[1050830722,"Chattogram","Chattogram","Bangladesh","BGD","admin",2581643],
[1214636202,"Santo Domingo","Santo Domingo","Dominican Republic","DOM","primary",2581827],
[1156294429,"Sanming","Sanming","China","CHN","minor",2580000],
[1156633259,"Longba","Longba","China","CHN","",2567718],
[1840034030,"Brooklyn","Brooklyn","United States","USA","",2559903],
[1156123172,"Yangjiang","Yangjiang","China","CHN","minor",2555600],
[1156350864,"Jiamusi","Jiamusi","China","CHN","minor",2552097],
[1566366407,"Ibadan","Ibadan","Nigeria","NGA","admin",2550593],
[1156330876,"Luohe","Luohe","China","CHN","minor",2544266],
[1156044130,"Lincang","Lincang","China","CHN","",2536000],
[1170680389,"Medellín","Medellin","Colombia","COL","admin",2529403],
[1156424311,"Xuanzhou","Xuanzhou","China","CHN","",2532938],
[1156057251,"Yunfu","Yunfu","China","CHN","minor",2526900],
[1784736618,"Dubai","Dubai","United Arab Emirates","ARE","admin",2502715],
[1356427908,"Mirzāpur","Mirzapur","India","IND","",2496970],
[1860331871,"Tashkent","Tashkent","Uzbekistan","UZB","primary",2497900],
[1156084562,"Guangyuan","Guangyuan","China","CHN","",2484122],
[1170417589,"Cali","Cali","Colombia","COL","admin",2471474],
[1156234290,"Huangshi","Huangshi","China","CHN","minor",2471700],
[1854029208,"Ouagadougou","Ouagadougou","Burkina Faso","BFA","primary",2453496],
[1410095252,"Daegu","Daegu","South Korea","KOR","admin",2461002],
[1076567885,"Fortaleza","Fortaleza","Brazil","BRA","admin",2452185],
[1120298240,"Yaoundé","Yaounde","Cameroon","CMR","primary",2440462],
[1120494607,"Douala","Douala","Cameroon","CMR","admin",2446945],
[1156646448,"Jilin","Jilin","China","CHN","",2396000],
[1156178316,"Dandong","Dandong","China","CHN","",2444697],
[1156046704,"Lianshan","Lianshan","China","CHN","minor",2426000],
[1156257074,"Yingkou","Yingkou","China","CHN","minor",2428534],
[1356365743,"Nāgpur","Nagpur","India","IND","",2405665],
[1729912179,"Omdurman","Omdurman","Sudan","SDN","",2395159],
[1360006015,"Bekasi","Bekasi","Indonesia","IDN","",2381053],
[1356691871,"Ghāziābād","Ghaziabad","India","IND","",2375820],
[1156682309,"Yuxi","Yuxi","China","CHN","minor",2386000],
[1036192929,"Brisbane","Brisbane","Australia","AUS","admin",2360241],
[1156415948,"Anshun","Anshun","China","CHN","",2353100],
[1360962899,"Depok","Depok","Indonesia","IDN","",2330333],
[1156091241,"Shangzhou","Shangzhou","China","CHN","",2341742],
[1156877299,"Huainan","Huainan","China","CHN","",2333896],
[1156106507,"Kuaidamao","Kuaidamao","China","CHN","minor",2324439],
[1288299415,"Accra","Accra","Ghana","GHA","primary",2291352],
[1392576294,"Fukuoka","Fukuoka","Japan","JPN","admin",2280000],
[1156163376,"Jincheng","Jincheng","China","CHN","minor",2279146],
[1124825478,"Vancouver","Vancouver","Canada","CAN","",2264823],
[1360002844,"Tangerang","Tangerang","Indonesia","IDN","",2237006],
[1156529682,"Sanmenxia","Sanmenxia","China","CHN","",2234018],
[1156925734,"Laibin","Laibin","China","CHN","minor",2233900],
[1840034002,"Queens","Queens","United States","USA","",2230722],
[1156032582,"Qinbaling","Qinbaling","China","CHN","",2211191],
[1156081448,"Xining","Xining","China","CHN","admin",2208708],
[1156847452,"Ma’anshan","Ma'anshan","China","CHN","minor",2202899],
[1156546342,"Yan’an","Yan'an","China","CHN","",2187009],
[1031946365,"Baku","Baku","Azerbaijan","AZE","primary",2181800],
[1156522457,"Gaoping","Gaoping","China","CHN","minor",2174000],
[1716196799,"Harare","Harare","Zimbabwe","ZWE","primary",2150000],
[1192752771,"Havana","Havana","Cuba","CUB","primary",2141652],
[1116260534,"Phnom Penh","Phnom Penh","Cambodia","KHM","primary",2129371],
[1156170787,"Ningbo","Ningbo","China","CHN","minor",2125500],
[1706893395,"Mogadishu","Mogadishu","Somalia","SOM","primary",2120000],
[1156756494,"Puning","Puning","China","CHN","",2118200],
[1360543171,"Medan","Medan","Indonesia","IDN","admin",2109330],
[1156142626,"Huaibei","Huaibei","China","CHN","",2114276],
[1156273372,"Qingyang","Qingyang","China","CHN","minor",2111000],
[1840020551,"Riverside","Riverside","United States","USA","",2107852],
[1840001592,"Baltimore","Baltimore","United States","USA","",2106068],
[1704000623,"Haiphong","Haiphong","Vietnam","VNM","admin",2103500],
[1840020364,"Las Vegas","Las Vegas","United States","USA","",2104198],
[1156438670,"Chongzuo","Chongzuo","China","CHN","minor",2099400],
[1586344001,"Rawalpindi","Rawalpindi","Pakistan","PAK","minor",2098231],
[1288181103,"Kumasi","Kumasi","Ghana","GHA","admin",2069350],
[1840019941,"Portland","Portland","United States","USA","",2074775],
[1356705249,"Vadodara","Vadodara","India","IND","",2065771],
[1156459799,"Hezhou","Hezhou","China","CHN","minor",2072600],
[1156216904,"Pingliang","Pingliang","China","CHN","minor",2068033],
[1840022220,"San Antonio","San Antonio","United States","USA","",2049293],
[1036178956,"Perth","Perth","Australia","AUS","admin",2039200],
[1356692563,"Vishākhapatnam","Vishakhapatnam","India","IND","",2035922],
[1156672254,"Shengli","Shengli","China","CHN","minor",2035338],
[1586400472,"Gujranwala","Gujranwala","Pakistan","PAK","minor",2027001],
[1156435764,"Baicheng","Baicheng","China","CHN","minor",2032356],
[1156857743,"Fushun","Fushun","China","CHN","",2024000],
[1840001651,"St. Louis","St. Louis","United States","USA","",2024074],
[1466965925,"Bamako","Bamako","Mali","MLI","primary",2009109],
[1218441993,"Quito","Quito","Ecuador","ECU","primary",2011388],
[1112348503,"Minsk","Minsk","Belarus","BLR","primary",2009786],
[1356402812,"Indore","Indore","India","IND","",1994397],
[1156359072,"Yinchuan","Yinchuan","China","CHN","admin",1993088],
[1180172460,"Kananga","Kananga","Congo (Kinshasa)","COD","admin",1971704],
[1586851102,"Peshawar","Peshawar","Pakistan","PAK","admin",1970042],
[1392000195,"Sapporo","Sapporo","Japan","JPN","admin",1961690],
[1364023865,"Eşfahān","Esfahan","Iran","IRN","admin",1961260],
[1862748204,"Caracas","Caracas","Venezuela","VEN","primary",1943901],
[1156066465,"Pingxiang","Pingxiang","China","CHN","minor",1933200],
[1760366651,"Aleppo","Aleppo","Syria","SYR","admin",1916781],
[1484708778,"Tijuana","Tijuana","Mexico","MEX","minor",1922523],
[1398351701,"Almaty","Almaty","Kazakhstan","KAZ","admin",1916822],
[1040261752,"Vienna","Vienna","Austria","AUT","primary",1911191],
[1356681152,"Thāne","Thane","India","IND","",1886941],
[1840021491,"Sacramento","Sacramento","United States","USA","admin",1898019],
[1454145012,"Blantyre","Blantyre","Malawi","MWI","admin",1895973],
[1158061376,"Tainan","Tainan","Taiwan","TWN","admin",1883831],
[1156722242,"Zhuhai","Zhuhai","China","CHN","minor",1891100],
[1642414442,"Bucharest","Bucharest","Romania","ROU","primary",1883425],
[1076701712,"Curitiba","Curitiba","Brazil","BRA","admin",1879355],
[1586256291,"Multan","Multan","Pakistan","PAK","minor",1871843],
[1156898522,"Xiping","Xiping","China","CHN","minor",1873000],
[1484003694,"Ecatepec","Ecatepec","Mexico","MEX","minor",1857188],
[1156393765,"Jixi","Jixi","China","CHN","minor",1862165],
[1586619596,"Saidu Sharif","Saidu Sharif","Pakistan","PAK","minor",1860310],
[1156202749,"Liaoyang","Liaoyang","China","CHN","",1858768],
[1276041799,"Hamburg","Hamburg","Germany","DEU","admin",1852478],
[1404588252,"Meru","Meru","Kenya","KEN","admin",1833000],
[1178340306,"Brazzaville","Brazzaville","Congo (Brazzaville)","COG","primary",1827000],
[1840015099,"Orlando","Orlando","United States","USA","",1822394],
[1156141954,"Fuxin","Fuxin","China","CHN","",1819339],
[1156760291,"Wuwei","Wuwei","China","CHN","minor",1815059],
[1076607274,"Manaus","Manaus","Brazil","BRA","admin",1802014],
[1356734039,"Bhopāl","Bhopal","India","IND","admin",1798218],
[1840021570,"San Jose","San Jose","United States","USA","",1798103],
[1616024847,"Warsaw","Warsaw","Poland","POL","primary",1790658],
[1180506234,"Lubumbashi","Lubumbashi","Congo (Kinshasa)","COD","admin",1786397],
[1608906877,"Davao","Davao","Philippines","PHL","admin",1776949],
[1156183327,"Haikou","Haikou","China","CHN","admin",1776141],
[1760685964,"Damascus","Damascus","Syria","SYR","primary",1754000],
[1156051957,"Shuyangzha","Shuyangzha","China","CHN","",1770000],
[1056469830,"Brussels","Brussels","Belgium","BEL","primary",1743000],
[1894157390,"Lusaka","Lusaka","Zambia","ZMB","primary",1742979],
[1586185019,"Hyderabad City","Hyderabad City","Pakistan","PAK","minor",1732693],
[1348611435,"Budapest","Budapest","Hungary","HUN","primary",1723836],
[1156227167,"Shuozhou","Shuozhou","China","CHN","minor",1714857],
[1840000596,"Cleveland","Cleveland","United States","USA","",1710093],
[1156097909,"Benxi","Benxi","China","CHN","",1709538],
[1156140738,"Baiyin","Baiyin","China","CHN","minor",1708751],
[1840001254,"Pittsburgh","Pittsburgh","United States","USA","",1703266],
[1356821429,"Patna","Patna","India","IND","admin",1684222],
[1368194914,"Mosul","Mosul","Iraq","IRQ","admin",1694000],
[1608897690,"Caloocan City","Caloocan City","Philippines","PHL","admin",1661584],
[1840019590,"Austin","Austin","United States","USA","admin",1687311],
[1156025536,"Sanzhou","Sanzhou","China","CHN","",1680000],
[1156421449,"Beihai","Beihai","China","CHN","minor",1680000],
[1682169241,"Mecca","Mecca","Saudi Arabia","SAU","admin",1675368],
[1156339225,"Heihe","Heihe","China","CHN","minor",1673899],
[1156038165,"Jingdezhen","Jingdezhen","China","CHN","minor",1673200],
[1324568159,"Conakry","Conakry","Guinea","GIN","primary",1667864],
[1800406299,"Kampala","Kampala","Uganda","UGA","primary",1659600],
[1840003814,"Cincinnati","Cincinnati","United States","USA","",1662691],
[1076137337,"Recife","Recife","Brazil","BRA","admin",1653461],
[1156245000,"Yushan","Yushan","China","CHN","minor",1651200],
[1158025380,"Zhongli","Zhongli","Taiwan","TWN","",1632616],
[1840008535,"Kansas City","Kansas City","United States","USA","",1636715],
[1840034000,"Manhattan","Manhattan","United States","USA","",1628706],
[1356820491,"Bilāspur","Bilaspur","India","IND","",1625502],
[1360745537,"Semarang","Semarang","Indonesia","IDN","admin",1621384],
[1356929498,"Ludhiāna","Ludhiana","India","IND","",1618879],
[1643399240,"Novosibirsk","Novosibirsk","Russia","RUS","admin",1602915],
[1156883901,"Chengtangcun","Chengtangcun","China","CHN","",1603659],
[1356187395,"Āgra","Agra","India","IND","",1592000],
[1364258511,"Karaj","Karaj","Iran","IRN","admin",1592492],
[1156188829,"Wenzhou","Wenzhou","China","CHN","",1588700],
[1840030084,"Indianapolis","Indianapolis","United States","USA","admin",1588961],
[1484811199,"León de los Aldama","Leon de los Aldama","Mexico","MEX","minor",1579803],
[1484416394,"Puebla","Puebla","Mexico","MEX","admin",1576259],
[1356172246,"Kalyān","Kalyan","India","IND","",1576614],
[1356257289,"Madurai","Madurai","India","IND","minor",1561129],
[1180399586,"Mbuji-Mayi","Mbuji-Mayi","Congo (Kinshasa)","COD","admin",1559073],
[1156114258,"Hebi","Hebi","China","CHN","",1569208],
[1364432238,"Shīrāz","Shiraz","Iran","IRN","admin",1565572],
[1356501259,"Jamshedpur","Jamshedpur","India","IND","",1558000],
[1840003760,"Columbus","Columbus","United States","USA","admin",1562009],
[1364141756,"Tabrīz","Tabriz","Iran","IRN","admin",1558693],
[1862072711,"Maracaibo","Maracaibo","Venezuela","VEN","admin",1551539],
[1392003356,"Kawasaki","Kawasaki","Japan","JPN","",1539522],
[1566262000,"Aba","Aba","Nigeria","NGA","minor",1530000],
[1360902897,"Palembang","Palembang","Indonesia","IDN","admin",1535952],
[1156072884,"Zhangjiajie","Zhangjiajie","China","CHN","minor",1537900],
[1392978082,"Kōbe","Kobe","Japan","JPN","admin",1513193],
[1840014557,"Charlotte","Charlotte","United States","USA","",1512923],
[1156901538,"Changshu","Changshu","China","CHN","",1510100],
[1156944106,"Lianjiang","Lianjiang","China","CHN","",1509400],
[1156173813,"Ximeicun","Ximeicun","China","CHN","",1508000],
[1156545200,"Jianguang","Jianguang","China","CHN","",1507402],
[1156817119,"Yucheng","Yucheng","China","CHN","minor",1507258],
[1076646823,"Belém","Belem","Brazil","BRA","admin",1499641],
[1156165517,"Guiping","Guiping","China","CHN","minor",1496904],
[1156863840,"Leizhou","Leizhou","China","CHN","minor",1494700],
[1410000087,"Gwangju","Gwangju","South Korea","KOR","admin",1490092],
[1276692352,"Munich","Munich","Germany","DEU","admin",1488202],
[1356562598,"Nāsik","Nasik","India","IND","",1486053],
[1076658221,"Porto Alegre","Porto Alegre","Brazil","BRA","admin",1484941],
[1862309871,"Valencia","Valencia","Venezuela","VEN","admin",1484430],
[1566593483,"Onitsha","Onitsha","Nigeria","NGA","minor",1483000],
[1784176710,"Abu Dhabi","Abu Dhabi","United Arab Emirates","ARE","primary",1483000],
[1840003871,"Virginia Beach","Virginia Beach","United States","USA","",1478868],
[1410993875,"Daejeon","Daejeon","South Korea","KOR","admin",1475221],
[1484198680,"Zapopan","Zapopan","Mexico","MEX","minor",1476491],
[1643582706,"Yekaterinburg","Yekaterinburg","Russia","RUS","admin",1468833],
[1156796734,"Huazhou","Huazhou","China","CHN","minor",1468061],
[1392622735,"Kyōto","Kyoto","Japan","JPN","admin",1464890],
[1156245904,"Shuangyashan","Shuangyashan","China","CHN","minor",1462626],
[1156114238,"Pizhou","Pizhou","China","CHN","",1458038],
[1504846488,"El Kelaa des Srarhna","El Kelaa des Srarhna","Morocco","MAR","",1450021],
[1804588111,"Kharkiv","Kharkiv","Ukraine","UKR","admin",1446107],
[1156203000,"Yangshe","Yangshe","China","CHN","minor",1432044],
[1156817541,"Guyuan","Guyuan","China","CHN","",1426000],
[1050667339,"Khulna","Khulna","Bangladesh","BGD","admin",1400689],
[1512035506,"Muscat","Muscat","Oman","OMN","primary",1421409],
[1840033999,"Bronx","Bronx","United States","USA","",1418207],
[1156785303,"Gaozhou","Gaozhou","China","CHN","",1414100],
[1156131504,"Chizhou","Chizhou","China","CHN","minor",1402518],
[1356013205,"Farīdābād","Faridabad","India","IND","",1394000],
[1496024767,"Ulaanbaatar","Ulaanbaatar","Mongolia","MNG","primary",1396288],
[1076034054,"Goiânia","Goiania","Brazil","BRA","admin",1393575],
[1156893569,"Fuqing","Fuqing","China","CHN","minor",1390487],
[1688374696,"Belgrade","Belgrade","Serbia","SRB","primary",1378682],
[1156157078,"Pingdu","Pingdu","China","CHN","",1378900],
[1380724377,"Milan","Milan","Italy","ITA","admin",1366180],
[1356840670,"Aurangābād","Aurangabad","India","IND","",1371330],
[1156592042,"Yutan","Yutan","China","CHN","minor",1368117],
[1840003046,"Milwaukee","Milwaukee","United States","USA","",1365787],
[1156527426,"Huangshan","Huangshan","China","CHN","minor",1358980],
[1554435911,"Auckland","Auckland","New Zealand","NZL","admin",1346091],
[1360051337,"Makassar","Makassar","Indonesia","IDN","admin",1338663],
[1214985348,"Santiago","Santiago","Dominican Republic","DOM","admin",1343423],
[1203744823,"Prague","Prague","Czechia","CZE","primary",1335084],
[1356317190,"Rājkot","Rajkot","India","IND","",1335397],
[1156366507,"Liangshi","Liangshi","China","CHN","",1335900],
[1032803249,"Córdoba","Cordoba","Argentina","ARG","admin",1329604],
[1076730420,"Guarulhos","Guarulhos","Brazil","BRA","",1324781],
[1368714645,"Al Başrah","Al Basrah","Iraq","IRQ","admin",1326564],
[1392017719,"Saitama","Saitama","Japan","JPN","admin",1320571],
[1484840083,"Juárez","Juarez","Mexico","MEX","minor",1321004],
[1858107000,"Montevideo","Montevideo","Uruguay","URY","primary",1319108],
[1156761230,"Xintai","Xintai","China","CHN","",1315942],
[1156264408,"Wusong","Wusong","China","CHN","minor",1311726],
[1356390476,"Meerut","Meerut","India","IND","",1305429],
[1156326773,"Yushu","Yushu","China","CHN","",1304436],
[1156122888,"Rongcheng","Rongcheng","China","CHN","",1302891],
[1156282637,"Huazhou","Huazhou","China","CHN","",1302100],
[1156157844,"Yangquan","Yangquan","China","CHN","minor",1300000],
[1036538171,"Adelaide","Adelaide","Australia","AUS","admin",1295714],
[1156960624,"Baishan","Baishan","China","CHN","minor",1296127],
[1156828380,"Dayan","Dayan","China","CHN","",1296000],
[1156052713,"Haicheng","Haicheng","China","CHN","minor",1293877],
[1156033234,"Jiangyin","Jiangyin","China","CHN","",1285785],
[1156662372,"Huaiyin","Huaiyin","China","CHN","",1264000],
[1156139322,"Wuzhong","Wuzhong","China","CHN","minor",1284000],
[1024559448,"Cacuaco","Cacuaco","Angola","AGO","",1279488],
[1170179113,"Barranquilla","Barranquilla","Colombia","COL","admin",1274250],
[1100762037,"Sofia","Sofia","Bulgaria","BGR","primary",1277411],
[1710627007,"Soweto","Soweto","South Africa","ZAF","",1271628],
[1356115460,"Jabalpur","Jabalpur","India","IND","",1267564],
[1156323529,"Rucheng","Rucheng","China","CHN","minor",1267066],
[1643012126,"Nizhniy Novgorod","Nizhniy Novgorod","Russia","RUS","admin",1264075],
[1156668366,"Shaoyang","Shaoyang","China","CHN","minor",1253548],
[1356103392,"Dhanbād","Dhanbad","India","IND","",1246000],
[1340762485,"Comayagüela","Comayaguela","Honduras","HND","",1250000],
[1156207332,"Laiwu","Laiwu","China","CHN","",1248636],
[1784152993,"Sharjah","Sharjah","United Arab Emirates","ARE","admin",1247749],
[1156060544,"Jingling","Jingling","China","CHN","",1247400],
[1643101260,"Kazan","Kazan","Russia","RUS","admin",1243500],
[1410679777,"Suwon","Suwon","South Korea","KOR","admin",1234300],
[1156841802,"Yongcheng","Yongcheng","China","CHN","",1240382],
[1124690423,"Calgary","Calgary","Canada","CAN","",1239220],
[1704783472,"Cần Thơ","Can Tho","Vietnam","VNM","admin",1237300],
[1566342270,"Abuja","Abuja","Nigeria","NGA","primary",1235880],
[1104468217,"Mandalay","Mandalay","Myanmar","MMR","admin",1225546],
[1156137209,"Beidao","Beidao","China","CHN","minor",1225000],
[1156328867,"Xiangshui","Xiangshui","China","CHN","",1221000],
[1156901342,"Dadukou","Dadukou","China","CHN","minor",1214121],
[1076575691,"Vila Velha","Vila Velha","Brazil","BRA","",1209091],
[1643224011,"Chelyabinsk","Chelyabinsk","Russia","RUS","admin",1202371],
[1404512373,"Mombasa","Mombasa","Kenya","KEN","admin",1200000],
[1840003289,"Providence","Providence","United States","USA","admin",1203230],
[1356145782,"Vārānasi","Varanasi","India","IND","",1198491],
[1364701633,"Qom","Qom","Iran","IRN","admin",1201158],
[1156180353,"Zhangye","Zhangye","China","CHN","minor",1199515],
[1392373695,"Hiroshima","Hiroshima","Japan","JPN","admin",1198021],
[1566540296,"Maiduguri","Maiduguri","Nigeria","NGA","admin",1197497],
[1508074843,"Maputo","Maputo","Mozambique","MOZ","primary",1191613],
[1634459660,"Doha","Doha","Qatar","QAT","primary",1186023],
[1032770677,"Rosario","Rosario","Argentina","ARG","minor",1193605],
[1686165071,"Pikine","Pikine","Senegal","SEN","",1170791],
[1156138735,"Xinyu","Xinyu","China","CHN","minor",1186700],
[1364350188,"Ahvāz","Ahvaz","Iran","IRN","admin",1184788],
[1840015031,"Jacksonville","Jacksonville","United States","USA","",1181496],
[1682345785,"Medina","Medina","Saudi Arabia","SAU","admin",1180770],
[1356442950,"Srīnagar","Srinagar","India","IND","admin",1180570],
[1643360863,"Omsk","Omsk","Russia","RUS","admin",1178391],
[1156249772,"Liaoyuan","Liaoyuan","China","CHN","",1176239],
[1360503809,"Cilacap","Cilacap","Indonesia","IDN","minor",1174964],
[1156301061,"Yingtan","Yingtan","China","CHN","",1175000],
[1360243491,"Bandar Lampung","Bandar Lampung","Indonesia","IDN","admin",1166761],
[1643205757,"Samara","Samara","Russia","RUS","admin",1169719],
[1156249346,"Guankou","Guankou","China","CHN","minor",1168056],
[1410134602,"Ulsan","Ulsan","South Korea","KOR","admin",1166033],
[1156656582,"Dingzhou","Dingzhou","China","CHN","",1165182],
[1076145766,"Campinas","Campinas","Brazil","BRA","",1164098],
[1156490109,"Lianyuan","Lianyuan","China","CHN","minor",1162928],
[1686604760,"Dakar","Dakar","Senegal","SEN","primary",1146053],
[1156102432,"Rongcheng","Rongcheng","China","CHN","minor",1162770],
[1156441554,"Kaiyuan","Kaiyuan","China","CHN","minor",1160000],
[1104838105,"Nay Pyi Taw","Nay Pyi Taw","Myanmar","MMR","primary",1160242],
[1646923541,"Kigali","Kigali","Rwanda","RWA","primary",1156663],
[1156057789,"Leiyang","Leiyang","China","CHN","minor",1151554],
[1156757274,"Yichun","Yichun","China","CHN","minor",1148126],
[1566080151,"Benin City","Benin City","Nigeria","NGA","admin",1147188],
[1826423213,"Birmingham","Birmingham","United Kingdom","GBR","",1137100],
[1156216927,"Xiantao","Xiantao","China","CHN","",1140100],
[1356926507,"Amritsar","Amritsar","India","IND","",1132383],
[1604422141,"Callao","Callao","Peru","PER","admin",1129854],
[1484559591,"Monterrey","Monterrey","Mexico","MEX","admin",1135512],
[1356076391,"Alīgarh","Aligarh","India","IND","",1131160],
[1156748426,"Yingchuan","Yingchuan","China","CHN","minor",1131896],
[1484016661,"Ciudad Nezahualcóyotl","Ciudad Nezahualcoyotl","Mexico","MEX","",1109363],
[1434201852,"Tripoli","Tripoli","Libya","LBY","primary",1126000],
[1408358410,"Nampo","Nampo","North Korea","PRK","",1127000],
[1643013518,"Rostov","Rostov","Russia","RUS","admin",1125299],
[1340344059,"Tegucigalpa","Tegucigalpa","Honduras","HND","primary",1126534],
[1268203191,"Tbilisi","Tbilisi","Georgia","GEO","primary",1118035],
[1356593800,"Guwāhāti","Guwahati","India","IND","",1116267],
[1643722928,"Ufa","Ufa","Russia","RUS","admin",1115560],
[1504861997,"Fès","Fes","Morocco","MAR","admin",1112072],
[1704863046,"Biên Hòa","Bien Hoa","Vietnam","VNM","admin",1104000],
[1148708596,"N’Djamena","N'Djamena","Chad","TCD","primary",1092066],
[1566683694,"Ikare","Ikare","Nigeria","NGA","minor",1099931],
[1840021383,"Salt Lake City","Salt Lake City","United States","USA","admin",1098526],
[1356071083,"Bhilai","Bhilai","India","IND","",1097000],
[1356986516,"Hāora","Haora","India","IND","",1077075],
[1288890688,"Tamale","Tamale","Ghana","GHA","admin",1095808],
[1156960560,"Xibeijie","Xibeijie","China","CHN","minor",1095947],
[1208763942,"Copenhagen","Copenhagen","Denmark","DNK","primary",1085000],
[1484074285,"Nezahualcóyotl","Nezahualcoyotl","Mexico","MEX","minor",1077208],
[1156149248,"Hanchuan","Hanchuan","China","CHN","",1092700],
[1156696810,"Gongzhuling","Gongzhuling","China","CHN","",1092692],
[1643544975,"Krasnoyarsk","Krasnoyarsk","Russia","RUS","admin",1083865],
[1276015998,"Cologne","Cologne","Germany","DEU","",1083498],
[1156292419,"Yicheng","Yicheng","China","CHN","minor",1082929],
[1156522825,"Zhufeng","Zhufeng","China","CHN","",1081960],
[1076485783,"São Gonçalo","Sao Goncalo","Brazil","BRA","",1077687],
[1840036155,"Nashville","Nashville","United States","USA","admin",1081903],
[1051074169,"Yerevan","Yerevan","Armenia","ARM","primary",1075800],
[1398516045,"Nur-Sultan","Nur-Sultan","Kazakhstan","KAZ","primary",1078362],
[1478414984,"Nouakchott","Nouakchott","Mauritania","MRT","primary",1077169],
[1710271883,"Vereeniging","Vereeniging","South Africa","ZAF","",1074000],
[1840001698,"Richmond","Richmond","United States","USA","admin",1075798],
[1076819308,"São Luís","Sao Luis","Brazil","BRA","admin",1073893],
[1356110588,"Rānchi","Ranchi","India","IND","admin",1073440],
[1340568412,"San Pedro Sula","San Pedro Sula","Honduras","HND","admin",1073824],
[1156331200,"Taixing","Taixing","China","CHN","minor",1073921],
[1356363967,"Gwalior","Gwalior","India","IND","",1069276],
[1840015457,"Memphis","Memphis","United States","USA","",1066967],
[1410511255,"Goyang","Goyang","South Korea","KOR","minor",1061929],
[1356807575,"Bezwāda","Bezwada","India","IND","",1048240],
[1124290735,"Edmonton","Edmonton","Canada","CAN","admin",1062643],
[1417191971,"Bishkek","Bishkek","Kyrgyzstan","KGZ","primary",1053900],
[1156935002,"Mizhou","Mizhou","China","CHN","minor",1060000],
[1788742103,"Tunis","Tunis","Tunisia","TUN","primary",1056247],
[1156155575,"Xishan","Xishan","China","CHN","minor",1060000],
[1156414637,"Ezhou","Ezhou","China","CHN","minor",1059700],
[1862860739,"Barquisimeto","Barquisimeto","Venezuela","VEN","admin",1059092],
[1392457903,"Sendai","Sendai","Japan","JPN","admin",1058070],
[1156541759,"Hegang","Hegang","China","CHN","minor",1058665],
[1524589448,"Kathmandu","Kathmandu","Nepal","NPL","primary",975453],
[1484788702,"Mexicali","Mexicali","Mexico","MEX","admin",1049792],
[1643811064,"Voronezh","Voronezh","Russia","RUS","admin",1047549],
[1643294442,"Perm","Perm","Russia","RUS","admin",1048005],
[1410592618,"Changwon","Changwon","South Korea","KOR","admin",1046054],
[1156956616,"Zhongwei","Zhongwei","China","CHN","minor",1046000],
[1156787809,"Shouguang","Shouguang","China","CHN","",1039205],
[1360771925,"Bogor","Bogor","Indonesia","IDN","",1030720],
[1840014497,"Raleigh","Raleigh","United States","USA","admin",1038738],
[1170886102,"Cartagena","Cartagena","Colombia","COL","admin",1036412],
[1356739179,"Chandīgarh","Chandigarh","India","IND","admin",1026459],
[1508768577,"Matola","Matola","Mozambique","MOZ","",1032197],
[1356727084,"Jodhpur","Jodhpur","India","IND","",1033918],
[1566373448,"Ogbomoso","Ogbomoso","Nigeria","NGA","minor",1032000],
[1398791401,"Shymkent","Shymkent","Kazakhstan","KAZ","admin",1028673],
[1562932886,"Niamey","Niamey","Niger","NER","primary",1026848],
[1156322307,"Taizhou","Taizhou","China","CHN","minor",1030200],
[1558296252,"Managua","Managua","Nicaragua","NIC","primary",1028808],
[1360405604,"Bagam","Bagam","Indonesia","IDN","",1029808],
[1818909612,"Shubrā al Khaymah","Shubra al Khaymah","Egypt","EGY","",1025569],
[1076440479,"Maceió","Maceio","Brazil","BRA","admin",1025360],
[1430477826,"Monrovia","Monrovia","Liberia","LBR","primary",1021762],
[1156476417,"Wafangdian","Wafangdian","China","CHN","",1024876],
[1156631720,"Zhongxiang","Zhongxiang","China","CHN","",1022514],
[1804178102,"Odesa","Odesa","Ukraine","UKR","admin",1017699],
[1332401940,"Port-au-Prince","Port-au-Prince","Haiti","HTI","primary",987310],
[1840001839,"New Orleans","New Orleans","United States","USA","",1020886],
[1484460894,"Villahermosa","Villahermosa","Mexico","MEX","admin",1013484],
[1704361621,"Thủ Đức","Thu Duc","Vietnam","VNM","minor",1013795],
[1643577201,"Volgograd","Volgograd","Russia","RUS","admin",1015586],
[1356779323,"Mysore","Mysore","India","IND","",1014227],
[1586306717,"Islamabad","Islamabad","Pakistan","PAK","primary",1014825],
[1156936644,"Xinyi","Xinyi","China","CHN","",1013900],
[1356374983,"Raipur","Raipur","India","IND","admin",1010087],
[1604723954,"Arequipa","Arequipa","Peru","PER","admin",1008290],
[1566070649,"Port Harcourt","Port Harcourt","Nigeria","NGA","admin",1005904],
[1840030815,"Louisville","Louisville","United States","USA","",1005654],
[1156197076,"Zaoyang","Zaoyang","China","CHN","",1004741],
[1156462734,"Shuizhai","Shuizhai","China","CHN","",1003698],
[1156255316,"Xingyi","Xingyi","China","CHN","",1004132],
[1356820310,"Kota","Kota","India","IND","",1001694],
[1586556108,"Quetta","Quetta","Pakistan","PAK","admin",1001205],
[1124399363,"Ottawa","Ottawa","Canada","CAN","primary",989567],
[1752425602,"Stockholm","Stockholm","Sweden","SWE","primary",975819],
[1232791236,"Asmara","Asmara","Eritrea","ERI","primary",963000],
[1694085071,"Freetown","Freetown","Sierra Leone","SLE","primary",951000],
[1418732714,"Vientiane","Vientiane","Laos","LAO","primary",948487],
[1376261644,"Jerusalem","Jerusalem","Israel","ISR","primary",919438],
[1140080881,"Bangui","Bangui","Central African Republic","CAF","primary",889231],
[1591672475,"Panama City","Panama City","Panama","PAN","primary",880691],
[1528355309,"Amsterdam","Amsterdam","Netherlands","NLD","primary",862965],
[1768409132,"Lomé","Lome","Togo","TGO","primary",837437],
[1266952885,"Libreville","Libreville","Gabon","GAB","primary",797003],
[1191233290,"Zagreb","Zagreb","Croatia","HRV","primary",790017],
[1762930616,"Dushanbe","Dushanbe","Tajikistan","TJK","primary",778500],
[1454688499,"Lilongwe","Lilongwe","Malawi","MWI","primary",781538],
[1204955174,"Cotonou","Cotonou","Benin","BEN","primary",762000],
[1144251314,"Colombo","Colombo","Sri Lanka","LKA","primary",752993],
[1710176249,"Pretoria","Pretoria","South Africa","ZAF","primary",741651],
[1124224963,"Winnipeg","Winnipeg","Canada","CAN","admin",705244],
[1124823933,"Quebec City","Quebec City","Canada","CAN","admin",705103],
[1578324706,"Oslo","Oslo","Norway","NOR","primary",693494],
[1300715560,"Athens","Athens","Greece","GRC","primary",664046],
[1108101689,"Bujumbura","Bujumbura","Burundi","BDI","primary",658859],
[1246177997,"Helsinki","Helsinki","Finland","FIN","primary",642045],
[1807600615,"Skopje","Skopje","Macedonia","MKD","primary",640000],
[1498011437,"Chisinau","Chisinau","Moldova","MDA","primary",639000],
[1428586192,"Riga","Riga","Latvia","LVA","primary",614618],
[1388709177,"Kingston","Kingston","Jamaica","JAM","primary",580000],
[1504023252,"Rabat","Rabat","Morocco","MAR","primary",572717],
[1440887149,"Vilnius","Vilnius","Lithuania","LTU","primary",574147],
[1222647454,"San Salvador","San Salvador","El Salvador","SLV","primary",567698],
[1262028958,"Djibouti","Djibouti","Djibouti","DJI","primary",562000],
[1372595407,"Dublin","Dublin","Ireland","IRL","primary",553165],
[1528799905,"The Hague","The Hague","Netherlands","NLD","primary",537833],
[1600057911,"Asunción","Asuncion","Paraguay","PRY","primary",524190],
[1620619017,"Lisbon","Lisbon","Portugal","PRT","primary",506654],
[1703195001,"Bratislava","Bratislava","Slovakia","SVK","primary",475503],
[1124158530,"Kitchener","Kitchener","Canada","CAN","",470015],
[1233260021,"Tallinn","Tallinn","Estonia","EST","primary",438341],
[1422847713,"Beirut","Beirut","Lebanon","LBN","primary",361366],
[1710680650,"Cape Town","Cape Town","South Africa","ZAF","primary",433688],
[1008162156,"Tirana","Tirana","Albania","ALB","primary",418495],
[1554772152,"Wellington","Wellington","New Zealand","NZL","primary",418500],
[1834288497,"Dodoma","Dodoma","Tanzania","TZA","primary",410956],
[1124130981,"Halifax","Halifax","Canada","CAN","admin",403131],
[1624168850,"Bissau","Bissau","Guinea-Bissau","GNB","primary",395954],
[1036142029,"Canberra","Canberra","Australia","AUS","primary",381488],
[1728444337,"Juba","Juba","South Sudan","SSD","primary",372410],
[1384683557,"Yamoussoukro","Yamoussoukro","Côte d'Ivoire","CIV","primary",355573],
[1124147219,"Victoria","Victoria","Canada","CAN","admin",335696],
[1426977668,"Maseru","Maseru","Lesotho","LSO","primary",330790],
[1196944155,"Nicosia","Nicosia","Cyprus","CYP","primary",330000],
[1516802003,"Windhoek","Windhoek","Namibia","NAM","primary",322500],
[1598685395,"Port Moresby","Port Moresby","Papua New Guinea","PNG","primary",317374],
[1204172060,"Porto-Novo","Porto-Novo","Benin","BEN","primary",300000],
[1068823873,"Sucre","Sucre","Bolivia","BOL","primary",300000],
[1188749877,"San José","San Jose","Costa Rica","CRI","primary",288054],
[1705917455,"Ljubljana","Ljubljana","Slovenia","SVN","primary",286745],
[1070966777,"Sarajevo","Sarajevo","Bosnia And Herzegovina","BIH","primary",275524],
[1044318561,"Nassau","Nassau","The Bahamas","BHS","primary",274400],
[1710495933,"Bloemfontein","Bloemfontein","South Africa","ZAF","primary",256185],
[1474969110,"Fort-de-France","Fort-de-France","Martinique","MTQ","primary",253995],
[1356215164,"New Delhi","New Delhi","India","IND","primary",249998],
[1072756768,"Gaborone","Gaborone","Botswana","BWA","primary",231626],
[1740518660,"Paramaribo","Paramaribo","Suriname","SUR","primary",223757],
[1626308942,"Dili","Dili","Timor-Leste","TLS","primary",222323],
[1462441685,"Male","Male","Maldives","MDV","primary",133019],
[1328160906,"Georgetown","Georgetown","Guyana","GUY","primary",200500],
[1292385245,"Gibraltar","Gibraltar","Gibraltar","GIB","primary",187083],
[1638024662,"Saint-Denis","Saint-Denis","Reunion","REU","primary",190047],
[1226861333,"Malabo","Malabo","Equatorial Guinea","GNQ","primary",187302],
[1499454516,"Podgorica","Podgorica","Montenegro","MNE","primary",174515],
[1048989486,"Manama","Manama","Bahrain","BHR","primary",157474],
[1480131261,"Port Louis","Port Louis","Mauritius","MUS","primary",149194],
[1531000000,"Willemstad","Willemstad","Curaçao","CUW","primary",150000],
[1756374318,"Bern","Bern","Switzerland","CHE","primary",133798],
[1258907380,"Papeete","Papeete","French Polynesia","PYF","primary",131695],
[1442262731,"Luxembourg","Luxembourg","Luxembourg","LUX","primary",128512],
[1352327190,"Reykjavík","Reykjavik","Iceland","ISL","primary",128793],
[1132398770,"Praia","Praia","Cabo Verde","CPV","primary",127832],
[1144239330,"Sri Jayewardenepura Kotte","Sri Jayewardenepura Kotte","Sri Lanka","LKA","primary",115826],
[1052274244,"Bridgetown","Bridgetown","Barbados","BRB","primary",110000],
[1174793581,"Moroni","Moroni","Comoros","COM","primary",111329],
[1064010361,"Thimphu","Thimphu","Bhutan","BTN","primary",104000],
[1748811945,"Mbabane","Mbabane","Swaziland","SWZ","primary",94874],
[1540958092,"Nouméa","Noumea","New Caledonia","NCL","primary",93060],
[1090737486,"Honiara","Honiara","Solomon Islands","SLB","primary",84520],
[1242615095,"Suva","Suva","Fiji","FJI","primary",88271],
[1792572891,"Ankara","Ankara","Turkey","TUR","primary",77168],
[1662922505,"Castries","Castries","Saint Lucia","LCA","primary",70000],
[1254304969,"Cayenne","Cayenne","French Guiana","GUF","primary",61550],
[1678301324,"São Tomé","Sao Tome","Sao Tome And Principe","STP","primary",56166],
[1548805075,"Port-Vila","Port-Vila","Vanuatu","VUT","primary",51437],
[1060000000,"Hamilton","Hamilton","Bermuda","BMU","primary",52320],
[1096465895,"Bandar Seri Begawan","Bandar Seri Begawan","Brunei","BRN","primary",50000],
[1492854256,"Monaco","Monaco","Monaco","MCO","primary",36371],
[1108778000,"Gitega","Gitega","Burundi","BDI","primary",41944],
[1780670676,"Port of Spain","Port of Spain","Trinidad And Tobago","TTO","primary",37074],
[1882489296,"Apia","Apia","Samoa","WSM","primary",37708],
[1296152641,"Tarawa","Tarawa","Kiribati","KIR","primary",28802],
[1533513057,"Oranjestad","Oranjestad","Aruba","ABW","primary",34980],
[1832490253,"Saint Helier","Saint Helier","Jersey","JEY","primary",33522],
[1270723713,"Banjul","Banjul","The Gambia","GMB","primary",31356],
[1175099654,"Mamoudzou","Mamoudzou","Mayotte","MYT","primary",32057],
[1584000000,"Majuro","Majuro","Marshall Islands","MHL","primary",30000],
[1833688345,"Douglas","Douglas","Isle Of Man","IMN","primary",27938],
[1136159124,"George Town","George Town","Cayman Islands","CYM","primary",27704],
[1690193579,"Victoria","Victoria","Seychelles","SYC","primary",26450],
[1670376659,"Kingstown","Kingstown","Saint Vincent And The Grenadines","VCT","primary",25000],
[1020828846,"Andorra la Vella","Andorra la Vella","Andorra","AND","primary",22615],
[1028912067,"Saint John’s","Saint John's","Antigua And Barbuda","ATG","primary",21926],
[1776737461,"Nuku‘alofa","Nuku`alofa","Tonga","TON","primary",23221],
[1795049992,"Ashgabat","Ashgabat","Turkmenistan","TKM","primary",19426],
[1304028354,"Nuuk","Nuuk","Greenland","GRL","primary",18326],
[1084586375,"Belmopan","Belmopan","Belize","BLZ","primary",17222],
[1212060440,"Roseau","Roseau","Dominica","DMA","primary",16582],
[1659198919,"Basseterre","Basseterre","Saint Kitts And Nevis","KNA","primary",13220],
[1234904517,"Tórshavn","Torshavn","Faroe Islands","FRO","primary",13326],
[1016976740,"Pago Pago","Pago Pago","American Samoa","ASM","primary",12576],
[1470574399,"Valletta","Valletta","Malta","MLT","primary",6444],
[1916116052,"Gaza","Gaza","Gaza Strip","XGZ","primary",0],
[1796965313,"Grand Turk","Grand Turk","Turks And Caicos Islands","TCA","primary",5801],
[1583008885,"Palikir","Palikir","Federated States of Micronesia","FSM","primary",6227],
[1798251391,"Funafuti","Funafuti","Tuvalu","TUV","primary",6025],
[1438317747,"Vaduz","Vaduz","Liechtenstein","LIE","primary",5668],
[1748963140,"Lobamba","Lobamba","Swaziland","SWZ","primary",5800],
[1184217570,"Avarua","Avarua","Cook Islands","COK","primary",5445],
[1308891766,"Saint George’s","Saint George's","Grenada","GRD","primary",4315],
[1674741947,"San Marino","San Marino","San Marino","SMR","primary",4040],
[1934000006,"Al Quds","Al Quds","West Bank","XWB","primary",0],
[1580556972,"Capitol Hill","Capitol Hill","Northern Mariana Islands","MNP","primary",2500],
[1238780509,"Stanley","Stanley","Falkland Islands (Islas Malvinas)","FLK","primary",2213],
[1336000000,"Vatican City","Vatican City","Vatican City","VAT","primary",825],
[1570882835,"Alofi","Alofi","Niue","NIU","primary",1611],
[1312938008,"Basse-Terre","Basse-Terre","Guadeloupe","GLP","primary",307],
[1316937540,"Hagåtña","Hagta","Guam","GUM","primary",1051],
[1663133172,"Marigot","Marigot","Saint Martin","MAF","primary",0],
[1654761576,"Jamestown","Jamestown","Saint Helena, Ascension, And Tristan Da Cunha","SHN","primary",714],
[1500971198,"Brades","Brades","Montserrat","MSR","primary",391],
[1534859858,"Philipsburg","Philipsburg","Sint Maarten","SXM","primary",0],
[1520790128,"Yaren","Yaren","Nauru","NRU","primary",0],
[1901760068,"Pristina","Pristina","Kosovo","XKS","primary",0],
[1652681565,"Gustavia","Gustavia","Saint Barthelemy","BLM","primary",0],
[1092732412,"Road Town","Road Town","British Virgin Islands","VGB","primary",0],
[1585525081,"Ngerulmud","Ngerulmud","Palau","PLW","primary",271],
[1666340272,"Saint-Pierre","Saint-Pierre","Saint Pierre And Miquelon","SPM","primary",0],
[1660698387,"The Valley","The Valley","Anguilla","AIA","primary",0],
[1876784844,"Mata-Utu","Mata-Utu","Wallis And Futuna","WLF","primary",0],
[1574121434,"Kingston","Kingston","Norfolk Island","NFK","primary",0],
[1930654114,"Longyearbyen","Longyearbyen","Svalbard","XSV","primary",0],
[1504999990,"Tifariti","Tifariti","Morocco","MAR","primary",0],
[1612000000,"Adamstown","Adamstown","Pitcairn Islands","PCN","primary",0],
[1162889600,"Flying Fish Cove","Flying Fish Cove","Christmas Island","CXR","primary",0],
[1239048838,"King Edward Point","King Edward Point","South Georgia And South Sandwich Islands","SGS","primary",0],
[1356698199,"Bareilly","Bareilly","India","IND","",1000000],
[1704966442,"Quảng Hà","Quang Ha","Vietnam","VNM","",1000000],
[1156913008,"Xingcheng","Xingcheng","China","CHN","minor",993000],
[1156536785,"Dongtai","Dongtai","China","CHN","minor",990306],
[1818255319,"Al Manşūrah","Al Mansurah","Egypt","EGY","admin",960423],
[1156012356,"Yingcheng","Yingcheng","China","CHN","minor",986400],
[1392107144,"Chiba","Chiba","Japan","JPN","admin",981738],
[1360422679,"Pekanbaru","Pekanbaru","Indonesia","IDN","admin",983356],
[1156138895,"Luocheng","Luocheng","China","CHN","minor",984100],
[1804152933,"Dnipro","Dnipro","Ukraine","UKR","admin",980948],
[1156578273,"Danyang","Danyang","China","CHN","",980662],
[1076336975,"Natal","Natal","Brazil","BRA","",980588],
[1156911678,"Nada","Nada","China","CHN","minor",977700],
[1608189351,"Zamboanga City","Zamboanga City","Philippines","PHL","admin",977234],
[1368344172,"Kirkuk","Kirkuk","Iraq","IRQ","admin",975000],
[1380646673,"Naples","Naples","Italy","ITA","admin",966144],
[1156198103,"Wuchuan","Wuchuan","China","CHN","",972400],
[1156485081,"Huilong","Huilong","China","CHN","minor",972525],
[1840020428,"Oklahoma City","Oklahoma City","United States","USA","admin",972943],
[1484669072,"Morelia","Morelia","Mexico","MEX","",962555],
[1608136151,"Cebu City","Cebu City","Philippines","PHL","admin",964169],
[1156893449,"Shaoxing","Shaoxing","China","CHN","minor",961200],
[1356999503,"Coimbatore","Coimbatore","India","IND","",959823],
[1214664832,"Santo Domingo Este","Santo Domingo Este","Dominican Republic","DOM","admin",948855],
[1392792380,"Setagaya","Setagaya","Japan","JPN","",940509],
[1410622472,"Sŏngnam","Songnam","South Korea","KOR","",948757],
[1156105450,"Taishan","Taishan","China","CHN","",953900],
[1156532454,"Fangchenggang","Fangchenggang","China","CHN","minor",953300],
[1356314385,"Solāpur","Solapur","India","IND","",951558],
[1504861504,"Tangier","Tangier","Morocco","MAR","admin",947952],
[1156592047,"Anqiu","Anqiu","China","CHN","",947723],
[1156303834,"Feicheng","Feicheng","China","CHN","",946627],
[1364535690,"Kermānshāh","Kermanshah","Iran","IRN","admin",945651],
[1392003140,"Kitakyūshū","Kitakyushu","Japan","JPN","",935084],
[1156023073,"Meishan","Meishan","China","CHN","minor",936000],
[1729318628,"Khartoum North","Khartoum North","Sudan","SDN","",936349],
[1180478201,"Kisangani","Kisangani","Congo (Kinshasa)","COD","admin",935977],
[1484666646,"Aguascalientes","Aguascalientes","Mexico","MEX","admin",934424],
[1504172585,"Marrakech","Marrakech","Morocco","MAR","admin",928850],
[1804963805,"Donetsk","Donetsk","Ukraine","UKR","admin",929063],
[1604613706,"Trujillo","Trujillo","Peru","PER","admin",919899],
[1156281983,"Taihe","Taihe","China","CHN","minor",924531],
[1840004836,"Bridgeport","Bridgeport","United States","USA","",924449],
[1356884472,"Trichinopoly","Trichinopoly","India","IND","",916857],
[1156236053,"Xin’an","Xin'an","China","CHN","",920628],
[1156875484,"Taihecun","Taihecun","China","CHN","minor",920471],
[1484850125,"Naucalpan de Juárez","Naucalpan de Juarez","Mexico","MEX","minor",913681],
[1566679132,"Owerri","Owerri","Nigeria","NGA","admin",908109],
[1360900986,"Padang","Padang","Indonesia","IDN","admin",914970],
[1156874864,"Qingzhou","Qingzhou","China","CHN","",914047],
[1840000386,"Buffalo","Buffalo","United States","USA","",914341],
[1156302762,"Lichuan","Lichuan","China","CHN","",913700],
[1156255811,"Daye","Daye","China","CHN","",909724],
[1840020696,"Fort Worth","Fort Worth","United States","USA","",909585],
[1156041202,"Hengzhou","Hengzhou","China","CHN","minor",908400],
[1076660445,"Campo Grande","Campo Grande","Brazil","BRA","admin",906092],
[1156410076,"Zhuanghe","Zhuanghe","China","CHN","",905852],
[1840004773,"Hartford","Hartford","United States","USA","admin",905152],
[1854348796,"Bobo-Dioulasso","Bobo-Dioulasso","Burkina Faso","BFA","admin",903887],
[1682452296,"Ad Dammām","Ad Dammam","Saudi Arabia","SAU","admin",903312],
[1156369972,"Lhasa","Lhasa","China","CHN","admin",902500],
[1156752602,"Jiaozhou","Jiaozhou","China","CHN","",900500],
[1608766695,"Taguig City","Taguig City","Philippines","PHL","admin",886722],
[1484396779,"Mérida","Merida","Mexico","MEX","admin",892363],
[1156787307,"Yangchun","Yangchun","China","CHN","",891800],
[1410428222,"Bucheon","Bucheon","South Korea","KOR","minor",867678],
[1156202014,"Dengtalu","Dengtalu","China","CHN","minor",887000],
[1608824345,"Antipolo","Antipolo","Philippines","PHL","admin",887399],
[1356102365,"Hubli","Hubli","India","IND","",890000],
[1566979497,"Abeokuta","Abeokuta","Nigeria","NGA","admin",888924],
[1484010310,"Cancún","Cancun","Mexico","MEX","minor",888797],
[1840022101,"Tucson","Tucson","United States","USA","",888486],
[1643438227,"Krasnodar","Krasnodar","Russia","RUS","admin",881476],
[1076697777,"Natal","Natal","Brazil","BRA","admin",877662],
[1484335603,"Chihuahua","Chihuahua","Mexico","MEX","admin",878062],
[1458509635,"Klang","Klang","Malaysia","MYS","",878000],
[1380244627,"Turin","Turin","Italy","ITA","admin",870952],
[1368838855,"Ar Ramādī","Ar Ramadi","Iraq","IRQ","admin",874543],
[1156207330,"Laiyang","Laiyang","China","CHN","",874127],
[1504989034,"Sale","Sale","Morocco","MAR","",850403],
[1356494816,"Jalandhar","Jalandhar","India","IND","",873725],
[1156686574,"Kaifeng Chengguanzhen","Kaifeng Chengguanzhen","China","CHN","minor",872000],
[1566486388,"Ikeja","Ikeja","Nigeria","NGA","admin",861300],
[1360141408,"Malang","Malang","Indonesia","IDN","",866118],
[1250774071,"Marseille","Marseille","France","FRA","admin",868277],
[1484107245,"Saltillo","Saltillo","Mexico","MEX","admin",864431],
[1156673331,"Gaomi","Gaomi","China","CHN","",868715],
[1458423505,"Ipoh","Ipoh","Malaysia","MYS","admin",866772],
[1156332302,"Hai’an","Hai'an","China","CHN","minor",866337],
[1012126319,"Oran","Oran","Algeria","DZA","admin",852000],
[1484015319,"Hermosillo","Hermosillo","Mexico","MEX","admin",855563],
[1156194600,"Weichanglu","Weichanglu","China","CHN","minor",859424],
[1156278934,"Shache","Shache","China","CHN","",851374],
[1156705082,"Leping","Leping","China","CHN","minor",852800],
[1156804488,"Hailun","Hailun","China","CHN","minor",850000],
[1156949639,"Macheng","Macheng","China","CHN","",849090],
[1566568277,"Akure","Akure","Nigeria","NGA","admin",847903],
[1566480168,"Ilorin","Ilorin","Nigeria","NGA","admin",847582],
[1076727667,"Teresina","Teresina","Brazil","BRA","admin",847430],
[1156177817,"Yuci","Yuci","China","CHN","",840000],
[1840009315,"Omaha","Omaha","United States","USA","",847819],
[1643556540,"Saratov","Saratov","Russia","RUS","admin",845300],
[1368578192,"Erbil","Erbil","Iraq","IRQ","admin",846000],
[1076339714,"Iguaçu","Iguacu","Brazil","BRA","",844583],
[1840023252,"El Paso","El Paso","United States","USA","",843386],
[1608278212,"Pasig City","Pasig City","Philippines","PHL","admin",803159],
[1360848527,"Denpasar","Denpasar","Indonesia","IDN","admin",834881],
[1156898134,"Dehui","Dehui","China","CHN","",839786],
[1356140143,"Bhubaneshwar","Bhubaneshwar","India","IND","admin",837737],
[1156849608,"Tongchuan","Tongchuan","China","CHN","minor",834437],
[1410964361,"Cheongju","Cheongju","South Korea","KOR","admin",833276],
[1566325734,"Warri","Warri","Nigeria","NGA","minor",830106],
[1178411563,"Pointe-Noire","Pointe-Noire","Congo (Brazzaville)","COG","admin",829134],
[1392003291,"Sakai","Sakai","Japan","JPN","",823523],
[1156795164,"Rongjiawan","Rongjiawan","China","CHN","minor",826000],
[1458469233,"Butterworth","Butterworth","Malaysia","MYS","",821652],
[1156943939,"Renqiu","Renqiu","China","CHN","",822455],
[1840013305,"Honolulu","Honolulu","United States","USA","admin",820987],
[1156263165,"Xindi","Xindi","China","CHN","",819446],
[1156729960,"Wu’an","Wu'an","China","CHN","",819000],
[1076793227,"São Bernardo do Campo","Sao Bernardo do Campo","Brazil","BRA","",816925],
[1156235854,"Gaoyou","Gaoyou","China","CHN","minor",811800],
[1484516810,"Culiacán","Culiacan","Mexico","MEX","admin",808416],
[1156405731,"Hejian","Hejian","China","CHN","",810306],
[1156142520,"Yiyang","Yiyang","China","CHN","minor",810447],
[1156046618,"Puxi","Puxi","China","CHN","minor",809535],
[1156086381,"Zijinglu","Zijinglu","China","CHN","minor",807857],
[1076922014,"João Pessoa","Joao Pessoa","Brazil","BRA","admin",801718],
[1840021024,"McAllen","McAllen","United States","USA","",804114],
[1484604775,"Querétaro","Queretaro","Mexico","MEX","admin",801940],
[1076413528,"Abaeté","Abaete","Brazil","BRA","",800000],
[1170614290,"Palermo","Palermo","Colombia","COL","minor",800000],
[1156033855,"Qingping","Qingping","China","CHN","minor",797200],
[1724981666,"Valencia","Valencia","Spain","ESP","admin",789744],
[1392913753,"Niigata","Niigata","Japan","JPN","admin",790646],
[1826343963,"Leeds","Leeds","United Kingdom","GBR","",789194],
[1356269375,"Morādābād","Moradabad","India","IND","",787000],
[1392174500,"Hamamatsu","Hamamatsu","Japan","JPN","",788211],
[1156524101,"Xiangxiang","Xiangxiang","China","CHN","",787216],
[1156671495,"Chaohucun","Chaohucun","China","CHN","",782000],
[1156340393,"Fuyang","Fuyang","China","CHN","minor",771000],
[1760013934,"Homs","Homs","Syria","SYR","admin",775404],
[1024669127,"Lubango","Lubango","Angola","AGO","admin",776249],
[1484583620,"San Luis Potosí","San Luis Potosi","Mexico","MEX","admin",772828],
[1156000460,"Cencheng","Cencheng","China","CHN","minor",772113],
[1156840276,"Dali","Dali","China","CHN","",771128],
[1408482040,"Hamhŭng","Hamhung","North Korea","PRK","admin",768551],
[1616172264,"Kraków","Krakow","Poland","POL","admin",766739],
[1840005293,"Hempstead","Hempstead","United States","USA","",767417],
[1276054552,"Frankfurt","Frankfurt","Germany","DEU","minor",764104],
[1784674685,"Al ‘Ayn","Al `Ayn","United Arab Emirates","ARE","",766936],
[1156837705,"Songzi","Songzi","China","CHN","",765911],
[1156973102,"Laixi","Laixi","China","CHN","",762900],
[1586038700,"Bahawalpur","Bahawalpur","Pakistan","PAK","minor",762111],
[1156515985,"Zhongba","Zhongba","China","CHN","minor",762140],
[1566368729,"Kaduna","Kaduna","Nigeria","NGA","admin",760084],
[1156689964,"Qingnian","Qingnian","China","CHN","minor",760781],
[1840019176,"Albuquerque","Albuquerque","United States","USA","",761195],
[1156544851,"Xinhualu","Xinhualu","China","CHN","minor",758079],
[1392093402,"Nerima","Nerima","Japan","JPN","",742463],
[1156267419,"Guangshui","Guangshui","China","CHN","",755910],
[1484017493,"Tlajomulco de Zúñiga","Tlajomulco de Zuniga","Mexico","MEX","minor",727750],
[1360684979,"Samarinda","Samarinda","Indonesia","IDN","admin",753370],
[1710690280,"Pietermaritzburg","Pietermaritzburg","South Africa","ZAF","admin",750845],
[1158439005,"Changhua","Changhua","Taiwan","TWN","admin",750000],
[1356110593,"Kolhāpur","Kolhapur","India","IND","",750000],
[1156450911,"Sizhan","Sizhan","China","CHN","",751389],
[1862889027,"Ciudad Guayana","Ciudad Guayana","Venezuela","VEN","minor",751331],
[1170743755,"Cúcuta","Cucuta","Colombia","COL","admin",750000],
[1156933354,"Licheng","Licheng","China","CHN","minor",749522],
[1392003511,"Ōta-ku","Ota-ku","Japan","JPN","",737187],
[1356024354,"Thiruvananthapuram","Thiruvananthapuram","India","IND","admin",743691],
[1643040435,"Tyumen","Tyumen","Russia","RUS","admin",744554],
[1508958445,"Nampula","Nampula","Mozambique","MOZ","admin",743000],
[1804644752,"Zaporizhzhia","Zaporizhzhia","Ukraine","UKR","admin",741717],
[1156866870,"Chengguan","Chengguan","China","CHN","minor",740435],
[1392106283,"Kumamoto","Kumamoto","Japan","JPN","admin",738385],
[1156609562,"Nehe","Nehe","China","CHN","",740000],
[1840006507,"Birmingham","Birmingham","United States","USA","",739573],
[1156756935,"Zunhua","Zunhua","China","CHN","minor",737011],
[1608492120,"Valenzuela","Valenzuela","Philippines","PHL","admin",714978],
[1364158221,"Orūmīyeh","Orumiyeh","Iran","IRN","admin",736224],
[1156089788,"Wugang","Wugang","China","CHN","",734870],
[1566395088,"Osogbo","Osogbo","Nigeria","NGA","admin",731000],
[1156968311,"Shuangqiao","Shuangqiao","China","CHN","minor",733000],
[1032042035,"Comodoro Rivadavia","Comodoro Rivadavia","Argentina","ARG","minor",730266],
[1608831546,"Cagayan de Oro","Cagayan de Oro","Philippines","PHL","admin",728402],
[1156930148,"Langzhong","Langzhong","China","CHN","minor",728935],
[1156315498,"Qian’an","Qian'an","China","CHN","",728160],
[1804939658,"Lviv","Lviv","Ukraine","UKR","admin",724314],
[1156817518,"Zouping","Zouping","China","CHN","",726722],
[1368003357,"An Najaf","An Najaf","Iraq","IRQ","admin",724700],
[1392967248,"Sagamihara","Sagamihara","Japan","JPN","",722973],
[1840015988,"Sarasota","Sarasota","United States","USA","",722243],
[1124112672,"Mississauga","Mississauga","Canada","CAN","",721599],
[1392954750,"Okayama","Okayama","Japan","JPN","admin",720043],
[1156406202,"Anlu","Anlu","China","CHN","minor",720000],
[1840034249,"Dayton","Dayton","United States","USA","",718353],
[1156011120,"Changsha","Changsha","China","CHN","minor",717700],
[1484215762,"Torreón","Torreon","Mexico","MEX","minor",716672],
[1156232270,"Shihezi","Shihezi","China","CHN","minor",717000],
[1458236750,"George Town","George Town","Malaysia","MYS","admin",708127],
[1566212729,"Enugu","Enugu","Nigeria","NGA","admin",715774],
[1170765625,"Soledad","Soledad","Colombia","COL","minor",698852],
[1076000699,"Jaboatão","Jaboatao","Brazil","BRA","",702621],
[1410188674,"Yanggok","Yanggok","South Korea","KOR","",713321],
[1156009046,"Yatou","Yatou","China","CHN","minor",714211],
[1076625886,"Santo André","Santo Andre","Brazil","BRA","",710210],
[1156116456,"Xichang","Xichang","China","CHN","minor",712434],
[1356763571,"Bhiwandi","Bhiwandi","India","IND","",709665],
[1608379532,"City of Parañaque","City of Paranaque","Philippines","PHL","admin",689992],
[1608418544,"Dasmariñas","Dasmarinas","Philippines","PHL","",703141],
[1156254788,"Chengxiang","Chengxiang","China","CHN","minor",709500],
[1356139858,"Sahāranpur","Saharanpur","India","IND","",705478],
[1356851618,"Warangal","Warangal","India","IND","",704570],
[1392135698,"Edogawa","Edogawa","Japan","JPN","",690457],
[1076786452,"Osasco","Osasco","Brazil","BRA","",694844],
[1156141962,"Dashiqiao","Dashiqiao","China","CHN","minor",704891],
[1760555544,"Latakia","Latakia","Syria","SYR","admin",700000],
[1840000373,"Rochester","Rochester","United States","USA","",703952],
[1840020319,"Fresno","Fresno","United States","USA","",703498],
[1360685223,"Banjarmasin","Banjarmasin","Indonesia","IDN","admin",692793],
[1356567087,"Salem","Salem","India","IND","",693236],
[1608171585,"General Santos","General Santos","Philippines","PHL","admin",697315],
[1760197502,"Ḩamāh","Hamah","Syria","SYR","admin",696863],
[1608869358,"Bacoor","Bacoor","Philippines","PHL","",664625],
[1156077046,"Shishi","Shishi","China","CHN","minor",693000],
[1484002410,"Guadalupe","Guadalupe","Mexico","MEX","minor",691931],
[1392464568,"Adachi","Adachi","Japan","JPN","",682326],
[1156919716,"Qianxi","Qianxi","China","CHN","",695947],
[1643256295,"Tolyatti","Tolyatti","Russia","RUS","",693072],
[1446227359,"Macau","Macau","Macau","MAC","",568700],
[1566483284,"Bauchi","Bauchi","Nigeria","NGA","admin",693700],
[1124567288,"Hamilton","Hamilton","Canada","CAN","",693645],
[1616832750,"Łódź","Lodz","Poland","POL","admin",690422],
[1156690651,"Miluo Chengguanzhen","Miluo Chengguanzhen","China","CHN","minor",692080],
[1156145272,"Gaizhou","Gaizhou","China","CHN","minor",691595],
[1356113556,"Mālegaon","Malegaon","India","IND","",690844],
[1368597794,"Karbalā’","Karbala'","Iraq","IRQ","admin",690100],
[1156044041,"Leling","Leling","China","CHN","minor",689867],
[1076783887,"São José dos Campos","Sao Jose dos Campos","Brazil","BRA","",688597],
[1724991838,"Sevilla","Sevilla","Spain","ESP","admin",684234],
[1156444449,"Jianshe","Jianshe","China","CHN","minor",687130],
[1392235505,"Shizuoka","Shizuoka","Japan","JPN","admin",685589],
[1156033208,"Jingcheng","Jingcheng","China","CHN","minor",684360],
[1356707865,"Kochi","Kochi","India","IND","",677381],
[1840001044,"Allentown","Allentown","United States","USA","",683794],
[1360027771,"Tasikmalaya","Tasikmalaya","Indonesia","IDN","",678027],
[1364630382,"Rasht","Rasht","Iran","IRN","admin",679995],
[1156368551,"Xinmin","Xinmin","China","CHN","",680000],
[1156658422,"Zhongshu","Zhongshu","China","CHN","",679624],
[1156107208,"Xigazê","Xigaze","China","CHN","minor",679771],
[1356190221,"Gorakhpur","Gorakhpur","India","IND","",673446],
[1368735317,"As Sulaymānīyah","As Sulaymaniyah","Iraq","IRQ","admin",676500],
[1724907391,"Zaragoza","Zaragoza","Spain","ESP","admin",675301],
[1484463183,"Acapulco de Juárez","Acapulco de Juarez","Mexico","MEX","minor",673478],
[1364891653,"Bahār","Bahar","Iran","IRN","minor",673405],
[1380428434,"Palermo","Palermo","Italy","ITA","admin",668405],
[1156503907,"Guankou","Guankou","China","CHN","",671200],
[1840021672,"Tulsa","Tulsa","United States","USA","",671033],
[1484087945,"Tlaquepaque","Tlaquepaque","Mexico","MEX","minor",664193],
[1484841466,"Mazatlán","Mazatlan","Mexico","MEX","minor",658354],
[1156143149,"Songyang","Songyang","China","CHN","minor",668592],
[1840015130,"Cape Coral","Cape Coral","United States","USA","",668382],
[1408498177,"Ch’ŏngjin","Ch'ongjin","North Korea","PRK","minor",667929],
[1156103317,"Puyang Chengguanzhen","Puyang Chengguanzhen","China","CHN","minor",666322],
[1156678111,"Qionghu","Qionghu","China","CHN","minor",667104],
[1076524478,"Ribeirão Prêto","Ribeirao Preto","Brazil","BRA","",666323],
[1156601489,"Zhaodong","Zhaodong","China","CHN","minor",666532],
[1024079828,"Huambo","Huambo","Angola","AGO","admin",665564],
[1156574542,"Wenchang","Wenchang","China","CHN","minor",664455],
[1156989733,"Shulan","Shulan","China","CHN","",663403],
[1484861603,"Tlalnepantla","Tlalnepantla","Mexico","MEX","minor",653410],
[1862657837,"Catia La Mar","Catia La Mar","Venezuela","VEN","minor",661897],
[1586696588,"Sargodha","Sargodha","Pakistan","PAK","minor",659862],
[1682958157,"Al Hufūf","Al Hufuf","Saudi Arabia","SAU","",660788],
[1484854616,"Durango","Durango","Mexico","MEX","admin",654876],
[1566732241,"Jalingo","Jalingo","Nigeria","NGA","admin",660213],
[1384983838,"Bouaké","Bouake","Côte d'Ivoire","CIV","admin",659233],
[1586141444,"Sialkot City","Sialkot City","Pakistan","PAK","minor",655852],
[1608850554,"San Jose del Monte","San Jose del Monte","Philippines","PHL","",651813],
[1410585171,"Ansan","Ansan","South Korea","KOR","",652800],
[1156837145,"Lingbao Chengguanzhen","Lingbao Chengguanzhen","China","CHN","minor",656571],
[1410037247,"Hwasu-dong","Hwasu-dong","South Korea","KOR","",655350],
[1704016023,"Huế","Hue","Vietnam","VNM","admin",652572],
[1356016156,"Shimoga","Shimoga","India","IND","",654055],
[1716032632,"Bulawayo","Bulawayo","Zimbabwe","ZWE","admin",653337],
[1156207794,"Xiping","Xiping","China","CHN","minor",652604],
[1156476348,"Sanhe","Sanhe","China","CHN","",652042],
[1356374905,"Guntūr","Guntur","India","IND","",647508],
[1840018905,"Concord","Concord","United States","USA","",652308],
[1076845191,"Contagem","Contagem","Brazil","BRA","",648766],
[1356539761,"Tiruppūr","Tiruppur","India","IND","",650000],
[1410020455,"Ch’ŏnan","Ch'onan","South Korea","KOR","",651661],
[1422886065,"Tripoli","Tripoli","Lebanon","LBN","admin",530000],
[1392505502,"Honchō","Honcho","Japan","JPN","",641499],
[1276615258,"Düsseldorf","Dusseldorf","Germany","DEU","admin",645923],
[1643983138,"Izhevsk","Izhevsk","Russia","RUS","admin",646277],
[1156259342,"Guixi","Guixi","China","CHN","minor",647240],
[1076758708,"Sorocaba","Sorocaba","Brazil","BRA","",644919],
[1458989343,"Petaling Jaya","Petaling Jaya","Malaysia","MYS","",638516],
[1156832866,"Tengyue","Tengyue","China","CHN","minor",644765],
[1156027100,"Wuxue","Wuxue","China","CHN","minor",644247],
[1180518247,"Kikwit","Kikwit","Congo (Kinshasa)","COD","",637736],
[1840018825,"Colorado Springs","Colorado Springs","United States","USA","",642413],
[1156490037,"Qufu","Qufu","China","CHN","",640498],
[1156487293,"Gaobeidian","Gaobeidian","China","CHN","",640280],
[1156104573,"Ruiming","Ruiming","China","CHN","",640600],
[1616108520,"Wrocław","Wroclaw","Poland","POL","admin",638586],
[1036153217,"Gold Coast","Gold Coast","Australia","AUS","",638090],
[1156422214,"Xinshi","Xinshi","China","CHN","minor",636776],
[1887324526,"Ta‘izz","Ta`izz","Yemen","YEM","admin",615467],
[1076527830,"Aracaju","Aracaju","Brazil","BRA","admin",632744],
[1068793894,"Cochabamba","Cochabamba","Bolivia","BOL","admin",632013],
[1410494847,"Jeonju","Jeonju","South Korea","KOR","admin",631532],
[1156661253,"Jin’e","Jin'e","China","CHN","minor",633210],
[1643318931,"Barnaul","Barnaul","Russia","RUS","admin",633301],
[1608725647,"Makati City","Makati City","Philippines","PHL","admin",629616],
[1276171358,"Stuttgart","Stuttgart","Germany","DEU","admin",630305],
[1528892850,"Rotterdam","Rotterdam","Netherlands","NLD","minor",631155],
[1156166828,"Changping","Changping","China","CHN","",614821],
[1434915572,"Benghazi","Benghazi","Libya","LBY","admin",631555],
[1804544901,"Kryvyi Rih","Kryvyi Rih","Ukraine","UKR","minor",629695],
[1356096816,"Raurkela","Raurkela","India","IND","",625831],
[1818000039,"Ḩalwān","Halwan","Egypt","EGY","",619293],
[1840015163,"Charleston","Charleston","United States","USA","",628377],
[1484504936,"Chimalhuacán","Chimalhuacan","Mexico","MEX","minor",614453],
[1156258586,"Xinxing","Xinxing","China","CHN","minor",627475],
[1156236948,"Suohe","Suohe","China","CHN","minor",626700],
[1356972351,"Mangalore","Mangalore","India","IND","",623841],
[1156263400,"Zhuangyuan","Zhuangyuan","China","CHN","minor",626683],
[1826836462,"Glasgow","Glasgow","United Kingdom","GBR","",626410],
[1860894033,"Namangan","Namangan","Uzbekistan","UZB","admin",626120],
[1643668944,"Ulyanovsk","Ulyanovsk","Russia","RUS","admin",624518],
[1643439037,"Irkutsk","Irkutsk","Russia","RUS","admin",623736],
[1356722310,"Nānded","Nanded","India","IND","",623708],
[1566773679,"Jos","Jos","Nigeria","NGA","admin",622802],
[1360992394,"Pontianak","Pontianak","Indonesia","IDN","admin",618388],
[1320353009,"Villa Nueva","Villa Nueva","Guatemala","GTM","minor",618397],
[1156127276,"Bazhou","Bazhou","China","CHN","",622975],
[1840000466,"Springfield","Springfield","United States","USA","",623401],
[1156573684,"Turpan","Turpan","China","CHN","minor",622903],
[1608544537,"Las Piñas City","Las Pinas City","Philippines","PHL","",606293],
[1156474288,"Meihekou","Meihekou","China","CHN","minor",618251],
[1156897463,"Jurong","Jurong","China","CHN","",617706],
[1076892244,"Feira de Santana","Feira de Santana","Brazil","BRA","",617528],
[1643175363,"Khabarovsk","Khabarovsk","Russia","RUS","admin",616242],
[1156456552,"Xinji","Xinji","China","CHN","",615919],
[1360329102,"Serang","Serang","Indonesia","IDN","admin",613356],
[1004003059,"Kandahār","Kandahar","Afghanistan","AFG","admin",614254],
[1156373900,"Sanya","Sanya","China","CHN","minor",614647],
[1032233996,"San Miguel de Tucumán","San Miguel de Tucuman","Argentina","ARG","admin",605767],
[1643338528,"Yaroslavl","Yaroslavl","Russia","RUS","admin",608079],
[1156996913,"Zhangshu","Zhangshu","China","CHN","",610424],
[1792374908,"Bağcılar","Bagcilar","Turkey","TUR","",556519],
[1840002928,"Grand Rapids","Grand Rapids","United States","USA","",609314],
[1643832017,"Vladivostok","Vladivostok","Russia","RUS","admin",606589],
[1458763489,"Kuantan","Kuantan","Malaysia","MYS","admin",607778],
[1752059374,"Gothenburg","Gothenburg","Sweden","SWE","admin",604829],
[1356872061,"Cuttack","Cuttack","India","IND","",606007],
[1360645580,"Jambi","Jambi","Indonesia","IDN","admin",602187],
[1360181436,"Cimahi","Cimahi","Indonesia","IDN","",586580],
[1608244137,"Bacolod","Bacolod","Philippines","PHL","admin",600783],
[1156045160,"Zhuozhou","Zhuozhou","China","CHN","",603535],
[1076495001,"Uberlândia","Uberlandia","Brazil","BRA","",604013],
[1156770851,"Tianchang","Tianchang","China","CHN","minor",602840],
[1392975133,"Kawaguchi","Kawaguchi","Japan","JPN","",593353],
[1392836404,"Itabashi","Itabashi","Japan","JPN","",581337],
[1392003090,"Suginami-ku","Suginami-ku","Japan","JPN","",583609],
[1484832519,"Tuxtla","Tuxtla","Mexico","MEX","admin",598710],
[1356033724,"Tumkūr","Tumkur","India","IND","",599078],
[1276563678,"Leipzig","Leipzig","Germany","DEU","minor",597215],
[1360500922,"Balikpapan","Balikpapan","Indonesia","IDN","",598043],
[1156277802,"Qamdo","Qamdo","China","CHN","minor",598862],
[1710149138,"Durban","Durban","South Africa","ZAF","",595061],
[1356592607,"Chānda","Chanda","India","IND","",595118],
[1392120675,"Kagoshima","Kagoshima","Japan","JPN","admin",593754],
[1682494753,"Al Ḩillah","Al Hillah","Saudi Arabia","SAU","",594605],
[1643580480,"Makhachkala","Makhachkala","Russia","RUS","admin",592976],
[1156609451,"Sihui","Sihui","China","CHN","",593400],
[1032456103,"Mar del Plata","Mar del Plata","Argentina","ARG","minor",593337],
[1484625454,"Irapuato","Irapuato","Mexico","MEX","minor",592953],
[1124625989,"Brampton","Brampton","Canada","CAN","",593638],
[1156180482,"Luocheng","Luocheng","China","CHN","minor",591115],
[1170386718,"Pereira","Pereira","Colombia","COL","admin",590554],
[1840020580,"Mission Viejo","Mission Viejo","United States","USA","",590249],
[1276562886,"Dortmund","Dortmund","Germany","DEU","minor",587696],
[1484737671,"Reynosa","Reynosa","Mexico","MEX","minor",589466],
[1156225985,"Chuxiong","Chuxiong","China","CHN","",588620],
[1364072353,"Zāhedān","Zahedan","Iran","IRN","admin",587730],
[1156547188,"Jinhua","Jinhua","China","CHN","minor",586000],
[1840000417,"Albany","Albany","United States","USA","admin",586383],
[1458194263,"Shah Alam","Shah Alam","Malaysia","MYS","admin",584340],
[1840014486,"Knoxville","Knoxville","United States","USA","",586048],
[1076112309,"Cuiabá","Cuiaba","Brazil","BRA","admin",585367],
[1156107332,"Shangzhi","Shangzhi","China","CHN","minor",585386],
[1276769247,"Essen","Essen","Germany","DEU","minor",582415],
[1156018338,"Botou","Botou","China","CHN","",584308],
[1170940590,"Bucaramanga","Bucaramanga","Colombia","COL","admin",581130],
[1410581095,"Anyang","Anyang","South Korea","KOR","",573296],
[1380716540,"Genoa","Genoa","Italy","ITA","admin",580097],
[1729710259,"Port Sudan","Port Sudan","Sudan","SDN","admin",579942],
[1152516346,"Puente Alto","Puente Alto","Chile","CHL","minor",573935],
[1356970407,"Dehra Dūn","Dehra Dun","India","IND","admin",578420],
[1682956102,"Aţ Ţā’if","At Ta'if","Saudi Arabia","SAU","",579970],
[1840019148,"Bakersfield","Bakersfield","United States","USA","",579295],
[1156017483,"Wancheng","Wancheng","China","CHN","minor",578600],
[1724397372,"Málaga","Malaga","Spain","ESP","minor",577405],
[1392172935,"Hachiōji","Hachioji","Japan","JPN","",575721],
[1840020135,"Ogden","Ogden","United States","USA","",578523],
[1156284109,"Xiulin","Xiulin","China","CHN","",577022],
[1156244234,"Fu’an","Fu'an","China","CHN","minor",577000],
[1643258928,"Tomsk","Tomsk","Russia","RUS","admin",572740],
[1484750897,"Tonalá","Tonala","Mexico","MEX","minor",569913],
[1156131545,"Kumul","Kumul","China","CHN","minor",572400],
[1826921049,"Bristol","Bristol","United Kingdom","GBR","",567111],
[1156158643,"Luofeng","Luofeng","China","CHN","minor",570898],
[1156184681,"Lingyuan","Lingyuan","China","CHN","",570660],
[1400221568,"Irbid","Irbid","Jordan","JOR","admin",569068],
[1840013941,"Baton Rouge","Baton Rouge","United States","USA","admin",570308],
[1156335543,"Huzhou","Huzhou","China","CHN","minor",569000],
[1156985313,"Wencheng","Wencheng","China","CHN","minor",568900],
[1276376509,"Bremen","Bremen","Germany","DEU","admin",566573],
[1862318264,"Ciudad Bolívar","Ciudad Bolivar","Venezuela","VEN","admin",567953],
[1356045686,"Durgāpur","Durgapur","India","IND","",566517],
[1643685056,"Orenburg","Orenburg","Russia","RUS","admin",564443],
[1156921843,"Shenzhou","Shenzhou","China","CHN","",566087],
[1356093694,"Āsansol","Asansol","India","IND","",563917],
[1840000791,"Akron","Akron","United States","USA","",565208],
[1156174997,"Kuiju","Kuiju","China","CHN","minor",564501],
[1840004850,"New Haven","New Haven","United States","USA","",564830],
[1156634387,"Zhenzhou","Zhenzhou","China","CHN","minor",564021],
[1360853933,"Surakarta","Surakarta","Indonesia","IDN","",552118],
[1156304827,"Jieshou","Jieshou","China","CHN","",561956],
[1024141961,"Benguela","Benguela","Angola","AGO","admin",561775],
[1484714297,"Ensenada","Ensenada","Mexico","MEX","minor",557430],
[1156585505,"Dangyang","Dangyang","China","CHN","",560000],
[1840014730,"Columbia","Columbia","United States","USA","admin",560041],
[1643216311,"Kemerovo","Kemerovo","Russia","RUS","admin",556920],
[1004237782,"Herāt","Herat","Afghanistan","AFG","admin",556205],
[1276561036,"Dresden","Dresden","Germany","DEU","admin",554907],
[1356982375,"Bhāvnagar","Bhavnagar","India","IND","",554978],
[1076006144,"Juiz de Fora","Juiz de Fora","Brazil","BRA","",555284],
[1156092104,"Luanzhou","Luanzhou","China","CHN","minor",554315],
[1364126377,"Hamadān","Hamadan","Iran","IRN","admin",554406],
[1643628717,"Novokuznetsk","Novokuznetsk","Russia","RUS","",552105],
[1356280972,"Nellore","Nellore","India","IND","",547621],
[1604799615,"Chiclayo","Chiclayo","Peru","PER","admin",552508],
[1826246335,"Manchester","Manchester","United Kingdom","GBR","",547627],
[1887984890,"Al Ḩudaydah","Al Hudaydah","Yemen","YEM","admin",548433],
[1356462099,"Amrāvati","Amravati","India","IND","",549370],
[1024474012,"Cabinda","Cabinda","Angola","AGO","admin",550000],
[1156965620,"Korla","Korla","China","CHN","minor",549324],
[1156131099,"Huanghua","Huanghua","China","CHN","minor",548507],
[1608473406,"Muntinlupa City","Muntinlupa City","Philippines","PHL","admin",543445],
[1076723241,"Londrina","Londrina","Brazil","BRA","",548249],
[1682590992,"Tabūk","Tabuk","Saudi Arabia","SAU","admin",547957],
[1484614906,"Heroica Matamoros","Heroica Matamoros","Mexico","MEX","minor",541979],
[1860388706,"Samarkand","Samarkand","Uzbekistan","UZB","admin",546303],
[1156705922,"Xingcheng","Xingcheng","China","CHN","",546176],
[1156081841,"Kaiyuan","Kaiyuan","China","CHN","",545624],
[1276457707,"Hannover","Hannover","Germany","DEU","admin",542668],
[1170481949,"Valledupar","Valledupar","Colombia","COL","admin",544134],
[1156519626,"Fengcheng","Fengcheng","China","CHN","",543933],
[1356058258,"Ajmer","Ajmer","India","IND","",542321],
[1156064979,"Ghulja","Ghulja","China","CHN","minor",542507],
[1356037155,"Tinnevelly","Tinnevelly","India","IND","",542200],
[1608985581,"City of Calamba","City of Calamba","Philippines","PHL","",539671],
[1156215566,"Xiangyang","Xiangyang","China","CHN","",541554],
[1156530120,"Fuding","Fuding","China","CHN","minor",542000],
[1368273311,"An Nāşirīyah","An Nasiriyah","Iraq","IRQ","admin",541600],
[1368916692,"Al Ḩillah","Al Hillah","Iraq","IRQ","admin",541034],
[1170245063,"Ibagué","Ibague","Colombia","COL","admin",541101],
[1643205787,"Ryazan","Ryazan","Russia","RUS","admin",537622],
[1729157224,"Kassala","Kassala","Sudan","SDN","admin",536009],
[1156139784,"Chang’an","Chang'an","China","CHN","minor",537500],
[1364554896,"Kermān","Kerman","Iran","IRN","admin",537718],
[1392003346,"Kōtō-ku","Koto-ku","Japan","JPN","",523117],
[1616725607,"Poznań","Poznan","Poland","POL","admin",533830],
[1156436913,"Aksu","Aksu","China","CHN","minor",535657],
[1032926124,"Salta","Salta","Argentina","ARG","admin",535303],
[1643407929,"Astrakhan","Astrakhan","Russia","RUS","admin",532504],
[1156575615,"Wuhai","Wuhai","China","CHN","minor",532902],
[1156864248,"Mingguang","Mingguang","China","CHN","",532732],
[1643008493,"Naberezhnyye Chelny","Naberezhnyye Chelny","Russia","RUS","",529797],
[1056168623,"Antwerp","Antwerp","Belgium","BEL","minor",529247],
[1686956738,"Touba","Touba","Senegal","SEN","",529176],
[1364437616,"Ardabīl","Ardabil","Iran","IRN","admin",529374],
[1356026593,"Bīkaner","Bikaner","India","IND","",529007],
[1250196189,"Lyon","Lyon","France","FRA","admin",518635],
[1356148992,"Agartala","Agartala","India","IND","admin",522613],
[1894032745,"Ndola","Ndola","Zambia","ZMB","admin",528330],
[1392003149,"Himeji","Himeji","Japan","JPN","",527596],
[1484562374,"Tultitlán de Mariano Escobedo","Tultitlan de Mariano Escobedo","Mexico","MEX","minor",520557],
[1170426927,"Villavicencio","Villavicencio","Colombia","COL","admin",527668],
[1156279608,"Ailan Mubage","Ailan Mubage","China","CHN","minor",526745],
[1364120623,"Bandar ‘Abbās","Bandar `Abbas","Iran","IRN","admin",526648],
[1704025181,"Bắc Ninh","Bac Ninh","Vietnam","VNM","admin",520000],
[1484855080,"Ciudad Apodaca","Ciudad Apodaca","Mexico","MEX","minor",523370],
[1862528581,"Santa Teresa del Tuy","Santa Teresa del Tuy","Venezuela","VEN","minor",525321],
[1152583016,"Maipú","Maipu","Chile","CHL","",521627],
[1643492830,"Penza","Penza","Russia","RUS","admin",523726],
[1170512000,"Soacha","Soacha","Colombia","COL","minor",522442],
[1818628574,"Port Said","Port Said","Egypt","EGY","admin",524433],
[1156530681,"Yucheng","Yucheng","China","CHN","minor",522878],
[1504333193,"Meknès","Meknes","Morocco","MAR","",520428],
[1364624691,"Arāk","Arak","Iran","IRN","admin",520944],
[1410983252,"Pohang","Pohang","South Korea","KOR","minor",520305],
[1156863928,"Longzhou","Longzhou","China","CHN","",520000],
[1156142150,"Anda","Anda","China","CHN","minor",520000],
[1156181533,"Jinghong","Jinghong","China","CHN","",519935],
[1826289852,"Sheffield","Sheffield","United Kingdom","GBR","",518090],
[1392506125,"Utsunomiya","Utsunomiya","Japan","JPN","admin",518197],
[1818495972,"Suez","Suez","Egypt","EGY","admin",516959],
[1276166609,"Nuremberg","Nuremberg","Germany","DEU","minor",515543],
[1826558678,"Liverpool","Liverpool","United Kingdom","GBR","",513441],
[1840020566,"Mesa","Mesa","United States","USA","",518012],
[1124001454,"Surrey","Surrey","Canada","CAN","",517887],
[1156013872,"Heshan","Heshan","China","CHN","",516500],
[1156200283,"Zhoushan","Zhoushan","China","CHN","minor",516000],
[1356050735,"Ujjain","Ujjain","India","IND","",515215],
[1156658217,"Jiaji","Jiaji","China","CHN","minor",515700],
[1170715594,"Santa Marta","Santa Marta","Colombia","COL","admin",515556],
[1076050637,"Joinvile","Joinvile","Brazil","BRA","",515288],
[1156424678,"Beining","Beining","China","CHN","",514898],
[1704909566,"Hải Dương","Hai Duong","Vietnam","VNM","admin",507469],
[1332000098,"Carrefour","Carrefour","Haiti","HTI","",511345],
[1862546949,"Maturín","Maturin","Venezuela","VEN","admin",514046],
[1112580227,"Homyel’","Homyel'","Belarus","BLR","admin",510300],
[1076025295,"Ananindeua","Ananindeua","Brazil","BRA","",510834],
[1156405468,"Yanji","Yanji","China","CHN","minor",513072],
[1156742818,"Yicheng","Yicheng","China","CHN","minor",512530],
[1356375341,"Ulhāsnagar","Ulhasnagar","India","IND","",506098],
[1643772906,"Lipetsk","Lipetsk","Russia","RUS","admin",510439],
[1368336235,"Al ‘Amārah","Al `Amarah","Iraq","IRQ","admin",511500],
[1340125981,"Choloma","Choloma","Honduras","HND","",510456],
[1804806030,"Sevastopol","Sevastopol","Ukraine","UKR","admin",509992],
[1156653230,"Encheng","Encheng","China","CHN","minor",509700],
[1887867886,"Aden","Aden","Yemen","YEM","admin",507355],
[1894321752,"Kitwe","Kitwe","Zambia","ZMB","",504194],
[1392220893,"Matsuyama","Matsuyama","Japan","JPN","admin",506743],
[1356712664,"Jhānsi","Jhansi","India","IND","",507000],
[1156113193,"Kashgar","Kashgar","China","CHN","minor",506640],
[1840015094,"Palm Bay","Palm Bay","United States","USA","",507002],
[1158209038,"Pingtung","Pingtung","Taiwan","TWN","admin",503530],
[1608430676,"Lapu-Lapu City","Lapu-Lapu City","Philippines","PHL","admin",497604],
[1170855299,"Montería","Monteria","Colombia","COL","admin",505334],
[1392076347,"Ichikawa","Ichikawa","Japan","JPN","",496657],
[1608802508,"Imus","Imus","Philippines","PHL","",496794],
[1356445061,"Davangere","Davangere","India","IND","",503564],
[1356491738,"Jammu","Jammu","India","IND","",502197],
[1156078044,"Yiwu","Yiwu","China","CHN","minor",502000],
[1024196826,"Belas","Belas","Angola","AGO","",500000],
[1024988332,"Talatona","Talatona","Angola","AGO","",500000],
[1566756897,"Ile-Ife","Ile-Ife","Nigeria","NGA","minor",501952],
[1643106064,"Kirov","Kirov","Russia","RUS","admin",501468],
[1156491661,"Jiaxing","Jiaxing","China","CHN","minor",500100],
[1804398395,"Mykolaiv","Mykolaiv","Ukraine","UKR","admin",498748],
[1840020174,"Provo","Provo","United States","USA","",500617],
[1156136207,"Meicheng","Meicheng","China","CHN","minor",500292],
[1076501425,"Niterói","Niteroi","Brazil","BRA","",496696],
[1392642525,"Matsudo","Matsudo","Japan","JPN","",492367],
[1586383591,"Sukkur","Sukkur","Pakistan","PAK","minor",499900],
[1504891036,"Oujda-Angad","Oujda-Angad","Morocco","MAR","admin",494252],
[1156438524,"Taozhou","Taozhou","China","CHN","minor",499132],
[1392117396,"Higashi-ōsaka","Higashi-osaka","Japan","JPN","",490819],
[1458747615,"Johor Bahru","Johor Bahru","Malaysia","MYS","admin",497097],
[1840000434,"Worcester","Worcester","United States","USA","",498328],
[1156039152,"Hongjiang","Hongjiang","China","CHN","",498100],
[1604199858,"Chimbote","Chimbote","Peru","PER","",497875],
[1276977172,"Duisburg","Duisburg","Germany","DEU","minor",495885],
[1398274508,"Qaraghandy","Qaraghandy","Kazakhstan","KAZ","admin",497777],
[1484452937,"Ixtapaluca","Ixtapaluca","Mexico","MEX","minor",495566],
[1156096868,"Dengtacun","Dengtacun","China","CHN","",496122],
[1156769646,"Zhijiang","Zhijiang","China","CHN","",495995],
[1156571332,"Chengjiao","Chengjiao","China","CHN","minor",495744],
[1156378599,"Beipiao","Beipiao","China","CHN","",496164],
[1156764587,"Suoluntun","Suoluntun","China","CHN","",495900],
[1840020553,"Murrieta","Murrieta","United States","USA","",496046],
[1458150101,"Kota Bharu","Kota Bharu","Malaysia","MYS","admin",491237],
[1484363879,"Ciudad López Mateos","Ciudad Lopez Mateos","Mexico","MEX","minor",489937],
[1484979555,"Celaya","Celaya","Mexico","MEX","minor",494304],
[1704960059,"Vinh","Vinh","Vietnam","VNM","admin",490000],
[1156084618,"Duyun","Duyun","China","CHN","",493574],
[1484443585,"Los Mochis","Los Mochis","Mexico","MEX","minor",490000],
[1729833248,"Nyala","Nyala","Sudan","SDN","admin",492984],
[1586678302,"Larkana","Larkana","Pakistan","PAK","minor",490508],
[1392114116,"Nishinomiya-hama","Nishinomiya-hama","Japan","JPN","",487010],
[1784337875,"‘Ajmān","`Ajman","United Arab Emirates","ARE","admin",490035],
[1643163382,"Cheboksary","Cheboksary","Russia","RUS","admin",489498],
[1156294277,"Yuanping","Yuanping","China","CHN","",491213],
[1250258110,"Toulouse","Toulouse","France","FRA","admin",486828],
[1826492520,"Edinburgh","Edinburgh","United Kingdom","GBR","",488050],
[1356390535,"Belgaum","Belgaum","India","IND","",488157],
[1643255206,"Tula","Tula","Russia","RUS","admin",485221],
[1156690538,"Shahe","Shahe","China","CHN","",486329],
[1076191325,"Serra","Serra","Brazil","BRA","",485376],
[1156238773,"Gaoping","Gaoping","China","CHN","",484862],
[1840013501,"Greenville","Greenville","United States","USA","",484465],
[1356091187,"Gulbarga","Gulbarga","India","IND","",483615],
[1156058709,"Dunhua","Dunhua","China","CHN","minor",483811],
[1840057464,"Brookhaven","Brookhaven","United States","USA","",483546],
[1400161837,"Az Zarqā’","Az Zarqa'","Jordan","JOR","admin",481300],
[1050646703,"Sylhet","Sylhet","Bangladesh","BGD","admin",479837],
[1840001686,"Wichita","Wichita","United States","USA","",482249],
[1840000572,"Toledo","Toledo","United States","USA","",482111],
[1156017759,"Kaihua","Kaihua","China","CHN","minor",481505],
[1356104995,"Jāmnagar","Jamnagar","India","IND","",479920],
[1156196485,"Fuyuan","Fuyuan","China","CHN","minor",480000],
[1356224695,"Dhūlia","Dhulia","India","IND","",479073],
[1356045727,"Gaya","Gaya","India","IND","",474093],
[1076190259,"Florianópolis","Florianopolis","Brazil","BRA","admin",477798],
[1586413435,"Chiniot","Chiniot","Pakistan","PAK","minor",477781],
[1156155414,"Jiannan","Jiannan","China","CHN","minor",477868],
[1392081193,"Ōita","Oita","Japan","JPN","admin",477186],
[1643178106,"Kaliningrad","Kaliningrad","Russia","RUS","admin",475056],
[1156426803,"Nangong","Nangong","China","CHN","",476096],
[1392003246,"Kurashiki","Kurashiki","Japan","JPN","",474862],
[1840034032,"Staten Island","Staten Island","United States","USA","",476143],
[1792992349,"Küçükçekmece","Kucukcekmece","Turkey","TUR","minor",469431],
[1032869625,"San Juan","San Juan","Argentina","ARG","admin",471389],
[1076404077,"Vila Velha","Vila Velha","Brazil","BRA","",472762],
[1004436363,"Mazār-e Sharīf","Mazar-e Sharif","Afghanistan","AFG","admin",469247],
[1076189884,"Macapá","Macapa","Brazil","BRA","admin",474706],
[1586291726,"Shekhupura","Shekhupura","Pakistan","PAK","minor",473129],
[1840007069,"Des Moines","Des Moines","United States","USA","admin",473957],
[1604331641,"Piura","Piura","Peru","PER","admin",473025],
[1608166320,"Mandaluyong City","Mandaluyong City","Philippines","PHL","admin",425758],
[1156812073,"Jiaojiangcun","Jiaojiangcun","China","CHN","",471500],
[1156791804,"Laohekou","Laohekou","China","CHN","",471482],
[1792526380,"Kâğıthane","Kagithane","Turkey","TUR","",437026],
[1608036027,"Angeles City","Angeles City","Philippines","PHL","admin",462928],
[1608448280,"Pasay City","Pasay City","Philippines","PHL","admin",440656],
[1156084414,"Beian","Beian","China","CHN","",470000],
[1156404715,"Fujin","Fujin","China","CHN","minor",470000],
[1826431946,"Leicester","Leicester","United Kingdom","GBR","",464395],
[1156910270,"Xiaoyi","Xiaoyi","China","CHN","",468770],
[1032009573,"Lanús","Lanus","Argentina","ARG","minor",459263],
[1156587033,"Qingzhen","Qingzhen","China","CHN","",467992],
[1368444902,"Ba‘qūbah","Ba`qubah","Iraq","IRQ","admin",467900],
[1392003368,"Katsushika-ku","Katsushika-ku","Japan","JPN","",453410],
[1682470726,"Buraydah","Buraydah","Saudi Arabia","SAU","admin",467410],
[1616406372,"Gdańsk","Gdansk","Poland","POL","admin",464254],
[1608000077,"Marikina City","Marikina City","Philippines","PHL","admin",456059],
[1360771278,"Manado","Manado","Indonesia","IDN","admin",461636],
[1076606365,"Campos","Campos","Brazil","BRA","",463731],
[1566495489,"Calabar","Calabar","Nigeria","NGA","admin",461796],
[1392684679,"Kanazawa","Kanazawa","Japan","JPN","admin",462479],
[1608875987,"Iloilo","Iloilo","Philippines","PHL","admin",457626],
[1840020490,"Long Beach","Long Beach","United States","USA","",462628],
[1156894895,"Kuqa","Kuqa","China","CHN","minor",462588],
[1356734842,"Jalgaon","Jalgaon","India","IND","",460468],
[1036685862,"Cranbourne","Cranbourne","Australia","AUS","",460491],
[1840015119,"Port St. Lucie","Port St. Lucie","United States","USA","",461152],
[1724107739,"Murcia","Murcia","Spain","ESP","admin",460349],
[1076477498,"Mauá","Maua","Brazil","BRA","",453286],
[1392551602,"Fukuyama","Fukuyama","Japan","JPN","",459576],
[1376401542,"Tel Aviv-Yafo","Tel Aviv-Yafo","Israel","ISR","admin",451523],
[1156161838,"Xicheng","Xicheng","China","CHN","minor",459781],
[1392003182,"Amagasaki","Amagasaki","Japan","JPN","",450506],
[1410641095,"Pyeongtaek","Pyeongtaek","South Korea","KOR","",457873],
[1356058372,"Kurnool","Kurnool","India","IND","",457633],
[1840019390,"Denton","Denton","United States","USA","",457177],
[1458467506,"Melaka","Melaka","Malaysia","MYS","admin",455300],
[1158127875,"Taoyuan District","Taoyuan District","Taiwan","TWN","admin",443273],
[1608826995,"General Trias","General Trias","Philippines","PHL","",450583],
[1156278784,"Jian’ou","Jian'ou","China","CHN","minor",456000],
[1156018839,"Huadian","Huadian","China","CHN","",455339],
[1818501770,"Ţanţā","Tanta","Egypt","EGY","admin",429503],
[1458441859,"Kota Kinabalu","Kota Kinabalu","Malaysia","MYS","admin",452058],
[1156295044,"Minzhu","Minzhu","China","CHN","minor",453265],
[1180475821,"Bukavu","Bukavu","Congo (Kinshasa)","COD","admin",436779],
[1050547831,"Rājshāhi","Rajshahi","Bangladesh","BGD","admin",448087],
[1643989845,"Balashikha","Balashikha","Russia","RUS","",450771],
[1356266094,"Udaipur","Udaipur","India","IND","",451100],
[1643011077,"Kursk","Kursk","Russia","RUS","admin",449063],
[1804630021,"Mariupol","Mariupol","Ukraine","UKR","",449498],
[1364870126,"Eslāmshahr","Eslamshahr","Iran","IRN","minor",448129],
[1484264138,"San Nicolás de los Garza","San Nicolas de los Garza","Mexico","MEX","minor",443273],
[1158276420,"Hsinchu","Hsinchu","Taiwan","TWN","admin",445635],
[1862418619,"Barcelona","Barcelona","Venezuela","VEN","admin",448016],
[1012275076,"Constantine","Constantine","Algeria","DZA","admin",448374],
[1156690688,"Tanbei","Tanbei","China","CHN","minor",447701],
[1566196391,"Ado-Ekiti","Ado-Ekiti","Nigeria","NGA","admin",446749],
[1840002915,"Madison","Madison","United States","USA","admin",447245],
[1356209152,"Bellary","Bellary","India","IND","",445388],
[1608543530,"Rodriguez","Rodriguez","Philippines","PHL","",443954],
[1192766111,"Santiago de Cuba","Santiago de Cuba","Cuba","CUB","admin",444851],
[1156001205,"Yongji","Yongji","China","CHN","",444724],
[1840020121,"Reno","Reno","United States","USA","",445020],
[1156347994,"Danjiangkou","Danjiangkou","China","CHN","",443755],
[1076760827,"São José do Rio Prêto","Sao Jose do Rio Preto","Brazil","BRA","",442548],
[1392640771,"Fujisawa","Fujisawa","Japan","JPN","",436744],
[1860445095,"Andijon","Andijon","Uzbekistan","UZB","admin",441700],
[1840001288,"Harrisburg","Harrisburg","United States","USA","admin",442289],
[1392788615,"Machida","Machida","Japan","JPN","",434414],
[1156629205,"Ning’an","Ning'an","China","CHN","minor",440000],
[1840015509,"Little Rock","Little Rock","United States","USA","admin",439815],
[1156240430,"Zhangjiakou Shi Xuanhua Qu","Zhangjiakou Shi Xuanhua Qu","China","CHN","minor",409745],
[1756539143,"Zürich","Zurich","Switzerland","CHE","admin",434008],
[1408510801,"Sunch’ŏn","Sunch'on","North Korea","PRK","",437000],
[1156184861,"Jinchang","Jinchang","China","CHN","minor",438026],
[1392133166,"Kashiwa","Kashiwa","Japan","JPN","",433941],
[1156955625,"Guangming","Guangming","China","CHN","minor",437559],
[1356921375,"Sāngli","Sangli","India","IND","",436639],
[1356751023,"Tuticorin","Tuticorin","India","IND","",436094],
[1508407369,"Beira","Beira","Mozambique","MOZ","admin",436240],
[1360696757,"Kupang","Kupang","Indonesia","IDN","admin",433970],
[1410364424,"Jeju","Jeju","South Korea","KOR","admin",435413],
[1076809957,"Caxias do Sul","Caxias do Sul","Brazil","BRA","",435564],
[1076033299,"Santos","Santos","Brazil","BRA","",433966],
[1170930654,"Manizales","Manizales","Colombia","COL","admin",434403],
[1643947228,"Stavropol","Stavropol","Russia","RUS","admin",433577],
[1360384833,"Yogyakarta","Yogyakarta","Indonesia","IDN","admin",422732],
[1356010401,"Calicut","Calicut","India","IND","minor",431560],
[1484992153,"Veracruz","Veracruz","Mexico","MEX","minor",428323],
[1364312712,"Zanjān","Zanjan","Iran","IRN","admin",433475],
[1604162901,"Cusco","Cusco","Peru","PER","admin",428450],
[1710480365,"Welkom","Welkom","South Africa","ZAF","",431944],
[1643774900,"Ulan-Ude","Ulan-Ude","Russia","RUS","admin",431922],
[1840020296,"Oakland","Oakland","United States","USA","",433031],
[1392003304,"Shinagawa-ku","Shinagawa-ku","Japan","JPN","",415729],
[1364006067,"Kāshān","Kashan","Iran","IRN","minor",432557],
[1504534876,"Kenitra","Kenitra","Morocco","MAR","",431282],
[1566061694,"Uyo","Uyo","Nigeria","NGA","admin",429900],
[1566574518,"Sokoto","Sokoto","Nigeria","NGA","admin",427760],
[1410394650,"Masan","Masan","South Korea","KOR","",429612],
[1788196439,"Sidi Bouzid","Sidi Bouzid","Tunisia","TUN","admin",429912],
[1076045591,"Porto Velho","Porto Velho","Brazil","BRA","admin",428527],
[1410313432,"Sihŭng","Sihung","South Korea","KOR","",425184],
[1484334948,"Xalapa","Xalapa","Mexico","MEX","admin",424755],
[1032730758,"Florencio Varela","Florencio Varela","Argentina","ARG","",426005],
[1410888678,"Uijeongbu","Uijeongbu","South Korea","KOR","",421579],
[1356089496,"Akola","Akola","India","IND","",425817],
[1392083898,"Aomori","Aomori","Japan","JPN","admin",425962],
[1156048097,"Yan’an Beilu","Yan'an Beilu","China","CHN","minor",426253],
[1504116858,"Agadir","Agadir","Morocco","MAR","admin",421844],
[1076857883,"Mogi das Cruzes","Mogi das Cruzes","Brazil","BRA","",424633],
[1840013364,"Durham","Durham","United States","USA","",424700],
[1076867279,"Diadema","Diadema","Brazil","BRA","",412428],
[1180978192,"Likasi","Likasi","Congo (Kinshasa)","COD","",422535],
[1170287988,"Buenaventura","Buenaventura","Colombia","COL","minor",423927],
[1364429875,"Yazd","Yazd","Iran","IRN","admin",423006],
[1124922301,"Laval","Laval","Canada","CAN","",422993],
[1392498272,"Toyota","Toyota","Japan","JPN","",422106],
[1608571683,"Santa Rosa","Santa Rosa","Philippines","PHL","",414812],
[1840015324,"Winston-Salem","Winston-Salem","United States","USA","",422269],
[1643456559,"Tver","Tver","Russia","RUS","admin",419363],
[1792156766,"Elazığ","Elazig","Turkey","TUR","admin",421726],
[1104494124,"Hpa-An","Hpa-An","Myanmar","MMR","admin",421525],
[1724728111,"Palma","Palma","Spain","ESP","admin",419366],
[1840014227,"Bonita Springs","Bonita Springs","United States","USA","",421291],
[1156267144,"Mishan","Mishan","China","CHN","minor",420000],
[1156267191,"Hailin","Hailin","China","CHN","minor",420000],
[1458051507,"Seremban","Seremban","Malaysia","MYS","admin",419536],
[1156612198,"Lecheng","Lecheng","China","CHN","minor",419500],
[1156759747,"Zhengjiatun","Zhengjiatun","China","CHN","",419529],
[1804688214,"Luhansk","Luhansk","Ukraine","UKR","admin",417990],
[1156147187,"Pencheng","Pencheng","China","CHN","",419047],
[1643987830,"Magnitogorsk","Magnitogorsk","Russia","RUS","",418241],
[1392427161,"Takamatsu","Takamatsu","Japan","JPN","admin",417814],
[1729215531,"El Obeid","El Obeid","Sudan","SDN","admin",418280],
[1156912899,"Dalai","Dalai","China","CHN","",418232],
[1156533633,"Xingren","Xingren","China","CHN","",417919],
[1180380965,"Kolwezi","Kolwezi","Congo (Kinshasa)","COD","admin",418000],
[1156385754,"Wenlan","Wenlan","China","CHN","minor",417156],
[1840019304,"Indio","Indio","United States","USA","",417059],
[1840015064,"Palm Coast","Palm Coast","United States","USA","",417007],
[1608039268,"Biñan","Binan","Philippines","PHL","",407437],
[1834484937,"Arusha","Arusha","Tanzania","TZA","admin",416442],
[1156455704,"Fenyang","Fenyang","China","CHN","",416212],
[1410365324,"Paju","Paju","South Korea","KOR","minor",415345],
[1360021952,"Mataram","Mataram","Indonesia","IDN","admin",408900],
[1840014569,"Chattanooga","Chattanooga","United States","USA","",415501],
[1404511920,"Kisumu","Kisumu","Kenya","KEN","admin",409928],
[1586288677,"Jhang City","Jhang City","Pakistan","PAK","minor",414131],
[1156260844,"Nagqu","Nagqu","China","CHN","minor",414554],
[1360517692,"Jayapura","Jayapura","Indonesia","IDN","admin",413283],
[1076391263,"Rio Branco","Rio Branco","Brazil","BRA","admin",413418],
[1392000560,"Toyama","Toyama","Japan","JPN","admin",413028],
[1156384608,"Fangting","Fangting","China","CHN","minor",412758],
[1364178783,"Sanandaj","Sanandaj","Iran","IRN","admin",412767],
[1156081300,"Linghai","Linghai","China","CHN","",412513],
[1392003256,"Toyonaka","Toyonaka","Japan","JPN","",401233],
[1840021093,"Spokane","Spokane","United States","USA","",412275],
[1643009782,"Sochi","Sochi","Russia","RUS","",411524],
[1356760990,"Bhāgalpur","Bhagalpur","India","IND","",410210],
[1643297945,"Ivanovo","Ivanovo","Russia","RUS","admin",406933],
[1795079064,"Türkmenabat","Turkmenabat","Turkmenistan","TKM","admin",408906],
[1566287704,"Zaria","Zaria","Nigeria","NGA","minor",408198],
[1643208827,"Bryansk","Bryansk","Russia","RUS","admin",406553],
[1818456592,"Asyūţ","Asyut","Egypt","EGY","admin",389307],
[1156077074,"Taiping","Taiping","China","CHN","",407594],
[1800265900,"Mbale","Mbale","Uganda","UGA","admin",402368],
[1862284350,"Maracay","Maracay","Venezuela","VEN","admin",407109],
[1156275703,"Jiexiu","Jiexiu","China","CHN","",406517],
[1032817575,"Santa Fe","Santa Fe","Argentina","ARG","admin",405683],
[1076218697,"Campina Grande","Campina Grande","Brazil","BRA","",405072],
[1392162566,"Nagasaki","Nagasaki","Japan","JPN","admin",404656],
[1616256546,"Szczecin","Szczecin","Poland","POL","admin",403833],
[1840000378,"Syracuse","Syracuse","United States","USA","",404223],
[1076013378,"Maringá","Maringa","Brazil","BRA","",403063],
[1076874103,"Carapicuíba","Carapicuiba","Brazil","BRA","",392294],
[1364073420,"Qazvīn","Qazvin","Iran","IRN","admin",402748],
[1356304110,"Quilon","Quilon","India","IND","",397419],
[1076998392,"Jundiaí","Jundiai","Brazil","BRA","",401896],
[1392999987,"Hirakata","Hirakata","Japan","JPN","",396694],
[1392097787,"Gifu","Gifu","Japan","JPN","admin",400118],
[1840003718,"Lancaster","Lancaster","United States","USA","",401524],
[1356163729,"Sīkar","Sikar","India","IND","",400000],
[1156352568,"Jiangjiafan","Jiangjiafan","China","CHN","",400000],
[1586002238,"Dera Ghazi Khan","Dera Ghazi Khan","Pakistan","PAK","minor",399064],
[1834011288,"Mwanza","Mwanza","Tanzania","TZA","admin",385810],
[1840019422,"Arlington","Arlington","United States","USA","",398854],
[1156046916,"Xushan","Xushan","China","CHN","minor",397000],
[1392216224,"Miyazaki","Miyazaki","Japan","JPN","admin",397476],
[1156221984,"Yuyao","Yuyao","China","CHN","",397000],
[1840021517,"Stockton","Stockton","United States","USA","",397264],
[1356022456,"Bhātpāra","Bhatpara","India","IND","",386019],
[1458405180,"Sandakan","Sandakan","Malaysia","MYS","",396290],
[1608530771,"Taytay","Taytay","Philippines","PHL","",386451],
[1156225234,"Hejin","Hejin","China","CHN","",395527],
[1704016079,"Thanh Hóa","Thanh Hoa","Vietnam","VNM","admin",393294],
[1392948850,"Minamisuita","Minamisuita","Japan","JPN","",384953],
[1840000500,"Poughkeepsie","Poughkeepsie","United States","USA","",394760],
[1392003389,"Yokosuka","Yokosuka","Japan","JPN","",390275],
[1704497901,"Nha Trang","Nha Trang","Vietnam","VNM","admin",392279],
[1643407900,"Belgorod","Belgorod","Russia","RUS","admin",391135],
[1608045841,"Malabon","Malabon","Philippines","PHL","admin",380522],
[1566782065,"Yola","Yola","Nigeria","NGA","admin",392854],
[1024128946,"Lobito","Lobito","Angola","AGO","",393079],
[1024326839,"Saurimo","Saurimo","Angola","AGO","admin",393000],
[1076784718,"Olinda","Olinda","Brazil","BRA","",389494],
[1792000667,"Esenler","Esenler","Turkey","TUR","",380709],
[1586006990,"Gujrat","Gujrat","Pakistan","PAK","minor",390533],
[1368864006,"Ad Dīwānīyah","Ad Diwaniyah","Iraq","IRQ","admin",391600],
[1076166252,"Piracicaba","Piracicaba","Brazil","BRA","",391449],
[1156265838,"Hancheng","Hancheng","China","CHN","",391164],
[1156892128,"Karamay","Karamay","China","CHN","minor",391008],
[1356573609,"Kākināda","Kakinada","India","IND","",384182],
[1840029462,"Augusta","Augusta","United States","USA","",390809],
[1356077831,"Bhīlwāra","Bhilwara","India","IND","",389911],
[1156769379,"Tieli","Tieli","China","CHN","minor",390000],
[1360643410,"Cilegon","Cilegon","Indonesia","IDN","",387543],
[1356242168,"Nizāmābād","Nizamabad","India","IND","",388505],
[1380202039,"Bologna","Bologna","Italy","ITA","admin",389261],
[1840027142,"Boise","Boise","United States","USA","admin",389280],
[1792759121,"Esenyurt","Esenyurt","Turkey","TUR","",373017],
[1504709141,"Tétouan","Tetouan","Morocco","MAR","",380787],
[1398602716,"Aqtöbe","Aqtobe","Kazakhstan","KAZ","admin",387807],
[1840020474,"Oxnard","Oxnard","United States","USA","",387647],
[1566930579,"Oyo","Oyo","Nigeria","NGA","minor",386723],
[1608237027,"Tarlac City","Tarlac City","Philippines","PHL","admin",385398],
[1392862345,"Okazaki","Okazaki","Japan","JPN","",385376],
[1608314665,"Cainta","Cainta","Philippines","PHL","",376933],
[1682249750,"Ḩā’il","Ha'il","Saudi Arabia","SAU","admin",385257],
[1156230664,"Yidu","Yidu","China","CHN","",384598],
[1156020454,"Lianzhou","Lianzhou","China","CHN","minor",384700],
[1380726561,"Florence","Florence","Italy","ITA","admin",380948],
[1554377228,"Christchurch","Christchurch","New Zealand","NZL","admin",383200],
[1484597234,"Nuevo Laredo","Nuevo Laredo","Mexico","MEX","minor",384033],
[1840003389,"Scranton","Scranton","United States","USA","",384250],
[1203676514,"Brno","Brno","Czechia","CZE","admin",382405],
[1124469960,"London","London","Canada","CAN","",383822],
[1688169087,"Novi Sad","Novi Sad","Serbia","SRB","admin",380000],
[1566383682,"Gusau","Gusau","Nigeria","NGA","admin",383162],
[1840020287,"Modesto","Modesto","United States","USA","",383134],
[1170320545,"Pasto","Pasto","Colombia","COL","admin",382236],
[1840015109,"Kissimmee","Kissimmee","United States","USA","",382720],
[1724501748,"Las Palmas","Las Palmas","Spain","ESP","admin",378675],
[1392379530,"Ichinomiya","Ichinomiya","Japan","JPN","",378681],
[1356118632,"Pānihāti","Panihati","India","IND","",377347],
[1604249985,"Huancayo","Huancayo","Peru","PER","admin",378203],
[1840018794,"Aurora","Aurora","United States","USA","",379289],
[1076953384,"Betim","Betim","Brazil","BRA","",378089],
[1620848791,"Sintra","Sintra","Portugal","PRT","minor",377835],
[1356632842,"Parbhani","Parbhani","India","IND","",378326],
[1222984157,"Usulután","Usulutan","El Salvador","SLV","admin",378606],
[1840003563,"Youngstown","Youngstown","United States","USA","",378732],
[1604493809,"Iquitos","Iquitos","Peru","PER","admin",377609],
[1156734041,"Helixi","Helixi","China","CHN","minor",376857],
[1554797148,"Manukau City","Manukau City","New Zealand","NZL","",375600],
[1862583279,"Cumaná","Cumana","Venezuela","VEN","admin",374706],
[1356162915,"Rohtak","Rohtak","India","IND","",374292],
[1804658571,"Vinnytsia","Vinnytsia","Ukraine","UKR","admin",371855],
[1356918265,"Lātūr","Latur","India","IND","",374394],
[1608615113,"Lipa City","Lipa City","Philippines","PHL","",372931],
[1608794590,"Mandaue City","Mandaue City","Philippines","PHL","admin",364116],
[1170423489,"Bello","Bello","Colombia","COL","minor",371591],
[1364548806,"Khorramābād","Khorramabad","Iran","IRN","admin",373416],
[1360756802,"Ambon","Ambon","Indonesia","IDN","admin",372249],
[1608000722,"Butuan","Butuan","Philippines","PHL","admin",372910],
[1158820647,"Keelung","Keelung","Taiwan","TWN","admin",370155],
[1392482960,"Toyohashi","Toyohashi","Japan","JPN","",371507],
[1608164766,"Baguio City","Baguio City","Philippines","PHL","admin",366358],
[1152939649,"La Florida","La Florida","Chile","CHL","",366916],
[1156002852,"Lengshuijiang","Lengshuijiang","China","CHN","",370300],
[1156172518,"Anguo","Anguo","China","CHN","",370317],
[1392003263,"Kita-ku","Kita-ku","Japan","JPN","",353058],
[1356110350,"Rājapālaiyam","Rajapalaiyam","India","IND","",369991],
[1156659612,"Panshi","Panshi","China","CHN","",370238],
[1364708556,"Madan","Madan","Iran","IRN","",370180],
[1100436706,"Plovdiv","Plovdiv","Bulgaria","BGR","admin",366511],
[1368147923,"Az Zubayr","Az Zubayr","Iraq","IRQ","minor",370000],
[1682001245,"Al Qaţīf","Al Qatif","Saudi Arabia","SAU","",368892],
[1392000529,"Takasaki","Takasaki","Japan","JPN","",367463],
[1156035769,"Huichang","Huichang","China","CHN","minor",367113],
[1112480679,"Vitsyebsk","Vitsyebsk","Belarus","BLR","admin",364800],
[1392603439,"Nagano","Nagano","Japan","JPN","admin",367184],
[1076905338,"Bauru","Bauru","Brazil","BRA","",366992],
[1156470847,"Yanjiao","Yanjiao","China","CHN","",363809],
[1276227288,"Bochum","Bochum","Germany","DEU","minor",364454],
[1484363321,"Tecámac","Tecamac","Mexico","MEX","minor",364579],
[1076208869,"Anápolis","Anapolis","Brazil","BRA","",366491],
[1826979198,"Coventry","Coventry","United Kingdom","GBR","",362690],
[1392536374,"Shinjuku","Shinjuku","Japan","JPN","",346115],
[1408692125,"Wŏnsan","Wonsan","North Korea","PRK","admin",363127],
[1826362422,"Caerdydd","Caerdydd","United Kingdom","GBR","",361469],
[1608000268,"Iligan","Iligan","Philippines","PHL","admin",363115],
[1608604441,"Cabuyao","Cabuyao","Philippines","PHL","",355330],
[1392891845,"Nakano","Nakano","Japan","JPN","",341014],
[1360191448,"Bengkulu","Bengkulu","Indonesia","IDN","admin",360495],
[1484766767,"Orizaba","Orizaba","Mexico","MEX","minor",355333],
[1076618665,"Blumenau","Blumenau","Brazil","BRA","",361855],
[1076113275,"Montes Claros","Montes Claros","Brazil","BRA","",361915],
[1332051873,"Pétion-Ville","Petion-Ville","Haiti","HTI","",359615],
[1156052635,"Shuanghejiedao","Shuanghejiedao","China","CHN","minor",360000],
[1566217980,"Umuahia","Umuahia","Nigeria","NGA","admin",359230],
[1643007475,"Surgut","Surgut","Russia","RUS","",360590],
[1729215057,"Gedaref","Gedaref","Sudan","SDN","admin",354927],
[1360518272,"Palu","Palu","Indonesia","IDN","admin",359350],
[1524416084,"Pokhara","Pokhara","Nepal","NPL","admin",353841],
[1112518993,"Mahilyow","Mahilyow","Belarus","BLR","admin",357100],
[1156059331,"Wudalianchi","Wudalianchi","China","CHN","",360000],
[1458639918,"Sungai Petani","Sungai Petani","Malaysia","MYS","",358499],
[1704906277,"Nam Định","Nam Dinh","Vietnam","VNM","admin",352108],
[1076376829,"Vitória","Vitoria","Brazil","BRA","admin",355875],
[1112187197,"Hrodna","Hrodna","Belarus","BLR","admin",356900],
[1643712167,"Vladimir","Vladimir","Russia","RUS","admin",356168],
[1076857089,"São Vicente","Sao Vicente","Brazil","BRA","",355542],
[1398626276,"Taraz","Taraz","Kazakhstan","KAZ","admin",357795],
[1024580158,"Cubal","Cubal","Angola","AGO","",357618],
[1392825080,"Kawagoe","Kawagoe","Japan","JPN","",354195],
[1887321491,"Ibb","Ibb","Yemen","YEM","admin",350864],
[1156185328,"Yong’an","Yong'an","China","CHN","minor",357000],
[1276004611,"Wuppertal","Wuppertal","Germany","DEU","minor",355004],
[1792804328,"Manisa","Manisa","Turkey","TUR","admin",356702],
[1608862124,"San Fernando","San Fernando","Philippines","PHL","admin",354666],
[1484735713,"Minatitlán","Minatitlan","Mexico","MEX","minor",356020],
[1643992310,"Nizhniy Tagil","Nizhniy Tagil","Russia","RUS","",355693],
[1608848483,"San Pedro","San Pedro","Philippines","PHL","",326001],
[1156905289,"Hongzhai","Hongzhai","China","CHN","",355037],
[1392907296,"Wakayama","Wakayama","Japan","JPN","admin",353299],
[1724331267,"Bilbao","Bilbao","Spain","ESP","minor",346405],
[1586136399,"Rahimyar Khan","Rahimyar Khan","Pakistan","PAK","",353203],
[1398790087,"Pavlodar","Pavlodar","Kazakhstan","KAZ","admin",353930],
[1410797548,"Gimpo","Gimpo","South Korea","KOR","minor",352683],
[1076942224,"Itaquaquecetuba","Itaquaquecetuba","Brazil","BRA","",352801],
[1392520831,"Nara","Nara","Japan","JPN","admin",352377],
[1792940471,"Van","Van","Turkey","TUR","admin",353419],
[1032173097,"Corrientes","Corrientes","Argentina","ARG","admin",352646],
[1170159963,"Neiva","Neiva","Colombia","COL","admin",353033],
[1643797198,"Arkhangelsk","Arkhangelsk","Russia","RUS","admin",351488],
[1608417616,"Batangas","Batangas","Philippines","PHL","admin",351437],
[1156208986,"Licheng","Licheng","China","CHN","minor",352472],
[1392606124,"Koshigaya","Koshigaya","Japan","JPN","",346768],
[1408740449,"Sinŭiju","Sinuiju","North Korea","PRK","admin",352000],
[1862398719,"Cabimas","Cabimas","Venezuela","VEN","minor",351735],
[1156900058,"Yueqing","Yueqing","China","CHN","",351200],
[1156666223,"Yakeshi","Yakeshi","China","CHN","minor",352173],
[1356972679,"Ahmadnagar","Ahmadnagar","India","IND","",350859],
[1840013368,"Fayetteville","Fayetteville","United States","USA","",351246],
[1392003061,"Takatsuki","Takatsuki","Japan","JPN","",347496],
[1192920574,"Holguín","Holguin","Cuba","CUB","admin",350191],
[1860403462,"Qoqon","Qoqon","Uzbekistan","UZB","",350000],
[1840019322,"Anaheim","Anaheim","United States","USA","",350365],
[1398405657,"Semey","Semey","Kazakhstan","KAZ","",350201],
[1100789115,"Varna","Varna","Bulgaria","BGR","admin",347924],
[1156386711,"Yingmen","Yingmen","China","CHN","",350000],
[1076479479,"Cariacica","Cariacica","Brazil","BRA","",348738],
[1170969619,"Palmira","Palmira","Colombia","COL","minor",349294],
[1484997178,"Tapachula","Tapachula","Mexico","MEX","minor",348156],
[1792668647,"Konak","Konak","Turkey","TUR","minor",344678],
[1616454014,"Bydgoszcz","Bydgoszcz","Poland","POL","admin",346739],
[1792115763,"Hatay","Hatay","Turkey","TUR","admin",347974],
[1152734289,"Antofagasta","Antofagasta","Chile","CHL","admin",348517],
[1356831716,"Rājahmundry","Rajahmundry","India","IND","",341831],
[1643036673,"Chita","Chita","Russia","RUS","admin",347088],
[1716688236,"Chitungwiza","Chitungwiza","Zimbabwe","ZWE","",340360],
[1076397475,"Caruaru","Caruaru","Brazil","BRA","",347088],
[1528871692,"Utrecht","Utrecht","Netherlands","NLD","admin",343779],
[1840015005,"Pensacola","Pensacola","United States","USA","",346921],
[1840021731,"Victorville","Victorville","United States","USA","",346789],
[1408940912,"Tanch’ŏn","Tanch'on","North Korea","PRK","",345876],
[1392340764,"Tokorozawa","Tokorozawa","Japan","JPN","",341195],
[1250774553,"Nice","Nice","France","FRA","minor",341032],
[1031630283,"Sumqayıt","Sumqayit","Azerbaijan","AZE","admin",341200],
[1729229371,"Kūstī","Kusti","Sudan","SDN","",345068],
[1356360140,"Cuddapah","Cuddapah","India","IND","",344893],
[1804665958,"Simferopol","Simferopol","Ukraine","UKR","admin",341799],
[1392164106,"Ōtsu","Otsu","Japan","JPN","admin",342607],
[1076812020,"Vitória da Conquista","Vitoria da Conquista","Brazil","BRA","",343230],
[1840020516,"Lancaster","Lancaster","United States","USA","",343304],
[1804926154,"Makiivka","Makiivka","Ukraine","UKR","",343158],
[1710178149,"East London","East London","South Africa","ZAF","",338627],
[1840013356,"Greensboro","Greensboro","United States","USA","",343090],
[1484051478,"Uruapan","Uruapan","Mexico","MEX","minor",334749],
[1484092318,"Gómez Palacio","Gomez Palacio","Mexico","MEX","minor",342286],
[1076740256,"Franca","Franca","Brazil","BRA","",342112],
[1112896927,"Brest","Brest","Belarus","BLR","admin",340318],
[1643161747,"Kaluga","Kaluga","Russia","RUS","admin",341892],
[1840019718,"Corpus Christi","Corpus Christi","United States","USA","",342464],
[1356897425,"Muzaffarpur","Muzaffarpur","India","IND","",333200],
[1410002025,"Yeosu","Yeosu","South Korea","KOR","minor",341994],
[1616953501,"Lublin","Lublin","Poland","POL","admin",339850],
[1356570855,"Alwar","Alwar","India","IND","",341422],
[1356569354,"Brahmapur","Brahmapur","India","IND","",324726],
[1156332794,"Lianran","Lianran","China","CHN","minor",341341],
[1704542086,"Buôn Ma Thuột","Buon Ma Thuot","Vietnam","VNM","admin",340000],
[1484926471,"Cuernavaca","Cuernavaca","Mexico","MEX","admin",338650],
[1180325051,"Beni","Beni","Congo (Kinshasa)","COD","",332903],
[1710279034,"Randburg","Randburg","South Africa","ZAF","",337053],
[1724923163,"Alicante","Alicante","Spain","ESP","minor",337304],
[1524593184,"Jitpur","Jitpur","Nepal","NPL","",337785],
[1408725697,"Kaesŏng","Kaesong","North Korea","PRK","minor",338155],
[1076843988,"Petrolina","Petrolina","Brazil","BRA","",337683],
[1410560599,"Chinju","Chinju","South Korea","KOR","",337230],
[1156682620,"Tangdong","Tangdong","China","CHN","minor",337495],
[1156202457,"Hangu","Hangu","China","CHN","",332793],
[1826325087,"Belfast","Belfast","United Kingdom","GBR","",333871],
[1392158088,"Iwaki","Iwaki","Japan","JPN","",336111],
[1012045589,"Blida","Blida","Algeria","DZA","admin",331779],
[1484741627,"Salamanca","Salamanca","Mexico","MEX","minor",327169],
[1156969537,"Yingzhong","Yingzhong","China","CHN","",334977],
[1392003311,"Hirosaki","Hirosaki","Japan","JPN","",335203],
[1152898644,"Viña del Mar","Vina del Mar","Chile","CHL","",332875],
[1231826873,"Nazrēt","Nazret","Ethiopia","ETH","",324000],
[1276112885,"Bielefeld","Bielefeld","Germany","DEU","minor",333509],
[1218041020,"Cuenca","Cuenca","Ecuador","ECU","admin",329928],
[1818281002,"Al Fayyūm","Al Fayyum","Egypt","EGY","admin",315940],
[1840008261,"Fort Wayne","Fort Wayne","United States","USA","",334122],
[1484887986,"Ciudad Obregón","Ciudad Obregon","Mexico","MEX","minor",329404],
[1729581572,"Wad Medani","Wad Medani","Sudan","SDN","admin",332714],
[1076482220,"Ribeirão das Neves","Ribeirao das Neves","Brazil","BRA","",331045],
[1484610487,"Soledad de Graciano Sánchez","Soledad de Graciano Sanchez","Mexico","MEX","minor",332072],
[1276807850,"Bonn","Bonn","Germany","DEU","minor",330579],
[1356676559,"Kāmārhāti","Kamarhati","India","IND","",330211],
[1392333295,"Maebashi","Maebashi","Japan","JPN","admin",331576],
[1300397999,"Thessaloníki","Thessaloniki","Greece","GRC","admin",315196],
[1031197327,"Gəncə","Ganca","Azerbaijan","AZE","admin",331400],
[1050399881,"Mymensingh","Mymensingh","Bangladesh","BGD","admin",330126],
[1840021964,"Santa Ana","Santa Ana","United States","USA","",332318],
[1840002949,"Flint","Flint","United States","USA","",332190],
[1360992102,"Kendari","Kendari","Indonesia","IDN","admin",331013],
[1704613715,"Thái Nguyên","Thai Nguyen","Vietnam","VNM","admin",330000],
[1643627051,"Smolensk","Smolensk","Russia","RUS","admin",329853],
[1392380358,"Asahikawa","Asahikawa","Japan","JPN","",331392],
[1840058203,"Islip","Islip","United States","USA","",331499],
[1368137126,"Dahūk","Dahuk","Iraq","IRQ","admin",330600],
[1410782685,"Wŏnju","Wonju","South Korea","KOR","",330854],
[1356066081,"Mathura","Mathura","India","IND","",330511],
[1404140179,"Nakuru","Nakuru","Kenya","KEN","admin",307990],
[1566042542,"Lafia","Lafia","Nigeria","NGA","admin",330712],
[1392003178,"Koriyama","Koriyama","Japan","JPN","",329706],
[1156971194,"Bamiantong","Bamiantong","China","CHN","minor",330000],
[1356458416,"Patiāla","Patiala","India","IND","",329224],
[1504648957,"Taourirt","Taourirt","Morocco","MAR","",321876],
[1792725579,"İzmir","Izmir","Turkey","TUR","admin",329052],
[1704581438,"Vũng Tàu","Vung Tau","Vietnam","VNM","admin",327000],
[1608247694,"Cabanatuan City","Cabanatuan City","Philippines","PHL","",327325],
[1124272698,"Markham","Markham","Canada","CAN","",328966],
[1356781800,"Saugor","Saugor","India","IND","",328240],
[1076815692,"Pelotas","Pelotas","Brazil","BRA","",328275],
[1710090212,"Roodepoort","Roodepoort","South Africa","ZAF","",326416],
[1643875527,"Volzhskiy","Volzhskiy","Russia","RUS","",326055],
[1356499139,"Bijāpur","Bijapur","India","IND","",327427],
[1360447543,"Sukabumi","Sukabumi","Indonesia","IDN","",320970],
[1840013490,"Fayetteville","Fayetteville","United States","USA","",327435],
[1156182060,"Ulanhot","Ulanhot","China","CHN","",327081],
[1156589240,"Yunzhong","Yunzhong","China","CHN","minor",326849],
[1608753128,"Cotabato","Cotabato","Philippines","PHL","admin",325079],
[1368081888,"Al Fallūjah","Al Fallujah","Iraq","IRQ","minor",326471],
[1392086071,"Kōchi","Kochi","Japan","JPN","admin",325560],
[1566285237,"Minna","Minna","Nigeria","NGA","admin",322163],
[1076621300,"Boa Vista","Boa Vista","Brazil","BRA","admin",326419],
[1642503974,"Cluj-Napoca","Cluj-Napoca","Romania","ROU","admin",324576],
[1076009922,"Canoas","Canoas","Brazil","BRA","",323827],
[1410103113,"Gwangmyeongni","Gwangmyeongni","South Korea","KOR","",318021],
[1380991126,"Bari","Bari","Italy","ITA","admin",323370],
[1604478712,"Pucallpa","Pucallpa","Peru","PER","admin",326040],
[1792764051,"Yıldırım","Yildirim","Turkey","TUR","minor",324377],
[1458462262,"Kuching","Kuching","Malaysia","MYS","admin",325132],
[1484433877,"Tepic","Tepic","Mexico","MEX","admin",318781],
[1076870058,"Caucaia","Caucaia","Brazil","BRA","",325441],
[1231234833,"Gonder","Gonder","Ethiopia","ETH","",323900],
[1076230331,"Uberaba","Uberaba","Brazil","BRA","",325279],
[1840014895,"Jackson","Jackson","United States","USA","admin",325350],
[1231468531,"Mekele","Mekele","Ethiopia","ETH","admin",323700],
[1840021488,"Santa Rosa","Santa Rosa","United States","USA","",324634],
[1332384588,"Gonaïves","Gonaives","Haiti","HTI","admin",324043],
[1484450749,"Guasave","Guasave","Mexico","MEX","minor",320000],
[1840003102,"Lansing","Lansing","United States","USA","admin",324286],
[1392583118,"Naha","Naha","Japan","JPN","admin",316048],
[1156167534,"Binxian","Binxian","China","CHN","",323256],
[1630035577,"San Juan","San Juan","Puerto Rico","PRI","primary",323279],
[1840015211,"Lexington","Lexington","United States","USA","",323152],
[1156111844,"Hotan","Hotan","China","CHN","minor",322300],
[1156259752,"Dongyang","Dongyang","China","CHN","minor",322500],
[1600265252,"Ciudad del Este","Ciudad del Este","Paraguay","PRY","admin",320782],
[1156888008,"Kaiyuan","Kaiyuan","China","CHN","",322693],
[1504016606,"Temara","Temara","Morocco","MAR","",313510],
[1024666275,"Uíge","Uige","Angola","AGO","admin",322531],
[1724706440,"Córdoba","Cordoba","Spain","ESP","minor",322071],
[1192667983,"Camagüey","Camaguey","Cuba","CUB","admin",321992],
[1840003172,"Ann Arbor","Ann Arbor","United States","USA","",322267],
[1032815808,"San Salvador de Jujuy","San Salvador de Jujuy","Argentina","ARG","admin",321789],
[1642603121,"Timişoara","Timisoara","Romania","ROU","admin",319279],
[1368569694,"Al Kūt","Al Kut","Iraq","IRQ","admin",321521],
[1356415439,"Shāhjānpur","Shahjanpur","India","IND","",320434],
[1643937680,"Cherepovets","Cherepovets","Russia","RUS","",318856],
[1591394184,"San Miguelito","San Miguelito","Panama","PAN","minor",315019],
[1024725650,"Menongue","Menongue","Angola","AGO","admin",320914],
[1356057451,"Jūnāgadh","Junagadh","India","IND","",320250],
[1566777297,"Katsina","Katsina","Nigeria","NGA","admin",318459],
[1840020361,"Henderson","Henderson","United States","USA","",320189],
[1804547489,"Poltava","Poltava","Ukraine","UKR","admin",317847],
[1120956931,"Maroua","Maroua","Cameroon","CMR","admin",319941],
[1408781295,"Kaech’ŏn","Kaech'on","North Korea","PRK","",319554],
[1410904940,"Asan","Asan","South Korea","KOR","",319929],
[1484817336,"Tehuacán","Tehuacan","Mexico","MEX","minor",319375],
[1484016854,"Coatzacoalcos","Coatzacoalcos","Mexico","MEX","minor",319187],
[1860620079,"Nukus","Nukus","Uzbekistan","UZB","admin",319583],
[1840005061,"Huntsville","Huntsville","United States","USA","",319249],
[1398371414,"Öskemen","Oskemen","Kazakhstan","KAZ","admin",319067],
[1250091495,"Nantes","Nantes","France","FRA","admin",314138],
[1156280237,"Zalantun","Zalantun","China","CHN","minor",318933],
[1356589298,"Trichūr","Trichur","India","IND","",315596],
[1608102511,"Binangonan","Binangonan","Philippines","PHL","",313631],
[1360011375,"Cirebon","Cirebon","Indonesia","IDN","",316126],
[1276714504,"Münster","Munster","Germany","DEU","minor",316403],
[1818017750,"Az Zaqāzīq","Az Zaqaziq","Egypt","EGY","admin",285097],
[1558023610,"Boaco","Boaco","Nicaragua","NIC","admin",317000],
[1704320474,"Cà Mau","Ca Mau","Vietnam","VNM","admin",315270],
[1392793312,"Toshima","Toshima","Japan","JPN","",297954],
[1643013685,"Vologda","Vologda","Russia","RUS","admin",313012],
[1643003229,"Saransk","Saransk","Russia","RUS","admin",314789],
[1840006009,"Mobile","Mobile","United States","USA","",315502],
[1356062166,"Barddhamān","Barddhaman","India","IND","",314265],
[1608010777,"Tanza","Tanza","Philippines","PHL","",312116],
[1728186782,"Bor","Bor","South Sudan","SSD","admin",315351],
[1586858135,"Kasur","Kasur","Pakistan","PAK","minor",314617],
[1156326854,"Yakou","Yakou","China","CHN","minor",313828],
[1643703818,"Orël","Orel","Russia","RUS","admin",311625],
[1364272235,"Shahr-e Qods","Shahr-e Qods","Iran","IRN","minor",309605],
[1504000717,"Safi","Safi","Morocco","MAR","",308508],
[1792090978,"Güngören","Gungoren","Turkey","TUR","",272950],
[1076832747,"Guarujá","Guaruja","Brazil","BRA","",311230],
[1484559458,"Playa del Carmen","Playa del Carmen","Mexico","MEX","minor",304942],
[1356486511,"Purnea","Purnea","India","IND","",310817],
[1156511075,"Datang","Datang","China","CHN","",310889],
[1170495189,"Zarzal","Zarzal","Colombia","COL","minor",312599],
[1840020151,"Fort Collins","Fort Collins","United States","USA","",312666],
[1710918997,"Port Elizabeth","Port Elizabeth","South Africa","ZAF","",312392],
[1840013411,"Asheville","Asheville","United States","USA","",312507],
[1840021864,"Santa Clarita","Santa Clarita","United States","USA","",312446],
[1364802450,"Gorgān","Gorgan","Iran","IRN","admin",312223],
[1704056461,"Quy Nhơn","Quy Nhon","Vietnam","VNM","admin",311000],
[1356772339,"Sambalpur","Sambalpur","India","IND","",310852],
[1276150104,"Mannheim","Mannheim","Germany","DEU","minor",309721],
[1643163546,"Yakutsk","Yakutsk","Russia","RUS","admin",311760],
[1392198395,"Yokkaichi","Yokkaichi","Japan","JPN","",310263],
[1076716439,"Ponta Grossa","Ponta Grossa","Brazil","BRA","",311611],
[1380562508,"Catania","Catania","Italy","ITA","minor",311584],
[1484834149,"Chalco","Chalco","Mexico","MEX","minor",310130],
[1276923210,"Karlsruhe","Karlsruhe","Germany","DEU","minor",308436],
[1364482289,"Shahrīār","Shahriar","Iran","IRN","minor",309607],
[1643201853,"Kurgan","Kurgan","Russia","RUS","admin",309285],
[1392431449,"Kasugai","Kasugai","Japan","JPN","",306449],
[1408018673,"Sariwŏn","Sariwon","North Korea","PRK","admin",307764],
[1124140229,"St. Catharines","St. Catharines","Canada","CAN","",309319],
[1180529604,"Matadi","Matadi","Congo (Kinshasa)","COD","admin",306053],
[1124704011,"Niagara Falls","Niagara Falls","Canada","CAN","",308596],
[1356031978,"Fīrozābād","Firozabad","India","IND","",306409],
[1840008940,"St. Paul","St. Paul","United States","USA","admin",308096],
[1643438348,"Vladikavkaz","Vladikavkaz","Russia","RUS","admin",306978],
[1356004790,"Hisar","Hisar","India","IND","",307024],
[1862856141,"Puerto La Cruz","Puerto La Cruz","Venezuela","VEN","minor",306261],
[1608455700,"Puerto Princesa","Puerto Princesa","Philippines","PHL","admin",307079],
[1643693800,"Podolsk","Podolsk","Russia","RUS","",299660],
[1392876044,"Meguro","Meguro","Japan","JPN","",286905],
[1484616519,"Ciudad Victoria","Ciudad Victoria","Mexico","MEX","admin",305155],
[1484858068,"Ciudad Santa Catarina","Ciudad Santa Catarina","Mexico","MEX","minor",306322],
[1124000141,"Vaughan","Vaughan","Canada","CAN","",306233],
[1231663122,"Āwasa","Awasa","Ethiopia","ETH","admin",300100],
[1392000137,"Ōakashichō","Oakashicho","Japan","JPN","",299699],
[1360039434,"Pekalongan","Pekalongan","Indonesia","IDN","",298386],
[1392003184,"Kurume","Kurume","Japan","JPN","",302858],
[1620040225,"Vila Nova de Gaia","Vila Nova de Gaia","Portugal","PRT","minor",302295],
[1480343099,"Curepipe","Curepipe","Mauritius","MUS","",299975],
[1076183876,"Paulista","Paulista","Brazil","BRA","",300466],
[1484301467,"Oaxaca","Oaxaca","Mexico","MEX","admin",300050],
[1170398459,"Armenia","Armenia","Colombia","COL","admin",301226],
[1392129688,"Akita","Akita","Japan","JPN","admin",302984],
[1566560581,"Awka","Awka","Nigeria","NGA","admin",301657],
[1152050361,"San Bernardo","San Bernardo","Chile","CHL","minor",301313],
[1410134391,"Iksan","Iksan","South Korea","KOR","",302310],
[1076146252,"Taubaté","Taubate","Brazil","BRA","",302331],
[1840018903,"Antioch","Antioch","United States","USA","",302419],
[1840015108,"Lakeland","Lakeland","United States","USA","",302284],
[1586001546,"Mardan","Mardan","Pakistan","PAK","minor",300424],
[1704758756,"Sóc Trăng","Soc Trang","Vietnam","VNM","admin",300000],
[1834396594,"Mbeya","Mbeya","Tanzania","TZA","admin",291649],
[1484890205,"San Juan del Río","San Juan del Rio","Mexico","MEX","minor",301237],
[1170764265,"Popayán","Popayan","Colombia","COL","admin",300837],
[1076548222,"Praia Grande","Praia Grande","Brazil","BRA","",299261],
[1156103756,"Qianzhou","Qianzhou","China","CHN","minor",301000],
[1826292220,"Newcastle","Newcastle","United Kingdom","GBR","",300196],
[1484345554,"Ciudad General Escobedo","Ciudad General Escobedo","Mexico","MEX","minor",299364],
[1320672314,"Coatepeque","Coatepeque","Guatemala","GTM","minor",300000],
[1156180376,"Quzhou","Quzhou","China","CHN","",300300],
[1484060031,"Tampico","Tampico","Mexico","MEX","minor",297284],
[1616443575,"Białystok","Bialystok","Poland","POL","admin",297554],
[1862668122,"Mérida","Merida","Venezuela","VEN","admin",300000],
[1643755251,"Murmansk","Murmansk","Russia","RUS","admin",298096],
[1760035911,"Ar Raqqah","Ar Raqqah","Syria","SYR","admin",299824],
[1156451663,"Linhai","Linhai","China","CHN","",299500],
[1360316553,"Jember","Jember","Indonesia","IDN","minor",298585],
[1724133771,"Valladolid","Valladolid","Spain","ESP","admin",297775],
[1032795766,"Bahía Blanca","Bahia Blanca","Argentina","ARG","minor",299101],
[1036067845,"Central Coast","Central Coast","Australia","AUS","",297713],
[1356666569,"Rāmpur","Rampur","India","IND","",296418],
[1792962911,"İskenderun","Iskenderun","Turkey","TUR","minor",297943],
[1682484039,"Al Mubarraz","Al Mubarraz","Saudi Arabia","SAU","",298562],
[1076352504,"Petrópolis","Petropolis","Brazil","BRA","",298142],
[1682947408,"Al Kharj","Al Kharj","Saudi Arabia","SAU","",298428],
[1608538447,"Navotas","Navotas","Philippines","PHL","admin",247543],
[1804565996,"Chernihiv","Chernihiv","Ukraine","UKR","admin",294522],
[1410795549,"Yangsan","Yangsan","South Korea","KOR","minor",297532],
[1050609330,"Comilla","Comilla","Bangladesh","BGD","",296010],
[1484575026,"Pachuca","Pachuca","Mexico","MEX","admin",297848],
[1276314100,"Augsburg","Augsburg","Germany","DEU","minor",295830],
[1826687116,"Bradford","Bradford","United Kingdom","GBR","",293277],
[1840058379,"Oyster Bay","Oyster Bay","United States","USA","",297822],
[1608755366,"Tagum","Tagum","Philippines","PHL","admin",296202],
[1152337970,"Valparaíso","Valparaiso","Chile","CHL","admin",296655],
[1608301996,"Silang","Silang","Philippines","PHL","",295644],
[1076508566,"Limeira","Limeira","Brazil","BRA","",296440],
[1050667437,"Rangpur","Rangpur","Bangladesh","BGD","admin",294265],
[1724045676,"Vigo","Vigo","Spain","ESP","",293837],
[1792965114,"Kocaeli","Kocaeli","Turkey","TUR","admin",294875],
[1250819356,"Montpellier","Montpellier","France","FRA","minor",290053],
[1356113138,"Bāli","Bali","India","IND","",293373],
[1356526780,"Pānīpat","Panipat","India","IND","",292808],
[1818532766,"Ismailia","Ismailia","Egypt","EGY","admin",293184],
[1024863343,"Vila Teixeira da Silva","Vila Teixeira da Silva","Angola","AGO","",294494],
[1332257532,"Delmas","Delmas","Haiti","HTI","",284079],
[1608402560,"Mabalacat","Mabalacat","Philippines","PHL","",293244],
[1012093229,"Batna","Batna","Algeria","DZA","admin",290645],
[1356342768,"Āīzawl","Aizawl","India","IND","admin",293416],
[1410672540,"Kunp’o","Kunp'o","South Korea","KOR","",285721],
[1643802687,"Tambov","Tambov","Russia","RUS","admin",290365],
[1686527948,"Thiès","Thies","Senegal","SEN","admin",293001],
[1642367695,"Iaşi","Iasi","Romania","ROU","admin",290422],
[1792824929,"Pendik","Pendik","Turkey","TUR","minor",289380],
[1826122597,"Nottingham","Nottingham","United Kingdom","GBR","",289301],
[1608186208,"Santa Maria","Santa Maria","Philippines","PHL","",289820],
[1643049853,"Groznyy","Groznyy","Russia","RUS","admin",291687],
[1804514036,"Kherson","Kherson","Ukraine","UKR","admin",291428],
[1076256494,"Santarém","Santarem","Brazil","BRA","",292520],
[1120435460,"Bafoussam","Bafoussam","Cameroon","CMR","admin",290768],
[1156999688,"Hong’an","Hong'an","China","CHN","minor",289999],
[1032720891,"Resistencia","Resistencia","Argentina","ARG","admin",291720],
[1642328429,"Braşov","Brasov","Romania","ROU","admin",290743],
[1604174464,"Juliaca","Juliaca","Peru","PER","",291189],
[1040184559,"Graz","Graz","Austria","AUT","admin",289440],
[1170708072,"Itagüí","Itagui","Colombia","COL","minor",276744],
[1356578937,"Karīmnagar","Karimnagar","India","IND","",289821],
[1600667303,"San Lorenzo","San Lorenzo","Paraguay","PRY","",287977],
[1392075752,"Sumida","Sumida","Japan","JPN","",270823],
[1288186231,"Sekondi","Sekondi","Ghana","GHA","admin",286248],
[1392981957,"Morioka","Morioka","Japan","JPN","admin",290553],
[1012981116,"Sétif","Setif","Algeria","DZA","admin",288461],
[1840001383,"Trenton","Trenton","United States","USA","admin",290716],
[1398169063,"Atyraū","Atyrau","Kazakhstan","KAZ","admin",290700],
[1826629486,"Ipswich","Ipswich","United Kingdom","GBR","",290000],
[1440302852,"Kaunas","Kaunas","Lithuania","LTU","admin",288466],
[1792783772,"Adana","Adana","Turkey","TUR","admin",289919],
[1156161638,"Hulin","Hulin","China","CHN","minor",290000],
[1840009357,"Lincoln","Lincoln","United States","USA","admin",289490],
[1356806356,"Bhuj","Bhuj","India","IND","",289429],
[1860479627,"Farg‘ona","Farg`ona","Uzbekistan","UZB","admin",288850],
[1356651502,"Ichalkaranji","Ichalkaranji","India","IND","",287570],
[1250789140,"Strasbourg","Strasbourg","France","FRA","admin",284677],
[1840009904,"Springfield","Springfield","United States","USA","",288090],
[1840023385,"Anchorage","Anchorage","United States","USA","",288000],
[1862535644,"Punto Fijo","Punto Fijo","Venezuela","VEN","minor",287558],
[1170364198,"Sincelejo","Sincelejo","Colombia","COL","admin",286716],
[1840020662,"Plano","Plano","United States","USA","",287677],
[1392003421,"Ibaraki","Ibaraki","Japan","JPN","",283835],
[1840019325,"Irvine","Irvine","United States","USA","",287401],
[1076610862,"Camaçari","Camacari","Brazil","BRA","",286919],
[1862252264,"San Cristóbal","San Cristobal","Venezuela","VEN","admin",285872],
[1826628353,"Bolton","Bolton","United Kingdom","GBR","",285372],
[1608801564,"San Pablo","San Pablo","Philippines","PHL","",285348],
[1076830201,"Suzano","Suzano","Brazil","BRA","",285280],
[1384205840,"Korhogo","Korhogo","Côte d'Ivoire","CIV","admin",286071],
[1356241463,"Hospet","Hospet","India","IND","",286007],
[1356343054,"Bhatinda","Bhatinda","India","IND","",285813],
[1076509946,"Cascavel","Cascavel","Brazil","BRA","",286205],
[1203687206,"Ostrava","Ostrava","Czechia","CZE","admin",284982],
[1604388134,"Tacna","Tacna","Peru","PER","admin",286240],
[1642851858,"Constanţa","Constanta","Romania","ROU","admin",283872],
[1376133727,"Haifa","Haifa","Israel","ISR","admin",281087],
[1840007081,"Davenport","Davenport","United States","USA","",285362],
[1392570027,"Fukushima","Fukushima","Japan","JPN","admin",284282],
[1862647790,"Barinas","Barinas","Venezuela","VEN","admin",284289],
[1862429150,"Coro","Coro","Venezuela","VEN","admin",284266],
[1104027443,"Bago","Bago","Myanmar","MMR","admin",284179],
[1156672189,"Fuquan","Fuquan","China","CHN","",283904],
[1156606433,"Tongchuanshi","Tongchuanshi","China","CHN","",282258],
[1356009968,"Sannai","Sannai","India","IND","",283004],
[1156917368,"Huozhou","Huozhou","China","CHN","",282905],
[1152318955,"Temuco","Temuco","Chile","CHL","admin",282415],
[1643812452,"Sterlitamak","Sterlitamak","Russia","RUS","",280233],
[1840009132,"Rockford","Rockford","United States","USA","",282762],
[1360035814,"Tegal","Tegal","Indonesia","IDN","",275789],
[1604607907,"Ica","Ica","Peru","PER","admin",282407],
[1608000461,"Lucena","Lucena","Philippines","PHL","admin",278924],
[1417797596,"Osh","Osh","Kyrgyzstan","KGZ","admin",281900],
[1840002791,"Newark","Newark","United States","USA","",282011],
[1156261326,"Jining","Jining","China","CHN","",281716],
[1410231130,"Chuncheon","Chuncheon","South Korea","KOR","admin",281596],
[1364376065,"Malārd","Malard","Iran","IRN","minor",281027],
[1360769496,"Pematangsiantar","Pematangsiantar","Indonesia","IDN","",278055],
[1704453892,"Long Xuyên","Long Xuyen","Vietnam","VNM","admin",278658],
[1643319966,"Petrozavodsk","Petrozavodsk","Russia","RUS","admin",278551],
[1840009241,"South Bend","South Bend","United States","USA","",280498],
[1860523678,"Bukhara","Bukhara","Uzbekistan","UZB","admin",280187],
[1840015768,"Shreveport","Shreveport","United States","USA","",280062],
[1024297937,"Sumbe","Sumbe","Angola","AGO","admin",279968],
[1704332956,"Việt Trì","Viet Tri","Vietnam","VNM","admin",277539],
[1276652118,"Wiesbaden","Wiesbaden","Germany","DEU","admin",278609],
[1804459212,"Cherkasy","Cherkasy","Ukraine","UKR","admin",276360],
[1826736387,"Sunderland","Sunderland","United Kingdom","GBR","",277417],
[1356644721,"Bārāsat","Barasat","India","IND","",278435],
[1643869304,"Kostroma","Kostroma","Russia","RUS","admin",277648],
[1156504227,"Zhuji","Zhuji","China","CHN","minor",278900],
[1840011171,"Round Lake Beach","Round Lake Beach","United States","USA","",279381],
[1410545168,"Gyeongsan","Gyeongsan","South Korea","KOR","",278500],
[1214807042,"Los Alcarrizos","Los Alcarrizos","Dominican Republic","DOM","",272776],
[1076271003,"Governador Valadares","Governador Valadares","Brazil","BRA","",278363],
[1076000585,"Taboão da Serra","Taboao da Serra","Brazil","BRA","",272177],
[1608557779,"San Mateo","San Mateo","Philippines","PHL","",273306],
[1616798495,"Katowice","Katowice","Poland","POL","admin",276499],
[1156978131,"Shaowu","Shaowu","China","CHN","minor",278000],
[1788741658,"Sfax","Sfax","Tunisia","TUN","admin",272801],
[1643786132,"Nizhnevartovsk","Nizhnevartovsk","Russia","RUS","",277668],
[1156043522,"Linxia Chengguanzhen","Linxia Chengguanzhen","China","CHN","minor",274466],
[1231089714,"Dire Dawa","Dire Dawa","Ethiopia","ETH","admin",277000],
[1804347108,"Khmelnytskyi","Khmelnytskyi","Ukraine","UKR","admin",274176],
[1566833788,"Owo","Owo","Nigeria","NGA","minor",276574],
[1826602892,"Southampton","Southampton","United Kingdom","GBR","",271173],
[1840015830,"Savannah","Savannah","United States","USA","",276295],
[1032970696,"Posadas","Posadas","Argentina","ARG","admin",275988],
[1124722129,"Gatineau","Gatineau","Canada","CAN","",276245],
[1124261024,"Windsor","Windsor","Canada","CAN","",276165],
[1180720887,"Mbandaka","Mbandaka","Congo (Kinshasa)","COD","admin",274996],
[1840014717,"Myrtle Beach","Myrtle Beach","United States","USA","",275579],
[1752705818,"Malmö","Malmo","Sweden","SWE","admin",269349],
[1410913202,"Kunsan","Kunsan","South Korea","KOR","",275155],
[1860343319,"Qarshi","Qarshi","Uzbekistan","UZB","admin",274891],
[1818347704,"Kafr ad Dawwār","Kafr ad Dawwar","Egypt","EGY","",262748],
[1840019350,"Chula Vista","Chula Vista","United States","USA","",274492],
[1562200314,"Maradi","Maradi","Niger","NER","admin",267249],
[1356241663,"Ratlām","Ratlam","India","IND","",273892],
[1410698161,"Yeosu","Yeosu","South Korea","KOR","minor",273761],
[1076425706,"Crato","Crato","Brazil","BRA","",273883],
[1392082102,"Tsu","Tsu","Japan","JPN","admin",273267],
[1840020007,"Eugene","Eugene","United States","USA","",273439],
[1156211724,"Bijiao","Bijiao","China","CHN","",270310],
[1076052802,"Palmas","Palmas","Brazil","BRA","admin",272726],
[1642859458,"Craiova","Craiova","Romania","ROU","admin",269506],
[1392294093,"Minato","Minato","Japan","JPN","",258105],
[1360018780,"Sorong","Sorong","Indonesia","IDN","",272349],
[1360498576,"Majene","Majene","Indonesia","IDN","minor",272377],
[1704716027,"Thái Bình","Thai Binh","Vietnam","VNM","admin",268167],
[1360884608,"Binjai","Binjai","Indonesia","IDN","",269053],
[1392370709,"Fuchū","Fuchu","Japan","JPN","",263093],
[1024159015,"Gabela","Gabela","Angola","AGO","",271843],
[1398593972,"Oral","Oral","Kazakhstan","KAZ","admin",271900],
[1760792603,"Dayr az Zawr","Dayr az Zawr","Syria","SYR","admin",271800],
[1050193121,"Brāhmanbāria","Brahmanbaria","Bangladesh","BGD","",268279],
[1364143380,"Sartā","Sarta","Iran","IRN","",271467],
[1826947183,"Plymouth","Plymouth","United Kingdom","GBR","",267918],
[1218148017,"Santo Domingo de los Colorados","Santo Domingo de los Colorados","Ecuador","ECU","admin",270875],
[1643087180,"Novorossiysk","Novorossiysk","Russia","RUS","",270774],
[1222021362,"Santa Ana","Santa Ana","El Salvador","SLV","admin",270413],
[1566855445,"Gombe","Gombe","Nigeria","NGA","admin",270366],
[1724170659,"Gijón","Gijon","Spain","ESP","",268896],
[1246357316,"Espoo","Espoo","Finland","FIN","minor",269802],
[1356910418,"Drug","Drug","India","IND","",268806],
[1392665227,"Mito","Mito","Japan","JPN","admin",268750],
[1120909610,"Bamenda","Bamenda","Cameroon","CMR","admin",269530],
[1170331200,"Floridablanca","Floridablanca","Colombia","COL","minor",267170],
[1356080179,"Handwāra","Handwara","India","IND","",269311],
[1608040297,"Talisay","Talisay","Philippines","PHL","",263048],
[1840000963,"Canton","Canton","United States","USA","",269418],
[1643701904,"Yoshkar-Ola","Yoshkar-Ola","Russia","RUS","admin",266675],
[1643746064,"Nalchik","Nalchik","Russia","RUS","admin",265162],
[1818262512,"Aswān","Aswan","Egypt","EGY","admin",267913],
[1392167256,"Ichihara","Ichihara","Japan","JPN","",268038],
[1804540656,"Zhytomyr","Zhytomyr","Ukraine","UKR","admin",264452],
[1356107172,"Imphāl","Imphal","India","IND","admin",264986],
[1804652872,"Chernivtsi","Chernivtsi","Ukraine","UKR","admin",266550],
[1484364591,"Heroica Nogales","Heroica Nogales","Mexico","MEX","minor",261137],
[1076684312,"Sumaré","Sumare","Brazil","BRA","",265955],
[1840020604,"Lubbock","Lubbock","United States","USA","",267648],
[1682000044,"Yanbu‘","Yanbu`","Saudi Arabia","SAU","",267590],
[1804489982,"Sumy","Sumy","Ukraine","UKR","admin",265758],
[1180581239,"Tshikapa","Tshikapa","Congo (Kinshasa)","COD","",267462],
[1356296545,"Anantapur","Anantapur","India","IND","",267161],
[1826759011,"Westminster","Westminster","United Kingdom","GBR","",255324],
[1840001185,"Reading","Reading","United States","USA","",267155],
[1840015970,"Winter Haven","Winter Haven","United States","USA","",267069],
[1104715655,"Myeik","Myeik","Myanmar","MMR","",266720],
[1076974144,"Marabá","Maraba","Brazil","BRA","",266932],
[1840021224,"Salem","Salem","United States","USA","admin",266804],
[1392943074,"Yao","Yao","Japan","JPN","",264913],
[1076211114,"Barueri","Barueri","Brazil","BRA","",262275],
[1012268984,"Djelfa","Djelfa","Algeria","DZA","admin",265833],
[1410109654,"Suncheon","Suncheon","South Korea","KOR","minor",265390],
[1004315012,"Jalālābād","Jalalabad","Afghanistan","AFG","admin",263312],
[1840015977,"St. Petersburg","St. Petersburg","United States","USA","",265351],
[1643653861,"Engels","Engels","Russia","RUS","",264990],
[1608358783,"Malolos","Malolos","Philippines","PHL","admin",261189],
[1156052493,"Wenling","Wenling","China","CHN","",263700],
[1068626742,"Oruro","Oruro","Bolivia","BOL","",264683],
[1484793569,"Nogales","Nogales","Mexico","MEX","",264782],
[1364663520,"Dezfūl","Dezful","Iran","IRN","minor",264709],
[1076174955,"São José dos Pinhais","Sao Jose dos Pinhais","Brazil","BRA","",264210],
[1840015044,"Lafayette","Lafayette","United States","USA","",264357],
[1410173146,"Kyŏngju","Kyongju","South Korea","KOR","",264091],
[1392003404,"Nagaoka","Nagaoka","Japan","JPN","",263955],
[1360153292,"Dumai","Dumai","Indonesia","IDN","",264084],
[1004687194,"Tāluqān","Taluqan","Afghanistan","AFG","admin",263800],
[1056062897,"Gent","Gent","Belgium","BEL","minor",262219],
[1818708838,"Damanhūr","Damanhur","Egypt","EGY","admin",244043],
[1586294005,"Nawabshah","Nawabshah","Pakistan","PAK","minor",263102],
[1076343513,"Volta Redonda","Volta Redonda","Brazil","BRA","",262970],
[1012600001,"Annaba","Annaba","Algeria","DZA","admin",257359],
[1840021002,"Laredo","Laredo","United States","USA","",262491],
[1392189230,"Kakogawachō-honmachi","Kakogawacho-honmachi","Japan","JPN","",260595],
[1036502269,"Wollongong","Wollongong","Australia","AUS","",261896],
[1250449238,"Bordeaux","Bordeaux","France","FRA","admin",257068],
[1764667935,"Nonthaburi","Nonthaburi","Thailand","THA","admin",255671],
[1840003600,"Jersey City","Jersey City","United States","USA","",262075],
[1608371779,"Marilao","Marilao","Philippines","PHL","",254453],
[1380660414,"Venice","Venice","Italy","ITA","admin",261321],
[1704029499,"Quảng Ngãi","Quang Ngai","Vietnam","VNM","admin",260252],
[1840014559,"Concord","Concord","United States","USA","",261801],
[1608001640,"Olongapo","Olongapo","Philippines","PHL","admin",260317],
[1484140727,"Ciudad Benito Juárez","Ciudad Benito Juarez","Mexico","MEX","minor",260683],
[1276788537,"Gelsenkirchen","Gelsenkirchen","Germany","DEU","minor",259105],
[1392311050,"Hiratsuka","Hiratsuka","Japan","JPN","",257662],
[1840014887,"Columbus","Columbus","United States","USA","",261445],
[1276982173,"Mönchengladbach","Monchengladbach","Germany","DEU","minor",259665],
[1840019309,"Chandler","Chandler","United States","USA","",261165],
[1392897510,"Fukui","Fukui","Japan","JPN","admin",260263],
[1392354483,"Sōka","Soka","Japan","JPN","",251390],
[1004227517,"Kunduz","Kunduz","Afghanistan","AFG","admin",259809],
[1826028894,"Kingston upon Hull","Kingston upon Hull","United Kingdom","GBR","",260200],
[1076461194,"Mossoró","Mossoro","Brazil","BRA","",259815],
[1156182309,"Wutong","Wutong","China","CHN","minor",257800],
[1434518407,"Mişrātah","Misratah","Libya","LBY","admin",259056],
[1826333435,"Derby","Derby","United Kingdom","GBR","",255394],
[1380324879,"Verona","Verona","Italy","ITA","minor",257275],
[1356241312,"Etāwah","Etawah","India","IND","",257448],
[1156156462,"Huayin","Huayin","China","CHN","",258113],
[1840020657,"McKinney","McKinney","United States","USA","",258277],
[1840021940,"Scottsdale","Scottsdale","United States","USA","",258069],
[1840020854,"Killeen","Killeen","United States","USA","",258009],
[1578465701,"Bergen","Bergen","Norway","NOR","admin",257087],
[1840015913,"Tallahassee","Tallahassee","United States","USA","admin",257601],
[1804235146,"Horlivka","Horlivka","Ukraine","UKR","minor",256714],
[1450791699,"Antsirabe","Antsirabe","Madagascar","MDG","minor",257163],
[1566993724,"Ondo","Ondo","Nigeria","NGA","minor",257005],
[1704613422,"Ấp Đa Lợi","Ap Da Loi","Vietnam","VNM","",256019],
[1076025805,"Foz do Iguaçu","Foz do Iguacu","Brazil","BRA","",256088],
[1392003059,"Bunkyō-ku","Bunkyo-ku","Japan","JPN","",235981],
[1840009373,"Peoria","Peoria","United States","USA","",256286],
[1076919841,"Gravataí","Gravatai","Brazil","BRA","",255660],
[1158867217,"Chiayi","Chiayi","Taiwan","TWN","admin",251938],
[1360498846,"Kediri","Kediri","Indonesia","IDN","",252000],
[1566897107,"Damaturu","Damaturu","Nigeria","NGA","admin",255895],
[1392795984,"Tokushima","Tokushima","Japan","JPN","admin",254510],
[1800812511,"Arua","Arua","Uganda","UGA","admin",250000],
[1862335549,"Turmero","Turmero","Venezuela","VEN","minor",254880],
[1840015576,"Wilmington","Wilmington","United States","USA","",255616],
[1356217280,"Rāichūr","Raichur","India","IND","",255240],
[1458475563,"Kuala Terengganu","Kuala Terengganu","Malaysia","MYS","admin",255109],
[1384564974,"Daloa","Daloa","Côte d'Ivoire","CIV","admin",255168],
[1320220558,"San Pedro Carchá","San Pedro Carcha","Guatemala","GTM","minor",255006],
[1024785067,"Moçâmedes","Mocamedes","Angola","AGO","admin",255000],
[1484005187,"La Paz","La Paz","Mexico","MEX","admin",250141],
[1840008353,"Montgomery","Montgomery","United States","USA","admin",254634],
[1826636841,"Wolverhampton","Wolverhampton","United Kingdom","GBR","",250970],
[1840021947,"Gilbert","Gilbert","United States","USA","",254114],
[1376642268,"Rishon LeẔiyyon","Rishon LeZiyyon","Israel","ISR","",249860],
[1724975338,"Vitoria-Gasteiz","Vitoria-Gasteiz","Spain","ESP","admin",253093],
[1792671735,"Kütahya","Kutahya","Turkey","TUR","admin",253335],
[1356168278,"Bharatpur","Bharatpur","India","IND","",252342],
[1392516557,"Shinozaki","Shinozaki","Japan","JPN","",252844],
[1180805022,"Goma","Goma","Congo (Kinshasa)","COD","admin",249862],
[1608710592,"Tacloban","Tacloban","Philippines","PHL","admin",251881],
[1704872008,"Rạch Giá","Rach Gia","Vietnam","VNM","admin",250660],
[1408728939,"Kanggye","Kanggye","North Korea","PRK","admin",251971],
[1643228316,"Taganrog","Taganrog","Russia","RUS","",250287],
[1076359879,"Várzea Grande","Varzea Grande","Brazil","BRA","",249752],
[1729372385,"El Fasher","El Fasher","Sudan","SDN","admin",252609],
[1152858037,"Las Condes","Las Condes","Chile","CHL","",249893],
[1840020563,"Glendale","Glendale","United States","USA","",252381],
[1032492280,"Santiago del Estero","Santiago del Estero","Argentina","ARG","admin",252192],
[1392708558,"Hakodate","Hakodate","Japan","JPN","",251942],
[1356619346,"Begusarai","Begusarai","India","IND","",252008],
[1840020363,"North Las Vegas","North Las Vegas","United States","USA","",251974],
[1724417375,"A Coruña","A Coruna","Spain","ESP","minor",245468],
[1356648808,"Sonīpat","Sonipat","India","IND","",250521],
[1826799578,"Stoke-on-Trent","Stoke-on-Trent","United Kingdom","GBR","",249008],
[1862066931,"Los Teques","Los Teques","Venezuela","VEN","admin",251200],
[1156062960,"Jinshi","Jinshi","China","CHN","minor",251064],
[1392692794,"Chōfugaoka","Chofugaoka","Japan","JPN","",240359],
[1566462707,"Iwo","Iwo","Nigeria","NGA","minor",250443],
[1214313712,"Higüey","Higuey","Dominican Republic","DOM","minor",251243],
[1076912078,"Juazeiro do Norte","Juazeiro do Norte","Brazil","BRA","",249939],
[1226528087,"Bata","Bata","Equatorial Guinea","GNQ","admin",250770],
[1818607968,"Al Minyā","Al Minya","Egypt","EGY","admin",236043],
[1364476070,"Bābol","Babol","Iran","IRN","minor",250217],
[1643862307,"Komsomol’sk-na-Amure","Komsomol'sk-na-Amure","Russia","RUS","minor",249810],
[1276805572,"Aachen","Aachen","Germany","DEU","minor",248960],
[1804144712,"Rivne","Rivne","Ukraine","UKR","admin",246574],
[1642571620,"Galaţi","Galati","Romania","ROU","admin",249432],
[1434263017,"Al Bayḑā’","Al Bayda'","Libya","LBY","admin",250000],
[1729180375,"Kurmuk","Kurmuk","Sudan","SDN","",250000],
[1392003273,"Shibuya-ku","Shibuya-ku","Japan","JPN","",235193],
[1704890399,"Thủ Dầu Một","Thu Dau Mot","Vietnam","VNM","admin",244277],
[1276941443,"Braunschweig","Braunschweig","Germany","DEU","minor",248561],
[1156354568,"Manzhouli","Manzhouli","China","CHN","",249472],
[1616385189,"Gdynia","Gdynia","Poland","POL","minor",247672],
[1360268553,"Palangkaraya","Palangkaraya","Indonesia","IDN","admin",249434],
[1682394909,"Ḩafr al Bāţin","Hafr al Batin","Saudi Arabia","SAU","",249194],
[1392346493,"Chigasaki","Chigasaki","Japan","JPN","",242347],
[1586672083,"Sahiwal","Sahiwal","Pakistan","PAK","minor",247706],
[1276305306,"Kiel","Kiel","Germany","DEU","admin",246601],
[1356021505,"Shrīrāmpur","Shrirampur","India","IND","",181842],
[1826964096,"Portsmouth","Portsmouth","United Kingdom","GBR","",248440],
[1458970454,"Sibu","Sibu","Malaysia","MYS","",247995],
[1392469032,"Yato","Yato","Japan","JPN","",239146],
[1032266693,"Paraná","Parana","Argentina","ARG","admin",247863],
[1192329773,"Santa Clara","Santa Clara","Cuba","CUB","admin",247436],
[1392300081,"Yamagata","Yamagata","Japan","JPN","admin",247234],
[1076486025,"Imperatriz","Imperatriz","Brazil","BRA","",247505],
[1068271533,"Oruro","Oruro","Bolivia","BOL","admin",246501],
[1032232613,"Merlo","Merlo","Argentina","ARG","minor",244168],
[1392112466,"Tsukuba-kenkyūgakuen-toshi","Tsukuba-kenkyugakuen-toshi","Japan","JPN","",246647],
[1826597621,"Barnsley","Barnsley","United Kingdom","GBR","",245199],
[1643573386,"Syktyvkar","Syktyvkar","Russia","RUS","admin",245313],
[1643601857,"Khimki","Khimki","Russia","RUS","",244668],
[1524520011,"Birāṭnagar","Biratnagar","Nepal","NPL","admin",242548],
[1124612546,"Saskatoon","Saskatoon","Canada","CAN","",246376],
[1826574888,"Abertawe","Abertawe","United Kingdom","GBR","",245508],
[1050244487,"Jessore","Jessore","Bangladesh","BGD","",243987],
[1156401666,"Beichengqu","Beichengqu","China","CHN","minor",245608],
[1704697424,"Tuy Hòa","Tuy Hoa","Vietnam","VNM","admin",242840],
[1356820012,"Hāpur","Hapur","India","IND","",242920],
[1840003874,"Chesapeake","Chesapeake","United States","USA","",244835],
[1392249213,"Fuji","Fuji","Japan","JPN","",243739],
[1276519956,"Chemnitz","Chemnitz","Germany","DEU","minor",243487],
[1410279439,"Mokpo","Mokpo","South Korea","KOR","minor",239524],
[1792144759,"Avcılar","Avcilar","Turkey","TUR","",233749],
[1834004568,"Tanga","Tanga","Tanzania","TZA","admin",243580],
[1076178738,"Santa Maria","Santa Maria","Brazil","BRA","",243611],
[1364379130,"Sabzevār","Sabzevar","Iran","IRN","minor",243700],
[1356590864,"Rāmgundam","Ramgundam","India","IND","",242979],
[1231784118,"Bahir Dar","Bahir Dar","Ethiopia","ETH","admin",243300],
[1620356810,"Porto","Porto","Portugal","PRT","admin",237591],
[1862630716,"Baruta","Baruta","Venezuela","VEN","minor",240755],
[1566310893,"Sapele","Sapele","Nigeria","NGA","minor",242652],
[1392003180,"Sasebo","Sasebo","Japan","JPN","",242664],
[1104327329,"Myitkyina","Myitkyina","Myanmar","MMR","admin",243031],
[1840031233,"Barnstable","Barnstable","United States","USA","",242847],
[1408348983,"Haeju","Haeju","North Korea","PRK","admin",241599],
[1376362310,"Petaẖ Tiqwa","Petah Tiqwa","Israel","ISR","",236169],
[1840003869,"Norfolk","Norfolk","United States","USA","",242742],
[1032883563,"González Catán","Gonzalez Catan","Argentina","ARG","",238067],
[1156893347,"Diaobingshancun","Diaobingshancun","China","CHN","",241431],
[1604622202,"Tarapoto","Tarapoto","Peru","PER","",240453],
[1156352113,"Zhangping","Zhangping","China","CHN","minor",242000],
[1076673445,"São Carlos","Sao Carlos","Brazil","BRA","",241389],
[1208841031,"Aarhus","Aarhus","Denmark","DNK","minor",237551],
[1840020292,"Fremont","Fremont","United States","USA","",241110],
[1076484921,"Ipatinga","Ipatinga","Brazil","BRA","",239468],
[1408625970,"Anju","Anju","North Korea","PRK","",240117],
[1156029691,"Shanhu","Shanhu","China","CHN","minor",240400],
[1050424421,"Nārāyanganj","Narayanganj","Bangladesh","BGD","",223622],
[1484281759,"Monclova","Monclova","Mexico","MEX","minor",237169],
[1840018481,"Kennewick","Kennewick","United States","USA","",240735],
[1156047949,"Atushi","Atushi","China","CHN","minor",240368],
[1508460246,"Chimoio","Chimoio","Mozambique","MOZ","admin",238976],
[1196136222,"Limassol","Limassol","Cyprus","CYP","admin",235056],
[1076221386,"Novo Hamburgo","Novo Hamburgo","Brazil","BRA","",238940],
[1840020707,"Garland","Garland","United States","USA","",239928],
[1840019438,"Irving","Irving","United States","USA","",239798],
[1250071961,"Lille","Lille","France","FRA","admin",233098],
[1392229262,"Arakawa","Arakawa","Japan","JPN","",217891],
[1124122753,"Longueuil","Longueuil","Canada","CAN","",239700],
[1276167077,"Halle","Halle","Germany","DEU","minor",237865],
[1703452690,"Košice","Kosice","Slovakia","SVK","admin",238593],
[1076314777,"Viamão","Viamao","Brazil","BRA","",239384],
[1392003338,"Matsumoto","Matsumoto","Japan","JPN","",239115],
[1360353144,"Banda Aceh","Banda Aceh","Indonesia","IDN","admin",235305],
[1156106796,"Shenmu","Shenmu","China","CHN","",237846],
[1710058382,"Springs","Springs","South Africa","ZAF","",236083],
[1458446120,"Taiping","Taiping","Malaysia","MYS","",237095],
[1562758258,"Zinder","Zinder","Niger","NER","admin",235605],
[1512461161,"As Sīb","As Sib","Oman","OMN","",237816],
[1408184982,"P’yŏng-dong","P'yong-dong","North Korea","PRK","",236583],
[1804208152,"Ivano-Frankivsk","Ivano-Frankivsk","Ukraine","UKR","admin",236602],
[1156858793,"Lishui","Lishui","China","CHN","minor",238400],
[1032880202,"Quilmes","Quilmes","Argentina","ARG","minor",230810],
[1156519625,"Wuyishan","Wuyishan","China","CHN","minor",238000],
[1364107935,"Āmol","Amol","Iran","IRN","minor",237528],
[1586156251,"Mirpur Khas","Mirpur Khas","Pakistan","PAK","minor",236961],
[1104832430,"Pathein","Pathein","Myanmar","MMR","admin",237089],
[1643493938,"Nizhnekamsk","Nizhnekamsk","Russia","RUS","",237250],
[1840021639,"Visalia","Visalia","United States","USA","",237386],
[1682564079,"Al Jubayl","Al Jubayl","Saudi Arabia","SAU","",237274],
[1392993634,"Neya","Neya","Japan","JPN","",227997],
[1156325764,"Chishui","Chishui","China","CHN","",237052],
[1710138774,"Centurion","Centurion","South Africa","ZAF","",236580],
[1356354610,"Uluberiya","Uluberiya","India","IND","",235345],
[1840003798,"Atlantic City","Atlantic City","United States","USA","",237054],
[1364370088,"Pākdasht","Pakdasht","Iran","IRN","minor",236319],
[1643542365,"Shakhty","Shakhty","Russia","RUS","",235492],
[1276418236,"Magdeburg","Magdeburg","Germany","DEU","admin",235775],
[1887036494,"Ibb","Ibb","Yemen","YEM","",234837],
[1682759151,"Abhā","Abha","Saudi Arabia","SAU","admin",236157],
[1120803808,"Garoua","Garoua","Cameroon","CMR","admin",235996],
[1156784761,"Bole","Bole","China","CHN","",235585],
[1024320952,"Ganda","Ganda","Angola","AGO","",235486],
[1364053850,"Najafābād","Najafabad","Iran","IRN","minor",235281],
[1192297857,"Bayamo","Bayamo","Cuba","CUB","admin",235107],
[1356368903,"Puducherry","Puducherry","India","IND","admin",227411],
[1356634492,"Porbandar","Porbandar","India","IND","",234684],
[1804033242,"Kamianske","Kamianske","Ukraine","UKR","minor",235066],
[1364855573,"Borūjerd","Borujerd","Iran","IRN","minor",234997],
[1840033743,"Paradise","Paradise","United States","USA","",235087],
[1360426282,"Singaraja","Singaraja","Indonesia","IDN","minor",234468],
[1724611437,"Elche","Elche","Spain","ESP","",234205],
[1076074287,"Macaé","Macae","Brazil","BRA","",234628],
[1458079883,"Miri","Miri","Malaysia","MYS","",234541],
[1218378191,"Machala","Machala","Ecuador","ECU","admin",231260],
[1724929320,"Granada","Granada","Spain","ESP","minor",231775],
[1694651111,"Bo","Bo","Sierra Leone","SLE","admin",233684],
[1380622386,"Messina","Messina","Italy","ITA","minor",234293],
[1528636212,"Eindhoven","Eindhoven","Netherlands","NLD","minor",231642],
[1840002984,"Nashua","Nashua","United States","USA","",233917],
[1214335207,"San Cristóbal","San Cristobal","Dominican Republic","DOM","admin",232769],
[1076615737,"Arapiraca","Arapiraca","Brazil","BRA","",233047],
[1586880900,"Okara","Okara","Pakistan","PAK","minor",232386],
[1724090334,"Badalona","Badalona","Spain","ESP","",223006],
[1840006112,"Arlington","Arlington","United States","USA","",233464],
[1050512022,"Saidpur","Saidpur","Bangladesh","BGD","",232209],
[1840015157,"Hialeah","Hialeah","United States","USA","",233339],
[1840001472,"York","York","United States","USA","",233184],
[1392618841,"Saga","Saga","Japan","JPN","admin",232359],
[1124817304,"Burnaby","Burnaby","Canada","CAN","",232755],
[1608553352,"Meycauayan","Meycauayan","Philippines","PHL","",225673],
[1152672356,"Rancagua","Rancagua","Chile","CHL","admin",231370],
[1276371228,"Freiburg im Breisgau","Freiburg im Breisgau","Germany","DEU","minor",230940],
[1392430282,"Kasukabe","Kasukabe","Japan","JPN","",228975],
[1643076798,"Dzerzhinsk","Dzerzhinsk","Russia","RUS","",231797],
[1076042151,"Marília","Marilia","Brazil","BRA","",232006],
[1643485535,"Bratsk","Bratsk","Russia","RUS","",231602],
[1050297281,"Barishal","Barishal","Bangladesh","BGD","admin",230000],
[1156177210,"Jiayuguan","Jiayuguan","China","CHN","minor",231853],
[1218127217,"Eloy Alfaro","Eloy Alfaro","Ecuador","ECU","",230839],
[1076347789,"Indaiatuba","Indaiatuba","Brazil","BRA","",231033],
[1170785909,"Envigado","Envigado","Colombia","COL","minor",228848],
[1484781342,"Guadalupe","Guadalupe","Mexico","MEX","minor",215000],
[1392046664,"Ageoshimo","Ageoshimo","Japan","JPN","",226616],
[1364173799,"Qarchak","Qarchak","Iran","IRN","",231075],
[1484124846,"Toluca","Toluca","Mexico","MEX","admin",223876],
[1608269612,"Ormoc","Ormoc","Philippines","PHL","admin",230998],
[1032525768,"Neuquén","Neuquen","Argentina","ARG","admin",231198],
[1032997685,"Banfield","Banfield","Argentina","ARG","",223898],
[1076922153,"Americana","Americana","Brazil","BRA","",229322],
[1484014035,"Fresnillo","Fresnillo","Mexico","MEX","minor",230865],
[1360906363,"Singkawang","Singkawang","Indonesia","IDN","",230376],
[1643003114,"Orsk","Orsk","Russia","RUS","",230414],
[1356212761,"Vizianagaram","Vizianagaram","India","IND","",228720],
[1840087737,"North Hempstead","North Hempstead","United States","USA","",230531],
[1840013730,"Evansville","Evansville","United States","USA","",230427],
[1706165964,"Marka","Marka","Somalia","SOM","admin",230100],
[1076098590,"Cotia","Cotia","Brazil","BRA","",229548],
[1356212172,"Pāli","Pali","India","IND","",229956],
[1643129651,"Noginsk","Noginsk","Russia","RUS","",229731],
[1804374492,"Kropyvnytskyi","Kropyvnytskyi","Ukraine","UKR","admin",227413],
[1392662678,"Taitō","Taito","Japan","JPN","",210528],
[1076627175,"Rondonópolis","Rondonopolis","Brazil","BRA","",228857],
[1320020813,"Cobán","Coban","Guatemala","GTM","admin",228664],
[1192866062,"Guantánamo","Guantanamo","Cuba","CUB","admin",228436],
[1276149829,"Krefeld","Krefeld","Germany","DEU","minor",226844],
[1484187110,"Huixquilucan","Huixquilucan","Mexico","MEX","minor",224042],
[1643448070,"Kolpino","Kolpino","Russia","RUS","",225801],
[1422897920,"Sidon","Sidon","Lebanon","LBN","admin",200000],
[1076385139,"Magé","Mage","Brazil","BRA","",227322],
[1566625487,"Apapa","Apapa","Nigeria","NGA","minor",217362],
[1356992385,"Nadiād","Nadiad","India","IND","",225132],
[1840019310,"Avondale","Avondale","United States","USA","",227289],
[1840019743,"Brownsville","Brownsville","United States","USA","",227239],
[1795167397,"Daşoguz","Dasoguz","Turkmenistan","TKM","admin",227184],
[1360138476,"Probolinggo","Probolinggo","Indonesia","IDN","",223159],
[1076592769,"Jacareí","Jacarei","Brazil","BRA","",226539],
[1320083599,"Quetzaltenango","Quetzaltenango","Guatemala","GTM","admin",225000],
[1076251019,"Araraquara","Araraquara","Brazil","BRA","",226508],
[1643989118,"Angarsk","Angarsk","Russia","RUS","",226374],
[1356051733,"Nāgercoil","Nagercoil","India","IND","",224329],
[1788927583,"Sousse","Sousse","Tunisia","TUN","admin",221530],
[1646257566,"Nyanza","Nyanza","Rwanda","RWA","admin",225209],
[1392999976,"Takarazuka","Takarazuka","Japan","JPN","",224055],
[1484431512,"Campeche","Campeche","Mexico","MEX","admin",220389],
[1392522298,"Atsugichō","Atsugicho","Japan","JPN","",223815],
[1724377964,"Tarrasa","Tarrasa","Spain","ESP","",223011],
[1704298745,"Bạc Liêu","Bac Lieu","Vietnam","VNM","admin",225000],
[1076008789,"Itapevi","Itapevi","Brazil","BRA","",223404],
[1450540529,"Toamasina","Toamasina","Madagascar","MDG","admin",225116],
[1356145204,"Karnāl","Karnal","India","IND","",225049],
[1360506609,"Padangsidempuan","Padangsidempuan","Indonesia","IDN","",225544],
[1364275103,"Varāmīn","Varamin","Iran","IRN","minor",225628],
[1566265170,"Mubi","Mubi","Nigeria","NGA","minor",225705],
[1643323167,"Korolëv","Korolev","Russia","RUS","",221797],
[1156644593,"Hunchun","Hunchun","China","CHN","minor",225454],
[1246964318,"Tampere","Tampere","Finland","FIN","admin",225118],
[1792191587,"Sakarya","Sakarya","Turkey","TUR","admin",224962],
[1643308239,"Blagoveshchensk","Blagoveshchensk","Russia","RUS","admin",224419],
[1643774241,"Velikiy Novgorod","Velikiy Novgorod","Russia","RUS","admin",222594],
[1156526154,"Longjin","Longjin","China","CHN","",221881],
[1376458766,"Ashdod","Ashdod","Israel","ISR","",220174],
[1616881632,"Częstochowa","Czestochowa","Poland","POL","minor",223322],
[1356558409,"Puri","Puri","India","IND","",201026],
[1192400731,"Carlos Manuel de Céspedes","Carlos Manuel de Cespedes","Cuba","CUB","minor",224488],
[1076258255,"Chapecó","Chapeco","Brazil","BRA","",224013],
[1710113163,"Sandton","Sandton","South Africa","ZAF","",222415],
[1356599194,"Tanjore","Tanjore","India","IND","",222943],
[1643807951,"Staryy Oskol","Staryy Oskol","Russia","RUS","",223360],
[1356779437,"Secunderābād","Secunderabad","India","IND","",213698],
[1156207117,"Ji’an Shi","Ji'an Shi","China","CHN","minor",222938],
[1792903330,"Bursa","Bursa","Turkey","TUR","admin",211644],
[1032741145,"José C. Paz","Jose C. Paz","Argentina","ARG","minor",216637],
[1686348669,"Rufisque","Rufisque","Senegal","SEN","",221066],
[1076239965,"Presidente Prudente","Presidente Prudente","Brazil","BRA","",222192],
[1024937810,"Barra do Dande","Barra do Dande","Angola","AGO","",222528],
[1036679838,"Hobart","Hobart","Australia","AUS","admin",222356],
[1826498106,"Swindon","Swindon","United Kingdom","GBR","",222193],
[1392003546,"Ōta","Ota","Japan","JPN","",221123],
[1804000146,"Ternopil","Ternopil","Ukraine","UKR","admin",218653],
[1032802536,"Formosa","Formosa","Argentina","ARG","admin",222226],
[1356376216,"Sambhal","Sambhal","India","IND","",220813],
[1324580681,"Guéckédou","Gueckedou","Guinea","GIN","minor",221715],
[1250363682,"Rennes","Rennes","France","FRA","admin",217728],
[1710908010,"Polokwane","Polokwane","South Africa","ZAF","admin",220045],
[1724348384,"Sabadell","Sabadell","Spain","ESP","",216204],
[1364706573,"Neyshābūr","Neyshabur","Iran","IRN","minor",221700],
[1616327727,"Radom","Radom","Poland","POL","minor",219703],
[1804014744,"Lutsk","Lutsk","Ukraine","UKR","admin",216505],
[1392000706,"Hachinohe","Hachinohe","Japan","JPN","",220612],
[1840013947,"Gulfport","Gulfport","United States","USA","",220987],
[1862716082,"San Felipe","San Felipe","Venezuela","VEN","admin",220786],
[1364844111,"Sāveh","Saveh","Iran","IRN","minor",220762],
[1392001244,"Nishitōkyō","Nishitokyo","Japan","JPN","",207098],
[1608845898,"Santo Tomas","Santo Tomas","Philippines","PHL","",218500],
[1214691060,"La Vega","La Vega","Dominican Republic","DOM","admin",220279],
[1840002400,"Appleton","Appleton","United States","USA","",220570],
[1364403465,"Khomeynī Shahr","Khomeyni Shahr","Iran","IRN","minor",218737],
[1818333966,"Damietta","Damietta","Egypt","EGY","admin",206664],
[1076632040,"Juazeiro","Juazeiro","Brazil","BRA","",220253],
[1804343754,"Kremenchuk","Kremenchuk","Ukraine","UKR","minor",220174],
[1076003792,"Itabuna","Itabuna","Brazil","BRA","",219680],
[1682059414,"Al Khubar","Al Khubar","Saudi Arabia","SAU","",219679],
[1484179679,"Córdoba","Cordoba","Mexico","MEX","minor",218153],
[1356724691,"Shiliguri","Shiliguri","India","IND","",218718],
[1368905231,"Zākhū","Zakhu","Iraq","IRQ","minor",219006],
[1170721938,"Tuluá","Tulua","Colombia","COL","minor",219138],
[1276801317,"Mainz","Mainz","Germany","DEU","admin",217123],
[1076591779,"Hortolândia","Hortolandia","Brazil","BRA","",215819],
[1360695939,"Bitung","Bitung","Indonesia","IDN","",218520],
[1356715598,"Naihāti","Naihati","India","IND","",217900],
[1528817379,"Tilburg","Tilburg","Netherlands","NLD","minor",217259],
[1218160109,"Manta","Manta","Ecuador","ECU","",217553],
[1410606985,"Osan","Osan","South Korea","KOR","",213840],
[1180446432,"Butembo","Butembo","Congo (Kinshasa)","COD","",217625],
[1222009747,"San Miguel","San Miguel","El Salvador","SLV","admin",218410],
[1724090743,"Oviedo","Oviedo","Spain","ESP","admin",217552],
[1376203187,"Netanya","Netanya","Israel","ISR","",217244],
[1152838958,"Concepción","Concepcion","Chile","CHL","admin",217537],
[1076964860,"Itaboraí","Itaborai","Brazil","BRA","",218008],
[1484229977,"Zamora","Zamora","Mexico","MEX","",207860],
[1840018410,"Bremerton","Bremerton","United States","USA","",218400],
[1458273978,"Alor Setar","Alor Setar","Malaysia","MYS","admin",217000],
[1840014524,"Hickory","Hickory","United States","USA","",218323],
[1826630574,"Luton","Luton","United Kingdom","GBR","",213052],
[1840021129,"Tacoma","Tacoma","United States","USA","",217827],
[1860150082,"Denov","Denov","Uzbekistan","UZB","",217274],
[1512325823,"Maţraḩ","Matrah","Oman","OMN","",214901],
[1398455461,"Qostanay","Qostanay","Kazakhstan","KAZ","admin",217135],
[1360085654,"Banjarbaru","Banjarbaru","Indonesia","IDN","",216600],
[1704983576,"Sa Đéc","Sa Dec","Vietnam","VNM","minor",213610],
[1608418474,"Valencia","Valencia","Philippines","PHL","",216546],
[1156571525,"Gujiao","Gujiao","China","CHN","",216723],
[1276852342,"Lübeck","Lubeck","Germany","DEU","minor",215846],
[1724143241,"Cartagena","Cartagena","Spain","ESP","",216365],
[1398252858,"Petropavl","Petropavl","Kazakhstan","KAZ","admin",216406],
[1076834293,"São Leopoldo","Sao Leopoldo","Brazil","BRA","",214087],
[1860419224,"Marg‘ilon","Marg`ilon","Uzbekistan","UZB","",215400],
[1608990723,"Trece Martires City","Trece Martires City","Philippines","PHL","admin",210503],
[1410450550,"Gangneung","Gangneung","South Korea","KOR","minor",215677],
[1840021728,"San Bernardino","San Bernardino","United States","USA","",215784],
[1862770169,"Cúa","Cua","Venezuela","VEN","minor",214823],
[1368246912,"As Samāwah","As Samawah","Iraq","IRQ","admin",215000],
[1246957545,"Vantaa","Vantaa","Finland","FIN","minor",214605],
[1840019570,"College Station","College Station","United States","USA","",215243],
[1156083724,"Golmud","Golmud","China","CHN","minor",215214],
[1840003185,"Kalamazoo","Kalamazoo","United States","USA","",215193],
[1756810813,"Geneva","Geneva","Switzerland","CHE","admin",201818],
[1124342541,"Regina","Regina","Canada","CAN","admin",215106],
[1840021844,"Thousand Oaks","Thousand Oaks","United States","USA","",215029],
[1862054455,"La Victoria","La Victoria","Venezuela","VEN","minor",214492],
[1356962932,"Shimla","Shimla","India","IND","admin",206575],
[1112573808,"Babruysk","Babruysk","Belarus","BLR","minor",212200],
[1826806747,"Northampton","Northampton","United Kingdom","GBR","",212100],
[1504542634,"Mohammedia","Mohammedia","Morocco","MAR","",208612],
[1840003858,"Roanoke","Roanoke","United States","USA","",214674],
[1156993705,"Rui’an","Rui'an","China","CHN","",213600],
[1276924655,"Erfurt","Erfurt","Germany","DEU","admin",213835],
[1076863850,"Sete Lagoas","Sete Lagoas","Brazil","BRA","",214152],
[1840020402,"Fontana","Fontana","United States","USA","",214547],
[1466666150,"Sikasso","Sikasso","Mali","MLI","admin",213977],
[1068890339,"Warnes","Warnes","Bolivia","BOL","",214216],
[1724412875,"Móstoles","Mostoles","Spain","ESP","",209639],
[1862428934,"El Tigre","El Tigre","Venezuela","VEN","minor",213524],
[1076716552,"Divinópolis","Divinopolis","Brazil","BRA","",213016],
[1076976439,"Colombo","Colombo","Brazil","BRA","",212967],
[1840020552,"Moreno Valley","Moreno Valley","United States","USA","",213055],
[1724866806,"Jerez de la Frontera","Jerez de la Frontera","Spain","ESP","",212801],
[1012123414,"Sidi Bel Abbès","Sidi Bel Abbes","Algeria","DZA","admin",212935],
[1120635273,"Limbe","Limbe","Cameroon","CMR","",212474],
[1392991987,"Kure","Kure","Japan","JPN","",212159],
[1380964615,"Padova","Padova","Italy","ITA","minor",210440],
[1192534571,"Arroyo Naranjo","Arroyo Naranjo","Cuba","CUB","",210053],
[1591599922,"Colón","Colon","Panama","PAN","admin",204000],
[1642169731,"Ploieşti","Ploiesti","Romania","ROU","admin",209945],
[1276448936,"Oberhausen","Oberhausen","Germany","DEU","minor",209566],
[1076000206,"Criciúma","Criciuma","Brazil","BRA","",211369],
[1643877414,"Pskov","Pskov","Russia","RUS","admin",209840],
[1804758853,"Bila Tserkva","Bila Tserkva","Ukraine","UKR","minor",208944],
[1392003456,"Isesaki","Isesaki","Japan","JPN","",210332],
[1724483329,"Pamplona","Pamplona","Spain","ESP","admin",203081],
[1608775993,"Naga City","Naga City","Philippines","PHL","admin",209170],
[1100365645,"Burgas","Burgas","Bulgaria","BGR","admin",210720],
[1840005142,"Babylon","Babylon","United States","USA","",211207],
[1410333057,"Chungju","Chungju","South Korea","KOR","",211005],
[1076848743,"Maracanaú","Maracanau","Brazil","BRA","",209057],
[1170843027,"Tunja","Tunja","Colombia","COL","admin",209263],
[1608329397,"Pagadian","Pagadian","Philippines","PHL","admin",210452],
[1608693683,"Legazpi City","Legazpi City","Philippines","PHL","admin",209533],
[1170362340,"Barrancabermeja","Barrancabermeja","Colombia","COL","minor",210729],
[1384436547,"San-Pédro","San-Pedro","Côte d'Ivoire","CIV","admin",210273],
[1458619046,"Bukit Mertajam","Bukit Mertajam","Malaysia","MYS","",210000],
[1484408906,"Puerto Vallarta","Puerto Vallarta","Mexico","MEX","minor",203342],
[1566495747,"Ijebu-Ode","Ijebu-Ode","Nigeria","NGA","minor",209175],
[1156077513,"Taisheng","Taisheng","China","CHN","",208589],
[1276210265,"Rostock","Rostock","Germany","DEU","",209061],
[1372221853,"Cork","Cork","Ireland","IRL","admin",208669],
[1862083525,"Guarenas","Guarenas","Venezuela","VEN","minor",208663],
[1608577408,"Panabo","Panabo","Philippines","PHL","",209230],
[1156856366,"Dongning","Dongning","China","CHN","minor",210000],
[1724813158,"Santa Cruz","Santa Cruz","Spain","ESP","admin",208563],
[1826720500,"Solihull","Solihull","United Kingdom","GBR","",206674],
[1566686777,"Burutu","Burutu","Nigeria","NGA","minor",209666],
[1364571196,"Nasīm Shahr","Nasim Shahr","Iran","IRN","minor",200393],
[1144324309,"Moratuwa","Moratuwa","Sri Lanka","LKA","",200000],
[1156720536,"Pinghu","Pinghu","China","CHN","",208500],
[1410736435,"Ich’ŏn","Ich'on","South Korea","KOR","",209003],
[1826291745,"Milton Keynes","Milton Keynes","United Kingdom","GBR","",207057],
[1608812117,"Marawi City","Marawi City","Philippines","PHL","admin",207010],
[1862031193,"Puerto Cabello","Puerto Cabello","Venezuela","VEN","minor",209080],
[1376023307,"Beersheba","Beersheba","Israel","ISR","admin",209000],
[1156149186,"Huangyan","Huangyan","China","CHN","",198713],
[1840015120,"North Port","North Port","United States","USA","",209070],
[1528683566,"Almere","Almere","Netherlands","NLD","minor",207904],
[1360359449,"Lubuklinggau","Lubuklinggau","Indonesia","IDN","",208225],
[1795413265,"Mary","Mary","Turkmenistan","TKM","admin",208682],
[1840000177,"Fargo","Fargo","United States","USA","",208675],
[1620824685,"Cascais","Cascais","Portugal","PRT","minor",206479],
[1554717659,"Northcote","Northcote","New Zealand","NZL","",205605],
[1818868450,"Qinā","Qina","Egypt","EGY","admin",201191],
[1608665464,"Toledo","Toledo","Philippines","PHL","",207314],
[1356305803,"Kharagpur","Kharagpur","India","IND","",207604],
[1554034359,"Waitakere","Waitakere","New Zealand","NZL","",208100],
[1104777345,"Monywa","Monywa","Myanmar","MMR","",207489],
[1356106153,"Dindigul","Dindigul","India","IND","",207327],
[1834185429,"Morogoro","Morogoro","Tanzania","TZA","admin",207000],
[1840002344,"Green Bay","Green Bay","United States","USA","",207557],
[1158047789,"Pingzhen","Pingzhen","Taiwan","TWN","",201632],
[1818902849,"Banī Suwayf","Bani Suwayf","Egypt","EGY","admin",193048],
[1508752825,"Cidade de Nacala","Cidade de Nacala","Mozambique","MOZ","",206449],
[1152736946,"Talca","Talca","Chile","CHL","admin",206069],
[1218169586,"Portoviejo","Portoviejo","Ecuador","ECU","admin",206682],
[1840033832,"Spring Valley","Spring Valley","United States","USA","",207127],
[1040261171,"Linz","Linz","Austria","AUT","admin",204846],
[1380102581,"Trieste","Trieste","Italy","ITA","admin",204338],
[1608542323,"San Carlos City","San Carlos City","Philippines","PHL","",205424],
[1392003213,"Kodaira","Kodaira","Japan","JPN","",196959],
[1392384479,"Itami","Itami","Japan","JPN","",198522],
[1704221456,"Phan Thiết","Phan Thiet","Vietnam","VNM","admin",205333],
[1180574233,"Kalemie","Kalemie","Congo (Kinshasa)","COD","admin",206257],
[1392889022,"Kamirenjaku","Kamirenjaku","Japan","JPN","",194460],
[1620042113,"Loures","Loures","Portugal","PRT","minor",205054],
[1012947247,"Biskra","Biskra","Algeria","DZA","admin",204661],
[1356142829,"Ingrāj Bāzār","Ingraj Bazar","India","IND","",205521],
[1376944837,"Bené Beraq","Bene Beraq","Israel","ISR","",193774],
[1643322494,"Mytishchi","Mytishchi","Russia","RUS","",205397],
[1392398873,"Nagareyama","Nagareyama","Japan","JPN","",200298],
[1356385136,"Ongole","Ongole","India","IND","",204746],
[1834823848,"Zanzibar","Zanzibar","Tanzania","TZA","admin",205870],
[1156061722,"Jiutai","Jiutai","China","CHN","",205399],
[1364170406,"Qā’em Shahr","Qa'em Shahr","Iran","IRN","",204953],
[1840019156,"Amarillo","Amarillo","United States","USA","",205603],
[1356931882,"Ellore","Ellore","India","IND","",203780],
[1686273643,"Ziguinchor","Ziguinchor","Senegal","SEN","admin",205294],
[1360041663,"Ternate","Ternate","Indonesia","IDN","",204215],
[1156189796,"Puqi","Puqi","China","CHN","",205164],
[1340870189,"La Ceiba","La Ceiba","Honduras","HND","admin",196856],
[1392929073,"Yachiyo","Yachiyo","Japan","JPN","",200538],
[1586997587,"Mandi Burewala","Mandi Burewala","Pakistan","PAK","",203454],
[1152038253,"Coquimbo","Coquimbo","Chile","CHL","minor",204068],
[1792519395,"Tekirdağ","Tekirdag","Turkey","TUR","admin",204001],
[1076600360,"Parnamirim","Parnamirim","Brazil","BRA","",202456],
[1840000327,"Portland","Portland","United States","USA","",203969],
[1528295161,"Groningen","Groningen","Netherlands","NLD","admin",201462],
[1643652314,"Biysk","Biysk","Russia","RUS","",203108],
[1056263311,"Charleroi","Charleroi","Belgium","BEL","minor",201816],
[1826324306,"Aberdeen","Aberdeen","United Kingdom","GBR","",200680],
[1156686465,"Lanxi","Lanxi","China","CHN","",203300],
[1862282663,"La Guaira","La Guaira","Venezuela","VEN","admin",203520],
[1894390715,"Mazabuka","Mazabuka","Zambia","ZMB","",203219],
[1158417233,"Zhubei","Zhubei","Taiwan","TWN","admin",200000],
[1484808798,"Poza Rica de Hidalgo","Poza Rica de Hidalgo","Mexico","MEX","minor",200119],
[1616267221,"Toruń","Torun","Poland","POL","admin",201447],
[1360990589,"Tanjungpinang","Tanjungpinang","Indonesia","IDN","admin",203008],
[1276791686,"Kassel","Kassel","Germany","DEU","minor",201048],
[1204972666,"Djougou","Djougou","Benin","BEN","admin",202810],
[1356491171,"Haldia","Haldia","India","IND","",200827],
[1818948225,"Luxor","Luxor","Egypt","EGY","admin",202232],
[1360080072,"Tarakan","Tarakan","Indonesia","IDN","",201635],
[1840021829,"Santa Barbara","Santa Barbara","United States","USA","",202401],
[1840014022,"Gainesville","Gainesville","United States","USA","",202335],
[1192626319,"Las Tunas","Las Tunas","Cuba","CUB","admin",202105],
[1643024284,"Lyubertsy","Lyubertsy","Russia","RUS","",197705],
[1392692238,"Matsue","Matsue","Japan","JPN","admin",201802],
[1616057255,"Sosnowiec","Sosnowiec","Poland","POL","minor",199974],
[1152531089,"Arica","Arica","Chile","CHL","admin",202131],
[1434172839,"Al Khums","Al Khums","Libya","LBY","",201943],
[1604316784,"Huacho","Huacho","Peru","PER","admin",200585],
[1356836043,"Gurgaon","Gurgaon","India","IND","",197340],
[1504964063,"El Jadid","El Jadid","Morocco","MAR","",194934],
[1604091119,"Cajamarca","Cajamarca","Peru","PER","admin",201329],
[1840058192,"Huntington","Huntington","United States","USA","",201718],
[1484185237,"Ciudad Madero","Ciudad Madero","Mexico","MEX","minor",197216],
[1004765445,"Lashkar Gāh","Lashkar Gah","Afghanistan","AFG","admin",201546],
[1566695464,"Mai’Adua","Mai'Adua","Nigeria","NGA","minor",201178],
[1586964444,"Jacobabad","Jacobabad","Pakistan","PAK","minor",200815],
[1724745640,"Almería","Almeria","Spain","ESP","minor",200753],
[1348460698,"Debrecen","Debrecen","Hungary","HUN","admin",200974],
[1792534905,"Tokat","Tokat","Turkey","TUR","admin",201294],
[1478009046,"Néma","Nema","Mauritania","MRT","admin",200000],
[1398248334,"Qyzylorda","Qyzylorda","Kazakhstan","KAZ","admin",200900],
[1840019865,"Olympia","Olympia","United States","USA","admin",200915],
[1862573240,"Guacara","Guacara","Venezuela","VEN","minor",200212],
[1246093273,"Oulu","Oulu","Finland","FIN","admin",200526],
[1004622920,"Maīmanah","Maimanah","Afghanistan","AFG","admin",199795],
[1840020654,"Frisco","Frisco","United States","USA","",200490],
[1608697923,"Kabankalan","Kabankalan","Philippines","PHL","",200198],
[1032715964,"Isidro Casanova","Isidro Casanova","Argentina","ARG","",190696],
[1840003478,"Yonkers","Yonkers","United States","USA","",200370],
[1076411428,"Rio Claro","Rio Claro","Brazil","BRA","",199961],
[1840004828,"Norwich","Norwich","United States","USA","",200289],
[1356067648,"Bulandshahr","Bulandshahr","India","IND","",198612],
[1434421178,"Az Zāwīyah","Az Zawiyah","Libya","LBY","admin",200000],
[1894305215,"Kasama","Kasama","Zambia","ZMB","admin",200000],
[1340000062,"Puerto Cortés","Puerto Cortes","Honduras","HND","",200000],
[1504325928,"Kouribga","Kouribga","Morocco","MAR","",196196],
[1458472057,"Lahad Datu","Lahad Datu","Malaysia","MYS","",199830],
[1364981174,"Bojnūrd","Bojnurd","Iran","IRN","admin",199791],
[1826688051,"Norwich","Norwich","United Kingdom","GBR","",195971],
[1356612685,"Baharampur","Baharampur","India","IND","",195223],
[1056513284,"Liège","Liege","Belgium","BEL","minor",196623],
[1070859064,"Banja Luka","Banja Luka","Bosnia And Herzegovina","BIH","admin",199191],
[1840020483,"Glendale","Glendale","United States","USA","",199303],
[1840020578,"Huntington Beach","Huntington Beach","United States","USA","",199223],
[1380707445,"Taranto","Taranto","Italy","ITA","minor",198283],
[1156077330,"Zhugang","Zhugang","China","CHN","minor",197400],
[1360139854,"Martapura","Martapura","Indonesia","IDN","minor",198239],
[1356082013,"Chakradharpur","Chakradharpur","India","IND","",197953],
[1862659974,"Tocuyito","Tocuyito","Venezuela","VEN","minor",197446],
[1076999998,"Alvorada","Alvorada","Brazil","BRA","",195673],
[1840015072,"Deltona","Deltona","United States","USA","",198361],
[1124121940,"Richmond","Richmond","Canada","CAN","",198309],
[1376222772,"Holon","Holon","Israel","ISR","",188834],
[1724663253,"Alcalá de Henares","Alcala de Henares","Spain","ESP","",195982],
[1180000163,"Gemena","Gemena","Congo (Kinshasa)","COD","admin",198056],
[1642066626,"Oradea","Oradea","Romania","ROU","admin",196367],
[1156369451,"Helong","Helong","China","CHN","minor",197885],
[1504131639,"Béni Mellal","Beni Mellal","Morocco","MAR","admin",192676],
[1356501701,"Madhyamgram","Madhyamgram","India","IND","",196127],
[1840007034,"Aurora","Aurora","United States","USA","",197757],
[1356857493,"Burhānpur","Burhanpur","India","IND","",197233],
[1356007170,"Khammam","Khammam","India","IND","",196283],
[1356780092,"Bhiwāni","Bhiwani","India","IND","",197662],
[1392464732,"Higashi-Hiroshima","Higashi-Hiroshima","Japan","JPN","",197347],
[1604589102,"Huánuco","Huanuco","Peru","PER","admin",196627],
[1180474388,"Mbanza-Ngungu","Mbanza-Ngungu","Congo (Kinshasa)","COD","",197545],
[1404676289,"Eldoret","Eldoret","Kenya","KEN","admin",193830],
[1392686410,"Hino","Hino","Japan","JPN","",190598],
[1170798590,"Zipaquirá","Zipaquira","Colombia","COL","minor",196409],
[1076567920,"Rio Grande","Rio Grande","Brazil","BRA","",197228],
[1643653477,"Prokopyevsk","Prokopyevsk","Russia","RUS","",196406],
[1408449973,"Rajin","Rajin","North Korea","PRK","admin",196954],
[1724000348,"Fuenlabrada","Fuenlabrada","Spain","ESP","",192233],
[1356140914,"Ghāndīnagar","Ghandinagar","India","IND","admin",195891],
[1380432555,"Brescia","Brescia","Italy","ITA","minor",196745],
[1408227006,"Kusŏng","Kusong","North Korea","PRK","",196515],
[1818460403,"Sūhāj","Suhaj","Egypt","EGY","admin",193931],
[1862134462,"Acarigua","Acarigua","Venezuela","VEN","minor",195637],
[1356109548,"Hugli","Hugli","India","IND","",179931],
[1214233006,"San Pedro de Macorís","San Pedro de Macoris","Dominican Republic","DOM","admin",195307],
[1380655938,"Parma","Parma","Italy","ITA","minor",195687],
[1694780903,"Kenema","Kenema","Sierra Leone","SLE","admin",188463],
[1270953861,"Brikama","Brikama","The Gambia","GMB","admin",195136],
[1392913924,"Suzuka","Suzuka","Japan","JPN","",195250],
[1608000651,"Koronadal","Koronadal","Philippines","PHL","",195398],
[1484359683,"Cuautla","Cuautla","Mexico","MEX","minor",194786],
[1860285858,"Iskandar","Iskandar","Uzbekistan","UZB","",195633],
[1792525360,"Karaköprü","Karakopru","Turkey","TUR","minor",195552],
[1840021942,"Tempe","Tempe","United States","USA","",195805],
[1231359719,"Desē","Dese","Ethiopia","ETH","",187900],
[1608053818,"Tanauan","Tanauan","Philippines","PHL","",193936],
[1152155065,"La Serena","La Serena","Chile","CHL","admin",195382],
[1840003834,"Overland Park","Overland Park","United States","USA","",195494],
[1364483819,"Bandar-e Būshehr","Bandar-e Bushehr","Iran","IRN","admin",195222],
[1380751753,"Prato","Prato","Italy","ITA","minor",193325],
[1024883433,"Tchitato","Tchitato","Angola","AGO","",195136],
[1410960903,"Anseong","Anseong","South Korea","KOR","",194765],
[1643703767,"Yuzhno-Sakhalinsk","Yuzhno-Sakhalinsk","Russia","RUS","admin",194882],
[1124364273,"Richmond Hill","Richmond Hill","Canada","CAN","",195022],
[1484290575,"Chilpancingo","Chilpancingo","Mexico","MEX","admin",182387],
[1360408580,"Gorontalo","Gorontalo","Indonesia","IDN","admin",191897],
[1484185068,"Guanajuato","Guanajuato","Mexico","MEX","admin",194500],
[1826626144,"Peterborough","Peterborough","United Kingdom","GBR","",194000],
[1840020709,"Grand Prairie","Grand Prairie","United States","USA","",194543],
[1508396687,"Quelimane","Quelimane","Mozambique","MOZ","admin",192876],
[1012196375,"Tébessa","Tebessa","Algeria","DZA","admin",194461],
[1392500750,"Kumagaya","Kumagaya","Japan","JPN","",193190],
[1862404343,"San Fernando","San Fernando","Venezuela","VEN","admin",194274],
[1414182001,"Al Jahrā’","Al Jahra'","Kuwait","KWT","",194193],
[1356014528,"Mahbūbnagar","Mahbubnagar","India","IND","",190400],
[1032403831,"La Plata","La Plata","Argentina","ARG","admin",193144],
[1320451247,"San Juan Sacatepéquez","San Juan Sacatepequez","Guatemala","GTM","minor",193000],
[1392887215,"Yamaguchi","Yamaguchi","Japan","JPN","admin",193761],
[1458170112,"Muar","Muar","Malaysia","MYS","",191346],
[1332333795,"Cap-Haïtien","Cap-Haitien","Haiti","HTI","admin",190289],
[1124080468,"Oakville","Oakville","Canada","CAN","",193832],
[1840033833,"Sunrise Manor","Sunrise Manor","United States","USA","",193781],
[1032263200,"Godoy Cruz","Godoy Cruz","Argentina","ARG","minor",191299],
[1364530447,"Būkān","Bukan","Iran","IRN","minor",193501],
[1408642146,"Hyesan","Hyesan","North Korea","PRK","minor",192680],
[1616176351,"Kielce","Kielce","Poland","POL","admin",191605],
[1076630308,"Araçatuba","Aracatuba","Brazil","BRA","",192757],
[1076216938,"Castanhal","Castanhal","Brazil","BRA","",192571],
[1862645590,"Guanare","Guanare","Venezuela","VEN","admin",192644],
[1840022140,"Waco","Waco","United States","USA","",192315],
[1826481004,"Basildon","Basildon","United Kingdom","GBR","",185900],
[1792504666,"Beylikdüzü","Beylikduzu","Turkey","TUR","",185633],
[1724900225,"Leganés","Leganes","Spain","ESP","",187762],
[1360921516,"Madiun","Madiun","Indonesia","IDN","",186099],
[1608815735,"General Mariano Alvarez","General Mariano Alvarez","Philippines","PHL","",172433],
[1608943172,"Bago","Bago","Philippines","PHL","",191210],
[1862735261,"Valera","Valera","Venezuela","VEN","minor",191167],
[1826769743,"Bournemouth","Bournemouth","United Kingdom","GBR","",187503],
[1360084806,"Pasuruan","Pasuruan","Indonesia","IDN","",186262],
[1643809754,"Armavir","Armavir","Russia","RUS","",190709],
[1180134137,"Mwene-Ditu","Mwene-Ditu","Congo (Kinshasa)","COD","",189177],
[1643480033,"Balakovo","Balakovo","Russia","RUS","",191260],
[1724910555,"Donostia","Donostia","Spain","ESP","minor",188102],
[1792696058,"Aydın","Aydin","Turkey","TUR","admin",191037],
[1360427259,"Batu","Batu","Indonesia","IDN","",190184],
[1704714941,"Sơn Tây","Son Tay","Vietnam","VNM","minor",189547],
[1392081830,"Anjōmachi","Anjomachi","Japan","JPN","",188801],
[1840021632,"Salinas","Salinas","United States","USA","",190972],
[1608859265,"Malaybalay","Malaybalay","Philippines","PHL","admin",190712],
[1076173995,"Ferraz de Vasconcelos","Ferraz de Vasconcelos","Brazil","BRA","",184700],
[1076199404,"Santa Bárbara d’Oeste","Santa Barbara d'Oeste","Brazil","BRA","",190139],
[1024017930,"Chibia","Chibia","Angola","AGO","",190670],
[1392003516,"Odawara","Odawara","Japan","JPN","",189038],
[1392003372,"Kishiwada","Kishiwada","Japan","JPN","",188015],
[1586378758,"Saddiqabad","Saddiqabad","Pakistan","PAK","",189876],
[1643113701,"Rybinsk","Rybinsk","Russia","RUS","",190429],
[1408650871,"Chŏngju","Chongju","North Korea","PRK","",189742],
[1076536175,"Cachoeiro de Itapemirim","Cachoeiro de Itapemirim","Brazil","BRA","",189889],
[1356671879,"Nandyāl","Nandyal","India","IND","",188654],
[1276389303,"Hagen","Hagen","Germany","DEU","minor",188687],
[1068933987,"Potosí","Potosi","Bolivia","BOL","admin",189652],
[1120011020,"Ngaoundéré","Ngaoundere","Cameroon","CMR","admin",189800],
[1764165203,"Pak Kret","Pak Kret","Thailand","THA","minor",184501],
[1840004851,"Waterbury","Waterbury","United States","USA","",189614],
[1204807468,"Parakou","Parakou","Benin","BEN","admin",188853],
[1156975773,"Donghua","Donghua","China","CHN","minor",189333],
[1716060405,"Mutare","Mutare","Zimbabwe","ZWE","admin",188243],
[1050904616,"Narsingdi","Narsingdi","Bangladesh","BGD","",185128],
[1620949401,"Braga","Braga","Portugal","PRT","admin",181494],
[1862226710,"Araure","Araure","Venezuela","VEN","minor",188800],
[1608635653,"Digos","Digos","Philippines","PHL","admin",188376],
[1192216820,"Pinar del Río","Pinar del Rio","Cuba","CUB","admin",188614],
[1840014421,"Clarksville","Clarksville","United States","USA","",188746],
[1392003112,"Numazu","Numazu","Japan","JPN","",187653],
[1356159126,"Rāiganj","Raiganj","India","IND","",183612],
[1792683478,"Selçuklu","Selcuklu","Turkey","TUR","minor",188224],
[1392042507,"Tachikawa","Tachikawa","Japan","JPN","",181115],
[1360148993,"Prabumulih","Prabumulih","Indonesia","IDN","minor",188082],
[1076039737,"Angra dos Reis","Angra dos Reis","Brazil","BRA","",188276],
[1214710545,"San Francisco de Macorís","San Francisco de Macoris","Dominican Republic","DOM","admin",188118],
[1076577102,"Sobral","Sobral","Brazil","BRA","",188233],
[1156080077,"Xiashi","Xiashi","China","CHN","minor",187300],
[1246456609,"Turku","Turku","Finland","FIN","admin",187604],
[1862199442,"Guatire","Guatire","Venezuela","VEN","minor",187262],
[1152234625,"Iquique","Iquique","Chile","CHL","admin",188003],
[1504000319,"Laâyoune","Laayoune","Morocco","MAR","",188084],
[1840000471,"Cedar Rapids","Cedar Rapids","United States","USA","",188038],
[1392307565,"Kōfu","Kofu","Japan","JPN","admin",187144],
[1862530883,"San Diego","San Diego","Venezuela","VEN","minor",187215],
[1434507846,"Gharyān","Gharyan","Libya","LBY","admin",187854],
[1356768708,"Bārākpur","Barakpur","India","IND","",152783],
[1392416969,"Tottori","Tottori","Japan","JPN","",187323],
[1408001232,"Chaedŏk","Chaedok","North Korea","PRK","",187270],
[1392040772,"Jōetsu","Joetsu","Japan","JPN","",187291],
[1840002648,"Sioux Falls","Sioux Falls","United States","USA","",187239],
[1608088739,"Calbayog City","Calbayog City","Philippines","PHL","",186960],
[1792744270,"Sultanbeyli","Sultanbeyli","Turkey","TUR","",175700],
[1788844707,"Kairouan","Kairouan","Tunisia","TUN","admin",186653],
[1076449553,"Cabo Frio","Cabo Frio","Brazil","BRA","",186227],
[1729244380,"Shendi","Shendi","Sudan","SDN","",186611],
[1792910994,"Kayapınar","Kayapinar","Turkey","TUR","minor",185626],
[1818787044,"Shibīn al Kawm","Shibin al Kawm","Egypt","EGY","admin",177112],
[1729684147,"Ed Damazin","Ed Damazin","Sudan","SDN","admin",186051],
[1762372787,"Khŭjand","Khujand","Tajikistan","TJK","admin",181600],
[1250608730,"Reims","Reims","France","FRA","minor",182211],
[1156068377,"Dunhuang","Dunhuang","China","CHN","",186027],
[1840006211,"Huntington","Huntington","United States","USA","",186034],
[1356719082,"Mahesāna","Mahesana","India","IND","",184991],
[1380306270,"Modena","Modena","Italy","ITA","minor",185273],
[1410478813,"Guri","Guri","South Korea","KOR","",180063],
[1724750196,"Getafe","Getafe","Spain","ESP","",183095],
[1706288768,"Jamaame","Jamaame","Somalia","SOM","",185270],
[1528921549,"Breda","Breda","Netherlands","NLD","minor",183873],
[1756731313,"Basel","Basel","Switzerland","CHE","admin",177827],
[1364417512,"Semnān","Semnan","Iran","IRN","admin",185129],
[1398081646,"Temirtaū","Temirtau","Kazakhstan","KAZ","",185082],
[1392297078,"Toyokawa","Toyokawa","Japan","JPN","",183965],
[1076763340,"Passo Fundo","Passo Fundo","Brazil","BRA","",184826],
[1728607274,"Yei","Yei","South Sudan","SSD","",185000],
[1840020410,"Ontario","Ontario","United States","USA","",185010],
[1156305822,"Luzhang","Luzhang","China","CHN","minor",184835],
[1760560461,"Al Qāmishlī","Al Qamishli","Syria","SYR","minor",184231],
[1840005613,"Hagerstown","Hagerstown","United States","USA","",184755],
[1364967800,"Fardīs","Fardis","Iran","IRN","",181174],
[1392003401,"Chūō-ku","Chuo-ku","Japan","JPN","",169995],
[1840000478,"Erie","Erie","United States","USA","",184484],
[1840021189,"Vancouver","Vancouver","United States","USA","",184463],
[1840020041,"Nampa","Nampa","United States","USA","",184428],
[1036870987,"Geelong","Geelong","Australia","AUS","",184182],
[1450070223,"Fianarantsoa","Fianarantsoa","Madagascar","MDG","admin",184184],
[1360289512,"Banjar","Banjar","Indonesia","IDN","minor",182819],
[1324494896,"Siguiri","Siguiri","Guinea","GIN","minor",183875],
[1643427671,"Severodvinsk","Severodvinsk","Russia","RUS","",183996],
[1356786750,"Batāla","Batala","India","IND","",183314],
[1616879570,"Rzeszów","Rzeszow","Poland","POL","admin",182548],
[1356338789,"Bhusāval","Bhusaval","India","IND","",183001],
[1076348188,"Itajaí","Itajai","Brazil","BRA","",183373],
[1578633461,"Trondheim","Trondheim","Norway","NOR","minor",183378],
[1024514740,"Cuango","Cuango","Angola","AGO","",183767],
[1398046759,"Aqtaū","Aqtau","Kazakhstan","KAZ","admin",183350],
[1688661068,"Niš","Nis","Serbia","SRB","admin",183164],
[1356833304,"Bahraigh","Bahraigh","India","IND","",182218],
[1392933042,"Narashino","Narashino","Japan","JPN","",174990],
[1643946203,"Abakan","Abakan","Russia","RUS","admin",181709],
[1124955083,"Burlington","Burlington","Canada","CAN","",183314],
[1276395100,"Potsdam","Potsdam","Germany","DEU","admin",182112],
[1360941841,"Pinrang","Pinrang","Indonesia","IDN","minor",182731],
[1608265953,"Sorsogon","Sorsogon","Philippines","PHL","admin",182237],
[1076544482,"Dourados","Dourados","Brazil","BRA","",182747],
[1840015482,"Spartanburg","Spartanburg","United States","USA","",182701],
[1792895883,"Meram","Meram","Turkey","TUR","minor",182444],
[1642286806,"Brăila","Braila","Romania","ROU","admin",180302],
[1840013468,"Gastonia","Gastonia","United States","USA","",182581],
[1620896557,"Amadora","Amadora","Portugal","PRT","minor",175136],
[1840014236,"Fort Lauderdale","Fort Lauderdale","United States","USA","",182437],
[1392148678,"Uji","Uji","Japan","JPN","",179626],
[1076922983,"Nova Friburgo","Nova Friburgo","Brazil","BRA","",182082],
[1356991408,"Tonk","Tonk","India","IND","",181734],
[1380630212,"Reggio di Calabria","Reggio di Calabria","Italy","ITA","minor",181447],
[1032535314,"Berazategui","Berazategui","Argentina","ARG","minor",180523],
[1364186788,"Khowy","Khowy","Iran","IRN","minor",182000],
[1356966764,"Sirsa","Sirsa","India","IND","",181639],
[1050628940,"Tāngāil","Tangail","Bangladesh","BGD","",180144],
[1356646586,"Jaunpur","Jaunpur","India","IND","",180362],
[1170184135,"Dosquebradas","Dosquebradas","Colombia","COL","minor",179301],
[1826149980,"York","York","United Kingdom","GBR","",181131],
[1643129247,"Petropavlovsk-Kamchatskiy","Petropavlovsk-Kamchatskiy","Russia","RUS","admin",181216],
[1704094609,"Phan Rang-Tháp Chàm","Phan Rang-Thap Cham","Vietnam","VNM","admin",179773],
[1566461573,"Epe","Epe","Nigeria","NGA","minor",181409],
[1104269305,"Sittwe","Sittwe","Myanmar","MMR","admin",181000],
[1356051452,"Dam Dam","Dam Dam","India","IND","",114786],
[1231214366,"Jīma","Jima","Ethiopia","ETH","",177900],
[1360418625,"Lhokseumawe","Lhokseumawe","Indonesia","IDN","",180200],
[1608344583,"Roxas City","Roxas City","Philippines","PHL","admin",179292],
[1566877863,"Funtua","Funtua","Nigeria","NGA","minor",180475],
[1170426476,"Turbo","Turbo","Colombia","COL","minor",181000],
[1104524588,"Hinthada","Hinthada","Myanmar","MMR","",180728],
[1032864257,"La Rioja","La Rioja","Argentina","ARG","admin",180995],
[1356232508,"Madanapalle","Madanapalle","India","IND","",180180],
[1360740288,"Palopo","Palopo","Indonesia","IDN","",180130],
[1604300430,"Ayacucho","Ayacucho","Peru","PER","admin",180766],
[1288615192,"Obuase","Obuase","Ghana","GHA","",180460],
[1528136727,"Nijmegen","Nijmegen","Netherlands","NLD","minor",177659],
[1484573106,"San Luis Río Colorado","San Luis Rio Colorado","Mexico","MEX","minor",176685],
[1356293762,"Alleppey","Alleppey","India","IND","",176783],
[1180611452,"Boma","Boma","Congo (Kinshasa)","COD","",178638],
[1012785868,"Tiaret","Tiaret","Algeria","DZA","admin",178915],
[1422316734,"Tyre","Tyre","Lebanon","LBN","minor",160000],
[1276419711,"Saarbrücken","Saarbrucken","Germany","DEU","admin",179349],
[1360967092,"Purwakarta","Purwakarta","Indonesia","IDN","minor",179233],
[1156772152,"Longjing","Longjing","China","CHN","minor",180307],
[1191440208,"Split","Split","Croatia","HRV","admin",178102],
[1076021121,"Ilhéus","Ilheus","Brazil","BRA","",180213],
[1250541629,"Toulon","Toulon","France","FRA","minor",176198],
[1710416691,"Klerksdorp","Klerksdorp","South Africa","ZAF","",178921],
[1840000644,"Lorain","Lorain","United States","USA","",180279],
[1076686083,"Barra Mansa","Barra Mansa","Brazil","BRA","",179915],
[1156480258,"Tongjiang","Tongjiang","China","CHN","minor",180000],
[1840014495,"Murfreesboro","Murfreesboro","United States","USA","",179951],
[1840014479,"High Point","High Point","United States","USA","",179913],
[1276808737,"Hamm","Hamm","Germany","DEU","minor",178967],
[1384831436,"Divo","Divo","Côte d'Ivoire","CIV","minor",179455],
[1068356085,"Tarija","Tarija","Bolivia","BOL","admin",179528],
[1818291145,"Al ‘Arīsh","Al `Arish","Egypt","EGY","admin",178651],
[1156383681,"Guli","Guli","China","CHN","",178900],
[1392003082,"Urayasu","Urayasu","Japan","JPN","",169749],
[1566468363,"Bida","Bida","Nigeria","NGA","minor",173849],
[1616311376,"Gliwice","Gliwice","Poland","POL","minor",178186],
[1604588759,"Paita","Paita","Peru","PER","",179346],
[1158126203,"Bade","Bade","Taiwan","TWN","",172065],
[1840003862,"Newport News","Newport News","United States","USA","",179225],
[1036500020,"Townsville","Townsville","Australia","AUS","",178649],
[1360337304,"Langsa","Langsa","Indonesia","IDN","",178334],
[1608530964,"Dagupan City","Dagupan City","Philippines","PHL","admin",174302],
[1484709570,"Teziutlan","Teziutlan","Mexico","MEX","",177796],
[1512995148,"Şalālah","Salalah","Oman","OMN","admin",178469],
[1360271289,"Salatiga","Salatiga","Indonesia","IDN","",175288],
[1620049442,"Matosinhos","Matosinhos","Portugal","PRT","minor",175478],
[1554873040,"Hamilton","Hamilton","New Zealand","NZL","admin",176500],
[1364897698,"Bīrjand","Birjand","Iran","IRN","admin",178020],
[1156181740,"Lin’an","Lin'an","China","CHN","minor",177303],
[1484980825,"Chicoloapan","Chicoloapan","Mexico","MEX","minor",175053],
[1356977661,"Vellore","Vellore","India","IND","",177081],
[1012140298,"Bejaïa","Bejaia","Algeria","DZA","admin",176139],
[1840020411,"Rancho Cucamonga","Rancho Cucamonga","United States","USA","",177603],
[1643832764,"Norilsk","Norilsk","Russia","RUS","",177428],
[1356590173,"Titāgarh","Titagarh","India","IND","",116541],
[1076881156,"Nossa Senhora do Socorro","Nossa Senhora do Socorro","Brazil","BRA","",177344],
[1112421165,"Baranavichy","Baranavichy","Belarus","BLR","minor",174183],
[1484127851,"Santa María Texmelucan","Santa Maria Texmelucan","Mexico","MEX","",175518],
[1392220561,"Kamakurayama","Kamakurayama","Japan","JPN","",172929],
[1840020550,"Hemet","Hemet","United States","USA","",177253],
[1158247880,"Yangmei","Yangmei","Taiwan","TWN","",175000],
[1332587854,"Les Cayes","Les Cayes","Haiti","HTI","admin",175457],
[1484904610,"Ciudad Valles","Ciudad Valles","Mexico","MEX","minor",177022],
[1724247413,"Santander","Santander","Spain","ESP","admin",172221],
[1729757472,"Kadugli","Kadugli","Sudan","SDN","admin",176931],
[1300458367,"Piraeus","Piraeus","Greece","GRC","minor",163688],
[1076355611,"Linhares","Linhares","Brazil","BRA","",176688],
[1484192447,"Ciudad del Carmen","Ciudad del Carmen","Mexico","MEX","minor",169466],
[1104882792,"Letpandan","Letpandan","Myanmar","MMR","",176571],
[1616784915,"Zabrze","Zabrze","Poland","POL","minor",174349],
[1620388276,"Almada","Almada","Portugal","PRT","minor",174030],
[1203402469,"Plzeň","Plzen","Czechia","CZE","admin",175219],
[1686542859,"Saint-Louis","Saint-Louis","Senegal","SEN","admin",176000],
[1076844683,"Rio Verde","Rio Verde","Brazil","BRA","",176424],
[1840021579,"Santa Cruz","Santa Cruz","United States","USA","",176428],
[1504134516,"Ait Melloul","Ait Melloul","Morocco","MAR","",171847],
[1484955658,"Comitán","Comitan","Mexico","MEX","minor",170000],
[1840004837,"Danbury","Danbury","United States","USA","",176030],
[1840020567,"Peoria","Peoria","United States","USA","",175961],
[1643411150,"Orekhovo-Borisovo Yuzhnoye","Orekhovo-Borisovo Yuzhnoye","Russia","RUS","",147713],
[1620375757,"Oeiras","Oeiras","Portugal","PRT","minor",172120],
[1024821574,"Catumbela","Catumbela","Angola","AGO","",175805],
[1792160689,"Ereğli","Eregli","Turkey","TUR","minor",175605],
[1840020623,"Oceanside","Oceanside","United States","USA","",175742],
[1231785978,"Harar","Harar","Ethiopia","ETH","admin",174994],
[1724993285,"Burgos","Burgos","Spain","ESP","minor",174051],
[1004805783,"Shibirghān","Shibirghan","Afghanistan","AFG","admin",175599],
[1356174802,"Chandannagar","Chandannagar","India","IND","",166867],
[1616383275,"Olsztyn","Olsztyn","Poland","POL","admin",173599],
[1356544008,"Cuddalore","Cuddalore","India","IND","",173676],
[1484759605,"Lagos de Moreno","Lagos de Moreno","Mexico","MEX","minor",164981],
[1364532780,"Marāgheh","Maragheh","Iran","IRN","minor",175255],
[1360386781,"Tebingtinggi","Tebingtinggi","Indonesia","IDN","",169786],
[1724318578,"Alcorcón","Alcorcon","Spain","ESP","",170817],
[1250000540,"Saint-Étienne","Saint-Etienne","France","FRA","minor",173089],
[1484338031,"Chetumal","Chetumal","Mexico","MEX","admin",169028],
[1364204506,"Sīrjān","Sirjan","Iran","IRN","minor",175000],
[1608191667,"Mexico","Mexico","Philippines","PHL","",173403],
[1276912330,"Ludwigshafen","Ludwigshafen","Germany","DEU","minor",172557],
[1840020245,"Elk Grove","Elk Grove","United States","USA","",174775],
[1643711617,"Syzran","Syzran","Russia","RUS","",173260],
[1862777685,"Carúpano","Carupano","Venezuela","VEN","minor",173877],
[1608215915,"Lubao","Lubao","Philippines","PHL","",173502],
[1076073549,"Luziânia","Luziania","Brazil","BRA","",174531],
[1558654236,"León","Leon","Nicaragua","NIC","admin",174051],
[1356100300,"Chīrāla","Chirala","India","IND","",172826],
[1484871648,"San Andrés Tuxtla","San Andres Tuxtla","Mexico","MEX","minor",164834],
[1792933981,"Eskişehir","Eskisehir","Turkey","TUR","admin",173882],
[1724579885,"Castellón de la Plana","Castellon de la Plana","Spain","ESP","minor",172589],
[1156753422,"Tiantoujiao","Tiantoujiao","China","CHN","",166774],
[1616302636,"Bielsko-Biała","Bielsko-Biala","Poland","POL","minor",172781],
[1484000400,"Piedras Negras","Piedras Negras","Mexico","MEX","minor",173959],
[1818596265,"Banhā","Banha","Egypt","EGY","admin",157701],
[1792340207,"Osmaniye","Osmaniye","Turkey","TUR","admin",173977],
[1616740907,"Bytom","Bytom","Poland","POL","minor",171515],
[1156357534,"Linjiang","Linjiang","China","CHN","minor",173903],
[1704379547,"Hạ Long","Ha Long","Vietnam","VNM","admin",172915],
[1356131438,"Deo","Deo","India","IND","",173216],
[1840015141,"Pembroke Pines","Pembroke Pines","United States","USA","",173591],
[1012978325,"Tlemcen","Tlemcen","Algeria","DZA","admin",173531],
[1392145167,"Hitachi","Hitachi","Japan","JPN","",172709],
[1180106925,"Kindu","Kindu","Congo (Kinshasa)","COD","admin",172321],
[1364921034,"Shāhīn Shahr","Shahin Shahr","Iran","IRN","minor",173329],
[1250775297,"Le Havre","Le Havre","France","FRA","minor",169733],
[1840021499,"Vallejo","Vallejo","United States","USA","",173256],
[1608490461,"Polomolok","Polomolok","Philippines","PHL","",172605],
[1360008480,"Banyuwangi","Banyuwangi","Indonesia","IDN","minor",172424],
[1724000069,"Albacete","Albacete","Spain","ESP","minor",172722],
[1356933453,"Bīdar","Bidar","India","IND","",172298],
[1608046677,"San Miguel","San Miguel","Philippines","PHL","",172073],
[1214863528,"Moca","Moca","Dominican Republic","DOM","minor",172294],
[1276676856,"Mülheim","Mulheim","Germany","DEU","minor",170921],
[1068288609,"Sacaba","Sacaba","Bolivia","BOL","",172466],
[1380487033,"Reggio Emilia","Reggio Emilia","Italy","ITA","minor",171944],
[1124340223,"Barrie","Barrie","Canada","CAN","",172657],
[1643674336,"Krasnogorsk","Krasnogorsk","Russia","RUS","",171793],
[1686256343,"Kaolack","Kaolack","Senegal","SEN","admin",172305],
[1392299364,"Izumo","Izumo","Japan","JPN","",171995],
[1608703693,"Baliuag","Baliuag","Philippines","PHL","",168470],
[1392772700,"Niiza","Niiza","Japan","JPN","",164653],
[1608611556,"Surigao","Surigao","Philippines","PHL","admin",171107],
[1076808330,"Francisco Morato","Francisco Morato","Brazil","BRA","",168243],
[1840020577,"Garden Grove","Garden Grove","United States","USA","",171644],
[1643784914,"Volgodonsk","Volgodonsk","Russia","RUS","",171471],
[1484365643,"Cuauhtémoc","Cuauhtemoc","Mexico","MEX","minor",168482],
[1586349992,"Kohat","Kohat","Pakistan","PAK","minor",170800],
[1566873994,"Makurdi","Makurdi","Nigeria","NGA","admin",170925],
[1643640451,"Kamensk-Ural’skiy","Kamensk-Ural'skiy","Russia","RUS","",169929],
[1840033827,"Enterprise","Enterprise","United States","USA","",171108],
[1218739896,"Loja","Loja","Ecuador","ECU","admin",170280],
[1840020076,"Medford","Medford","United States","USA","",170876],
[1324336588,"N’Zérékoré","N'Zerekore","Guinea","GIN","admin",168121],
[1643001263,"Ussuriysk","Ussuriysk","Russia","RUS","",170660],
[1392611314,"Sakura","Sakura","Japan","JPN","",169059],
[1608682956,"Concepcion","Concepcion","Philippines","PHL","",169953],
[1180205443,"Uvira","Uvira","Congo (Kinshasa)","COD","",170391],
[1392999977,"Tomakomai","Tomakomai","Japan","JPN","",170223],
[1388926551,"Portmore","Portmore","Jamaica","JAM","",170000],
[1356067784,"Machilīpatnam","Machilipatnam","India","IND","",169892],
[1012016677,"Bordj Bou Arreridj","Bordj Bou Arreridj","Algeria","DZA","admin",168346],
[1364030346,"Malāyer","Malayer","Iran","IRN","minor",170237],
[1840016196,"Cary","Cary","United States","USA","",170282],
[1458692921,"Kluang","Kluang","Malaysia","MYS","",169828],
[1643990727,"Novocherkassk","Novocherkassk","Russia","RUS","",168766],
[1788442482,"Métouia","Metouia","Tunisia","TUN","",170000],
[1392425838,"Nishio","Nishio","Japan","JPN","",168992],
[1840019789,"Marysville","Marysville","United States","USA","",170009],
[1032547434,"San Luis","San Luis","Argentina","ARG","admin",169947],
[1152443957,"Puerto Montt","Puerto Montt","Chile","CHL","admin",169736],
[1840019305,"Corona","Corona","United States","USA","",169868],
[1356432910,"Medinīpur","Medinipur","India","IND","",169264],
[1276946953,"Oldenburg","Oldenburg","Germany","DEU","minor",168210],
[1156317766,"Fenglu","Fenglu","China","CHN","minor",169366],
[1434742923,"Al Marj","Al Marj","Libya","LBY","admin",169540],
[1410171679,"Sŏsan","Sosan","South Korea","KOR","",169221],
[1840015067,"Ocala","Ocala","United States","USA","",169383],
[1752953686,"Uppsala","Uppsala","Sweden","SWE","admin",165456],
[1620506259,"Gondomar","Gondomar","Portugal","PRT","minor",168027],
[1050233680,"Jamālpur","Jamalpur","Bangladesh","BGD","",167900],
[1862408122,"Santa Rita","Santa Rita","Venezuela","VEN","minor",169158],
[1826261547,"Warrington","Warrington","United Kingdom","GBR","",165456],
[1356671176,"Bāramūla","Baramula","India","IND","",167986],
[1840003845,"Fredericksburg","Fredericksburg","United States","USA","",168909],
[1392122083,"Oyama","Oyama","Japan","JPN","",167874],
[1218046148,"Ambato","Ambato","Ecuador","ECU","admin",165185],
[1408445793,"Hŭich’ŏn","Huich'on","North Korea","PRK","",168180],
[1364192213,"Mahābād","Mahabad","Iran","IRN","",168393],
[1076163359,"Itapecerica da Serra","Itapecerica da Serra","Brazil","BRA","",167236],
[1076527920,"São Caetano do Sul","Sao Caetano do Sul","Brazil","BRA","",158024],
[1710326039,"Rustenburg","Rustenburg","South Africa","ZAF","",165976],
[1156260069,"Basuo","Basuo","China","CHN","minor",167636],
[1643000102,"Zlatoust","Zlatoust","Russia","RUS","",167978],
[1528822178,"Haarlem","Haarlem","Netherlands","NLD","admin",162902],
[1300201099,"Pátra","Patra","Greece","GRC","admin",167446],
[1170903069,"Ríohacha","Riohacha","Colombia","COL","admin",167865],
[1024321158,"Catape","Catape","Angola","AGO","",167820],
[1608110634,"Tuguegarao","Tuguegarao","Philippines","PHL","admin",166334],
[1076415327,"Guarapuava","Guarapuava","Brazil","BRA","",167328],
[1840013612,"Gainesville","Gainesville","United States","USA","",167371],
[1076622789,"Itu","Itu","Brazil","BRA","",167095],
[1356059135,"Fatehpur","Fatehpur","India","IND","",166480],
[1368929021,"Al Kūfah","Al Kufah","Iraq","IRQ","minor",166100],
[1144308408,"Kandy","Kandy","Sri Lanka","LKA","admin",161000],
[1704544061,"Hà Tĩnh","Ha Tinh","Vietnam","VNM","admin",165396],
[1710282622,"Kimberley","Kimberley","South Africa","ZAF","admin",165264],
[1356831482,"Tenāli","Tenali","India","IND","",164937],
[1392088261,"Iwata","Iwata","Japan","JPN","",165688],
[1706091701,"Kismaayo","Kismaayo","Somalia","SOM","admin",166667],
[1792102607,"Edirne","Edirne","Turkey","TUR","admin",166494],
[1392754231,"Takaoka","Takaoka","Japan","JPN","",165880],
[1504811178,"Nador","Nador","Morocco","MAR","",161726],
[1012619903,"Skikda","Skikda","Algeria","DZA","admin",163318],
[1156287095,"Kuytun","Kuytun","China","CHN","minor",166261],
[1250071647,"Grenoble","Grenoble","France","FRA","minor",157650],
[1276554949,"Osnabrück","Osnabruck","Germany","DEU","minor",164748],
[1380939013,"Perugia","Perugia","Italy","ITA","admin",165683],
[1484001709,"Jiutepec","Jiutepec","Mexico","MEX","minor",162427],
[1356145399,"Udipi","Udipi","India","IND","",165401],
[1124541904,"Oshawa","Oshawa","Canada","CAN","",166000],
[1440897790,"Klaipėda","Klaipeda","Lithuania","LTU","admin",164310],
[1360992709,"Tanjungbalai","Tanjungbalai","Indonesia","IDN","",165763],
[1392003095,"Obihiro","Obihiro","Japan","JPN","",165684],
[1608454598,"Midsayap","Midsayap","Philippines","PHL","",165376],
[1276002465,"Leverkusen","Leverkusen","Germany","DEU","minor",163838],
[1392003173,"Hadano","Hadano","Japan","JPN","",164292],
[1392003151,"Kushiro","Kushiro","Japan","JPN","",165699],
[1760305230,"Idlib","Idlib","Syria","SYR","admin",165000],
[1356838415,"Sitalpur","Sitalpur","India","IND","",164435],
[1012371820,"Béchar","Bechar","Algeria","DZA","admin",165627],
[1356148941,"Conjeeveram","Conjeeveram","India","IND","",164384],
[1356025913,"Proddatūr","Proddatur","India","IND","",163970],
[1192020054,"Cienfuegos","Cienfuegos","Cuba","CUB","admin",164924],
[1364098155,"Saqqez","Saqqez","Iran","IRN","minor",165258],
[1156184947,"Zhanlicun","Zhanlicun","China","CHN","",161439],
[1156761099,"Fukang","Fukang","China","CHN","minor",165006],
[1608218990,"Pikit","Pikit","Philippines","PHL","",164646],
[1376357911,"Ramat Gan","Ramat Gan","Israel","ISR","",152596],
[1710672530,"Bhisho","Bhisho","South Africa","ZAF","admin",160997],
[1398398278,"Türkistan","Turkistan","Kazakhstan","KAZ","admin",164746],
[1826672445,"Huddersfield","Huddersfield","United Kingdom","GBR","",162949],
[1024922883,"Bocoio","Bocoio","Angola","AGO","",164685],
[1152082093,"Chillán","Chillan","Chile","CHL","admin",164270],
[1414456826,"Abū Ḩulayfah","Abu Hulayfah","Kuwait","KWT","",164212],
[1208194249,"Odense","Odense","Denmark","DNK","minor",158222],
[1586205456,"Muridke","Muridke","Pakistan","PAK","",163268],
[1288205885,"Tema","Tema","Ghana","GHA","",161612],
[1360659228,"Metro","Metro","Indonesia","IDN","",161799],
[1036244388,"Ipswich","Ipswich","Australia","AUS","",163000],
[1076425970,"Itapetininga","Itapetininga","Brazil","BRA","",157016],
[1104162015,"Myingyan","Myingyan","Myanmar","MMR","",163812],
[1024007950,"Quibala","Quibala","Angola","AGO","",163991],
[1076000296,"Teresópolis","Teresopolis","Brazil","BRA","",163746],
[1484828397,"Ciudad Acuña","Ciudad Acuna","Mexico","MEX","minor",160225],
[1410780187,"Pocheon","Pocheon","South Korea","KOR","minor",163388],
[1356120513,"Navsāri","Navsari","India","IND","",163000],
[1076976057,"São José de Ribamar","Sao Jose de Ribamar","Brazil","BRA","",163045],
[1728877501,"Wau","Wau","South Sudan","SSD","admin",163442],
[1392198814,"Ube","Ube","Japan","JPN","",162873],
[1586492401,"Muzaffargarh","Muzaffargarh","Pakistan","PAK","minor",163268],
[1788285135,"Kebili","Kebili","Tunisia","TUN","admin",163257],
[1860218891,"Jizzax","Jizzax","Uzbekistan","UZB","admin",163200],
[1156008347,"Simao","Simao","China","CHN","minor",162725],
[1484481265,"San Martin Texmelucan de Labastida","San Martin Texmelucan de Labastida","Mexico","MEX","minor",152051],
[1070000220,"Mostar","Mostar","Bosnia And Herzegovina","BIH","minor",163067],
[1608196842,"Naic","Naic","Philippines","PHL","",160987],
[1729642412,"El Geneina","El Geneina","Sudan","SDN","admin",162981],
[1156036643,"Jinggang","Jinggang","China","CHN","",161343],
[1364956793,"Bandar-e Māhshahr","Bandar-e Mahshahr","Iran","IRN","minor",162797],
[1840002983,"Manchester","Manchester","United States","USA","",162877],
[1356386046,"Godhra","Godhra","India","IND","",161925],
[1862074247,"Anaco","Anaco","Venezuela","VEN","minor",162704],
[1604666111,"Sullana","Sullana","Peru","PER","",162434],
[1392003488,"Musashino","Musashino","Japan","JPN","",148971],
[1826869043,"Reading","Reading","United Kingdom","GBR","",162666],
[1688453076,"Zemun","Zemun","Serbia","SRB","minor",161596],
[1608396060,"Sariaya","Sariaya","Philippines","PHL","",161868],
[1484448356,"Tuxtepec","Tuxtepec","Mexico","MEX","",162511],
[1320264119,"Jutiapa","Jutiapa","Guatemala","GTM","admin",162312],
[1356639213,"Budaun","Budaun","India","IND","",161555],
[1356026391,"Chittoor","Chittoor","India","IND","",160722],
[1710880986,"Benoni","Benoni","South Africa","ZAF","",158777],
[1410095935,"Andong","Andong","South Korea","KOR","admin",162180],
[1368920164,"Ash Shaţrah","Ash Shatrah","Iraq","IRQ","minor",161949],
[1364354751,"Rafsanjān","Rafsanjan","Iran","IRN","minor",161909],
[1818666245,"Al Ghardaqah","Al Ghardaqah","Egypt","EGY","admin",160901],
[1360692406,"Bontang","Bontang","Indonesia","IDN","",161413],
[1484419416,"Tulancingo","Tulancingo","Mexico","MEX","minor",161069],
[1024645515,"Ndalatando","Ndalatando","Angola","AGO","admin",161584],
[1528057552,"Apeldoorn","Apeldoorn","Netherlands","NLD","minor",161156],
[1643790299,"Elektrostal","Elektrostal","Russia","RUS","",158508],
[1076558785,"Jequié","Jequie","Brazil","BRA","",161528],
[1704323043,"Đồng Hới","Dong Hoi","Vietnam","VNM","admin",160325],
[1356128689,"Krishnanagar","Krishnanagar","India","IND","",153062],
[1124559506,"Sherbrooke","Sherbrooke","Canada","CAN","",161323],
[1608883158,"Kidapawan","Kidapawan","Philippines","PHL","admin",160791],
[1032038706,"San Miguel","San Miguel","Argentina","ARG","",157532],
[1484844355,"Papantla de Olarte","Papantla de Olarte","Mexico","MEX","minor",161097],
[1887135215,"Dhamār","Dhamar","Yemen","YEM","admin",160114],
[1032337881,"José María Ezeiza","Jose Maria Ezeiza","Argentina","ARG","minor",160219],
[1826524208,"Southend","Southend","United Kingdom","GBR","",160257],
[1076368194,"Ibirité","Ibirite","Brazil","BRA","",158954],
[1276728190,"Solingen","Solingen","Germany","DEU","minor",159360],
[1156191514,"Tacheng","Tacheng","China","CHN","minor",161037],
[1250002615,"Villeurbanne","Villeurbanne","France","FRA","",150659],
[1630035622,"Bayamón","Bayamon","Puerto Rico","PRI","",161034],
[1076245528,"Bragança Paulista","Braganca Paulista","Brazil","BRA","",160665],
[1156000451,"Zhengding","Zhengding","China","CHN","",158599],
[1076937468,"Pindamonhangaba","Pindamonhangaba","Brazil","BRA","",160614],
[1528181808,"Enschede","Enschede","Netherlands","NLD","minor",159703],
[1170575968,"Girón","Giron","Colombia","COL","minor",160403],
[1250505606,"Dijon","Dijon","France","FRA","admin",156854],
[1004919977,"Khōst","Khost","Afghanistan","AFG","admin",160214],
[1854839075,"Koudougou","Koudougou","Burkina Faso","BFA","admin",160207],
[1276607395,"Darmstadt","Darmstadt","Germany","DEU","minor",159207],
[1332084366,"Saint-Marc","Saint-Marc","Haiti","HTI","",160181],
[1104364374,"Taunggyi","Taunggyi","Myanmar","MMR","admin",160115],
[1642996909,"Arad","Arad","Romania","ROU","admin",159074],
[1792911843,"Gaziantep","Gaziantep","Turkey","TUR","admin",160152],
[1586169401,"Khanpur","Khanpur","Pakistan","PAK","",160308],
[1604578883,"Huaycan","Huaycan","Peru","PER","",160000],
[1032067887,"San Nicolás de los Arroyos","San Nicolas de los Arroyos","Argentina","ARG","minor",160000],
[1276519742,"Heidelberg","Heidelberg","Germany","DEU","minor",158741],
[1392003484,"Miyakonojō","Miyakonojo","Japan","JPN","",159878],
[1608700526,"Pandi","Pandi","Philippines","PHL","",155115],
[1804461469,"Kramatorsk","Kramatorsk","Ukraine","UKR","",159445],
[1620870397,"Seixal","Seixal","Portugal","PRT","minor",158269],
[1380159305,"Livorno","Livorno","Italy","ITA","minor",158371],
[1364643377,"Shahr-e Kord","Shahr-e Kord","Iran","IRN","admin",159775],
[1398583266,"Ekibastuz","Ekibastuz","Kazakhstan","KAZ","",159760],
[1764161022,"Hat Yai","Hat Yai","Thailand","THA","minor",159130],
[1348655615,"Szeged","Szeged","Hungary","HUN","admin",159074],
[1032260908,"Catamarca","Catamarca","Argentina","ARG","admin",159139],
[1860343195,"Chirchiq","Chirchiq","Uzbekistan","UZB","",159400],
[1724625025,"La Laguna","La Laguna","Spain","ESP","",158010],
[1231737909,"Jijiga","Jijiga","Ethiopia","ETH","admin",159300],
[1840007239,"Champaign","Champaign","United States","USA","",159443],
[1840003837,"Alexandria","Alexandria","United States","USA","",159428],
[1710164136,"George","George","South Africa","ZAF","",157394],
[1276656117,"Herne","Herne","Germany","DEU","minor",156374],
[1380964180,"Ravenna","Ravenna","Italy","ITA","minor",159115],
[1392034645,"Higashimurayama","Higashimurayama","Japan","JPN","",150458],
[1840020293,"Hayward","Hayward","United States","USA","",159203],
[1356981799,"Bharūch","Bharuch","India","IND","",158253],
[1392727505,"Ōgaki","Ogaki","Japan","JPN","",158386],
[1356492911,"Saharsa","Saharsa","India","IND","",156540],
[1214279422,"Puerto Plata","Puerto Plata","Dominican Republic","DOM","minor",158756],
[1156745569,"Nan Zhuang","Nan Zhuang","China","CHN","",156902],
[1024929138,"Quipungo","Quipungo","Angola","AGO","",158918],
[1608224037,"Cadiz","Cadiz","Philippines","PHL","",158544],
[1704020910,"Châu Đốc","Chau Doc","Vietnam","VNM","",157298],
[1620771539,"Guimarães","Guimaraes","Portugal","PRT","minor",158124],
[1528206992,"Amersfoort","Amersfoort","Netherlands","NLD","minor",156286],
[1392893621,"Matsuzaka","Matsuzaka","Japan","JPN","",158472],
[1356141115,"Harīpur","Haripur","India","IND","",158142],
[1368265789,"Sāmarrā’","Samarra'","Iraq","IRQ","minor",158508],
[1484451215,"San Cristóbal","San Cristobal","Mexico","MEX","minor",158121],
[1840009517,"Springfield","Springfield","United States","USA","admin",158509],
[1608190610,"Ilagan","Ilagan","Philippines","PHL","admin",158218],
[1032812310,"Rafael Castillo","Rafael Castillo","Argentina","ARG","",147965],
[1792014004,"Konya","Konya","Turkey","TUR","admin",157934],
[1032552145,"Río Cuarto","Rio Cuarto","Argentina","ARG","minor",158298],
[1710495632,"Middelburg","Middelburg","South Africa","ZAF","",154706],
[1250962174,"Angers","Angers","France","FRA","minor",154508],
[1340079427,"Villanueva","Villanueva","Honduras","HND","",157615],
[1586904918,"Gojra","Gojra","Pakistan","PAK","",157863],
[1076918835,"Teixeira de Freitas","Teixeira de Freitas","Brazil","BRA","",157804],
[1840020198,"Lakewood","Lakewood","United States","USA","",157935],
[1076738662,"Camarajibe","Camarajibe","Brazil","BRA","",155054],
[1840008354,"Lafayette","Lafayette","United States","USA","",157820],
[1410211816,"Ŭiwang","Uiwang","South Korea","KOR","",154879],
[1608547808,"Danao","Danao","Philippines","PHL","",156321],
[1152168074,"Calama","Calama","Chile","CHL","minor",157575],
[1156193615,"Chaoshan","Chaoshan","China","CHN","",156522],
[1040312147,"Salzburg","Salzburg","Austria","AUT","admin",155021],
[1586202018,"Mandi Bahauddin","Mandi Bahauddin","Pakistan","PAK","minor",157352],
[1180183850,"Isiro","Isiro","Congo (Kinshasa)","COD","admin",157196],
[1012292620,"El Eulma","El Eulma","Algeria","DZA","",155038],
[1156122424,"Xiaping","Xiaping","China","CHN","minor",157000],
[1268193611,"Batumi","Batumi","Georgia","GEO","admin",154600],
[1012772239,"Chlef","Chlef","Algeria","DZA","admin",155134],
[1484822562,"Guaymas","Guaymas","Mexico","MEX","",156863],
[1356878237,"Pathānkot","Pathankot","India","IND","",155909],
[1792049367,"Arnavutköy","Arnavutkoy","Turkey","TUR","",156333],
[1840005710,"Frederick","Frederick","United States","USA","",156787],
[1076517475,"Lajes","Lajes","Brazil","BRA","",156727],
[1642781938,"Piteşti","Pitesti","Romania","ROU","admin",155383],
[1608456191,"Poblacion","Poblacion","Philippines","PHL","",153197],
[1410241338,"Hanam","Hanam","South Korea","KOR","",154838],
[1608379387,"Capas","Capas","Philippines","PHL","",156056],
[1524494654,"Ghorāhī","Ghorahi","Nepal","NPL","",156164],
[1356299932,"Vidisha","Vidisha","India","IND","",155959],
[1704985016,"Cẩm Phả","Cam Pha","Vietnam","VNM","minor",156000],
[1218601363,"Esmeraldas","Esmeraldas","Ecuador","ECU","admin",154035],
[1400675695,"Ar Ramthā","Ar Ramtha","Jordan","JOR","minor",155693],
[1392620119,"Kariya","Kariya","Japan","JPN","",153178],
[1840015039,"Lake Charles","Lake Charles","United States","USA","",156181],
[1840020794,"Odessa","Odessa","United States","USA","",155998],
[1380685705,"Cagliari","Cagliari","Italy","ITA","admin",154106],
[1528395473,"Zaanstad","Zaanstad","Netherlands","NLD","",154037],
[1392134860,"Hitachi-Naka","Hitachi-Naka","Japan","JPN","",154311],
[1792540951,"Ordu","Ordu","Turkey","TUR","admin",155117],
[1356414359,"Nalgonda","Nalgonda","India","IND","",154326],
[1076758286,"Timon","Timon","Brazil","BRA","",155460],
[1840005563,"Tuscaloosa","Tuscaloosa","United States","USA","",155499],
[1862061949,"Palo Negro","Palo Negro","Venezuela","VEN","minor",153706],
[1012419619,"Souk Ahras","Souk Ahras","Algeria","DZA","admin",155259],
[1112659163,"Horad Barysaw","Horad Barysaw","Belarus","BLR","minor",155389],
[1484585697,"Colima","Colima","Mexico","MEX","admin",150673],
[1276075502,"Neuss","Neuss","Germany","DEU","minor",153796],
[1826689568,"Oxford","Oxford","United Kingdom","GBR","",152000],
[1076325693,"Caxias","Caxias","Brazil","BRA","",155129],
[1840015800,"Warner Robins","Warner Robins","United States","USA","",155140],
[1840020502,"Palmdale","Palmdale","United States","USA","",155079],
[1528519634,"Hoofddorp","Hoofddorp","Netherlands","NLD","minor",154235],
[1608817515,"San Juan","San Juan","Philippines","PHL","admin",126347],
[1804906240,"Melitopol","Melitopol","Ukraine","UKR","minor",154992],
[1566483135,"Zango","Zango","Nigeria","NGA","minor",154743],
[1818743040,"Kafr ash Shaykh","Kafr ash Shaykh","Egypt","EGY","admin",147393],
[1356496150,"Bālurghāt","Balurghat","India","IND","",153279],
[1840015144,"Hollywood","Hollywood","United States","USA","",154817],
[1818735651,"Madīnat as Sādis min Uktūbar","Madinat as Sadis min Uktubar","Egypt","EGY","",154093],
[1840020792,"Midland","Midland","United States","USA","",154793],
[1356100193,"Dibrugarh","Dibrugarh","India","IND","",154019],
[1356346826,"Verāval","Veraval","India","IND","",153696],
[1076155953,"Alagoinhas","Alagoinhas","Brazil","BRA","",154495],
[1450421961,"Mahajanga","Mahajanga","Madagascar","MDG","admin",154657],
[1643996483,"Salavat","Salavat","Russia","RUS","",153181],
[1180466776,"Gandajika","Gandajika","Congo (Kinshasa)","COD","",154425],
[1840015083,"Leesburg","Leesburg","United States","USA","",154574],
[1276000325,"Regensburg","Regensburg","Germany","DEU","minor",152610],
[1840020919,"Port Arthur","Port Arthur","United States","USA","",154468],
[1643421011,"Almetyevsk","Almetyevsk","Russia","RUS","",154262],
[1024056286,"Lucapa","Lucapa","Angola","AGO","",154305],
[1392092333,"Tama","Tama","Japan","JPN","",147252],
[1410542763,"Seogwipo","Seogwipo","South Korea","KOR","",153861],
[1392660923,"Tochigi","Tochigi","Japan","JPN","",153508],
[1180108441,"Moanda","Moanda","Congo (Kinshasa)","COD","",153915],
[1076854674,"Barreiras","Barreiras","Brazil","BRA","",153918],
[1508476900,"Tete","Tete","Mozambique","MOZ","admin",152909],
[1356032860,"Fyzābād","Fyzabad","India","IND","",153047],
[1392224794,"Noda","Noda","Japan","JPN","",152227],
[1484390572,"Kanasín","Kanasin","Mexico","MEX","minor",139753],
[1484837068,"Ixtlahuaca","Ixtlahuaca","Mexico","MEX","minor",153184],
[1408656165,"Hoeryŏng","Hoeryong","North Korea","PRK","minor",153532],
[1608355709,"San Jose","San Jose","Philippines","PHL","",153267],
[1036468001,"Newcastle","Newcastle","Australia","AUS","",152984],
[1840002870,"Muskegon","Muskegon","United States","USA","",153565],
[1804577024,"Sievierodonetsk","Sievierodonetsk","Ukraine","UKR","minor",150000],
[1408269466,"Sinpo","Sinpo","North Korea","PRK","",152759],
[1566855083,"Dutse","Dutse","Nigeria","NGA","admin",153000],
[1356102467,"Silchar","Silchar","India","IND","",152393],
[1608573791,"Minglanilla","Minglanilla","Philippines","PHL","",151002],
[1392438902,"Ueda","Ueda","Japan","JPN","",152948],
[1840043455,"Macon","Macon","United States","USA","",153159],
[1156096615,"Dahuaishu","Dahuaishu","China","CHN","minor",151037],
[1356584320,"Shāntipur","Shantipur","India","IND","",151777],
[1392003269,"Moriguchi","Moriguchi","Japan","JPN","",141849],
[1840001626,"Kansas City","Kansas City","United States","USA","",152960],
[1158534780,"Yilan","Yilan","Taiwan","TWN","admin",150000],
[1116263015,"Siem Reap","Siem Reap","Cambodia","KHM","admin",147866],
[1364909317,"Golmeh","Golmeh","Iran","IRN","",152894],
[1156702015,"Fengyicun","Fengyicun","China","CHN","",150138],
[1356805611,"Hindupur","Hindupur","India","IND","",151677],
[1392471189,"Kawashiri","Kawashiri","Japan","JPN","",152076],
[1076336113,"Poços de Caldas","Pocos de Caldas","Brazil","BRA","",152435],
[1724721513,"Logroño","Logrono","Spain","ESP","admin",150808],
[1840021573,"Sunnyvale","Sunnyvale","United States","USA","",152703],
[1300302779,"Peristéri","Peristeri","Greece","GRC","minor",139981],
[1360789994,"Baubau","Baubau","Indonesia","IDN","",152143],
[1104174785,"Mudon","Mudon","Myanmar","MMR","",152300],
[1504405154,"Taza","Taza","Morocco","MAR","",148456],
[1356040695,"Erode","Erode","India","IND","",151184],
[1410398748,"Gwangyang","Gwangyang","South Korea","KOR","minor",151834],
[1356028963,"Beāwar","Beawar","India","IND","",151472],
[1076974632,"Abaetetuba","Abaetetuba","Brazil","BRA","",151934],
[1392642279,"Kukichūō","Kukichuo","Japan","JPN","",150197],
[1608199695,"Consolacion","Consolacion","Philippines","PHL","",148012],
[1364336980,"Gonbad-e Kāvūs","Gonbad-e Kavus","Iran","IRN","minor",151910],
[1729742500,"Al Manāqil","Al Manaqil","Sudan","SDN","",151827],
[1800214991,"Tororo","Tororo","Uganda","UGA","admin",150000],
[1643043679,"Miass","Miass","Russia","RUS","",151856],
[1454525586,"Mzuzu","Mzuzu","Malawi","MWI","",150100],
[1484405772,"Delicias","Delicias","Mexico","MEX","minor",150506],
[1643144321,"Nakhodka","Nakhodka","Russia","RUS","",151420],
[1218928435,"Quevedo","Quevedo","Ecuador","ECU","",150827],
[1392003253,"Asaka","Asaka","Japan","JPN","",143915],
[1608000478,"San Jose","San Jose","Philippines","PHL","",150917],
[1840020507,"Pomona","Pomona","United States","USA","",151691],
[1704276832,"Cao Lãnh","Cao Lanh","Vietnam","VNM","admin",149837],
[1380084447,"Foggia","Foggia","Italy","ITA","minor",151372],
[1840020620,"Escondido","Escondido","United States","USA","",151625],
[1710716158,"Vryheid","Vryheid","South Africa","ZAF","",150012],
[1218552075,"Riobamba","Riobamba","Ecuador","ECU","admin",146324],
[1512145575,"Aş Şuwayḩirah as Sāḩil","As Suwayhirah as Sahil","Oman","OMN","",151349],
[1276339087,"Paderborn","Paderborn","Germany","DEU","minor",150580],
[1392752018,"Sayama","Sayama","Japan","JPN","",148324],
[1348668815,"Miskolc","Miskolc","Hungary","HUN","admin",150695],
[1032021324,"Florencio Varela","Florencio Varela","Argentina","ARG","minor",146704],
[1192805452,"Manzanillo","Manzanillo","Cuba","CUB","minor",150999],
[1840020930,"Pasadena","Pasadena","United States","USA","",151227],
[1152023044,"Talcahuano","Talcahuano","Chile","CHL","",147831],
[1804437456,"Kerch","Kerch","Ukraine","UKR","",149566],
[1012857730,"M’Sila","M'Sila","Algeria","DZA","admin",150000],
[1076100026,"Patos de Minas","Patos de Minas","Brazil","BRA","",150833],
[1608735167,"Mariveles","Mariveles","Philippines","PHL","",149879],
[1152406965,"Copiapó","Copiapo","Chile","CHL","admin",150804],
[1688832387,"Kragujevac","Kragujevac","Serbia","SRB","admin",150623],
[1724759742,"Badajoz","Badajoz","Spain","ESP","minor",150610],
[1250417467,"Nîmes","Nimes","France","FRA","minor",149633],
[1834684278,"Sumbawanga","Sumbawanga","Tanzania","TZA","admin",147483],
[1076632868,"Araguaína","Araguaina","Brazil","BRA","",150484],
[1380527853,"Rimini","Rimini","Italy","ITA","minor",149403],
[1862015576,"Ocumare del Tuy","Ocumare del Tuy","Venezuela","VEN","minor",150000],
[1818284236,"Mallawī","Mallawi","Egypt","EGY","",139929],
[1392770958,"Komaki","Komaki","Japan","JPN","",147897],
[1152201132,"Valdivia","Valdivia","Chile","CHL","admin",150048],
[1484060538,"Valle de Santiago","Valle de Santiago","Mexico","MEX","minor",150054],
[1392003295,"Toda","Toda","Japan","JPN","",142352],
[1250135509,"Clermont-Ferrand","Clermont-Ferrand","France","FRA","minor",146734],
[1800406007,"Gulu","Gulu","Uganda","UGA","admin",146858],
[1312460524,"Pointe-à-Pitre","Pointe-a-Pitre","Guadeloupe","GLP","",145511],
[1364363854,"Shāhrūd","Shahrud","Iran","IRN","minor",150129],
[1268369835,"Kutaisi","Kutaisi","Georgia","GEO","admin",147900],
[1894795016,"Kashikishi","Kashikishi","Zambia","ZMB","",150000],
[1484131107,"Pénjamo","Penjamo","Mexico","MEX","minor",149936],
[1620010482,"Odivelas","Odivelas","Portugal","PRT","minor",144549],
[1840003219,"New Bedford","New Bedford","United States","USA","",149910],
[1360861988,"Saumlaki","Saumlaki","Indonesia","IDN","minor",149790],
[1826932068,"Gloucester","Gloucester","United Kingdom","GBR","",145563],
[1710838885,"Potchefstroom","Potchefstroom","South Africa","ZAF","",148804],
[1392801732,"Imabari","Imabari","Japan","JPN","",149209],
[1528862562,"Arnhem","Arnhem","Netherlands","NLD","admin",148070],
[1586788758,"Abbottabad","Abbottabad","Pakistan","PAK","minor",148587],
[1032923957,"Concordia","Concordia","Argentina","ARG","minor",149450],
[1826231773,"West Bromwich","West Bromwich","United Kingdom","GBR","",146386],
[1192000782,"Centro Habana","Centro Habana","Cuba","CUB","",140234],
[1608284971,"Sagay","Sagay","Philippines","PHL","",148894],
[1724685705,"Marbella","Marbella","Spain","ESP","",147958],
[1704004349,"Lạng Sơn","Lang Son","Vietnam","VNM","admin",148000],
[1608477470,"Santiago","Santiago","Philippines","PHL","admin",148580],
[1392661533,"Iruma","Iruma","Japan","JPN","",145778],
[1156418808,"Dongsheng","Dongsheng","China","CHN","",147228],
[1364881808,"Marvdasht","Marvdasht","Iran","IRN","minor",148858],
[1400775371,"‘Ajlūn","`Ajlun","Jordan","JOR","admin",148870],
[1894202007,"Chingola","Chingola","Zambia","ZMB","",147448],
[1356181198,"Mauli","Mauli","India","IND","",146213],
[1840020253,"Fairfield","Fairfield","United States","USA","",148683],
[1356091822,"Hābra","Habra","India","IND","",147221],
[1012061703,"Mostaganem","Mostaganem","Algeria","DZA","admin",145696],
[1642393086,"Sibiu","Sibiu","Romania","ROU","admin",147245],
[1508872233,"Pemba","Pemba","Mozambique","MOZ","admin",141316],
[1840008143,"Naperville","Naperville","United States","USA","",148449],
[1152063222,"Quilpué","Quilpue","Chile","CHL","minor",147991],
[1392391989,"Yonago","Yonago","Japan","JPN","",147210],
[1826581481,"Dundee","Dundee","United Kingdom","GBR","",148280],
[1818106054,"Disūq","Disuq","Egypt","EGY","",143404],
[1643343511,"Kopeysk","Kopeysk","Russia","RUS","",147573],
[1840018417,"Bellevue","Bellevue","United States","USA","",148164],
[1840000460,"Binghamton","Binghamton","United States","USA","",148145],
[1724960825,"Salamanca","Salamanca","Spain","ESP","minor",143269],
[1024532464,"Mbanza Kongo","Mbanza Kongo","Angola","AGO","admin",148000],
[1894890604,"Nchelenge","Nchelenge","Zambia","ZMB","",147927],
[1356947216,"Ambāla","Ambala","India","IND","",146787],
[1586802806,"Turbat","Turbat","Pakistan","PAK","minor",147791],
[1608000731,"Mati","Mati","Philippines","PHL","admin",147547],
[1398790140,"Mangghystaū","Mangghystau","Kazakhstan","KAZ","",147443],
[1728299711,"Malakal","Malakal","South Sudan","SSD","admin",147450],
[1642838304,"Bacău","Bacau","Romania","ROU","admin",144307],
[1152866014,"Osorno","Osorno","Chile","CHL","minor",147460],
[1840008187,"Elkhart","Elkhart","United States","USA","",147567],
[1840001621,"Topeka","Topeka","United States","USA","admin",147458],
[1384112524,"Man","Man","Côte d'Ivoire","CIV","admin",146974],
[1076749992,"Mogi Guaçu","Mogi Guacu","Brazil","BRA","",147233],
[1840008192,"Joliet","Joliet","United States","USA","",147344],
[1643815630,"Pyatigorsk","Pyatigorsk","Russia","RUS","",145836],
[1834217168,"Moshi","Moshi","Tanzania","TZA","admin",144739],
[1788330365,"Bizerte","Bizerte","Tunisia","TUN","admin",142966],
[1760427038,"Dar‘ā","Dar`a","Syria","SYR","admin",146481],
[1036016939,"Cairns","Cairns","Australia","AUS","",146778],
[1643450182,"Rubtsovsk","Rubtsovsk","Russia","RUS","",145333],
[1826379738,"Poole","Poole","United Kingdom","GBR","",144800],
[1144271397,"Negombo","Negombo","Sri Lanka","LKA","",142136],
[1646226936,"Gisenyi","Gisenyi","Rwanda","RWA","",136830],
[1704104189,"Cam Ranh","Cam Ranh","Vietnam","VNM","",146771],
[1180866253,"Wamba","Wamba","Congo (Kinshasa)","COD","",146871],
[1643102939,"Odintsovo","Odintsovo","Russia","RUS","",146574],
[1586791198,"Dadu","Dadu","Pakistan","PAK","minor",146179],
[1076071582,"Franco da Rocha","Franco da Rocha","Brazil","BRA","",145755],
[1392464033,"Misato","Misato","Japan","JPN","",141913],
[1704220080,"Pleiku","Pleiku","Vietnam","VNM","admin",146073],
[1356096916,"Etah","Etah","India","IND","",145601],
[1232693598,"Keren","Keren","Eritrea","ERI","admin",146500],
[1826018889,"Newport","Newport","United Kingdom","GBR","",145700],
[1608578259,"Calapan","Calapan","Philippines","PHL","admin",145786],
[1152944896,"Colina","Colina","Chile","CHL","minor",146207],
[1643196698,"Kolomna","Kolomna","Russia","RUS","",144125],
[1222243504,"Mejicanos","Mejicanos","El Salvador","SLV","",140751],
[1300003141,"Lárisa","Larisa","Greece","GRC","admin",144651],
[1156383448,"Yima","Yima","China","CHN","",144779],
[1076363089,"Santo Agostinho","Santo Agostinho","Brazil","BRA","",146219],
[1840019612,"Beaumont","Beaumont","United States","USA","",146091],
[1076568871,"Parnaíba","Parnaiba","Brazil","BRA","",145705],
[1484753599,"García","Garcia","Mexico","MEX","minor",145867],
[1608117383,"Urdaneta","Urdaneta","Philippines","PHL","",144577],
[1250829671,"Le Mans","Le Mans","France","FRA","minor",143252],
[1504194885,"Barrechid","Barrechid","Morocco","MAR","",136634],
[1608482411,"Arayat","Arayat","Philippines","PHL","",144875],
[1504720478,"Settat","Settat","Morocco","MAR","",142250],
[1586259149,"Khairpur Mir’s","Khairpur Mir's","Pakistan","PAK","minor",144949],
[1608457468,"Bocaue","Bocaue","Philippines","PHL","",141412],
[1214720035,"Baní","Bani","Dominican Republic","DOM","minor",145595],
[1156557448,"Xintang","Xintang","China","CHN","",144537],
[1192888416,"Matanzas","Matanzas","Cuba","CUB","admin",145246],
[1591487342,"David","David","Panama","PAN","admin",144858],
[1032899295,"San Justo","San Justo","Argentina","ARG","minor",136604],
[1364255116,"Qūchān","Quchan","Iran","IRN","minor",145531],
[1643757810,"Berezniki","Berezniki","Russia","RUS","",145115],
[1076932180,"Pôrto Seguro","Porto Seguro","Brazil","BRA","",145431],
[1356533936,"Shillong","Shillong","India","IND","admin",143229],
[1288506097,"Cape Coast","Cape Coast","Ghana","GHA","admin",143015],
[1862979204,"Villa de Cura","Villa de Cura","Venezuela","VEN","minor",145098],
[1392082200,"Kusatsu","Kusatsu","Japan","JPN","",143230],
[1392578597,"Kakamigahara","Kakamigahara","Japan","JPN","",143641],
[1840000838,"Paterson","Paterson","United States","USA","",145233],
[1840020313,"Merced","Merced","United States","USA","",145149],
[1356953848,"Kolār","Kolar","India","IND","",144625],
[1887202594,"Al Mukallā","Al Mukalla","Yemen","YEM","admin",144137],
[1320651129,"Flores","Flores","Guatemala","GTM","admin",144932],
[1340015594,"Comayagua","Comayagua","Honduras","HND","admin",144785],
[1156419338,"Dongxing","Dongxing","China","CHN","minor",144709],
[1392003477,"Okinawa","Okinawa","Japan","JPN","",142094],
[1604547675,"Barranca","Barranca","Peru","PER","",144381],
[1643734694,"Khasavyurt","Khasavyurt","Russia","RUS","minor",141259],
[1124001930,"Saguenay","Saguenay","Canada","CAN","",144746],
[1484282338,"Cuautitlán Izcalli","Cuautitlan Izcalli","Mexico","MEX","minor",140059],
[1120492761,"Kumba","Kumba","Cameroon","CMR","",144268],
[1100854249,"Ruse","Ruse","Bulgaria","BGR","admin",143931],
[1792015771,"Çekme","Cekme","Turkey","TUR","",142546],
[1608316754,"Malasiqui","Malasiqui","Philippines","PHL","",143094],
[1524780273,"Bharatpur","Bharatpur","Nepal","NPL","",143836],
[1170606634,"Florencia","Florencia","Colombia","COL","admin",143871],
[1840020255,"Pueblo","Pueblo","United States","USA","",143932],
[1250001687,"Aix-en-Provence","Aix-en-Provence","France","FRA","minor",143097],
[1620166724,"Coimbra","Coimbra","Portugal","PRT","admin",143396],
[1434401280,"Ajdābiyā","Ajdabiya","Libya","LBY","admin",143833],
[1608955576,"Calabayan","Calabayan","Philippines","PHL","",143403],
[1840022076,"Tyler","Tyler","United States","USA","",143796],
[1050253103,"Nawābganj","Nawabganj","Bangladesh","BGD","",142361],
[1192302618,"Ciego de Ávila","Ciego de Avila","Cuba","CUB","admin",143449],
[1826080662,"Birkenhead","Birkenhead","United Kingdom","GBR","",142968],
[1156855629,"Altay","Altay","China","CHN","minor",142000],
[1392003201,"Ashikaga","Ashikaga","Japan","JPN","",142882],
[1004167490,"Ghaznī","Ghazni","Afghanistan","AFG","admin",143379],
[1340231948,"El Progreso","El Progreso","Honduras","HND","",143360],
[1840021873,"Torrance","Torrance","United States","USA","",143592],
[1818863783,"Bilbays","Bilbays","Egypt","EGY","",141285],
[1724420824,"Huelva","Huelva","Spain","ESP","minor",142538],
[1076312559,"Jaú","Jau","Brazil","BRA","",143283],
[1124958950,"Lévis","Levis","Canada","CAN","",143414],
[1356195520,"Bhīmavaram","Bhimavaram","India","IND","",142184],
[1076588128,"Jaraguá do Sul","Jaragua do Sul","Brazil","BRA","",143123],
[1156149547,"Jinjiang","Jinjiang","China","CHN","minor",142948],
[1826093175,"Blackpool","Blackpool","United Kingdom","GBR","",139305],
[1152810305,"Los Ángeles","Los Angeles","Chile","CHL","minor",143023],
[1214362164,"Boca Chica","Boca Chica","Dominican Republic","DOM","",142019],
[1826968934,"Telford","Telford","United Kingdom","GBR","",142723],
[1840021998,"Yuma","Yuma","United States","USA","",142847],
[1826018478,"Preston","Preston","United Kingdom","GBR","",141801],
[1508041628,"Lichinga","Lichinga","Mozambique","MOZ","admin",142253],
[1148369114,"Moundou","Moundou","Chad","TCD","admin",142462],
[1807020286,"Tetovo","Tetovo","Macedonia","MKD","admin",142030],
[1586152082,"Bahawalnagar","Bahawalnagar","Pakistan","PAK","minor",141935],
[1643584159,"Maykop","Maykop","Russia","RUS","admin",141970],
[1250882453,"Brest","Brest","France","FRA","minor",139602],
[1364102350,"Kamālshahr","Kamalshahr","Iran","IRN","",141166],
[1392571441,"Fukayachō","Fukayacho","Japan","JPN","",141336],
[1756055099,"Lausanne","Lausanne","Switzerland","CHE","admin",138905],
[1716621481,"Gweru","Gweru","Zimbabwe","ZWE","admin",141260],
[1608252596,"Tabaco","Tabaco","Philippines","PHL","",140961],
[1124080626,"Kelowna","Kelowna","Canada","CAN","",142146],
[1840013994,"Metairie","Metairie","United States","USA","",142135],
[1024843393,"Namacunde","Namacunde","Angola","AGO","",142047],
[1300777854,"Irákleio","Irakleio","Greece","GRC","admin",140730],
[1356467529,"Mandsaur","Mandsaur","India","IND","",141667],
[1616092098,"Rybnik","Rybnik","Poland","POL","minor",141000],
[1156278589,"Nong’an","Nong'an","China","CHN","minor",141482],
[1504786674,"Inezgane","Inezgane","Morocco","MAR","",130333],
[1076148122,"Rio das Ostras","Rio das Ostras","Brazil","BRA","",141117],
[1008276050,"Vlorë","Vlore","Albania","ALB","admin",130827],
[1250978859,"Boulogne-Billancourt","Boulogne-Billancourt","France","FRA","minor",121334],
[1392223322,"Fujita","Fujita","Japan","JPN","",140947],
[1364271412,"Jahrom","Jahrom","Iran","IRN","minor",141634],
[1840021941,"Surprise","Surprise","United States","USA","",141664],
[1840007391,"Columbia","Columbia","United States","USA","",141645],
[1840029463,"Athens","Athens","United States","USA","",141532],
[1840020233,"Roseville","Roseville","United States","USA","",141500],
[1840021422,"Thornton","Thornton","United States","USA","",141464],
[1826407067,"Middlesbrough","Middlesbrough","United Kingdom","GBR","",140545],
[1586530458,"Khuzdar","Khuzdar","Pakistan","PAK","",141395],
[1484777621,"Tepatitlán de Morelos","Tepatitlan de Morelos","Mexico","MEX","minor",141322],
[1124808029,"Abbotsford","Abbotsford","Canada","CAN","",141397],
[1458310769,"Batu Pahat","Batu Pahat","Malaysia","MYS","",140000],
[1616148566,"Ruda Śląska","Ruda Slaska","Poland","POL","minor",139412],
[1608946840,"Porac","Porac","Philippines","PHL","",140751],
[1840015137,"Miramar","Miramar","United States","USA","",141191],
[1608100412,"Ozamiz City","Ozamiz City","Philippines","PHL","",140334],
[1348611992,"Pécs","Pecs","Hungary","HUN","admin",140237],
[1840020505,"Pasadena","Pasadena","United States","USA","",141029],
[1356960436,"Kumbakonam","Kumbakonam","India","IND","",139264],
[1643110693,"Kovrov","Kovrov","Russia","RUS","",138552],
[1156898106,"Shizhaobi","Shizhaobi","China","CHN","",140493],
[1840020713,"Mesquite","Mesquite","United States","USA","",140937],
[1392193917,"Kokubunji","Kokubunji","Japan","JPN","",129619],
[1724114678,"Lleida","Lleida","Spain","ESP","minor",140080],
[1392003085,"Ebina","Ebina","Japan","JPN","",135557],
[1076265266,"Paranaguá","Paranagua","Brazil","BRA","",140469],
[1484280781,"Iguala de la Independencia","Iguala de la Independencia","Mexico","MEX","minor",140363],
[1840003833,"Olathe","Olathe","United States","USA","",140545],
[1840021830,"Santa Maria","Santa Maria","United States","USA","",140545],
[1558765329,"Masaya","Masaya","Nicaragua","NIC","admin",139582],
[1012758282,"Médéa","Medea","Algeria","DZA","admin",138355],
[1862905123,"Yaritagua","Yaritagua","Venezuela","VEN","minor",140256],
[1840015063,"Houma","Houma","United States","USA","",140469],
[1250635972,"Tours","Tours","France","FRA","minor",136463],
[1170322047,"Fusagasugá","Fusagasuga","Colombia","COL","minor",139805],
[1214760518,"La Romana","La Romana","Dominican Republic","DOM","admin",139671],
[1608260734,"Tanay","Tanay","Philippines","PHL","",139420],
[1032997137,"Ituzaingó","Ituzaingo","Argentina","ARG","minor",135275],
[1400618058,"Al ‘Aqabah","Al `Aqabah","Jordan","JOR","admin",140000],
[1364398113,"Torbat-e Ḩeydarīyeh","Torbat-e Heydariyeh","Iran","IRN","minor",140019],
[1320482609,"Momostenango","Momostenango","Guatemala","GTM","minor",139552],
[1104373474,"Dawei","Dawei","Myanmar","MMR","admin",139900],
[1616050904,"Zielona Góra","Zielona Gora","Poland","POL","admin",139330],
[1392018722,"Kuwana","Kuwana","Japan","JPN","",138798],
[1729042522,"Atbara","Atbara","Sudan","SDN","",139768],
[1586409848,"Pakpattan","Pakpattan","Pakistan","PAK","minor",139525],
[1356141471,"Chicacole","Chicacole","India","IND","",137944],
[1050424286,"Pābna","Pabna","Bangladesh","BGD","",137888],
[1076113865,"Botucatu","Botucatu","Brazil","BRA","",139483],
[1392003271,"Minō","Mino","Japan","JPN","",136976],
[1156361664,"Shizuishan","Shizuishan","China","CHN","",136570],
[1608000107,"La Trinidad","La Trinidad","Philippines","PHL","admin",137404],
[1392720735,"Koga","Koga","Japan","JPN","",138237],
[1704199290,"Tân An","Tan An","Vietnam","VNM","admin",137498],
[1826016049,"Sale","Sale","United Kingdom","GBR","",134022],
[1124000500,"Coquitlam","Coquitlam","Canada","CAN","",139284],
[1840019436,"Carrollton","Carrollton","United States","USA","",139248],
[1484157742,"San José del Cabo","San Jose del Cabo","Mexico","MEX","minor",136285],
[1392384377,"Ishizaki","Ishizaki","Japan","JPN","",138856],
[1840020230,"Grand Junction","Grand Junction","United States","USA","",139143],
[1398375387,"Kökshetaū","Kokshetau","Kazakhstan","KAZ","admin",139063],
[1504079907,"Al Khmissat","Al Khmissat","Morocco","MAR","",131542],
[1376837517,"Bat Yam","Bat Yam","Israel","ISR","",128800],
[1608579689,"Candelaria","Candelaria","Philippines","PHL","minor",137881],
[1392962266,"Tsuchiura","Tsuchiura","Japan","JPN","",137825],
[1356561184,"Tiruvannāmalai","Tiruvannamalai","India","IND","",138243],
[1364699746,"Pīrānshahr","Piranshahr","Iran","IRN","minor",138864],
[1710651314,"Umtata","Umtata","South Africa","ZAF","",137772],
[1608664300,"Dipolog","Dipolog","Philippines","PHL","admin",138141],
[1840006196,"Charleston","Charleston","United States","USA","admin",138706],
[1840020582,"Orange","Orange","United States","USA","",138669],
[1840020576,"Fullerton","Fullerton","United States","USA","",138632],
[1192600260,"Sancti Spíritus","Sancti Spiritus","Cuba","CUB","admin",138504],
[1392003171,"Koganei","Koganei","Japan","JPN","",127226],
[1484818856,"Tultepec","Tultepec","Mexico","MEX","minor",131567],
[1608685440,"Jolo","Jolo","Philippines","PHL","admin",137266],
[1392313741,"Zama","Zama","Japan","JPN","",130753],
[1392003434,"Shūnan","Shunan","Japan","JPN","",137899],
[1608682936,"Dumaguete City","Dumaguete City","Philippines","PHL","admin",134103],
[1360053101,"Mojokerto","Mojokerto","Indonesia","IDN","",130196],
[1036497565,"Darwin","Darwin","Australia","AUS","admin",136828],
[1276803150,"Ingolstadt","Ingolstadt","Germany","DEU","minor",136981],
[1356039212,"Mandya","Mandya","India","IND","",137358],
[1840020149,"Greeley","Greeley","United States","USA","",137810],
[1410257662,"Ch’ungmu","Ch'ungmu","South Korea","KOR","",137208],
[1724296961,"Tarragona","Tarragona","Spain","ESP","minor",135436],
[1524676691,"Birgañj","Birganj","Nepal","NPL","",135904],
[1076000559,"Palhoça","Palhoca","Brazil","BRA","",137334],
[1800877735,"Lira","Lira","Uganda","UGA","admin",135445],
[1608778175,"Carcar","Carcar","Philippines","PHL","",136453],
[1024978551,"Negage","Negage","Angola","AGO","",137559],
[1360175198,"Gunungsitoli","Gunungsitoli","Indonesia","IDN","minor",137104],
[1156455844,"Yunxian Chengguanzhen","Yunxian Chengguanzhen","China","CHN","minor",133558],
[1076042485,"Atibaia","Atibaia","Brazil","BRA","",137187],
[1246938345,"Jyväskylä","Jyvaskyla","Finland","FIN","admin",137368],
[1356582158,"Bānkura","Bankura","India","IND","",137386],
[1834583327,"Kigoma","Kigoma","Tanzania","TZA","admin",135234],
[1620859041,"Vila Franca de Xira","Vila Franca de Xira","Portugal","PRT","minor",136886],
[1068265899,"Quillacollo","Quillacollo","Bolivia","BOL","",137182],
[1076673653,"Garanhuns","Garanhuns","Brazil","BRA","",136949],
[1894634581,"Livingstone","Livingstone","Zambia","ZMB","",136897],
[1360521866,"Bima","Bima","Indonesia","IDN","",136492],
[1724272711,"Dos Hermanas","Dos Hermanas","Spain","ESP","",136250],
[1392821453,"Kisarazu","Kisarazu","Japan","JPN","",136118],
[1724153608,"Parla","Parla","Spain","ESP","",131689],
[1152564798,"Curicó","Curico","Chile","CHL","minor",136954],
[1024818756,"Porto Amboim","Porto Amboim","Angola","AGO","",137000],
[1608413633,"Nasugbu","Nasugbu","Philippines","PHL","",136524],
[1608630986,"Gingoog","Gingoog","Philippines","PHL","",136698],
[1620000072,"Maia","Maia","Portugal","PRT","minor",135306],
[1752330831,"Uppsala","Uppsala","Sweden","SWE","",133117],
[1392569740,"Yaizu","Yaizu","Japan","JPN","",136028],
[1630035637,"Carolina","Carolina","Puerto Rico","PRI","",136771],
[1364680490,"Marīvān","Marivan","Iran","IRN","minor",136654],
[1222613306,"Santa Tecla","Santa Tecla","El Salvador","SLV","admin",135483],
[1392019493,"Inazawa","Inazawa","Japan","JPN","",134938],
[1100903924,"Stara Zagora","Stara Zagora","Bulgaria","BGR","admin",136475],
[1250794759,"Amiens","Amiens","France","FRA","minor",133891],
[1410470747,"Chech’ŏn","Chech'on","South Korea","KOR","",136350],
[1608520209,"Norzagaray","Norzagaray","Philippines","PHL","",136064],
[1558697688,"Jinotega","Jinotega","Nicaragua","NIC","admin",136342],
[1498104958,"Tiraspol","Tiraspol","Moldova","MDA","admin",133807],
[1360027360,"Pageralam","Pageralam","Indonesia","IDN","minor",136244],
[1012126997,"Tizi Ouzou","Tizi Ouzou","Algeria","DZA","admin",135088],
[1504230428,"Ksar El Kebir","Ksar El Kebir","Morocco","MAR","",126617],
[1860617243,"Termiz","Termiz","Uzbekistan","UZB","admin",136200],
[1608344732,"Floridablanca","Floridablanca","Philippines","PHL","",135542],
[1642875714,"Târgu-Mureş","Targu-Mures","Romania","ROU","admin",134290],
[1840020683,"Las Cruces","Las Cruces","United States","USA","",136254],
[1528012333,"’s-Hertogenbosch","'s-Hertogenbosch","Netherlands","NLD","admin",134520],
[1380863448,"Salerno","Salerno","Italy","ITA","minor",133970],
[1170000361,"Rionegro","Rionegro","Colombia","COL","minor",135465],
[1840015034,"Panama City","Panama City","United States","USA","",136133],
[1360011677,"Blitar","Blitar","Indonesia","IDN","",132018],
[1840021036,"Harlingen","Harlingen","United States","USA","",136037],
[1036765315,"Toowoomba","Toowoomba","Australia","AUS","",135631],
[1764662886,"Chiang Mai","Chiang Mai","Thailand","THA","admin",132634],
[1826609057,"Brighton","Brighton","United Kingdom","GBR","",134293],
[1434068493,"Tobruk","Tobruk","Libya","LBY","admin",135832],
[1554759867,"Tauranga","Tauranga","New Zealand","NZL","",135000],
[1104978348,"Pyay","Pyay","Myanmar","MMR","",135308],
[1840058431,"Ramapo","Ramapo","United States","USA","",135560],
[1156257611,"Shuangcheng","Shuangcheng","China","CHN","",130710],
[1608373503,"Angono","Angono","Philippines","PHL","",130494],
[1170225267,"Cartago","Cartago","Colombia","COL","minor",134827],
[1860546433,"Urganch","Urganch","Uzbekistan","UZB","admin",135100],
[1388671677,"May Pen","May Pen","Jamaica","JAM","admin",135142],
[1586796643,"Zafarwal","Zafarwal","Pakistan","PAK","",134275],
[1840021389,"West Valley City","West Valley City","United States","USA","",135248],
[1364453657,"Andīmeshk","Andimeshk","Iran","IRN","minor",135116],
[1076661082,"Santa Rita","Santa Rita","Brazil","BRA","",134940],
[1608571209,"Daraga","Daraga","Philippines","PHL","",133893],
[1218568564,"Milagro","Milagro","Ecuador","ECU","",133508],
[1764752197,"Nakhon Ratchasima","Nakhon Ratchasima","Thailand","THA","admin",134440],
[1012148937,"El Oued","El Oued","Algeria","DZA","admin",134699],
[1376324059,"Ashqelon","Ashqelon","Israel","ISR","",134454],
[1724901780,"Mataró","Mataro","Spain","ESP","",129120],
[1076465745,"Teófilo Otoni","Teofilo Otoni","Brazil","BRA","",134745],
[1608693751,"Hagonoy","Hagonoy","Philippines","PHL","",133448],
[1012233848,"Laghouat","Laghouat","Algeria","DZA","admin",134372],
[1496482400,"Mörön","Moron","Mongolia","MNG","admin",134530],
[1364242660,"Shahreẕā","Shahreza","Iran","IRN","minor",134592],
[1364485195,"Zābol","Zabol","Iran","IRN","minor",134590],
[1484693242,"Apatzingan de la Constitucion","Apatzingan de la Constitucion","Mexico","MEX","",128250],
[1840003866,"Hampton","Hampton","United States","USA","",134510],
[1620202480,"Famalicão","Famalicao","Portugal","PRT","minor",133832],
[1608928299,"Naga","Naga","Philippines","PHL","",133184],
[1124407487,"Trois-Rivières","Trois-Rivieres","Canada","CAN","",134413],
[1724711203,"Torrejón de Ardoz","Torrejon de Ardoz","Spain","ESP","",132771],
[1156040158,"Zhangmu Touwei","Zhangmu Touwei","China","CHN","",132816],
[1024280825,"Londuimbali","Londuimbali","Angola","AGO","",134254],
[1376684821,"Reẖovot","Rehovot","Israel","ISR","",132671],
[1144464659,"Batticaloa","Batticaloa","Sri Lanka","LKA","",129222],
[1834712235,"Tabora","Tabora","Tanzania","TZA","admin",127880],
[1860291734,"Navoiy","Navoiy","Uzbekistan","UZB","admin",134100],
[1586001015,"Tando Allahyar","Tando Allahyar","Pakistan","PAK","minor",133487],
[1818755693,"Idfū","Idfu","Egypt","EGY","",133772],
[1466684950,"Ségou","Segou","Mali","MLI","admin",133501],
[1840002418,"Warren","Warren","United States","USA","",133943],
[1392443480,"Isahaya","Isahaya","Japan","JPN","",133512],
[1840015476,"Mauldin","Mauldin","United States","USA","",133872],
[1840007207,"Bloomington","Bloomington","United States","USA","",133846],
[1156346497,"Jiangshan","Jiangshan","China","CHN","",133600],
[1222101845,"Apopa","Apopa","El Salvador","SLV","",131286],
[1840015134,"Coral Springs","Coral Springs","United States","USA","",133759],
[1040038924,"Innsbruck","Innsbruck","Austria","AUT","admin",132493],
[1116106237,"Battambang","Battambang","Cambodia","KHM","admin",130000],
[1392575345,"Ōme","Ome","Japan","JPN","",132436],
[1012782547,"Jijel","Jijel","Algeria","DZA","admin",131513],
[1558728443,"Matagalpa","Matagalpa","Nicaragua","NIC","admin",133416],
[1356105759,"Gondiā","Gondia","India","IND","",132821],
[1348507878,"Győr","Gyor","Hungary","HUN","admin",132735],
[1356007455,"Hassan","Hassan","India","IND","",133436],
[1170820158,"Pitalito","Pitalito","Colombia","COL","minor",133205],
[1840020879,"Round Rock","Round Rock","United States","USA","",133372],
[1392000342,"Abiko","Abiko","Japan","JPN","",130290],
[1608474974,"Talavera","Talavera","Philippines","PHL","",132338],
[1840021154,"Yakima","Yakima","United States","USA","",133191],
[1364111149,"Khorramshahr","Khorramshahr","Iran","IRN","minor",133097],
[1250736774,"Limoges","Limoges","France","FRA","minor",131479],
[1076894967,"Crato","Crato","Brazil","BRA","",133031],
[1704929966,"Trà Vinh","Tra Vinh","Vietnam","VNM","admin",131360],
[1012425687,"Ouargla","Ouargla","Algeria","DZA","admin",133024],
[1076876295,"Sinop","Sinop","Brazil","BRA","",132934],
[1608048026,"San Carlos","San Carlos","Philippines","PHL","",132650],
[1704442748,"Ninh Bình","Ninh Binh","Vietnam","VNM","admin",130517],
[1008148968,"Kamëz","Kamez","Albania","ALB","",126777],
[1076010069,"Cametá","Cameta","Brazil","BRA","",132515],
[1218479054,"Ibarra","Ibarra","Ecuador","ECU","admin",131856],
[1760709370,"Jaramānā","Jaramana","Syria","SYR","minor",114363],
[1320642245,"San Luis","San Luis","Guatemala","GTM","minor",132470],
[1840003094,"Sterling Heights","Sterling Heights","United States","USA","",132438],
[1578801684,"Stavanger","Stavanger","Norway","NOR","admin",129300],
[1840018424,"Kent","Kent","United States","USA","",132319],
[1380682411,"Ferrara","Ferrara","Italy","ITA","minor",132278],
[1214608846,"San Juan","San Juan","Dominican Republic","DOM","admin",132177],
[1862623441,"Calabozo","Calabozo","Venezuela","VEN","minor",131989],
[1356147005,"Pīlibhīt","Pilibhit","India","IND","",131008],
[1024892795,"Chicomba","Chicomba","Angola","AGO","",131807],
[1356115164,"Pālghāt","Palghat","India","IND","",130955],
[1124968815,"Guelph","Guelph","Canada","CAN","",131794],
[1120497849,"Buea","Buea","Cameroon","CMR","admin",131325],
[1862264170,"Los Guayos","Los Guayos","Venezuela","VEN","minor",130345],
[1156513218,"Nanqiaotou","Nanqiaotou","China","CHN","",130370],
[1076313540,"Ji-Paraná","Ji-Parana","Brazil","BRA","",131560],
[1191949063,"Rijeka","Rijeka","Croatia","HRV","admin",128624],
[1608453085,"Guagua","Guagua","Philippines","PHL","",128893],
[1356365783,"Pālakollu","Palakollu","India","IND","",129717],
[1388689196,"Spanish Town","Spanish Town","Jamaica","JAM","admin",131056],
[1360021476,"Parepare","Parepare","Indonesia","IDN","",129542],
[1764338230,"Surat Thani","Surat Thani","Thailand","THA","admin",130703],
[1392216588,"Narita","Narita","Japan","JPN","",130689],
[1012939885,"Relizane","Relizane","Algeria","DZA","admin",130094],
[1792945815,"Kayseri","Kayseri","Turkey","TUR","admin",126653],
[1608362038,"Silay","Silay","Philippines","PHL","",130478],
[1840013362,"Burlington","Burlington","United States","USA","",131043],
[1320214238,"Nueva Concepción","Nueva Concepcion","Guatemala","GTM","minor",130754],
[1608621038,"City of Isabela","City of Isabela","Philippines","PHL","admin",130379],
[1356846795,"Abohar","Abohar","India","IND","",130603],
[1616396493,"Tychy","Tychy","Poland","POL","minor",129322],
[1364567639,"Marand","Marand","Iran","IRN","minor",130825],
[1356022687,"Kānchrāpāra","Kanchrapara","India","IND","",129576],
[1170186734,"Quibdó","Quibdo","Colombia","COL","admin",130825],
[1170838212,"Girardot","Girardot","Colombia","COL","minor",129834],
[1076082333,"Pouso Alegre","Pouso Alegre","Brazil","BRA","",130615],
[1268562807,"Rustavi","Rustavi","Georgia","GEO","admin",128680],
[1484237822,"Cholula de Rivadabia","Cholula de Rivadabia","Mexico","MEX","",129032],
[1840018346,"Bellingham","Bellingham","United States","USA","",130641],
[1392886423,"Onomichi","Onomichi","Japan","JPN","",130143],
[1643705192,"Kislovodsk","Kislovodsk","Russia","RUS","",128779],
[1764676047,"Udon Thani","Udon Thani","Thailand","THA","admin",130274],
[1364826721,"Jīroft","Jiroft","Iran","IRN","minor",130429],
[1840021571,"Santa Clara","Santa Clara","United States","USA","",130365],
[1076843224,"Vitória de Santo Antão","Vitoria de Santo Antao","Brazil","BRA","",129974],
[1528966223,"Leiden","Leiden","Netherlands","NLD","minor",124899],
[1484746079,"Huejutla de Reyes","Huejutla de Reyes","Mexico","MEX","",129919],
[1156843490,"Zhaozhou","Zhaozhou","China","CHN","",127545],
[1729986512,"Sannār","Sannar","Sudan","SDN","",130122],
[1156314517,"Lucheng","Lucheng","China","CHN","minor",130142],
[1840002493,"Racine","Racine","United States","USA","",130142],
[1840013407,"Greenville","Greenville","United States","USA","",130118],
[1356133715,"Hanumāngarh","Hanumangarh","India","IND","",129654],
[1250551848,"Annecy","Annecy","France","FRA","minor",128199],
[1012285874,"Saïda","Saida","Algeria","DZA","admin",128413],
[1558801854,"Estelí","Esteli","Nicaragua","NIC","admin",129924],
[1398112507,"Taldyqorghan","Taldyqorghan","Kazakhstan","KAZ","admin",129960],
[1124113576,"Cambridge","Cambridge","Canada","CAN","",129920],
[1156054333,"Fengcheng","Fengcheng","China","CHN","minor",128571],
[1706563100,"Baidoa","Baidoa","Somalia","SOM","admin",129839],
[1276580165,"Fürth","Furth","Germany","DEU","minor",127748],
[1643395657,"Serpukhov","Serpukhov","Russia","RUS","",125817],
[1818400389,"Mīt Ghamr","Mit Ghamr","Egypt","EGY","",121039],
[1840004841,"Stamford","Stamford","United States","USA","",129638],
[1152839066,"Villa Alemana","Villa Alemana","Chile","CHL","",125140],
[1170825751,"Ciénaga","Cienaga","Colombia","COL","minor",129414],
[1862780259,"Táriba","Tariba","Venezuela","VEN","minor",128590],
[1024191137,"Chinguar","Chinguar","Angola","AGO","",129370],
[1276233514,"Würzburg","Wurzburg","Germany","DEU","minor",127880],
[1894038366,"Mansa","Mansa","Zambia","ZMB","admin",129185],
[1408214405,"Songnim","Songnim","North Korea","PRK","",128831],
[1608792041,"Santo Tomas","Santo Tomas","Philippines","PHL","",128667],
[1752826955,"Västerås","Vasteras","Sweden","SWE","admin",128534],
[1840003613,"Elizabeth","Elizabeth","United States","USA","",129216],
[1616096837,"Opole","Opole","Poland","POL","admin",127792],
[1643839131,"Novocheboksarsk","Novocheboksarsk","Russia","RUS","",126626],
[1076656148,"Araras","Araras","Brazil","BRA","",128895],
[1586829520,"Jaranwala","Jaranwala","Pakistan","PAK","",127973],
[1604227042,"Puno","Puno","Peru","PER","admin",128637],
[1288961962,"Koforidua","Koforidua","Ghana","GHA","admin",127334],
[1586824484,"Ahmadpur East","Ahmadpur East","Pakistan","PAK","",128112],
[1608786784,"Rosario","Rosario","Philippines","PHL","",128352],
[1858575950,"Salto","Salto","Uruguay","URY","admin",124878],
[1586888846,"Vihari","Vihari","Pakistan","PAK","minor",128034],
[1180363197,"Kamina","Kamina","Congo (Kinshasa)","COD","admin",128803],
[1032183944,"Temperley","Temperley","Argentina","ARG","",121451],
[1156195365,"Baigou","Baigou","China","CHN","",124274],
[1834960117,"Tukuyu","Tukuyu","Tanzania","TZA","",127570],
[1156157858,"Shiyan","Shiyan","China","CHN","",122802],
[1764009212,"Ban Bang Pu Mai","Ban Bang Pu Mai","Thailand","THA","",120058],
[1392032573,"Iwakuni","Iwakuni","Japan","JPN","",128401],
[1392028874,"Seto","Seto","Japan","JPN","",127327],
[1804782563,"Drohobych","Drohobych","Ukraine","UKR","minor",124269],
[1643522051,"Bataysk","Bataysk","Russia","RUS","",126769],
[1124112077,"Whitby","Whitby","Canada","CAN","",128377],
[1528416914,"Zoetermeer","Zoetermeer","Netherlands","NLD","minor",124994],
[1112209279,"Pinsk","Pinsk","Belarus","BLR","minor",125900],
[1682232132,"Sakākā","Sakaka","Saudi Arabia","SAU","admin",128332],
[1704000376,"Mỹ Tho","My Tho","Vietnam","VNM","admin",124143],
[1156872358,"Tumen","Tumen","China","CHN","",128212],
[1032425368,"Ramos Mejía","Ramos Mejia","Argentina","ARG","",120346],
[1760476337,"Al Ḩasakah","Al Hasakah","Syria","SYR","admin",128100],
[1356072147,"Hāthras","Hathras","India","IND","",126882],
[1608954884,"Guimba","Guimba","Philippines","PHL","",127653],
[1484353090,"Miramar","Miramar","Mexico","MEX","",118614],
[1152785745,"La Granja","La Granja","Chile","CHL","",116571],
[1760587307,"Al Ḩajar al Aswad","Al Hajar al Aswad","Syria","SYR","minor",101827],
[1862834503,"Guasdualito","Guasdualito","Venezuela","VEN","minor",128025],
[1643918019,"Domodedovo","Domodedovo","Russia","RUS","",127850],
[1231110370,"Shashemenē","Shashemene","Ethiopia","ETH","",114350],
[1434920152,"Darnah","Darnah","Libya","LBY","admin",127974],
[1392702415,"Kadoma","Kadoma","Japan","JPN","",118319],
[1364204147,"Salmās","Salmas","Iran","IRN","minor",127864],
[1076384228,"Cubatão","Cubatao","Brazil","BRA","",127006],
[1682515652,"Jāzān","Jazan","Saudi Arabia","SAU","admin",127743],
[1076927018,"Maricá","Marica","Brazil","BRA","",127461],
[1752223019,"Örebro","Orebro","Sweden","SWE","admin",126009],
[1643020514,"Kaspiysk","Kaspiysk","Russia","RUS","",123988],
[1276377359,"Heilbronn","Heilbronn","Germany","DEU","minor",126458],
[1643718660,"Neftekamsk","Neftekamsk","Russia","RUS","",126805],
[1392347988,"Ōmiyachō","Omiyacho","Japan","JPN","",127252],
[1840014462,"Johnson City","Johnson City","United States","USA","",127571],
[1504371270,"Mediouna","Mediouna","Morocco","MAR","",122851],
[1276002212,"Ulm","Ulm","Germany","DEU","minor",126405],
[1214790716,"Bajos de Haina","Bajos de Haina","Dominican Republic","DOM","",124193],
[1364697653,"Bam","Bam","Iran","IRN","minor",127396],
[1704250951,"Tây Ninh","Tay Ninh","Vietnam","VNM","admin",126370],
[1826609342,"High Wycombe","High Wycombe","United Kingdom","GBR","",120256],
[1380622727,"Monza","Monza","Italy","ITA","minor",123598],
[1276732622,"Pforzheim","Pforzheim","Germany","DEU","minor",126016],
[1392003337,"Ōsaki","Osaki","Japan","JPN","",127135],
[1076385564,"Balneário de Camboriú","Balneario de Camboriu","Brazil","BRA","",124557],
[1076401391,"Santana de Parnaíba","Santana de Parnaiba","Brazil","BRA","",126574],
[1643009656,"Nefteyugansk","Nefteyugansk","Russia","RUS","",127255],
[1360091636,"Payakumbuh","Payakumbuh","Indonesia","IDN","",125608],
[1104161315,"Pakokku","Pakokku","Myanmar","MMR","",126938],
[1860045958,"Angren","Angren","Uzbekistan","UZB","",126962],
[1356109985,"Basīrhat","Basirhat","India","IND","",125254],
[1170695532,"Duitama","Duitama","Colombia","COL","minor",126670],
[1620304777,"Leiria","Leiria","Portugal","PRT","admin",126897],
[1504637172,"Larache","Larache","Morocco","MAR","",125008],
[1356449184,"Navadwīp","Navadwip","India","IND","",125543],
[1380947157,"Latina","Latina","Italy","ITA","minor",126470],
[1826229713,"Cambridge","Cambridge","United Kingdom","GBR","",123867],
[1608635527,"San Fernando","San Fernando","Philippines","PHL","admin",125640],
[1826840903,"Exeter","Exeter","United Kingdom","GBR","",124180],
[1840003855,"Lynchburg","Lynchburg","United States","USA","",126814],
[1360901919,"Pangkalpinang","Pangkalpinang","Indonesia","IDN","admin",125933],
[1608971699,"Santa Cruz","Santa Cruz","Philippines","PHL","",123574],
[1356140724,"Guntakal","Guntakal","India","IND","",126270],
[1392365784,"Iizuka","Iizuka","Japan","JPN","",126136],
[1076006379,"Sabará","Sabara","Brazil","BRA","",126269],
[1024994288,"Catabola","Catabola","Angola","AGO","",126631],
[1840021843,"Simi Valley","Simi Valley","United States","USA","",126589],
[1076877003,"Barbacena","Barbacena","Brazil","BRA","",126284],
[1826545433,"Colchester","Colchester","United Kingdom","GBR","",121859],
[1356242644,"Hālīsahar","Halisahar","India","IND","",124939],
[1484930279,"Matamoros","Matamoros","Mexico","MEX","minor",118337],
[1356339732,"Rishra","Rishra","India","IND","",124577],
[1104246517,"Magway","Magway","Myanmar","MMR","admin",125973],
[1024774947,"Malanje","Malanje","Angola","AGO","admin",125856],
[1360065728,"Magelang","Magelang","Indonesia","IDN","",124912],
[1156346717,"Jizhou","Jizhou","China","CHN","",124716],
[1116115849,"Kampong Cham","Kampong Cham","Cambodia","KHM","admin",118242],
[1566925429,"Gashua","Gashua","Nigeria","NGA","minor",125817],
[1528690076,"Zwolle","Zwolle","Netherlands","NLD","admin",124914],
[1643006516,"Shchelkovo","Shchelkovo","Russia","RUS","",125634],
[1643119962,"Novomoskovsk","Novomoskovsk","Russia","RUS","",125647],
[1320110674,"Santa Lucía Cotzumalguapa","Santa Lucia Cotzumalguapa","Guatemala","GTM","minor",125473],
[1704516746,"Cam Ranh","Cam Ranh","Vietnam","VNM","minor",125311],
[1120679288,"Kumbo","Kumbo","Cameroon","CMR","",125486],
[1380386690,"Giugliano in Campania","Giugliano in Campania","Italy","ITA","",124361],
[1862805374,"Cagua","Cagua","Venezuela","VEN","minor",122571],
[1076873964,"Jandira","Jandira","Brazil","BRA","",118832],
[1320637423,"Amatitlán","Amatitlan","Guatemala","GTM","minor",125000],
[1826635849,"Gateshead","Gateshead","United Kingdom","GBR","",120046],
[1418863956,"Pakxé","Pakxe","Laos","LAO","admin",119848],
[1208789278,"Aalborg","Aalborg","Denmark","DNK","admin",122219],
[1214793175,"Bonao","Bonao","Dominican Republic","DOM","minor",125338],
[1392994259,"Honchō","Honcho","Japan","JPN","",116477],
[1840057194,"Amherst","Amherst","United States","USA","",125509],
[1608172208,"Magalang","Magalang","Philippines","PHL","minor",124188],
[1076680267,"Uruguaiana","Uruguaiana","Brazil","BRA","",125435],
[1862693736,"Porlamar","Porlamar","Venezuela","VEN","minor",120924],
[1840013456,"Fort Smith","Fort Smith","United States","USA","",125354],
[1076678781,"Resende","Resende","Brazil","BRA","",125214],
[1392727709,"Daitōchō","Daitocho","Japan","JPN","",118799],
[1724907542,"León","Leon","Spain","ESP","minor",122051],
[1818327836,"Jirjā","Jirja","Egypt","EGY","",102597],
[1156766749,"Fugu","Fugu","China","CHN","",124002],
[1840003160,"Kenosha","Kenosha","United States","USA","",124972],
[1854011699,"Ouahigouya","Ouahigouya","Burkina Faso","BFA","admin",124580],
[1760821818,"Dūmā","Duma","Syria","SYR","minor",123494],
[1840020451,"Norman","Norman","United States","USA","",124880],
[1156414076,"Zhaxi","Zhaxi","China","CHN","minor",124458],
[1484653806,"Villa de Álvarez","Villa de Alvarez","Mexico","MEX","minor",117600],
[1620174557,"Setúbal","Setubal","Portugal","PRT","admin",123684],
[1422031285,"Zahlé","Zahle","Lebanon","LBN","admin",100000],
[1156124522,"Gexianzhuang","Gexianzhuang","China","CHN","",122917],
[1616788025,"Gorzów Wielkopolski","Gorzow Wielkopolski","Poland","POL","admin",123341],
[1276033981,"Wolfsburg","Wolfsburg","Germany","DEU","minor",124151],
[1418179232,"Savannakhet","Savannakhet","Laos","LAO","admin",124000],
[1840002432,"South Lyon","South Lyon","United States","USA","",124694],
[1051341374,"Gyumri","Gyumri","Armenia","ARM","admin",121976],
[1643845220,"Pervouralsk","Pervouralsk","Russia","RUS","",124447],
[1586007078,"New Mirpur","New Mirpur","Pakistan","PAK","minor",124352],
[1710468143,"Brits","Brits","South Africa","ZAF","",122497],
[1410179693,"Noksan","Noksan","South Korea","KOR","",124246],
[1484228590,"San Pedro Garza García","San Pedro Garza Garcia","Mexico","MEX","minor",122659],
[1724355681,"Algeciras","Algeciras","Spain","ESP","",122982],
[1840018774,"Boulder","Boulder","United States","USA","",124345],
[1140257478,"Bimbo","Bimbo","Central African Republic","CAF","admin",124176],
[1642459769,"Baia Mare","Baia Mare","Romania","ROU","admin",123738],
[1392003470,"Matsubara","Matsubara","Japan","JPN","",117186],
[1804368412,"Khrustalnyi","Khrustalnyi","Ukraine","UKR","",124000],
[1643955713,"Cherkessk","Cherkessk","Russia","RUS","admin",122395],
[1360004807,"Indramayu","Indramayu","Indonesia","IDN","minor",123263],
[1398701954,"Rudnyy","Rudnyy","Kazakhstan","KAZ","",124000],
[1056297471,"Anderlecht","Anderlecht","Belgium","BEL","",117412],
[1380253521,"Bergamo","Bergamo","Italy","ITA","minor",120923],
[1392003529,"Kirishima","Kirishima","Japan","JPN","",123812],
[1608386821,"Gapan","Gapan","Philippines","PHL","",122968],
[1170903510,"Magangué","Magangue","Colombia","COL","minor",123906],
[1170370871,"Maicao","Maicao","Colombia","COL","minor",123757],
[1222858341,"Delgado","Delgado","El Salvador","SLV","",120200],
[1392003417,"Uruma","Uruma","Japan","JPN","",122371],
[1704897050,"Hội An","Hoi An","Vietnam","VNM","",121716],
[1643003556,"Derbent","Derbent","Russia","RUS","minor",123720],
[1152483678,"Melipilla","Melipilla","Chile","CHL","minor",123627],
[1724502822,"Cádiz","Cadiz","Spain","ESP","minor",114244],
[1360407556,"Pati","Pati","Indonesia","IDN","minor",122785],
[1528563623,"Maastricht","Maastricht","Netherlands","NLD","admin",121565],
[1156115403,"Longtian","Longtian","China","CHN","",123469],
[1818310821,"Munūf","Munuf","Egypt","EGY","",117240],
[1384138010,"Gagnoa","Gagnoa","Côte d'Ivoire","CIV","admin",123184],
[1840019476,"Abilene","Abilene","United States","USA","",123420],
[1152262933,"Punta Arenas","Punta Arenas","Chile","CHL","admin",123403],
[1076731794,"Varginha","Varginha","Brazil","BRA","",123081],
[1840014220,"Lehigh Acres","Lehigh Acres","United States","USA","",123378],
[1616312023,"Dąbrowa Górnicza","Dabrowa Gornicza","Poland","POL","minor",122712],
[1408134393,"Munch’ŏn","Munch'on","North Korea","PRK","",122934],
[1484118312,"Zacatecas","Zacatecas","Mexico","MEX","admin",122889],
[1854170035,"Kaya","Kaya","Burkina Faso","BFA","admin",122949],
[1710738396,"Alberton","Alberton","South Africa","ZAF","",121536],
[1250689747,"Montreuil","Montreuil","France","FRA","",109914],
[1392000398,"Ise","Ise","Japan","JPN","",122432],
[1156101860,"Lianhe","Lianhe","China","CHN","minor",121367],
[1076855072,"Bragança","Braganca","Brazil","BRA","",122881],
[1608189345,"Bayawan","Bayawan","Philippines","PHL","",122747],
[1076042195,"Barretos","Barretos","Brazil","BRA","",119243],
[1792788928,"Kâhta","Kahta","Turkey","TUR","minor",122774],
[1484007496,"Las Margaritas","Las Margaritas","Mexico","MEX","minor",122821],
[1826802533,"Blackburn","Blackburn","United Kingdom","GBR","",117963],
[1862003182,"Machiques","Machiques","Venezuela","VEN","minor",122734],
[1484580926,"Ciudad Hidalgo","Ciudad Hidalgo","Mexico","MEX","minor",122619],
[1826807636,"Slough","Slough","United Kingdom","GBR","",119070],
[1320108089,"Jalapa","Jalapa","Guatemala","GTM","admin",122483],
[1380000966,"Pescara","Pescara","Italy","ITA","minor",119217],
[1012266321,"Guelma","Guelma","Algeria","DZA","admin",120004],
[1364393434,"Behbahān","Behbahan","Iran","IRN","minor",122604],
[1356079081,"Baidyabāti","Baidyabati","India","IND","",121110],
[1360015626,"Kotamobagu","Kotamobagu","Indonesia","IDN","",120597],
[1156812271,"Xiangcheng","Xiangcheng","China","CHN","minor",121959],
[1840020979,"Pearland","Pearland","United States","USA","",122460],
[1894907880,"Mufulira","Mufulira","Zambia","ZMB","",122336],
[1316874021,"Maina","Maina","Guam","GUM","",122411],
[1356879569,"Dharmavaram","Dharmavaram","India","IND","",121874],
[1120546542,"Edéa","Edea","Cameroon","CMR","",122300],
[1392126782,"Honmachi","Honmachi","Japan","JPN","",122134],
[1504143530,"Khénifra","Khenifra","Morocco","MAR","",117510],
[1862967909,"Ciudad Ojeda","Ciudad Ojeda","Venezuela","VEN","minor",122124],
[1008293317,"Fier","Fier","Albania","ALB","admin",120655],
[1586927428,"Kamalia","Kamalia","Pakistan","PAK","",121401],
[1356773744,"Ghazīpur","Ghazipur","India","IND","",121020],
[1643381342,"Orekhovo-Zuyevo","Orekhovo-Zuyevo","Russia","RUS","",118822],
[1704237072,"Hòa Bình","Hoa Binh","Vietnam","VNM","admin",121309],
[1558172276,"Chinandega","Chinandega","Nicaragua","NIC","admin",121793],
[1356350196,"Puruliya","Puruliya","India","IND","",121067],
[1392686221,"Kashiwara","Kashiwara","Japan","JPN","",121604],
[1392003314,"Urasoe","Urasoe","Japan","JPN","",115855],
[1364662084,"Dorūd","Dorud","Iran","IRN","minor",121608],
[1076076726,"Guarapari","Guarapari","Brazil","BRA","",121506],
[1076050419,"Ribeirão Pires","Ribeirao Pires","Brazil","BRA","",120396],
[1024504085,"Ondjiva","Ondjiva","Angola","AGO","admin",121537],
[1332536650,"Port-de-Paix","Port-de-Paix","Haiti","HTI","admin",121220],
[1156805889,"Shuixi","Shuixi","China","CHN","",119517],
[1156122729,"Wuling","Wuling","China","CHN","minor",121110],
[1392935450,"Tsuruoka","Tsuruoka","Japan","JPN","",121371],
[1710210449,"Upington","Upington","South Africa","ZAF","",121189],
[1840018914,"Berkeley","Berkeley","United States","USA","",121363],
[1616954507,"Płock","Plock","Poland","POL","minor",120000],
[1840020710,"Richardson","Richardson","United States","USA","",121323],
[1840020141,"Redding","Redding","United States","USA","",121313],
[1840018788,"Arvada","Arvada","United States","USA","",121272],
[1608831439,"Tabuk","Tabuk","Philippines","PHL","",121033],
[1170483593,"Apartadó","Apartado","Colombia","COL","minor",121003],
[1840019206,"East Los Angeles","East Los Angeles","United States","USA","",121187],
[1380071816,"Siracusa","Siracusa","Italy","ITA","minor",121171],
[1250935115,"Saint-Denis","Saint-Denis","France","FRA","minor",112091],
[1076256387,"Apucarana","Apucarana","Brazil","BRA","",120919],
[1076809155,"Valinhos","Valinhos","Brazil","BRA","",120258],
[1484562441,"Chilapa de Álvarez","Chilapa de Alvarez","Mexico","MEX","minor",120790],
[1076573967,"Cachoeirinha","Cachoeirinha","Brazil","BRA","",118278],
[1504110861,"Guelmim","Guelmim","Morocco","MAR","admin",118318],
[1484166303,"Navojoa","Navojoa","Mexico","MEX","minor",120926],
[1250102680,"Perpignan","Perpignan","France","FRA","minor",119188],
[1586130042,"Kot Addu","Kot Addu","Pakistan","PAK","",120479],
[1840021559,"St. George","St. George","United States","USA","",120899],
[1276211234,"Göttingen","Gottingen","Germany","DEU","minor",119801],
[1840018496,"Billings","Billings","United States","USA","",120728],
[1024414170,"Catchiungo","Catchiungo","Angola","AGO","",120677],
[1620850431,"Barcelos","Barcelos","Portugal","PRT","minor",120391],
[1300675902,"Kallithéa","Kallithea","Greece","GRC","minor",100641],
[1484244950,"Tizayuca","Tizayuca","Mexico","MEX","minor",119442],
[1356267176,"Darjeeling","Darjeeling","India","IND","",118805],
[1364247384,"Moḩammad Shahr","Mohammad Shahr","Iran","IRN","",119418],
[1608584009,"Calumpit","Calumpit","Philippines","PHL","",118471],
[1484256075,"Cuautitlán","Cuautitlan","Mexico","MEX","minor",110385],
[1156988315,"Baisha","Baisha","China","CHN","",120300],
[1250441405,"Orléans","Orleans","France","FRA","admin",116238],
[1392987572,"Ebetsu","Ebetsu","Japan","JPN","",119819],
[1840021463,"Yuba City","Yuba City","United States","USA","",120456],
[1392078110,"Fujimino","Fujimino","Japan","JPN","",112745],
[1076989194,"Sertãozinho","Sertaozinho","Brazil","BRA","",120152],
[1246334067,"Kuopio","Kuopio","Finland","FIN","admin",120246],
[1076905631,"Poá","Poa","Brazil","BRA","",113793],
[1012074690,"Ghardaïa","Ghardaia","Algeria","DZA","admin",120000],
[1608001625,"Candaba","Candaba","Philippines","PHL","",119497],
[1862109303,"San Carlos","San Carlos","Venezuela","VEN","admin",120000],
[1340256619,"Ciudad Choluteca","Ciudad Choluteca","Honduras","HND","admin",120000],
[1392363594,"Handa","Handa","Japan","JPN","",117544],
[1076046083,"Várzea Paulista","Varzea Paulista","Brazil","BRA","",116601],
[1840008987,"Rochester","Rochester","United States","USA","",119942],
[1076772178,"Catanduva","Catanduva","Brazil","BRA","",119480],
[1478176283,"Nouadhibou","Nouadhibou","Mauritania","MRT","admin",118000],
[1826876670,"Chelmsford","Chelmsford","United Kingdom","GBR","",115369],
[1528952691,"Dordrecht","Dordrecht","Netherlands","NLD","minor",118654],
[1356068699,"Gudivāda","Gudivada","India","IND","",118167],
[1032623086,"Lomas de Zamora","Lomas de Zamora","Argentina","ARG","minor",112580],
[1364796337,"Naz̧arābād","Nazarabad","Iran","IRN","minor",119512],
[1250182013,"Besançon","Besancon","France","FRA","minor",117912],
[1840000437,"Leominster","Leominster","United States","USA","",119690],
[1124382916,"Ajax","Ajax","Canada","CAN","",119677],
[1840014425,"Kingsport","Kingsport","United States","USA","",119666],
[1156372212,"Xuqiaocun","Xuqiaocun","China","CHN","",118263],
[1608149999,"Dinalupihan","Dinalupihan","Philippines","PHL","",118209],
[1840007685,"Duluth","Duluth","United States","USA","",119476],
[1156117107,"Dongsheng","Dongsheng","China","CHN","",117976],
[1356978065,"Sopur","Sopur","India","IND","",118608],
[1076312600,"Toledo","Toledo","Brazil","BRA","",119313],
[1616395994,"Elbląg","Elblag","Poland","POL","minor",119317],
[1643123780,"Nazran","Nazran","Russia","RUS","",117936],
[1076784908,"Araucária","Araucaria","Brazil","BRA","",119123],
[1250778717,"Metz","Metz","France","FRA","minor",116581],
[1320223386,"Totonicapán","Totonicapan","Guatemala","GTM","admin",118960],
[1076084498,"Paulo Afonso","Paulo Afonso","Brazil","BRA","",119214],
[1076125544,"Guaratinguetá","Guaratingueta","Brazil","BRA","",119073],
[1724354998,"Alcobendas","Alcobendas","Spain","ESP","",116589],
[1604026500,"Huaraz","Huaraz","Peru","PER","admin",118836],
[1056953902,"Bruges","Bruges","Belgium","BEL","minor",118284],
[1840014618,"Rock Hill","Rock Hill","United States","USA","",119105],
[1392971052,"Kasuga","Kasuga","Japan","JPN","",111144],
[1608288417,"Apalit","Apalit","Philippines","PHL","",117160],
[1788064276,"Gabès","Gabes","Tunisia","TUN","admin",116323],
[1840020327,"Gilroy","Gilroy","United States","USA","",118993],
[1862753487,"Charallave","Charallave","Venezuela","VEN","minor",117707],
[1180219776,"Bandundu","Bandundu","Congo (Kinshasa)","COD","admin",118211],
[1826524974,"Cheltenham","Cheltenham","United Kingdom","GBR","",116447],
[1840000429,"Cambridge","Cambridge","United States","USA","",118927],
[1643869152,"Nevinnomyssk","Nevinnomyssk","Russia","RUS","",117446],
[1246538847,"Lahti","Lahti","Finland","FIN","admin",118119],
[1643138327,"Reutov","Reutov","Russia","RUS","",106990],
[1643039639,"Dimitrovgrad","Dimitrovgrad","Russia","RUS","",116055],
[1231961383,"Giyon","Giyon","Ethiopia","ETH","",114534],
[1380953307,"Trento","Trento","Italy","ITA","admin",117997],
[1156904006,"Yongqing","Yongqing","China","CHN","",118494],
[1586290729,"Nowshera","Nowshera","Pakistan","PAK","minor",118594],
[1524843250,"Butwāl","Butwal","Nepal","NPL","admin",118462],
[1076791102,"Barcarena Nova","Barcarena Nova","Brazil","BRA","",118537],
[1484150240,"Martínez de la Torre","Martinez de la Torre","Mexico","MEX","minor",110415],
[1392041019,"Akishima","Akishima","Japan","JPN","",112110],
[1076546798,"Birigui","Birigui","Brazil","BRA","",118352],
[1608907106,"Ligao","Ligao","Philippines","PHL","",118096],
[1276473363,"Bottrop","Bottrop","Germany","DEU","minor",117383],
[1076862896,"Santa Cruz do Sul","Santa Cruz do Sul","Brazil","BRA","",118374],
[1392326410,"Kōnosu","Konosu","Japan","JPN","",116777],
[1840022217,"Sugar Land","Sugar Land","United States","USA","",118488],
[1752963378,"Linköping","Linkoping","Sweden","SWE","admin",115672],
[1076604064,"Votorantim","Votorantim","Brazil","BRA","",117794],
[1156335037,"Yulu","Yulu","China","CHN","",117110],
[1380594352,"Forlì","Forli","Italy","ITA","minor",117863],
[1392390581,"Ikoma","Ikoma","Japan","JPN","",116174],
[1608802375,"Malita","Malita","Philippines","PHL","admin",118197],
[1862490314,"La Asunción","La Asuncion","Venezuela","VEN","admin",117513],
[1392003083,"Aizuwakamatsu","Aizuwakamatsu","Japan","JPN","",117924],
[1012021090,"Aïn Beïda","Ain Beida","Algeria","DZA","",116064],
[1840022234,"Texas City","Texas City","United States","USA","",118169],
[1566590565,"Bama","Bama","Nigeria","NGA","minor",118121],
[1076537068,"Codó","Codo","Brazil","BRA","",118038],
[1840000532,"Iowa City","Iowa City","United States","USA","",118041],
[1703430611,"Petržalka","Petrzalka","Slovakia","SVK","",114000],
[1608000273,"Plaridel","Plaridel","Philippines","PHL","",114432],
[1840002813,"Saginaw","Saginaw","United States","USA","",117958],
[1894711746,"Kabwe","Kabwe","Zambia","ZMB","admin",117517],
[1392666259,"Nobeoka","Nobeoka","Japan","JPN","",117711],
[1894410334,"Luanshya","Luanshya","Zambia","ZMB","",117579],
[1562789067,"Agadez","Agadez","Niger","NER","admin",117770],
[1804851697,"Uzhhorod","Uzhhorod","Ukraine","UKR","admin",114897],
[1356085840,"Adilābād","Adilabad","India","IND","",117167],
[1643426054,"Obninsk","Obninsk","Russia","RUS","",115029],
[1170046204,"Uribia","Uribia","Colombia","COL","minor",117674],
[1170759043,"Piedecuesta","Piedecuesta","Colombia","COL","minor",117364],
[1840018778,"Chico","Chico","United States","USA","",117668],
[1608949348,"Guiguinto","Guiguinto","Philippines","PHL","",113415],
[1156918189,"Huanren","Huanren","China","CHN","",116621],
[1404746781,"Machakos","Machakos","Kenya","KEN","admin",114109],
[1032297325,"San Martín","San Martin","Argentina","ARG","minor",117399],
[1608920078,"Los Baños","Los Banos","Philippines","PHL","",115353],
[1616162263,"Wałbrzych","Walbrzych","Poland","POL","minor",116069],
[1508689070,"Xai-Xai","Xai-Xai","Mozambique","MOZ","admin",116343],
[1826578106,"Rochdale","Rochdale","United Kingdom","GBR","",110194],
[1854763822,"Banfora","Banfora","Burkina Faso","BFA","admin",117200],
[1276256795,"Reutlingen","Reutlingen","Germany","DEU","minor",115966],
[1124000480,"Langley","Langley","Canada","CAN","",117285],
[1840005810,"Dover","Dover","United States","USA","admin",117282],
[1356923354,"Narasaraopet","Narasaraopet","India","IND","",116250],
[1324348910,"Kindia","Kindia","Guinea","GIN","admin",117062],
[1484689704,"Heroica Guaymas","Heroica Guaymas","Mexico","MEX","minor",117253],
[1643780385,"Kyzyl","Kyzyl","Russia","RUS","admin",116015],
[1120972098,"Nkongsamba","Nkongsamba","Cameroon","CMR","",117063],
[1608425228,"Samal","Samal","Philippines","PHL","",116771],
[1170830205,"Facatativá","Facatativa","Colombia","COL","minor",117133],
[1170472765,"Guadalajara de Buga","Guadalajara de Buga","Colombia","COL","minor",116893],
[1024511668,"Cassongue","Cassongue","Angola","AGO","",117000],
[1348653343,"Nyíregyháza","Nyiregyhaza","Hungary","HUN","admin",116554],
[1408334845,"Manpo","Manpo","North Korea","PRK","",116760],
[1032433516,"Mendoza","Mendoza","Argentina","ARG","admin",114822],
[1032075057,"Tandil","Tandil","Argentina","ARG","minor",116917],
[1840015110,"Clearwater","Clearwater","United States","USA","",116946],
[1356201218,"Yavatmāl","Yavatmal","India","IND","",116551],
[1392115605,"Beppu","Beppu","Japan","JPN","",115992],
[1642794918,"Buzău","Buzau","Romania","ROU","admin",115494],
[1076402865,"Araguari","Araguari","Brazil","BRA","",116871],
[1076587962,"Tatuí","Tatui","Brazil","BRA","",116682],
[1266383028,"Port-Gentil","Port-Gentil","Gabon","GAB","admin",116836],
[1392000470,"Shibuya","Shibuya","Japan","JPN","",102056],
[1380371433,"Sassari","Sassari","Italy","ITA","minor",116641],
[1840018402,"Coeur d'Alene","Coeur d'Alene","United States","USA","",116834],
[1076456009,"Conselheiro Lafaiete","Conselheiro Lafaiete","Brazil","BRA","",116512],
[1076515015,"Bagé","Bage","Brazil","BRA","",116794],
[1356110002,"Chittaurgarh","Chittaurgarh","India","IND","",116406],
[1504282363,"Berkane","Berkane","Morocco","MAR","",109237],
[1170277699,"Santander de Quilichao","Santander de Quilichao","Colombia","COL","minor",116535],
[1840021634,"Seaside","Seaside","United States","USA","",116720],
[1752789933,"Helsingborg","Helsingborg","Sweden","SWE","minor",113816],
[1152234834,"Coronel","Coronel","Chile","CHL","",116262],
[1840008534,"Independence","Independence","United States","USA","",116672],
[1840058498,"Smithtown","Smithtown","United States","USA","",116669],
[1250226887,"Argenteuil","Argenteuil","France","FRA","minor",110213],
[1524888375,"Dharān","Dharan","Nepal","NPL","",116181],
[1324037897,"Boké","Boke","Guinea","GIN","admin",116270],
[1250372069,"Rouen","Rouen","France","FRA","admin",111360],
[1608765297,"Himamaylan","Himamaylan","Philippines","PHL","",116240],
[1484770456,"San Antonio Enchisi","San Antonio Enchisi","Mexico","MEX","",110560],
[1422032780,"Joünié","Jounie","Lebanon","LBN","minor",102221],
[1840021388,"West Jordan","West Jordan","United States","USA","",116480],
[1608490585,"Bongao","Bongao","Philippines","PHL","admin",116118],
[1764492695,"Phatthaya","Phatthaya","Thailand","THA","",115840],
[1586628764,"Swabi","Swabi","Pakistan","PAK","minor",115018],
[1156599423,"Qiaotou","Qiaotou","China","CHN","minor",114712],
[1764003406,"Khon Kaen","Khon Kaen","Thailand","THA","admin",115928],
[1392003116,"Karatsu","Karatsu","Japan","JPN","",116052],
[1643438526,"Ramenskoye","Ramenskoye","Russia","RUS","",116077],
[1784053892,"Ra’s al Khaymah","Ra's al Khaymah","United Arab Emirates","ARE","admin",115949],
[1076980375,"Itapipoca","Itapipoca","Brazil","BRA","",116065],
[1192000780,"Guanabacoa","Guanabacoa","Cuba","CUB","",115180],
[1434044820,"Sabhā","Sabha","Libya","LBY","admin",116016],
[1562214493,"Tahoua","Tahoua","Niger","NER","admin",115956],
[1156278933,"Shacheng","Shacheng","China","CHN","minor",114569],
[1392003257,"Fujimi","Fujimi","Japan","JPN","",110400],
[1862904072,"Valle de La Pascua","Valle de La Pascua","Venezuela","VEN","minor",115902],
[1840014151,"Brandon","Brandon","United States","USA","",115911],
[1608068184,"San Ildefonso","San Ildefonso","Philippines","PHL","",115713],
[1840007376,"Bloomington","Bloomington","United States","USA","",115884],
[1450593748,"Toliara","Toliara","Madagascar","MDG","admin",115319],
[1392841957,"Nasushiobara","Nasushiobara","Japan","JPN","",115602],
[1392003126,"Tōkai","Tokai","Japan","JPN","",113144],
[1008173690,"Durrës","Durres","Albania","ALB","admin",113249],
[1804599785,"Berdiansk","Berdiansk","Ukraine","UKR","minor",114205],
[1600089732,"Pedro Juan Caballero","Pedro Juan Caballero","Paraguay","PRY","admin",115583],
[1076281782,"Três Lagoas","Tres Lagoas","Brazil","BRA","",115561],
[1392099278,"Kōenchō","Koencho","Japan","JPN","",115441],
[1608105622,"Mangaldan","Mangaldan","Philippines","PHL","",113185],
[1840020480,"El Monte","El Monte","United States","USA","",115487],
[1392682431,"Niihama","Niihama","Japan","JPN","",114971],
[1840015164,"North Charleston","North Charleston","United States","USA","",115382],
[1840019352,"Carlsbad","Carlsbad","United States","USA","",115382],
[1356897672,"Bānsbāria","Bansbaria","India","IND","",103920],
[1032351657,"Puerto Madryn","Puerto Madryn","Argentina","ARG","minor",115353],
[1608112592,"Iriga City","Iriga City","Philippines","PHL","",114457],
[1392791927,"Sano","Sano","Japan","JPN","",114842],
[1788682546,"Ariana","Ariana","Tunisia","TUN","admin",114486],
[1804877044,"Sloviansk","Sloviansk","Ukraine","UKR","",113196],
[1276605495,"Koblenz","Koblenz","Germany","DEU","minor",114024],
[1643301615,"Oktyabr’skiy","Oktyabr'skiy","Russia","RUS","",113929],
[1170000109,"Sogamoso","Sogamoso","Colombia","COL","minor",114486],
[1840008881,"St. Cloud","St. Cloud","United States","USA","",115028],
[1076427264,"Salto","Salto","Brazil","BRA","",114171],
[1156128936,"Zhijiang","Zhijiang","China","CHN","minor",113907],
[1392723053,"Hatsukaichi","Hatsukaichi","Japan","JPN","",114699],
[1484513329,"Las Delicias","Las Delicias","Mexico","MEX","",114783],
[1070522751,"Bijeljina","Bijeljina","Bosnia And Herzegovina","BIH","minor",114663],
[1156525318,"Heshan","Heshan","China","CHN","minor",114496],
[1356671720,"Siddipet","Siddipet","India","IND","",114091],
[1324495325,"Kankan","Kankan","Guinea","GIN","admin",114009],
[1840021937,"Temecula","Temecula","United States","USA","",114761],
[1276991229,"Bremerhaven","Bremerhaven","Germany","DEU","",113634],
[1376846832,"Bet Shemesh","Bet Shemesh","Israel","ISR","",114371],
[1858042396,"Ciudad de la Costa","Ciudad de la Costa","Uruguay","URY","",112449],
[1840018944,"Clovis","Clovis","United States","USA","",114584],
[1032030395,"Bernal","Bernal","Argentina","ARG","",109914],
[1392541992,"Kamagaya","Kamagaya","Japan","JPN","",109370],
[1608474998,"San Juan","San Juan","Philippines","PHL","minor",114068],
[1356065507,"Vālpārai","Valparai","India","IND","",114308],
[1826763937,"Rotherham","Rotherham","United Kingdom","GBR","",109691],
[1392003270,"Kakegawa","Kakegawa","Japan","JPN","",113954],
[1458164361,"Bintulu","Bintulu","Malaysia","MYS","",114058],
[1840020046,"Meridian","Meridian","United States","USA","",114161],
[1124000949,"Saanich","Saanich","Canada","CAN","",114148],
[1608562606,"Daet","Daet","Philippines","PHL","admin",111700],
[1834453478,"Iringa","Iringa","Tanzania","TZA","admin",111820],
[1024939858,"Cuito","Cuito","Angola","AGO","admin",114000],
[1276179876,"Recklinghausen","Recklinghausen","Germany","DEU","minor",112267],
[1004123527,"Pul-e Khumrī","Pul-e Khumri","Afghanistan","AFG","admin",113500],
[1392190380,"Nagahama","Nagahama","Japan","JPN","",113740],
[1458745722,"Tawau","Tawau","Malaysia","MYS","",113809],
[1250218452,"Mulhouse","Mulhouse","France","FRA","minor",108942],
[1024895987,"Quilengues","Quilengues","Angola","AGO","",113825],
[1840019585,"The Woodlands","The Woodlands","United States","USA","",113819],
[1156411606,"Mazhang","Mazhang","China","CHN","minor",107819],
[1710440011,"Paarl","Paarl","South Africa","ZAF","",112045],
[1392985430,"Hōfu","Hofu","Japan","JPN","",113170],
[1392717059,"Hikone","Hikone","Japan","JPN","",113191],
[1076845536,"Maranguape","Maranguape","Brazil","BRA","",113561],
[1158174293,"Hualien","Hualien","Taiwan","TWN","admin",110000],
[1608718800,"Rosario","Rosario","Philippines","PHL","",110807],
[1076747401,"Itatiba","Itatiba","Brazil","BRA","",113284],
[1076389529,"Ubá","Uba","Brazil","BRA","",113300],
[1360552560,"Bukittinggi","Bukittinggi","Indonesia","IDN","",113326],
[1076107372,"Caraguatatuba","Caraguatatuba","Brazil","BRA","",113317],
[1608811201,"Manolo Fortich","Manolo Fortich","Philippines","PHL","",113200],
[1024065318,"Mungo","Mungo","Angola","AGO","",113417],
[1180810333,"Kipushi","Kipushi","Congo (Kinshasa)","COD","",113347],
[1788952846,"Jendouba","Jendouba","Tunisia","TUN","admin",113116],
[1276339482,"Erlangen","Erlangen","Germany","DEU","minor",111962],
[1410369367,"Sa-ch’on","Sa-ch'on","South Korea","KOR","",113335],
[1630023669,"Ponce","Ponce","Puerto Rico","PRI","",113401],
[1826979494,"Doncaster","Doncaster","United Kingdom","GBR","",109805],
[1608310701,"Libmanan","Libmanan","Philippines","PHL","",112994],
[1276074373,"Bergisch Gladbach","Bergisch Gladbach","Germany","DEU","minor",111966],
[1076770753,"Euriápolis","Euriapolis","Brazil","BRA","",113191],
[1356005329,"Osmānābād","Osmanabad","India","IND","",112085],
[1643427847,"Novyy Urengoy","Novyy Urengoy","Russia","RUS","",113254],
[1068836323,"Montero","Montero","Bolivia","BOL","",112837],
[1170693388,"Madrid","Madrid","Colombia","COL","minor",112254],
[1840021423,"Westminster","Westminster","United States","USA","",113166],
[1608195528,"Tayabas","Tayabas","Philippines","PHL","",112658],
[1466352252,"Mopti","Mopti","Mali","MLI","admin",108456],
[1768875145,"Sokodé","Sokode","Togo","TGO","admin",113000],
[1032123891,"Castelar","Castelar","Argentina","ARG","",107786],
[1012495148,"Khenchela","Khenchela","Algeria","DZA","admin",108580],
[1380072199,"Vicenza","Vicenza","Italy","ITA","minor",111620],
[1840019326,"Costa Mesa","Costa Mesa","United States","USA","",113003],
[1032111842,"San Carlos de Bariloche","San Carlos de Bariloche","Argentina","ARG","minor",112887],
[1392240421,"Otaru","Otaru","Japan","JPN","",112452],
[1578642977,"Kristiansand","Kristiansand","Norway","NOR","minor",112588],
[1528593016,"Alphen aan den Rijn","Alphen aan den Rijn","Netherlands","NLD","minor",110986],
[1840014881,"Monroe","Monroe","United States","USA","",112891],
[1032069640,"Esteban Echeverría","Esteban Echeverria","Argentina","ARG","",109644],
[1392117204,"Higashiōmi","Higashiomi","Japan","JPN","",112459],
[1862614387,"Santa Lucía","Santa Lucia","Venezuela","VEN","minor",112357],
[1840002746,"Utica","Utica","United States","USA","",112650],
[1862485109,"Carora","Carora","Venezuela","VEN","minor",112600],
[1608043510,"Laoag","Laoag","Philippines","PHL","admin",111651],
[1156508113,"Tangjia","Tangjia","China","CHN","",109152],
[1356132208,"Champdani","Champdani","India","IND","",111251],
[1392826391,"Ōshū","Oshu","Japan","JPN","",112402],
[1276043920,"Remscheid","Remscheid","Germany","DEU","minor",110994],
[1392918777,"Habikino","Habikino","Japan","JPN","",108373],
[1643117920,"Kamyshin","Kamyshin","Russia","RUS","",111100],
[1076072105,"Campo Largo","Campo Largo","Brazil","BRA","",112377],
[1643283176,"Dolgoprudnyy","Dolgoprudnyy","Russia","RUS","",108861],
[1008977725,"Shkodër","Shkoder","Albania","ALB","admin",112276],
[1276659978,"Jena","Jena","Germany","DEU","minor",111407],
[1608633194,"Subic","Subic","Philippines","PHL","",111912],
[1076974952,"Santana","Santana","Brazil","BRA","",112218],
[1860946502,"Olmaliq","Olmaliq","Uzbekistan","UZB","",112078],
[1608411157,"Kawit","Kawit","Philippines","PHL","",107535],
[1012931222,"Bou Saâda","Bou Saada","Algeria","DZA","",111787],
[1724699771,"Jaén","Jaen","Spain","ESP","minor",111932],
[1076900900,"Araruama","Araruama","Brazil","BRA","",112008],
[1840015143,"Pompano Beach","Pompano Beach","United States","USA","",112118],
[1608960920,"Baybay","Baybay","Philippines","PHL","",111848],
[1076131775,"Corumbá","Corumba","Brazil","BRA","",112058],
[1643012071,"Zhukovskiy","Zhukovskiy","Russia","RUS","",107994],
[1840015993,"West Palm Beach","West Palm Beach","United States","USA","",111955],
[1566882360,"Nsukka","Nsukka","Nigeria","NGA","minor",111017],
[1392003094,"Ichinoseki","Ichinoseki","Japan","JPN","",111824],
[1620995356,"Funchal","Funchal","Portugal","PRT","admin",111892],
[1250925250,"Nancy","Nancy","France","FRA","minor",104885],
[1076751743,"Colatina","Colatina","Brazil","BRA","",111788],
[1826000009,"Maidstone","Maidstone","United Kingdom","GBR","",107627],
[1231347519,"Āsela","Asela","Ethiopia","ETH","",110088],
[1484607603,"Parral","Parral","Mexico","MEX","minor",104836],
[1380323915,"Terni","Terni","Italy","ITA","minor",111189],
[1792174991,"Tuzla","Tuzla","Turkey","TUR","",107883],
[1840000440,"Waterloo","Waterloo","United States","USA","",111631],
[1076090375,"Parintins","Parintins","Brazil","BRA","",111575],
[1276211430,"Trier","Trier","Germany","DEU","minor",110636],
[1124993674,"Terrebonne","Terrebonne","Canada","CAN","",111575],
[1056954156,"Namur","Namur","Belgium","BEL","admin",110939],
[1156755405,"Changbang","Changbang","China","CHN","",110352],
[1608740996,"Pulilan","Pulilan","Philippines","PHL","",108836],
[1643769134,"Murom","Murom","Russia","RUS","",109072],
[1748177431,"Manzini","Manzini","Swaziland","SWZ","admin",110508],
[1392173163,"Tondabayashichō","Tondabayashicho","Japan","JPN","",108735],
[1840019785,"Everett","Everett","United States","USA","",111475],
[1156442510,"Pingquan","Pingquan","China","CHN","minor",110646],
[1392384497,"Kazo","Kazo","Japan","JPN","",110622],
[1840020630,"El Centro","El Centro","United States","USA","",111425],
[1356765227,"Khardah","Khardah","India","IND","",108496],
[1392003164,"Ōmuta","Omuta","Japan","JPN","",110054],
[1032858021,"Villa Mercedes","Villa Mercedes","Argentina","ARG","minor",111391],
[1706737655,"Jawhar","Jawhar","Somalia","SOM","admin",111308],
[1756362130,"Winterthur","Winterthur","Switzerland","CHE","minor",109775],
[1070117835,"Tuzla","Tuzla","Bosnia And Herzegovina","BIH","minor",110979],
[1616375879,"Tarnów","Tarnow","Poland","POL","minor",110956],
[1788454569,"Gafsa","Gafsa","Tunisia","TUN","admin",111170],
[1887195126,"Ash Shaykh ‘Uthmān","Ash Shaykh `Uthman","Yemen","YEM","minor",105248],
[1528566376,"Alkmaar","Alkmaar","Netherlands","NLD","minor",107822],
[1566737779,"Nguru","Nguru","Nigeria","NGA","minor",111014],
[1840021707,"Santa Fe","Santa Fe","United States","USA","admin",111269],
[1364759228,"Bandar-e Anzalī","Bandar-e Anzali","Iran","IRN","minor",110643],
[1586738716,"Khushab","Khushab","Pakistan","PAK","minor",110868],
[1840019245,"Downey","Downey","United States","USA","",111126],
[1840014105,"Spring Hill","Spring Hill","United States","USA","",111076],
[1826924980,"Basingstoke","Basingstoke","United Kingdom","GBR","",107355],
[1076169871,"Catalão","Catalao","Brazil","BRA","",110983],
[1840000426,"Lowell","Lowell","United States","USA","",110997],
[1222380208,"Sonsonate","Sonsonate","El Salvador","SLV","admin",110501],
[1222480039,"Ahuachapán","Ahuachapan","El Salvador","SLV","admin",110511],
[1840018792,"Centennial","Centennial","United States","USA","",110937],
[1320517532,"Puerto Barrios","Puerto Barrios","Guatemala","GTM","admin",110846],
[1364549592,"Fasā","Fasa","Iran","IRN","minor",110825],
[1760391067,"As Salamīyah","As Salamiyah","Syria","SYR","minor",110683],
[1643737725,"Yessentuki","Yessentuki","Russia","RUS","",108679],
[1840008134,"Elgin","Elgin","United States","USA","",110849],
[1834972707,"Shinyanga","Shinyanga","Tanzania","TZA","admin",107362],
[1478465771,"Kiffa","Kiffa","Mauritania","MRT","admin",110714],
[1484223913,"Manzanillo","Manzanillo","Mexico","MEX","minor",110735],
[1804000135,"Nikopol","Nikopol","Ukraine","UKR","minor",110669],
[1156708054,"Dali","Dali","China","CHN","minor",109696],
[1104118838,"Yenangyaung","Yenangyaung","Myanmar","MMR","",110553],
[1862178539,"Quíbor","Quibor","Venezuela","VEN","minor",110536],
[1076551408,"Ourinhos","Ourinhos","Brazil","BRA","",110282],
[1364720199,"Borāzjān","Borazjan","Iran","IRN","minor",110567],
[1840020277,"Richmond","Richmond","United States","USA","",110567],
[1862619610,"Socopó","Socopo","Venezuela","VEN","minor",110512],
[1012738269,"Mascara","Mascara","Algeria","DZA","admin",108587],
[1156133257,"Genhe","Genhe","China","CHN","minor",110438],
[1388955058,"Montego Bay","Montego Bay","Jamaica","JAM","admin",110115],
[1410005963,"Jeonghae","Jeonghae","South Korea","KOR","",110194],
[1788688595,"Msaken","Msaken","Tunisia","TUN","",110000],
[1364786972,"Bāneh","Baneh","Iran","IRN","minor",110218],
[1392840575,"Shirayamamachi","Shirayamamachi","Japan","JPN","",110135],
[1834433264,"Bukoba","Bukoba","Tanzania","TZA","admin",100504],
[1862118872,"Tinaquillo","Tinaquillo","Venezuela","VEN","minor",110000],
[1840019059,"Broken Arrow","Broken Arrow","United States","USA","",110198],
[1156055006,"Xishancun","Xishancun","China","CHN","",108592],
[1392003524,"Marugame","Marugame","Japan","JPN","",109165],
[1356624441,"Bangaon","Bangaon","India","IND","",108864],
[1124001426,"Milton","Milton","Canada","CAN","",110128],
[1410007012,"Yŏju","Yoju","South Korea","KOR","",109937],
[1616517871,"Chorzów","Chorzow","Poland","POL","minor",106846],
[1608479806,"Tacurong","Tacurong","Philippines","PHL","",109319],
[1840015151,"Miami Gardens","Miami Gardens","United States","USA","",110001],
[1604438126,"Pisco","Pisco","Peru","PER","",109965],
[1348900171,"Kecskemét","Kecskemet","Hungary","HUN","admin",109651],
[1586008360,"Dera Ismail Khan","Dera Ismail Khan","Pakistan","PAK","minor",109686],
[1324900784,"Labé","Labe","Guinea","GIN","admin",107695],
[1076710878,"Altamira","Altamira","Brazil","BRA","",109938],
[1608639398,"Cavite City","Cavite City","Philippines","PHL","",100674],
[1578937195,"Drammen","Drammen","Norway","NOR","minor",109416],
[1158804050,"Taitung","Taitung","Taiwan","TWN","admin",108905],
[1076783407,"Itabira","Itabira","Brazil","BRA","",109783],
[1504975687,"Al Fqih Ben Çalah","Al Fqih Ben Calah","Morocco","MAR","",102019],
[1608362602,"Naujan","Naujan","Philippines","PHL","",109587],
[1840018618,"Bend","Bend","United States","USA","",109802],
[1608600962,"Quezon","Quezon","Philippines","PHL","",109624],
[1204875413,"Kandi","Kandi","Benin","BEN","admin",109701],
[1840002310,"Burlington","Burlington","United States","USA","",109763],
[1392493731,"Sandachō","Sandacho","Japan","JPN","",109243],
[1710276157,"Uitenhage","Uitenhage","South Africa","ZAF","",103639],
[1170152591,"Aguachica","Aguachica","Colombia","COL","minor",109621],
[1608947570,"Glan","Glan","Philippines","PHL","",109547],
[1608216694,"Carmona","Carmona","Philippines","PHL","",106256],
[1608483872,"Bayugan","Bayugan","Philippines","PHL","",109499],
[1250001272,"Caen","Caen","France","FRA","minor",105512],
[1788240639,"Medenine","Medenine","Tunisia","TUN","admin",109409],
[1840043419,"Jurupa Valley","Jurupa Valley","United States","USA","",109527],
[1788047794,"Kasserine","Kasserine","Tunisia","TUN","admin",108794],
[1156695837,"Taoyang","Taoyang","China","CHN","minor",109300],
[1032523704,"Gualeguaychú","Gualeguaychu","Argentina","ARG","minor",109461],
[1788225711,"Béja","Beja","Tunisia","TUN","admin",109299],
[1152487376,"Espejo","Espejo","Chile","CHL","",98804],
[1642183791,"Botoşani","Botosani","Romania","ROU","admin",106847],
[1840015609,"Sandy Springs","Sandy Springs","United States","USA","",109452],
[1608509888,"Talisay","Talisay","Philippines","PHL","",108909],
[1608464071,"Lingayen","Lingayen","Philippines","PHL","admin",107728],
[1410990908,"Yŏngju","Yongju","South Korea","KOR","",109266],
[1840019939,"Gresham","Gresham","United States","USA","",109381],
[1231492773,"Ādīgrat","Adigrat","Ethiopia","ETH","",104021],
[1508002342,"Maxixe","Maxixe","Mozambique","MOZ","",108824],
[1764800579,"Ban Mangkon","Ban Mangkon","Thailand","THA","",102291],
[1384745470,"Soubré","Soubre","Côte d'Ivoire","CIV","minor",108933],
[1840020639,"Lewisville","Lewisville","United States","USA","",109212],
[1484316468,"Túxpam de Rodríguez Cano","Tuxpam de Rodriguez Cano","Mexico","MEX","minor",109049],
[1170309931,"Ipiales","Ipiales","Colombia","COL","minor",109116],
[1392924607,"Mineshita","Mineshita","Japan","JPN","",107416],
[1840019932,"Hillsboro","Hillsboro","United States","USA","",109128],
[1826936965,"Worthing","Worthing","United Kingdom","GBR","",109120],
[1840037414,"San Buenaventura","San Buenaventura","United States","USA","",109106],
[1643535469,"Novoshakhtinsk","Novoshakhtinsk","Russia","RUS","",108345],
[1076829621,"São Mateus","Sao Mateus","Brazil","BRA","",109028],
[1024251027,"Balombo","Balombo","Angola","AGO","",108965],
[1826470693,"Crawley","Crawley","United Kingdom","GBR","",106597],
[1392188564,"Ikeda","Ikeda","Japan","JPN","",104148],
[1818661611,"Maţrūḩ","Matruh","Egypt","EGY","",108774],
[1124741456,"St. John's","St. John's","Canada","CAN","admin",108860],
[1840014653,"Jacksonville","Jacksonville","United States","USA","",108856],
[1826868550,"Salford","Salford","United Kingdom","GBR","",103886],
[1792169057,"Samsun","Samsun","Turkey","TUR","admin",107510],
[1840001373,"Pottstown","Pottstown","United States","USA","",108758],
[1608006603,"Cawayan","Cawayan","Philippines","PHL","",108480],
[1356318314,"Tādpatri","Tadpatri","India","IND","",108171],
[1124521303,"Moncton","Moncton","Canada","CAN","",108620],
[1364652740,"Yāsūj","Yasuj","Iran","IRN","admin",108505],
[1558753915,"Tipitapa","Tipitapa","Nicaragua","NIC","minor",108457],
[1152536354,"Alto Hospicio","Alto Hospicio","Chile","CHL","",108375],
[1356324247,"Islāmābād","Islamabad","India","IND","",108505],
[1608275407,"Maramag","Maramag","Philippines","PHL","",108293],
[1356763479,"Jalpāiguri","Jalpaiguri","India","IND","",107341],
[1566191812,"Birnin Kebbi","Birnin Kebbi","Nigeria","NGA","admin",108164],
[1792938326,"Sivas","Sivas","Turkey","TUR","admin",108320],
[1440593416,"Šiauliai","Siauliai","Lithuania","LTU","admin",107086],
[1643818456,"Seversk","Seversk","Russia","RUS","",107922],
[1862210475,"El Limón","El Limon","Venezuela","VEN","minor",106206],
[1840019237,"Inglewood","Inglewood","United States","USA","",108151],
[1724192207,"Reus","Reus","Spain","ESP","",106084],
[1148442794,"Sarh","Sarh","Chad","TCD","admin",108061],
[1729223651,"An Nuhūd","An Nuhud","Sudan","SDN","",108008],
[1032221516,"San Rafael","San Rafael","Argentina","ARG","minor",107997],
[1616258002,"Koszalin","Koszalin","Poland","POL","minor",106880],
[1320838903,"Escuintla","Escuintla","Guatemala","GTM","admin",107638],
[1392899702,"Tajimi","Tajimi","Japan","JPN","",106746],
[1124398712,"Thunder Bay","Thunder Bay","Canada","CAN","",107909],
[1804162854,"Pavlohrad","Pavlohrad","Ukraine","UKR","minor",106082],
[1024743438,"Baía Farta","Baia Farta","Angola","AGO","",107841],
[1608573250,"Tagbilaran City","Tagbilaran City","Philippines","PHL","minor",104976],
[1250060303,"Courbevoic","Courbevoic","France","FRA","",82198],
[1804279364,"Yevpatoriia","Yevpatoriia","Ukraine","UKR","",106158],
[1528332075,"Emmen","Emmen","Netherlands","NLD","minor",107471],
[1056103437,"Moortebeek","Moortebeek","Belgium","BEL","",97005],
[1158732750,"Douliu","Douliu","Taiwan","TWN","admin",106653],
[1710110028,"Queenstown","Queenstown","South Africa","ZAF","",105309],
[1608666262,"Carmen","Carmen","Philippines","PHL","",107603],
[1586640695,"Chaman","Chaman","Pakistan","PAK","",107660],
[1608860224,"Pateros","Pateros","Philippines","PHL","",65227],
[1368478549,"Umm Qaşr","Umm Qasr","Iraq","IRQ","",107620],
[1834100025,"Musoma","Musoma","Tanzania","TZA","admin",103497],
[1076492877,"Bento Gonçalves","Bento Goncalves","Brazil","BRA","",107278],
[1356067301,"Suriāpet","Suriapet","India","IND","",106805],
[1586928614,"Charsadda","Charsadda","Pakistan","PAK","minor",105414],
[1860234026,"Kogon Shahri","Kogon Shahri","Uzbekistan","UZB","minor",107566],
[1840020973,"League City","League City","United States","USA","",107536],
[1376008883,"Kefar Sava","Kefar Sava","Israel","ISR","",100800],
[1804025187,"Alchevsk","Alchevsk","Ukraine","UKR","minor",105398],
[1320701049,"Morales","Morales","Guatemala","GTM","minor",107400],
[1320948769,"Chichicastenango","Chichicastenango","Guatemala","GTM","minor",107193],
[1840002296,"Eau Claire","Eau Claire","United States","USA","",107404],
[1380677819,"Bolzano","Bolzano","Italy","ITA","minor",107317],
[1840021533,"Turlock","Turlock","United States","USA","",107317],
[1036170383,"Launceston","Launceston","Australia","AUS","",106153],
[1840022154,"Temple","Temple","United States","USA","",107258],
[1156147494,"Chongshan","Chongshan","China","CHN","minor",107100],
[1180788280,"Ilebo","Ilebo","Congo (Kinshasa)","COD","",107093],
[1104269989,"Taungoo","Taungoo","Myanmar","MMR","",106945],
[1124195431,"Dieppe","Dieppe","Canada","CAN","",107068],
[1643088735,"Arzamas","Arzamas","Russia","RUS","",104547],
[1032773254,"Morón","Moron","Argentina","ARG","minor",99066],
[1156263974,"Longjiang","Longjiang","China","CHN","minor",106384],
[1643978240,"Artëm","Artem","Russia","RUS","",106692],
[1608344411,"Tiaong","Tiaong","Philippines","PHL","minor",106265],
[1643340196,"Noyabrsk","Noyabrsk","Russia","RUS","",106879],
[1170295059,"Yopal","Yopal","Colombia","COL","admin",106822],
[1788553334,"Monastir","Monastir","Tunisia","TUN","admin",104535],
[1608878798,"Catbalogan","Catbalogan","Philippines","PHL","admin",106440],
[1760134354,"As Safīrah","As Safirah","Syria","SYR","minor",106460],
[1364525124,"Chābahār","Chabahar","Iran","IRN","minor",106739],
[1764409111,"Nakhon Si Thammarat","Nakhon Si Thammarat","Thailand","THA","admin",106322],
[1156528474,"Jincheng","Jincheng","China","CHN","minor",105038],
[1112188007,"Orsha","Orsha","Belarus","BLR","minor",106505],
[1360014952,"Raba","Raba","Indonesia","IDN","minor",106101],
[1076232522,"Patos","Patos","Brazil","BRA","",106314],
[1032317566,"La Banda","La Banda","Argentina","ARG","minor",106441],
[1840000447,"Sioux City","Sioux City","United States","USA","",106455],
[1840006219,"Salisbury","Salisbury","United States","USA","",106447],
[1704262419,"Vĩnh Long","Vinh Long","Vietnam","VNM","admin",103314],
[1076782492,"Passos","Passos","Brazil","BRA","",106290],
[1818295057,"Akhmīm","Akhmim","Egypt","EGY","",101509],
[1392003448,"Komatsu","Komatsu","Japan","JPN","",106023],
[1840017272,"Davie","Davie","United States","USA","",106306],
[1156317956,"Aihua","Aihua","China","CHN","minor",106054],
[1484890875,"Temoaya","Temoaya","Mexico","MEX","minor",105766],
[1643890929,"Achinsk","Achinsk","Russia","RUS","",105264],
[1840018926,"Daly City","Daly City","United States","USA","",106280],
[1192844279,"Contramaestre","Contramaestre","Cuba","CUB","minor",106002],
[1484549731,"Ciudad Río Bravo","Ciudad Rio Bravo","Mexico","MEX","minor",101481],
[1076342199,"Vespasiano","Vespasiano","Brazil","BRA","",104527],
[1704178922,"Mang La","Mang La","Vietnam","VNM","",105489],
[1144417074,"Trincomalee","Trincomalee","Sri Lanka","LKA","admin",99135],
[1152490874,"Lo Barnechea","Lo Barnechea","Chile","CHL","",105833],
[1566322480,"Azare","Azare","Nigeria","NGA","minor",105687],
[1076442639,"Ariquemes","Ariquemes","Brazil","BRA","",105896],
[1076632637,"Paço do Lumiar","Paco do Lumiar","Brazil","BRA","",105121],
[1466253368,"Koutiala","Koutiala","Mali","MLI","minor",104927],
[1804386597,"Brovary","Brovary","Ukraine","UKR","minor",102856],
[1392003445,"Kiryū","Kiryu","Japan","JPN","",105465],
[1643799484,"Pushkino","Pushkino","Russia","RUS","",105479],
[1643014014,"Yelets","Yelets","Russia","RUS","",104349],
[1724571895,"Ourense","Ourense","Spain","ESP","minor",104596],
[1368199624,"Tikrīt","Tikrit","Iraq","IRQ","admin",105700],
[1608516439,"Bulan","Bulan","Philippines","PHL","",105190],
[1320759841,"Malacatán","Malacatan","Guatemala","GTM","minor",105178],
[1484522993,"Playas de Rosarito","Playas de Rosarito","Mexico","MEX","minor",100660],
[1840028579,"Highlands Ranch","Highlands Ranch","United States","USA","",105631],
[1840019396,"Allen","Allen","United States","USA","",105623],
[1887801013,"Tarīm","Tarim","Yemen","YEM","minor",105552],
[1608972592,"Maluñgun","Malungun","Philippines","PHL","",105465],
[1112704173,"Mazyr","Mazyr","Belarus","BLR","minor",105439],
[1250000779,"Roubaix","Roubaix","France","FRA","",98089],
[1364282464,"Robāţ Karīm","Robat Karim","Iran","IRN","minor",105393],
[1710508288,"Kroonstad","Kroonstad","South Africa","ZAF","",103992],
[1586311788,"Kandhkot","Kandhkot","Pakistan","PAK","",105011],
[1826775771,"Saint Helens","Saint Helens","United Kingdom","GBR","",102629],
[1392922950,"Toride","Toride","Japan","JPN","",103908],
[1392003262,"Ōnojō","Onojo","Japan","JPN","",101603],
[1558101678,"Granada","Granada","Nicaragua","NIC","admin",105171],
[1792511957,"Erzurum","Erzurum","Turkey","TUR","admin",105317],
[1180814807,"Kongolo","Kongolo","Congo (Kinshasa)","COD","",105202],
[1608836609,"Sultan Kudarat","Sultan Kudarat","Philippines","PHL","",105121],
[1276257182,"Moers","Moers","Germany","DEU","",103725],
[1203577727,"Liberec","Liberec","Czechia","CZE","admin",104261],
[1484653265,"Texcoco","Texcoco","Mexico","MEX","minor",105165],
[1380911437,"Novara","Novara","Italy","ITA","minor",104183],
[1710524815,"Mmabatho","Mmabatho","South Africa","ZAF","",104428],
[1368130668,"Al Fāw","Al Faw","Iraq","IRQ","minor",105080],
[1608467104,"Balanga","Balanga","Philippines","PHL","admin",104173],
[1024911597,"Ndjamba","Ndjamba","Angola","AGO","",105090],
[1840021876,"West Covina","West Covina","United States","USA","",105101],
[1608802236,"Masbate","Masbate","Philippines","PHL","admin",104522],
[1276613066,"Salzgitter","Salzgitter","Germany","DEU","minor",104948],
[1643751718,"Berdsk","Berdsk","Russia","RUS","",103578],
[1840021337,"Sparks","Sparks","United States","USA","",105006],
[1124321390,"Waterloo","Waterloo","Canada","CAN","",104986],
[1826393854,"Worcester","Worcester","United Kingdom","GBR","",101891],
[1356576541,"Tādepallegūdem","Tadepallegudem","India","IND","",104032],
[1792485155,"Malatya","Malatya","Turkey","TUR","admin",104428],
[1250886409,"Nanterre","Nanterre","France","FRA","minor",96807],
[1643900929,"Sergiyev Posad","Sergiyev Posad","Russia","RUS","",104579],
[1840021923,"Wichita Falls","Wichita Falls","United States","USA","",104683],
[1156010739,"Fugangcun","Fugangcun","China","CHN","",102012],
[1804110853,"Konotop","Konotop","Ukraine","UKR","minor",103547],
[1076815881,"Trindade","Trindade","Brazil","BRA","",104488],
[1724386661,"Girona","Girona","Spain","ESP","minor",101932],
[1392272573,"Inzai","Inzai","Japan","JPN","",103677],
[1360776014,"Maumere","Maumere","Indonesia","IDN","minor",104285],
[1364217752,"Khāk-e ‘Alī","Khak-e `Ali","Iran","IRN","",104417],
[1792909050,"Suruç","Suruc","Turkey","TUR","minor",104302],
[1840021551,"San Mateo","San Mateo","United States","USA","",104430],
[1076623771,"Arapongas","Arapongas","Brazil","BRA","",104150],
[1032092344,"Villa Luzuriaga","Villa Luzuriaga","Argentina","ARG","",94403],
[1392003463,"Chikushino","Chikushino","Japan","JPN","",103185],
[1724451934,"San Vicente de Baracaldo","San Vicente de Baracaldo","Spain","ESP","",100907],
[1032500630,"Caseros","Caseros","Argentina","ARG","minor",95785],
[1826642243,"Gillingham","Gillingham","United Kingdom","GBR","",104157],
[1392613742,"Ginowan","Ginowan","Japan","JPN","",99256],
[1384295898,"Abengourou","Abengourou","Côte d'Ivoire","CIV","admin",104020],
[1484316056,"Ciudad Guzmán","Ciudad Guzman","Mexico","MEX","minor",97750],
[1608537090,"Sindangan","Sindangan","Philippines","PHL","",103952],
[1554623632,"Lower Hutt","Lower Hutt","New Zealand","NZL","",103400],
[1528448452,"Delft","Delft","Netherlands","NLD","minor",100011],
[1076563450,"Coronel Fabriciano","Coronel Fabriciano","Brazil","BRA","",103694],
[1504503306,"Bouskoura","Bouskoura","Morocco","MAR","",103026],
[1804779341,"Kamianets-Podilskyi","Kamianets-Podilskyi","Ukraine","UKR","minor",100462],
[1076993685,"Açailandia","Acailandia","Brazil","BRA","",104047],
[1356108133,"Kalyani","Kalyani","India","IND","",100575],
[1144468936,"Kilinochchi","Kilinochchi","Sri Lanka","LKA","",103717],
[1840005803,"Columbia","Columbia","United States","USA","",103991],
[1608244278,"Paniqui","Paniqui","Philippines","PHL","",103003],
[1392903707,"Saijō","Saijo","Japan","JPN","",103760],
[1729791168,"EdDamer","EdDamer","Sudan","SDN","admin",103941],
[1840020501,"Norwalk","Norwalk","United States","USA","",103949],
[1032215828,"Santa Rosa","Santa Rosa","Argentina","ARG","admin",103860],
[1392928065,"Isehara","Isehara","Japan","JPN","",102088],
[1454072947,"Zomba","Zomba","Malawi","MWI","admin",101140],
[1178045241,"Dolisie","Dolisie","Congo (Brazzaville)","COG","admin",103894],
[1356879770,"Negapatam","Negapatam","India","IND","",102905],
[1250711716,"Tourcoing","Tourcoing","France","FRA","",97442],
[1826356320,"Eastbourne","Eastbourne","United Kingdom","GBR","",101547],
[1826902223,"Wigan","Wigan","United Kingdom","GBR","",103608],
[1032241314,"Libertad","Libertad","Argentina","ARG","",100324],
[1608373072,"San Rafael","San Rafael","Philippines","PHL","",103097],
[1724281666,"Telde","Telde","Spain","ESP","",102769],
[1404482650,"Thika","Thika","Kenya","KEN","",99322],
[1498172131,"Bălţi","Balti","Moldova","MDA","admin",102457],
[1156353293,"Yunfu","Yunfu","China","CHN","",103532],
[1156405666,"Dongguazhen","Dongguazhen","China","CHN","",103115],
[1276268768,"Siegen","Siegen","Germany","DEU","minor",102836],
[1484205572,"Tantoyuca","Tantoyuca","Mexico","MEX","minor",103616],
[1360911386,"Biak","Biak","Indonesia","IDN","minor",103610],
[1643581064,"Elista","Elista","Russia","RUS","admin",103132],
[1156025883,"Yishi","Yishi","China","CHN","minor",102090],
[1834461509,"Songea","Songea","Tanzania","TZA","admin",99961],
[1320123250,"Mazatenango","Mazatenango","Guatemala","GTM","admin",103276],
[1356402465,"Būndi","Bundi","India","IND","",103286],
[1840020407,"Rialto","Rialto","United States","USA","",103526],
[1792536241,"Diyarbakır","Diyarbakir","Turkey","TUR","admin",102653],
[1826419818,"Hove","Hove","United Kingdom","GBR","",91900],
[1404924901,"Nyeri","Nyeri","Kenya","KEN","admin",98908],
[1032073218,"Burzaco","Burzaco","Argentina","ARG","",98859],
[1112110662,"Lida","Lida","Belarus","BLR","",103391],
[1840020265,"Manteca","Manteca","United States","USA","",103420],
[1012278908,"Messaad","Messaad","Algeria","DZA","",102453],
[1180549980,"Bumba","Bumba","Congo (Kinshasa)","COD","",103328],
[1076259402,"Araxá","Araxa","Brazil","BRA","",103287],
[1076372357,"Almirante Tamandaré","Almirante Tamandare","Brazil","BRA","",103204],
[1392771396,"Sakado","Sakado","Japan","JPN","",100829],
[1076714150,"São Lourenço da Mata","Sao Lourenco da Mata","Brazil","BRA","",102895],
[1156987450,"Yilong","Yilong","China","CHN","minor",102923],
[1643467643,"Novokuybyshevsk","Novokuybyshevsk","Russia","RUS","",102075],
[1360827216,"Soasio","Soasio","Indonesia","IDN","",103171],
[1380821832,"Piacenza","Piacenza","Italy","ITA","minor",103082],
[1410001039,"Miryang","Miryang","South Korea","KOR","",103069],
[1156080869,"Houzhuang","Houzhuang","China","CHN","",102400],
[1156696271,"Mengdingjie","Mengdingjie","China","CHN","",102992],
[1642046798,"Satu Mare","Satu Mare","Romania","ROU","admin",102411],
[1276244190,"Hildesheim","Hildesheim","Germany","DEU","minor",101990],
[1608326061,"Parang","Parang","Philippines","PHL","",102914],
[1158112865,"Nantou","Nantou","Taiwan","TWN","admin",101606],
[1484934939,"Coatepec","Coatepec","Mexico","MEX","minor",92127],
[1410127055,"Sangju","Sangju","South Korea","KOR","",102892],
[1404232773,"Mumias","Mumias","Kenya","KEN","",99987],
[1356320019,"Bhadreswar","Bhadreswar","India","IND","",101477],
[1608628412,"Guihulñgan","Guihulngan","Philippines","PHL","",102656],
[1840036690,"Arden-Arcade","Arden-Arcade","United States","USA","",102864],
[1643001706,"Noginsk","Noginsk","Russia","RUS","",102592],
[1710328253,"Bethal","Bethal","South Africa","ZAF","",101919],
[1250115605,"Vitry-sur-Seine","Vitry-sur-Seine","France","FRA","",94649],
[1156808087,"Hengnan","Hengnan","China","CHN","",101415],
[1840020618,"El Cajon","El Cajon","United States","USA","",102708],
[1300155901,"Níkaia","Nikaia","Greece","GRC","minor",89380],
[1608768907,"Calasiao","Calasiao","Philippines","PHL","",100471],
[1840019233,"Burbank","Burbank","United States","USA","",102511],
[1840020178,"Longmont","Longmont","United States","USA","",102474],
[1840081607,"Lakewood","Lakewood","United States","USA","",102466],
[1192527369,"Mayarí","Mayari","Cuba","CUB","minor",102354],
[1156252271,"Mositai","Mositai","China","CHN","minor",102214],
[1524561456,"Dhangaḍhi̇̄","Dhangadhi","Nepal","NPL","",101970],
[1076739866,"Igarassu","Igarassu","Brazil","BRA","",102021],
[1364144807,"Kāshmar","Kashmar","Iran","IRN","minor",102282],
[1040149651,"Klagenfurt","Klagenfurt","Austria","AUT","admin",101403],
[1124001200,"Delta","Delta","Canada","CAN","",102238],
[1356065865,"Chilakalūrupet","Chilakalurupet","India","IND","",101398],
[1586451544,"Chishtian","Chishtian","Pakistan","PAK","",101659],
[1434908655,"Şabrātah","Sabratah","Libya","LBY","",102038],
[1056866572,"Leuven","Leuven","Belgium","BEL","minor",100291],
[1410204364,"Boryeong","Boryeong","South Korea","KOR","minor",101852],
[1156801687,"Jingping","Jingping","China","CHN","minor",101297],
[1364856875,"Shūshtar","Shushtar","Iran","IRN","minor",101878],
[1458126062,"Teluk Intan","Teluk Intan","Malaysia","MYS","",101659],
[1076231231,"Santo Antônio de Jesus","Santo Antonio de Jesus","Brazil","BRA","",101548],
[1076782502,"Assis","Assis","Brazil","BRA","",101597],
[1504098746,"Oued Zem","Oued Zem","Morocco","MAR","",95267],
[1840019827,"Renton","Renton","United States","USA","",101751],
[1496374417,"Erdenet","Erdenet","Mongolia","MNG","admin",101260],
[1124393373,"Chatham","Chatham","Canada","CAN","",101647],
[1512077267,"‘Ibrī","`Ibri","Oman","OMN","admin",101640],
[1840021994,"Vista","Vista","United States","USA","",101638],
[1643006066,"Zheleznogorsk","Zheleznogorsk","Russia","RUS","",100740],
[1840020108,"Logan","Logan","United States","USA","",101616],
[1360337679,"Sungai Penuh","Sungai Penuh","Indonesia","IDN","",101325],
[1598466091,"Lae","Lae","Papua New Guinea","PNG","admin",100677],
[1840021772,"Prescott Valley","Prescott Valley","United States","USA","",101539],
[1068929509,"Trinidad","Trinidad","Bolivia","BOL","admin",101454],
[1203328061,"Olomouc","Olomouc","Czechia","CZE","admin",100514],
[1076067021,"Balsas","Balsas","Brazil","BRA","",101456],
[1100973719,"Pleven","Pleven","Bulgaria","BGR","admin",101299],
[1840021498,"Vacaville","Vacaville","United States","USA","",101444],
[1608664930,"Santa Cruz","Santa Cruz","Philippines","PHL","",101125],
[1484137795,"San Luis de la Paz","San Luis de la Paz","Mexico","MEX","minor",101370],
[1012469007,"Aïn Oussera","Ain Oussera","Algeria","DZA","",101239],
[1156559810,"Liancheng","Liancheng","China","CHN","minor",101221],
[1392003443,"Kawachinagano","Kawachinagano","Japan","JPN","",100415],
[1120996697,"Kousséri","Kousseri","Cameroon","CMR","",101246],
[1380275919,"Mestre","Mestre","Italy","ITA","",89376],
[1788930929,"Radès","Rades","Tunisia","TUN","",97588],
[1156185980,"Weifen","Weifen","China","CHN","minor",100615],
[1840021020,"Edinburg","Edinburg","United States","USA","",101170],
[1392003144,"Kanoya","Kanoya","Japan","JPN","",100880],
[1276587494,"Gütersloh","Gutersloh","Germany","DEU","minor",100194],
[1012958880,"Oum el Bouaghi","Oum el Bouaghi","Algeria","DZA","admin",100821],
[1840007260,"Carmel","Carmel","United States","USA","",101068],
[1840021094,"Spokane Valley","Spokane Valley","United States","USA","",101060],
[1380597324,"Ancona","Ancona","Italy","ITA","admin",100924],
[1840022146,"San Angelo","San Angelo","United States","USA","",101004],
[1356161713,"Port Blair","Port Blair","India","IND","admin",100608],
[1792834766,"Karabük","Karabuk","Turkey","TUR","admin",100749],
[1076003733,"Muriaé","Muriae","Brazil","BRA","",100765],
[1112250470,"Salihorsk","Salihorsk","Belarus","BLR","minor",100824],
[1768253626,"Kpalimé","Kpalime","Togo","TGO","",100479],
[1076793612,"Umuarama","Umuarama","Brazil","BRA","",100676],
[1276674534,"Kaiserslautern","Kaiserslautern","Germany","DEU","minor",100030],
[1356689564,"Gangtok","Gangtok","India","IND","admin",100286],
[1686087214,"Diourbel","Diourbel","Senegal","SEN","admin",100445],
[1840002577,"La Crosse","La Crosse","United States","USA","",100693],
[1364602437,"Ahar","Ahar","Iran","IRN","minor",100641],
[1392978695,"Kōnan","Konan","Japan","JPN","",97435],
[1364152430,"Masjed Soleymān","Masjed Soleyman","Iran","IRN","minor",100497],
[1076161359,"Mairiporã","Mairipora","Brazil","BRA","",100179],
[1364064948,"Torbat-e Jām","Torbat-e Jam","Iran","IRN","minor",100449],
[1840081696,"Edison","Edison","United States","USA","",100447],
[1840018644,"Idaho Falls","Idaho Falls","United States","USA","",100442],
[1608647250,"Lamitan","Lamitan","Philippines","PHL","",100150],
[1840002996,"Holland","Holland","United States","USA","",100432],
[1124404130,"Red Deer","Red Deer","Canada","CAN","",100418],
[1840001678,"Charlottesville","Charlottesville","United States","USA","",100416],
[1860513278,"Shahrisabz","Shahrisabz","Uzbekistan","UZB","",100300],
[1608300985,"Talipao","Talipao","Philippines","PHL","minor",100088],
[1840020746,"Longview","Longview","United States","USA","",100330],
[1250710438,"Créteil","Creteil","France","FRA","minor",92265],
[1826312785,"Lincoln","Lincoln","United Kingdom","GBR","",97541],
[1112965860,"Navapolatsk","Navapolatsk","Belarus","BLR","",98122],
[1076601172,"Formosa","Formosa","Brazil","BRA","",100085],
[1156911168,"Nanxicun","Nanxicun","China","CHN","",97747],
[1840081695,"Woodbridge","Woodbridge","United States","USA","",100089],
[1076125117,"Bacabal","Bacabal","Brazil","BRA","",100014],
[1840021518,"Tracy","Tracy","United States","USA","",100049],
[1124735582,"Kamloops","Kamloops","Canada","CAN","",100046],
[1826491250,"Rayleigh","Rayleigh","United Kingdom","GBR","",95580],
[1554475997,"Dunedin","Dunedin","New Zealand","NZL","admin",99885],
[1642348361,"Râmnicu Vâlcea","Ramnicu Valcea","Romania","ROU","admin",98776],
[1620291266,"Viseu","Viseu","Portugal","PRT","admin",99274],
[1392003382,"Ashiya","Ashiya","Japan","JPN","",94116],
[1356241829,"Dhuliān","Dhulian","India","IND","",95706],
[1076607187,"Bayeux","Bayeux","Brazil","BRA","",96140],
[1356332206,"Kohīma","Kohima","India","IND","admin",99039],
[1826374836,"Hemel Hempstead","Hemel Hempstead","United Kingdom","GBR","",94932],
[1250470371,"Aubervilliers","Aubervilliers","France","FRA","",87572],
[1031509213,"Mingəçevir","Mingacevir","Azerbaijan","AZE","admin",98800],
[1894816262,"Chipata","Chipata","Zambia","ZMB","admin",98416],
[1643001221,"Khanty-Mansiysk","Khanty-Mansiysk","Russia","RUS","admin",98692],
[1032336348,"Ciudad General Belgrano","Ciudad General Belgrano","Argentina","ARG","",92957],
[1705454394,"Maribor","Maribor","Slovenia","SVN","admin",96211],
[1144191486,"Galle","Galle","Sri Lanka","LKA","admin",93118],
[1392563124,"Yashio","Yashio","Japan","JPN","",93283],
[1840001926,"Bismarck","Bismarck","United States","USA","admin",98345],
[1376303805,"Herẕliyya","Herzliyya","Israel","ISR","",93989],
[1704249231,"Yên Bái","Yen Bai","Vietnam","VNM","admin",96540],
[1724547778,"Santiago de Compostela","Santiago de Compostela","Spain","ESP","admin",97858],
[1404380224,"Malindi","Malindi","Kenya","KEN","",94016],
[1608432162,"Catarman","Catarman","Philippines","PHL","admin",97879],
[1826611282,"Bath","Bath","United Kingdom","GBR","",94782],
[1524563587,"Janakpur","Janakpur","Nepal","NPL","admin",97776],
[1724235367,"San Fernando","San Fernando","Spain","ESP","",94867],
[1388715163,"Half Way Tree","Half Way Tree","Jamaica","JAM","admin",96494],
[1840020171,"Orem","Orem","United States","USA","",97828],
[1392003400,"Inagi","Inagi","Japan","JPN","",92604],
[1704210026,"Vị Thanh","Vi Thanh","Vietnam","VNM","admin",97200],
[1152095800,"San Joaquín","San Joaquin","Chile","CHL","",94492],
[1604505281,"Tumbes","Tumbes","Peru","PER","admin",96946],
[1608085930,"Isulan","Isulan","Philippines","PHL","admin",97490],
[1484348795,"Tecomán","Tecoman","Mexico","MEX","minor",91321],
[1320957558,"Petapa","Petapa","Guatemala","GTM","minor",94228],
[1504101128,"Sidi Slimane","Sidi Slimane","Morocco","MAR","",92989],
[1031145251,"Xırdalan","Xirdalan","Azerbaijan","AZE","admin",95200],
[1156184335,"Wangqing","Wangqing","China","CHN","minor",88732],
[1392000109,"Komae","Komae","Japan","JPN","",83677],
[1250390247,"Colombes","Colombes","France","FRA","",86052],
[1826453946,"Darlington","Darlington","United Kingdom","GBR","",92363],
[1360021193,"Sibolga","Sibolga","Indonesia","IDN","",94971],
[1180006418,"Bunia","Bunia","Congo (Kinshasa)","COD","admin",96764],
[1170322340,"Arauca","Arauca","Colombia","COL","admin",96814],
[1152154801,"La Reina","La Reina","Chile","CHL","",92787],
[1788911754,"La Marsa","La Marsa","Tunisia","TUN","",92987],
[1156736933,"Yishui","Yishui","China","CHN","",94115],
[1356764529,"Marmagao","Marmagao","India","IND","",94393],
[1250809881,"Levallois-Perret","Levallois-Perret","France","FRA","",65817],
[1032776804,"San Francisco Solano","San Francisco Solano","Argentina","ARG","",91322],
[1818759149,"Ziftá","Zifta","Egypt","EGY","",93740],
[1404614327,"Kakamega","Kakamega","Kenya","KEN","admin",91778],
[1276221707,"Schwerin","Schwerin","Germany","DEU","admin",95818],
[1504842310,"Guercif","Guercif","Morocco","MAR","",90880],
[1348968301,"Székesfehérvár","Szekesfehervar","Hungary","HUN","admin",95545],
[1504005759,"Errachidia","Errachidia","Morocco","MAR","admin",92374],
[1156920212,"Lingtang","Lingtang","China","CHN","",93835],
[1392512633,"Yotsukaidō","Yotsukaido","Japan","JPN","",93233],
[1203398046,"České Budějovice","Ceske Budejovice","Czechia","CZE","admin",94229],
[1032471024,"Río Gallegos","Rio Gallegos","Argentina","ARG","admin",95796],
[1156163523,"Fenggang","Fenggang","China","CHN","",93148],
[1788300169,"Tataouine","Tataouine","Tunisia","TUN","admin",95775],
[1276803720,"Ludwigsburg","Ludwigsburg","Germany","DEU","minor",93499],
[1840019240,"Compton","Compton","United States","USA","",95605],
[1276510955,"Esslingen","Esslingen","Germany","DEU","minor",93542],
[1392999336,"Nisshin","Nisshin","Japan","JPN","",92823],
[1156479306,"Xiancun","Xiancun","China","CHN","",91109],
[1392870664,"Ōbu","Obu","Japan","JPN","",92562],
[1840016000,"Sunrise","Sunrise","United States","USA","",95166],
[1826386301,"Wimbledon","Wimbledon","United Kingdom","GBR","",92765],
[1484804575,"Ciudad Lázaro Cárdenas","Ciudad Lazaro Cardenas","Mexico","MEX","",79200],
[1834044142,"Mtwara","Mtwara","Tanzania","TZA","admin",92602],
[1788439087,"Ben Arous","Ben Arous","Tunisia","TUN","admin",88322],
[1826570072,"Watford","Watford","United Kingdom","GBR","",90301],
[1840000461,"Quincy","Quincy","United States","USA","",94470],
[1032641177,"Monte Chingolo","Monte Chingolo","Argentina","ARG","",85060],
[1840000409,"Lynn","Lynn","United States","USA","",94299],
[1642729144,"Drobeta-Turnu Severin","Drobeta-Turnu Severin","Romania","ROU","admin",92617],
[1504909564,"Ben Guerir","Ben Guerir","Morocco","MAR","",88626],
[1051691929,"Vanadzor","Vanadzor","Armenia","ARM","admin",90525],
[1826499763,"Hastings","Hastings","United Kingdom","GBR","",91053],
[1642721443,"Suceava","Suceava","Romania","ROU","admin",92121],
[1784909196,"Al Fujayrah","Al Fujayrah","United Arab Emirates","ARE","admin",93673],
[1076418225,"Brusque","Brusque","Brazil","BRA","",88284],
[1528243202,"Amstelveen","Amstelveen","Netherlands","NLD","minor",91675],
[1233809410,"Tartu","Tartu","Estonia","EST","admin",91407],
[1694028641,"Makeni","Makeni","Sierra Leone","SLE","admin",87679],
[1076274068,"Itanhaém","Itanhaem","Brazil","BRA","",90385],
[1203430618,"Hradec Králové","Hradec Kralove","Czechia","CZE","admin",92683],
[1826240370,"Nuneaton","Nuneaton","United Kingdom","GBR","",86552],
[1840021870,"South Gate","South Gate","United States","USA","",93444],
[1156790418,"Kargilik","Kargilik","China","CHN","",75730],
[1158446494,"Miaoli","Miaoli","Taiwan","TWN","admin",90963],
[1724144891,"Ciudad de Melilla","Ciudad de Melilla","Spain","ESP","",86261],
[1826117667,"Stevenage","Stevenage","United Kingdom","GBR","",89663],
[1840019836,"Kirkland","Kirkland","United States","USA","",93010],
[1203734193,"Ústí nad Labem","Usti nad Labem","Czechia","CZE","admin",91982],
[1203857442,"Pardubice","Pardubice","Czechia","CZE","admin",91755],
[1643216966,"Magadan","Magadan","Russia","RUS","admin",92782],
[1498257678,"Bender","Bender","Moldova","MDA","admin",91882],
[1440120065,"Panevėžys","Panevezys","Lithuania","LTU","admin",91054],
[1504278611,"Oulad Teïma","Oulad Teima","Morocco","MAR","",89387],
[1144005506,"Jaffna","Jaffna","Sri Lanka","LKA","admin",88138],
[1620896457,"Queluz","Queluz","Portugal","PRT","",78273],
[1392003111,"Settsu","Settsu","Japan","JPN","",86168],
[1826069842,"Hartlepool","Hartlepool","United Kingdom","GBR","",88855],
[1392003192,"Wakō","Wako","Japan","JPN","",84120],
[1250420439,"Aulnay-sous-Bois","Aulnay-sous-Bois","France","FRA","",86278],
[1072124168,"Francistown","Francistown","Botswana","BWA","admin",89979],
[1826441668,"Chester","Chester","United Kingdom","GBR","",87507],
[1643040713,"Lobnya","Lobnya","Russia","RUS","",88220],
[1608268539,"Kalibo","Kalibo","Philippines","PHL","admin",89127],
[1752079041,"Jönköping","Jonkoping","Sweden","SWE","admin",89780],
[1392003383,"Ama","Ama","Japan","JPN","",87668],
[1752273881,"Umeå","Umea","Sweden","SWE","admin",90412],
[1250812174,"Poitiers","Poitiers","France","FRA","minor",88665],
[1300003373,"Glyfáda","Glyfada","Greece","GRC","minor",87305],
[1392360419,"Kitanagoya","Kitanagoya","Japan","JPN","",86060],
[1032150292,"Remedios de Escalada","Remedios de Escalada","Argentina","ARG","",81465],
[1218156392,"Babahoyo","Babahoyo","Ecuador","ECU","admin",90191],
[1356655968,"Jangipur","Jangipur","India","IND","",88165],
[1484349924,"Acayucan","Acayucan","Mexico","MEX","minor",83817],
[1840021969,"Westminster","Westminster","United States","USA","",90643],
[1100364404,"Dobrich","Dobrich","Bulgaria","BGR","admin",90419],
[1484427246,"Xicotepec de Juárez","Xicotepec de Juarez","Mexico","MEX","",81455],
[1840005840,"Germantown","Germantown","United States","USA","",90582],
[1760695473,"Ţarţūs","Tartus","Syria","SYR","admin",89457],
[1724094287,"Fuengirola","Fuengirola","Spain","ESP","",82585],
[1392233405,"Higashiyamato","Higashiyamato","Japan","JPN","",84260],
[1380650072,"Catanzaro","Catanzaro","Italy","ITA","admin",89718],
[1688926375,"Valjevo","Valjevo","Serbia","SRB","admin",90312],
[1840021866,"Santa Monica","Santa Monica","United States","USA","",90401],
[1417653652,"Jalal-Abad","Jalal-Abad","Kyrgyzstan","KGZ","admin",89004],
[1484003075,"Tala","Tala","Mexico","MEX","minor",80365],
[1703231427,"Prešov","Presov","Slovakia","SVK","admin",88680],
[1795885709,"Balkanabat","Balkanabat","Turkmenistan","TKM","admin",89785],
[1608307222,"Ipil","Ipil","Philippines","PHL","admin",89401],
[1392922621,"Takasagochō-takasemachi","Takasagocho-takasemachi","Japan","JPN","",87220],
[1100110215,"Sliven","Sliven","Bulgaria","BGR","admin",89540],
[1056687706,"Mechelen","Mechelen","Belgium","BEL","minor",86921],
[1400470384,"As Salţ","As Salt","Jordan","JOR","admin",88900],
[1804401780,"Mukacheve","Mukacheve","Ukraine","UKR","minor",86257],
[1156031027,"Tangxing","Tangxing","China","CHN","minor",86862],
[1422269278,"Nabatîyé","Nabatiye","Lebanon","LBN","admin",80000],
[1156044428,"Daxincun","Daxincun","China","CHN","",76536],
[1300109851,"Vólos","Volos","Greece","GRC","minor",86046],
[1634261569,"Al Wakrah","Al Wakrah","Qatar","QAT","admin",87970],
[1620680440,"Viana do Castelo","Viana do Castelo","Portugal","PRT","admin",88725],
[1840015150,"Miami Beach","Miami Beach","United States","USA","",88885],
[1484021647,"Apizaco","Apizaco","Mexico","MEX","minor",81565],
[1840021538,"San Leandro","San Leandro","United States","USA","",88815],
[1826391298,"Aylesbury","Aylesbury","United Kingdom","GBR","",83407],
[1380068715,"Sesto San Giovanni","Sesto San Giovanni","Italy","ITA","",81773],
[1392003138,"Warabi","Warabi","Japan","JPN","",74996],
[1608461552,"Prosperidad","Prosperidad","Philippines","PHL","admin",88321],
[1120406967,"Bertoua","Bertoua","Cameroon","CMR","admin",88462],
[1608579431,"Alabel","Alabel","Philippines","PHL","admin",88294],
[1250143827,"Versailles","Versailles","France","FRA","minor",85205],
[1600075989,"Coronel Oviedo","Coronel Oviedo","Paraguay","PRY","admin",88101],
[1760409750,"Dārayyā","Darayya","Syria","SYR","minor",84044],
[1392003387,"Ayase","Ayase","Japan","JPN","",84257],
[1792520282,"Mersin","Mersin","Turkey","TUR","admin",86692],
[1724324416,"Ciudad de Ceuta","Ciudad de Ceuta","Spain","ESP","",83517],
[1120924207,"Ébolowa","Ebolowa","Cameroon","CMR","admin",87875],
[1170000611,"Sabaneta","Sabaneta","Colombia","COL","minor",82375],
[1380905401,"Torre del Greco","Torre del Greco","Italy","ITA","",85332],
[1608244406,"Maasin","Maasin","Philippines","PHL","admin",87446],
[1862865294,"San Juan de los Morros","San Juan de los Morros","Venezuela","VEN","admin",87739],
[1840018845,"Citrus Heights","Citrus Heights","United States","USA","",87796],
[1484364230,"Salina Cruz","Salina Cruz","Mexico","MEX","",81063],
[1840000830,"State College","State College","United States","USA","",87723],
[1724214083,"San Baudilio de Llobregat","San Baudilio de Llobregat","Spain","ESP","",83755],
[1204036358,"Lokossa","Lokossa","Benin","BEN","admin",86971],
[1250104726,"Clichy","Clichy","France","FRA","",62485],
[1858958595,"Maldonado","Maldonado","Uruguay","URY","admin",86782],
[1826565522,"Burnley","Burnley","United Kingdom","GBR","",82002],
[1792546179,"Mardin","Mardin","Turkey","TUR","admin",86948],
[1156026460,"Xishancun","Xishancun","China","CHN","",83822],
[1032462589,"Ezpeleta","Ezpeleta","Argentina","ARG","",79557],
[1156050784,"Mingxing","Mingxing","China","CHN","minor",82981],
[1764821078,"Nakhon Sawan","Nakhon Sawan","Thailand","THA","admin",86439],
[1826053841,"Saint Albans","Saint Albans","United Kingdom","GBR","",82146],
[1032320584,"Villa Celina","Villa Celina","Argentina","ARG","",78699],
[1250923546,"Issy-les-Moulineaux","Issy-les-Moulineaux","France","FRA","",68260],
[1688071221,"Loznica","Loznica","Serbia","SRB","admin",86413],
[1862849758,"Tucupita","Tucupita","Venezuela","VEN","admin",86487],
[1760605225,"Ath Thawrah","Ath Thawrah","Syria","SYR","minor",84000],
[1484508699,"Tacámbaro de Codallos","Tacambaro de Codallos","Mexico","MEX","minor",76661],
[1484980436,"Ciudad Lerdo","Ciudad Lerdo","Mexico","MEX","minor",79669],
[1392703321,"Owariasahi","Owariasahi","Japan","JPN","",82336],
[1642444635,"Piatra Neamţ","Piatra Neamt","Romania","ROU","admin",85055],
[1840020486,"Hawthorne","Hawthorne","United States","USA","",86068],
[1246167296,"Kouvola","Kouvola","Finland","FIN","admin",85855],
[1643787798,"Kuznetsk","Kuznetsk","Russia","RUS","",82276],
[1724171411,"Toledo","Toledo","Spain","ESP","admin",85449],
[1380033378,"Busto Arsizio","Busto Arsizio","Italy","ITA","",83045],
[1012906892,"El Bayadh","El Bayadh","Algeria","DZA","admin",85577],
[1380994905,"Como","Como","Italy","ITA","minor",83320],
[1246259412,"Pori","Pori","Finland","FIN","admin",85363],
[1818076217,"Manfalūţ","Manfalut","Egypt","EGY","",82585],
[1356102140,"Baj Baj","Baj Baj","India","IND","",76837],
[1484935305,"Cozumel","Cozumel","Mexico","MEX","minor",77236],
[1048992336,"Al Muḩarraq","Al Muharraq","Bahrain","BHR","",75000],
[1686269931,"Louga","Louga","Senegal","SEN","admin",85075],
[1800554483,"Mbarara","Mbarara","Uganda","UGA","admin",83700],
[1840021878,"Whittier","Whittier","United States","USA","",85098],
[1840003511,"Clifton","Clifton","United States","USA","",85052],
[1604871130,"Puerto Maldonado","Puerto Maldonado","Peru","PER","admin",85024],
[1524551914,"Heṭauḍā","Hetauda","Nepal","NPL","admin",84671],
[1780795054,"Chaguanas","Chaguanas","Trinidad And Tobago","TTO","admin",83489],
[1376505625,"Nazareth","Nazareth","Israel","ISR","admin",83400],
[1804670442,"Uman","Uman","Ukraine","UKR","minor",82762],
[1608879246,"Nabunturan","Nabunturan","Philippines","PHL","admin",84340],
[1204541753,"Ouidah","Ouidah","Benin","BEN","admin",83503],
[1392219533,"Nagaoka","Nagaoka","Japan","JPN","",80423],
[1191917921,"Osijek","Osijek","Croatia","HRV","admin",84104],
[1804958186,"Chervonohrad","Chervonohrad","Ukraine","UKR","minor",82395],
[1756544536,"Lucerne","Lucerne","Switzerland","CHE","admin",81691],
[1364656518,"Būmahen","Bumahen","Iran","IRN","",79034],
[1392309515,"Kunitachi","Kunitachi","Japan","JPN","",75133],
[1484547809,"Tecate","Tecate","Mexico","MEX","minor",81059],
[1124400266,"Newmarket","Newmarket","Canada","CAN","",84224],
[1840020329,"Milpitas","Milpitas","United States","USA","",84196],
[1214900129,"Barahona","Barahona","Dominican Republic","DOM","admin",83619],
[1288938914,"Ho","Ho","Ghana","GHA","admin",83715],
[1764327831,"Phuket","Phuket","Thailand","THA","admin",77610],
[1788939893,"Le Bardo","Le Bardo","Tunisia","TUN","",73953],
[1466546429,"Kayes","Kayes","Mali","MLI","admin",77207],
[1250631569,"Champigny-sur-Marne","Champigny-sur-Marne","France","FRA","",77039],
[1826765672,"Chatham","Chatham","United Kingdom","GBR","",76792],
[1840019222,"Alhambra","Alhambra","United States","USA","",83750],
[1703289183,"Žilina","Zilina","Slovakia","SVK","admin",82704],
[1826037459,"Batley","Batley","United Kingdom","GBR","",80485],
[1076924823,"Esteio","Esteio","Brazil","BRA","",80755],
[1642047399,"Reşiţa","Resita","Romania","ROU","admin",83324],
[1392023081,"Shinkai","Shinkai","Japan","JPN","",75247],
[1450106928,"Antsiranana","Antsiranana","Madagascar","MDG","admin",82937],
[1524402867,"Kirtipur","Kirtipur","Nepal","NPL","",65602],
[1380040521,"Casoria","Casoria","Italy","ITA","",77087],
[1528918720,"Purmerend","Purmerend","Netherlands","NLD","minor",80117],
[1250924511,"Rueil-Malmaison","Rueil-Malmaison","France","FRA","",77986],
[1826817883,"Scunthorpe","Scunthorpe","United Kingdom","GBR","",79977],
[1826052828,"Dudley","Dudley","United Kingdom","GBR","",79379],
[1764039814,"Ban Talat Rangsit","Ban Talat Rangsit","Thailand","THA","",79319],
[1642174891,"Târgu Jiu","Targu Jiu","Romania","ROU","admin",82504],
[1484276023,"Silao","Silao","Mexico","MEX","minor",74242],
[1840035234,"Upper Darby","Upper Darby","United States","USA","",82887],
[1204597697,"Abomey","Abomey","Benin","BEN","admin",82154],
[1392003108,"Kiyose","Kiyose","Japan","JPN","",75389],
[1840020332,"Mountain View","Mountain View","United States","USA","",82739],
[1100000004,"Shumen","Shumen","Bulgaria","BGR","admin",82497],
[1356546052,"Tanuku","Tanuku","India","IND","",77962],
[1484386317,"Juchitán de Zaragoza","Juchitan de Zaragoza","Mexico","MEX","minor",74825],
[1124260555,"White Rock","White Rock","Canada","CAN","",82368],
[1008409270,"Elbasan","Elbasan","Albania","ALB","admin",78703],
[1076847580,"Campo Formoso","Campo Formoso","Brazil","BRA","",72271],
[1826189795,"Weston-super-Mare","Weston-super-Mare","United Kingdom","GBR","",76143],
[1300842760,"Néa Ionía","Nea Ionia","Greece","GRC","minor",67134],
[1826396004,"South Shields","South Shields","United Kingdom","GBR","",75337],
[1250687119,"Saint-Maur-des-Fossés","Saint-Maur-des-Fosses","France","FRA","",75298],
[1528910170,"Schiedam","Schiedam","Netherlands","NLD","minor",77999],
[1156486055,"Huolu","Huolu","China","CHN","minor",78250],
[1840019324,"Buena Park","Buena Park","United States","USA","",81788],
[1840005845,"Silver Spring","Silver Spring","United States","USA","",81773],
[1818729843,"Banī Mazār","Bani Mazar","Egypt","EGY","",79553],
[1428924928,"Daugavpils","Daugavpils","Latvia","LVA","admin",80627],
[1643986494,"Ivanteyevka","Ivanteyevka","Russia","RUS","",76612],
[1484279186,"Los Reyes de Salgado","Los Reyes de Salgado","Mexico","MEX","",69723],
[1380556172,"Cinisello Balsamo","Cinisello Balsamo","Italy","ITA","",75723],
[1392003075,"Kashiba","Kashiba","Japan","JPN","",78346],
[1792629133,"Hakkari","Hakkari","Turkey","TUR","admin",81424],
[1250144343,"Drancy","Drancy","France","FRA","",72109],
[1840003123,"Somerville","Somerville","United States","USA","",81360],
[1826242195,"Bury","Bury","United Kingdom","GBR","",78729],
[1300443208,"Chalándri","Chalandri","Greece","GRC","minor",74192],
[1788996070,"Le Kram","Le Kram","Tunisia","TUN","",74132],
[1826549531,"Paisley","Paisley","United Kingdom","GBR","",76220],
[1840015136,"Deerfield Beach","Deerfield Beach","United States","USA","",81066],
[1642534646,"Târgovişte","Targoviste","Romania","ROU","admin",79610],
[1372499968,"Galway","Galway","Ireland","IRL","admin",79504],
[1204752595,"Natitingou","Natitingou","Benin","BEN","admin",80892],
[1724552367,"Rubí","Rubi","Spain","ESP","",78549],
[1620760195,"Barreiro","Barreiro","Portugal","PRT","minor",78764],
[1858756515,"Paysandú","Paysandu","Uruguay","URY","admin",76429],
[1840009186,"Cicero","Cicero","United States","USA","",80796],
[1768070717,"Atakpamé","Atakpame","Togo","TGO","admin",80683],
[1642736232,"Focşani","Focsani","Romania","ROU","admin",79315],
[1608889253,"Cabadbaran","Cabadbaran","Philippines","PHL","admin",80354],
[1484506998,"Tejupilco","Tejupilco","Mexico","MEX","minor",71077],
[1380117871,"Ragusa","Ragusa","Italy","ITA","minor",73638],
[1434206265,"Zuwārah","Zuwarah","Libya","LBY","admin",80310],
[1156514157,"Shancheng","Shancheng","China","CHN","",74459],
[1504670555,"Fnidq","Fnidq","Morocco","MAR","",77436],
[1862027409,"Puerto Ayacucho","Puerto Ayacucho","Venezuela","VEN","admin",80000],
[1320041079,"Chiquimula","Chiquimula","Guatemala","GTM","admin",79815],
[1840000408,"Lawrence","Lawrence","United States","USA","",80028],
[1504300626,"Sidi Qacem","Sidi Qacem","Morocco","MAR","",75672],
[1392003429,"Izumiōtsu","Izumiotsu","Japan","JPN","",74175],
[1826359576,"Mansfield","Mansfield","United Kingdom","GBR","",77551],
[1826880896,"Bracknell","Bracknell","United Kingdom","GBR","",77256],
[1724815050,"Avilés","Aviles","Spain","ESP","",76874],
[1608000709,"Balagtas","Balagtas","Philippines","PHL","",77018],
[1764251992,"Nakhon Pathom","Nakhon Pathom","Thailand","THA","admin",78780],
[1788440786,"Mahdia","Mahdia","Tunisia","TUN","admin",79545],
[1840018713,"Cheyenne","Cheyenne","United States","USA","admin",79484],
[1764611048,"Ubon Ratchathani","Ubon Ratchathani","Thailand","THA","admin",79023],
[1032639381,"Lomas del Mirador","Lomas del Mirador","Argentina","ARG","",71479],
[1826843688,"Carlisle","Carlisle","United Kingdom","GBR","",75399],
[1404464692,"Garissa","Garissa","Kenya","KEN","admin",65881],
[1840021967,"Tustin","Tustin","United States","USA","",79348],
[1840020515,"Lakewood","Lakewood","United States","USA","",79307],
[1180477995,"Lisala","Lisala","Congo (Kinshasa)","COD","admin",79235],
[1826488452,"East Kilbride","East Kilbride","United Kingdom","GBR","",75120],
[1348565183,"Szombathely","Szombathely","Hungary","HUN","admin",78324],
[1703015198,"Banská Bystrica","Banska Bystrica","Slovakia","SVK","admin",78327],
[1484811972,"Frontera","Frontera","Mexico","MEX","minor",75242],
[1840014098,"Pine Hills","Pine Hills","United States","USA","",78995],
[1392003379,"Katano","Katano","Japan","JPN","",76002],
[1376791991,"Ra‘ananna","Ra`ananna","Israel","ISR","",74000],
[1484668149,"Perote","Perote","Mexico","MEX","minor",72795],
[1620555869,"Aveiro","Aveiro","Portugal","PRT","admin",78450],
[1686195160,"Tambacounda","Tambacounda","Senegal","SEN","admin",78800],
[1250623782,"La Rochelle","La Rochelle","France","FRA","minor",76114],
[1834127573,"Mpanda","Mpanda","Tanzania","TZA","admin",73338],
[1826585602,"Burton upon Trent","Burton upon Trent","United Kingdom","GBR","",75074],
[1250041150,"Pau","Pau","France","FRA","minor",76275],
[1840000782,"New Rochelle","New Rochelle","United States","USA","",78557],
[1762998971,"Bokhtar","Bokhtar","Tajikistan","TJK","admin",75450],
[1504563452,"Moulay Abdallah","Moulay Abdallah","Morocco","MAR","",74671],
[1840001347,"Lebanon","Lebanon","United States","USA","",78302],
[1524020578,"Godāwari̇̄","Godawari","Nepal","NPL","admin",78018],
[1818762526,"Maghāghah","Maghaghah","Egypt","EGY","",75657],
[1288765586,"Wa","Wa","Ghana","GHA","admin",78107],
[1703890031,"Nitra","Nitra","Slovakia","SVK","admin",77374],
[1528990721,"Lelystad","Lelystad","Netherlands","NLD","admin",77893],
[1826086541,"Crewe","Crewe","United Kingdom","GBR","",73241],
[1276216238,"Gladbeck","Gladbeck","Germany","DEU","",75687],
[1484007926,"San Miguel de Allende","San Miguel de Allende","Mexico","MEX","minor",69811],
[1756343098,"Sankt Gallen","Sankt Gallen","Switzerland","CHE","admin",75833],
[1250487828,"Cannes","Cannes","France","FRA","",73965],
[1752586931,"Gävle","Gavle","Sweden","SWE","admin",77586],
[1840018913,"Alameda","Alameda","United States","USA","",77624],
[1250189603,"Montrouge","Montrouge","France","FRA","",48734],
[1826124765,"Newcastle under Lyme","Newcastle under Lyme","United Kingdom","GBR","",75082],
[1826765513,"Harrogate","Harrogate","United Kingdom","GBR","",73576],
[1840021581,"Watsonville","Watsonville","United States","USA","",77352],
[1024050171,"Caxito","Caxito","Angola","AGO","admin",77276],
[1208757169,"Esbjerg","Esbjerg","Denmark","DNK","minor",72205],
[1214217168,"Mao","Mao","Dominican Republic","DOM","admin",76863],
[1392003539,"Okegawa","Okegawa","Japan","JPN","",74115],
[1608265120,"Virac","Virac","Philippines","PHL","admin",76520],
[1840018833,"Davis","Davis","United States","USA","",76997],
[1858563314,"Las Piedras","Las Piedras","Uruguay","URY","",71268],
[1826969205,"Rugby","Rugby","United Kingdom","GBR","",70627],
[1140239733,"Berbérati","Berberati","Central African Republic","CAF","admin",76918],
[1484802864,"Tamazunchale","Tamazunchale","Mexico","MEX","minor",72685],
[1688827840,"Zrenjanin","Zrenjanin","Serbia","SRB","admin",76511],
[1788968797,"Fouchana","Fouchana","Tunisia","TUN","",74868],
[1434563640,"Surt","Surt","Libya","LBY","admin",76788],
[1231437227,"Nek’emtē","Nek'emte","Ethiopia","ETH","",73018],
[1688356974,"Pančevo","Pancevo","Serbia","SRB","admin",76203],
[1792285496,"Karaman","Karaman","Turkey","TUR","admin",76525],
[1484115665,"Dolores Hidalgo Cuna de la Independencia Nacional","Dolores Hidalgo Cuna de la Independencia Nacional","Mexico","MEX","minor",67101],
[1148461151,"Abéché","Abeche","Chad","TCD","admin",76492],
[1554138183,"Palmerston North","Palmerston North","New Zealand","NZL","admin",76236],
[1392003353,"Jōyō","Joyo","Japan","JPN","",74187],
[1840019230,"Bellflower","Bellflower","United States","USA","",76435],
[1300258604,"Palaió Fáliro","Palaio Faliro","Greece","GRC","minor",64021],
[1826336439,"Tamworth","Tamworth","United Kingdom","GBR","",73924],
[1392192403,"Chiryū","Chiryu","Japan","JPN","",71907],
[1462941721,"Un’goofaaru","Un'goofaaru","Maldives","MDV","admin",0],
[1376321361,"Ramla","Ramla","Israel","ISR","admin",75500],
[1800632405,"Jinja","Jinja","Uganda","UGA","admin",72931],
[1012765474,"Tamanrasset","Tamanrasset","Algeria","DZA","admin",76000],
[1191160875,"Zadar","Zadar","Croatia","HRV","admin",75082],
[1484464346,"Ixtaczoquitlán","Ixtaczoquitlan","Mexico","MEX","minor",68823],
[1392092262,"Musashimurayama","Musashimurayama","Japan","JPN","",71183],
[1032720412,"Bella Vista","Bella Vista","Argentina","ARG","",72000],
[1250213494,"Antibes","Antibes","France","FRA","",72915],
[1012743339,"Tissemsilt","Tissemsilt","Algeria","DZA","admin",75197],
[1642633889,"Bistriţa","Bistrita","Romania","ROU","admin",75076],
[1246489056,"Joensuu","Joensuu","Finland","FIN","admin",75514],
[1250087809,"Vincennes","Vincennes","France","FRA","",49635],
[1484341437,"Rioverde","Rioverde","Mexico","MEX","minor",69613],
[1484682498,"Matehuala","Matehuala","Mexico","MEX","minor",67717],
[1496235602,"Darhan","Darhan","Mongolia","MNG","admin",74738],
[1752502445,"Karlstad","Karlstad","Sweden","SWE","admin",74141],
[1426159118,"Teyateyaneng","Teyateyaneng","Lesotho","LSO","admin",75115],
[1528695192,"Gouda","Gouda","Netherlands","NLD","minor",71449],
[1222647953,"Zacatecoluca","Zacatecoluca","El Salvador","SLV","admin",75100],
[1840019227,"Baldwin Park","Baldwin Park","United States","USA","",75251],
[1203582141,"Zlín","Zlin","Czechia","CZE","admin",74478],
[1528234095,"Spijkenisse","Spijkenisse","Netherlands","NLD","minor",72740],
[1250081128,"Calais","Calais","France","FRA","minor",72929],
[1156108304,"Jinsha","Jinsha","China","CHN","",71240],
[1392439011,"Kiyosu","Kiyosu","Japan","JPN","",69809],
[1356042495,"Siuri","Siuri","India","IND","",67864],
[1528137355,"Vlaardingen","Vlaardingen","Netherlands","NLD","minor",72404],
[1116378797,"Prey Veng","Prey Veng","Cambodia","KHM","admin",74000],
[1616606592,"Inowrocław","Inowroclaw","Poland","POL","minor",72561],
[1100273248,"Pazardzhik","Pazardzhik","Bulgaria","BGR","admin",74785],
[1392003236,"Dazaifu","Dazaifu","Japan","JPN","",72430],
[1807488567,"Bitola","Bitola","Macedonia","MKD","admin",74550],
[1100616332,"Pernik","Pernik","Bulgaria","BGR","admin",74553],
[1170563968,"San Andrés","San Andres","Colombia","COL","admin",71946],
[1608772527,"Poblacion","Poblacion","Philippines","PHL","",70595],
[1826419858,"Lowestoft","Lowestoft","United Kingdom","GBR","",70945],
[1031943755,"Naxçıvan","Naxcivan","Azerbaijan","AZE","admin",74500],
[1156223355,"Longkoucun","Longkoucun","China","CHN","",72421],
[1360451991,"Manokwari","Manokwari","Indonesia","IDN","admin",74504],
[1392819275,"Hekinan","Hekinan","Japan","JPN","",72480],
[1716049475,"Masvingo","Masvingo","Zimbabwe","ZWE","admin",72527],
[1392319161,"Yoshikawa","Yoshikawa","Japan","JPN","",72139],
[1232396238,"Assab","Assab","Eritrea","ERI","admin",74405],
[1826330438,"Gosport","Gosport","United Kingdom","GBR","",71529],
[1788902612,"Nabeul","Nabeul","Tunisia","TUN","admin",73128],
[1840006015,"Centreville","Centreville","United States","USA","",74125],
[1642854000,"Tulcea","Tulcea","Romania","ROU","admin",73707],
[1643548797,"Birobidzhan","Birobidzhan","Russia","RUS","admin",73623],
[1826003493,"Grays","Grays","United Kingdom","GBR","",66843],
[1504381507,"Warzat","Warzat","Morocco","MAR","",71067],
[1792937570,"Şanlıurfa","Sanliurfa","Turkey","TUR","admin",73498],
[1392196288,"Tsurugashima","Tsurugashima","Japan","JPN","",70067],
[1788314833,"El Kef","El Kef","Tunisia","TUN","admin",73706],
[1454747771,"Salima","Salima","Malawi","MWI","admin",71181],
[1004523791,"Farāh","Farah","Afghanistan","AFG","admin",73647],
[1250904640,"Ivry-sur-Seine","Ivry-sur-Seine","France","FRA","",63309],
[1100214416,"Blagoevgrad","Blagoevgrad","Bulgaria","BGR","admin",73463],
[1840001507,"Camden","Camden","United States","USA","",73562],
[1792988434,"Antalya","Antalya","Turkey","TUR","admin",71833],
[1887513055,"Şa‘dah","Sa`dah","Yemen","YEM","admin",70203],
[1840008129,"Evanston","Evanston","United States","USA","",73473],
[1826528871,"Walton upon Thames","Walton upon Thames","United Kingdom","GBR","",66566],
[1250765188,"Neuilly-sur-Seine","Neuilly-sur-Seine","France","FRA","",59940],
[1231943444,"Debre Mark’os","Debre Mark'os","Ethiopia","ETH","",70758],
[1250182208,"Noisy-le-Grand","Noisy-le-Grand","France","FRA","",68126],
[1826609378,"Gravesend","Gravesend","United Kingdom","GBR","",66000],
[1031478213,"Şirvan","Sirvan","Azerbaijan","AZE","",70684],
[1630023540,"Caguas","Caguas","Puerto Rico","PRI","",73322],
[1484694325,"Cabo San Lucas","Cabo San Lucas","Mexico","MEX","",68463],
[1854057074,"Fada Ngourma","Fada Ngourma","Burkina Faso","BFA","admin",73200],
[1392797096,"Yawata-shimizui","Yawata-shimizui","Japan","JPN","",70373],
[1192731332,"San José de las Lajas","San Jose de las Lajas","Cuba","CUB","admin",73136],
[1418367677,"Thakhèk","Thakhek","Laos","LAO","admin",70000],
[1384274793,"Dabou","Dabou","Côte d'Ivoire","CIV","admin",72913],
[1222934169,"Cuscatancingo","Cuscatancingo","El Salvador","SLV","",66400],
[1600088413,"San Antonio","San Antonio","Paraguay","PRY","",69976],
[1608401350,"Pavia","Pavia","Philippines","PHL","",70388],
[1246492910,"Lappeenranta","Lappeenranta","Finland","FIN","admin",72875],
[1231302134,"Ārba Minch’","Arba Minch'","Ethiopia","ETH","",69622],
[1710219075,"Thohoyandou","Thohoyandou","South Africa","ZAF","",69453],
[1392003134,"Chiyoda-ku","Chiyoda-ku","Japan","JPN","",67036],
[1724108022,"Benalmádena","Benalmadena","Spain","ESP","",70204],
[1608239509,"Oroquieta","Oroquieta","Philippines","PHL","admin",72301],
[1840004774,"New Britain","New Britain","United States","USA","",72495],
[1156181413,"Karakax","Karakax","China","CHN","minor",66541],
[1604782074,"Abancay","Abancay","Peru","PER","admin",72277],
[1724000280,"Castelldefels","Castelldefels","Spain","ESP","",67226],
[1392203165,"Toyoake","Toyoake","Japan","JPN","",69389],
[1203173875,"Havířov","Havirov","Czechia","CZE","",70165],
[1032256650,"Wilde","Wilde","Argentina","ARG","",65881],
[1512180300,"Nizwá","Nizwa","Oman","OMN","admin",72076],
[1100186247,"Haskovo","Haskovo","Bulgaria","BGR","admin",72016],
[1840003285,"Pawtucket","Pawtucket","United States","USA","",72117],
[1608990192,"Borongan","Borongan","Philippines","PHL","admin",71961],
[1144127163,"Matara","Matara","Sri Lanka","LKA","",68244],
[1682069716,"Najrān","Najran","Saudi Arabia","SAU","admin",72038],
[1250553439,"Cergy","Cergy","France","FRA","minor",66322],
[1688216463,"Čačak","Cacak","Serbia","SRB","admin",71883],
[1826655696,"Walsall","Walsall","United Kingdom","GBR","",67594],
[1591982720,"La Chorrera","La Chorrera","Panama","PAN","admin",68896],
[1818093562,"Al Qūşīyah","Al Qusiyah","Egypt","EGY","",69388],
[1840015146,"Lauderhill","Lauderhill","United States","USA","",71868],
[1528041299,"Zaandam","Zaandam","Netherlands","NLD","minor",68695],
[1250622666,"Ajaccio","Ajaccio","France","FRA","admin",70817],
[1376739486,"Givatayim","Givatayim","Israel","ISR","",59518],
[1324990909,"Mamou","Mamou","Guinea","GIN","admin",71153],
[1504459034,"Youssoufia","Youssoufia","Morocco","MAR","",67628],
[1642577360,"Slatina","Slatina","Romania","ROU","admin",70293],
[1484744150,"Misantla","Misantla","Mexico","MEX","minor",64249],
[1320223205,"Salamá","Salama","Guatemala","GTM","admin",71478],
[1100748067,"Yambol","Yambol","Bulgaria","BGR","admin",70782],
[1250755963,"Vénissieux","Venissieux","France","FRA","",67129],
[1724424815,"Torremolinos","Torremolinos","Spain","ESP","",68056],
[1484685820,"Ramos Arizpe","Ramos Arizpe","Mexico","MEX","minor",66554],
[1764140981,"Phitsanulok","Phitsanulok","Thailand","THA","admin",70871],
[1887645956,"Zinjibār","Zinjibar","Yemen","YEM","admin",70801],
[1392167019,"Hatogaya-honchō","Hatogaya-honcho","Japan","JPN","",61379],
[1124196524,"New Westminster","New Westminster","Canada","CAN","",70996],
[1807301219,"Kumanovo","Kumanovo","Macedonia","MKD","admin",70842],
[1484479299,"Valle Hermoso","Valle Hermoso","Mexico","MEX","minor",68573],
[1688435541,"Novi Pazar","Novi Pazar","Serbia","SRB","admin",66527],
[1250209071,"Pantin","Pantin","France","FRA","",59060],
[1132180389,"Mindelo","Mindelo","Cabo Verde","CPV","admin",70468],
[1528883195,"Capelle aan den IJssel","Capelle aan den IJssel","Netherlands","NLD","minor",66514],
[1764748484,"Chiang Rai","Chiang Rai","Thailand","THA","admin",70610],
[1826445971,"Tynemouth","Tynemouth","United Kingdom","GBR","",68202],
[1818739665,"Abnūb","Abnub","Egypt","EGY","",67526],
[1826935894,"Paignton","Paignton","United Kingdom","GBR","",64410],
[1231573651,"Āksum","Aksum","Ethiopia","ETH","",66800],
[1156547623,"Jinxing","Jinxing","China","CHN","",60086],
[1484463389,"Huatusco","Huatusco","Mexico","MEX","minor",60674],
[1288679588,"Sunyani","Sunyani","Ghana","GHA","admin",70299],
[1392763646,"Fujiidera","Fujiidera","Japan","JPN","",63338],
[1504718611,"Aïn Harrouda","Ain Harrouda","Morocco","MAR","",62420],
[1792650390,"Aksaray","Aksaray","Turkey","TUR","admin",70359],
[1392003287,"Kashiwara","Kashiwara","Japan","JPN","",67757],
[1710078862,"Saldanha","Saldanha","South Africa","ZAF","",68284],
[1840005579,"Wilmington","Wilmington","United States","USA","",70166],
[1104151403,"Sagaing","Sagaing","Myanmar","MMR","admin",69917],
[1004468894,"Gardēz","Gardez","Afghanistan","AFG","admin",70000],
[1348287339,"Szolnok","Szolnok","Hungary","HUN","admin",69725],
[1600377819,"Encarnación","Encarnacion","Paraguay","PRY","admin",69868],
[1231777741,"Debre Birhan","Debre Birhan","Ethiopia","ETH","",65231],
[1724069372,"Viladecáns","Viladecans","Spain","ESP","",66707],
[1826559634,"Rochester","Rochester","United Kingdom","GBR","",62982],
[1604230427,"Moquegua","Moquegua","Peru","PER","admin",69882],
[1840020492,"Lynwood","Lynwood","United States","USA","",69887],
[1484993432,"Heroica Caborca","Heroica Caborca","Mexico","MEX","minor",67604],
[1826149081,"Washington","Washington","United Kingdom","GBR","",67158],
[1858819782,"Rivera","Rivera","Uruguay","URY","admin",64465],
[1826045748,"Ashford","Ashford","United Kingdom","GBR","",67528],
[1643279802,"Georgiyevsk","Georgiyevsk","Russia","RUS","",67054],
[1840000837,"Passaic","Passaic","United States","USA","",69703],
[1380725803,"Castellammare di Stabia","Castellammare di Stabia","Italy","ITA","",65922],
[1792020804,"Balıkesir","Balikesir","Turkey","TUR","admin",69341],
[1380218474,"L’Aquila","L'Aquila","Italy","ITA","admin",69439],
[1484238779,"Cortazar","Cortazar","Mexico","MEX","minor",61658],
[1250570123,"Antony","Antony","France","FRA","minor",62858],
[1458000206,"Putrajaya","Putrajaya","Malaysia","MYS","admin",67964],
[1428511842,"Liepāja","Liepaja","Latvia","LVA","admin",67964],
[1466006801,"Kati","Kati","Mali","MLI","minor",66895],
[1012006499,"Bouira","Bouira","Algeria","DZA","admin",68545],
[1380276866,"Portici","Portici","Italy","ITA","",54577],
[1356893735,"Tamlūk","Tamluk","India","IND","",65306],
[1528062494,"Veenendaal","Veenendaal","Netherlands","NLD","minor",65589],
[1170839384,"San José del Guaviare","San Jose del Guaviare","Colombia","COL","admin",68878],
[1620456537,"Ponta Delgada","Ponta Delgada","Portugal","PRT","admin",68809],
[1818905246,"Hihyā","Hihya","Egypt","EGY","",66702],
[1818211426,"Al Minshāh","Al Minshah","Egypt","EGY","",65484],
[1032866743,"Villa Domínico","Villa Dominico","Argentina","ARG","",62315],
[1826737367,"Merthyr Tudful","Merthyr Tudful","United Kingdom","GBR","",63546],
[1800924936,"Kasese","Kasese","Uganda","UGA","admin",67269],
[1392754858,"Kitamoto","Kitamoto","Japan","JPN","",65191],
[1031619846,"Şəki","Saki","Azerbaijan","AZE","admin",68360],
[1380524178,"Afragola","Afragola","Italy","ITA","",64817],
[1616490229,"Zamość","Zamosc","Poland","POL","minor",66234],
[1528917714,"Assen","Assen","Netherlands","NLD","admin",67580],
[1012462113,"Adrar","Adrar","Algeria","DZA","admin",68276],
[1392091635,"Tomigusuku","Tomigusuku","Japan","JPN","",64850],
[1608066874,"Bayombong","Bayombong","Philippines","PHL","admin",67714],
[1643980922,"Buynaksk","Buynaksk","Russia","RUS","minor",65080],
[1356096653,"Bankra","Bankra","India","IND","",63957],
[1764305340,"Ban Suan","Ban Suan","Thailand","THA","",66092],
[1600141362,"Areguá","Aregua","Paraguay","PRY","admin",67487],
[1246026891,"Hämeenlinna","Hameenlinna","Finland","FIN","admin",68011],
[1630023575,"Guaynabo","Guaynabo","Puerto Rico","PRI","",68024],
[1246734710,"Vaasa","Vaasa","Finland","FIN","admin",67619],
[1840005848,"Gaithersburg","Gaithersburg","United States","USA","",67985],
[1840001034,"Union City","Union City","United States","USA","",67982],
[1300508500,"Výronas","Vyronas","Greece","GRC","minor",61308],
[1826723231,"Scarborough","Scarborough","United Kingdom","GBR","",61749],
[1840021552,"South San Francisco","South San Francisco","United States","USA","",67789],
[1826383788,"Farnborough","Farnborough","United Kingdom","GBR","",65034],
[1076791382,"Cabedelo","Cabedelo","Brazil","BRA","",65634],
[1704290986,"Lào Cai","Lao Cai","Vietnam","VNM","admin",67206],
[1072560529,"Molepolole","Molepolole","Botswana","BWA","admin",67598],
[1380649430,"Potenza","Potenza","Italy","ITA","admin",67211],
[1724139875,"El Prat de Llobregat","El Prat de Llobregat","Spain","ESP","",65532],
[1608949971,"Teresa","Teresa","Philippines","PHL","",64072],
[1384235566,"Dimbokro","Dimbokro","Côte d'Ivoire","CIV","admin",67349],
[1528804942,"Katwijk","Katwijk","Netherlands","NLD","minor",65302],
[1840000781,"Mount Vernon","Mount Vernon","United States","USA","",67345],
[1724630905,"Arrecife","Arrecife","Spain","ESP","",64497],
[1484764524,"Altamira","Altamira","Mexico","MEX","minor",59536],
[1484709566,"Guamúchil","Guamuchil","Mexico","MEX","minor",63743],
[1826879996,"Stourbridge","Stourbridge","United Kingdom","GBR","",63298],
[1643988572,"Fryazino","Fryazino","Russia","RUS","",60437],
[1484524073,"Acámbaro","Acambaro","Mexico","MEX","minor",57972],
[1156327170,"Lechang","Lechang","China","CHN","minor",64587],
[1288943371,"Bolgatanga","Bolgatanga","Ghana","GHA","admin",66685],
[1504341023,"Martil","Martil","Morocco","MAR","",64355],
[1250904959,"Épinay-sur-Seine","Epinay-sur-Seine","France","FRA","",54771],
[1840020509,"Redondo Beach","Redondo Beach","United States","USA","",66749],
[1688625234,"Kraljevo","Kraljevo","Serbia","SRB","admin",66688],
[1840016001,"Tamarac","Tamarac","United States","USA","",66721],
[1826996583,"Hereford","Hereford","United Kingdom","GBR","",63024],
[1300253630,"Agía Paraskeví","Agia Paraskevi","Greece","GRC","minor",59704],
[1250800856,"Troyes","Troyes","France","FRA","minor",61996],
[1724011647,"Granollers","Granollers","Spain","ESP","",62475],
[1100134696,"Veliko Tarnovo","Veliko Tarnovo","Bulgaria","BGR","admin",66550],
[1434550258,"Nālūt","Nalut","Libya","LBY","admin",66609],
[1320977472,"Zacapa","Zacapa","Guatemala","GTM","admin",66423],
[1032236823,"Los Polvorines","Los Polvorines","Argentina","ARG","minor",60867],
[1608138574,"San Jose","San Jose","Philippines","PHL","admin",65140],
[1250000462,"Maisons-Alfort","Maisons-Alfort","France","FRA","",55899],
[1807551778,"Prilep","Prilep","Macedonia","MKD","admin",66246],
[1703497997,"Trnava","Trnava","Slovakia","SVK","admin",65382],
[1800731885,"Masaka","Masaka","Uganda","UGA","admin",65373],
[1724645759,"Collado-Villalba","Collado-Villalba","Spain","ESP","",63825],
[1826354283,"Dewsbury","Dewsbury","United Kingdom","GBR","",62945],
[1148101824,"Goz-Beida","Goz-Beida","Chad","TCD","admin",66107],
[1320960166,"San Marcos","San Marcos","Guatemala","GTM","admin",65571],
[1826194258,"Loughborough","Loughborough","United Kingdom","GBR","",59932],
[1826879983,"Wrecsam","Wrecsam","United Kingdom","GBR","",61603],
[1764502057,"Samut Sakhon","Samut Sakhon","Thailand","THA","admin",60103],
[1348450358,"Tatabánya","Tatabanya","Hungary","HUN","admin",65145],
[1724170346,"La Línea de la Concepción","La Linea de la Concepcion","Spain","ESP","",63365],
[1250985562,"Sarcelles","Sarcelles","France","FRA","minor",58811],
[1300317204,"Ioánnina","Ioannina","Greece","GRC","admin",65574],
[1250392648,"La Seyne-sur-Mer","La Seyne-sur-Mer","France","FRA","",62888],
[1840037057,"Florence-Graham","Florence-Graham","United States","USA","",65716],
[1792019202,"Trabzon","Trabzon","Turkey","TUR","admin",65516],
[1826968679,"Kettering","Kettering","United Kingdom","GBR","",56226],
[1642445982,"Călăraşi","Calarasi","Romania","ROU","admin",65181],
[1792161179,"Denizli","Denizli","Turkey","TUR","admin",64331],
[1528701694,"Nieuwegein","Nieuwegein","Netherlands","NLD","minor",63036],
[1516885937,"Rundu","Rundu","Namibia","NAM","admin",63431],
[1404890081,"Kitale","Kitale","Kenya","KEN","admin",63245],
[1392003238,"Nagakute","Nagakute","Japan","JPN","",62473],
[1840000395,"Schenectady","Schenectady","United States","USA","",65273],
[1250637012,"Villejuif","Villejuif","France","FRA","",54964],
[1764543650,"Songkhla","Songkhla","Thailand","THA","admin",63834],
[1504736892,"Ouezzane","Ouezzane","Morocco","MAR","",59606],
[1392003360,"Tagajō","Tagajo","Japan","JPN","",61937],
[1834418526,"Singida","Singida","Tanzania","TZA","admin",62432],
[1894777820,"Solwezi","Solwezi","Zambia","ZMB","admin",65000],
[1760680757,"As Suwaydā’","As Suwayda'","Syria","SYR","admin",64730],
[1076277178,"Euclides da Cunha","Euclides da Cunha","Brazil","BRA","",60666],
[1056640531,"Forest","Forest","Belgium","BEL","",56008],
[1616783003,"Ełk","Elk","Poland","POL","minor",62006],
[1840003595,"Bayonne","Bayonne","United States","USA","",64897],
[1620330407,"Faro","Faro","Portugal","PRT","admin",64560],
[1004452653,"Faīẕābād","Faizabad","Afghanistan","AFG","admin",64704],
[1484307969,"Cosamaloapan","Cosamaloapan","Mexico","MEX","minor",57147],
[1268394475,"Sokhumi","Sokhumi","Georgia","GEO","admin",64441],
[1826938401,"Ellesmere Port","Ellesmere Port","United Kingdom","GBR","",61090],
[1320747500,"Sololá","Solola","Guatemala","GTM","admin",63973],
[1056267205,"Etterbeek","Etterbeek","Belgium","BEL","",47786],
[1392003391,"Yamatotakada","Yamatotakada","Japan","JPN","",60791],
[1340638121,"Yoro","Yoro","Honduras","HND","admin",64425],
[1616154673,"Pruszków","Pruszkow","Poland","POL","minor",61237],
[1788608864,"Manouba","Manouba","Tunisia","TUN","admin",58792],
[1840002792,"East Orange","East Orange","United States","USA","",64367],
[1356993418,"Nagari","Nagari","India","IND","",62253],
[1250383006,"Le Blanc-Mesnil","Le Blanc-Mesnil","France","FRA","",57150],
[1826282262,"Bangor","Bangor","United Kingdom","GBR","",61011],
[1508945412,"Inhambane","Inhambane","Mozambique","MOZ","admin",63837],
[1826349439,"Runcorn","Runcorn","United Kingdom","GBR","",61789],
[1826959489,"Taunton","Taunton","United Kingdom","GBR","",60479],
[1826096073,"Littlehampton","Littlehampton","United Kingdom","GBR","",58357],
[1642449522,"Alba Iulia","Alba Iulia","Romania","ROU","admin",63536],
[1218947988,"Latacunga","Latacunga","Ecuador","ECU","admin",63842],
[1250274671,"Bondy","Bondy","France","FRA","",54055],
[1643549691,"Gorno-Altaysk","Gorno-Altaysk","Russia","RUS","admin",63214],
[1392294890,"Hasuda","Hasuda","Japan","JPN","",61473],
[1380179165,"Marano di Napoli","Marano di Napoli","Italy","ITA","",59862],
[1854743311,"Dédougou","Dedougou","Burkina Faso","BFA","admin",63617],
[1380045698,"Legnano","Legnano","Italy","ITA","",60177],
[1392003332,"Ōsakasayama","Osakasayama","Japan","JPN","",58593],
[1608961915,"Taal","Taal","Philippines","PHL","",61460],
[1792726797,"Kahramanmaraş","Kahramanmaras","Turkey","TUR","admin",63284],
[1392146541,"Mukōchō","Mukocho","Japan","JPN","",56152],
[1454281420,"Nkhotakota","Nkhotakota","Malawi","MWI","admin",59854],
[1840005021,"Brentwood","Brentwood","United States","USA","",63399],
[1417269527,"Karakol","Karakol","Kyrgyzstan","KGZ","admin",63377],
[1392244952,"Tsushima","Tsushima","Japan","JPN","",60908],
[1348988570,"Sopron","Sopron","Hungary","HUN","admin",62900],
[1144764835,"Anuradhapura","Anuradhapura","Sri Lanka","LKA","admin",63208],
[1250026751,"Cherbourg","Cherbourg","France","FRA","minor",60991],
[1116453792,"Kratie","Kratie","Cambodia","KHM","admin",60000],
[1484526560,"Sabinas","Sabinas","Mexico","MEX","minor",59196],
[1764251181,"Ban Rangsit","Ban Rangsit","Thailand","THA","",58838],
[1706018197,"Beledweyne","Beledweyne","Somalia","SOM","admin",62945],
[1826741418,"Wallasey","Wallasey","United Kingdom","GBR","",60284],
[1608155856,"Tandag","Tandag","Philippines","PHL","admin",62669],
[1804780082,"Khartsyzk","Khartsyzk","Ukraine","UKR","",59763],
[1250405027,"Suresnes","Suresnes","France","FRA","",48763],
[1804862811,"Stryi","Stryi","Ukraine","UKR","minor",59325],
[1840015154,"North Miami","North Miami","United States","USA","",62822],
[1840011321,"Skokie","Skokie","United States","USA","",62700],
[1688752541,"Leskovac","Leskovac","Serbia","SRB","admin",60288],
[1764111243,"Saraburi","Saraburi","Thailand","THA","admin",61750],
[1764920057,"Rayong","Rayong","Thailand","THA","admin",61902],
[1250000037,"Saint-Ouen","Saint-Ouen","France","FRA","",50670],
[1686219536,"Kolda","Kolda","Senegal","SEN","admin",62258],
[1620315932,"Santarém","Santarem","Portugal","PRT","admin",62200],
[1392749897,"Fussa","Fussa","Japan","JPN","",56713],
[1554064936,"Napier","Napier","New Zealand","NZL","admin",62241],
[1250306149,"Bobigny","Bobigny","France","FRA","minor",54272],
[1484504671,"Linares","Linares","Mexico","MEX","minor",57731],
[1804199117,"Chornomorsk","Chornomorsk","Ukraine","UKR","",59800],
[1598116558,"Madang","Madang","Papua New Guinea","PNG","admin",62023],
[1643669152,"Lytkarino","Lytkarino","Russia","RUS","",58606],
[1826464817,"Bebington","Bebington","United Kingdom","GBR","",57336],
[1840020506,"Pico Rivera","Pico Rivera","United States","USA","",62027],
[1840020499,"Montebello","Montebello","United States","USA","",61954],
[1004274041,"Bāmyān","Bamyan","Afghanistan","AFG","admin",61863],
[1646793543,"Ruhengeri","Ruhengeri","Rwanda","RWA","",59333],
[1826522277,"Macclesfield","Macclesfield","United Kingdom","GBR","",56581],
[1764430323,"Yala","Yala","Thailand","THA","admin",61250],
[1246718173,"Rovaniemi","Rovaniemi","Finland","FIN","admin",61763],
[1642984994,"Giurgiu","Giurgiu","Romania","ROU","admin",61353],
[1188214393,"Puerto Limón","Puerto Limon","Costa Rica","CRI","admin",60710],
[1250283861,"Chambéry","Chambery","France","FRA","minor",58833],
[1250384578,"Fontenay-sous-Bois","Fontenay-sous-Bois","France","FRA","",52256],
[1840081753,"North Bergen","North Bergen","United States","USA","",61619],
[1246118146,"Seinäjoki","Seinajoki","Finland","FIN","admin",61530],
[1724017694,"Portugalete","Portugalete","Spain","ESP","",45285],
[1156128173,"Suileng","Suileng","China","CHN","minor",57789],
[1840029009,"The Hammocks","The Hammocks","United States","USA","",61516],
[1840020622,"National City","National City","United States","USA","",61394],
[1392299085,"Koja","Koja","Japan","JPN","",58658],
[1392003342,"Nonoichi","Nonoichi","Japan","JPN","",57090],
[1840015132,"Coconut Creek","Coconut Creek","United States","USA","",61248],
[1152541137,"Coyhaique","Coyhaique","Chile","CHL","admin",61210],
[1706067930,"Gaalkacyo","Gaalkacyo","Somalia","SOM","admin",61200],
[1704108909,"Bến Tre","Ben Tre","Vietnam","VNM","admin",59442],
[1642078107,"Hunedoara","Hunedoara","Romania","ROU","admin",60525],
[1372126011,"Limerick","Limerick","Ireland","IRL","admin",58319],
[1724001899,"Mislata","Mislata","Spain","ESP","",44320],
[1504893162,"Sidi Bennour","Sidi Bennour","Morocco","MAR","",55815],
[1156152527,"Longxing","Longxing","China","CHN","minor",56381],
[1196804795,"Larnaca","Larnaca","Cyprus","CYP","admin",59200],
[1032898708,"Rafael Calzada","Rafael Calzada","Argentina","ARG","",56419],
[1826011948,"Royal Tunbridge Wells","Royal Tunbridge Wells","United Kingdom","GBR","",57772],
[1764343817,"Trang","Trang","Thailand","THA","admin",60591],
[1764813354,"Ban Bang Kaeo","Ban Bang Kaeo","Thailand","THA","",56949],
[1392000468,"Takaishi","Takaishi","Japan","JPN","",55910],
[1266867613,"Oyem","Oyem","Gabon","GAB","admin",60685],
[1566772925,"Lokoja","Lokoja","Nigeria","NGA","admin",60579],
[1558986603,"Juigalpa","Juigalpa","Nicaragua","NIC","admin",60583],
[1752263370,"Växjö","Vaxjo","Sweden","SWE","admin",59600],
[1840028983,"Fountainebleau","Fountainebleau","United States","USA","",60547],
[1250407425,"Puteaux","Puteaux","France","FRA","",44837],
[1840020585,"La Habra","La Habra","United States","USA","",60513],
[1840000430,"Malden","Malden","United States","USA","",60470],
[1356000447,"Chakapara","Chakapara","India","IND","",35282],
[1616002338,"Świdnica","Swidnica","Poland","POL","minor",57761],
[1840019209,"South Whittier","South Whittier","United States","USA","",60357],
[1484617215,"Tezonapa","Tezonapa","Mexico","MEX","minor",56956],
[1250615711,"Lorient","Lorient","France","FRA","minor",57084],
[1348114190,"Kaposvár","Kaposvar","Hungary","HUN","admin",59777],
[1392442008,"Zushi","Zushi","Japan","JPN","",56996],
[1404689847,"Bungoma","Bungoma","Kenya","KEN","admin",55857],
[1484150923,"Pinotepa","Pinotepa","Mexico","MEX","minor",53148],
[1504365068,"Sidi Yahya Zaer","Sidi Yahya Zaer","Morocco","MAR","",57790],
[1250675373,"Évry","Evry","France","FRA","minor",53641],
[1504279379,"Midalt","Midalt","Morocco","MAR","",55304],
[1840003034,"West Allis","West Allis","United States","USA","",59890],
[1356023817,"Itānagar","Itanagar","India","IND","admin",59490],
[1688591624,"Užice","Uzice","Serbia","SRB","admin",59747],
[1764159228,"Samut Prakan","Samut Prakan","Thailand","THA","admin",51309],
[1840021387,"Taylorsville","Taylorsville","United States","USA","",59805],
[1320020808,"Antigua Guatemala","Antigua Guatemala","Guatemala","GTM","admin",59091],
[1504585311,"Azrou","Azrou","Morocco","MAR","",54350],
[1643385248,"Klimovsk","Klimovsk","Russia","RUS","",56239],
[1840020500,"Monterey Park","Monterey Park","United States","USA","",59669],
[1818038230,"Samannūd","Samannud","Egypt","EGY","",57177],
[1376159880,"Hod HaSharon","Hod HaSharon","Israel","ISR","",56659],
[1300944675,"Ródos","Rodos","Greece","GRC","minor",56969],
[1250857642,"Alfortville","Alfortville","France","FRA","",44287],
[1858952595,"Tacuarembó","Tacuarembo","Uruguay","URY","admin",54755],
[1826257230,"Folkestone","Folkestone","United Kingdom","GBR","",51337],
[1724941889,"Mérida","Merida","Spain","ESP","admin",59424],
[1504990575,"Al Hoceïma","Al Hoceima","Morocco","MAR","",56716],
[1392153436,"Hamura","Hamura","Japan","JPN","",53970],
[1840020482,"Gardena","Gardena","United States","USA","",59329],
[1484625824,"Zumpango","Zumpango","Mexico","MEX","minor",50742],
[1840018950,"Cupertino","Cupertino","United States","USA","",59276],
[1826633006,"Royal Leamington Spa","Royal Leamington Spa","United Kingdom","GBR","",55733],
[1840020625,"La Mesa","La Mesa","United States","USA","",59249],
[1643369563,"Dzerzhinskiy","Dzerzhinskiy","Russia","RUS","",55669],
[1192325408,"Artemisa","Artemisa","Cuba","CUB","admin",59130],
[1826899809,"Crosby","Crosby","United Kingdom","GBR","",51789],
[1840053672,"Brookline","Brookline","United States","USA","",59180],
[1031581655,"Yevlax","Yevlax","Azerbaijan","AZE","admin",59036],
[1032613063,"Viedma","Viedma","Argentina","ARG","admin",59122],
[1356773697,"Mūndka","Mundka","India","IND","",54541],
[1604446908,"Cerro de Pasco","Cerro de Pasco","Peru","PER","admin",58899],
[1250827686,"Meaux","Meaux","France","FRA","minor",55416],
[1156989557,"Liuhu","Liuhu","China","CHN","",47442],
[1180751831,"Kabinda","Kabinda","Congo (Kinshasa)","COD","admin",59004],
[1250130113,"Clamart","Clamart","France","FRA","",52926],
[1826465421,"Stratford","Stratford","United Kingdom","GBR","",51387],
[1484180362,"Huamantla","Huamantla","Mexico","MEX","minor",51996],
[1688595236,"Kruševac","Krusevac","Serbia","SRB","admin",58745],
[1840015999,"Margate","Margate","United States","USA","",58796],
[1076000916,"Mineiros","Mineiros","Brazil","BRA","",52935],
[1376676929,"Qiryat Ata","Qiryat Ata","Israel","ISR","",55464],
[1380486559,"Aversa","Aversa","Italy","ITA","",52794],
[1840003826,"Carson City","Carson City","United States","USA","admin",58756],
[1854646157,"Tenkodogo","Tenkodogo","Burkina Faso","BFA","admin",58600],
[1562574611,"Dosso","Dosso","Niger","NER","admin",58671],
[1608929611,"Naval","Naval","Philippines","PHL","admin",58187],
[1356275520,"Bāruipur","Baruipur","India","IND","",53128],
[1356648879,"Mandapeta","Mandapeta","India","IND","",56063],
[1642043593,"Bârlad","Barlad","Romania","ROU","",55837],
[1250001485,"Chelles","Chelles","France","FRA","",55148],
[1124473757,"Port Coquitlam","Port Coquitlam","Canada","CAN","",58612],
[1348279762,"Veszprém","Veszprem","Hungary","HUN","admin",58153],
[1376619380,"Rosh Ha‘Ayin","Rosh Ha`Ayin","Israel","ISR","",56300],
[1840000585,"Middletown","Middletown","United States","USA","",58592],
[1800380883,"Kitgum","Kitgum","Uganda","UGA","admin",56891],
[1384649653,"Bondoukou","Bondoukou","Côte d'Ivoire","CIV","admin",58297],
[1250494022,"Sartrouville","Sartrouville","France","FRA","",52269],
[1780361077,"San Fernando","San Fernando","Trinidad And Tobago","TTO","admin",55419],
[1804059567,"Novohrad-Volynskyi","Novohrad-Volynskyi","Ukraine","UKR","minor",56288],
[1608839244,"Caridad","Caridad","Philippines","PHL","",27891],
[1348329493,"Békéscsaba","Bekescsaba","Hungary","HUN","admin",58002],
[1840056367,"Union","Union","United States","USA","",58297],
[1250179512,"Sevran","Sevran","France","FRA","",51225],
[1300233408,"Chaniá","Chania","Greece","GRC","minor",53910],
[1840003477,"White Plains","White Plains","United States","USA","",58109],
[1320742269,"Huehuetenango","Huehuetenango","Guatemala","GTM","admin",58000],
[1392003452,"Shijōnawate","Shijonawate","Japan","JPN","",55094],
[1840008615,"Jefferson City","Jefferson City","United States","USA","admin",58025],
[1616994284,"Legionowo","Legionowo","Poland","POL","minor",53886],
[1356889289,"Bhīmunipatnam","Bhimunipatnam","India","IND","",55082],
[1840019223,"Arcadia","Arcadia","United States","USA","",57939],
[1276577152,"Hilden","Hilden","Germany","DEU","",55764],
[1191097030,"Slavonski Brod","Slavonski Brod","Croatia","HRV","admin",56769],
[1158297836,"Magong","Magong","Taiwan","TWN","admin",56435],
[1484004002,"Nuevo Casas Grandes","Nuevo Casas Grandes","Mexico","MEX","minor",55553],
[1484022961,"Acatzingo","Acatzingo","Mexico","MEX","minor",52078],
[1376814378,"Umm el Faḥm","Umm el Fahm","Israel","ISR","",55300],
[1826052030,"Kidderminster","Kidderminster","United Kingdom","GBR","",55530],
[1400040712,"Al Mafraq","Al Mafraq","Jordan","JOR","admin",57118],
[1608972476,"Boac","Boac","Philippines","PHL","admin",57283],
[1826280426,"Altrincham","Altrincham","United Kingdom","GBR","",52419],
[1840019235,"Huntington Park","Huntington Park","United States","USA","",57509],
[1826316742,"Weymouth","Weymouth","United Kingdom","GBR","",54539],
[1426506047,"Mafeteng","Mafeteng","Lesotho","LSO","admin",57059],
[1716523245,"Chinhoyi","Chinhoyi","Zimbabwe","ZWE","admin",56794],
[1840000431,"Medford","Medford","United States","USA","",57341],
[1356440541,"Pithāpuram","Pithapuram","India","IND","",54859],
[1858600801,"Melo","Melo","Uruguay","URY","admin",51830],
[1826605492,"Barri","Barri","United Kingdom","GBR","",51502],
[1084150679,"Belize City","Belize City","Belize","BLZ","admin",57169],
[1484445555,"Colonia del Sol","Colonia del Sol","Mexico","MEX","",48032],
[1100261281,"Vratsa","Vratsa","Bulgaria","BGR","admin",57028],
[1072985345,"Maun","Maun","Botswana","BWA","admin",57067],
[1704256754,"Bắc Giang","Bac Giang","Vietnam","VNM","admin",53728],
[1756649723,"Biel/Bienne","Biel/Bienne","Switzerland","CHE","",54456],
[1484314420,"Chiapa de Corzo","Chiapa de Corzo","Mexico","MEX","minor",45077],
[1792999306,"Düzce","Duzce","Turkey","TUR","admin",56649],
[1032847885,"Ushuaia","Ushuaia","Argentina","ARG","admin",56956],
[1724352928,"Esplugas de Llobregat","Esplugas de Llobregat","Spain","ESP","",46777],
[1484673086,"San Pedro","San Pedro","Mexico","MEX","minor",49490],
[1642791988,"Zalău","Zalau","Romania","ROU","admin",56202],
[1792992104,"Muğla","Mugla","Turkey","TUR","admin",56619],
[1642189178,"Sfântu-Gheorghe","Sfantu-Gheorghe","Romania","ROU","admin",56006],
[1818093442,"Abū Qīr","Abu Qir","Egypt","EGY","",37997],
[1620456226,"Évora","Evora","Portugal","PRT","admin",56596],
[1764002329,"Phra Nakhon Si Ayutthaya","Phra Nakhon Si Ayutthaya","Thailand","THA","admin",52952],
[1478799785,"Zouerate","Zouerate","Mauritania","MRT","admin",56345],
[1703029695,"Trenčín","Trencin","Slovakia","SVK","admin",55593],
[1340050563,"Santa Rosa de Copán","Santa Rosa de Copan","Honduras","HND","admin",56000],
[1428370571,"Jelgava","Jelgava","Latvia","LVA","admin",55336],
[1250806002,"Saint-Quentin","Saint-Quentin","France","FRA","minor",53856],
[1840029085,"Tamiami","Tamiami","United States","USA","",56225],
[1642644428,"Vaslui","Vaslui","Romania","ROU","admin",55407],
[1840029045,"Kendale Lakes","Kendale Lakes","United States","USA","",56182],
[1484764993,"Francisco I. Madero","Francisco I. Madero","Mexico","MEX","minor",50084],
[1620277400,"Castelo Branco","Castelo Branco","Portugal","PRT","admin",56109],
[1620258719,"Rio Tinto","Rio Tinto","Portugal","PRT","",50713],
[1380360808,"San Giorgio a Cremano","San Giorgio a Cremano","Italy","ITA","",45122],
[1608368724,"Vigan","Vigan","Philippines","PHL","admin",53935],
[1040313109,"Sankt Pölten","Sankt Polten","Austria","AUT","admin",55514],
[1348293073,"Zalaegerszeg","Zalaegerszeg","Hungary","HUN","admin",55470],
[1392003519,"Fuchū","Fuchu","Japan","JPN","",51096],
[1250651220,"Massy","Massy","France","FRA","",50632],
[1826424354,"Dunfermline","Dunfermline","United Kingdom","GBR","",53100],
[1380947310,"Gallarate","Gallarate","Italy","ITA","",53425],
[1608986957,"Iba","Iba","Philippines","PHL","admin",55581],
[1752392511,"Halmstad","Halmstad","Sweden","SWE","admin",55657],
[1807586875,"Ohrid","Ohrid","Macedonia","MKD","admin",55749],
[1724443143,"Mollet","Mollet","Spain","ESP","",51151],
[1860505287,"Guliston","Guliston","Uzbekistan","UZB","admin",55600],
[1048909146,"Madīnat Ḩamad","Madinat Hamad","Bahrain","BHR","",52700],
[1840001339,"New Brunswick","New Brunswick","United States","USA","",55676],
[1031204213,"M.Ə. Rəsulzadə","M.A. Rasulzada","Azerbaijan","AZE","",51800],
[1826320670,"Bootle","Bootle","United Kingdom","GBR","",51394],
[1826692620,"Hamilton","Hamilton","United Kingdom","GBR","",53188],
[1250742467,"Corbeil-Essonnes","Corbeil-Essonnes","France","FRA","",50954],
[1800460306,"Busia","Busia","Uganda","UGA","admin",47100],
[1242457077,"Lautoka","Lautoka","Fiji","FJI","",52220],
[1380009957,"Ercolano","Ercolano","Italy","ITA","",52763],
[1840020575,"Fountain Valley","Fountain Valley","United States","USA","",55357],
[1528456884,"Rijswijk","Rijswijk","Netherlands","NLD","minor",51742],
[1356997622,"Amalāpuram","Amalapuram","India","IND","",53231],
[1826197341,"Lancaster","Lancaster","United Kingdom","GBR","",52234],
[1578807356,"Skien","Skien","Norway","NOR","admin",55144],
[1764081847,"Lampang","Lampang","Thailand","THA","admin",55044],
[1688474456,"Vranje","Vranje","Serbia","SRB","admin",55138],
[1724123244,"Ibiza","Ibiza","Spain","ESP","",50643],
[1840000442,"Ithaca","Ithaca","United States","USA","",55137],
[1840011306,"Oak Lawn","Oak Lawn","United States","USA","",55022],
[1392003536,"Shiogama","Shiogama","Japan","JPN","",51999],
[1818862945,"Al Karnak","Al Karnak","Egypt","EGY","",26488],
[1901597212,"Malishevë","Malisheve","Kosovo","XKS","admin",54613],
[1156151766,"Gutao","Gutao","China","CHN","minor",50000],
[1360231049,"Padangpanjang","Padangpanjang","Indonesia","IDN","",52422],
[1246875185,"Mikkeli","Mikkeli","Finland","FIN","admin",54665],
[1834409018,"Chake Chake","Chake Chake","Tanzania","TZA","admin",49959],
[1826862515,"Cumbernauld","Cumbernauld","United Kingdom","GBR","",50920],
[1250504037,"Choisy-le-Roi","Choisy-le-Roi","France","FRA","",46154],
[1826743524,"Brentwood","Brentwood","United Kingdom","GBR","",52586],
[1764003021,"Muban Saeng Bua Thong","Muban Saeng Bua Thong","Thailand","THA","",51932],
[1840007027,"Berwyn","Berwyn","United States","USA","",54391],
[1004817775,"Chārīkār","Charikar","Afghanistan","AFG","admin",53676],
[1840017414,"Aloha","Aloha","United States","USA","",54287],
[1250261503,"Cagnes-sur-Mer","Cagnes-sur-Mer","France","FRA","",51411],
[1826751733,"Willenhall","Willenhall","United Kingdom","GBR","",51429],
[1418530759,"Louangphabang","Louangphabang","Laos","LAO","admin",53792],
[1392337140,"Shiraoka","Shiraoka","Japan","JPN","",52103],
[1764877766,"Prachuap Khiri Khan","Prachuap Khiri Khan","Thailand","THA","admin",54018],
[1466571211,"Gao","Gao","Mali","MLI","admin",49483],
[1840080906,"Irvington","Irvington","United States","USA","",54079],
[1218976878,"Tulcán","Tulcan","Ecuador","ECU","admin",53558],
[1840020495,"Rosemead","Rosemead","United States","USA","",54058],
[1008361921,"Korçë","Korce","Albania","ALB","admin",51152],
[1840020504,"Paramount","Paramount","United States","USA","",53955],
[1800987671,"Iganga","Iganga","Uganda","UGA","admin",45024],
[1250643229,"Rosny-sous-Bois","Rosny-sous-Bois","France","FRA","",46043],
[1250223048,"Bayonne","Bayonne","France","FRA","minor",51411],
[1764476362,"Sakon Nakhon","Sakon Nakhon","Thailand","THA","admin",53618],
[1188394508,"Alajuela","Alajuela","Costa Rica","CRI","admin",48326],
[1484937914,"Ocosingo","Ocosingo","Mexico","MEX","minor",41878],
[1116566865,"Pursat","Pursat","Cambodia","KHM","admin",52476],
[1716375676,"Marondera","Marondera","Zimbabwe","ZWE","admin",52283],
[1643344934,"Moskovskiy","Moskovskiy","Russia","RUS","",50167],
[1376745785,"Nes Ẕiyyona","Nes Ziyyona","Israel","ISR","",50200],
[1222913273,"San Vicente","San Vicente","El Salvador","SLV","admin",53213],
[1380466267,"Cologno Monzese","Cologno Monzese","Italy","ITA","",47720],
[1250814472,"Vaulx-en-Velin","Vaulx-en-Velin","France","FRA","",50823],
[1380992516,"Scafati","Scafati","Italy","ITA","",50686],
[1100696135,"Gabrovo","Gabrovo","Bulgaria","BGR","admin",52974],
[1380877337,"Rho","Rho","Italy","ITA","",50904],
[1051566733,"Hrazdan","Hrazdan","Armenia","ARM","admin",52808],
[1484801408,"Buena Vista Tomatlán","Buena Vista Tomatlan","Mexico","MEX","",47498],
[1840000457,"Revere","Revere","United States","USA","",53073],
[1764568961,"Maha Sarakham","Maha Sarakham","Thailand","THA","admin",52866],
[1484332013,"Valladolid","Valladolid","Mexico","MEX","",48973],
[1484452730,"Jiménez","Jimenez","Mexico","MEX","minor",48859],
[1840005825,"Aspen Hill","Aspen Hill","United States","USA","",53049],
[1250727880,"Noisy-le-Sec","Noisy-le-Sec","France","FRA","",44223],
[1504259447,"Boujad","Boujad","Morocco","MAR","",46893],
[1364382390,"Chahār Dangeh","Chahar Dangeh","Iran","IRN","",49950],
[1116674518,"Takeo","Takeo","Cambodia","KHM","admin",52000],
[1840019820,"Helena","Helena","United States","USA","admin",52936],
[1208585023,"Vejle","Vejle","Denmark","DNK","admin",51177],
[1724220415,"Santurce-Antiguo","Santurce-Antiguo","Spain","ESP","",46085],
[1764694888,"Bang Bua Thong","Bang Bua Thong","Thailand","THA","minor",50141],
[1840001035,"West New York","West New York","United States","USA","",52723],
[1840003599,"Hoboken","Hoboken","United States","USA","",52677],
[1578023501,"Bodø","Bodo","Norway","NOR","admin",52560],
[1894761291,"Mongu","Mongu","Zambia","ZMB","admin",52534],
[1804762140,"Myrnohrad","Myrnohrad","Ukraine","UKR","",50360],
[1392765544,"Iwakura","Iwakura","Japan","JPN","",47975],
[1608459830,"Noveleta","Noveleta","Philippines","PHL","",49452],
[1392860759,"Takahama","Takahama","Japan","JPN","",48685],
[1840011307,"Oak Park","Oak Park","United States","USA","",52381],
[1558246417,"Jinotepe","Jinotepe","Nicaragua","NIC","admin",52175],
[1380000029,"Collegno","Collegno","Italy","ITA","",49597],
[1504400263,"Ain El Aouda","Ain El Aouda","Morocco","MAR","",49816],
[1276091723,"Elmshorn","Elmshorn","Germany","DEU","",49883],
[1392676251,"Suzukawa","Suzukawa","Japan","JPN","",48532],
[1300400935,"Lamía","Lamia","Greece","GRC","admin",52006],
[1454766726,"Mangochi","Mangochi","Malawi","MWI","admin",51429],
[1031218031,"Lənkəran","Lankaran","Azerbaijan","AZE","admin",51300],
[1620292123,"Vila Real","Vila Real","Portugal","PRT","admin",51850],
[1250897232,"La Garenne-Colombes","La Garenne-Colombes","France","FRA","",29430],
[1056315355,"Jette","Jette","Belgium","BEL","",43564],
[1484384276,"Loreto","Loreto","Mexico","MEX","minor",43411],
[1826587515,"Pen-y-Bont ar Ogwr","Pen-y-Bont ar Ogwr","United Kingdom","GBR","",49404],
[1144739208,"Ratnapura","Ratnapura","Sri Lanka","LKA","admin",47832],
[1528438292,"Barendrecht","Barendrecht","Netherlands","NLD","minor",48673],
[1250529722,"Gennevilliers","Gennevilliers","France","FRA","",47702],
[1203801370,"Teplice","Teplice","Czechia","CZE","",49705],
[1710969597,"Vryburg","Vryburg","South Africa","ZAF","",49588],
[1348559499,"Eger","Eger","Hungary","HUN","admin",51168],
[1203810604,"Jihlava","Jihlava","Czechia","CZE","admin",51125],
[1760273732,"Ḩarastā","Harasta","Syria","SYR","minor",45974],
[1554000636,"Whangarei","Whangarei","New Zealand","NZL","admin",50784],
[1688575779,"Sombor","Sombor","Serbia","SRB","admin",51471],
[1504612704,"Qasbat Tadla","Qasbat Tadla","Morocco","MAR","",47343],
[1840005270,"Levittown","Levittown","United States","USA","",51634],
[1484254957,"Tizimín","Tizimin","Mexico","MEX","minor",46971],
[1840001340,"Perth Amboy","Perth Amboy","United States","USA","",51390],
[1484110723,"Tlapa de Comonfort","Tlapa de Comonfort","Mexico","MEX","minor",37975],
[1392003430,"Kasuya","Kasuya","Japan","JPN","",47981],
[1100473094,"Kardzhali","Kardzhali","Bulgaria","BGR","admin",51242],
[1404067343,"Wajir","Wajir","Kenya","KEN","admin",45771],
[1156084652,"Guozhen","Guozhen","China","CHN","minor",49100],
[1384639807,"Séguéla","Seguela","Côte d'Ivoire","CIV","admin",51157],
[1144219740,"Puttalam","Puttalam","Sri Lanka","LKA","",45661],
[1840020583,"Placentia","Placentia","United States","USA","",51233],
[1826645692,"Stretford","Stretford","United Kingdom","GBR","",46910],
[1484831454,"Cuetzalan","Cuetzalan","Mexico","MEX","minor",47983],
[1004047427,"Sar-e Pul","Sar-e Pul","Afghanistan","AFG","admin",51075],
[1300373048,"Komotiní","Komotini","Greece","GRC","admin",50990],
[1250653520,"Livry-Gargan","Livry-Gargan","France","FRA","",45012],
[1276281757,"Halle-Neustadt","Halle-Neustadt","Germany","DEU","",46280],
[1268442763,"Gori","Gori","Georgia","GEO","admin",48143],
[1356074103,"Bodupāl","Bodupal","India","IND","",43692],
[1032203390,"Longchamps","Longchamps","Argentina","ARG","",47622],
[1440273296,"Alytus","Alytus","Lithuania","LTU","admin",49888],
[1116276411,"Sisophon","Sisophon","Cambodia","KHM","admin",50302],
[1826679432,"Neath","Neath","United Kingdom","GBR","",45898],
[1840019321,"Aliso Viejo","Aliso Viejo","United States","USA","",50887],
[1400505859,"Jarash","Jarash","Jordan","JOR","admin",50745],
[1608442037,"Bangued","Bangued","Philippines","PHL","admin",50382],
[1504512130,"Beni Yakhlef","Beni Yakhlef","Morocco","MAR","",48338],
[1231809487,"Hāgere Hiywet","Hagere Hiywet","Ethiopia","ETH","",43920],
[1250181473,"Garges-lès-Gonesse","Garges-les-Gonesse","France","FRA","",42956],
[1826174957,"Kirkcaldy","Kirkcaldy","United Kingdom","GBR","",48108],
[1428952300,"Jūrmala","Jurmala","Latvia","LVA","admin",50248],
[1051509043,"Abovyan","Abovyan","Armenia","ARM","",44400],
[1504675793,"Azemmour","Azemmour","Morocco","MAR","",40920],
[1180674224,"Gbadolite","Gbadolite","Congo (Kinshasa)","COD","admin",50493],
[1250888157,"Bagneux","Bagneux","France","FRA","",40812],
[1250664815,"Bastia","Bastia","France","FRA","",48044],
[1380370266,"Lissone","Lissone","Italy","ITA","",45535],
[1840029029,"Country Club","Country Club","United States","USA","",50431],
[1222979186,"Cojutepeque","Cojutepeque","El Salvador","SLV","admin",48411],
[1032506308,"Villa Alsina","Villa Alsina","Argentina","ARG","",41155],
[1340141391,"Gracias","Gracias","Honduras","HND","admin",50256],
[1250863022,"Meudon","Meudon","France","FRA","",45748],
[1400670443,"Ma‘ān","Ma`an","Jordan","JOR","admin",50350],
[1072308184,"Selibe Phikwe","Selibe Phikwe","Botswana","BWA","admin",49724],
[1818610123,"Al Balyanā","Al Balyana","Egypt","EGY","",46997],
[1840001090,"Plainfield","Plainfield","United States","USA","",50317],
[1608442374,"Tubod","Tubod","Philippines","PHL","admin",50073],
[1840031295,"Wheaton","Wheaton","United States","USA","",50229],
[1380959273,"Campobasso","Campobasso","Italy","ITA","admin",49262],
[1604635600,"Moyobamba","Moyobamba","Peru","PER","admin",50073],
[1818872500,"Al Khārjah","Al Kharjah","Egypt","EGY","admin",49991],
[1826027715,"Ashton","Ashton","United Kingdom","GBR","",45198],
[1643514399,"Kotelniki","Kotelniki","Russia","RUS","",46763],
[1380201460,"Nichelino","Nichelino","Italy","ITA","",47721],
[1242640119,"Nausori","Nausori","Fiji","FJI","",47604],
[1380402852,"Paderno Dugnano","Paderno Dugnano","Italy","ITA","",46701],
[1376486332,"El‘ad","El`ad","Israel","ISR","",46896],
[1004504986,"Zaranj","Zaranj","Afghanistan","AFG","admin",49851],
[1384967993,"Odienné","Odienne","Côte d'Ivoire","CIV","admin",49857],
[1840031494,"North Bethesda","North Bethesda","United States","USA","",49872],
[1840019215,"Cerritos","Cerritos","United States","USA","",49859],
[1458939333,"Kangar","Kangar","Malaysia","MYS","admin",48898],
[1250362239,"La Courneuve","La Courneuve","France","FRA","",43946],
[1250108238,"Belfort","Belfort","France","FRA","minor",46954],
[1840000608,"Lakewood","Lakewood","United States","USA","",49678],
[1604876709,"Huancavelica","Huancavelica","Peru","PER","admin",49570],
[1724732496,"Mairena del Aljarafe","Mairena del Aljarafe","Spain","ESP","",46895],
[1124902278,"Dollard-des-Ormeaux","Dollard-des-Ormeaux","Canada","CAN","",49637],
[1752765449,"Luleå","Lulea","Sweden","SWE","admin",49123],
[1250335183,"Bagnolet","Bagnolet","France","FRA","",35442],
[1780835692,"Couva","Couva","Trinidad And Tobago","TTO","admin",48858],
[1826161019,"Inverness","Inverness","United Kingdom","GBR","",47290],
[1372267114,"Waterford","Waterford","Ireland","IRL","admin",48369],
[1826304328,"Salisbury","Salisbury","United Kingdom","GBR","",45477],
[1376215427,"Ramat HaSharon","Ramat HaSharon","Israel","ISR","",46700],
[1724895039,"Figueras","Figueras","Spain","ESP","",47043],
[1554017097,"Nelson","Nelson","New Zealand","NZL","admin",49300],
[1826430700,"Ayr","Ayr","United Kingdom","GBR","",46780],
[1056731697,"Evere","Evere","Belgium","BEL","",41131],
[1724279247,"San Felíu de Llobregat","San Feliu de Llobregat","Spain","ESP","",45463],
[1484867296,"Meoqui","Meoqui","Mexico","MEX","minor",44853],
[1840131592,"Bloomfield","Bloomfield","United States","USA","",49260],
[1032862666,"San Isidro","San Isidro","Argentina","ARG","minor",43595],
[1620361953,"Corroios","Corroios","Portugal","PRT","",46475],
[1250813874,"Châtillon","Chatillon","France","FRA","",37010],
[1203518899,"Karlovy Vary","Karlovy Vary","Czechia","CZE","admin",48319],
[1032126414,"José Mármol","Jose Marmol","Argentina","ARG","",41109],
[1826878333,"Wokingham","Wokingham","United Kingdom","GBR","",46745],
[1826594194,"Banbury","Banbury","United Kingdom","GBR","",46853],
[1840019327,"Cypress","Cypress","United States","USA","",49006],
[1840020354,"Hollister","Hollister","United States","USA","",48992],
[1250666731,"Mantes-la-Jolie","Mantes-la-Jolie","France","FRA","minor",44227],
[1804938726,"Rovenky","Rovenky","Ukraine","UKR","",46734],
[1004251962,"Asadābād","Asadabad","Afghanistan","AFG","admin",48400],
[1792425356,"Sarıyer","Sariyer","Turkey","TUR","minor",46729],
[1528241984,"Middelburg","Middelburg","Netherlands","NLD","admin",47939],
[1484002889,"Tulum","Tulum","Mexico","MEX","minor",33374],
[1356963190,"Gobārdānga","Gobardanga","India","IND","",45377],
[1643985194,"Krasnoznamensk","Krasnoznamensk","Russia","RUS","",41769],
[1840018910,"Ceres","Ceres","United States","USA","",48706],
[1218895755,"Nueva Loja","Nueva Loja","Ecuador","ECU","admin",48562],
[1380007396,"Seregno","Seregno","Italy","ITA","",45131],
[1466078415,"Kita","Kita","Mali","MLI","minor",46435],
[1072708388,"Serowe","Serowe","Botswana","BWA","admin",48573],
[1388493847,"Mandeville","Mandeville","Jamaica","JAM","admin",48317],
[1524574121,"Birendranagar","Birendranagar","Nepal","NPL","admin",47914],
[1764279113,"Nong Khai","Nong Khai","Thailand","THA","admin",48274],
[1643083395,"Salekhard","Salekhard","Russia","RUS","admin",48507],
[1840073852,"University","University","United States","USA","",48436],
[1716331687,"Bindura","Bindura","Zimbabwe","ZWE","admin",46275],
[1404771203,"Isiolo","Isiolo","Kenya","KEN","admin",45989],
[1858182538,"Mercedes","Mercedes","Uruguay","URY","admin",41974],
[1840022490,"Antelope","Antelope","United States","USA","",48398],
[1840020512,"La Mirada","La Mirada","United States","USA","",48183],
[1048219300,"Madīnat ‘Īsá","Madinat `Isa","Bahrain","BHR","",40000],
[1484472329,"Villa de Zaachila","Villa de Zaachila","Mexico","MEX","minor",43279],
[1392163993,"Inuma","Inuma","Japan","JPN","",45065],
[1380017105,"Torre Annunziata","Torre Annunziata","Italy","ITA","",42406],
[1250358877,"Malakoff","Malakoff","France","FRA","",30711],
[1426721246,"Leribe","Leribe","Lesotho","LSO","admin",47675],
[1826014873,"Hinckley","Hinckley","United Kingdom","GBR","",45249],
[1834328362,"Njombe","Njombe","Tanzania","TZA","admin",46724],
[1724013514,"Ripollet","Ripollet","Spain","ESP","",38347],
[1643340791,"Kanash","Kanash","Russia","RUS","",45482],
[1380717035,"Melito di Napoli","Melito di Napoli","Italy","ITA","",37943],
[1608912012,"Mamburao","Mamburao","Philippines","PHL","admin",47705],
[1250490677,"Talence","Talence","France","FRA","",42701],
[1250630825,"Chalon-sur-Saône","Chalon-sur-Saone","France","FRA","minor",44810],
[1554148942,"Invercargill","Invercargill","New Zealand","NZL","admin",47625],
[1528289295,"Kerkrade","Kerkrade","Netherlands","NLD","minor",45642],
[1840018841,"North Highlands","North Highlands","United States","USA","",47661],
[1376615005,"Karmiel","Karmiel","Israel","ISR","",45300],
[1328195392,"New Amsterdam","New Amsterdam","Guyana","GUY","admin",46874],
[1887522445,"Ḩajjah","Hajjah","Yemen","YEM","admin",46568],
[1250389807,"Charenton-le-Pont","Charenton-le-Pont","France","FRA","",30053],
[1246041998,"Kokkola","Kokkola","Finland","FIN","admin",47570],
[1840017581,"Florin","Florin","United States","USA","",47555],
[1788380846,"Hammam-Lif","Hammam-Lif","Tunisia","TUN","",42518],
[1840019241,"Covina","Covina","United States","USA","",47450],
[1404376456,"Embu","Embu","Kenya","KEN","admin",41092],
[1764357378,"Bang Kruai","Bang Kruai","Thailand","THA","minor",42390],
[1478524903,"Rosso","Rosso","Mauritania","MRT","admin",47203],
[1591257375,"Chitré","Chitre","Panama","PAN","admin",46191],
[1144962750,"Badulla","Badulla","Sri Lanka","LKA","admin",42923],
[1348509592,"Nagykanizsa","Nagykanizsa","Hungary","HUN","admin",46866],
[1818262231,"Naj‘ Ḩammādī","Naj` Hammadi","Egypt","EGY","",45038],
[1484811681,"Ciudad Constitución","Ciudad Constitucion","Mexico","MEX","minor",43805],
[1724799974,"San Adrián de Besós","San Adrian de Besos","Spain","ESP","",37283],
[1706054548,"Boosaaso","Boosaaso","Somalia","SOM","admin",46969],
[1591231138,"Santiago","Santiago","Panama","PAN","admin",45955],
[1376929399,"Qiryat Ono","Qiryat Ono","Israel","ISR","",37791],
[1250073067,"Caluire-et-Cuire","Caluire-et-Cuire","France","FRA","",42847],
[1250292202,"Le Cannet","Le Cannet","France","FRA","",41471],
[1834550750,"Lindi","Lindi","Tanzania","TZA","admin",41549],
[1072506645,"Kanye","Kanye","Botswana","BWA","admin",46831],
[1894419971,"Choma","Choma","Zambia","ZMB","admin",46746],
[1818459800,"Al Badārī","Al Badari","Egypt","EGY","",42770],
[1504917091,"Mrirt","Mrirt","Morocco","MAR","",42730],
[1752863731,"Trollhättan","Trollhattan","Sweden","SWE","minor",44543],
[1728097802,"Aweil","Aweil","South Sudan","SSD","admin",46705],
[1752026711,"Östersund","Ostersund","Sweden","SWE","admin",46178],
[1840000784,"Rye","Rye","United States","USA","",46595],
[1250025032,"Valenciennes","Valenciennes","France","FRA","minor",43405],
[1854096946,"Dori","Dori","Burkina Faso","BFA","admin",46521],
[1392003115,"Tōgō","Togo","Japan","JPN","",44065],
[1156756753,"Yuchengcun","Yuchengcun","China","CHN","",43983],
[1858646839,"Artigas","Artigas","Uruguay","URY","admin",40658],
[1840000425,"Everett","Everett","United States","USA","",46451],
[1826462023,"Coatbridge","Coatbridge","United Kingdom","GBR","",43960],
[1191444936,"Šibenik","Sibenik","Croatia","HRV","admin",46332],
[1156097347,"Daijiazhuang","Daijiazhuang","China","CHN","",44111],
[1068395023,"Cobija","Cobija","Bolivia","BOL","admin",46267],
[1826477913,"Chorley","Chorley","United Kingdom","GBR","",38420],
[1250002616,"Bron","Bron","France","FRA","",42216],
[1788113180,"Hammam Sousse","Hammam Sousse","Tunisia","TUN","",42691],
[1624753622,"Farim","Farim","Guinea-Bissau","GNB","admin",46268],
[1376946236,"Ben Zakkay","Ben Zakkay","Israel","ISR","",42314],
[1642971618,"Slobozia","Slobozia","Romania","ROU","admin",45891],
[1250698978,"Bois-Colombes","Bois-Colombes","France","FRA","",28468],
[1250574796,"Saint-Brieuc","Saint-Brieuc","France","FRA","minor",44170],
[1826616515,"Kingswood","Kingswood","United Kingdom","GBR","",40734],
[1620550022,"Mafamude","Mafamude","Portugal","PRT","",38940],
[1392003543,"Kumatori","Kumatori","Japan","JPN","",43570],
[1484411990,"Santa María Atzompa","Santa Maria Atzompa","Mexico","MEX","",41921],
[1056838834,"Vilvoorde","Vilvoorde","Belgium","BEL","minor",44015],
[1156087114,"Donggangli","Donggangli","China","CHN","",24605],
[1100463536,"Vidin","Vidin","Bulgaria","BGR","admin",45926],
[1724444786,"Igualada","Igualada","Spain","ESP","",40875],
[1380496948,"Rozzano","Rozzano","Italy","ITA","",42442],
[1430269323,"Gbarnga","Gbarnga","Liberia","LBR","admin",45835],
[1504230609,"Jerada","Jerada","Morocco","MAR","",43506],
[1250321790,"Vanves","Vanves","France","FRA","",27466],
[1642953190,"Alexandria","Alexandria","Romania","ROU","admin",45434],
[1250114874,"Stains","Stains","France","FRA","",38666],
[1356247896,"Diamond Harbour","Diamond Harbour","India","IND","",41802],
[1484054405,"Jáltipan de Morelos","Jaltipan de Morelos","Mexico","MEX","minor",41644],
[1608192136,"Palayan City","Palayan City","Philippines","PHL","admin",45383],
[1756018756,"Thun","Thun","Switzerland","CHE","minor",43743],
[1826345299,"Kingston upon Thames","Kingston upon Thames","United Kingdom","GBR","",43013],
[1180712204,"Buta","Buta","Congo (Kinshasa)","COD","admin",45677],
[1192344354,"Nueva Gerona","Nueva Gerona","Cuba","CUB","admin",45577],
[1012450434,"Tindouf","Tindouf","Algeria","DZA","admin",45610],
[1558301368,"Bluefields","Bluefields","Nicaragua","NIC","admin",45547],
[1188743090,"Liberia","Liberia","Costa Rica","CRI","admin",45380],
[1250693185,"Boulogne-sur-Mer","Boulogne-sur-Mer","France","FRA","minor",40664],
[1756130026,"Bellinzona","Bellinzona","Switzerland","CHE","",43220],
[1764277891,"Pattani","Pattani","Thailand","THA","admin",44234],
[1862961933,"Lecherías","Lecherias","Venezuela","VEN","minor",36450],
[1250886805,"Rezé","Reze","France","FRA","",42368],
[1484594634,"Actopan","Actopan","Mexico","MEX","minor",43388],
[1250000251,"Gagny","Gagny","France","FRA","",39618],
[1792813007,"Iğdır","Igdir","Turkey","TUR","admin",45321],
[1840053631,"Arlington","Arlington","United States","USA","",45304],
[1276865707,"Pinneberg","Pinneberg","Germany","DEU","minor",43280],
[1724229842,"Alcantarilla","Alcantarilla","Spain","ESP","",42559],
[1578533046,"Arendal","Arendal","Norway","NOR","admin",45065],
[1826103829,"Newbury","Newbury","United Kingdom","GBR","",41075],
[1484352296,"Coyotepec","Coyotepec","Mexico","MEX","minor",41810],
[1840015139,"Oakland Park","Oakland Park","United States","USA","",45202],
[1250001722,"Tarbes","Tarbes","France","FRA","minor",42426],
[1250447540,"Arras","Arras","France","FRA","minor",41555],
[1484003827,"Teoloyucan","Teoloyucan","Mexico","MEX","minor",41333],
[1600557615,"Concepción","Concepcion","Paraguay","PRY","admin",45068],
[1348928583,"Dunaújváros","Dunaujvaros","Hungary","HUN","admin",44200],
[1268300325,"Zugdidi","Zugdidi","Georgia","GEO","admin",42998],
[1800408751,"Kabale","Kabale","Uganda","UGA","admin",44600],
[1380553893,"Desio","Desio","Italy","ITA","",42079],
[1484878589,"Salvatierra","Salvatierra","Mexico","MEX","minor",37203],
[1250913458,"Melun","Melun","France","FRA","minor",39947],
[1616873846,"Świdnik","Swidnik","Poland","POL","minor",42797],
[1840017918,"Altadena","Altadena","United States","USA","",44850],
[1100543134,"Kyustendil","Kyustendil","Bulgaria","BGR","admin",44787],
[1376833983,"Qiryat Bialik","Qiryat Bialik","Israel","ISR","",39900],
[1504312724,"El Aïoun","El Aioun","Morocco","MAR","",41832],
[1250793808,"Nogent-sur-Marne","Nogent-sur-Marne","France","FRA","minor",32922],
[1012627486,"Boumerdes","Boumerdes","Algeria","DZA","admin",41685],
[1784525230,"Umm al Qaywayn","Umm al Qaywayn","United Arab Emirates","ARE","admin",44411],
[1124316061,"Duncan","Duncan","Canada","CAN","",44451],
[1320147012,"Chimaltenango","Chimaltenango","Guatemala","GTM","admin",43900],
[1051527958,"Kapan","Kapan","Armenia","ARM","admin",43190],
[1484536308,"Paracho de Verduzco","Paracho de Verduzco","Mexico","MEX","",37464],
[1484366250,"Empalme","Empalme","Mexico","MEX","minor",38886],
[1800139086,"Fort Portal","Fort Portal","Uganda","UGA","admin",42670],
[1792855788,"Afyonkarahisar","Afyonkarahisar","Turkey","TUR","admin",44026],
[1392007461,"Katsuren-haebaru","Katsuren-haebaru","Japan","JPN","",40541],
[1826934854,"Llanelli","Llanelli","United Kingdom","GBR","",37050],
[1840015138,"North Lauderdale","North Lauderdale","United States","USA","",44262],
[1608495530,"Baler","Baler","Philippines","PHL","admin",43785],
[1840003556,"Hackensack","Hackensack","United States","USA","",44188],
[1484540557,"Nueva Rosita","Nueva Rosita","Mexico","MEX","",39058],
[1036266942,"Caloundra","Caloundra","Australia","AUS","",41293],
[1392003190,"Ōizumi","Oizumi","Japan","JPN","",41681],
[1840000597,"Cleveland Heights","Cleveland Heights","United States","USA","",43992],
[1504419242,"Temsia","Temsia","Morocco","MAR","",40780],
[1250832962,"Wattrelos","Wattrelos","France","FRA","",40885],
[1484068720,"Playa Vicente","Playa Vicente","Mexico","MEX","minor",39205],
[1144554963,"Matale","Matale","Sri Lanka","LKA","",36451],
[1620357803,"Ermezinde","Ermezinde","Portugal","PRT","",38798],
[1807468155,"Veles","Veles","Macedonia","MKD","admin",43716],
[1376356429,"Or Yehuda","Or Yehuda","Israel","ISR","",36706],
[1032803323,"Haedo","Haedo","Argentina","ARG","",37745],
[1807614061,"Štip","Stip","Macedonia","MKD","admin",43652],
[1250286015,"Le Kremlin-Bicêtre","Le Kremlin-Bicetre","France","FRA","",24850],
[1434910333,"Murzuq","Murzuq","Libya","LBY","admin",43732],
[1372750233,"Drogheda","Drogheda","Ireland","IRL","",40956],
[1376191471,"Shefar‘am","Shefar`am","Israel","ISR","",41600],
[1630023656,"Trujillo Alto","Trujillo Alto","Puerto Rico","PRI","",43703],
[1620147105,"Cacém","Cacem","Portugal","PRT","",21289],
[1840002747,"Concord","Concord","United States","USA","admin",43627],
[1752640618,"Kalmar","Kalmar","Sweden","SWE","admin",41388],
[1250122238,"Annemasse","Annemasse","France","FRA","",36250],
[1032318811,"Munro","Munro","Argentina","ARG","",35844],
[1800284151,"Mityana","Mityana","Uganda","UGA","admin",41131],
[1826278899,"Ramsgate","Ramsgate","United Kingdom","GBR","",40408],
[1348676241,"Hódmezővásárhely","Hodmezovasarhely","Hungary","HUN","admin",43311],
[1116735270,"Kampong Chhnang","Kampong Chhnang","Cambodia","KHM","admin",41700],
[1484009408,"Uman","Uman","Mexico","MEX","",39611],
[1840006011,"Annandale","Annandale","United States","USA","",43295],
[1840020243,"Rohnert Park","Rohnert Park","United States","USA","",43291],
[1484000401,"Juan Rodríguez Clara","Juan Rodriguez Clara","Mexico","MEX","minor",38895],
[1504084050,"Aziylal","Aziylal","Morocco","MAR","",38520],
[1840000410,"Salem","Salem","United States","USA","",43226],
[1380104019,"Pomigliano d’Arco","Pomigliano d'Arco","Italy","ITA","",39819],
[1528896975,"Beverwijk","Beverwijk","Netherlands","NLD","minor",41176],
[1051878002,"Armavir","Armavir","Armenia","ARM","admin",38635],
[1858724823,"Minas","Minas","Uruguay","URY","admin",38446],
[1266537692,"Franceville","Franceville","Gabon","GAB","admin",42967],
[1840015155,"North Miami Beach","North Miami Beach","United States","USA","",43041],
[1826440705,"Bishops Stortford","Bishops Stortford","United Kingdom","GBR","",38202],
[1706488487,"Garbahaarrey","Garbahaarrey","Somalia","SOM","admin",43000],
[1764698508,"Ban Sai Ma Tai","Ban Sai Ma Tai","Thailand","THA","",30750],
[1250716454,"Franconville","Franconville","France","FRA","",37010],
[1380012817,"Saronno","Saronno","Italy","ITA","",39419],
[1840033834,"Whitney","Whitney","United States","USA","",42973],
[1840005288,"Freeport","Freeport","United States","USA","",42956],
[1191004286,"Dubrovnik","Dubrovnik","Croatia","HRV","admin",42615],
[1484736113,"Ciudad Melchor Múzquiz","Ciudad Melchor Muzquiz","Mexico","MEX","minor",38992],
[1840021549,"San Bruno","San Bruno","United States","USA","",42807],
[1624877378,"Quinhámel","Quinhamel","Guinea-Bissau","GNB","admin",42659],
[1840005266,"Hicksville","Hicksville","United States","USA","",42709],
[1356008028,"Damān","Daman","India","IND","admin",39737],
[1818973684,"Dayr Mawās","Dayr Mawas","Egypt","EGY","",40640],
[1840005109,"West Babylon","West Babylon","United States","USA","",42665],
[1484944309,"Tonalá","Tonala","Mexico","MEX","minor",35322],
[1484505986,"Temascal","Temascal","Mexico","MEX","",39680],
[1620174984,"Guarda","Guarda","Portugal","PRT","admin",42541],
[1764002764,"Si Sa Ket","Si Sa Ket","Thailand","THA","admin",42405],
[1724143581,"Blanes","Blanes","Spain","ESP","",40274],
[1250862617,"Saint-Martin-d’Hères","Saint-Martin-d'Heres","France","FRA","",38398],
[1756145667,"Fribourg","Fribourg","Switzerland","CHE","admin",38365],
[1116966757,"Kampot","Kampot","Cambodia","KHM","admin",39186],
[1642603145,"Miercurea-Ciuc","Miercurea-Ciuc","Romania","ROU","admin",42029],
[1032579921,"Dock Sur","Dock Sur","Argentina","ARG","",35897],
[1250033970,"Le Perreux-Sur-Marne","Le Perreux-Sur-Marne","France","FRA","",33793],
[1008955153,"Berat","Berat","Albania","ALB","admin",36496],
[1504763448,"Ait Ourir","Ait Ourir","Morocco","MAR","",39108],
[1804138671,"Myrhorod","Myrhorod","Ukraine","UKR","minor",40160],
[1140304277,"Bambari","Bambari","Central African Republic","CAF","admin",41356],
[1504579638,"Zagora","Zagora","Morocco","MAR","",40067],
[1250549282,"Le Pré-Saint-Gervais","Le Pre-Saint-Gervais","France","FRA","",17485],
[1250259069,"Cachan","Cachan","France","FRA","",30884],
[1392968664,"Nakama","Nakama","Japan","JPN","",39634],
[1704552735,"Cao Bằng","Cao Bang","Vietnam","VNM","admin",41112],
[1858927597,"San José","San Jose","Uruguay","URY","admin",36747],
[1156275236,"Matoupu","Matoupu","China","CHN","",40010],
[1826427395,"Aberdare","Aberdare","United Kingdom","GBR","",39550],
[1484011085,"Xico","Xico","Mexico","MEX","minor",38198],
[1834043034,"Kahama","Kahama","Tanzania","TZA","",36014],
[1840019229,"Bell Gardens","Bell Gardens","United States","USA","",42012],
[1724718493,"Villafranca del Panadés","Villafranca del Panades","Spain","ESP","",39969],
[1250549576,"Savigny-sur-Orge","Savigny-sur-Orge","France","FRA","",36734],
[1380045359,"Cesano Maderno","Cesano Maderno","Italy","ITA","",38637],
[1250026390,"Douai","Douai","France","FRA","minor",39634],
[1826454069,"Herne Bay","Herne Bay","United Kingdom","GBR","",38385],
[1152562274,"Placilla de Peñuelas","Placilla de Penuelas","Chile","CHL","",39344],
[1356850881,"Amudālavalasa","Amudalavalasa","India","IND","",39799],
[1840018949,"Campbell","Campbell","United States","USA","",41793],
[1840003290,"Woonsocket","Woonsocket","United States","USA","",41751],
[1188639267,"Puntarenas","Puntarenas","Costa Rica","CRI","admin",41528],
[1504630552,"Biougra","Biougra","Morocco","MAR","",37933],
[1764748532,"Narathiwat","Narathiwat","Thailand","THA","admin",41342],
[1250068443,"Échirolles","Echirolles","France","FRA","",36961],
[1380872508,"Mugnano di Napoli","Mugnano di Napoli","Italy","ITA","",34996],
[1356994427,"Kānkuria","Kankuria","India","IND","",36925],
[1608281273,"Mambajao","Mambajao","Philippines","PHL","admin",41094],
[1380847693,"Ciampino","Ciampino","Italy","ITA","",38645],
[1484460521,"Zacatelco","Zacatelco","Mexico","MEX","minor",38654],
[1340290947,"La Paz","La Paz","Honduras","HND","admin",41250],
[1356010831,"Pujali","Pujali","India","IND","",37047],
[1643010235,"Morshansk","Morshansk","Russia","RUS","",39362],
[1032929712,"Villa Adelina","Villa Adelina","Argentina","ARG","",35307],
[1380852442,"Arzano","Arzano","Italy","ITA","",34217],
[1180127290,"Lusambo","Lusambo","Congo (Kinshasa)","COD","admin",41416],
[1792000464,"Kars","Kars","Turkey","TUR","admin",41376],
[1484073387,"Sayula de Alemán","Sayula de Aleman","Mexico","MEX","minor",32721],
[1600446518,"Villarrica","Villarrica","Paraguay","PRY","admin",41157],
[1108753930,"Ngozi","Ngozi","Burundi","BDI","admin",39884],
[1418975079,"Xam Nua","Xam Nua","Laos","LAO","admin",38992],
[1250045997,"Marcq-en-Baroeul","Marcq-en-Baroeul","France","FRA","",38570],
[1484716155,"Ameca","Ameca","Mexico","MEX","minor",36156],
[1404617601,"Kisii","Kisii","Kenya","KEN","admin",37531],
[1356842137,"Chittaranjan","Chittaranjan","India","IND","",39098],
[1380973282,"Corsico","Corsico","Italy","ITA","",34727],
[1250776265,"Poissy","Poissy","France","FRA","",38313],
[1300407295,"Kozáni","Kozani","Greece","GRC","admin",41066],
[1724238629,"Burjasot","Burjasot","Spain","ESP","",38712],
[1710121734,"Vredenburg","Vredenburg","South Africa","ZAF","",38382],
[1616964352,"Malbork","Malbork","Poland","POL","minor",38895],
[1056856588,"Wilrijk","Wilrijk","Belgium","BEL","",38319],
[1516866759,"Oshakati","Oshakati","Namibia","NAM","admin",39679],
[1356909212,"Panaji","Panaji","India","IND","admin",40017],
[1840036057,"Greenacres","Greenacres","United States","USA","",41117],
[1196128852,"Famagusta","Famagusta","Cyprus","CYP","admin",40920],
[1608428749,"Romblon","Romblon","Philippines","PHL","admin",40554],
[1218387446,"Puerto Francisco de Orellana","Puerto Francisco de Orellana","Ecuador","ECU","admin",40730],
[1484132726,"Zacatlán","Zacatlan","Mexico","MEX","minor",33736],
[1392859111,"Miyoshidai","Miyoshidai","Japan","JPN","",38380],
[1250377296,"Neuilly-sur-Marne","Neuilly-sur-Marne","France","FRA","",35680],
[1250274181,"Villepinte","Villepinte","France","FRA","",37280],
[1156929184,"Shengli","Shengli","China","CHN","minor",36937],
[1484752107,"Cananea","Cananea","Mexico","MEX","minor",38113],
[1887788283,"Al Bayḑā’","Al Bayda'","Yemen","YEM","admin",37821],
[1840000777,"Wilkes-Barre","Wilkes-Barre","United States","USA","",40766],
[1031776445,"Şəmkir","Samkir","Azerbaijan","AZE","admin",40600],
[1250325561,"Chartres","Chartres","France","FRA","minor",38426],
[1788800357,"Ez Zahra","Ez Zahra","Tunisia","TUN","",34962],
[1826878705,"Bletchley","Bletchley","United Kingdom","GBR","",37520],
[1233955054,"Pärnu","Parnu","Estonia","EST","admin",39438],
[1764865021,"Ban Na Pa","Ban Na Pa","Thailand","THA","",38548],
[1372735852,"Dún Dealgan","Dun Dealgan","Ireland","IRL","admin",39004],
[1484215926,"Mariano Escobedo","Mariano Escobedo","Mexico","MEX","minor",37285],
[1826889162,"Airdrie","Airdrie","United Kingdom","GBR","",37410],
[1191340640,"Bjelovar","Bjelovar","Croatia","HRV","admin",40276],
[1840081757,"Teaneck","Teaneck","United States","USA","",40458],
[1380580243,"Grugliasco","Grugliasco","Italy","ITA","",37592],
[1728463035,"Yambio","Yambio","South Sudan","SSD","admin",40382],
[1140144321,"Bouar","Bouar","Central African Republic","CAF","admin",40353],
[1100946651,"Montana","Montana","Bulgaria","BGR","admin",40295],
[1620936507,"Agualva","Agualva","Portugal","PRT","",35824],
[1504994850,"Sidi Yahia El Gharb","Sidi Yahia El Gharb","Morocco","MAR","",37979],
[1012834851,"El Golea","El Golea","Algeria","DZA","admin",40195],
[1372755688,"Swords","Swords","Ireland","IRL","admin",36924],
[1180194164,"Inongo","Inongo","Congo (Kinshasa)","COD","admin",40113],
[1250969422,"Villefranche-sur-Saône","Villefranche-sur-Saone","France","FRA","minor",36288],
[1392146454,"Kanie","Kanie","Japan","JPN","",36782],
[1840020408,"Montclair","Montclair","United States","USA","",40083],
[1320999503,"Retalhuleu","Retalhuleu","Guatemala","GTM","admin",40000],
[1764632382,"Chachoengsao","Chachoengsao","Thailand","THA","admin",39570],
[1418378289,"Phônsavan","Phonsavan","Laos","LAO","admin",37507],
[1031335433,"Xaçmaz","Xacmaz","Azerbaijan","AZE","admin",39900],
[1070370826,"Brčko","Brcko","Bosnia And Herzegovina","BIH","admin",39893],
[1100987486,"Targovishte","Targovishte","Bulgaria","BGR","admin",39874],
[1764003521,"Samrong","Samrong","Thailand","THA","",30382],
[1148599298,"Koumra","Koumra","Chad","TCD","admin",39852],
[1250428869,"Sainte-Geneviève-des-Bois","Sainte-Genevieve-des-Bois","France","FRA","",36015],
[1840021862,"San Gabriel","San Gabriel","United States","USA","",39899],
[1764813179,"Surin","Surin","Thailand","THA","admin",39728],
[1608769914,"Jordan","Jordan","Philippines","PHL","admin",39566],
[1250320498,"Pierrefitte-sur-Seine","Pierrefitte-sur-Seine","France","FRA","",30828],
[1840014237,"Hallandale Beach","Hallandale Beach","United States","USA","",39847],
[1232344222,"Massawa","Massawa","Eritrea","ERI","admin",39758],
[1608320897,"San Roque","San Roque","Philippines","PHL","",19335],
[1484876293,"Nueva Italia de Ruiz","Nueva Italia de Ruiz","Mexico","MEX","",32467],
[1250321161,"Houilles","Houilles","France","FRA","",32449],
[1218296446,"Santa Elena","Santa Elena","Ecuador","ECU","admin",39681],
[1380525862,"Pioltello","Pioltello","Italy","ITA","",36920],
[1072876960,"Mochudi","Mochudi","Botswana","BWA","admin",39700],
[1840018581,"Keizer","Keizer","United States","USA","",39713],
[1756335917,"Vernier","Vernier","Switzerland","CHE","",35132],
[1840000456,"Chelsea","Chelsea","United States","USA","",39690],
[1380853307,"Sant’Antimo","Sant'Antimo","Italy","ITA","",33892],
[1724606295,"San Juan Despí","San Juan Despi","Spain","ESP","",34130],
[1616375300,"Sopot","Sopot","Poland","POL","minor",37457],
[1840020513,"La Puente","La Puente","United States","USA","",39614],
[1250804499,"Les Lilas","Les Lilas","France","FRA","",23402],
[1012546670,"Touggourt","Touggourt","Algeria","DZA","admin",39409],
[1484776246,"Miahuatlán de Porfirio Díaz","Miahuatlan de Porfirio Diaz","Mexico","MEX","minor",35517],
[1858077099,"Florida","Florida","Uruguay","URY","admin",33639],
[1705563326,"Celje","Celje","Slovenia","SVN","admin",37872],
[1250512323,"Châtenay-Malabry","Chatenay-Malabry","France","FRA","",34170],
[1250707197,"L’Haÿ-les-Roses","L'Hay-les-Roses","France","FRA","minor",31417],
[1840023258,"Waipahu","Waipahu","United States","USA","",39469],
[1484059135,"Pánuco","Panuco","Mexico","MEX","minor",33122],
[1826640623,"Bridlington","Bridlington","United Kingdom","GBR","",35264],
[1642326202,"Olteniţa","Oltenita","Romania","ROU","",24822],
[1031860893,"Ağcabədi","Agcabadi","Azerbaijan","AZE","admin",39200],
[1724296865,"Premiá de Mar","Premia de Mar","Spain","ESP","",28523],
[1380424461,"Bollate","Bollate","Italy","ITA","",36486],
[1250363572,"Conflans-Sainte-Honorine","Conflans-Sainte-Honorine","France","FRA","",35656],
[1840005928,"Annapolis","Annapolis","United States","USA","admin",39223],
[1250955386,"Athis-Mons","Athis-Mons","France","FRA","",35101],
[1858006236,"Durazno","Durazno","Uruguay","URY","admin",34368],
[1840019243,"Culver City","Culver City","United States","USA","",39185],
[1504718907,"El Hajeb","El Hajeb","Morocco","MAR","",35282],
[1826502864,"Falkirk","Falkirk","United Kingdom","GBR","",35850],
[1250367571,"Creil","Creil","France","FRA","",35800],
[1818275538,"Fāraskūr","Faraskur","Egypt","EGY","",36850],
[1578188822,"Tromsø","Tromso","Norway","NOR","admin",38980],
[1484308293,"Zinacantán","Zinacantan","Mexico","MEX","minor",36489],
[1840013210,"Frankfort","Frankfort","United States","USA","admin",38852],
[1840020192,"Northglenn","Northglenn","United States","USA","",38819],
[1504831853,"Zaïo","Zaio","Morocco","MAR","",35806],
[1442192663,"Esch-sur-Alzette","Esch-sur-Alzette","Luxembourg","LUX","admin",36228],
[1704662313,"Tuyên Quang","Tuyen Quang","Vietnam","VNM","admin",36430],
[1300600750,"Vrilíssia","Vrilissia","Greece","GRC","minor",30741],
[1250731865,"Palaiseau","Palaiseau","France","FRA","minor",35590],
[1704495953,"Hà Giang","Ha Giang","Vietnam","VNM","admin",38362],
[1031495701,"Bərdə","Barda","Azerbaijan","AZE","admin",38500],
[1901230162,"Klinë","Kline","Kosovo","XKS","admin",38496],
[1840003552,"Fort Lee","Fort Lee","United States","USA","",38605],
[1380710953,"Casalecchio di Reno","Casalecchio di Reno","Italy","ITA","",36456],
[1826963129,"Dover","Dover","United Kingdom","GBR","",31022],
[1076808220,"Riacho de Santana","Riacho de Santana","Brazil","BRA","",36039],
[1250985976,"Villeneuve-Saint-Georges","Villeneuve-Saint-Georges","France","FRA","",34607],
[1840015127,"Lake Worth","Lake Worth","United States","USA","",38526],
[1804587935,"Bucha","Bucha","Ukraine","UKR","minor",35162],
[1840035805,"Kendall West","Kendall West","United States","USA","",38433],
[1840131597,"Montclair","Montclair","United States","USA","",38427],
[1250572876,"Le Plessis-Robinson","Le Plessis-Robinson","France","FRA","",29665],
[1484507470,"Tomatlán","Tomatlan","Mexico","MEX","minor",35824],
[1484295544,"Escuinapa","Escuinapa","Mexico","MEX","minor",30790],
[1496921469,"Choybalsan","Choybalsan","Mongolia","MNG","admin",38150],
[1826093917,"Hitchin","Hitchin","United Kingdom","GBR","",34266],
[1484303350,"Tenosique","Tenosique","Mexico","MEX","minor",32415],
[1156095214,"Shangzhuangcun","Shangzhuangcun","China","CHN","",35570],
[1148823427,"Am-Timan","Am-Timan","Chad","TCD","admin",38261],
[1840018023,"La Presa","La Presa","United States","USA","",38227],
[1620579552,"Massamá","Massama","Portugal","PRT","",28112],
[1380188289,"Brugherio","Brugherio","Italy","ITA","",34868],
[1862212549,"Trujillo","Trujillo","Venezuela","VEN","admin",38110],
[1705842003,"Kranj","Kranj","Slovenia","SVN","admin",37941],
[1840021966,"Stanton","Stanton","United States","USA","",38139],
[1616000502,"Brzeg","Brzeg","Poland","POL","minor",35890],
[1688358284,"Kikinda","Kikinda","Serbia","SRB","admin",38065],
[1504260154,"Zeghanghane","Zeghanghane","Morocco","MAR","",34025],
[1840005236,"East Meadow","East Meadow","United States","USA","",38029],
[1484078900,"La Huacana","La Huacana","Mexico","MEX","minor",34243],
[1262104228,"Ali Sabieh","Ali Sabieh","Djibouti","DJI","admin",37939],
[1380489248,"Limbiate","Limbiate","Italy","ITA","",35141],
[1840019643,"Mission Bend","Mission Bend","United States","USA","",37979],
[1156022705,"Yihezhuang","Yihezhuang","China","CHN","",34359],
[1196607408,"Paphos","Paphos","Cyprus","CYP","admin",35961],
[1454358935,"Karonga","Karonga","Malawi","MWI","admin",34207],
[1250139521,"Bezons","Bezons","France","FRA","",30484],
[1144238069,"Mannar","Mannar","Sri Lanka","LKA","",35000],
[1484640217,"Reforma","Reforma","Mexico","MEX","minor",29018],
[1840073269,"Egypt Lake-Leto","Egypt Lake-Leto","United States","USA","",37704],
[1826040909,"Grantham","Grantham","United Kingdom","GBR","",34592],
[1246377765,"Kajaani","Kajaani","Finland","FIN","admin",37622],
[1600283545,"Salto del Guairá","Salto del Guaira","Paraguay","PRY","admin",37600],
[1484237393,"Villagrán","Villagran","Mexico","MEX","minor",27079],
[1484716801,"Soteapan","Soteapan","Mexico","MEX","minor",35155],
[1392003375,"Ōharu","Oharu","Japan","JPN","",32590],
[1392000863,"Harima","Harima","Japan","JPN","",33822],
[1840073270,"Richmond West","Richmond West","United States","USA","",37486],
[1756849233,"Schaffhausen","Schaffhausen","Switzerland","CHE","admin",36587],
[1484990539,"Nanchital de Lázaro Cárdenas del Río","Nanchital de Lazaro Cardenas del Rio","Mexico","MEX","minor",30039],
[1392003339,"Aizumi","Aizumi","Japan","JPN","",35269],
[1250831662,"Villemomble","Villemomble","France","FRA","",30005],
[1840005331,"Valley Stream","Valley Stream","United States","USA","",37431],
[1788636202,"Tozeur","Tozeur","Tunisia","TUN","admin",37365],
[1840011251,"Hanover Park","Hanover Park","United States","USA","",37426],
[1250907646,"Thonon-les-Bains","Thonon-les-Bains","France","FRA","minor",35241],
[1250916117,"Schiltigheim","Schiltigheim","France","FRA","",33069],
[1887172893,"‘Ataq","`Ataq","Yemen","YEM","admin",37315],
[1826318947,"Ewell","Ewell","United Kingdom","GBR","",34872],
[1392003320,"Fusō","Fuso","Japan","JPN","",34268],
[1140523604,"Bossangoa","Bossangoa","Central African Republic","CAF","admin",36478],
[1484064616,"Abasolo","Abasolo","Mexico","MEX","minor",27389],
[1056006015,"Koekelberg","Koekelberg","Belgium","BEL","",18541],
[1724760114,"Alacuás","Alacuas","Spain","ESP","",29649],
[1484503444,"Putla Villa de Guerrero","Putla Villa de Guerrero","Mexico","MEX","minor",32640],
[1250000869,"Saint-Mandé","Saint-Mande","France","FRA","",22248],
[1840014240,"South Miami Heights","South Miami Heights","United States","USA","",37119],
[1724677327,"Salt","Salt","Spain","ESP","",32230],
[1688287067,"Prijepolje","Prijepolje","Serbia","SRB","admin",37059],
[1760132692,"Al Qunayţirah","Al Qunaytirah","Syria","SYR","admin",37022],
[1392591354,"Nishihara","Nishihara","Japan","JPN","",34802],
[1764784757,"Chaiyaphum","Chaiyaphum","Thailand","THA","admin",36923],
[1380177651,"Riccione Marina","Riccione Marina","Italy","ITA","",35003],
[1840014243,"Aventura","Aventura","United States","USA","",36987],
[1840009183,"Park Ridge","Park Ridge","United States","USA","",36950],
[1380429840,"Cernusco sul Naviglio","Cernusco sul Naviglio","Italy","ITA","",34341],
[1752939220,"Falun","Falun","Sweden","SWE","admin",36477],
[1484936909,"Ometepec","Ometepec","Mexico","MEX","minor",30271],
[1484056090,"Ticul","Ticul","Mexico","MEX","",32796],
[1250311855,"Romainville","Romainville","France","FRA","",28536],
[1484273682,"Parras de la Fuente","Parras de la Fuente","Mexico","MEX","minor",33817],
[1826918722,"Abingdon","Abingdon","United Kingdom","GBR","",33130],
[1764773366,"Ratchaburi","Ratchaburi","Thailand","THA","admin",36339],
[1484203573,"Paso del Macho","Paso del Macho","Mexico","MEX","minor",31890],
[1484005936,"Paso de Ovejas","Paso de Ovejas","Mexico","MEX","minor",33392],
[1231837780,"Goba","Goba","Ethiopia","ETH","",34369],
[1752316086,"Karlskrona","Karlskrona","Sweden","SWE","admin",35212],
[1504892729,"Tit Mellil","Tit Mellil","Morocco","MAR","",32782],
[1484535008,"Zapotiltic","Zapotiltic","Mexico","MEX","minor",29190],
[1826965204,"Trowbridge","Trowbridge","United Kingdom","GBR","",33108],
[1380361443,"Angri","Angri","Italy","ITA","",34126],
[1226449195,"Ebebiyín","Ebebiyin","Equatorial Guinea","GNQ","admin",36565],
[1484814346,"Calpulalpan","Calpulalpan","Mexico","MEX","minor",33263],
[1826453586,"Rutherglen","Rutherglen","United Kingdom","GBR","",31190],
[1616073267,"Czeladź","Czeladz","Poland","POL","",34402],
[1840028098,"West Hollywood","West Hollywood","United States","USA","",36475],
[1826846225,"Wigston Magna","Wigston Magna","United Kingdom","GBR","",32321],
[1031227222,"Göyçay","Goycay","Azerbaijan","AZE","admin",36200],
[1840008930,"Richfield","Richfield","United States","USA","",36354],
[1250123655,"Clichy-sous-Bois","Clichy-sous-Bois","France","FRA","",28992],
[1840017500,"Kearns","Kearns","United States","USA","",36330],
[1840003984,"Lincoln Park","Lincoln Park","United States","USA","",36321],
[1250855196,"Chatou","Chatou","France","FRA","",30330],
[1484944433,"Tancítaro","Tancitaro","Mexico","MEX","",31100],
[1756471395,"Chur","Chur","Switzerland","CHE","admin",35038],
[1800855823,"Adjumani","Adjumani","Uganda","UGA","admin",34700],
[1376760246,"Yehud","Yehud","Israel","ISR","",29146],
[1484667360,"San Juan Evangelista","San Juan Evangelista","Mexico","MEX","minor",33929],
[1484353804,"Amecameca de Juárez","Amecameca de Juarez","Mexico","MEX","minor",31687],
[1826803495,"Lichfield","Lichfield","United Kingdom","GBR","",33816],
[1840015145,"Lauderdale Lakes","Lauderdale Lakes","United States","USA","",36194],
[1840131591,"Belleville","Belleville","United States","USA","",36181],
[1116392544,"Krong Kep","Krong Kep","Cambodia","KHM","admin",35990],
[1901851592,"Kamenicë","Kamenice","Kosovo","XKS","admin",36085],
[1250376205,"Fresnes","Fresnes","France","FRA","",28230],
[1276918130,"Kornwestheim","Kornwestheim","Germany","DEU","",33803],
[1392934140,"Minamishiro","Minamishiro","Japan","JPN","",34012],
[1646868980,"Byumba","Byumba","Rwanda","RWA","admin",34544],
[1250674978,"Roanne","Roanne","France","FRA","minor",34004],
[1792863603,"Bartın","Bartin","Turkey","TUR","admin",35992],
[1208606810,"Viborg","Viborg","Denmark","DNK","admin",34831],
[1250549360,"Ermont","Ermont","France","FRA","",29079],
[1807901060,"Gostivar","Gostivar","Macedonia","MKD","admin",35847],
[1840031198,"Watertown Town","Watertown Town","United States","USA","",35939],
[1826382276,"Ecclesfield","Ecclesfield","United Kingdom","GBR","",31609],
[1620050458,"Beja","Beja","Portugal","PRT","admin",35854],
[1250059626,"Agen","Agen","France","FRA","minor",33012],
[1840017582,"Foothill Farms","Foothill Farms","United States","USA","",35881],
[1688560040,"Vršac","Vrsac","Serbia","SRB","admin",35701],
[1710933404,"Cradock","Cradock","South Africa","ZAF","",32898],
[1840005226,"Elmont","Elmont","United States","USA","",35824],
[1528829387,"Maassluis","Maassluis","Netherlands","NLD","minor",32768],
[1250247527,"Pontoise","Pontoise","France","FRA","",31422],
[1840021872,"Temple City","Temple City","United States","USA","",35811],
[1356036784,"Kaippakanchēri","Kaippakancheri","India","IND","",33721],
[1250498232,"Viry-Châtillon","Viry-Chatillon","France","FRA","",30706],
[1380472958,"Villaricca","Villaricca","Italy","ITA","",31223],
[1804354882,"Chuhuiv","Chuhuiv","Ukraine","UKR","minor",33144],
[1792360822,"Uşak","Usak","Turkey","TUR","admin",35517],
[1380291310,"Aosta","Aosta","Italy","ITA","admin",34082],
[1250306722,"Les Mureaux","Les Mureaux","France","FRA","",32949],
[1392003177,"Kōryō","Koryo","Japan","JPN","",33617],
[1466595315,"Timbuktu","Timbuktu","Mali","MLI","admin",35330],
[1840005948,"Chillum","Chillum","United States","USA","",35557],
[1484799033,"Pabellón de Arteaga","Pabellon de Arteaga","Mexico","MEX","minor",28633],
[1840019228,"Bell","Bell","United States","USA","",35521],
[1417698287,"Talas","Talas","Kyrgyzstan","KGZ","admin",35172],
[1764216668,"Roi Et","Roi Et","Thailand","THA","admin",35219],
[1158657404,"Taibao","Taibao","Taiwan","TWN","admin",35000],
[1887871834,"Laḩij","Lahij","Yemen","YEM","admin",30661],
[1250066096,"Fontenay-aux-Roses","Fontenay-aux-Roses","France","FRA","",25342],
[1554359840,"Gisborne","Gisborne","New Zealand","NZL","admin",34527],
[1056751248,"Sint-Joost-ten-Node","Sint-Joost-ten-Node","Belgium","BEL","",27032],
[1620281131,"Bragança","Braganca","Portugal","PRT","admin",35341],
[1250533450,"Montigny-le-Bretonneux","Montigny-le-Bretonneux","France","FRA","",32575],
[1484469922,"Catemaco","Catemaco","Mexico","MEX","minor",27615],
[1764240863,"Phatthalung","Phatthalung","Thailand","THA","admin",35039],
[1356477305,"Sānkrāil","Sankrail","India","IND","",29114],
[1756726571,"Neuchâtel","Neuchatel","Switzerland","CHE","admin",33475],
[1528603261,"Papendrecht","Papendrecht","Netherlands","NLD","minor",32290],
[1380074125,"Frattamaggiore","Frattamaggiore","Italy","ITA","",29738],
[1320642159,"Santa Cruz del Quiché","Santa Cruz del Quiche","Guatemala","GTM","admin",35000],
[1840028408,"Westmont","Westmont","United States","USA","",35266],
[1180012250,"Luebo","Luebo","Congo (Kinshasa)","COD","admin",35183],
[1764797592,"Ban Bang Krang","Ban Bang Krang","Thailand","THA","",23010],
[1504646910,"Mechraa Bel Ksiri","Mechraa Bel Ksiri","Morocco","MAR","",31497],
[1484262709,"San Salvador El Seco","San Salvador El Seco","Mexico","MEX","",30303],
[1140582053,"Bria","Bria","Central African Republic","CAF","admin",35204],
[1380781969,"San Donato Milanese","San Donato Milanese","Italy","ITA","",32664],
[1250966526,"Villiers-sur-Marne","Villiers-sur-Marne","France","FRA","",28592],
[1840020496,"Manhattan Beach","Manhattan Beach","United States","USA","",35183],
[1356080600,"Elesvaram","Elesvaram","India","IND","",32957],
[1724738779,"Sestao","Sestao","Spain","ESP","",27342],
[1484799240,"Magdalena de Kino","Magdalena de Kino","Mexico","MEX","minor",30429],
[1528731782,"Bussum","Bussum","Netherlands","NLD","minor",32410],
[1764931523,"Ban Ang Sila","Ban Ang Sila","Thailand","THA","",33053],
[1004798735,"Maīdān Shahr","Maidan Shahr","Afghanistan","AFG","admin",35008],
[1376429803,"Giv‘at Shemu’él","Giv`at Shemu'el","Israel","ISR","",25298],
[1300810075,"Néa Filadélfeia","Nea Filadelfeia","Greece","GRC","minor",25734],
[1056018953,"Ganshoren","Ganshoren","Belgium","BEL","",24865],
[1250005644,"Vigneux-sur-Seine","Vigneux-sur-Seine","France","FRA","",31463],
[1440180524,"Marijampolė","Marijampole","Lithuania","LTU","admin",34968],
[1600189153,"San Pedro de Ycuamandiyú","San Pedro de Ycuamandiyu","Paraguay","PRY","admin",35021],
[1250539371,"Gentilly","Gentilly","France","FRA","",18577],
[1262950337,"Dikhil","Dikhil","Djibouti","DJI","admin",35000],
[1558006000,"Ocotal","Ocotal","Nicaragua","NIC","admin",34580],
[1156141116,"Beidaying","Beidaying","China","CHN","",31139],
[1826688359,"Brighouse","Brighouse","United Kingdom","GBR","",32360],
[1826441495,"Saint Neots","Saint Neots","United Kingdom","GBR","",31165],
[1380894593,"Santa Maria Capua Vetere","Santa Maria Capua Vetere","Italy","ITA","",32893],
[1116471297,"Kampong Thom","Kampong Thom","Cambodia","KHM","admin",31871],
[1826854355,"Motherwell","Motherwell","United Kingdom","GBR","",32590],
[1840020211,"Englewood","Englewood","United States","USA","",34917],
[1484159329,"Ciudad Sabinas Hidalgo","Ciudad Sabinas Hidalgo","Mexico","MEX","minor",32047],
[1417466970,"Naryn","Naryn","Kyrgyzstan","KGZ","admin",34822],
[1840028974,"Buenaventura Lakes","Buenaventura Lakes","United States","USA","",34784],
[1840019137,"Oildale","Oildale","United States","USA","",34763],
[1332314393,"Jacmel","Jacmel","Haiti","HTI","admin",33563],
[1484800970,"Escárcega","Escarcega","Mexico","MEX","minor",29477],
[1404250734,"Busia","Busia","Kenya","KEN","admin",30777],
[1764060973,"Kalasin","Kalasin","Thailand","THA","admin",34437],
[1484335657,"Huatabampo","Huatabampo","Mexico","MEX","minor",30324],
[1826696164,"Chichester","Chichester","United Kingdom","GBR","",30925],
[1100458181,"Silistra","Silistra","Bulgaria","BGR","admin",34473],
[1250762117,"Trappes","Trappes","France","FRA","",32120],
[1516214290,"Swakopmund","Swakopmund","Namibia","NAM","admin",34300],
[1404321159,"Homa Bay","Homa Bay","Kenya","KEN","admin",32174],
[1250126108,"Thiais","Thiais","France","FRA","",29806],
[1826026639,"Wishaw","Wishaw","United Kingdom","GBR","",30290],
[1218651012,"Azogues","Azogues","Ecuador","ECU","admin",33848],
[1840003705,"Norristown","Norristown","United States","USA","",34341],
[1724676507,"Aldaya","Aldaya","Spain","ESP","",32313],
[1840005834,"Montgomery Village","Montgomery Village","United States","USA","",34332],
[1250108513,"Lens","Lens","France","FRA","minor",31606],
[1901134407,"Fushë Kosovë","Fushe Kosove","Kosovo","XKS","admin",33997],
[1250500651,"Le Chesnay","Le Chesnay","France","FRA","",27683],
[1688966590,"Bor","Bor","Serbia","SRB","admin",34159],
[1840010739,"University City","University City","United States","USA","",34165],
[1840020158,"Midvale","Midvale","United States","USA","",34124],
[1840029039,"Golden Glades","Golden Glades","United States","USA","",34109],
[1764146253,"Uttaradit","Uttaradit","Thailand","THA","admin",33930],
[1752377083,"Nyköping","Nykoping","Sweden","SWE","admin",33916],
[1484750477,"Zumpango del Río","Zumpango del Rio","Mexico","MEX","minor",24719],
[1250191688,"Grigny","Grigny","France","FRA","",28265],
[1608346338,"Shariff Aguak","Shariff Aguak","Philippines","PHL","admin",33982],
[1231550284,"Gīmbī","Gimbi","Ethiopia","ETH","",31809],
[1156254219,"Zhaoyu","Zhaoyu","China","CHN","minor",31685],
[1116446492,"Kampong Speu","Kampong Speu","Cambodia","KHM","admin",33231],
[1430656307,"Kakata","Kakata","Liberia","LBR","admin",33945],
[1380154563,"Bresso","Bresso","Italy","ITA","",26259],
[1428112098,"Ventspils","Ventspils","Latvia","LVA","admin",33372],
[1250160957,"Saint-Cloud","Saint-Cloud","France","FRA","",30038],
[1840000690,"Chester","Chester","United States","USA","",34000],
[1504182456,"Sidi Smai’il","Sidi Smai'il","Morocco","MAR","",28733],
[1036214023,"Dandenong","Dandenong","Australia","AUS","",29906],
[1484112463,"Ciudad Sahagun","Ciudad Sahagun","Mexico","MEX","",28609],
[1528804375,"Hendrik-Ido-Ambacht","Hendrik-Ido-Ambacht","Netherlands","NLD","minor",30966],
[1840020302,"Foster City","Foster City","United States","USA","",33901],
[1380589632,"San Giuseppe Vesuviano","San Giuseppe Vesuviano","Italy","ITA","",31612],
[1840019231,"Beverly Hills","Beverly Hills","United States","USA","",33792],
[1116924669,"Koh Kong","Koh Kong","Cambodia","KHM","admin",33591],
[1764012939,"Chumphon","Chumphon","Thailand","THA","admin",33516],
[1608312278,"Cabarroguis","Cabarroguis","Philippines","PHL","admin",33533],
[1840011406,"Glendale Heights","Glendale Heights","United States","USA","",33617],
[1558656214,"Bilwi","Bilwi","Nicaragua","NIC","admin",33600],
[1404338562,"Kericho","Kericho","Kenya","KEN","admin",30023],
[1404192737,"Mandera","Mandera","Kenya","KEN","admin",30433],
[1800409287,"Masindi","Masindi","Uganda","UGA","admin",31486],
[1840024568,"Fair Oaks","Fair Oaks","United States","USA","",33481],
[1840000988,"Long Beach","Long Beach","United States","USA","",33454],
[1191526652,"Sisak","Sisak","Croatia","HRV","admin",33322],
[1826356095,"Bromsgrove","Bromsgrove","United Kingdom","GBR","",29237],
[1470754290,"Birkirkara","Birkirkara","Malta","MLT","admin",24356],
[1196334499,"Kyrenia","Kyrenia","Cyprus","CYP","admin",33207],
[1250333047,"Goussainville","Goussainville","France","FRA","",30642],
[1340411203,"Juticalpa","Juticalpa","Honduras","HND","admin",33260],
[1100374163,"Lovech","Lovech","Bulgaria","BGR","admin",33195],
[1764994534,"Mukdahan","Mukdahan","Thailand","THA","admin",33102],
[1826912872,"Hertford","Hertford","United Kingdom","GBR","",28689],
[1032827397,"Adrogue","Adrogue","Argentina","ARG","",28265],
[1250981193,"Vandœuvre-lès-Nancy","Vandoeuvre-les-Nancy","France","FRA","",30009],
[1724055183,"Paiporta","Paiporta","Spain","ESP","",26401],
[1188421709,"San Juan","San Juan","Costa Rica","CRI","",25866],
[1250864403,"Périgueux","Perigueux","France","FRA","minor",30060],
[1100143131,"Razgrad","Razgrad","Bulgaria","BGR","admin",33034],
[1012351010,"Timimoun","Timimoun","Algeria","DZA","admin",33060],
[1792344167,"Amasya","Amasya","Turkey","TUR","admin",32900],
[1250798582,"Ris-Orangis","Ris-Orangis","France","FRA","",29589],
[1840058058,"Eastchester","Eastchester","United States","USA","",32983],
[1356820799,"Tarakeswar","Tarakeswar","India","IND","",30947],
[1600377954,"Pilar","Pilar","Paraguay","PRY","admin",32810],
[1840029096,"West Little River","West Little River","United States","USA","",32897],
[1840003548,"Fair Lawn","Fair Lawn","United States","USA","",32896],
[1380362156,"Aci Catena","Aci Catena","Italy","ITA","",29418],
[1840005081,"Huntington Station","Huntington Station","United States","USA","",32866],
[1250313503,"Sotteville-lès-Rouen","Sotteville-les-Rouen","France","FRA","",28958],
[1430540258,"Harper","Harper","Liberia","LBR","admin",32661],
[1320070166,"Santiago Sacatepéquez","Santiago Sacatepequez","Guatemala","GTM","minor",30747],
[1250072003,"Liévin","Lievin","France","FRA","",30423],
[1724436657,"Barañáin","Baranain","Spain","ESP","",19853],
[1504190665,"Arfoud","Arfoud","Morocco","MAR","",29279],
[1724494232,"Durango","Durango","Spain","ESP","",29935],
[1528654636,"Krimpen aan den IJssel","Krimpen aan den IJssel","Netherlands","NLD","minor",29376],
[1250300357,"Bègles","Begles","France","FRA","",29669],
[1404548296,"Kitui","Kitui","Kenya","KEN","admin",29062],
[1348290189,"Salgótarján","Salgotarjan","Hungary","HUN","admin",32304],
[1250831015,"Oullins","Oullins","France","FRA","",26583],
[1826679950,"Harpenden","Harpenden","United Kingdom","GBR","",30240],
[1643307601,"Dagestanskiye Ogni","Dagestanskiye Ogni","Russia","RUS","",29401],
[1840106198,"North Providence","North Providence","United States","USA","",32564],
[1643786528,"Kokhma","Kokhma","Russia","RUS","",30161],
[1012201146,"I-n-Salah","I-n-Salah","Algeria","DZA","admin",32518],
[1440746512,"Mažeikiai","Mazeikiai","Lithuania","LTU","admin",32477],
[1250128916,"Rillieux-la-Pape","Rillieux-la-Pape","France","FRA","",30410],
[1484007805,"Soledad de Doblado","Soledad de Doblado","Mexico","MEX","minor",27770],
[1170548641,"Leticia","Leticia","Colombia","COL","admin",32450],
[1124563603,"Côte-Saint-Luc","Cote-Saint-Luc","Canada","CAN","",32448],
[1504747424,"Demnat","Demnat","Morocco","MAR","",29504],
[1840020517,"Lawndale","Lawndale","United States","USA","",32389],
[1756916105,"Yverdon-les-Bains","Yverdon-les-Bains","Switzerland","CHE","minor",30157],
[1250391575,"Menton","Menton","France","FRA","",30231],
[1250456565,"Aix-les-Bains","Aix-les-Bains","France","FRA","",29993],
[1504454457,"Bou Arfa","Bou Arfa","Morocco","MAR","",28846],
[1140539356,"Bangassou","Bangassou","Central African Republic","CAF","admin",31453],
[1250114629,"Yerres","Yerres","France","FRA","",29338],
[1840133089,"Mount Lebanon","Mount Lebanon","United States","USA","",32303],
[1250790534,"Savigny-le-Temple","Savigny-le-Temple","France","FRA","",29792],
[1840004986,"Spring Valley","Spring Valley","United States","USA","",32261],
[1604650674,"Chachapoyas","Chachapoyas","Peru","PER","admin",32026],
[1250655335,"Montfermeil","Montfermeil","France","FRA","",27201],
[1222944408,"Sonzacate","Sonzacate","El Salvador","SLV","",25005],
[1360003468,"Kulat","Kulat","Indonesia","IDN","",30012],
[1250984996,"Les Pavillons-sous-Bois","Les Pavillons-sous-Bois","France","FRA","",23960],
[1840005971,"College Park","College Park","United States","USA","",32163],
[1728842249,"Rumbek","Rumbek","South Sudan","SSD","admin",32083],
[1484463833,"El Salto","El Salto","Mexico","MEX","minor",24241],
[1724606046,"San Andrés de la Barca","San Andres de la Barca","Spain","ESP","",27175],
[1180688906,"Boende","Boende","Congo (Kinshasa)","COD","admin",32091],
[1792988658,"Kartal","Kartal","Turkey","TUR","minor",20139],
[1840002420,"Eastpointe","Eastpointe","United States","USA","",32081],
[1764948515,"Ban Bang Khu Wat","Ban Bang Khu Wat","Thailand","THA","",28349],
[1840005256,"Franklin Square","Franklin Square","United States","USA","",32055],
[1250650651,"Sannois","Sannois","France","FRA","",26484],
[1764202077,"Chon Buri","Chon Buri","Thailand","THA","admin",29961],
[1356924997,"Nibria","Nibria","India","IND","",27818],
[1840005279,"Uniondale","Uniondale","United States","USA","",32007],
[1484903562,"Actopan","Actopan","Mexico","MEX","",29223],
[1840023306,"Juneau","Juneau","United States","USA","admin",31974],
[1710823263,"Ulundi","Ulundi","South Africa","ZAF","",29132],
[1076507348,"Pompeu","Pompeu","Brazil","BRA","",29105],
[1756703208,"Zug","Zug","Switzerland","CHE","admin",30542],
[1392868298,"Kaita","Kaita","Japan","JPN","",29793],
[1250693512,"Bourg-la-Reine","Bourg-la-Reine","France","FRA","",20769],
[1250001397,"Villiers-le-Bel","Villiers-le-Bel","France","FRA","",28041],
[1578540727,"Molde","Molde","Norway","NOR","admin",31870],
[1250198806,"Lambersart","Lambersart","France","FRA","",27415],
[1724800602,"Benetúser","Benetuser","Spain","ESP","",15430],
[1840003554,"Garfield","Garfield","United States","USA","",31802],
[1800214906,"Pallisa","Pallisa","Uganda","UGA","admin",30745],
[1332612037,"Jérémie","Jeremie","Haiti","HTI","admin",30917],
[1616807901,"Giżycko","Gizycko","Poland","POL","minor",29642],
[1643065597,"Shumerlya","Shumerlya","Russia","RUS","",29553],
[1834081851,"Babati","Babati","Tanzania","TZA","admin",30975],
[1504438304,"Mehdya","Mehdya","Morocco","MAR","",28636],
[1826755066,"Cambuslang","Cambuslang","United Kingdom","GBR","",29100],
[1250943881,"Limeil-Brévannes","Limeil-Brevannes","France","FRA","",27684],
[1484059318,"Contla","Contla","Mexico","MEX","minor",27610],
[1250611079,"Guyancourt","Guyancourt","France","FRA","",29332],
[1484959684,"Champotón","Champoton","Mexico","MEX","minor",26636],
[1356864766,"Kuli","Kuli","India","IND","",28092],
[1158987347,"Banqiao","Banqiao","Taiwan","TWN","admin",0],
[1076972725,"Ipu","Ipu","Brazil","BRA","",26678],
[1250937070,"Villeneuve-la-Garenne","Villeneuve-la-Garenne","France","FRA","",24023],
[1840005685,"Parkville","Parkville","United States","USA","",31451],
[1356073095,"Beldānga","Beldanga","India","IND","",29205],
[1356064506,"Saranga","Saranga","India","IND","",25200],
[1031500858,"Zaqatala","Zaqatala","Azerbaijan","AZE","admin",31300],
[1858276269,"Pando","Pando","Uruguay","URY","",25949],
[1372203613,"Blackrock","Blackrock","Ireland","IRL","",28557],
[1840017275,"Miami Lakes","Miami Lakes","United States","USA","",31367],
[1250141244,"Saint-Laurent-du-Var","Saint-Laurent-du-Var","France","FRA","",28511],
[1031686599,"İmişli","Imisli","Azerbaijan","AZE","admin",31310],
[1484830415,"San Fernando","San Fernando","Mexico","MEX","minor",29171],
[1203462593,"Břevnov","Brevnov","Czechia","CZE","",26275],
[1348026284,"Szekszárd","Szekszard","Hungary","HUN","admin",30963],
[1826387077,"Rhyl","Rhyl","United Kingdom","GBR","",25149],
[1484472740,"Castaños","Castanos","Mexico","MEX","minor",27314],
[1834217491,"Wete","Wete","Tanzania","TZA","admin",26450],
[1528749595,"Diemen","Diemen","Netherlands","NLD","minor",29196],
[1300609636,"Péfki","Pefki","Greece","GRC","minor",21415],
[1724724364,"San Vicente dels Horts","San Vicente dels Horts","Spain","ESP","",28115],
[1484359180,"Tuxpan","Tuxpan","Mexico","MEX","minor",27371],
[1800598019,"Nebbi","Nebbi","Uganda","UGA","admin",30354],
[1840142587,"Ridley","Ridley","United States","USA","",31120],
[1250317790,"Arcueil","Arcueil","France","FRA","",21721],
[1320810416,"Cuilapa","Cuilapa","Guatemala","GTM","admin",30951],
[1504497923,"Aïn Taoujdat","Ain Taoujdat","Morocco","MAR","",28288],
[1562050464,"Diffa","Diffa","Niger","NER","admin",30988],
[1250753691,"Lomme","Lomme","France","FRA","",28006],
[1250006284,"Dieppe","Dieppe","France","FRA","minor",28561],
[1484287458,"Ixhuatlancillo","Ixhuatlancillo","Mexico","MEX","minor",24896],
[1840021529,"San Pablo","San Pablo","United States","USA","",30990],
[1643598979,"Desnogorsk","Desnogorsk","Russia","RUS","",27771],
[1643942215,"Udomlya","Udomlya","Russia","RUS","",28119],
[1788569609,"Mégrine","Megrine","Tunisia","TUN","",26720],
[1724754042,"Martorell","Martorell","Spain","ESP","",28667],
[1498687533,"Ungheni","Ungheni","Moldova","MDA","admin",30804],
[1840018925,"Burlingame","Burlingame","United States","USA","",30889],
[1300131630,"Trípoli","Tripoli","Greece","GRC","admin",30866],
[1191424625,"Čakovec","Cakovec","Croatia","HRV","admin",30455],
[1826461714,"Longbridge","Longbridge","United Kingdom","GBR","",25410],
[1250109043,"Soissons","Soissons","France","FRA","minor",28522],
[1250854033,"Eaubonne","Eaubonne","France","FRA","",25139],
[1040174258,"Bregenz","Bregenz","Austria","AUT","admin",29806],
[1826065116,"Bearsden","Bearsden","United Kingdom","GBR","",28120],
[1524369856,"Siraha","Siraha","Nepal","NPL","",28442],
[1032478683,"Avellaneda","Avellaneda","Argentina","ARG","minor",24313],
[1818279617,"Qiman al ‘Arūs","Qiman al `Arus","Egypt","EGY","",28246],
[1724221843,"Catarroja","Catarroja","Spain","ESP","",28509],
[1484510036,"Jamay","Jamay","Mexico","MEX","minor",24753],
[1484274950,"Tuxpan","Tuxpan","Mexico","MEX","minor",26115],
[1764587855,"Krabi","Krabi","Thailand","THA","admin",30499],
[1756165206,"Carouge","Carouge","Switzerland","CHE","",22336],
[1840005246,"Oceanside","Oceanside","United States","USA","",30604],
[1484644846,"Puerto Escondido","Puerto Escondido","Mexico","MEX","",25902],
[1404689643,"Moyale","Moyale","Kenya","KEN","",24837],
[1392269744,"Ninomiya","Ninomiya","Japan","JPN","",27536],
[1231491184,"Āsosa","Asosa","Ethiopia","ETH","admin",30512],
[1616659048,"Kętrzyn","Ketrzyn","Poland","POL","minor",27827],
[1840131615,"City of Orange","City of Orange","United States","USA","",30484],
[1031301869,"Salyan","Salyan","Azerbaijan","AZE","admin",30396],
[1826086234,"Shenley Brook End","Shenley Brook End","United Kingdom","GBR","",25828],
[1724916166,"Tomares","Tomares","Spain","ESP","",25370],
[1484782521,"Tecax","Tecax","Mexico","MEX","",25751],
[1380991443,"Boscoreale","Boscoreale","Italy","ITA","",27927],
[1608478686,"Camaligan","Camaligan","Philippines","PHL","",25036],
[1356557030,"Jaynagar-Majilpur","Jaynagar-Majilpur","India","IND","",25922],
[1392003278,"Mizumaki","Mizumaki","Japan","JPN","",27822],
[1484000527,"Frontera","Frontera","Mexico","MEX","minor",22795],
[1840024508,"Sterling","Sterling","United States","USA","",30271],
[1598400611,"Mount Hagen","Mount Hagen","Papua New Guinea","PNG","admin",29765],
[1484937929,"Los Reyes de Juárez","Los Reyes de Juarez","Mexico","MEX","minor",27454],
[1840003673,"Long Branch","Long Branch","United States","USA","",30241],
[1484829832,"Nogales","Nogales","Mexico","MEX","minor",21113],
[1840021842,"Santa Paula","Santa Paula","United States","USA","",30233],
[1392411015,"Chatan","Chatan","Japan","JPN","",28167],
[1840021550,"San Carlos","San Carlos","United States","USA","",30185],
[1380031147,"Garbagnate Milanese","Garbagnate Milanese","Italy","ITA","",27155],
[1174036583,"Mutsamudu","Mutsamudu","Comoros","COM","admin",30000],
[1498020356,"Cahul","Cahul","Moldova","MDA","admin",30018],
[1528827638,"Heemstede","Heemstede","Netherlands","NLD","minor",27286],
[1504092591,"Tahla","Tahla","Morocco","MAR","",27729],
[1356068400,"Pānchla","Panchla","India","IND","",26432],
[1032549688,"Vicente López","Vicente Lopez","Argentina","ARG","",22419],
[1826245369,"Billericay","Billericay","United Kingdom","GBR","",27998],
[1516719545,"Otjiwarongo","Otjiwarongo","Namibia","NAM","admin",28249],
[1756017706,"Dübendorf","Dubendorf","Switzerland","CHE","",28002],
[1051304472,"Charentsavan","Charentsavan","Armenia","ARM","",25039],
[1340756106,"Trujillo","Trujillo","Honduras","HND","admin",30000],
[1764423311,"Sai Mai","Sai Mai","Thailand","THA","minor",23316],
[1688081964,"Subotica","Subotica","Serbia","SRB","admin",29919],
[1858879204,"Treinta y Tres","Treinta y Tres","Uruguay","URY","admin",25477],
[1222307415,"La Unión","La Union","El Salvador","SLV","admin",29733],
[1116286673,"Stung Treng","Stung Treng","Cambodia","KHM","admin",29665],
[1724964261,"Armilla","Armilla","Spain","ESP","",24388],
[1372403494,"Tralee","Tralee","Ireland","IRL","admin",26384],
[1840001091,"Rahway","Rahway","United States","USA","",29895],
[1826685347,"Aldridge","Aldridge","United Kingdom","GBR","",26988],
[1250260659,"Cenon","Cenon","France","FRA","",25292],
[1756546516,"Dietikon","Dietikon","Switzerland","CHE","",26936],
[1484649521,"Miahuatlán","Miahuatlan","Mexico","MEX","minor",25228],
[1076793835,"Arapoti","Arapoti","Brazil","BRA","",25855],
[1840005017,"Bay Shore","Bay Shore","United States","USA","",29799],
[1724068126,"Camas","Camas","Spain","ESP","",27490],
[1840014241,"Westchester","Westchester","United States","USA","",29778],
[1858338569,"Colonia del Sacramento","Colonia del Sacramento","Uruguay","URY","admin",26231],
[1826720044,"Upminster","Upminster","United Kingdom","GBR","",25361],
[1250158180,"Saint-Sébastien-sur-Loire","Saint-Sebastien-sur-Loire","France","FRA","",27383],
[1404163131,"Lamu","Lamu","Kenya","KEN","admin",24525],
[1250109731,"La Madeleine","La Madeleine","France","FRA","",21968],
[1148367091,"Doba","Doba","Chad","TCD","admin",29597],
[1031916654,"Ağdaş","Agdas","Azerbaijan","AZE","admin",29600],
[1250133123,"Villeparisis","Villeparisis","France","FRA","",26471],
[1840028115,"Suisun City","Suisun City","United States","USA","",29663],
[1380138569,"Chiavari","Chiavari","Italy","ITA","",27410],
[1380120364,"Cardito","Cardito","Italy","ITA","",22601],
[1840006117,"West Falls Church","West Falls Church","United States","USA","",29623],
[1144687416,"Nuwara Eliya","Nuwara Eliya","Sri Lanka","LKA","",27500],
[1356391664,"Māmidālapādu","Mamidalapadu","India","IND","",26694],
[1250757045,"Sucy-en-Brie","Sucy-en-Brie","France","FRA","",26974],
[1516068788,"Katima Mulilo","Katima Mulilo","Namibia","NAM","admin",28699],
[1840014228,"Golden Gate","Golden Gate","United States","USA","",29552],
[1250437632,"Saint-Gratien","Saint-Gratien","France","FRA","",20893],
[1056283690,"Mortsel","Mortsel","Belgium","BEL","",26157],
[1704000217,"Bắc Kạn","Bac Kan","Vietnam","VNM","admin",29227],
[1484022148,"Paracuaro","Paracuaro","Mexico","MEX","",26789],
[1688918464,"Bačka Palanka","Backa Palanka","Serbia","SRB","admin",29449],
[1222515741,"Chalatenango","Chalatenango","El Salvador","SLV","admin",29271],
[1840002424,"Oak Park","Oak Park","United States","USA","",29431],
[1328531190,"Linden","Linden","Guyana","GUY","admin",29298],
[1620528384,"Estoril","Estoril","Portugal","PRT","",26399],
[1762114045,"Khorugh","Khorugh","Tajikistan","TJK","admin",28098],
[1858936449,"Rocha","Rocha","Uruguay","URY","admin",25422],
[1340312026,"Santa Bárbara","Santa Barbara","Honduras","HND","admin",29283],
[1764367755,"Kamphaeng Phet","Kamphaeng Phet","Thailand","THA","admin",29178],
[1826373748,"Coulsdon","Coulsdon","United Kingdom","GBR","",25695],
[1208278269,"Hillerød","Hillerod","Denmark","DNK","admin",28313],
[1484016423,"Rafael Delgado","Rafael Delgado","Mexico","MEX","minor",23112],
[1826713585,"Newton Mearns","Newton Mearns","United Kingdom","GBR","",26600],
[1840020301,"East Palo Alto","East Palo Alto","United States","USA","",29314],
[1528990353,"Leiderdorp","Leiderdorp","Netherlands","NLD","minor",27109],
[1608692949,"Siquijor","Siquijor","Philippines","PHL","admin",28915],
[1591602960,"Penonomé","Penonome","Panama","PAN","admin",28766],
[1484800428,"Hunucmá","Hunucma","Mexico","MEX","minor",24910],
[1380575538,"Qualiano","Qualiano","Italy","ITA","",25755],
[1250240744,"Sèvres","Sevres","France","FRA","",23251],
[1250815725,"Brunoy","Brunoy","France","FRA","",25354],
[1818255123,"Qahā","Qaha","Egypt","EGY","",26694],
[1840004941,"Port Chester","Port Chester","United States","USA","",29163],
[1250016351,"Vallauris","Vallauris","France","FRA","",27072],
[1826039806,"Rainham","Rainham","United Kingdom","GBR","",25000],
[1764305010,"Samut Songkhram","Samut Songkhram","Thailand","THA","admin",28493],
[1250852016,"Taverny","Taverny","France","FRA","",26576],
[1250084403,"Vichy","Vichy","France","FRA","minor",24854],
[1250001308,"Champs-Sur-Marne","Champs-Sur-Marne","France","FRA","",25610],
[1792065200,"Çorum","Corum","Turkey","TUR","admin",28879],
[1392003216,"Ginan","Ginan","Japan","JPN","",25752],
[1826422730,"Bishop Auckland","Bishop Auckland","United Kingdom","GBR","",25455],
[1854485968,"Manga","Manga","Burkina Faso","BFA","admin",28612],
[1250024212,"Bussy-Saint-Georges","Bussy-Saint-Georges","France","FRA","",26806],
[1484498863,"Altepexi","Altepexi","Mexico","MEX","minor",21100],
[1764141031,"Buri Ram","Buri Ram","Thailand","THA","admin",28613],
[1834034762,"Nzega","Nzega","Tanzania","TZA","",26584],
[1496290857,"Ölgiy","Olgiy","Mongolia","MNG","admin",28496],
[1250737647,"Armentières","Armentieres","France","FRA","",24778],
[1826705684,"Clydebank","Clydebank","United Kingdom","GBR","",26320],
[1484176714,"Tixtla de Guerrero","Tixtla de Guerrero","Mexico","MEX","minor",21720],
[1356033556,"Jālhalli","Jalhalli","India","IND","",13063],
[1504694053,"Missour","Missour","Morocco","MAR","",25584],
[1232751882,"Mendefera","Mendefera","Eritrea","ERI","admin",28492],
[1100429166,"Smolyan","Smolyan","Bulgaria","BGR","admin",28541],
[1250293935,"Élancourt","Elancourt","France","FRA","",25575],
[1372038958,"Dunleary","Dunleary","Ireland","IRL","admin",23857],
[1376689197,"Gedera","Gedera","Israel","ISR","",26217],
[1840131593,"Nutley","Nutley","United States","USA","",28478],
[1528455119,"Oegstgeest","Oegstgeest","Netherlands","NLD","minor",24426],
[1840000849,"Shamokin","Shamokin","United States","USA","",28457],
[1250100380,"Le Bouscat","Le Bouscat","France","FRA","",23924],
[1466411645,"Koulikoro","Koulikoro","Mali","MLI","admin",23919],
[1032831289,"Tapiales","Tapiales","Argentina","ARG","",23586],
[1826292544,"Market Harborough","Market Harborough","United Kingdom","GBR","",22911],
[1484715262,"Ocatlán","Ocatlan","Mexico","MEX","",22082],
[1807422302,"Kočani","Kocani","Macedonia","MKD","admin",28330],
[1188911724,"Cartago","Cartago","Costa Rica","CRI","admin",22775],
[1428895373,"Rēzekne","Rezekne","Latvia","LVA","admin",26839],
[1376315793,"Eṭ Ṭīra","Et Tira","Israel","ISR","",26200],
[1840003546,"Englewood","Englewood","United States","USA","",28402],
[1504071186,"Zawyat ech Cheïkh","Zawyat ech Cheikh","Morocco","MAR","",25388],
[1170846096,"Mitú","Mitu","Colombia","COL","admin",28382],
[1826178927,"Droylsden","Droylsden","United Kingdom","GBR","",23689],
[1250409231,"Mons-en-Baroeul","Mons-en-Baroeul","France","FRA","",21017],
[1840007022,"Burbank","Burbank","United States","USA","",28289],
[1756579162,"Vevey","Vevey","Switzerland","CHE","",19891],
[1788010481,"Zaouiet Sousse","Zaouiet Sousse","Tunisia","TUN","",25000],
[1840033770,"Winchester","Winchester","United States","USA","",28231],
[1598887925,"Popondetta","Popondetta","Papua New Guinea","PNG","admin",28198],
[1643294187,"Losino-Petrovskiy","Losino-Petrovskiy","Russia","RUS","",25424],
[1250000395,"Alençon","Alencon","France","FRA","minor",25775],
[1764733770,"Kathu","Kathu","Thailand","THA","minor",26078],
[1178364266,"Ouésso","Ouesso","Congo (Brazzaville)","COG","admin",28179],
[1826596908,"Plymstock","Plymstock","United Kingdom","GBR","",24103],
[1826478043,"Stratton Saint Margaret","Stratton Saint Margaret","United Kingdom","GBR","",22698],
[1032701626,"Don Bosco","Don Bosco","Argentina","ARG","",20876],
[1300101706,"Mytilíni","Mytilini","Greece","GRC","admin",27871],
[1250398185,"Le Grand-Quevilly","Le Grand-Quevilly","France","FRA","",25771],
[1250595652,"Deuil-la-Barre","Deuil-la-Barre","France","FRA","",22165],
[1578111692,"Hamar","Hamar","Norway","NOR","admin",27947],
[1840000432,"Melrose","Melrose","United States","USA","",28016],
[1250524493,"Joinville-le-Pont","Joinville-le-Pont","France","FRA","",19516],
[1756264043,"Renens","Renens","Switzerland","CHE","minor",20927],
[1516928100,"Rehoboth","Rehoboth","Namibia","NAM","",25219],
[1840005550,"Drexel Hill","Drexel Hill","United States","USA","",27939],
[1072740062,"Lobatse","Lobatse","Botswana","BWA","admin",26900],
[1484573730,"Cherán","Cheran","Mexico","MEX","minor",19081],
[1484007324,"Sombrerete","Sombrerete","Mexico","MEX","minor",21702],
[1724241743,"Alboraya","Alboraya","Spain","ESP","",24904],
[1380948758,"Muggiò","Muggio","Italy","ITA","",23581],
[1764792338,"Ban Bang Phun","Ban Bang Phun","Thailand","THA","",24625],
[1250837552,"Béthune","Bethune","France","FRA","minor",25193],
[1148833900,"Bongor","Bongor","Chad","TCD","admin",27770],
[1056730951,"Saint-Nicolas","Saint-Nicolas","Belgium","BEL","",24251],
[1148891648,"Mongo","Mongo","Chad","TCD","admin",27763],
[1705478862,"Koper","Koper","Slovenia","SVN","admin",25753],
[1792630786,"Batman","Batman","Turkey","TUR","admin",26730],
[1250324713,"Biarritz","Biarritz","France","FRA","",25532],
[1356863929,"Poranki","Poranki","India","IND","",25545],
[1840017887,"Isla Vista","Isla Vista","United States","USA","",27707],
[1484011650,"Chapala","Chapala","Mexico","MEX","minor",21596],
[1528045631,"Voorschoten","Voorschoten","Netherlands","NLD","minor",25479],
[1705929589,"Velenje","Velenje","Slovenia","SVN","admin",25594],
[1792024731,"Rize","Rize","Turkey","TUR","admin",26989],
[1724867783,"San Juan de Aznalfarache","San Juan de Aznalfarache","Spain","ESP","",22088],
[1250599649,"Cormeilles-en-Parisis","Cormeilles-en-Parisis","France","FRA","",24681],
[1901598505,"Shtime","Shtime","Kosovo","XKS","admin",27324],
[1840023249,"Mililani Town","Mililani Town","United States","USA","",27562],
[1484274706,"Ciudad Altamirano","Ciudad Altamirano","Mexico","MEX","minor",24533],
[1682664517,"Arar","Arar","Saudi Arabia","SAU","admin",27449],
[1840019353,"Imperial Beach","Imperial Beach","United States","USA","",27440],
[1250660007,"Orly","Orly","France","FRA","",23853],
[1250526109,"Le Petit-Quevilly","Le Petit-Quevilly","France","FRA","",22291],
[1887000479,"Al Ghayz̧ah","Al Ghayzah","Yemen","YEM","admin",27404],
[1484720981,"Cerro Azul","Cerro Azul","Mexico","MEX","minor",23573],
[1380929157,"Seriate","Seriate","Italy","ITA","",25358],
[1076307665,"Itambé","Itambe","Brazil","BRA","",23327],
[1616118197,"Piastów","Piastow","Poland","POL","",23332],
[1470229986,"Sliema","Sliema","Malta","MLT","admin",16854],
[1840000893,"Bergenfield","Bergenfield","United States","USA","",27327],
[1840028333,"Ladera Ranch","Ladera Ranch","United States","USA","",27277],
[1484882196,"San Juan Zitlaltepec","San Juan Zitlaltepec","Mexico","MEX","",19600],
[1380397251,"Pompei","Pompei","Italy","ITA","",25207],
[1504027412,"Oulad Tayeb","Oulad Tayeb","Morocco","MAR","",24594],
[1840000970,"Easton","Easton","United States","USA","",27189],
[1484100040,"San Buenaventura","San Buenaventura","Mexico","MEX","minor",23413],
[1840000997,"Indiana","Indiana","United States","USA","",27142],
[1222098918,"Sensuntepeque","Sensuntepeque","El Salvador","SLV","admin",26989],
[1392003206,"Ōji","Oji","Japan","JPN","",23731],
[1250804380,"Maisons-Laffitte","Maisons-Laffitte","France","FRA","",23611],
[1788057426,"Siliana","Siliana","Tunisia","TUN","admin",26960],
[1250086555,"Neuilly-Plaisance","Neuilly-Plaisance","France","FRA","",20915],
[1624933572,"Catió","Catio","Guinea-Bissau","GNB","admin",26999],
[1818867916,"Hirrīyat Raznah","Hirriyat Raznah","Egypt","EGY","",24359],
[1826263581,"Arbroath","Arbroath","United Kingdom","GBR","",23940],
[1840005689,"Reisterstown","Reisterstown","United States","USA","",27007],
[1276346018,"Weingarten","Weingarten","Germany","DEU","",24943],
[1840020497,"Maywood","Maywood","United States","USA","",26973],
[1250292359,"Montigny-lès-Cormeilles","Montigny-les-Cormeilles","France","FRA","",21638],
[1840018924,"Belmont","Belmont","United States","USA","",26941],
[1826422379,"Oadby","Oadby","United Kingdom","GBR","",23849],
[1484904757,"Carlos A. Carrillo","Carlos A. Carrillo","Mexico","MEX","minor",24565],
[1724403338,"San Juan de Alicante","San Juan de Alicante","Spain","ESP","",24363],
[1484059063,"Texistepec","Texistepec","Mexico","MEX","minor",20887],
[1616047191,"Kościan","Koscian","Poland","POL","minor",24086],
[1140236347,"Nola","Nola","Central African Republic","CAF","admin",26809],
[1724029236,"Maracena","Maracena","Spain","ESP","",22358],
[1840004872,"Kiryas Joel","Kiryas Joel","United States","USA","",26813],
[1840020621,"Lemon Grove","Lemon Grove","United States","USA","",26811],
[1840005122,"Lindenhurst","Lindenhurst","United States","USA","",26801],
[1450306255,"Farafangana","Farafangana","Madagascar","MDG","minor",24764],
[1826594706,"Litherland","Litherland","United Kingdom","GBR","",22242],
[1356283197,"Sundararaopeta","Sundararaopeta","India","IND","",24112],
[1496815184,"Bayanhongor","Bayanhongor","Mongolia","MNG","admin",26252],
[1484665627,"Cazones de Herrera","Cazones de Herrera","Mexico","MEX","minor",23675],
[1554001426,"Blenheim","Blenheim","New Zealand","NZL","admin",26400],
[1840074745,"West Whittier-Los Nietos","West Whittier-Los Nietos","United States","USA","",26654],
[1840014245,"Leisure City","Leisure City","United States","USA","",26652],
[1380704433,"Seveso","Seveso","Italy","ITA","",23456],
[1430858471,"Voinjama","Voinjama","Liberia","LBR","admin",26594],
[1840029013,"University Park","University Park","United States","USA","",26620],
[1826299810,"Sheldon","Sheldon","United Kingdom","GBR","",21817],
[1764103547,"Nakhon Phanom","Nakhon Phanom","Thailand","THA","admin",26437],
[1756962454,"Meyrin","Meyrin","Switzerland","CHE","",24144],
[1484201826,"Heroica Ciudad de Tlaxiaco","Heroica Ciudad de Tlaxiaco","Mexico","MEX","minor",21391],
[1250122168,"Chaville","Chaville","France","FRA","",20702],
[1440298742,"Utena","Utena","Lithuania","LTU","admin",26491],
[1608472178,"General Emilio Aguinaldo","General Emilio Aguinaldo","Philippines","PHL","",23973],
[1484480343,"Oxkutzkab","Oxkutzkab","Mexico","MEX","",23096],
[1250807687,"Rodez","Rodez","France","FRA","minor",24319],
[1440040612,"Jonava","Jonava","Lithuania","LTU","admin",26427],
[1764759549,"Suphan Buri","Suphan Buri","Thailand","THA","admin",26164],
[1598467297,"Mendi","Mendi","Papua New Guinea","PNG","admin",26252],
[1729300155,"Dongola","Dongola","Sudan","SDN","admin",26404],
[1826547421,"Bishopbriggs","Bishopbriggs","United Kingdom","GBR","",23540],
[1826553059,"Littleover","Littleover","United Kingdom","GBR","",23958],
[1496088351,"Ulaangom","Ulaangom","Mongolia","MNG","admin",26319],
[1818236242,"Mīt Namā","Mit Nama","Egypt","EGY","",21321],
[1250760335,"Fontaine","Fontaine","France","FRA","",22906],
[1380159582,"Meda","Meda","Italy","ITA","",23463],
[1250006251,"Lormont","Lormont","France","FRA","",23128],
[1840021635,"Soledad","Soledad","United States","USA","",26207],
[1724259439,"San Juan de Vilasar","San Juan de Vilasar","Spain","ESP","",20936],
[1558146594,"Rivas","Rivas","Nicaragua","NIC","admin",26046],
[1840003537,"Cliffside Park","Cliffside Park","United States","USA","",26133],
[1250067454,"Eysines","Eysines","France","FRA","",24109],
[1840053474,"Belmont","Belmont","United States","USA","",26113],
[1764260674,"Bang Sao Thong","Bang Sao Thong","Thailand","THA","minor",23630],
[1250780004,"Torcy","Torcy","France","FRA","minor",22361],
[1484505595,"Motul","Motul","Mexico","MEX","",23240],
[1484657833,"Atoyac de Álvarez","Atoyac de Alvarez","Mexico","MEX","minor",20515],
[1688643521,"Bajina Bašta","Bajina Basta","Serbia","SRB","admin",26022],
[1724430426,"Castilleja de la Cuesta","Castilleja de la Cuesta","Spain","ESP","",17366],
[1372255646,"Ennis","Ennis","Ireland","IRL","admin",24253],
[1124190411,"Sainte-Thérèse","Sainte-Therese","Canada","CAN","",26025],
[1496382421,"Hovd","Hovd","Mongolia","MNG","admin",26023],
[1764425264,"Krathum Baen","Krathum Baen","Thailand","THA","minor",21904],
[1031242117,"Cəlilabad","Calilabad","Azerbaijan","AZE","admin",25846],
[1764038011,"Amnat Charoen","Amnat Charoen","Thailand","THA","admin",25858],
[1392764326,"Sanga","Sanga","Japan","JPN","",23264],
[1250766213,"Montgeron","Montgeron","France","FRA","",23775],
[1012205687,"El Tarf","El Tarf","Algeria","DZA","admin",25594],
[1818036288,"Kafr Shukr","Kafr Shukr","Egypt","EGY","",23390],
[1826796900,"Huntingdon","Huntingdon","United Kingdom","GBR","",23732],
[1250218619,"Croix","Croix","France","FRA","",21087],
[1504925399,"Sidi Lmokhtar","Sidi Lmokhtar","Morocco","MAR","",22714],
[1643685127,"Nar’yan-Mar","Nar'yan-Mar","Russia","RUS","admin",24775],
[1300093403,"Kérkyra","Kerkyra","Greece","GRC","admin",24838],
[1764455558,"Kanchanaburi","Kanchanaburi","Thailand","THA","admin",25651],
[1484248235,"Santiago Ixcuintla","Santiago Ixcuintla","Mexico","MEX","minor",18365],
[1116432743,"Svay Rieng","Svay Rieng","Cambodia","KHM","admin",23956],
[1756617916,"Onex","Onex","Switzerland","CHE","",18977],
[1840018248,"Cloverleaf","Cloverleaf","United States","USA","",25718],
[1430130578,"Zwedru","Zwedru","Liberia","LBR","admin",25678],
[1012866308,"Tipasa","Tipasa","Algeria","DZA","admin",25225],
[1840014777,"Decatur","Decatur","United States","USA","",25696],
[1250939076,"Montmorency","Montmorency","France","FRA","",21647],
[1276842192,"Ottobrunn","Ottobrunn","Germany","DEU","",21542],
[1858727525,"Fray Bentos","Fray Bentos","Uruguay","URY","admin",24406],
[1250834480,"Loos","Loos","France","FRA","",22426],
[1840029577,"Ewa Gentry","Ewa Gentry","United States","USA","",25641],
[1840005976,"Laurel","Laurel","United States","USA","",25631],
[1840018912,"San Lorenzo","San Lorenzo","United States","USA","",25569],
[1792190820,"Siirt","Siirt","Turkey","TUR","admin",25480],
[1380384622,"San Giovanni la Punta","San Giovanni la Punta","Italy","ITA","",23399],
[1752027172,"Visby","Visby","Sweden","SWE","admin",24942],
[1840020275,"El Cerrito","El Cerrito","United States","USA","",25508],
[1218537461,"Puyo","Puyo","Ecuador","ECU","admin",24881],
[1484659925,"Chocamán","Chocaman","Mexico","MEX","minor",21102],
[1188210837,"Heredia","Heredia","Costa Rica","CRI","admin",18988],
[1840029028,"Coral Terrace","Coral Terrace","United States","USA","",25387],
[1250537092,"Sainte-Foy-lès-Lyon","Sainte-Foy-les-Lyon","France","FRA","",22141],
[1056130684,"Ekeren","Ekeren","Belgium","BEL","",22874],
[1826548197,"Minster","Minster","United Kingdom","GBR","",21319],
[1484345092,"Chiconcuac","Chiconcuac","Mexico","MEX","minor",19656],
[1484076523,"Tlacolula de Matamoros","Tlacolula de Matamoros","Mexico","MEX","minor",22545],
[1840021871,"South Pasadena","South Pasadena","United States","USA","",25329],
[1266875472,"Lambaréné","Lambarene","Gabon","GAB","admin",25310],
[1250633800,"Morsang-sur-Orge","Morsang-sur-Orge","France","FRA","",20619],
[1250686935,"Longjumeau","Longjumeau","France","FRA","",20964],
[1484761843,"Ojinaga","Ojinaga","Mexico","MEX","minor",22744],
[1250210852,"Tassin-la-Demi-Lune","Tassin-la-Demi-Lune","France","FRA","",22403],
[1392003373,"Kitajima","Kitajima","Japan","JPN","",22670],
[1031256738,"Hacı Zeynalabdin","Haci Zeynalabdin","Azerbaijan","AZE","",22000],
[1840029076,"South Bradenton","South Bradenton","United States","USA","",25227],
[1426343192,"Mohale’s Hoek","Mohale's Hoek","Lesotho","LSO","admin",24992],
[1840018308,"Palm Springs","Palm Springs","United States","USA","",25216],
[1191345427,"Vukovar","Vukovar","Croatia","HRV","admin",24938],
[1250075648,"Vélizy-Villacoublay","Velizy-Villacoublay","France","FRA","",22649],
[1598405100,"Wewak","Wewak","Papua New Guinea","PNG","admin",25143],
[1630035506,"Levittown","Levittown","Puerto Rico","PRI","",25121],
[1116207762,"Tbeng Meanchey","Tbeng Meanchey","Cambodia","KHM","admin",24380],
[1616017427,"Szczytno","Szczytno","Poland","POL","minor",22813],
[1792867633,"Şırnak","Sirnak","Turkey","TUR","admin",25059],
[1826221040,"Maesteg","Maesteg","United Kingdom","GBR","",20612],
[1826881376,"Bathgate","Bathgate","United Kingdom","GBR","",22920],
[1616326744,"Bartoszyce","Bartoszyce","Poland","POL","minor",22984],
[1250623371,"Sceaux","Sceaux","France","FRA","",19606],
[1140658026,"Kaga Bandoro","Kaga Bandoro","Central African Republic","CAF","admin",24661],
[1826586304,"Truro","Truro","United Kingdom","GBR","",21555],
[1250420888,"Le Mée-sur-Seine","Le Mee-sur-Seine","France","FRA","",21071],
[1484193381,"Coquimatlán","Coquimatlan","Mexico","MEX","minor",19385],
[1250863295,"Montigny-lès-Metz","Montigny-les-Metz","France","FRA","",21749],
[1620475518,"Portalegre","Portalegre","Portugal","PRT","admin",24930],
[1840022055,"University Park","University Park","United States","USA","",24985],
[1826350658,"Yate","Yate","United Kingdom","GBR","",21789],
[1840013990,"Terrytown","Terrytown","United States","USA","",24953],
[1484086425,"Degollado","Degollado","Mexico","MEX","minor",21226],
[1484002795,"Valle Nacional","Valle Nacional","Mexico","MEX","minor",22699],
[1705849587,"Novo Mesto","Novo Mesto","Slovenia","SVN","admin",24183],
[1484490839,"Cotija de la Paz","Cotija de la Paz","Mexico","MEX","minor",19018],
[1826138490,"Southbourne","Southbourne","United Kingdom","GBR","",18960],
[1380658560,"Cusano Milanino","Cusano Milanino","Italy","ITA","",18797],
[1840020286,"Riverbank","Riverbank","United States","USA","",24881],
[1484333240,"Fortín de las Flores","Fortin de las Flores","Mexico","MEX","minor",21370],
[1826058750,"Leek","Leek","United Kingdom","GBR","",20768],
[1818302173,"Shārūnah","Sharunah","Egypt","EGY","",22221],
[1840081750,"Maplewood","Maplewood","United States","USA","",24784],
[1250401082,"Hérouville-Saint-Clair","Herouville-Saint-Clair","France","FRA","",22638],
[1840005228,"Baldwin","Baldwin","United States","USA","",24727],
[1840011296,"Melrose Park","Melrose Park","United States","USA","",24703],
[1156958987,"Dongta","Dongta","China","CHN","minor",22040],
[1840141656,"Palm Tree","Palm Tree","United States","USA","",24666],
[1496145017,"Sühbaatar","Suhbaatar","Mongolia","MNG","admin",24235],
[1250710876,"Le Plessis-Trévise","Le Plessis-Trevise","France","FRA","",20025],
[1032302344,"Rawson","Rawson","Argentina","ARG","admin",24616],
[1422694451,"Baalbek","Baalbek","Lebanon","LBN","admin",24000],
[1840006037,"Herndon","Herndon","United States","USA","",24601],
[1250410210,"Juvisy-sur-Orge","Juvisy-sur-Orge","France","FRA","",17007],
[1826117124,"Falmouth","Falmouth","United Kingdom","GBR","",21797],
[1392337002,"Kasamatsuchō","Kasamatsucho","Japan","JPN","",22415],
[1392530261,"Kanmaki","Kanmaki","Japan","JPN","",21145],
[1250043799,"Chevilly-Larue","Chevilly-Larue","France","FRA","",19863],
[1620164302,"Falagueira","Falagueira","Portugal","PRT","",14530],
[1840005320,"Rockville Centre","Rockville Centre","United States","USA","",24550],
[1764574750,"Lop Buri","Lop Buri","Thailand","THA","admin",24166],
[1484737223,"Allende","Allende","Mexico","MEX","minor",21376],
[1840031466,"Suitland","Suitland","United States","USA","",24522],
[1376546526,"Gan Yavne","Gan Yavne","Israel","ISR","",22453],
[1156022859,"Xingangli","Xingangli","China","CHN","",19751],
[1380158299,"Cormano","Cormano","Italy","ITA","",20019],
[1840022049,"Watauga","Watauga","United States","USA","",24481],
[1372096982,"Carlow","Carlow","Ireland","IRL","admin",24272],
[1056844359,"Edegem","Edegem","Belgium","BEL","",21947],
[1250034563,"Saint-Pol-sur-Mer","Saint-Pol-sur-Mer","France","FRA","",20479],
[1826564728,"Woodlesford","Woodlesford","United Kingdom","GBR","",21010],
[1620177884,"São João da Madeira","Sao Joao da Madeira","Portugal","PRT","minor",21713],
[1840017619,"Ashland","Ashland","United States","USA","",24430],
[1686096548,"Fatick","Fatick","Senegal","SEN","admin",24243],
[1250819039,"La Celle-Saint-Cloud","La Celle-Saint-Cloud","France","FRA","",20830],
[1250000952,"Garches","Garches","France","FRA","",17762],
[1840145210,"Woodlawn","Woodlawn","United States","USA","",24351],
[1840003535,"Lodi","Lodi","United States","USA","",24347],
[1376925215,"Kafr Qāsim","Kafr Qasim","Israel","ISR","",21848],
[1250036813,"Dammarie-lè-Lys","Dammarie-le-Lys","France","FRA","",22177],
[1032961945,"Villa Sarmiento","Villa Sarmiento","Argentina","ARG","",17481],
[1840021861,"San Fernando","San Fernando","United States","USA","",24322],
[1764151688,"Chanthaburi","Chanthaburi","Thailand","THA","admin",23835],
[1840000783,"Peekskill","Peekskill","United States","USA","",24295],
[1840041996,"Mill Creek East","Mill Creek East","United States","USA","",24291],
[1422639397,"Baabda","Baabda","Lebanon","LBN","admin",9000],
[1008368062,"Gjirokastër","Gjirokaster","Albania","ALB","admin",23437],
[1792385654,"Ağrı","Agri","Turkey","TUR","admin",24168],
[1840006040,"Tysons","Tysons","United States","USA","",24261],
[1380752236,"Frattaminore","Frattaminore","Italy","ITA","",16131],
[1428524787,"Valmiera","Valmiera","Latvia","LVA","admin",22971],
[1752552539,"Huskvarna","Huskvarna","Sweden","SWE","",22000],
[1840037327,"Bailey's Crossroads","Bailey's Crossroads","United States","USA","",24180],
[1688145915,"Vrbas","Vrbas","Serbia","SRB","admin",24112],
[1608526537,"Bontoc","Bontoc","Philippines","PHL","admin",24104],
[1478064510,"Atar","Atar","Mauritania","MRT","admin",24021],
[1818556807,"Banī Murr","Bani Murr","Egypt","EGY","",20065],
[1434996940,"Al Jawf","Al Jawf","Libya","LBY","admin",24132],
[1840011272,"Elmwood Park","Elmwood Park","United States","USA","",24098],
[1792182918,"Kırklareli","Kirklareli","Turkey","TUR","admin",24004],
[1834065400,"Kibaha","Kibaha","Tanzania","TZA","admin",23050],
[1826588626,"Renfrew","Renfrew","United Kingdom","GBR","",21854],
[1840029062,"Oak Ridge","Oak Ridge","United States","USA","",24004],
[1380425008,"Senago","Senago","Italy","ITA","",21500],
[1376958417,"Qalansuwa","Qalansuwa","Israel","ISR","",21451],
[1484664655,"Mecayapan","Mecayapan","Mexico","MEX","minor",17312],
[1250755525,"Hellemmes-Lille","Hellemmes-Lille","France","FRA","",18437],
[1178298042,"Owando","Owando","Congo (Brazzaville)","COG","admin",23952],
[1643440857,"Kudrovo","Kudrovo","Russia","RUS","",13501],
[1218581593,"Guaranda","Guaranda","Ecuador","ECU","admin",23874],
[1156185967,"Fengdeng","Fengdeng","China","CHN","",12922],
[1250722122,"Le Bourget","Le Bourget","France","FRA","",16139],
[1250672481,"Mantes-la-Ville","Mantes-la-Ville","France","FRA","",20499],
[1826850305,"Leigh-on-Sea","Leigh-on-Sea","United Kingdom","GBR","",20737],
[1454517378,"Nkhata Bay","Nkhata Bay","Malawi","MWI","admin",22108],
[1250113303,"Saint-Maurice","Saint-Maurice","France","FRA","",14001],
[1764836023,"Satun","Satun","Thailand","THA","admin",23612],
[1250314073,"Villeneuve-le-Roi","Villeneuve-le-Roi","France","FRA","",21214],
[1250540088,"Saint-Michel-sur-Orge","Saint-Michel-sur-Orge","France","FRA","",19965],
[1764000534,"Phetchaburi","Phetchaburi","Thailand","THA","admin",23235],
[1818431308,"Al Madāmūd","Al Madamud","Egypt","EGY","",15091],
[1356688611,"Bāuria","Bauria","India","IND","",16764],
[1792400872,"Bayburt","Bayburt","Turkey","TUR","admin",23690],
[1840019213,"Valinda","Valinda","United States","USA","",23705],
[1380064390,"Novate Milanese","Novate Milanese","Italy","ITA","",20003],
[1484013411,"Peto","Peto","Mexico","MEX","",19821],
[1484636817,"Ciudad Miguel Alemán","Ciudad Miguel Aleman","Mexico","MEX","minor",19998],
[1840037895,"North Lynnwood","North Lynnwood","United States","USA","",23620],
[1533786612,"Tanki Leendert","Tanki Leendert","Aruba","ABW","",21495],
[1840018844,"Rosemont","Rosemont","United States","USA","",23602],
[1792386602,"Kastamonu","Kastamonu","Turkey","TUR","admin",23485],
[1840019242,"Cudahy","Cudahy","United States","USA","",23569],
[1400134505,"Aţ Ţafīlah","At Tafilah","Jordan","JOR","admin",23512],
[1840005031,"Copiague","Copiague","United States","USA","",23561],
[1840019351,"Winter Gardens","Winter Gardens","United States","USA","",23545],
[1392279515,"Yonabaru","Yonabaru","Japan","JPN","",19735],
[1724290706,"Alfafar","Alfafar","Spain","ESP","",21415],
[1826397253,"Goodmayes","Goodmayes","United Kingdom","GBR","",13069],
[1756684864,"Allschwil","Allschwil","Switzerland","CHE","",21150],
[1840015158,"Hialeah Gardens","Hialeah Gardens","United States","USA","",23474],
[1250237697,"Wasquehal","Wasquehal","France","FRA","",20485],
[1804091595,"Sukhodilsk","Sukhodilsk","Ukraine","UKR","",21324],
[1250986253,"Chilly-Mazarin","Chilly-Mazarin","France","FRA","",19858],
[1840001331,"Carteret","Carteret","United States","USA","",23408],
[1756222668,"Opfikon","Opfikon","Switzerland","CHE","",19864],
[1218759537,"Tena","Tena","Ecuador","ECU","admin",23307],
[1372985945,"Naas","Naas","Ireland","IRL","admin",21393],
[1840028409,"West Puente Valley","West Puente Valley","United States","USA","",23382],
[1250623309,"Achères","Acheres","France","FRA","",21098],
[1620849212,"Sacavém","Sacavem","Portugal","PRT","",18469],
[1818102859,"Sunbāţ","Sunbat","Egypt","EGY","",20599],
[1484749313,"Hidalgotitlán","Hidalgotitlan","Mexico","MEX","minor",19587],
[1826600240,"Penzance","Penzance","United Kingdom","GBR","",20812],
[1756289111,"Nyon","Nyon","Switzerland","CHE","",20272],
[1470176983,"Mosta","Mosta","Malta","MLT","admin",20241],
[1250526010,"Coudekerque-Branche","Coudekerque-Branche","France","FRA","",20925],
[1840011294,"Maywood","Maywood","United States","USA","",23158],
[1250087554,"Fleury-les-Aubrais","Fleury-les-Aubrais","France","FRA","",21070],
[1392003446,"Shōwa","Showa","Japan","JPN","",20857],
[1276398825,"Gröbenzell","Grobenzell","Germany","DEU","",19967],
[1108413426,"Kayanza","Kayanza","Burundi","BDI","admin",21767],
[1504858900,"Douar Toulal","Douar Toulal","Morocco","MAR","",19077],
[1250877537,"Ronchin","Ronchin","France","FRA","",19477],
[1840004961,"Monsey","Monsey","United States","USA","",23055],
[1826812445,"Peterhead","Peterhead","United Kingdom","GBR","",19270],
[1428832851,"Ogre","Ogre","Latvia","LVA","admin",22978],
[1250139539,"Nogent-sur-Oise","Nogent-sur-Oise","France","FRA","",20298],
[1756722157,"Aarau","Aarau","Switzerland","CHE","admin",21268],
[1250284749,"Montereau-faut-Yonne","Montereau-faut-Yonne","France","FRA","",20712],
[1792403093,"Çanakkale","Canakkale","Turkey","TUR","admin",22789],
[1826995667,"Bellshill","Bellshill","United Kingdom","GBR","",20290],
[1484989287,"Zimatlán de Álvarez","Zimatlan de Alvarez","Mexico","MEX","minor",19849],
[1826976833,"Davyhulme","Davyhulme","United Kingdom","GBR","",19634],
[1484624680,"Tepatlaxco","Tepatlaxco","Mexico","MEX","minor",17472],
[1840028406,"West Rancho Dominguez","West Rancho Dominguez","United States","USA","",22901],
[1840007028,"Blue Island","Blue Island","United States","USA","",22899],
[1800294178,"Moyo","Moyo","Uganda","UGA","admin",22434],
[1031149283,"Biləsuvar","Bilasuvar","Azerbaijan","AZE","admin",22800],
[1380813472,"Monserrato","Monserrato","Italy","ITA","",19771],
[1764849819,"Phra Pradaeng","Phra Pradaeng","Thailand","THA","minor",10190],
[1454007077,"Mzimba","Mzimba","Malawi","MWI","admin",19308],
[1250471456,"Soisy-sous-Montmorency","Soisy-sous-Montmorency","France","FRA","",18243],
[1380538043,"Trentola","Trentola","Italy","ITA","",19844],
[1178867178,"Sibiti","Sibiti","Congo (Brazzaville)","COG","admin",22811],
[1840019220,"Willowbrook","Willowbrook","United States","USA","",22811],
[1250975407,"Saint-Cyr-l’École","Saint-Cyr-l'Ecole","France","FRA","",19011],
[1504478947,"Oulad Fraj","Oulad Fraj","Morocco","MAR","",19752],
[1140802055,"Sibut","Sibut","Central African Republic","CAF","admin",22419],
[1818728041,"Al Qays","Al Qays","Egypt","EGY","",20603],
[1388690384,"Savanna-la-Mar","Savanna-la-Mar","Jamaica","JAM","admin",22600],
[1178057279,"Madingou","Madingou","Congo (Brazzaville)","COG","admin",22760],
[1454459215,"Mulanje","Mulanje","Malawi","MWI","admin",20870],
[1484785956,"José Cardel","Jose Cardel","Mexico","MEX","minor",19341],
[1440351434,"Kėdainiai","Kedainiai","Lithuania","LTU","admin",22682],
[1840028705,"Ives Estates","Ives Estates","United States","USA","",22707],
[1800678001,"Kayunga","Kayunga","Uganda","UGA","admin",21704],
[1356922708,"Dumjor","Dumjor","India","IND","",18433],
[1428885452,"Jēkabpils","Jekabpils","Latvia","LVA","admin",21629],
[1040024396,"Mödling","Modling","Austria","AUT","minor",20555],
[1792413556,"Burdur","Burdur","Turkey","TUR","admin",22489],
[1380746538,"Ischia","Ischia","Italy","ITA","",20118],
[1826477610,"Antrim","Antrim","United Kingdom","GBR","",19986],
[1840005956,"Landover","Landover","United States","USA","",22553],
[1624735310,"Bafatá","Bafata","Guinea-Bissau","GNB","admin",22501],
[1484386885,"Mapastepec","Mapastepec","Mexico","MEX","minor",17931],
[1504027251,"Ahfir","Ahfir","Morocco","MAR","",19630],
[1470879974,"Saint Paul’s Bay","Saint Paul's Bay","Malta","MLT","admin",21046],
[1764024236,"Phichit","Phichit","Thailand","THA","admin",22299],
[1266074474,"Mouila","Mouila","Gabon","GAB","admin",22469],
[1051969157,"Artashat","Artashat","Armenia","ARM","admin",21300],
[1840029008,"The Crossings","The Crossings","United States","USA","",22441],
[1250455159,"Saint-Fons","Saint-Fons","France","FRA","",19254],
[1484197521,"Aldama","Aldama","Mexico","MEX","minor",18642],
[1356110820,"Mahiari","Mahiari","India","IND","",18223],
[1826062895,"Frimley","Frimley","United Kingdom","GBR","",19094],
[1764996883,"Loei","Loei","Thailand","THA","admin",22339],
[1682121855,"Al Bāḩah","Al Bahah","Saudi Arabia","SAU","admin",21983],
[1484142037,"Palau","Palau","Mexico","MEX","",17594],
[1840020306,"Millbrae","Millbrae","United States","USA","",22394],
[1454428076,"Nsanje","Nsanje","Malawi","MWI","admin",21774],
[1792686663,"Adıyaman","Adiyaman","Turkey","TUR","admin",22153],
[1140040245,"Mbaïki","Mbaiki","Central African Republic","CAF","admin",22166],
[1484402622,"Tatahuicapan","Tatahuicapan","Mexico","MEX","minor",15614],
[1498912060,"Soroca","Soroca","Moldova","MDA","admin",22196],
[1380500358,"Arese","Arese","Italy","ITA","",19347],
[1470252842,"Fgura","Fgura","Malta","MLT","admin",11670],
[1484235149,"Ayutla de los Libres","Ayutla de los Libres","Mexico","MEX","minor",15370],
[1826297411,"Great Linford","Great Linford","United Kingdom","GBR","",19350],
[1380479578,"Cercola","Cercola","Italy","ITA","",18007],
[1250119295,"Lingolsheim","Lingolsheim","France","FRA","",18930],
[1372349451,"Wexford","Wexford","Ireland","IRL","admin",20188],
[1132693257,"São Filipe","Sao Filipe","Cabo Verde","CPV","admin",22227],
[1496103841,"Uliastay","Uliastay","Mongolia","MNG","admin",22006],
[1764518331,"Phetchabun","Phetchabun","Thailand","THA","admin",22121],
[1380518961,"Sant’Antonio Abate","Sant'Antonio Abate","Italy","ITA","",19704],
[1600095784,"Caacupé","Caacupe","Paraguay","PRY","admin",21696],
[1826798518,"Maltby","Maltby","United Kingdom","GBR","",16856],
[1372926521,"Kilkenny","Kilkenny","Ireland","IRL","admin",22179],
[1250158129,"Cran-Gévrier","Cran-Gevrier","France","FRA","",18330],
[1826380949,"Keynsham","Keynsham","United Kingdom","GBR","",16641],
[1144224835,"Kegalle","Kegalle","Sri Lanka","LKA","",17962],
[1484788928,"Acala","Acala","Mexico","MEX","minor",15001],
[1250518301,"Fâches-Thumesnil","Faches-Thumesnil","France","FRA","",18165],
[1170970726,"Mocoa","Mocoa","Colombia","COL","admin",22035],
[1840028405,"West Carson","West Carson","United States","USA","",22079],
[1440908000,"Telšiai","Telsiai","Lithuania","LTU","admin",22039],
[1858883224,"Bella Unión","Bella Union","Uruguay","URY","",19100],
[1056722855,"Assebroek","Assebroek","Belgium","BEL","",19737],
[1051714712,"Ashtarak","Ashtarak","Armenia","ARM","admin",21600],
[1840025161,"Lealman","Lealman","United States","USA","",22034],
[1826000803,"Broughty Ferry","Broughty Ferry","United Kingdom","GBR","",18659],
[1250909117,"Éragny","Eragny","France","FRA","",18162],
[1454607053,"Mchinji","Mchinji","Malawi","MWI","admin",18305],
[1434971028,"Ghāt","Ghat","Libya","LBY","admin",22000],
[1840034726,"Hayesville","Hayesville","United States","USA","",21979],
[1250187381,"Bry-sur-Marne","Bry-sur-Marne","France","FRA","",16919],
[1840081741,"Hillside","Hillside","United States","USA","",21928],
[1792105249,"Isparta","Isparta","Turkey","TUR","admin",21406],
[1400073941,"Al Karak","Al Karak","Jordan","JOR","admin",21678],
[1826417791,"Tonypandy","Tonypandy","United Kingdom","GBR","",17789],
[1756011617,"Reinach","Reinach","Switzerland","CHE","",19144],
[1484699271,"Coalcomán de Vázquez Pallares","Coalcoman de Vazquez Pallares","Mexico","MEX","minor",18444],
[1598928169,"Goroka","Goroka","Papua New Guinea","PNG","admin",21507],
[1840014116,"Jasmine Estates","Jasmine Estates","United States","USA","",21865],
[1724188832,"Sant Just Desvern","Sant Just Desvern","Spain","ESP","",19379],
[1124174363,"Saint-Lambert","Saint-Lambert","Canada","CAN","",21861],
[1484340141,"Acatlán de Osorio","Acatlan de Osorio","Mexico","MEX","",18879],
[1032281187,"Aldo Bonzi","Aldo Bonzi","Argentina","ARG","",18175],
[1792838138,"Yalova","Yalova","Turkey","TUR","admin",20707],
[1392622247,"Kitagata","Kitagata","Japan","JPN","",18308],
[1250001025,"Moulins","Moulins","France","FRA","minor",19563],
[1792807068,"Bolu","Bolu","Turkey","TUR","admin",21700],
[1858670999,"Carmelo","Carmelo","Uruguay","URY","",18041],
[1840017923,"Lennox","Lennox","United States","USA","",21818],
[1380806046,"Melegnano","Melegnano","Italy","ITA","",18127],
[1840001092,"Roselle","Roselle","United States","USA","",21811],
[1840016007,"Sunny Isles Beach","Sunny Isles Beach","United States","USA","",21804],
[1051007129,"Ijevan","Ijevan","Armenia","ARM","admin",20509],
[1840005274,"Massapequa","Massapequa","United States","USA","",21784],
[1250611358,"Chamalières","Chamalieres","France","FRA","",17210],
[1818016476,"Dayr Abū Ḩinnis","Dayr Abu Hinnis","Egypt","EGY","",19638],
[1792867993,"Niğde","Nigde","Turkey","TUR","admin",21663],
[1356113261,"Mayahaura","Mayahaura","India","IND","",19604],
[1250657039,"Mont-Saint-Aignan","Mont-Saint-Aignan","France","FRA","",19262],
[1840005055,"North Bay Shore","North Bay Shore","United States","USA","",21679],
[1840025211,"Kapolei","Kapolei","United States","USA","",21674],
[1826599485,"Hadleigh","Hadleigh","United Kingdom","GBR","",18300],
[1764333285,"Nong Bua Lamphu","Nong Bua Lamphu","Thailand","THA","admin",21528],
[1724567421,"Calella","Calella","Spain","ESP","",19236],
[1826125584,"East Barnet","East Barnet","United Kingdom","GBR","",16137],
[1840001442,"Dover","Dover","United States","USA","",21605],
[1840003980,"Hamtramck","Hamtramck","United States","USA","",21599],
[1250458214,"Chennevières-sur-Marne","Chennevieres-sur-Marne","France","FRA","",18142],
[1140416562,"Bozoum","Bozoum","Central African Republic","CAF","admin",20665],
[1250075642,"Le Pecq","Le Pecq","France","FRA","",15949],
[1440115384,"Tauragė","Taurage","Lithuania","LTU","admin",21516],
[1756013633,"Schlieren","Schlieren","Switzerland","CHE","",18666],
[1840041794,"McNair","McNair","United States","USA","",21485],
[1484867017,"Chemax","Chemax","Mexico","MEX","",14885],
[1404895664,"Maralal","Maralal","Kenya","KEN","admin",20841],
[1756456471,"Pully","Pully","Switzerland","CHE","",18313],
[1191128636,"Virovitica","Virovitica","Croatia","HRV","admin",21291],
[1222399599,"San Francisco","San Francisco","El Salvador","SLV","admin",21049],
[1792583760,"Nevşehir","Nevsehir","Turkey","TUR","admin",21121],
[1250591118,"Vauréal","Vaureal","France","FRA","",16575],
[1792486859,"Giresun","Giresun","Turkey","TUR","admin",20914],
[1840019792,"Mountlake Terrace","Mountlake Terrace","United States","USA","",21338],
[1250498195,"Bonneuil-sur-Marne","Bonneuil-sur-Marne","France","FRA","",18045],
[1484696811,"Senguio","Senguio","Mexico","MEX","minor",19146],
[1840001059,"North Plainfield","North Plainfield","United States","USA","",21289],
[1250257678,"Le Raincy","Le Raincy","France","FRA","minor",14708],
[1440784663,"Ukmergė","Ukmerge","Lithuania","LTU","admin",21226],
[1484708548,"Técpan de Galeana","Tecpan de Galeana","Mexico","MEX","minor",14638],
[1858287723,"Santa Lucía","Santa Lucia","Uruguay","URY","",16742],
[1392003469,"Utazu","Utazu","Japan","JPN","",18897],
[1262002221,"Obock","Obock","Djibouti","DJI","admin",21200],
[1484768670,"Pajapan","Pajapan","Mexico","MEX","minor",17480],
[1498680500,"Orhei","Orhei","Moldova","MDA","admin",21065],
[1756221733,"Adliswil","Adliswil","Switzerland","CHE","",18731],
[1340614286,"La Esperanza","La Esperanza","Honduras","HND","admin",21000],
[1024283760,"Luena","Luena","Angola","AGO","admin",21115],
[1250130544,"Viroflay","Viroflay","France","FRA","",16406],
[1724653510,"Malgrat de Mar","Malgrat de Mar","Spain","ESP","",18950],
[1826286712,"Dingle","Dingle","United Kingdom","GBR","",13246],
[1250611667,"Bischheim","Bischheim","France","FRA","",17137],
[1756199955,"Thalwil","Thalwil","Switzerland","CHE","",17784],
[1356960169,"Dispur","Dispur","India","IND","admin",16140],
[1840016008,"Sweetwater","Sweetwater","United States","USA","",20994],
[1484373649,"El Rosario","El Rosario","Mexico","MEX","minor",16001],
[1484719986,"El Dorado","El Dorado","Mexico","MEX","",17365],
[1724056681,"El Astillero","El Astillero","Spain","ESP","",18116],
[1630035675,"Guayama","Guayama","Puerto Rico","PRI","",20913],
[1276706639,"Wolfratshausen","Wolfratshausen","Germany","DEU","",18836],
[1826693791,"Bonnyrigg","Bonnyrigg","United Kingdom","GBR","",17530],
[1826033048,"Fern Down","Fern Down","United Kingdom","GBR","",17650],
[1178021926,"Impfondo","Impfondo","Congo (Brazzaville)","COG","admin",20859],
[1051983153,"Gavarr","Gavarr","Armenia","ARM","admin",20765],
[1031078072,"Quba","Quba","Azerbaijan","AZE","admin",20791],
[1858369530,"Dolores","Dolores","Uruguay","URY","",15753],
[1392366184,"Tadaoka-higashi","Tadaoka-higashi","Japan","JPN","",16628],
[1250000295,"Écully","Ecully","France","FRA","",18587],
[1858741797,"Canelones","Canelones","Uruguay","URY","admin",19865],
[1840005240,"North Bellmore","North Bellmore","United States","USA","",20718],
[1840000915,"Palisades Park","Palisades Park","United States","USA","",20715],
[1031380246,"İsmayıllı","Ismayilli","Azerbaijan","AZE","admin",20660],
[1148642108,"Ati","Ati","Chad","TCD","admin",20695],
[1764061223,"Nan","Nan","Thailand","THA","admin",20595],
[1688642855,"Ćuprija","Cuprija","Serbia","SRB","admin",20585],
[1826628541,"Cosham","Cosham","United Kingdom","GBR","",13830],
[1826928486,"High Blantyre","High Blantyre","United Kingdom","GBR","",16900],
[1826659439,"Nailsea","Nailsea","United Kingdom","GBR","",15630],
[1840021869,"South El Monte","South El Monte","United States","USA","",20574],
[1764520637,"Yasothon","Yasothon","Thailand","THA","admin",20414],
[1380688508,"Beinasco","Beinasco","Italy","ITA","",17856],
[1756779389,"Ostermundigen","Ostermundigen","Switzerland","CHE","",17546],
[1788008309,"Zaghouan","Zaghouan","Tunisia","TUN","admin",20387],
[1826063569,"Basford","Basford","United Kingdom","GBR","",16207],
[1826674732,"Porthcawl","Porthcawl","United Kingdom","GBR","",15640],
[1818622612,"Banī Ḩasan ash Shurūq","Bani Hasan ash Shuruq","Egypt","EGY","",18218],
[1764734104,"Ban Rawai","Ban Rawai","Thailand","THA","",16988],
[1108018348,"Bubanza","Bubanza","Burundi","BDI","admin",20031],
[1826543368,"Milton","Milton","United Kingdom","GBR","",17250],
[1250064051,"Les Clayes-sous-Bois","Les Clayes-sous-Bois","France","FRA","",17560],
[1840006712,"Columbia Heights","Columbia Heights","United States","USA","",20427],
[1356456699,"Mālancha","Malancha","India","IND","",16918],
[1558605178,"Somoto","Somoto","Nicaragua","NIC","admin",20300],
[1688368364,"Senta","Senta","Serbia","SRB","admin",20302],
[1826746556,"Hilsea","Hilsea","United Kingdom","GBR","",13552],
[1404468256,"Eldama Ravine","Eldama Ravine","Kenya","KEN","",17581],
[1840020489,"Lomita","Lomita","United States","USA","",20320],
[1840014168,"Bayshore Gardens","Bayshore Gardens","United States","USA","",20287],
[1031748204,"Ağsu","Agsu","Azerbaijan","AZE","admin",20200],
[1031889683,"Ağstafa","Agstafa","Azerbaijan","AZE","admin",20200],
[1826458707,"Kilwinning","Kilwinning","United Kingdom","GBR","",16460],
[1826566992,"Woodhouse","Woodhouse","United Kingdom","GBR","",17450],
[1356255292,"Raghudebbati","Raghudebbati","India","IND","",14165],
[1056928401,"Boom","Boom","Belgium","BEL","",17782],
[1250552160,"Maurepas","Maurepas","France","FRA","",18019],
[1498677351,"Comrat","Comrat","Moldova","MDA","admin",20113],
[1320849830,"Guastatoya","Guastatoya","Guatemala","GTM","admin",20050],
[1484955369,"Tecuala","Tecuala","Mexico","MEX","minor",14921],
[1124000941,"Kirkland","Kirkland","Canada","CAN","",20151],
[1484409365,"Rodolfo Sánchez Taboada","Rodolfo Sanchez Taboada","Mexico","MEX","",15038],
[1470879234,"Qormi","Qormi","Malta","MLT","admin",16779],
[1454611219,"Chitipa","Chitipa","Malawi","MWI","admin",13412],
[1496580180,"Arvayheer","Arvayheer","Mongolia","MNG","admin",20000],
[1484912284,"Ciudad de Huitzuco","Ciudad de Huitzuco","Mexico","MEX","minor",16025],
[1818316929,"Biyahmū","Biyahmu","Egypt","EGY","",17486],
[1484948191,"Tepoztlán","Tepoztlan","Mexico","MEX","minor",14130],
[1484359502,"Tlaxcala","Tlaxcala","Mexico","MEX","admin",14692],
[1826659843,"Kidbrooke","Kidbrooke","United Kingdom","GBR","",14300],
[1484221851,"Santiago Tulantepec","Santiago Tulantepec","Mexico","MEX","minor",16078],
[1840003598,"Harrison","Harrison","United States","USA","",20061],
[1380510857,"Cattolica","Cattolica","Italy","ITA","",17177],
[1804009673,"Kotsyubyns’ke","Kotsyubyns'ke","Ukraine","UKR","",16337],
[1826460602,"Bingley","Bingley","United Kingdom","GBR","",15925],
[1840001436,"West Chester","West Chester","United States","USA","",20029],
[1356632745,"Nahāzāri","Nahazari","India","IND","",17422],
[1104739581,"Hakha","Hakha","Myanmar","MMR","admin",20000],
[1826363463,"Maldon","Maldon","United Kingdom","GBR","",14220],
[1826528845,"Fazakerley","Fazakerley","United Kingdom","GBR","",16786],
[1499867182,"Ulcinj","Ulcinj","Montenegro","MNE","admin",19921],
[1478594780,"Tidjikja","Tidjikja","Mauritania","MRT","admin",19981],
[1840019208,"South San Jose Hills","South San Jose Hills","United States","USA","",19977],
[1484654052,"Ciudad Guadalupe Victoria","Ciudad Guadalupe Victoria","Mexico","MEX","minor",16506],
[1840003544,"Elmwood Park","Elmwood Park","United States","USA","",19966],
[1250421727,"Floirac","Floirac","France","FRA","",17882],
[1756647288,"Morges","Morges","Switzerland","CHE","",15838],
[1124878078,"Westmount","Westmount","Canada","CAN","",19931],
[1418894454,"Attapu","Attapu","Laos","LAO","admin",19200],
[1496862229,"Saynshand","Saynshand","Mongolia","MNG","admin",19891],
[1404814363,"Kapsabet","Kapsabet","Kenya","KEN","admin",17918],
[1598946326,"Kavieng","Kavieng","Papua New Guinea","PNG","admin",19849],
[1840005282,"West Hempstead","West Hempstead","United States","USA","",19864],
[1056981406,"Wondelgem","Wondelgem","Belgium","BEL","",16932],
[1356054875,"Giria","Giria","India","IND","",17131],
[1372185807,"Sligo","Sligo","Ireland","IRL","admin",19199],
[1170563591,"Inírida","Inirida","Colombia","COL","admin",19816],
[1840001610,"Norwood","Norwood","United States","USA","",19776],
[1484360693,"Ciudad Hidalgo","Ciudad Hidalgo","Mexico","MEX","minor",14606],
[1484956696,"Cárdenas","Cardenas","Mexico","MEX","minor",15331],
[1484567751,"Izamal","Izamal","Mexico","MEX","",16195],
[1826423474,"Larkhall","Larkhall","United Kingdom","GBR","",14740],
[1324603099,"Faranah","Faranah","Guinea","GIN","admin",19469],
[1840006027,"Franconia","Franconia","United States","USA","",19720],
[1008889153,"Lezhë","Lezhe","Albania","ALB","admin",15510],
[1826801668,"Hatch End","Hatch End","United Kingdom","GBR","",10693],
[1840028140,"Albany","Albany","United States","USA","",19696],
[1840074182,"La Crescenta-Montrose","La Crescenta-Montrose","United States","USA","",19689],
[1826441033,"Deysbrook","Deysbrook","United Kingdom","GBR","",14490],
[1268806987,"Telavi","Telavi","Georgia","GEO","admin",19629],
[1484030886,"La Crucecita","La Crucecita","Mexico","MEX","",13044],
[1826888408,"Whickham","Whickham","United Kingdom","GBR","",16652],
[1356142669,"Baharu","Baharu","India","IND","",16155],
[1250829703,"Lons-le-Saunier","Lons-le-Saunier","France","FRA","minor",17320],
[1840003286,"Central Falls","Central Falls","United States","USA","",19568],
[1620674108,"Cacilhas","Cacilhas","Portugal","PRT","",6970],
[1484243519,"La Cruz","La Cruz","Mexico","MEX","minor",15657],
[1800105368,"Mubende","Mubende","Uganda","UGA","admin",18936],
[1840005959,"Langley Park","Langley Park","United States","USA","",19520],
[1124001920,"Mont-Royal","Mont-Royal","Canada","CAN","",19503],
[1840075052,"Schofield Barracks","Schofield Barracks","United States","USA","",19499],
[1756650126,"Solothurn","Solothurn","Switzerland","CHE","admin",16777],
[1840005304,"Lynbrook","Lynbrook","United States","USA","",19448],
[1484035729,"Grajales","Grajales","Mexico","MEX","minor",14159],
[1148360693,"Laï","Lai","Chad","TCD","admin",19382],
[1704957010,"Sơn La","Son La","Vietnam","VNM","admin",19054],
[1724734999,"Canovellas","Canovellas","Spain","ESP","",16872],
[1499564238,"Budva","Budva","Montenegro","MNE","admin",19218],
[1250419168,"Arnouville-lès-Gonesse","Arnouville-les-Gonesse","France","FRA","",14329],
[1266060335,"Tchibanga","Tchibanga","Gabon","GAB","admin",19365],
[1218176372,"Macas","Macas","Ecuador","ECU","admin",18984],
[1840020487,"Hermosa Beach","Hermosa Beach","United States","USA","",19320],
[1562317955,"Tillabéri","Tillaberi","Niger","NER","admin",19262],
[1826060826,"South Hayling","South Hayling","United Kingdom","GBR","",15948],
[1418944950,"Ban Houayxay","Ban Houayxay","Laos","LAO","admin",17687],
[1380728572,"Brusciano","Brusciano","Italy","ITA","",16371],
[1250025430,"Noisiel","Noisiel","France","FRA","",15676],
[1356912324,"Jagdispur","Jagdispur","India","IND","",16259],
[1840003577,"Morristown","Morristown","United States","USA","",19261],
[1826315811,"Johnstone","Johnstone","United Kingdom","GBR","",16090],
[1826268056,"Morriston","Morriston","United Kingdom","GBR","",16928],
[1031512571,"Əhmədli","Ahmadli","Azerbaijan","AZE","",10974],
[1356026794,"Ramnagar","Ramnagar","India","IND","",17053],
[1840028581,"Sherrelwood","Sherrelwood","United States","USA","",19208],
[1840005310,"Mineola","Mineola","United States","USA","",19207],
[1380239503,"Sant’Arpino","Sant'Arpino","Italy","ITA","",14606],
[1499255431,"Pljevlja","Pljevlja","Montenegro","MNE","admin",19136],
[1840011273,"Evergreen Park","Evergreen Park","United States","USA","",19147],
[1250742662,"Saint-Jean-de-la-Ruelle","Saint-Jean-de-la-Ruelle","France","FRA","",16445],
[1834932235,"Bububu","Bububu","Tanzania","TZA","",15666],
[1800204374,"Pakwach","Pakwach","Uganda","UGA","admin",17541],
[1756488918,"Binningen","Binningen","Switzerland","CHE","",15580],
[1392003185,"Kawai","Kawai","Japan","JPN","",16983],
[1484184075,"Tlaltetela","Tlaltetela","Mexico","MEX","minor",15818],
[1250736749,"Le Vésinet","Le Vesinet","France","FRA","",15865],
[1132061543,"Ribeira Grande","Ribeira Grande","Cabo Verde","CPV","admin",18890],
[1148740154,"Mao","Mao","Chad","TCD","admin",19004],
[1356322402,"Jaypul","Jaypul","India","IND","",16134],
[1250194364,"Montmagny","Montmagny","France","FRA","",14145],
[1840019617,"Bellaire","Bellaire","United States","USA","",18971],
[1608396110,"Lagawe","Lagawe","Philippines","PHL","admin",18876],
[1600581132,"Paraguarí","Paraguari","Paraguay","PRY","admin",18881],
[1250942695,"Hendaye","Hendaye","France","FRA","",16805],
[1724860489,"Albal","Albal","Spain","ESP","",16646],
[1484876942,"Loreto","Loreto","Mexico","MEX","minor",14724],
[1434396501,"Hūn","Hun","Libya","LBY","admin",18878],
[1598372456,"Kimbe","Kimbe","Papua New Guinea","PNG","admin",18847],
[1704264596,"Đông Hà","Dong Ha","Vietnam","VNM","admin",17662],
[1484584805,"Oteapan","Oteapan","Mexico","MEX","minor",16222],
[1504676510,"Bou Djeniba","Bou Djeniba","Morocco","MAR","",16030],
[1250926315,"Saint-Leu-la-Forêt","Saint-Leu-la-Foret","France","FRA","",15829],
[1484222410,"Puréparo de Echaíz","Pureparo de Echaiz","Mexico","MEX","",15255],
[1440984232,"Visaginas","Visaginas","Lithuania","LTU","admin",18514],
[1484332923,"Huixcolotla","Huixcolotla","Mexico","MEX","minor",14810],
[1250260531,"Marly-le-Roi","Marly-le-Roi","France","FRA","",16335],
[1270071162,"Mansa Konko","Mansa Konko","The Gambia","GMB","admin",18672],
[1826512301,"Wombwell","Wombwell","United Kingdom","GBR","",15316],
[1646996571,"Rwamagana","Rwamagana","Rwanda","RWA","admin",18009],
[1752644953,"Härnösand","Harnosand","Sweden","SWE","admin",18502],
[1826710421,"Prestwick","Prestwick","United Kingdom","GBR","",14720],
[1840001485,"Point Pleasant","Point Pleasant","United States","USA","",18772],
[1076527878,"Pedreiras","Pedreiras","Brazil","BRA","",13638],
[1332748356,"Hinche","Hinche","Haiti","HTI","admin",18590],
[1840003513,"Hawthorne","Hawthorne","United States","USA","",18753],
[1792490436,"Bitlis","Bitlis","Turkey","TUR","admin",18684],
[1724682871,"Masamagrell","Masamagrell","Spain","ESP","",16132],
[1484862775,"Vicente Guerrero","Vicente Guerrero","Mexico","MEX","minor",15982],
[1804995885,"Hostomel","Hostomel","Ukraine","UKR","",16190],
[1484001904,"Cerritos","Cerritos","Mexico","MEX","minor",14804],
[1484992524,"Juchique de Ferrer","Juchique de Ferrer","Mexico","MEX","minor",16360],
[1031277547,"Siyəzən","Siyazan","Azerbaijan","AZE","admin",18655],
[1840011248,"Bellwood","Bellwood","United States","USA","",18672],
[1392003325,"Ōyamazaki","Oyamazaki","Japan","JPN","",15991],
[1840005244,"North Valley Stream","North Valley Stream","United States","USA","",18661],
[1705072535,"Ptuj","Ptuj","Slovenia","SVN","admin",17959],
[1031302623,"Sabirabad","Sabirabad","Azerbaijan","AZE","admin",18612],
[1840024547,"Seabrook","Seabrook","United States","USA","",18616],
[1840005410,"Avenel","Avenel","United States","USA","",18592],
[1840006104,"Sudley","Sudley","United States","USA","",18575],
[1826972409,"Hythe","Hythe","United Kingdom","GBR","",14170],
[1826642248,"Melksham","Melksham","United Kingdom","GBR","",14677],
[1250589854,"Jouy-le-Moutier","Jouy-le-Moutier","France","FRA","",16214],
[1858245447,"Progreso","Progreso","Uruguay","URY","",16244],
[1132834308,"Tarrafal","Tarrafal","Cabo Verde","CPV","admin",18561],
[1496397451,"Tsetserleg","Tsetserleg","Mongolia","MNG","admin",18519],
[1380625213,"Casandrino","Casandrino","Italy","ITA","",14125],
[1840132450,"Winthrop","Winthrop","United States","USA","",18544],
[1504139417,"Goulmima","Goulmima","Morocco","MAR","",16419],
[1250534594,"Carrières-sous-Poissy","Carrieres-sous-Poissy","France","FRA","",16248],
[1840005241,"North Massapequa","North Massapequa","United States","USA","",18505],
[1250582714,"Lognes","Lognes","France","FRA","",14268],
[1196704525,"Mésa Geitoniá","Mesa Geitonia","Cyprus","CYP","",14477],
[1498773145,"Straşeni","Straseni","Moldova","MDA","admin",18376],
[1250505648,"Beausoleil","Beausoleil","France","FRA","",13576],
[1484108848,"Santa Catarina Juquila","Santa Catarina Juquila","Mexico","MEX","",14710],
[1840037012,"Bryn Mawr-Skyway","Bryn Mawr-Skyway","United States","USA","",18414],
[1484950775,"Santa Rosalía","Santa Rosalia","Mexico","MEX","minor",14357],
[1840005053,"North Amityville","North Amityville","United States","USA","",18382],
[1724922522,"Ermúa","Ermua","Spain","ESP","",15791],
[1792410633,"Zonguldak","Zonguldak","Turkey","TUR","admin",17879],
[1756960820,"Wallisellen","Wallisellen","Switzerland","CHE","",15855],
[1470317969,"Żabbar","Zabbar","Malta","MLT","admin",15404],
[1840010142,"Brookfield","Brookfield","United States","USA","",18310],
[1840000902,"Rutherford","Rutherford","United States","USA","",18303],
[1840006019,"Merrifield","Merrifield","United States","USA","",18291],
[1724290074,"Arenys de Mar","Arenys de Mar","Spain","ESP","",15942],
[1392003523,"Toyoyama","Toyoyama","Japan","JPN","",15729],
[1840006032,"Idylwood","Idylwood","United States","USA","",18273],
[1826716353,"Gornalwood","Gornalwood","United Kingdom","GBR","",12992],
[1800849421,"Kamuli","Kamuli","Uganda","UGA","admin",12764],
[1686320341,"Kédougou","Kedougou","Senegal","SEN","admin",18226],
[1840005975,"Hyattsville","Hyattsville","United States","USA","",18230],
[1418760593,"Xaignabouli","Xaignabouli","Laos","LAO","admin",16200],
[1600948743,"Filadelfia","Filadelfia","Paraguay","PRY","admin",18210],
[1504333871,"Sidi Zouine","Sidi Zouine","Morocco","MAR","",14954],
[1826173931,"Rosyth","Rosyth","United Kingdom","GBR","",13780],
[1840005418,"Iselin","Iselin","United States","USA","",18175],
[1764262472,"Prachin Buri","Prachin Buri","Thailand","THA","admin",17768],
[1484012062,"Erongarícuaro","Erongaricuaro","Mexico","MEX","minor",15291],
[1428270898,"Salaspils","Salaspils","Latvia","LVA","admin",17905],
[1826424344,"Saffron Walden","Saffron Walden","United Kingdom","GBR","",15504],
[1356586621,"Dogāchi","Dogachi","India","IND","",13848],
[1764482111,"Sing Buri","Sing Buri","Thailand","THA","admin",17843],
[1504697698,"Ait Yaazem","Ait Yaazem","Morocco","MAR","",16091],
[1250190345,"Montargis","Montargis","France","FRA","minor",14789],
[1124001153,"Sainte-Marthe-sur-le-Lac","Sainte-Marthe-sur-le-Lac","Canada","CAN","",18074],
[1728698486,"Torit","Torit","South Sudan","SSD","admin",17957],
[1804831750,"Vynnyky","Vynnyky","Ukraine","UKR","",15723],
[1484958144,"Madera","Madera","Mexico","MEX","minor",15447],
[1780508155,"Tunapuna","Tunapuna","Trinidad And Tobago","TTO","admin",17650],
[1724319564,"Gines","Gines","Spain","ESP","",13529],
[1132233840,"Porto Novo","Porto Novo","Cabo Verde","CPV","admin",18028],
[1756590980,"Prilly","Prilly","Switzerland","CHE","",12399],
[1233067368,"Viljandi","Viljandi","Estonia","EST","admin",16875],
[1084547220,"Orange Walk","Orange Walk","Belize","BLZ","admin",18000],
[1250253969,"Bois-d’Arcy","Bois-d'Arcy","France","FRA","",15220],
[1250595706,"Carrières-sur-Seine","Carrieres-sur-Seine","France","FRA","",15003],
[1031713436,"Saatlı","Saatli","Azerbaijan","AZE","admin",17900],
[1724576958,"Churriana de la Vega","Churriana de la Vega","Spain","ESP","",15741],
[1250521642,"Lucé","Luce","France","FRA","",15435],
[1840026768,"Mountain House","Mountain House","United States","USA","",17966],
[1484948651,"San Pablo Atlazalpan","San Pablo Atlazalpan","Mexico","MEX","",11236],
[1218585265,"Puerto Ayora","Puerto Ayora","Ecuador","ECU","",10999],
[1764207048,"Sa Kaeo","Sa Kaeo","Thailand","THA","admin",17864],
[1724315090,"Tabernes Blanques","Tabernes Blanques","Spain","ESP","",9205],
[1826182197,"Kidlington","Kidlington","United Kingdom","GBR","",13723],
[1484786185,"Huitzilan","Huitzilan","Mexico","MEX","minor",15096],
[1484310975,"Villa Unión","Villa Union","Mexico","MEX","",13404],
[1840041683,"Burke Centre","Burke Centre","United States","USA","",17894],
[1484885454,"Valparaíso","Valparaiso","Mexico","MEX","minor",12919],
[1276579726,"Eppelheim","Eppelheim","Germany","DEU","",15177],
[1454412462,"Dedza","Dedza","Malawi","MWI","admin",15608],
[1616658059,"Sidlice","Sidlice","Poland","POL","",12842],
[1756784451,"Thônex","Thonex","Switzerland","CHE","",14122],
[1512236141,"Khaşab","Khasab","Oman","OMN","admin",17777],
[1642287299,"Roşu","Rosu","Romania","ROU","",8020],
[1826806363,"Whitby","Whitby","United Kingdom","GBR","",13594],
[1484898373,"Juan Aldama","Juan Aldama","Mexico","MEX","minor",14162],
[1516128715,"Gobabis","Gobabis","Namibia","NAM","admin",16321],
[1840005850,"Takoma Park","Takoma Park","United States","USA","",17725],
[1840003581,"Dover","Dover","United States","USA","",17725],
[1826312183,"Swinton","Swinton","United Kingdom","GBR","",15559],
[1484783192,"Balancán","Balancan","Mexico","MEX","minor",11895],
[1008649172,"Kukës","Kukes","Albania","ALB","admin",16719],
[1764434288,"Pathum Thani","Pathum Thani","Thailand","THA","admin",13987],
[1826880341,"Harrow Weald","Harrow Weald","United Kingdom","GBR","",11376],
[1484350732,"Ezequiel Montes","Ezequiel Montes","Mexico","MEX","minor",14053],
[1724195852,"La Llagosta","La Llagosta","Spain","ESP","",13259],
[1826084160,"Tredegar","Tredegar","United Kingdom","GBR","",15103],
[1250694122,"Enghien-les-Bains","Enghien-les-Bains","France","FRA","",11285],
[1840034678,"Cedar Mill","Cedar Mill","United States","USA","",17659],
[1124990218,"Esquimalt","Esquimalt","Canada","CAN","",17655],
[1840020356,"Greenfield","Greenfield","United States","USA","",17646],
[1484533430,"Guachochi","Guachochi","Mexico","MEX","minor",14513],
[1250188744,"Valenton","Valenton","France","FRA","",14837],
[1764055292,"Tak","Tak","Thailand","THA","admin",17565],
[1276960521,"Eilendorf","Eilendorf","Germany","DEU","",15376],
[1250459927,"Lys-lès-Lannoy","Lys-les-Lannoy","France","FRA","",13471],
[1004590769,"Mehtar Lām","Mehtar Lam","Afghanistan","AFG","admin",17345],
[1031872322,"Füzuli","Fuzuli","Azerbaijan","AZE","admin",17500],
[1764291128,"Phayao","Phayao","Thailand","THA","admin",17467],
[1250525131,"Haubourdin","Haubourdin","France","FRA","",14775],
[1826221289,"Ilkley","Ilkley","United Kingdom","GBR","",14809],
[1124980214,"Deux-Montagnes","Deux-Montagnes","Canada","CAN","",17553],
[1484451722,"Miahuatlán","Miahuatlan","Mexico","MEX","minor",13159],
[1840029066,"Pinewood","Pinewood","United States","USA","",17542],
[1826436931,"Ovenden","Ovenden","United Kingdom","GBR","",12351],
[1840041770,"Kingstowne","Kingstowne","United States","USA","",17517],
[1840003541,"Dumont","Dumont","United States","USA","",17516],
[1840028979,"Country Walk","Country Walk","United States","USA","",17496],
[1484879768,"Guerrero Negro","Guerrero Negro","Mexico","MEX","",13596],
[1250757730,"Longwy","Longwy","France","FRA","",14730],
[1840003838,"Manassas Park","Manassas Park","United States","USA","",17478],
[1826133113,"Childwall","Childwall","United Kingdom","GBR","",14085],
[1840005284,"Woodmere","Woodmere","United States","USA","",17470],
[1826650494,"Shenley Church End","Shenley Church End","United Kingdom","GBR","",12961],
[1724398623,"Canet de Mar","Canet de Mar","Spain","ESP","",14810],
[1840022199,"South Houston","South Houston","United States","USA","",17438],
[1250836215,"Saint-Brice-sous-Forêt","Saint-Brice-sous-Foret","France","FRA","",14875],
[1470073144,"San Ġwann","San Gwann","Malta","MLT","admin",12523],
[1818471185,"Birqāsh","Birqash","Egypt","EGY","",14172],
[1404055253,"Marsabit","Marsabit","Kenya","KEN","admin",17127],
[1643862855,"Udelnaya","Udelnaya","Russia","RUS","",14870],
[1484875886,"San Nicolás de los Ranchos","San Nicolas de los Ranchos","Mexico","MEX","minor",11734],
[1012499058,"Illizi","Illizi","Algeria","DZA","admin",17252],
[1250308885,"Avon","Avon","France","FRA","",13662],
[1688148503,"Trstenik","Trstenik","Serbia","SRB","admin",17180],
[1620706972,"Anta","Anta","Portugal","PRT","",14800],
[1484329915,"Calkiní","Calkini","Mexico","MEX","minor",14934],
[1250689659,"Rive-de-Gier","Rive-de-Gier","France","FRA","",15105],
[1887153216,"Ma’rib","Ma'rib","Yemen","YEM","admin",16794],
[1484159343,"Vicente Guerrero","Vicente Guerrero","Mexico","MEX","",12829],
[1826735321,"Egg Buckland","Egg Buckland","United Kingdom","GBR","",13351],
[1528992603,"Leeuwarden","Leeuwarden","Netherlands","NLD","admin",17077],
[1840005307,"Massapequa Park","Massapequa Park","United States","USA","",17143],
[1840029550,"Wahiawa","Wahiawa","United States","USA","",17122],
[1484011037,"Tempoal de Sánchez","Tempoal de Sanchez","Mexico","MEX","minor",12237],
[1484112459,"Nacozari de García","Nacozari de Garcia","Mexico","MEX","minor",12987],
[1484888163,"El Parral","El Parral","Mexico","MEX","",11949],
[1840003703,"Lansdale","Lansdale","United States","USA","",17083],
[1266939354,"Makokou","Makokou","Gabon","GAB","admin",17070],
[1250089700,"Wattignies","Wattignies","France","FRA","",14736],
[1250188482,"Saint-André","Saint-Andre","France","FRA","",12966],
[1840006031,"Hybla Valley","Hybla Valley","United States","USA","",17069],
[1484468778,"Mexicaltzingo","Mexicaltzingo","Mexico","MEX","minor",10161],
[1276417573,"Neubiberg","Neubiberg","Germany","DEU","",14538],
[1404993573,"Lodwar","Lodwar","Kenya","KEN","admin",16981],
[1250211420,"Montesson","Montesson","France","FRA","",15013],
[1840029024,"Brownsville","Brownsville","United States","USA","",17051],
[1428162714,"Mārupe","Marupe","Latvia","LVA","admin",16826],
[1084924884,"San Ignacio","San Ignacio","Belize","BLZ","admin",16977],
[1826713495,"Fraserburgh","Fraserburgh","United Kingdom","GBR","",13180],
[1840000599,"East Cleveland","East Cleveland","United States","USA","",16964],
[1756486653,"Arbon","Arbon","Switzerland","CHE","",14537],
[1800042819,"Ntungamo","Ntungamo","Uganda","UGA","admin",16400],
[1250236653,"Anzin","Anzin","France","FRA","",13303],
[1840024545,"Glassmanor","Glassmanor","United States","USA","",16935],
[1076336461,"Cachoeira Alta","Cachoeira Alta","Brazil","BRA","",10553],
[1840005253,"Roosevelt","Roosevelt","United States","USA","",16899],
[1826891290,"Walsall Wood","Walsall Wood","United Kingdom","GBR","",13207],
[1764209592,"Phrae","Phrae","Thailand","THA","admin",16668],
[1840144061,"Live Oak","Live Oak","United States","USA","",16837],
[1516607376,"Keetmanshoop","Keetmanshoop","Namibia","NAM","admin",16800],
[1826850129,"Bodmin","Bodmin","United Kingdom","GBR","",14736],
[1031376971,"Astara","Astara","Azerbaijan","AZE","admin",16800],
[1440542185,"Plungė","Plunge","Lithuania","LTU","admin",16750],
[1826347383,"Streetly","Streetly","United Kingdom","GBR","",13934],
[1504839995,"Oulad Hamdane","Oulad Hamdane","Morocco","MAR","",11577],
[1826737467,"Wollaston","Wollaston","United Kingdom","GBR","",13092],
[1170291142,"Puerto Carreño","Puerto Carreno","Colombia","COL","admin",16763],
[1840007439,"Clayton","Clayton","United States","USA","",16747],
[1124580674,"L’Ancienne-Lorette","L'Ancienne-Lorette","Canada","CAN","",16745],
[1428304262,"Tukums","Tukums","Latvia","LVA","admin",16691],
[1250555797,"Ramonville-Saint-Agne","Ramonville-Saint-Agne","France","FRA","",14467],
[1807746682,"Struga","Struga","Macedonia","MKD","admin",16559],
[1724843693,"Ogíjares","Ogijares","Spain","ESP","",14559],
[1840024490,"Glenmont","Glenmont","United States","USA","",16659],
[1840006093,"Bull Run","Bull Run","United States","USA","",16651],
[1826296791,"Thorpe Saint Andrew","Thorpe Saint Andrew","United Kingdom","GBR","",14556],
[1440720895,"Kretinga","Kretinga","Lithuania","LTU","admin",16580],
[1076369423,"Elesbão Veloso","Elesbao Veloso","Brazil","BRA","",14512],
[1840018018,"Bostonia","Bostonia","United States","USA","",16603],
[1840019224,"Artesia","Artesia","United States","USA","",16601],
[1724107781,"Mollerusa","Mollerusa","Spain","ESP","",14545],
[1630035600,"Yauco","Yauco","Puerto Rico","PRI","",16585],
[1250579473,"Courcouronnes","Courcouronnes","France","FRA","",13490],
[1499673791,"Herceg Novi","Herceg Novi","Montenegro","MNE","admin",16493],
[1484665188,"Santa Cruz Amilpas","Santa Cruz Amilpas","Mexico","MEX","",12814],
[1484989109,"San Miguel Xoxtla","San Miguel Xoxtla","Mexico","MEX","",12341],
[1826156666,"Hawick","Hawick","United Kingdom","GBR","",13740],
[1840081372,"South Orange Village","South Orange Village","United States","USA","",16521],
[1616584715,"Chojnów","Chojnow","Poland","POL","",13904],
[1724914506,"Mongat","Mongat","Spain","ESP","",12260],
[1600405064,"Villa Hayes","Villa Hayes","Paraguay","PRY","admin",15643],
[1826613545,"Wolverton","Wolverton","United Kingdom","GBR","",12492],
[1826000089,"Linlithgow","Linlithgow","United Kingdom","GBR","",13260],
[1012945794,"Bordj Mokhtar","Bordj Mokhtar","Algeria","DZA","admin",16437],
[1826765618,"Broadwater","Broadwater","United Kingdom","GBR","",9373],
[1840000908,"New Milford","New Milford","United States","USA","",16429],
[1504439962,"Laaouama","Laaouama","Morocco","MAR","",8013],
[1840028742,"Ojus","Ojus","United States","USA","",16417],
[1840031482,"East Riverdale","East Riverdale","United States","USA","",16416],
[1356241630,"Janāi","Janai","India","IND","",12837],
[1380085680,"Castellanza","Castellanza","Italy","ITA","",14340],
[1040200365,"Hall in Tirol","Hall in Tirol","Austria","AUT","",13897],
[1840034722,"Four Corners","Four Corners","United States","USA","",16399],
[1764623795,"Ranong","Ranong","Thailand","THA","admin",16125],
[1826680472,"Milford Haven","Milford Haven","United Kingdom","GBR","",13725],
[1484003918,"Anenecuilco","Anenecuilco","Mexico","MEX","",11227],
[1840005957,"Hillcrest Heights","Hillcrest Heights","United States","USA","",16388],
[1233049348,"Rakvere","Rakvere","Estonia","EST","admin",14984],
[1840005944,"Adelphi","Adelphi","United States","USA","",16377],
[1710965423,"Mahikeng","Mahikeng","South Africa","ZAF","admin",15117],
[1148918270,"Moussoro","Moussoro","Chad","TCD","admin",16349],
[1484835121,"Aldama","Aldama","Mexico","MEX","minor",13661],
[1840002444,"Hazel Park","Hazel Park","United States","USA","",16347],
[1250337691,"Mouvaux","Mouvaux","France","FRA","",13173],
[1840028400,"Stanford","Stanford","United States","USA","",16326],
[1380987806,"Baranzate","Baranzate","Italy","ITA","",12003],
[1764068248,"Nakhon Nayok","Nakhon Nayok","Thailand","THA","admin",16195],
[1380926432,"Solaro","Solaro","Italy","ITA","",14163],
[1792379425,"Ardahan","Ardahan","Turkey","TUR","admin",16251],
[1012850542,"Naama","Naama","Algeria","DZA","admin",16251],
[1840028311,"East San Gabriel","East San Gabriel","United States","USA","",16256],
[1250948909,"Morangis","Morangis","France","FRA","",13453],
[1608841504,"Kabugao","Kabugao","Philippines","PHL","admin",16215],
[1266049565,"Koulamoutou","Koulamoutou","Gabon","GAB","admin",16222],
[1840074687,"Vincent","Vincent","United States","USA","",16225],
[1380710950,"Varedo","Varedo","Italy","ITA","",13446],
[1688533352,"Bačka Topola","Backa Topola","Serbia","SRB","admin",16171],
[1380840783,"Monte di Procida","Monte di Procida","Italy","ITA","",12743],
[1356004919,"Bāhāgalpur","Bahagalpur","India","IND","",11528],
[1356999062,"Muragācha","Muragacha","India","IND","",13249],
[1178867565,"Kinkala","Kinkala","Congo (Brazzaville)","COG","admin",16132],
[1826733547,"Sutton on Hull","Sutton on Hull","United Kingdom","GBR","",12649],
[1056614570,"Wezembeek-Oppem","Wezembeek-Oppem","Belgium","BEL","",14021],
[1840028361,"Cherryland","Cherryland","United States","USA","",16066],
[1250126617,"Fleury-Mérogis","Fleury-Merogis","France","FRA","",13917],
[1056363403,"Kraainem","Kraainem","Belgium","BEL","",13690],
[1826013201,"Milngavie","Milngavie","United Kingdom","GBR","",12795],
[1484659928,"Ascensión","Ascension","Mexico","MEX","minor",13456],
[1484667573,"Ángel R. Cabada","Angel R. Cabada","Mexico","MEX","minor",11689],
[1498826686,"Căuşeni","Causeni","Moldova","MDA","admin",15939],
[1250727740,"Persan","Persan","France","FRA","",13386],
[1250728330,"Fontenay-le-Fleury","Fontenay-le-Fleury","France","FRA","",13494],
[1250657845,"Auray","Auray","France","FRA","",13945],
[1826708962,"Southwick","Southwick","United Kingdom","GBR","",13195],
[1826947385,"Lye","Lye","United Kingdom","GBR","",12346],
[1440568024,"Šilutė","Silute","Lithuania","LTU","admin",15902],
[1484270020,"Villa Corzo","Villa Corzo","Mexico","MEX","minor",10841],
[1499452756,"Bijelo Polje","Bijelo Polje","Montenegro","MNE","admin",15883],
[1643453469,"Anadyr","Anadyr","Russia","RUS","admin",15604],
[1840019218,"Walnut Park","Walnut Park","United States","USA","",15896],
[1826530884,"Thatto Heath","Thatto Heath","United Kingdom","GBR","",12280],
[1626637884,"Maliana","Maliana","Timor-Leste","TLS","admin",15800],
[1554001427,"Richmond","Richmond","New Zealand","NZL","admin",15000],
[1840005286,"Floral Park","Floral Park","United States","USA","",15844],
[1484856745,"Isla Mujeres","Isla Mujeres","Mexico","MEX","minor",12491],
[1840037727,"White Center","White Center","United States","USA","",15834],
[1826285391,"Blunsdon Saint Andrew","Blunsdon Saint Andrew","United Kingdom","GBR","",12414],
[1840024628,"Parkway","Parkway","United States","USA","",15818],
[1496574715,"Altay","Altay","Mongolia","MNG","admin",15800],
[1328806426,"Bartica","Bartica","Guyana","GUY","admin",8532],
[1276656917,"Asperg","Asperg","Germany","DEU","",13480],
[1554253729,"Whakatane","Whakatane","New Zealand","NZL","admin",15795],
[1840028368,"East Rancho Dominguez","East Rancho Dominguez","United States","USA","",15792],
[1840001335,"South River","South River","United States","USA","",15779],
[1792530937,"Muş","Mus","Turkey","TUR","admin",15687],
[1764175777,"Sukhothai","Sukhothai","Thailand","THA","admin",15618],
[1484467834,"Villa Juárez","Villa Juarez","Mexico","MEX","minor",13153],
[1840024061,"Eggertsville","Eggertsville","United States","USA","",15721],
[1554341062,"Mosgiel","Mosgiel","New Zealand","NZL","",13400],
[1250068767,"Épinay-sous-Sénart","Epinay-sous-Senart","France","FRA","",12279],
[1826976360,"Hoyland Nether","Hoyland Nether","United Kingdom","GBR","",11852],
[1484260963,"Jaltenango","Jaltenango","Mexico","MEX","minor",11875],
[1840000909,"North Arlington","North Arlington","United States","USA","",15683],
[1826874548,"Giffnock","Giffnock","United Kingdom","GBR","",12300],
[1008412550,"Peshkopi","Peshkopi","Albania","ALB","admin",13251],
[1504459578,"Targuist","Targuist","Morocco","MAR","",13390],
[1792742754,"Erzincan","Erzincan","Turkey","TUR","admin",15591],
[1800749650,"Kiboga","Kiboga","Uganda","UGA","admin",14512],
[1840020419,"McFarland","McFarland","United States","USA","",15651],
[1840029063,"Palmetto Estates","Palmetto Estates","United States","USA","",15640],
[1764844835,"Uthai Thani","Uthai Thani","Thailand","THA","admin",15434],
[1840020323,"Parlier","Parlier","United States","USA","",15618],
[1250300713,"Vaires-sur-Marne","Vaires-sur-Marne","France","FRA","",13383],
[1498114952,"Edineţ","Edinet","Moldova","MDA","admin",15520],
[1840022205,"West University Place","West University Place","United States","USA","",15585],
[1484407989,"Nuevo Ideal","Nuevo Ideal","Mexico","MEX","minor",12850],
[1440868798,"Palanga","Palanga","Lithuania","LTU","admin",15381],
[1484499776,"San Patricio","San Patricio","Mexico","MEX","",7569],
[1484003997,"San Isidro Buen Suceso","San Isidro Buen Suceso","Mexico","MEX","",7688],
[1484590798,"Saucillo","Saucillo","Mexico","MEX","minor",11004],
[1788658832,"Seïada","Seiada","Tunisia","TUN","",12708],
[1724655094,"Sedaví","Sedavi","Spain","ESP","",10344],
[1470230507,"Tarxien","Tarxien","Malta","MLT","admin",8583],
[1250010206,"Voisins-le-Bretonneux","Voisins-le-Bretonneux","France","FRA","",10921],
[1250815243,"Arpajon","Arpajon","France","FRA","",10920],
[1484628971,"Santa María Jalapa del Marqués","Santa Maria Jalapa del Marques","Mexico","MEX","minor",13148],
[1764769560,"Phra Samut Chedi","Phra Samut Chedi","Thailand","THA","minor",13082],
[1484790302,"La Magdalena Chichicaspa","La Magdalena Chichicaspa","Mexico","MEX","",12193],
[1756270644,"Schwyz","Schwyz","Switzerland","CHE","admin",15181],
[1031160110,"Kürdəmir","Kurdamir","Azerbaijan","AZE","admin",15385],
[1826007490,"Blundellsands","Blundellsands","United Kingdom","GBR","",11514],
[1356146343,"Chandi","Chandi","India","IND","",13332],
[1484649015,"Rayón","Rayon","Mexico","MEX","minor",8590],
[1840020586,"La Palma","La Palma","United States","USA","",15428],
[1826235843,"Earlestown","Earlestown","United Kingdom","GBR","",10830],
[1826731920,"Snaresbrook","Snaresbrook","United Kingdom","GBR","",11868],
[1840028318,"Avocado Heights","Avocado Heights","United States","USA","",15426],
[1756611497,"La Tour-de-Peilz","La Tour-de-Peilz","Switzerland","CHE","",11829],
[1496245822,"Dzuunmod","Dzuunmod","Mongolia","MNG","admin",14660],
[1484950387,"El Fuerte","El Fuerte","Mexico","MEX","minor",12566],
[1840020359,"Pacific Grove","Pacific Grove","United States","USA","",15413],
[1840003684,"Asbury Park","Asbury Park","United States","USA","",15408],
[1705864078,"Kamnik","Kamnik","Slovenia","SVN","admin",13880],
[1250635282,"Billère","Billere","France","FRA","",12628],
[1484014263,"Cadereyta","Cadereyta","Mexico","MEX","minor",13347],
[1250606222,"Saint-Max","Saint-Max","France","FRA","",9984],
[1840005232,"Bellmore","Bellmore","United States","USA","",15368],
[1840002437,"Berkley","Berkley","United States","USA","",15366],
[1484964628,"Santa María Huazolotitlán","Santa Maria Huazolotitlan","Mexico","MEX","minor",11400],
[1188252548,"Santa Ana","Santa Ana","Costa Rica","CRI","",12956],
[1840005332,"Westbury","Westbury","United States","USA","",15351],
[1840011255,"La Grange","La Grange","United States","USA","",15322],
[1404000001,"Namanga","Namanga","Kenya","KEN","",13193],
[1356407230,"Saktipur","Saktipur","India","IND","",13123],
[1440712589,"Radviliškis","Radviliskis","Lithuania","LTU","admin",15275],
[1840001278,"Wilkinsburg","Wilkinsburg","United States","USA","",15292],
[1792862455,"Yozgat","Yozgat","Turkey","TUR","admin",15235],
[1504146532,"Bou Fekrane","Bou Fekrane","Morocco","MAR","",12941],
[1840005409,"Fords","Fords","United States","USA","",15250],
[1484002576,"Santa Ana","Santa Ana","Mexico","MEX","minor",12372],
[1840005276,"South Farmingdale","South Farmingdale","United States","USA","",15229],
[1826119514,"Parkstone","Parkstone","United Kingdom","GBR","",10779],
[1418524729,"Phôngsali","Phongsali","Laos","LAO","admin",15083],
[1380689845,"Calvizzano","Calvizzano","Italy","ITA","",12182],
[1036474450,"Campbelltown","Campbelltown","Australia","AUS","",12566],
[1484096349,"Las Veredas","Las Veredas","Mexico","MEX","",10478],
[1756371637,"Liestal","Liestal","Switzerland","CHE","admin",14390],
[1484508510,"Escuintla","Escuintla","Mexico","MEX","minor",10624],
[1756147685,"Chêne-Bougeries","Chene-Bougeries","Switzerland","CHE","",12215],
[1064216277,"Paro","Paro","Bhutan","BTN","admin",15000],
[1826263534,"Cromer","Cromer","United Kingdom","GBR","",12457],
[1826944275,"Hollington","Hollington","United Kingdom","GBR","",6099],
[1250069787,"Montévrain","Montevrain","France","FRA","",12764],
[1858652953,"Libertad","Libertad","Uruguay","URY","",11458],
[1426618526,"Quthing","Quthing","Lesotho","LSO","admin",15000],
[1840016002,"West Park","West Park","United States","USA","",15089],
[1466444510,"Kidal","Kidal","Mali","MLI","admin",15086],
[1840005243,"North New Hyde Park","North New Hyde Park","United States","USA","",15080],
[1484603562,"Dzitbalché","Dzitbalche","Mexico","MEX","",11686],
[1716612305,"Gwanda","Gwanda","Zimbabwe","ZWE","admin",14450],
[1484151830,"San Pedro Jicayán","San Pedro Jicayan","Mexico","MEX","minor",12387],
[1031126416,"Masallı","Masalli","Azerbaijan","AZE","admin",14746],
[1840005275,"Seaford","Seaford","United States","USA","",15040],
[1004988038,"Fayrōz Kōh","Fayroz Koh","Afghanistan","AFG","admin",15000],
[1840004386,"Kenmore","Kenmore","United States","USA","",15020],
[1036263278,"Leopold","Leopold","Australia","AUS","",12814],
[1826782144,"Woolton","Woolton","United Kingdom","GBR","",12921],
[1020008674,"Escaldes-Engordany","Escaldes-Engordany","Andorra","AND","admin",14521],
[1626835210,"Baucau","Baucau","Timor-Leste","TLS","admin",14961],
[1800419144,"Sironko","Sironko","Uganda","UGA","admin",14100],
[1840039242,"Ocean Pointe","Ocean Pointe","United States","USA","",14989],
[1324863095,"Forécariah","Forecariah","Guinea","GIN","minor",12358],
[1724497090,"Huétor Vega","Huetor Vega","Spain","ESP","",12120],
[1380642269,"Canegrate","Canegrate","Italy","ITA","",12574],
[1356237076,"Bhabānipur","Bhabanipur","India","IND","",11465],
[1356134351,"Bandlagūda","Bandlaguda","India","IND","",12734],
[1756885352,"Le Grand-Saconnex","Le Grand-Saconnex","Switzerland","CHE","",12162],
[1428840269,"Cēsis","Cesis","Latvia","LVA","admin",14815],
[1840014261,"Newport","Newport","United States","USA","",14932],
[1484175446,"Altamirano","Altamirano","Mexico","MEX","minor",9200],
[1826504633,"Sandridge","Sandridge","United Kingdom","GBR","",11451],
[1356787471,"Begampur","Begampur","India","IND","",12742],
[1705471403,"Jesenice","Jesenice","Slovenia","SVN","admin",13338],
[1826362404,"Abergavenny","Abergavenny","United Kingdom","GBR","",12515],
[1504965368,"El Menzel","El Menzel","Morocco","MAR","",12641],
[1826909482,"Warsop","Warsop","United Kingdom","GBR","",11999],
[1268276279,"Ozurgeti","Ozurgeti","Georgia","GEO","admin",14785],
[1840005239,"New Cassel","New Cassel","United States","USA","",14867],
[1826142319,"Gourock","Gourock","United Kingdom","GBR","",10350],
[1484573116,"Chiautla de Tapia","Chiautla de Tapia","Mexico","MEX","",11776],
[1262504958,"Tadjourah","Tadjourah","Djibouti","DJI","admin",14820],
[1484516715,"Tierra Colorada","Tierra Colorada","Mexico","MEX","minor",10502],
[1826092519,"Forres","Forres","United Kingdom","GBR","",10100],
[1040751740,"Eisenstadt","Eisenstadt","Austria","AUT","admin",14476],
[1504480318,"Oulad Ayyad","Oulad Ayyad","Morocco","MAR","",9566],
[1484796365,"Villa Unión","Villa Union","Mexico","MEX","minor",10753],
[1548569362,"Luganville","Luganville","Vanuatu","VUT","admin",13397],
[1756630924,"Rorschach","Rorschach","Switzerland","CHE","minor",9439],
[1840075922,"Lemon Hill","Lemon Hill","United States","USA","",14733],
[1840005842,"Kemp Mill","Kemp Mill","United States","USA","",14733],
[1250507061,"Saint-André-les-Vergers","Saint-Andre-les-Vergers","France","FRA","",12581],
[1496719699,"Öndörhaan","Ondorhaan","Mongolia","MNG","admin",14723],
[1807621851,"Debar","Debar","Macedonia","MKD","admin",14561],
[1484032951,"Sonoita","Sonoita","Mexico","MEX","minor",11440],
[1300868556,"Lykóvrysi","Lykovrysi","Greece","GRC","",9738],
[1484104363,"Progreso","Progreso","Mexico","MEX","",12557],
[1724369007,"Berriozar","Berriozar","Spain","ESP","",10723],
[1144358863,"Hambantota","Hambantota","Sri Lanka","LKA","",11213],
[1840000313,"Pierre","Pierre","United States","USA","admin",14659],
[1012827195,"Djanet","Djanet","Algeria","DZA","admin",14655],
[1380356399,"Biassono","Biassono","Italy","ITA","",12164],
[1484052886,"Maxcanú","Maxcanu","Mexico","MEX","minor",12621],
[1826675845,"Abertillery","Abertillery","United Kingdom","GBR","",11601],
[1800685460,"Kisoro","Kisoro","Uganda","UGA","admin",12900],
[1051802790,"Nor Hachn","Nor Hachn","Armenia","ARM","",10198],
[1484309288,"Coacoatzintla","Coacoatzintla","Mexico","MEX","minor",10482],
[1840003835,"Falls Church","Falls Church","United States","USA","",14617],
[1608255342,"Magugpo Poblacion","Magugpo Poblacion","Philippines","PHL","",6726],
[1840081754,"Weehawken","Weehawken","United States","USA","",14604],
[1826068717,"Trentham","Trentham","United Kingdom","GBR","",11836],
[1470470220,"Naxxar","Naxxar","Malta","MLT","admin",13443],
[1032010904,"Malvinas Argentinas","Malvinas Argentinas","Argentina","ARG","",12187],
[1270820759,"Basse Santa Su","Basse Santa Su","The Gambia","GMB","admin",14380],
[1124637966,"Pincourt","Pincourt","Canada","CAN","",14558],
[1250001537,"Stiring-Wendel","Stiring-Wendel","France","FRA","",11385],
[1496627655,"Baruun-Urt","Baruun-Urt","Mongolia","MNG","admin",14297],
[1840081686,"Haddon","Haddon","United States","USA","",14539],
[1504782261,"Ar Rommani","Ar Rommani","Morocco","MAR","",12297],
[1388024275,"Port Antonio","Port Antonio","Jamaica","JAM","admin",14400],
[1356179828,"Amtala","Amtala","India","IND","",8765],
[1484692677,"Muna","Muna","Mexico","MEX","",11469],
[1840029470,"Ewa Beach","Ewa Beach","United States","USA","",14479],
[1624988048,"Gabú","Gabu","Guinea-Bissau","GNB","admin",14430],
[1826799363,"Carnoustie","Carnoustie","United Kingdom","GBR","",11360],
[1826868989,"Tonyrefail","Tonyrefail","United Kingdom","GBR","",12301],
[1484919654,"Cuencamé de Ceniceros","Cuencame de Ceniceros","Mexico","MEX","minor",8876],
[1428703594,"Sigulda","Sigulda","Latvia","LVA","admin",14396],
[1826515115,"Brislington","Brislington","United Kingdom","GBR","",11511],
[1840029579,"Halawa","Halawa","United States","USA","",14453],
[1031822434,"Ucar","Ucar","Azerbaijan","AZE","admin",14273],
[1484035396,"Lerma","Lerma","Mexico","MEX","",8281],
[1250007037,"Hœnheim","Hoenheim","France","FRA","",11145],
[1756780364,"Birsfelden","Birsfelden","Switzerland","CHE","",10299],
[1470808916,"Marsaskala","Marsaskala","Malta","MLT","admin",12134],
[1840028325,"North Fair Oaks","North Fair Oaks","United States","USA","",14372],
[1630035640,"Cayey","Cayey","Puerto Rico","PRI","",14347],
[1792866362,"Kilis","Kilis","Turkey","TUR","admin",14150],
[1031299249,"Neftçala","Neftcala","Azerbaijan","AZE","admin",14241],
[1031059559,"Qusar","Qusar","Azerbaijan","AZE","admin",14230],
[1756439374,"Villars-sur-Glâne","Villars-sur-Glane","Switzerland","CHE","",12092],
[1300050699,"Zefýri","Zefyri","Greece","GRC","",9454],
[1840041868,"Stone Ridge","Stone Ridge","United States","USA","",14220],
[1826442570,"Oakham","Oakham","United Kingdom","GBR","",10975],
[1764574957,"Ban Bang Sai","Ban Bang Sai","Thailand","THA","",12136],
[1840003549,"Fairview","Fairview","United States","USA","",14189],
[1356592217,"Velivennu","Velivennu","India","IND","",12018],
[1231215294,"Negēlē","Negele","Ethiopia","ETH","",11772],
[1484221814,"Canatlán","Canatlan","Mexico","MEX","minor",10342],
[1840020485,"Hawaiian Gardens","Hawaiian Gardens","United States","USA","",14159],
[1840011302,"Norridge","Norridge","United States","USA","",14152],
[1484497758,"San Pedro Ixcatlán","San Pedro Ixcatlan","Mexico","MEX","",11653],
[1840000549,"Willowick","Willowick","United States","USA","",14105],
[1276781907,"Kronshagen","Kronshagen","Germany","DEU","",11869],
[1688303533,"Sjenica","Sjenica","Serbia","SRB","admin",14060],
[1826495708,"Bishopstoke","Bishopstoke","United Kingdom","GBR","",9974],
[1356059388,"Begampur","Begampur","India","IND","",10487],
[1250968732,"Ville-d’Avray","Ville-d'Avray","France","FRA","",11050],
[1840029588,"Waimalu","Waimalu","United States","USA","",14043],
[1268352935,"Akhaltsikhe","Akhaltsikhe","Georgia","GEO","admin",14000],
[1894041491,"Chinsali","Chinsali","Zambia","ZMB","admin",14015],
[1826981453,"Kippax","Kippax","United Kingdom","GBR","",9785],
[1724442328,"Nazaret","Nazaret","Spain","ESP","",6117],
[1499733751,"Cetinje","Cetinje","Montenegro","MNE","admin",13991],
[1250438803,"Talant","Talant","France","FRA","",11630],
[1484016340,"San José el Viejo","San Jose el Viejo","Mexico","MEX","",7222],
[1826951829,"Ryhope","Ryhope","United Kingdom","GBR","",10484],
[1356809062,"Kalinagar","Kalinagar","India","IND","",11358],
[1380676054,"San Gregorio di Catania","San Gregorio di Catania","Italy","ITA","",11880],
[1356961923,"Natshal","Natshal","India","IND","",11331],
[1840039889,"Franklin Park","Franklin Park","United States","USA","",13977],
[1840014247,"Olympia Heights","Olympia Heights","United States","USA","",13958],
[1340964186,"Nacaome","Nacaome","Honduras","HND","admin",13931],
[1398370030,"Koktobe","Koktobe","Kazakhstan","KAZ","",7989],
[1356876532,"Chaital","Chaital","India","IND","",11927],
[1233341219,"Kuressaare","Kuressaare","Estonia","EST","admin",13097],
[1484867357,"Etchojoa","Etchojoa","Mexico","MEX","minor",9831],
[1840010146,"Chicago Ridge","Chicago Ridge","United States","USA","",13928],
[1826962627,"Glascote","Glascote","United Kingdom","GBR","",8344],
[1826937694,"Larbert","Larbert","United Kingdom","GBR","",11050],
[1484835501,"González","Gonzalez","Mexico","MEX","minor",11212],
[1818375380,"Dishāshah","Dishashah","Egypt","EGY","",11844],
[1840016611,"Collingswood","Collingswood","United States","USA","",13884],
[1484244113,"Villanueva","Villanueva","Mexico","MEX","minor",11138],
[1499247875,"Plav","Plav","Montenegro","MNE","admin",13805],
[1818557641,"Mīt Damsīs","Mit Damsis","Egypt","EGY","",11528],
[1388256334,"Saint Ann’s Bay","Saint Ann's Bay","Jamaica","JAM","admin",13671],
[1840003036,"Whitefish Bay","Whitefish Bay","United States","USA","",13783],
[1484515773,"Akil","Akil","Mexico","MEX","",10176],
[1250228408,"Déville-lès-Rouen","Deville-les-Rouen","France","FRA","",10461],
[1840003759,"Bexley","Bexley","United States","USA","",13770],
[1484748421,"San Luis de La Loma","San Luis de La Loma","Mexico","MEX","",11090],
[1840003981,"Harper Woods","Harper Woods","United States","USA","",13746],
[1499197266,"Bar","Bar","Montenegro","MNE","admin",13719],
[1840033474,"Princeton Meadows","Princeton Meadows","United States","USA","",13717],
[1800429770,"Kumi","Kumi","Uganda","UGA","admin",13000],
[1826216570,"Lemington","Lemington","United Kingdom","GBR","",10228],
[1840003636,"Highland Park","Highland Park","United States","USA","",13711],
[1031405942,"Tovuz","Tovuz","Azerbaijan","AZE","admin",13700],
[1840011276,"Forest Park","Forest Park","United States","USA","",13704],
[1826580742,"Henley on Thames","Henley on Thames","United Kingdom","GBR","",11619],
[1764529940,"Ang Thong","Ang Thong","Thailand","THA","admin",13277],
[1250210383,"Épinay-sur-Orge","Epinay-sur-Orge","France","FRA","",11160],
[1484534707,"Chichihualco","Chichihualco","Mexico","MEX","minor",10079],
[1462186620,"Naifaru","Naifaru","Maldives","MDV","admin",0],
[1826700583,"Tavistock","Tavistock","United Kingdom","GBR","",11018],
[1804281966,"Hirnyk","Hirnyk","Ukraine","UKR","",11378],
[1840001093,"Roselle Park","Roselle Park","United States","USA","",13588],
[1826085922,"Horsell","Horsell","United Kingdom","GBR","",9384],
[1470395922,"Imsida","Imsida","Malta","MLT","admin",8545],
[1250337164,"Craponne","Craponne","France","FRA","",11125],
[1704949870,"Đà Nẵng","Da Nang","Vietnam","VNM","admin",0],
[1250530247,"Dugny","Dugny","France","FRA","",10757],
[1504858254,"Boudenib","Boudenib","Morocco","MAR","",11373],
[1826018401,"Buckhurst Hill","Buckhurst Hill","United Kingdom","GBR","",11380],
[1558170572,"San Carlos","San Carlos","Nicaragua","NIC","admin",13451],
[1792497865,"Sinop","Sinop","Turkey","TUR","admin",13354],
[1250295985,"Beaumont","Beaumont","France","FRA","",10793],
[1826096263,"Newport","Newport","United Kingdom","GBR","",11387],
[1356600666,"Dhāmua","Dhamua","India","IND","",10055],
[1840020414,"Grover Beach","Grover Beach","United States","USA","",13459],
[1250640842,"Ormesson-sur-Marne","Ormesson-sur-Marne","France","FRA","",10403],
[1250129620,"Chanteloup-les-Vignes","Chanteloup-les-Vignes","France","FRA","",10341],
[1056061898,"Hemiksem","Hemiksem","Belgium","BEL","",11368],
[1484343325,"Tetela del Volcán","Tetela del Volcan","Mexico","MEX","minor",10199],
[1826556120,"Cupar","Cupar","United Kingdom","GBR","",9020],
[1484193492,"Platón Sánchez","Platon Sanchez","Mexico","MEX","minor",10009],
[1056005961,"Borsbeek","Borsbeek","Belgium","BEL","",10685],
[1250642232,"Maromme","Maromme","France","FRA","",10730],
[1148095016,"Faya","Faya","Chad","TCD","admin",13400],
[1454451365,"Mwanza","Mwanza","Malawi","MWI","admin",11379],
[1705822721,"Domžale","Domzale","Slovenia","SVN","admin",13204],
[1826813563,"Stranraer","Stranraer","United Kingdom","GBR","",10320],
[1470739045,"Gżira","Gzira","Malta","MLT","admin",8029],
[1840003543,"Edgewater","Edgewater","United States","USA","",13364],
[1484306905,"Tixkokob","Tixkokob","Mexico","MEX","",10968],
[1826725161,"Longbenton","Longbenton","United Kingdom","GBR","",10617],
[1036501460,"Corinda","Corinda","Australia","AUS","",11019],
[1792825471,"Kırşehir","Kirsehir","Turkey","TUR","admin",13271],
[1484170180,"Acanceh","Acanceh","Mexico","MEX","minor",10968],
[1840006030,"Huntington","Huntington","United States","USA","",13334],
[1470279940,"Swieqi","Swieqi","Malta","MLT","admin",10064],
[1516582394,"Mariental","Mariental","Namibia","NAM","admin",12478],
[1498968635,"Drochia","Drochia","Moldova","MDA","admin",13150],
[1470473600,"Żebbuġ","Zebbug","Malta","MLT","admin",11903],
[1250090128,"Montigny-en-Gohelle","Montigny-en-Gohelle","France","FRA","",10315],
[1756748908,"Delémont","Delemont","Switzerland","CHE","admin",12682],
[1724153449,"Meliana","Meliana","Spain","ESP","",10926],
[1756961965,"Männedorf","Mannedorf","Switzerland","CHE","",10957],
[1740480869,"Nieuw Nickerie","Nieuw Nickerie","Suriname","SUR","admin",12818],
[1484044014,"Pajacuarán","Pajacuaran","Mexico","MEX","minor",10014],
[1646264461,"Kibuye","Kibuye","Rwanda","RWA","admin",12325],
[1484934308,"Tacotalpa","Tacotalpa","Mexico","MEX","minor",8071],
[1840011256,"La Grange Park","La Grange Park","United States","USA","",13178],
[1591037947,"Bocas del Toro","Bocas del Toro","Panama","PAN","admin",12996],
[1840003031,"Shorewood","Shorewood","United States","USA","",13145],
[1250407896,"Jarville-la-Malgrange","Jarville-la-Malgrange","France","FRA","",9312],
[1484235510,"San Ignacio Cohuirimpo","San Ignacio Cohuirimpo","Mexico","MEX","",10606],
[1826733076,"Wilnecote","Wilnecote","United Kingdom","GBR","",9358],
[1826552358,"Inverurie","Inverurie","United Kingdom","GBR","",10885],
[1484012996,"Cuatro Ciénegas de Carranza","Cuatro Cienegas de Carranza","Mexico","MEX","minor",10395],
[1484053518,"San Juanito","San Juanito","Mexico","MEX","",10535],
[1276335395,"Steinbach am Taunus","Steinbach am Taunus","Germany","DEU","",10682],
[1484925669,"Candelaria","Candelaria","Mexico","MEX","minor",9812],
[1705939355,"Nova Gorica","Nova Gorica","Slovenia","SVN","admin",13031],
[1840001424,"Coatesville","Coatesville","United States","USA","",13069],
[1470320205,"Żejtun","Zejtun","Malta","MLT","admin",11508],
[1380485604,"Capodrise","Capodrise","Italy","ITA","",10133],
[1826464470,"Hellesdon","Hellesdon","United Kingdom","GBR","",10957],
[1826492540,"Broadstone","Broadstone","United Kingdom","GBR","",10303],
[1250623470,"Crosne","Crosne","France","FRA","",9285],
[1250388590,"Gaillard","Gaillard","France","FRA","",10419],
[1826315331,"Roby","Roby","United Kingdom","GBR","",7254],
[1578642047,"Steinkjer","Steinkjer","Norway","NOR","admin",12985],
[1484368402,"Tlahualilo de Zaragoza","Tlahualilo de Zaragoza","Mexico","MEX","minor",9517],
[1840024510,"Sugarland Run","Sugarland Run","United States","USA","",12956],
[1826470405,"Nairn","Nairn","United Kingdom","GBR","",9960],
[1840005978,"New Carrollton","New Carrollton","United States","USA","",12928],
[1300684253,"Psychikó","Psychiko","Greece","GRC","minor",9529],
[1380684124,"Procida","Procida","Italy","ITA","",10465],
[1250684300,"Caudebec-lès-Elbeuf","Caudebec-les-Elbeuf","France","FRA","",10156],
[1233406308,"Valga","Valga","Estonia","EST","admin",12182],
[1498897259,"Ialoveni","Ialoveni","Moldova","MDA","admin",12515],
[1840000898,"Ridgefield Park","Ridgefield Park","United States","USA","",12901],
[1140533897,"Obo","Obo","Central African Republic","CAF","admin",12887],
[1598923764,"Daru","Daru","Papua New Guinea","PNG","admin",12879],
[1764104264,"Lamphun","Lamphun","Thailand","THA","admin",12595],
[1854052758,"Ziniaré","Ziniare","Burkina Faso","BFA","admin",12703],
[1826269195,"Ifield","Ifield","United Kingdom","GBR","",8882],
[1840018333,"Key Biscayne","Key Biscayne","United States","USA","",12846],
[1356171822,"Multi","Multi","India","IND","",10215],
[1840028425,"Federal Heights","Federal Heights","United States","USA","",12827],
[1470983296,"Santa Venera","Santa Venera","Malta","MLT","admin",6932],
[1840018557,"Cornelius","Cornelius","United States","USA","",12822],
[1840000756,"Kingston","Kingston","United States","USA","",12812],
[1840005455,"Ardmore","Ardmore","United States","USA","",12808],
[1840003416,"University Heights","University Heights","United States","USA","",12797],
[1250048167,"Pierre-Bénite","Pierre-Benite","France","FRA","",10461],
[1826157369,"Amesbury","Amesbury","United Kingdom","GBR","",10724],
[1484036948,"Cuapiaxtla de Madero","Cuapiaxtla de Madero","Mexico","MEX","minor",10101],
[1840016004,"Wilton Manors","Wilton Manors","United States","USA","",12756],
[1620413494,"Valadares","Valadares","Portugal","PRT","",10678],
[1440918695,"Rokiškis","Rokiskis","Lithuania","LTU","admin",12738],
[1076675429,"Lagamar","Lagamar","Brazil","BRA","",7600],
[1826191797,"Utley","Utley","United Kingdom","GBR","",5500],
[1818306172,"Aţ Ţūr","At Tur","Egypt","EGY","admin",12733],
[1764848732,"Chai Nat","Chai Nat","Thailand","THA","admin",12541],
[1356602192,"Chāndpur","Chandpur","India","IND","",9066],
[1826301318,"Helston","Helston","United Kingdom","GBR","",9780],
[1356064505,"Sāhāpur","Sahapur","India","IND","",9022],
[1826650581,"Aberbargoed","Aberbargoed","United Kingdom","GBR","",9184],
[1630023562,"Manatí","Manati","Puerto Rico","PRI","",12683],
[1826999025,"Choppington","Choppington","United Kingdom","GBR","",9787],
[1031622673,"Tərtər","Tartar","Azerbaijan","AZE","admin",12563],
[1484516323,"Ciudad Tula","Ciudad Tula","Mexico","MEX","minor",10043],
[1840014776,"Clarkston","Clarkston","United States","USA","",12637],
[1826198624,"Allington","Allington","United Kingdom","GBR","",7100],
[1250334937,"Tinqueux","Tinqueux","France","FRA","",10154],
[1470707733,"San Ġiljan","San Giljan","Malta","MLT","admin",7752],
[1498402212,"Hînceşti","Hincesti","Moldova","MDA","admin",12491],
[1470765022,"Attard","Attard","Malta","MLT","admin",10930],
[1840017259,"Lantana","Lantana","United States","USA","",12581],
[1826155857,"Chapeltown","Chapeltown","United Kingdom","GBR","",10043],
[1826482164,"Shenfield","Shenfield","United Kingdom","GBR","",10511],
[1858193401,"Nueva Palmira","Nueva Palmira","Uruguay","URY","",9857],
[1498521430,"Sîngerei","Singerei","Moldova","MDA","admin",12465],
[1031031472,"Culfa","Culfa","Azerbaijan","AZE","admin",12500],
[1250000653,"L’Île-Saint-Denis","L'Ile-Saint-Denis","France","FRA","",8012],
[1484273364,"San Ignacio Río Muerto","San Ignacio Rio Muerto","Mexico","MEX","minor",8435],
[1818001516,"Qufādah","Qufadah","Egypt","EGY","",9948],
[1484878072,"Tlalixtac de Cabrera","Tlalixtac de Cabrera","Mexico","MEX","minor",10208],
[1250971017,"Avranches","Avranches","France","FRA","minor",10246],
[1380943524,"San Marzano sul Sarno","San Marzano sul Sarno","Italy","ITA","",10499],
[1484592594,"Teotlaltzingo","Teotlaltzingo","Mexico","MEX","",10456],
[1840004938,"Pelham","Pelham","United States","USA","",12510],
[1020417470,"Encamp","Encamp","Andorra","AND","admin",12338],
[1840028588,"Cherry Creek","Cherry Creek","United States","USA","",12496],
[1630023701,"Río Grande","Rio Grande","Puerto Rico","PRI","",12492],
[1250399592,"Marquette-lès-Lille","Marquette-les-Lille","France","FRA","",10354],
[1496317433,"Bulgan","Bulgan","Mongolia","MNG","admin",12323],
[1826158363,"Dunbar","Dunbar","United Kingdom","GBR","",9030],
[1250023015,"Fosses","Fosses","France","FRA","",9737],
[1484057992,"San Gregorio Atzompa","San Gregorio Atzompa","Mexico","MEX","minor",9671],
[1498129687,"Taraclia","Taraclia","Moldova","MDA","admin",12355],
[1218873167,"Zamora","Zamora","Ecuador","ECU","admin",12386],
[1826340559,"Warfield","Warfield","United Kingdom","GBR","",10088],
[1756002124,"Chavannes-près-Renens","Chavannes-pres-Renens","Switzerland","CHE","",7724],
[1250762354,"Croissy-sur-Seine","Croissy-sur-Seine","France","FRA","",9602],
[1484106283,"Anáhuac","Anahuac","Mexico","MEX","",9952],
[1233754374,"Võru","Voru","Estonia","EST","admin",11533],
[1031681050,"Beyləqan","Beylaqan","Azerbaijan","AZE","admin",12263],
[1840018518,"Minnehaha","Minnehaha","United States","USA","",12353],
[1380979874,"Cesa","Cesa","Italy","ITA","",9039],
[1826730292,"Glenfield","Glenfield","United Kingdom","GBR","",9643],
[1840005129,"Patchogue","Patchogue","United States","USA","",12321],
[1484819687,"Celestún","Celestun","Mexico","MEX","minor",8389],
[1591472114,"Las Tablas","Las Tablas","Panama","PAN","admin",11358],
[1840034830,"Oak Hills","Oak Hills","United States","USA","",12308],
[1826146185,"Broughton Astley","Broughton Astley","United Kingdom","GBR","",8940],
[1788472866,"Khunays","Khunays","Tunisia","TUN","",10000],
[1300072209,"Ermoúpoli","Ermoupoli","Greece","GRC","admin",12260],
[1250423219,"Igny","Igny","France","FRA","",9744],
[1356436848,"Amgachia","Amgachia","India","IND","",10179],
[1826652073,"Greenhill","Greenhill","United Kingdom","GBR","",7339],
[1484683104,"Amatlán de los Reyes","Amatlan de los Reyes","Mexico","MEX","minor",9123],
[1484154416,"Xicoténcatl","Xicotencatl","Mexico","MEX","minor",9593],
[1484892055,"Rafael Lucio","Rafael Lucio","Mexico","MEX","minor",8068],
[1004016690,"Qalāt","Qalat","Afghanistan","AFG","admin",12191],
[1484351882,"Tekit","Tekit","Mexico","MEX","",9834],
[1417022726,"Batken","Batken","Kyrgyzstan","KGZ","admin",12134],
[1132845019,"Assomada","Assomada","Cabo Verde","CPV","admin",12026],
[1484806011,"Choix","Choix","Mexico","MEX","minor",9306],
[1250623453,"Sallaumines","Sallaumines","France","FRA","",9654],
[1840005242,"North Merrick","North Merrick","United States","USA","",12170],
[1826177889,"Cove","Cove","United Kingdom","GBR","",6548],
[1250212542,"Eybens","Eybens","France","FRA","",9947],
[1840017987,"Home Gardens","Home Gardens","United States","USA","",12153],
[1498180648,"Făleşti","Falesti","Moldova","MDA","admin",12074],
[1250261839,"Neuville-lès-Dieppe","Neuville-les-Dieppe","France","FRA","",9616],
[1840005255,"Salisbury","Salisbury","United States","USA","",12133],
[1356556732,"Laskarpar","Laskarpar","India","IND","",8489],
[1454008976,"Ntcheu","Ntcheu","Malawi","MWI","admin",10445],
[1484877569,"Tzucacab","Tzucacab","Mexico","MEX","",9967],
[1858852364,"Chuy","Chuy","Uruguay","URY","",9675],
[1756844616,"Massagno","Massagno","Switzerland","CHE","",6227],
[1826448406,"South Normanton","South Normanton","United Kingdom","GBR","",9445],
[1826765912,"Kilsyth","Kilsyth","United Kingdom","GBR","",10080],
[1826950028,"Saint Peters","Saint Peters","United Kingdom","GBR","",7042],
[1440489111,"Druskininkai","Druskininkai","Lithuania","LTU","admin",12055],
[1498297203,"Floreşti","Floresti","Moldova","MDA","admin",11998],
[1705476087,"Izola","Izola","Slovenia","SVN","admin",11682],
[1840020291,"Emeryville","Emeryville","United States","USA","",12086],
[1498766980,"Cimişlia","Cimislia","Moldova","MDA","admin",11997],
[1826085165,"Great Billing","Great Billing","United Kingdom","GBR","",8457],
[1380222168,"Portico di Caserta","Portico di Caserta","Italy","ITA","",7903],
[1642541459,"Modelu","Modelu","Romania","ROU","",7564],
[1430885010,"Robertsport","Robertsport","Liberia","LBR","admin",11969],
[1024121799,"Dundo","Dundo","Angola","AGO","admin",11985],
[1840003558,"Hasbrouck Heights","Hasbrouck Heights","United States","USA","",11992],
[1250107634,"Bougival","Bougival","France","FRA","",8795],
[1356113263,"Nimpot","Nimpot","India","IND","",8014],
[1826143891,"Shephall","Shephall","United Kingdom","GBR","",6210],
[1840001358,"Red Bank","Red Bank","United States","USA","",11966],
[1250921305,"Ferney-Voltaire","Ferney-Voltaire","France","FRA","",9895],
[1826029798,"Boxley","Boxley","United Kingdom","GBR","",9554],
[1826387928,"Gedling","Gedling","United Kingdom","GBR","",6817],
[1484959001,"Coahuitlán","Coahuitlan","Mexico","MEX","",8566],
[1470262687,"Rabat","Rabat","Malta","MLT","admin",11497],
[1840016006,"South Miami","South Miami","United States","USA","",11911],
[1705129726,"Murska Sobota","Murska Sobota","Slovenia","SVN","admin",11107],
[1356085339,"Hārua","Harua","India","IND","",9012],
[1756016282,"Widnau","Widnau","Switzerland","CHE","",9616],
[1250501258,"Bures-sur-Yvette","Bures-sur-Yvette","France","FRA","",9577],
[1470331348,"Żurrieq","Zurrieq","Malta","MLT","admin",10823],
[1826338626,"Attleborough","Attleborough","United Kingdom","GBR","",7564],
[1840002440,"Clawson","Clawson","United States","USA","",11845],
[1484457323,"Tlacotalpan","Tlacotalpan","Mexico","MEX","minor",7600],
[1484471294,"Higuera de Zaragoza","Higuera de Zaragoza","Mexico","MEX","",8976],
[1792920183,"Bingöl","Bingol","Turkey","TUR","admin",11727],
[1826794750,"Bradwell","Bradwell","United Kingdom","GBR","",9657],
[1826775307,"Newbold","Newbold","United Kingdom","GBR","",7962],
[1499204492,"Berane","Berane","Montenegro","MNE","admin",11776],
[1332603160,"Fort Liberté","Fort Liberte","Haiti","HTI","admin",11465],
[1356808460,"Nāzira","Nazira","India","IND","",9552],
[1840020288,"Newman","Newman","United States","USA","",11784],
[1356078345,"Krishnapur","Krishnapur","India","IND","",8205],
[1840014246,"Naranja","Naranja","United States","USA","",11778],
[1140271951,"Ndélé","Ndele","Central African Republic","CAF","admin",11764],
[1840074686,"View Park-Windsor Hills","View Park-Windsor Hills","United States","USA","",11756],
[1705743622,"Škofja Loka","Skofja Loka","Slovenia","SVN","admin",11671],
[1484009228,"Cuauhtémoc","Cuauhtemoc","Mexico","MEX","minor",7513],
[1148232209,"Bol","Bol","Chad","TCD","admin",11700],
[1840005245,"North Wantagh","North Wantagh","United States","USA","",11720],
[1756549876,"Epalinges","Epalinges","Switzerland","CHE","",9611],
[1756715308,"Kilchberg","Kilchberg","Switzerland","CHE","",8437],
[1484913185,"La Junta","La Junta","Mexico","MEX","",8930],
[1124421362,"Sidney","Sidney","Canada","CAN","",11672],
[1840041892,"Bothell East","Bothell East","United States","USA","",11665],
[1440272776,"Elektrėnai","Elektrenai","Lithuania","LTU","admin",11588],
[1250917889,"Bihorel","Bihorel","France","FRA","",8331],
[1250970448,"Le Plessis-Bouchard","Le Plessis-Bouchard","France","FRA","",8488],
[1598284215,"Alotau","Alotau","Papua New Guinea","PNG","admin",11624],
[1356361842,"Nalpur","Nalpur","India","IND","",6911],
[1356139009,"Mahadipur","Mahadipur","India","IND","",8638],
[1380421149,"Casapulla","Casapulla","Italy","ITA","",8597],
[1484012803,"Concordia","Concordia","Mexico","MEX","minor",8328],
[1840017638,"Alum Rock","Alum Rock","United States","USA","",11551],
[1250835364,"Beauchamp","Beauchamp","France","FRA","",8675],
[1826325556,"Cam","Cam","United Kingdom","GBR","",8152],
[1826961617,"Leven","Leven","United Kingdom","GBR","",9040],
[1250000416,"Le Portel","Le Portel","France","FRA","",9157],
[1484161200,"Halachó","Halacho","Mexico","MEX","minor",9412],
[1710632918,"Saron","Saron","South Africa","ZAF","",7843],
[1840028796,"Westwood Lakes","Westwood Lakes","United States","USA","",11510],
[1840000715,"Yeadon","Yeadon","United States","USA","",11496],
[1840000922,"Wallington","Wallington","United States","USA","",11495],
[1826418856,"Dowlais","Dowlais","United Kingdom","GBR","",6926],
[1430949102,"Sanniquellie","Sanniquellie","Liberia","LBR","admin",11415],
[1250372240,"Vaucresson","Vaucresson","France","FRA","",8660],
[1356656331,"Iarpur","Iarpur","India","IND","",9238],
[1840029589,"Waipio","Waipio","United States","USA","",11469],
[1246614476,"Mariehamn","Mariehamn","Finland","FIN","admin",11461],
[1826005601,"Sandiacre","Sandiacre","United Kingdom","GBR","",8889],
[1031852971,"Qax","Qax","Azerbaijan","AZE","admin",11415],
[1250782182,"Groslay","Groslay","France","FRA","",8545],
[1818837979,"Shanhūr","Shanhur","Egypt","EGY","",9314],
[1840029522,"Maili","Maili","United States","USA","",11437],
[1840000900,"River Edge","River Edge","United States","USA","",11435],
[1826942280,"Bolton upon Dearne","Bolton upon Dearne","United Kingdom","GBR","",6744],
[1340315181,"Yuscarán","Yuscaran","Honduras","HND","admin",11396],
[1840021868,"Signal Hill","Signal Hill","United States","USA","",11421],
[1800370948,"Mpigi","Mpigi","Uganda","UGA","admin",11082],
[1887452377,"Ḩadībū","Hadibu","Yemen","YEM","admin",11396],
[1484526569,"Acacoyagua","Acacoyagua","Mexico","MEX","minor",8092],
[1276833572,"Weißenthurm","Weissenthurm","Germany","DEU","",9115],
[1826321995,"Church","Church","United Kingdom","GBR","",5186],
[1826365312,"Glastonbury","Glastonbury","United Kingdom","GBR","",8932],
[1756600387,"Nidau","Nidau","Switzerland","CHE","",6815],
[1484000829,"San Diego de la Unión","San Diego de la Union","Mexico","MEX","minor",7946],
[1826925473,"Bonhill","Bonhill","United Kingdom","GBR","",9050],
[1380337324,"Sant’Agnello","Sant'Agnello","Italy","ITA","",9125],
[1826956381,"Codsall","Codsall","United Kingdom","GBR","",7582],
[1380646015,"Torre Boldone","Torre Boldone","Italy","ITA","",8755],
[1250002614,"Ambilly","Ambilly","France","FRA","",6261],
[1826018359,"Great Burstead","Great Burstead","United Kingdom","GBR","",5968],
[1478174698,"Arafat","Arafat","Mauritania","MRT","admin",0],
[1484614314,"San Juan Ixcaquixtla","San Juan Ixcaquixtla","Mexico","MEX","",8752],
[1250622011,"Évian-les-Bains","Evian-les-Bains","France","FRA","",9100],
[1504555478,"Ain Lehjer","Ain Lehjer","Morocco","MAR","",8272],
[1484927568,"Ciudad Ayala","Ciudad Ayala","Mexico","MEX","minor",6777],
[1598892363,"Vanimo","Vanimo","Papua New Guinea","PNG","admin",11204],
[1826167301,"Sundon","Sundon","United Kingdom","GBR","",7585],
[1484240728,"Tepeojuma","Tepeojuma","Mexico","MEX","minor",8492],
[1250110921,"Pérenchies","Perenchies","France","FRA","",8413],
[1250464206,"Billy-Montigny","Billy-Montigny","France","FRA","",8167],
[1643520048,"Magas","Magas","Russia","RUS","admin",10333],
[1840020297,"Piedmont","Piedmont","United States","USA","",11135],
[1826009826,"Exhall","Exhall","United Kingdom","GBR","",8006],
[1840019320,"Rossmoor","Rossmoor","United States","USA","",11128],
[1840003597,"Guttenberg","Guttenberg","United States","USA","",11121],
[1840011329,"Summit","Summit","United States","USA","",11116],
[1484294949,"Tataltepec de Valdés","Tataltepec de Valdes","Mexico","MEX","minor",8869],
[1818109000,"Dayr as Sanqūrīyah","Dayr as Sanquriyah","Egypt","EGY","",8911],
[1504748827,"Oulad Ben Sebbah","Oulad Ben Sebbah","Morocco","MAR","",7606],
[1724722976,"Lekeitio","Lekeitio","Spain","ESP","",7271],
[1498876065,"Rezina","Rezina","Moldova","MDA","admin",11032],
[1104542517,"Loikaw","Loikaw","Myanmar","MMR","admin",11000],
[1250465461,"Ablon-sur-Seine","Ablon-sur-Seine","France","FRA","",5818],
[1840020322,"Orange Cove","Orange Cove","United States","USA","",11059],
[1484008816,"Kantunilkín","Kantunilkin","Mexico","MEX","minor",7150],
[1484186132,"Guadalupe Yancuictlalpan","Guadalupe Yancuictlalpan","Mexico","MEX","",6385],
[1148086843,"Biltine","Biltine","Chad","TCD","admin",11000],
[1724266157,"Reinosa","Reinosa","Spain","ESP","",8810],
[1630035648,"Coamo","Coamo","Puerto Rico","PRI","",11012],
[1826357082,"Bedwas","Bedwas","United Kingdom","GBR","",8512],
[1470416994,"Paola","Paola","Malta","MLT","admin",7864],
[1840004987,"Suffern","Suffern","United States","USA","",11007],
[1724866272,"Montmeló","Montmelo","Spain","ESP","",8798],
[1498650298,"Anenii Noi","Anenii Noi","Moldova","MDA","admin",10872],
[1250864233,"Gournay-sur-Marne","Gournay-sur-Marne","France","FRA","",6878],
[1826030000,"Bramley","Bramley","United Kingdom","GBR","",8194],
[1807799132,"Strumica","Strumica","Macedonia","MKD","admin",10868],
[1356420017,"Raspunji","Raspunji","India","IND","",8036],
[1108619045,"Karuzi","Karuzi","Burundi","BDI","admin",10705],
[1642663139,"Curcani","Curcani","Romania","ROU","",5609],
[1484776218,"Bahía Kino","Bahia Kino","Mexico","MEX","",6454],
[1826128620,"Marlborough","Marlborough","United Kingdom","GBR","",8395],
[1250602233,"Meythet","Meythet","France","FRA","",8327],
[1498598747,"Călăraşi","Calarasi","Moldova","MDA","admin",10808],
[1807665568,"Vinica","Vinica","Macedonia","MKD","admin",10863],
[1012633792,"Beni Abbès","Beni Abbes","Algeria","DZA","admin",10885],
[1826142035,"Brimington","Brimington","United Kingdom","GBR","",8788],
[1250377997,"Aucamville","Aucamville","France","FRA","",8691],
[1807592969,"Probištip","Probistip","Macedonia","MKD","admin",10826],
[1826325568,"Bucksburn","Bucksburn","United Kingdom","GBR","",8131],
[1356110154,"Nijgaon Parānpur","Nijgaon Paranpur","India","IND","",8523],
[1826314267,"West Auckland","West Auckland","United Kingdom","GBR","",8509],
[1840028382,"La Riviera","La Riviera","United States","USA","",10840],
[1233731045,"Jõhvi","Johvi","Estonia","EST","admin",10541],
[1826948192,"Gowerton","Gowerton","United Kingdom","GBR","",8183],
[1484004336,"Ahumada","Ahumada","Mexico","MEX","minor",8575],
[1470830646,"Birżebbuġa","Birzebbuga","Malta","MLT","admin",9736],
[1484087998,"El Higo","El Higo","Mexico","MEX","minor",7844],
[1484739082,"Lázaro Cárdenas","Lazaro Cardenas","Mexico","MEX","",8704],
[1840003534,"Little Ferry","Little Ferry","United States","USA","",10739],
[1031479797,"Daşkəsən","Daskasan","Azerbaijan","AZE","admin",10700],
[1858193593,"Salinas","Salinas","Uruguay","URY","",8626],
[1484018181,"Altar","Altar","Mexico","MEX","minor",8439],
[1688101335,"Bela Crkva","Bela Crkva","Serbia","SRB","admin",10675],
[1840000695,"Darby","Darby","United States","USA","",10702],
[1340163370,"Roatán","Roatan","Honduras","HND","admin",7514],
[1356617460,"Ballālpur","Ballalpur","India","IND","",7217],
[1356089869,"Kavaratti","Kavaratti","India","IND","admin",10688],
[1826992188,"Harworth","Harworth","United Kingdom","GBR","",7948],
[1840034123,"Northbrook","Northbrook","United States","USA","",10684],
[1724572525,"Rocafort","Rocafort","Spain","ESP","",7445],
[1356078205,"Pātra","Patra","India","IND","",8310],
[1826422128,"Monifieth","Monifieth","United Kingdom","GBR","",8110],
[1356511733,"Chāndnidaha","Chandnidaha","India","IND","",5996],
[1840000700,"Lansdowne","Lansdowne","United States","USA","",10647],
[1484738451,"Cocorit","Cocorit","Mexico","MEX","",7424],
[1484789379,"Ayotoxco de Guerrero","Ayotoxco de Guerrero","Mexico","MEX","minor",8558],
[1051696950,"Byureghavan","Byureghavan","Armenia","ARM","",8500],
[1840005058,"North Lindenhurst","North Lindenhurst","United States","USA","",10624],
[1356926193,"Nabagrām","Nabagram","India","IND","",8452],
[1826317854,"Stopsley","Stopsley","United Kingdom","GBR","",7760],
[1108527579,"Kirundo","Kirundo","Burundi","BDI","admin",10024],
[1430362799,"Greenville","Greenville","Liberia","LBR","admin",10374],
[1887764813,"Al Maḩwīt","Al Mahwit","Yemen","YEM","admin",10593],
[1250256203,"Sainte-Adresse","Sainte-Adresse","France","FRA","",7349],
[1688687750,"Ada","Ada","Serbia","SRB","admin",10547],
[1826954935,"Oban","Oban","United Kingdom","GBR","",8490],
[1356127024,"Hilora","Hilora","India","IND","",7667],
[1840034388,"Lincoln Village","Lincoln Village","United States","USA","",10549],
[1233967642,"Haapsalu","Haapsalu","Estonia","EST","admin",9675],
[1764126822,"Trat","Trat","Thailand","THA","admin",10413],
[1470660015,"Mellieħa","Mellieha","Malta","MLT","admin",10087],
[1642208742,"Roseţi","Roseti","Romania","ROU","",6070],
[1840014249,"Richmond Heights","Richmond Heights","United States","USA","",10524],
[1858593854,"Lascano","Lascano","Uruguay","URY","",7645],
[1756451113,"Sarnen","Sarnen","Switzerland","CHE","admin",10368],
[1764855952,"Phangnga","Phangnga","Thailand","THA","admin",10412],
[1504662210,"Beni Bou Yafroun","Beni Bou Yafroun","Morocco","MAR","",6418],
[1840019619,"Jacinto City","Jacinto City","United States","USA","",10466],
[1826056862,"Wickersley","Wickersley","United Kingdom","GBR","",7392],
[1484903629,"Antón Lizardo","Anton Lizardo","Mexico","MEX","",6003],
[1250133428,"Boussy-Saint-Antoine","Boussy-Saint-Antoine","France","FRA","",7767],
[1780418671,"Siparia","Siparia","Trinidad And Tobago","TTO","admin",10254],
[1031853196,"Ordubad","Ordubad","Azerbaijan","AZE","admin",10372],
[1724870281,"Ondárroa","Ondarroa","Spain","ESP","",8326],
[1428220700,"Olaine","Olaine","Latvia","LVA","admin",10324],
[1250908812,"Terrenoire","Terrenoire","France","FRA","",8317],
[1826133084,"Wistaston","Wistaston","United Kingdom","GBR","",8117],
[1840019205,"East Whittier","East Whittier","United States","USA","",10356],
[1380872731,"Mariglianella","Mariglianella","Italy","ITA","",7924],
[1426574356,"Butha-Buthe","Butha-Buthe","Lesotho","LSO","admin",10000],
[1031441683,"Naftalan","Naftalan","Azerbaijan","AZE","admin",10100],
[1296060597,"Teaoraereke","Teaoraereke","Kiribati","KIR","",6073],
[1356819152,"Imamnagar","Imamnagar","India","IND","",6933],
[1756957308,"Altdorf","Altdorf","Switzerland","CHE","admin",9401],
[1250177804,"Carbon-Blanc","Carbon-Blanc","France","FRA","",8172],
[1356204007,"Serpur","Serpur","India","IND","",8170],
[1031600567,"Samux","Samux","Azerbaijan","AZE","admin",10228],
[1643032261,"Molochnoye","Molochnoye","Russia","RUS","",7690],
[1840004821,"Boulder Hill","Boulder Hill","United States","USA","",10262],
[1250670508,"La Verrière","La Verriere","France","FRA","",6551],
[1484723761,"Buctzotz","Buctzotz","Mexico","MEX","",7515],
[1826923281,"Crieff","Crieff","United Kingdom","GBR","",7430],
[1020543453,"La Massana","La Massana","Andorra","AND","admin",10076],
[1840037894,"Lake Stickney","Lake Stickney","United States","USA","",10230],
[1356801516,"Dīgnagar","Dignagar","India","IND","",6023],
[1840005290,"Great Neck","Great Neck","United States","USA","",10209],
[1826843496,"Torpoint","Torpoint","United Kingdom","GBR","",7717],
[1840004990,"West Haverstraw","West Haverstraw","United States","USA","",10189],
[1484190269,"San Francisco del Mar","San Francisco del Mar","Mexico","MEX","",7650],
[1724516026,"Almácera","Almacera","Spain","ESP","",7433],
[1840001053,"Bound Brook","Bound Brook","United States","USA","",10180],
[1140392673,"Birao","Birao","Central African Republic","CAF","admin",10178],
[1250755469,"La Ville-du-Bois","La Ville-du-Bois","France","FRA","",7970],
[1440132489,"Biržai","Birzai","Lithuania","LTU","admin",10146],
[1108466781,"Muyinga","Muyinga","Burundi","BDI","admin",9609],
[1840017916,"Citrus","Citrus","United States","USA","",10150],
[1826936718,"Bilton","Bilton","United Kingdom","GBR","",6175],
[1356128487,"Palta","Palta","India","IND","",6408],
[1484013492,"Tamazulapam Villa del Progreso","Tamazulapam Villa del Progreso","Mexico","MEX","",7707],
[1498953988,"Nisporeni","Nisporeni","Moldova","MDA","admin",10063],
[1428739306,"Kuldīga","Kuldiga","Latvia","LVA","admin",10109],
[1356916954,"Beonta","Beonta","India","IND","",7850],
[1250944890,"Fontaines-sur-Saône","Fontaines-sur-Saone","France","FRA","",7068],
[1688549018,"Vrnjačka Banja","Vrnjacka Banja","Serbia","SRB","admin",10065],
[1380773296,"Recale","Recale","Italy","ITA","",7710],
[1499103009,"Mojkovac","Mojkovac","Montenegro","MNE","admin",10066],
[1484217254,"Huiloapan","Huiloapan","Mexico","MEX","minor",7221],
[1250050071,"Villemoisson-sur-Orge","Villemoisson-sur-Orge","France","FRA","",7038],
[1470141385,"Ħamrun","Hamrun","Malta","MLT","admin",9244],
[1484431471,"Hopelchén","Hopelchen","Mexico","MEX","minor",7295],
[1826037087,"Warrenpoint","Warrenpoint","United Kingdom","GBR","",6981],
[1004893931,"Tarīn Kōṯ","Tarin Kot","Afghanistan","AFG","admin",10000],
[1356701037,"Andharmanik","Andharmanik","India","IND","",6676],
[1840017919,"Charter Oak","Charter Oak","United States","USA","",10048],
[1840018959,"Capitola","Capitola","United States","USA","",10010],
[1688731968,"Kanjiža","Kanjiza","Serbia","SRB","admin",9871],
[1840028367,"Del Aire","Del Aire","United States","USA","",9990],
[1826380790,"Whetstone","Whetstone","United Kingdom","GBR","",6556],
[1380973138,"Rovellasca","Rovellasca","Italy","ITA","",7797],
[1840028364,"Country Club","Country Club","United States","USA","",9977],
[1340380637,"Nueva Ocotepeque","Nueva Ocotepeque","Honduras","HND","admin",8780],
[1250549179,"La Mulatière","La Mulatiere","France","FRA","",6431],
[1840031154,"Timberlane","Timberlane","United States","USA","",9950],
[1250484829,"Montlhéry","Montlhery","France","FRA","",7624],
[1858885344,"Castillos","Castillos","Uruguay","URY","",7541],
[1826876428,"Aintree","Aintree","United Kingdom","GBR","",6689],
[1840002495,"Watervliet","Watervliet","United States","USA","",9900],
[1840005267,"Inwood","Inwood","United States","USA","",9892],
[1840018673,"White City","White City","United States","USA","",9890],
[1428015452,"Bauska","Bauska","Latvia","LVA","admin",9840],
[1356601239,"Balbalpāra","Balbalpara","India","IND","",5207],
[1356052495,"Bhandārdaha","Bhandardaha","India","IND","",5667],
[1356127022,"Jājigrām","Jajigram","India","IND","",6977],
[1826338747,"Brechin","Brechin","United Kingdom","GBR","",7400],
[1792408667,"Bilecik","Bilecik","Turkey","TUR","admin",9722],
[1840017920,"Marina del Rey","Marina del Rey","United States","USA","",9852],
[1840028570,"Stonegate","Stonegate","United States","USA","",9847],
[1356063143,"Alipur","Alipur","India","IND","",5937],
[1840029018,"West Perrine","West Perrine","United States","USA","",9826],
[1250039082,"Talange","Talange","France","FRA","",7731],
[1840005343,"East Rockaway","East Rockaway","United States","USA","",9814],
[1826692197,"Duntocher","Duntocher","United Kingdom","GBR","",6880],
[1356374734,"Burul","Burul","India","IND","",7014],
[1840005313,"New Hyde Park","New Hyde Park","United States","USA","",9807],
[1840024254,"Brookdale","Brookdale","United States","USA","",9801],
[1356030889,"Purbba Ramnagar","Purbba Ramnagar","India","IND","",7759],
[1840042909,"Westgate","Westgate","United States","USA","",9783],
[1380386033,"Cimitile","Cimitile","Italy","ITA","",7167],
[1642038257,"Chirnogi","Chirnogi","Romania","ROU","",7455],
[1250393244,"Huningue","Huningue","France","FRA","",7240],
[1440845969,"Jurbarkas","Jurbarkas","Lithuania","LTU","admin",9711],
[1642174720,"Fundeni","Fundeni","Romania","ROU","",5658],
[1630035532,"Pájaros","Pajaros","Puerto Rico","PRI","",9713],
[1484258446,"Santa Eulalia","Santa Eulalia","Mexico","MEX","minor",7135],
[1108520771,"Makamba","Makamba","Burundi","BDI","admin",9396],
[1608620601,"Basco","Basco","Philippines","PHL","admin",9517],
[1840028403,"West Athens","West Athens","United States","USA","",9706],
[1858294756,"Joaquín Suárez","Joaquin Suarez","Uruguay","URY","",6570],
[1428774997,"Saldus","Saldus","Latvia","LVA","admin",9679],
[1072830877,"Tshabong","Tshabong","Botswana","BWA","admin",9679],
[1484797126,"Algodones","Algodones","Mexico","MEX","",6796],
[1484383643,"Ojo Caliente","Ojo Caliente","Mexico","MEX","",6914],
[1178834249,"Djambala","Djambala","Congo (Brazzaville)","COG","admin",9651],
[1756730955,"Oberengstringen","Oberengstringen","Switzerland","CHE","",6569],
[1826473796,"Llantwit Fardre","Llantwit Fardre","United Kingdom","GBR","",6099],
[1705090259,"Postojna","Postojna","Slovenia","SVN","admin",9605],
[1840029469,"Aiea","Aiea","United States","USA","",9638],
[1840003690,"Keansburg","Keansburg","United States","USA","",9632],
[1598730976,"Kundiawa","Kundiawa","Papua New Guinea","PNG","admin",9383],
[1840003536,"Maywood","Maywood","United States","USA","",9614],
[1132841923,"Pedra Badejo","Pedra Badejo","Cabo Verde","CPV","admin",9530],
[1470444069,"Pietà","Pieta","Malta","MLT","admin",4020],
[1484272000,"San Pedro Amuzgos","San Pedro Amuzgos","Mexico","MEX","",6664],
[1380722958,"Barlassina","Barlassina","Italy","ITA","",7015],
[1484006331,"Tenabo","Tenabo","Mexico","MEX","minor",7543],
[1901964789,"Hani i Elezit","Hani i Elezit","Kosovo","XKS","admin",9403],
[1826238045,"Harlescott","Harlescott","United Kingdom","GBR","",5060],
[1826943843,"Bothwell","Bothwell","United Kingdom","GBR","",6380],
[1124978470,"Bois-des-Filion","Bois-des-Filion","Canada","CAN","",9485],
[1826718081,"Uddingston","Uddingston","United Kingdom","GBR","",6370],
[1826436345,"Withernsea","Withernsea","United Kingdom","GBR","",5980],
[1826495062,"Farington","Farington","United Kingdom","GBR","",6674],
[1440557692,"Vilkaviškis","Vilkaviskis","Lithuania","LTU","admin",9444],
[1250321285,"Sathonay-Camp","Sathonay-Camp","France","FRA","",6267],
[1826208698,"Kirkwall","Kirkwall","United Kingdom","GBR","",7420],
[1499854307,"Rožaje","Rozaje","Montenegro","MNE","admin",9422],
[1380563683,"Carnate","Carnate","Italy","ITA","",7327],
[1840005981,"Bladensburg","Bladensburg","United States","USA","",9408],
[1724019338,"Roda del Ter","Roda del Ter","Spain","ESP","",6449],
[1583881416,"Kolonia","Kolonia","Federated States of Micronesia","FSM","admin",6074],
[1705071756,"Vrhnika","Vrhnika","Slovenia","SVN","admin",8888],
[1250528227,"Le Port-Marly","Le Port-Marly","France","FRA","",5509],
[1090427067,"Gizo","Gizo","Solomon Islands","SLB","admin",6154],
[1498650340,"Rîşcani","Riscani","Moldova","MDA","admin",9259],
[1020885733,"Sant Julià de Lòria","Sant Julia de Loria","Andorra","AND","admin",9156],
[1840000925,"Wood-Ridge","Wood-Ridge","United States","USA","",9294],
[1804136852,"Komyshany","Komyshany","Ukraine","UKR","",6941],
[1470128499,"Victoria","Victoria","Malta","MLT","admin",6901],
[1380364140,"Isola delle Femmine","Isola delle Femmine","Italy","ITA","",7249],
[1840001212,"Brentwood","Brentwood","United States","USA","",9268],
[1356688318,"Bansabāti","Bansabati","India","IND","",6378],
[1072217316,"Kasane","Kasane","Botswana","BWA","admin",9250],
[1858554370,"Sauce","Sauce","Uruguay","URY","",6132],
[1276202316,"Neulußheim","Neulussheim","Germany","DEU","",7127],
[1826467438,"Dyce","Dyce","United Kingdom","GBR","",6190],
[1688662344,"Žabalj","Zabalj","Serbia","SRB","admin",9161],
[1840035266,"Woodlyn","Woodlyn","United States","USA","",9178],
[1840001333,"South Amboy","South Amboy","United States","USA","",9176],
[1630023550,"Sabana Grande","Sabana Grande","Puerto Rico","PRI","",9174],
[1226336138,"Evinayong","Evinayong","Equatorial Guinea","GNQ","admin",9155],
[1470598185,"Senglea","Senglea","Malta","MLT","admin",2784],
[1380286448,"Gorle","Gorle","Italy","ITA","",6557],
[1705847148,"Grosuplje","Grosuplje","Slovenia","SVN","admin",7703],
[1756019042,"Stans","Stans","Switzerland","CHE","admin",8393],
[1792584248,"Çankırı","Cankiri","Turkey","TUR","admin",9075],
[1084718311,"Dangriga","Dangriga","Belize","BLZ","admin",9096],
[1484013873,"Leona Vicario","Leona Vicario","Mexico","MEX","",6517],
[1454464861,"Thyolo","Thyolo","Malawi","MWI","admin",7029],
[1800303827,"Katakwi","Katakwi","Uganda","UGA","admin",8400],
[1826001135,"Lexden","Lexden","United Kingdom","GBR","",5549],
[1250652019,"Beuvrages","Beuvrages","France","FRA","",6821],
[1642797649,"Lunca Cetăţuii","Lunca Cetatuii","Romania","ROU","",6227],
[1250050005,"Guingamp","Guingamp","France","FRA","minor",7022],
[1818001458,"Dayr al Jarnūs","Dayr al Jarnus","Egypt","EGY","",6504],
[1356004384,"Bodāi","Bodai","India","IND","",6971],
[1178339407,"Ewo","Ewo","Congo (Brazzaville)","COG","admin",9062],
[1826896340,"Lerwick","Lerwick","United Kingdom","GBR","",6880],
[1626115337,"Manatuto","Manatuto","Timor-Leste","TLS","admin",9022],
[1484945952,"Valle de Guadalupe","Valle de Guadalupe","Mexico","MEX","minor",6924],
[1688373834,"Odžaci","Odzaci","Serbia","SRB","admin",9021],
[1840073671,"Leisure World","Leisure World","United States","USA","",9040],
[1840031382,"North Kensington","North Kensington","United States","USA","",9036],
[1840000904,"Leonia","Leonia","United States","USA","",9035],
[1840005285,"Farmingdale","Farmingdale","United States","USA","",9002],
[1788060879,"Sidi Bou Saïd","Sidi Bou Said","Tunisia","TUN","",5873],
[1250181295,"Grenay","Grenay","France","FRA","",6851],
[1840005249,"Plainedge","Plainedge","United States","USA","",8975],
[1826722060,"Sauchie","Sauchie","United Kingdom","GBR","",6310],
[1484401368,"San Antonino Castillo Velasco","San Antonino Castillo Velasco","Mexico","MEX","minor",6009],
[1826363162,"Cheddar","Cheddar","United Kingdom","GBR","",5755],
[1826648142,"Golcar","Golcar","United Kingdom","GBR","",6900],
[1840042758,"Stony Brook University","Stony Brook University","United States","USA","",8943],
[1756101962,"Bottmingen","Bottmingen","Switzerland","CHE","",6691],
[1688215764,"Sremski Karlovci","Sremski Karlovci","Serbia","SRB","admin",8750],
[1356817365,"Uttarbhag","Uttarbhag","India","IND","",6748],
[1840034970,"Folsom","Folsom","United States","USA","",8913],
[1626143485,"Gleno","Gleno","Timor-Leste","TLS","admin",8133],
[1484009522,"Temozon","Temozon","Mexico","MEX","",6553],
[1826413238,"Altofts","Altofts","United Kingdom","GBR","",6198],
[1428411666,"Talsi","Talsi","Latvia","LVA","admin",8816],
[1426785819,"Mokhotlong","Mokhotlong","Lesotho","LSO","admin",8809],
[1084938400,"Corozal","Corozal","Belize","BLZ","admin",8800],
[1484400934,"Bécal","Becal","Mexico","MEX","",6511],
[1484837691,"Xochitlan Todos Santos","Xochitlan Todos Santos","Mexico","MEX","",6336],
[1840000693,"Collingdale","Collingdale","United States","USA","",8794],
[1470181462,"Siġġiewi","Siggiewi","Malta","MLT","admin",8367],
[1276665888,"Eichwalde","Eichwalde","Germany","DEU","",6468],
[1440592411,"Joniškis","Joniskis","Lithuania","LTU","admin",8757],
[1840016009,"West Miami","West Miami","United States","USA","",8767],
[1840004980,"New Square","New Square","United States","USA","",8763],
[1428641580,"Dobele","Dobele","Latvia","LVA","admin",8731],
[1498553213,"Glodeni","Glodeni","Moldova","MDA","admin",8676],
[1792320984,"Artvin","Artvin","Turkey","TUR","admin",8719],
[1031444480,"Gədəbəy","Gadabay","Azerbaijan","AZE","admin",8657],
[1840006038,"Seven Corners","Seven Corners","United States","USA","",8731],
[1705859832,"Kočevje","Kocevje","Slovenia","SVN","admin",8151],
[1478173139,"Aleg","Aleg","Mauritania","MRT","admin",8388],
[1804999181,"Karnaukhivka","Karnaukhivka","Ukraine","UKR","",6631],
[1840024572,"Greenbriar","Greenbriar","United States","USA","",8686],
[1233393684,"Paide","Paide","Estonia","EST","admin",7905],
[1840005950,"Coral Hills","Coral Hills","United States","USA","",8685],
[1356074954,"Gācha","Gacha","India","IND","",6489],
[1826169659,"Bishopton","Bishopton","United Kingdom","GBR","",5330],
[1840001264,"Swissvale","Swissvale","United States","USA","",8647],
[1840003775,"Audubon","Audubon","United States","USA","",8637],
[1484585914,"Puerto San Carlos","Puerto San Carlos","Mexico","MEX","",5538],
[1250973088,"Jœuf","Joeuf","France","FRA","",6559],
[1826619680,"Broughton","Broughton","United Kingdom","GBR","",5726],
[1642001303,"Dragalina","Dragalina","Romania","ROU","",6218],
[1380039239,"Albiate","Albiate","Italy","ITA","",6352],
[1826624574,"Harleston","Harleston","United Kingdom","GBR","",5067],
[1756614612,"Rolle","Rolle","Switzerland","CHE","",6259],
[1498894118,"Basarabeasca","Basarabeasca","Moldova","MDA","admin",8471],
[1031852579,"Zərdab","Zardab","Azerbaijan","AZE","admin",8450],
[1356426591,"Gotra","Gotra","India","IND","",5894],
[1440174702,"Anykščiai","Anyksciai","Lithuania","LTU","admin",8491],
[1484346814,"Piste","Piste","Mexico","MEX","",5528],
[1440933251,"Varėna","Varena","Lithuania","LTU","admin",8477],
[1840005305,"Malverne","Malverne","United States","USA","",8485],
[1440412268,"Prienai","Prienai","Lithuania","LTU","admin",8451],
[1826917340,"Wotton-under-Edge","Wotton-under-Edge","United Kingdom","GBR","",5627],
[1484546249,"Teabo","Teabo","Mexico","MEX","",6115],
[1356088599,"Bāmanpukur","Bamanpukur","India","IND","",6421],
[1705286396,"Krško","Krsko","Slovenia","SVN","admin",7217],
[1840028357,"August","August","United States","USA","",8405],
[1250981216,"Palavas-les-Flots","Palavas-les-Flots","France","FRA","",5903],
[1250450385,"Esbly","Esbly","France","FRA","",6339],
[1740558611,"Brokopondo","Brokopondo","Suriname","SUR","admin",8340],
[1826777809,"Bridge of Allan","Bridge of Allan","United Kingdom","GBR","",5380],
[1840025037,"Midway City","Midway City","United States","USA","",8343],
[1840000894,"Bogota","Bogota","United States","USA","",8335],
[1840005257,"Garden City Park","Garden City Park","United States","USA","",8335],
[1840003761,"Grandview Heights","Grandview Heights","United States","USA","",8333],
[1840011252,"Harwood Heights","Harwood Heights","United States","USA","",8333],
[1484925741,"Tayoltita","Tayoltita","Mexico","MEX","minor",5124],
[1484192062,"Calderitas","Calderitas","Mexico","MEX","",5326],
[1478902195,"Tevragh Zeina","Tevragh Zeina","Mauritania","MRT","admin",0],
[1826757058,"Freckleton","Freckleton","United Kingdom","GBR","",6019],
[1840003512,"Haledon","Haledon","United States","USA","",8293],
[1826000038,"Hengoed","Hengoed","United Kingdom","GBR","",5548],
[1840001222,"Dormont","Dormont","United States","USA","",8282],
[1688152997,"Beočin","Beocin","Serbia","SRB","admin",8058],
[1208841384,"Sorø","Soro","Denmark","DNK","admin",7167],
[1840028356,"Alondra Park","Alondra Park","United States","USA","",8272],
[1031370082,"Balakən","Balakan","Azerbaijan","AZE","admin",8134],
[1840024489,"Four Corners","Four Corners","United States","USA","",8246],
[1705359875,"Slovenska Bistrica","Slovenska Bistrica","Slovenia","SVN","admin",8219],
[1826057542,"Magor","Magor","United Kingdom","GBR","",6140],
[1484003932,"Soledad Etla","Soledad Etla","Mexico","MEX","",5591],
[1250634837,"Pont-de-Chéruy","Pont-de-Cheruy","France","FRA","",5876],
[1840003813,"Cheviot","Cheviot","United States","USA","",8209],
[1356048024,"Padmarhā","Padmarha","India","IND","",5184],
[1840028918,"Broadview Park","Broadview Park","United States","USA","",8169],
[1484245253,"Guadalupe y Calvo","Guadalupe y Calvo","Mexico","MEX","minor",5816],
[1356070837,"Ramkrishnapur","Ramkrishnapur","India","IND","",5971],
[1840019207,"South San Gabriel","South San Gabriel","United States","USA","",8138],
[1826011003,"Balloch","Balloch","United Kingdom","GBR","",6050],
[1756001999,"Préverenges","Preverenges","Switzerland","CHE","",5287],
[1792559945,"Gümüşhane","Gumushane","Turkey","TUR","admin",8092],
[1840005977,"Mount Rainier","Mount Rainier","United States","USA","",8093],
[1840009740,"Maplewood","Maplewood","United States","USA","",8092],
[1388155945,"Port Maria","Port Maria","Jamaica","JAM","admin",7906],
[1356156049,"Iswaripur","Iswaripur","India","IND","",5155],
[1158327079,"Nangan","Nangan","Taiwan","TWN","admin",7382],
[1840015153,"North Bay Village","North Bay Village","United States","USA","",8057],
[1484235185,"Panindícuaro","Panindicuaro","Mexico","MEX","minor",5565],
[1840003697,"Conshohocken","Conshohocken","United States","USA","",8047],
[1484615349,"Palo Alto","Palo Alto","Mexico","MEX","minor",5399],
[1356505482,"Nadābhānga","Nadabhanga","India","IND","",5927],
[1840001203,"Bellevue","Bellevue","United States","USA","",8036],
[1756399436,"Gerlafingen","Gerlafingen","Switzerland","CHE","",5202],
[1826484672,"Chickerell","Chickerell","United Kingdom","GBR","",5515],
[1268173120,"Mtskheta","Mtskheta","Georgia","GEO","admin",7940],
[1688282797,"Sokobanja","Sokobanja","Serbia","SRB","admin",7982],
[1840041381,"Paloma Creek South","Paloma Creek South","United States","USA","",7986],
[1484205103,"Panabá","Panaba","Mexico","MEX","minor",5232],
[1554984303,"Greymouth","Greymouth","New Zealand","NZL","admin",7965],
[1484044585,"Santa María del Oro","Santa Maria del Oro","Mexico","MEX","minor",5878],
[1840005354,"Caldwell","Caldwell","United States","USA","",7941],
[1705902870,"Litija","Litija","Slovenia","SVN","admin",6673],
[1840005967,"Temple Hills","Temple Hills","United States","USA","",7926],
[1051234787,"Yeghegnadzor","Yeghegnadzor","Armenia","ARM","admin",7633],
[1724074512,"Cájar","Cajar","Spain","ESP","",5262],
[1600185723,"San Juan Bautista","San Juan Bautista","Paraguay","PRY","admin",7882],
[1004151943,"Maḩmūd-e Rāqī","Mahmud-e Raqi","Afghanistan","AFG","admin",7407],
[1388625979,"Falmouth","Falmouth","Jamaica","JAM","admin",7779],
[1840081629,"Riverside","Riverside","United States","USA","",7857],
[1056423988,"Drogenbos","Drogenbos","Belgium","BEL","",5599],
[1826530571,"Oundle","Oundle","United Kingdom","GBR","",5735],
[1728684421,"Bentiu","Bentiu","South Sudan","SSD","admin",7781],
[1705580792,"Ajdovščina","Ajdovscina","Slovenia","SVN","admin",6843],
[1840005462,"Glenside","Glenside","United States","USA","",7819],
[1356354067,"Bishnupur","Bishnupur","India","IND","",5030],
[1840000984,"Wilson","Wilson","United States","USA","",7807],
[1484729183,"Esperanza","Esperanza","Mexico","MEX","",3836],
[1840021001,"Rio Bravo","Rio Bravo","United States","USA","",7797],
[1840020467,"Guadalupe","Guadalupe","United States","USA","",7783],
[1484677856,"Angostura","Angostura","Mexico","MEX","minor",5086],
[1226278217,"Luba","Luba","Equatorial Guinea","GNQ","admin",7739],
[1826002814,"Dartmouth","Dartmouth","United Kingdom","GBR","",5064],
[1807619539,"Aračinovo","Aracinovo","Macedonia","MKD","admin",7315],
[1642918141,"Dobroeşti","Dobroesti","Romania","ROU","",5274],
[1840017572,"Boyes Hot Springs","Boyes Hot Springs","United States","USA","",7728],
[1250745099,"Champagne-au-Mont-d’Or","Champagne-au-Mont-d'Or","France","FRA","",5570],
[1470541461,"Cospicua","Cospicua","Malta","MLT","admin",5395],
[1031745676,"Yardımlı","Yardimli","Azerbaijan","AZE","admin",7623],
[1756983327,"Greifensee","Greifensee","Switzerland","CHE","",5345],
[1840003614,"Fanwood","Fanwood","United States","USA","",7697],
[1484278010,"Nombre de Dios","Nombre de Dios","Mexico","MEX","minor",5302],
[1484383331,"Pitiquito","Pitiquito","Mexico","MEX","minor",5139],
[1356698957,"Bhāsa","Bhasa","India","IND","",5559],
[1826117345,"Elderslie","Elderslie","United Kingdom","GBR","",5330],
[1840020631,"Holtville","Holtville","United States","USA","",7664],
[1840039869,"East Franklin","East Franklin","United States","USA","",7649],
[1840005229,"Baldwin Harbor","Baldwin Harbor","United States","USA","",7623],
[1630023721,"Juncos","Juncos","Puerto Rico","PRI","",7607],
[1840010145,"Calumet Park","Calumet Park","United States","USA","",7602],
[1630023692,"Luquillo","Luquillo","Puerto Rico","PRI","",7599],
[1442382721,"Diekirch","Diekirch","Luxembourg","LUX","admin",7047],
[1840005356,"Glen Ridge","Glen Ridge","United States","USA","",7574],
[1116978997,"Sen Monorom","Sen Monorom","Cambodia","KHM","admin",7500],
[1470875655,"Balzan","Balzan","Malta","MLT","admin",3958],
[1440476751,"Kelmė","Kelme","Lithuania","LTU","admin",7499],
[1630035678,"Gurabo","Gurabo","Puerto Rico","PRI","",7511],
[1498085636,"Leova","Leova","Moldova","MDA","admin",7443],
[1826306929,"Brotton","Brotton","United Kingdom","GBR","",5394],
[1484190103,"X-Cán","X-Can","Mexico","MEX","",5191],
[1840003700,"Hatboro","Hatboro","United States","USA","",7501],
[1826840707,"Brayton","Brayton","United Kingdom","GBR","",5299],
[1356952698,"Bodra","Bodra","India","IND","",5324],
[1428976928,"Ludza","Ludza","Latvia","LVA","admin",7473],
[1484694135,"Zapotitlán","Zapotitlan","Mexico","MEX","",5469],
[1705757622,"Ravne na Koroškem","Ravne na Koroskem","Slovenia","SVN","admin",7363],
[1031383465,"Goranboy","Goranboy","Azerbaijan","AZE","admin",7400],
[1840039259,"Waikele","Waikele","United States","USA","",7442],
[1840004967,"Hillcrest","Hillcrest","United States","USA","",7441],
[1840009133,"Park City","Park City","United States","USA","",7438],
[1807895120,"Kičevo","Kicevo","Macedonia","MKD","admin",7280],
[1858233151,"Tala","Tala","Uruguay","URY","",5089],
[1792859558,"Kırıkkale","Kirikkale","Turkey","TUR","admin",7369],
[1826912793,"Kinross","Kinross","United Kingdom","GBR","",5120],
[1484967062,"Chicxulub Puerto","Chicxulub Puerto","Mexico","MEX","",5052],
[1108406902,"Ruyigi","Ruyigi","Burundi","BDI","admin",7139],
[1498970287,"Briceni","Briceni","Moldova","MDA","admin",7314],
[1031887331,"Lerik","Lerik","Azerbaijan","AZE","admin",7301],
[1840002187,"Montpelier","Montpelier","United States","USA","admin",7372],
[1470129537,"Ta’ Xbiex","Ta' Xbiex","Malta","MLT","admin",1804],
[1840014085,"Sky Lake","Sky Lake","United States","USA","",7331],
[1498334915,"Ocniţa","Ocnita","Moldova","MDA","admin",7254],
[1826470625,"Whiston","Whiston","United Kingdom","GBR","",5042],
[1428739484,"Krāslava","Kraslava","Latvia","LVA","admin",7289],
[1630035569,"Sabana Seca","Sabana Seca","Puerto Rico","PRI","",7309],
[1705845238,"Slovenj Gradec","Slovenj Gradec","Slovenia","SVN","admin",7249],
[1140935252,"Mobaye","Mobaye","Central African Republic","CAF","admin",7176],
[1226565454,"Mongomo","Mongomo","Equatorial Guinea","GNQ","admin",7251],
[1688267080,"Lapovo","Lapovo","Serbia","SRB","admin",7143],
[1404396632,"Hola","Hola","Kenya","KEN","admin",6931],
[1840005333,"Williston Park","Williston Park","United States","USA","",7253],
[1498811064,"Teleneşti","Telenesti","Moldova","MDA","admin",7227],
[1428843734,"Ādaži","Adazi","Latvia","LVA","admin",7154],
[1440899932,"Naujoji Akmenė","Naujoji Akmene","Lithuania","LTU","admin",7194],
[1826320300,"Grangetown","Grangetown","United Kingdom","GBR","",5088],
[1036339460,"Worragee","Worragee","Australia","AUS","",5068],
[1840003634,"Dunellen","Dunellen","United States","USA","",7202],
[1800270160,"Nakasongola","Nakasongola","Uganda","UGA","admin",6921],
[1840000699,"Glenolden","Glenolden","United States","USA","",7164],
[1840004981,"Nyack","Nyack","United States","USA","",7156],
[1428407271,"Aizkraukle","Aizkraukle","Latvia","LVA","admin",7044],
[1124000763,"Hampstead","Hampstead","Canada","CAN","",7153],
[1498280582,"Donduşeni","Donduseni","Moldova","MDA","admin",7101],
[1630035578,"San Lorenzo","San Lorenzo","Puerto Rico","PRI","",7134],
[1462235059,"Mahibadhoo","Mahibadhoo","Maldives","MDV","admin",0],
[1840001378,"Souderton","Souderton","United States","USA","",7082],
[1372399438,"Monaghan","Monaghan","Ireland","IRL","admin",5937],
[1630023682,"Yabucoa","Yabucoa","Puerto Rico","PRI","",7070],
[1678096936,"Trindade","Trindade","Sao Tome And Principe","STP","admin",6636],
[1840000708,"Ridley Park","Ridley Park","United States","USA","",7065],
[1826178379,"Heage","Heage","United Kingdom","GBR","",5013],
[1428769984,"Līvāni","Livani","Latvia","LVA","admin",7035],
[1630035575,"San Isidro","San Isidro","Puerto Rico","PRI","",7046],
[1012000031,"In Guezzam","In Guezzam","Algeria","DZA","admin",7045],
[1840005292,"Great Neck Plaza","Great Neck Plaza","United States","USA","",7027],
[1840011309,"Orland Hills","Orland Hills","United States","USA","",7023],
[1705251132,"Brežice","Brezice","Slovenia","SVN","admin",6843],
[1428888445,"Gulbene","Gulbene","Latvia","LVA","admin",6982],
[1031370337,"Oğuz","Oguz","Azerbaijan","AZE","admin",6876],
[1428920312,"Limbaži","Limbazi","Latvia","LVA","admin",6888],
[1470901810,"Luqa","Luqa","Malta","MLT","admin",5945],
[1418448631,"Salavan","Salavan","Laos","LAO","admin",5521],
[1840005474,"Twin Rivers","Twin Rivers","United States","USA","",6870],
[1630023710,"Las Piedras","Las Piedras","Puerto Rico","PRI","",6835],
[1428548117,"Madona","Madona","Latvia","LVA","admin",6792],
[1840005265,"Hewlett","Hewlett","United States","USA","",6802],
[1462623341,"Eydhafushi","Eydhafushi","Maldives","MDV","admin",0],
[1498171854,"Criuleni","Criuleni","Moldova","MDA","admin",6708],
[1688530993,"Kovačica","Kovacica","Serbia","SRB","admin",6764],
[1840034062,"South Valley Stream","South Valley Stream","United States","USA","",6775],
[1440401402,"Šalčininkai","Salcininkai","Lithuania","LTU","admin",6715],
[1516958242,"Opuwo","Opuwo","Namibia","NAM","admin",4857],
[1840000692,"Clifton Heights","Clifton Heights","United States","USA","",6697],
[1840017271,"Lauderdale-by-the-Sea","Lauderdale-by-the-Sea","United States","USA","",6664],
[1554001293,"Stratford","Stratford","New Zealand","NZL","admin",5740],
[1840039286,"Notre Dame","Notre Dame","United States","USA","",6646],
[1840005339,"Cedarhurst","Cedarhurst","United States","USA","",6633],
[1840000698,"Folcroft","Folcroft","United States","USA","",6632],
[1840021948,"Guadalupe","Guadalupe","United States","USA","",6631],
[1840005306,"Manorhaven","Manorhaven","United States","USA","",6627],
[1630035555,"Puerto Real","Puerto Real","Puerto Rico","PRI","",6621],
[1840029578,"Ewa Villages","Ewa Villages","United States","USA","",6585],
[1840043043,"South Monrovia Island","South Monrovia Island","United States","USA","",6572],
[1840028422,"Contra Costa Centre","Contra Costa Centre","United States","USA","",6558],
[1840004946,"Tuckahoe","Tuckahoe","United States","USA","",6549],
[1428873095,"Alūksne","Aluksne","Latvia","LVA","admin",6535],
[1764090874,"Mae Hong Son","Mae Hong Son","Thailand","THA","admin",6526],
[1840017682,"Castroville","Castroville","United States","USA","",6521],
[1840001274,"West View","West View","United States","USA","",6516],
[1840014232,"Naples Manor","Naples Manor","United States","USA","",6507],
[1688635508,"Bogatić","Bogatic","Serbia","SRB","admin",6488],
[1840000707,"Prospect Park","Prospect Park","United States","USA","",6492],
[1840003693,"Ambler","Ambler","United States","USA","",6491],
[1840005824,"Forest Glen","Forest Glen","United States","USA","",6469],
[1840004949,"Bronxville","Bronxville","United States","USA","",6408],
[1840033314,"Kingston Estates","Kingston Estates","United States","USA","",6407],
[1132420232,"Sal Rei","Sal Rei","Cabo Verde","CPV","admin",6357],
[1440957197,"Pasvalys","Pasvalys","Lithuania","LTU","admin",6361],
[1233192849,"Jõgeva","Jogeva","Estonia","EST","admin",5073],
[1072132620,"Ghanzi","Ghanzi","Botswana","BWA","admin",6306],
[1233866730,"Põlva","Polva","Estonia","EST","admin",5324],
[1132760152,"Espargos","Espargos","Cabo Verde","CPV","admin",6173],
[1462657112,"Funadhoo","Funadhoo","Maldives","MDV","admin",0],
[1807183974,"Kavadarci","Kavadarci","Macedonia","MKD","admin",6228],
[1688400393,"Bački Petrovac","Backi Petrovac","Serbia","SRB","admin",6155],
[1840037105,"Cameron Park","Cameron Park","United States","USA","",6241],
[1840024710,"Saranap","Saranap","United States","USA","",6231],
[1438982330,"Schaan","Schaan","Liechtenstein","LIE","admin",5998],
[1840001428,"Kennett Square","Kennett Square","United States","USA","",6202],
[1428460035,"Preiļi","Preili","Latvia","LVA","admin",6161],
[1901042958,"Mamushë","Mamushe","Kosovo","XKS","admin",5507],
[1626768340,"Viqueque","Viqueque","Timor-Leste","TLS","admin",6078],
[1901930204,"Junik","Junik","Kosovo","XKS","admin",6084],
[1748933140,"Siteki","Siteki","Swaziland","SWZ","admin",6152],
[1388423676,"Lucea","Lucea","Jamaica","JAM","admin",6002],
[1233013333,"Rapla","Rapla","Estonia","EST","admin",5069],
[1108441253,"Rutana","Rutana","Burundi","BDI","admin",5865],
[1218093882,"Puerto Baquerizo Moreno","Puerto Baquerizo Moreno","Ecuador","ECU","admin",6140],
[1840039268,"West Loch Estate","West Loch Estate","United States","USA","",6139],
[1840005269,"Lakeview","Lakeview","United States","USA","",6131],
[1840043235,"Binghamton University","Binghamton University","United States","USA","",6130],
[1756095767,"Glarus","Glarus","Switzerland","CHE","admin",5996],
[1031379235,"Cəbrayıl","Cabrayil","Azerbaijan","AZE","admin",6070],
[1840075898,"Fruitridge Pocket","Fruitridge Pocket","United States","USA","",6116],
[1688168992,"Bač","Bac","Serbia","SRB","admin",6087],
[1756770881,"Appenzell","Appenzell","Switzerland","CHE","admin",5750],
[1840004934,"Larchmont","Larchmont","United States","USA","",6087],
[1630035613,"Arroyo","Arroyo","Puerto Rico","PRI","",6076],
[1840074532,"Pleasure Point","Pleasure Point","United States","USA","",6076],
[1470805169,"Vittoriosa","Vittoriosa","Malta","MLT","admin",2629],
[1705079549,"Sežana","Sezana","Slovenia","SVN","admin",6037],
[1440450872,"Zarasai","Zarasai","Lithuania","LTU","admin",6051],
[1705942287,"Zagorje","Zagorje","Slovenia","SVN","admin",6023],
[1108007544,"Muramvya","Muramvya","Burundi","BDI","admin",5458],
[1840005972,"District Heights","District Heights","United States","USA","",5984],
[1470720892,"Marsa","Marsa","Malta","MLT","admin",4401],
[1840073633,"Naval Academy","Naval Academy","United States","USA","",5970],
[1840041547,"Savannah","Savannah","United States","USA","",5953],
[1516820698,"Outapi","Outapi","Namibia","NAM","admin",4606],
[1470648445,"Għaxaq","Ghaxaq","Malta","MLT","admin",4722],
[1840035305,"Penn Wynne","Penn Wynne","United States","USA","",5932],
[1442794725,"Echternach","Echternach","Luxembourg","LUX","admin",5650],
[1440122297,"Kupiškis","Kupiskis","Lithuania","LTU","admin",5907],
[1705132468,"Črnomelj","Crnomelj","Slovenia","SVN","admin",5496],
[1705472042,"Idrija","Idrija","Slovenia","SVN","admin",5886],
[1705187949,"Prevalje","Prevalje","Slovenia","SVN","admin",4620],
[1840000705,"Norwood","Norwood","United States","USA","",5897],
[1840003637,"Jamesburg","Jamesburg","United States","USA","",5885],
[1901029901,"Ranillug","Ranillug","Kosovo","XKS","admin",5800],
[1840028387,"Mayflower Village","Mayflower Village","United States","USA","",5873],
[1840005574,"Elsmere","Elsmere","United States","USA","",5872],
[1470862409,"Lija","Lija","Malta","MLT","admin",3070],
[1428606162,"Balvi","Balvi","Latvia","LVA","admin",5840],
[1840001244,"McKees Rocks","McKees Rocks","United States","USA","",5855],
[1124185024,"Charlemagne","Charlemagne","Canada","CAN","",5853],
[1840000834,"Prospect Park","Prospect Park","United States","USA","",5843],
[1630035647,"Cidra","Cidra","Puerto Rico","PRI","",5835],
[1598571197,"Lorengau","Lorengau","Papua New Guinea","PNG","admin",5806],
[1705818009,"Hrastnik","Hrastnik","Slovenia","SVN","admin",4962],
[1840000767,"Plymouth","Plymouth","United States","USA","",5794],
[1840016005,"Bay Harbor Islands","Bay Harbor Islands","United States","USA","",5793],
[1840037177,"White City","White City","United States","USA","",5768],
[1840000846,"Mount Carmel","Mount Carmel","United States","USA","",5724],
[1840013164,"Bellevue","Bellevue","United States","USA","",5721],
[1840022100,"South Tucson","South Tucson","United States","USA","",5715],
[1156759821,"Fulin","Fulin","China","CHN","",1049],
[1840003531,"Lewisburg","Lewisburg","United States","USA","",5708],
[1191887616,"Gospić","Gospic","Croatia","HRV","admin",5695],
[1304160154,"Sisimiut","Sisimiut","Greenland","GRL","admin",5539],
[1442345477,"Wiltz","Wiltz","Luxembourg","LUX","admin",5427],
[1624294223,"Cacheu","Cacheu","Guinea-Bissau","GNB","admin",5674],
[1840000711,"Sharon Hill","Sharon Hill","United States","USA","",5689],
[1031598031,"Babək","Babak","Azerbaijan","AZE","admin",5600],
[1840000702,"Media","Media","United States","USA","",5682],
[1840001026,"New Brighton","New Brighton","United States","USA","",5679],
[1598925932,"Kerema","Kerema","Papua New Guinea","PNG","admin",5646],
[1800307801,"Koboko","Koboko","Uganda","UGA","admin",0],
[1840017278,"Surfside","Surfside","United States","USA","",5651],
[1840081801,"Rochelle Park","Rochelle Park","United States","USA","",5597],
[1901909986,"Partesh","Partesh","Kosovo","XKS","admin",5300],
[1840003815,"Deer Park","Deer Park","United States","USA","",5566],
[1440371651,"Kazlų Rūda","Kazlu Ruda","Lithuania","LTU","admin",5539],
[1840001355,"Belmar","Belmar","United States","USA","",5545],
[1600103814,"Caazapá","Caazapa","Paraguay","PRY","admin",5504],
[1840028586,"Shaw Heights","Shaw Heights","United States","USA","",5529],
[1840047821,"Palm Springs North","Palm Springs North","United States","USA","",5525],
[1440110307,"Molėtai","Moletai","Lithuania","LTU","admin",5497],
[1426611266,"Thaba-Tseka","Thaba-Tseka","Lesotho","LSO","admin",5423],
[1004947440,"Qal‘ah-ye Now","Qal`ah-ye Now","Afghanistan","AFG","admin",5340],
[1840029562,"Waipio Acres","Waipio Acres","United States","USA","",5451],
[1270000000,"Kanifing","Kanifing","The Gambia","GMB","admin",0],
[1840029006,"South Highpoint","South Highpoint","United States","USA","",5435],
[1438826448,"Triesen","Triesen","Liechtenstein","LIE","admin",5230],
[1470781874,"Xagħra","Xaghra","Malta","MLT","admin",4886],
[1840073677,"Friendship Heights Village","Friendship Heights Village","United States","USA","",5396],
[1372870384,"Ros Comáin","Ros Comain","Ireland","IRL","admin",4860],
[1840004977,"Kaser","Kaser","United States","USA","",5368],
[1404390868,"Kiambu","Kiambu","Kenya","KEN","admin",0],
[1630023590,"Añasco","Anasco","Puerto Rico","PRI","",5355],
[1124599436,"L’Epiphanie","L'Epiphanie","Canada","CAN","",5353],
[1840020196,"Edgewater","Edgewater","United States","USA","",5335],
[1840017613,"Kensington","Kensington","United States","USA","",5329],
[1800446257,"Kalangala","Kalangala","Uganda","UGA","admin",5200],
[1840001188,"Shillington","Shillington","United States","USA","",5319],
[1132502171,"Tarrafal","Tarrafal","Cabo Verde","CPV","admin",5237],
[1064353953,"Wangdue Phodrang","Wangdue Phodrang","Bhutan","BTN","admin",5000],
[1630023545,"Santa Isabel","Santa Isabel","Puerto Rico","PRI","",5248],
[1740921776,"Albina","Albina","Suriname","SUR","admin",5247],
[1800434608,"Soroti","Soroti","Uganda","UGA","admin",1038],
[1470802229,"Pembroke","Pembroke","Malta","MLT","admin",3645],
[1840005227,"Albertson","Albertson","United States","USA","",5225],
[1840006974,"Highwood","Highwood","United States","USA","",5224],
[1428331173,"Ķekava","Kekava","Latvia","LVA","admin",5134],
[1840019030,"Cutler","Cutler","United States","USA","",5214],
[1630035528,"Naguabo","Naguabo","Puerto Rico","PRI","",5210],
[1705506460,"Slovenske Konjice","Slovenske Konjice","Slovenia","SVN","admin",5157],
[1442392954,"Grevenmacher","Grevenmacher","Luxembourg","LUX","admin",4981],
[1840028200,"Twin Lakes","Twin Lakes","United States","USA","",5196],
[1226970205,"Palé","Pale","Equatorial Guinea","GNQ","admin",5008],
[1840017623,"Broadmoor","Broadmoor","United States","USA","",5170],
[1428035157,"Smiltene","Smiltene","Latvia","LVA","admin",5151],
[1626054379,"Liquiçá","Liquica","Timor-Leste","TLS","admin",5152],
[1840036997,"Bret Harte","Bret Harte","United States","USA","",5148],
[1630023556,"Peñuelas","Penuelas","Puerto Rico","PRI","",5142],
[1840028450,"Glendale","Glendale","United States","USA","",5141],
[1840001267,"Turtle Creek","Turtle Creek","United States","USA","",5138],
[1470985739,"Nadur","Nadur","Malta","MLT","admin",4509],
[1840005234,"Carle Place","Carle Place","United States","USA","",5131],
[1840017244,"Kenneth City","Kenneth City","United States","USA","",5121],
[1840028315,"Tara Hills","Tara Hills","United States","USA","",5117],
[1440264405,"Skuodas","Skuodas","Lithuania","LTU","admin",5083],
[1840015979,"South Pasadena","South Pasadena","United States","USA","",5095],
[1304656747,"Ilulissat","Ilulissat","Greenland","GRL","admin",4670],
[1124001742,"Montréal-Ouest","Montreal-Ouest","Canada","CAN","",5085],
[1807187187,"Vrapčište","Vrapciste","Macedonia","MKD","admin",4874],
[1630035570,"Salinas","Salinas","Puerto Rico","PRI","",5051],
[1705340993,"Žalec","Zalec","Slovenia","SVN","admin",5000],
[1840000368,"Mechanicville","Mechanicville","United States","USA","",5037],
[1084536442,"Punta Gorda","Punta Gorda","Belize","BLZ","admin",5026],
[1064171188,"Punakha","Punakha","Bhutan","BTN","admin",5000],
[1064763429,"Samtse","Samtse","Bhutan","BTN","admin",4981],
[1807600399,"Gevgelija","Gevgelija","Macedonia","MKD","admin",4967],
[1440362808,"Šakiai","Sakiai","Lithuania","LTU","admin",4998],
[1004564619,"Aībak","Aibak","Afghanistan","AFG","admin",4938],
[1438767966,"Mauren","Mauren","Liechtenstein","LIE","admin",4404],
[1470330332,"Iklin","Iklin","Malta","MLT","admin",3130],
[1705076635,"Šentjur","Sentjur","Slovenia","SVN","admin",4940],
[1705655016,"Bled","Bled","Slovenia","SVN","admin",4929],
[1740547119,"Nieuw Amsterdam","Nieuw Amsterdam","Suriname","SUR","admin",4935],
[1340110055,"Puerto Lempira","Puerto Lempira","Honduras","HND","admin",4856],
[1624958412,"Bolama","Bolama","Guinea-Bissau","GNB","admin",4819],
[1438692471,"Eschen","Eschen","Liechtenstein","LIE","admin",4459],
[1688660485,"Irig","Irig","Serbia","SRB","admin",4848],
[1438263000,"Balzers","Balzers","Liechtenstein","LIE","admin",4628],
[1234149995,"Klaksvík","Klaksvik","Faroe Islands","FRO","admin",4664],
[1096999548,"Kuala Belait","Kuala Belait","Brunei","BRN","admin",4259],
[1704000203,"Hưng Yên","Hung Yen","Vietnam","VNM","admin",0],
[1108963889,"Bururi","Bururi","Burundi","BDI","admin",4478],
[1231698892,"Gambēla","Gambela","Ethiopia","ETH","admin",0],
[1470089344,"Floriana","Floriana","Malta","MLT","admin",2205],
[1688200508,"Čoka","Coka","Serbia","SRB","admin",4707],
[1807341711,"Radoviš","Radovis","Macedonia","MKD","admin",4678],
[1470563392,"Kalkara","Kalkara","Malta","MLT","admin",3014],
[1440106904,"Šilalė","Silale","Lithuania","LTU","admin",4640],
[1020655238,"Ordino","Ordino","Andorra","AND","admin",4545],
[1470934982,"Imqabba","Imqabba","Malta","MLT","admin",3315],
[1764944006,"Bueng Kan","Bueng Kan","Thailand","THA","admin",4494],
[1705218575,"Sevnica","Sevnica","Slovenia","SVN","admin",4533],
[1428763918,"Valka","Valka","Latvia","LVA","admin",4510],
[1442971283,"Remich","Remich","Luxembourg","LUX","admin",3787],
[1031808614,"Şuşa","Susa","Azerbaijan","AZE","admin",4446],
[1440324561,"Trakai","Trakai","Lithuania","LTU","admin",4430],
[1388022504,"Black River","Black River","Jamaica","JAM","admin",4261],
[1705130450,"Dravograd","Dravograd","Slovenia","SVN","admin",3088],
[1440570493,"Pakruojis","Pakruojis","Lithuania","LTU","admin",4352],
[1132758433,"João Teves","Joao Teves","Cabo Verde","CPV","admin",0],
[1705031705,"Ilirska Bistrica","Ilirska Bistrica","Slovenia","SVN","admin",4323],
[1470798142,"Gudja","Gudja","Malta","MLT","admin",2997],
[1705932096,"Cerknica","Cerknica","Slovenia","SVN","admin",4018],
[1470596833,"Marsaxlokk","Marsaxlokk","Malta","MLT","admin",3534],
[1705962698,"Laško","Lasko","Slovenia","SVN","admin",3288],
[1705417281,"Ruše","Ruse","Slovenia","SVN","admin",4208],
[1705397569,"Šempeter pri Gorici","Sempeter pri Gorici","Slovenia","SVN","admin",3694],
[1470281352,"Dingli","Dingli","Malta","MLT","admin",3608],
[1430964557,"Bensonville","Bensonville","Liberia","LBR","admin",4089],
[1132750609,"Calheta de São Miguel","Calheta de Sao Miguel","Cabo Verde","CPV","admin",4123],
[1792507574,"Tunceli","Tunceli","Turkey","TUR","admin",4169],
[1470075119,"Kirkop","Kirkop","Malta","MLT","admin",2191],
[1470917815,"Għargħur","Gharghur","Malta","MLT","admin",2768],
[1020594179,"Canillo","Canillo","Andorra","AND","admin",4103],
[1705440220,"Žiri","Ziri","Slovenia","SVN","admin",3657],
[1705643923,"Gornja Radgona","Gornja Radgona","Slovenia","SVN","admin",3086],
[1800845749,"Kaberamaido","Kaberamaido","Uganda","UGA","admin",3400],
[1440170338,"Švenčionys","Svencionys","Lithuania","LTU","admin",4065],
[1598428400,"Wabag","Wabag","Papua New Guinea","PNG","admin",3958],
[1470040289,"Xewkija","Xewkija","Malta","MLT","admin",3300],
[1031176858,"Ağdam","Agdam","Azerbaijan","AZE","admin",3770],
[1800917331,"Bugiri","Bugiri","Uganda","UGA","admin",0],
[1705570941,"Trebnje","Trebnje","Slovenia","SVN","admin",3927],
[1901189818,"Deçan","Decan","Kosovo","XKS","admin",3803],
[1233977488,"Kärdla","Kardla","Estonia","EST","admin",3230],
[1705085466,"Piran","Piran","Slovenia","SVN","admin",3730],
[1440799248,"Kalvarija","Kalvarija","Lithuania","LTU","admin",3766],
[1270430701,"Janjanbureh","Janjanbureh","The Gambia","GMB","admin",3584],
[1108631099,"Cankuzo","Cankuzo","Burundi","BDI","admin",3624],
[1462282241,"Kudahuvadhoo","Kudahuvadhoo","Maldives","MDV","admin",0],
[1800980026,"Moroto","Moroto","Uganda","UGA","admin",371],
[1148928302,"Massenya","Massenya","Chad","TCD","admin",3680],
[1470038163,"Imġarr","Imgarr","Malta","MLT","admin",3629],
[1440584882,"Lazdijai","Lazdijai","Lithuania","LTU","admin",3629],
[1807873177,"Berovo","Berovo","Macedonia","MKD","admin",3619],
[1705521676,"Ankaran","Ankaran","Slovenia","SVN","admin",3224],
[1807741715,"Kruševo","Krusevo","Macedonia","MKD","admin",3570],
[1470946814,"Imtarfa","Imtarfa","Malta","MLT","admin",2572],
[1418920136,"Louang Namtha","Louang Namtha","Laos","LAO","admin",3225],
[1418805827,"Xai","Xai","Laos","LAO","admin",0],
[1807880409,"Sveti Nikole","Sveti Nikole","Macedonia","MKD","admin",3468],
[1688161411,"Tutin","Tutin","Serbia","SRB","admin",0],
[1498973808,"Cantemir","Cantemir","Moldova","MDA","admin",3429],
[1470535936,"Xgħajra","Xghajra","Malta","MLT","admin",1732],
[1688248362,"Alibunar","Alibunar","Serbia","SRB","admin",3431],
[1800806239,"Hoima","Hoima","Uganda","UGA","admin",0],
[1626118494,"Ainaro","Ainaro","Timor-Leste","TLS","admin",3085],
[1462969197,"Kulhudhuffushi","Kulhudhuffushi","Maldives","MDV","admin",0],
[1470797535,"Qrendi","Qrendi","Malta","MLT","admin",2752],
[1705719159,"Lenart v Slovenskih Goricah","Lenart v Slovenskih Goricah","Slovenia","SVN","admin",3285],
[1428511061,"Ulbroka","Ulbroka","Latvia","LVA","admin",3102],
[1705607524,"Mežica","Mezica","Slovenia","SVN","admin",3176],
[1807182004,"Demir Kapija","Demir Kapija","Macedonia","MKD","admin",3275],
[1428934591,"Saulkrasti","Saulkrasti","Latvia","LVA","admin",3120],
[1462781201,"Thinadhoo","Thinadhoo","Maldives","MDV","admin",0],
[1740072928,"Groningen","Groningen","Suriname","SUR","admin",3216],
[1705008169,"Metlika","Metlika","Slovenia","SVN","admin",3229],
[1304746917,"Qaqortoq","Qaqortoq","Greenland","GRL","admin",3093],
[1470050658,"Għajnsielem","Ghajnsielem","Malta","MLT","admin",3200],
[1454732693,"Balaka","Balaka","Malawi","MWI","admin",0],
[1116605438,"Banlung","Banlung","Cambodia","KHM","admin",0],
[1440780088,"Rietavas","Rietavas","Lithuania","LTU","admin",3149],
[1031323095,"Şahbuz","Sahbuz","Azerbaijan","AZE","admin",3127],
[1705665714,"Borovnica","Borovnica","Slovenia","SVN","admin",2674],
[1132346974,"Porto Inglês","Porto Ingles","Cabo Verde","CPV","admin",3056],
[1807161783,"Delčevo","Delcevo","Macedonia","MKD","admin",3033],
[1304194714,"Aasiaat","Aasiaat","Greenland","GRL","admin",3069],
[1454325221,"Rumphi","Rumphi","Malawi","MWI","admin",0],
[1470417421,"Safi","Safi","Malta","MLT","admin",2126],
[1372547040,"Tallaght","Tallaght","Ireland","IRL","admin",0],
[1328749920,"Lethem","Lethem","Guyana","GUY","admin",3000],
[1328079873,"Mabaruma","Mabaruma","Guyana","GUY","admin",2972],
[1496666560,"Mandalgovĭ","Mandalgovi","Mongolia","MNG","admin",2984],
[1705653525,"Lendava","Lendava","Slovenia","SVN","admin",2954],
[1807565779,"Bogdanci","Bogdanci","Macedonia","MKD","admin",2951],
[1705662463,"Vojnik","Vojnik","Slovenia","SVN","admin",2475],
[1372662642,"Wicklow","Wicklow","Ireland","IRL","admin",0],
[1462000004,"Thulusdhoo","Thulusdhoo","Maldives","MDV","admin",0],
[1780753308,"Arima","Arima","Trinidad And Tobago","TTO","admin",0],
[1470427419,"Fontana","Fontana","Malta","MLT","admin",985],
[1116571704,"Ta Khmau","Ta Khmau","Cambodia","KHM","admin",0],
[1132246964,"São Domingos","Sao Domingos","Cabo Verde","CPV","admin",2818],
[1705478193,"Radlje ob Dravi","Radlje ob Dravi","Slovenia","SVN","admin",2856],
[1270976260,"Kerewan","Kerewan","The Gambia","GMB","admin",2751],
[1688854200,"Aranđelovac","Arandelovac","Serbia","SRB","admin",0],
[1462000003,"Rasdhoo","Rasdhoo","Maldives","MDV","admin",0],
[1462109783,"Dhihdhoo","Dhihdhoo","Maldives","MDV","admin",0],
[1430129873,"Barclayville","Barclayville","Liberia","LBR","admin",2733],
[1438813592,"Triesenberg","Triesenberg","Liechtenstein","LIE","admin",2643],
[1634097551,"Ar Rayyān","Ar Rayyan","Qatar","QAT","admin",0],
[1807848381,"Negotino","Negotino","Macedonia","MKD","admin",2683],
[1470546177,"Sannat","Sannat","Malta","MLT","admin",2117],
[1470520722,"Qala","Qala","Malta","MLT","admin",2284],
[1834546025,"Bariadi","Bariadi","Tanzania","TZA","admin",0],
[1430708587,"Cestos City","Cestos City","Liberia","LBR","admin",2578],
[1583000000,"Tofol","Tofol","Federated States of Micronesia","FSM","admin",2591],
[1438787609,"Ruggell","Ruggell","Liechtenstein","LIE","admin",2295],
[1706512367,"Garoowe","Garoowe","Somalia","SOM","admin",2568],
[1800102352,"Wakiso","Wakiso","Uganda","UGA","admin",0],
[1800170407,"Kapchorwa","Kapchorwa","Uganda","UGA","admin",0],
[1688450536,"Ivanjica","Ivanjica","Serbia","SRB","admin",0],
[1807108428,"Vevčani","Vevcani","Macedonia","MKD","admin",2416],
[1600444658,"Fuerte Olimpo","Fuerte Olimpo","Paraguay","PRY","admin",2475],
[1705238814,"Beltinci","Beltinci","Slovenia","SVN","admin",2430],
[1404620707,"Kabarnet","Kabarnet","Kenya","KEN","admin",0],
[1440271703,"Nida","Nida","Lithuania","LTU","admin",2385],
[1704841896,"Phủ Lý","Phu Ly","Vietnam","VNM","admin",0],
[1440134144,"Birštonas","Birstonas","Lithuania","LTU","admin",2331],
[1442979391,"Vianden","Vianden","Luxembourg","LUX","admin",2161],
[1800500326,"Bundibugyo","Bundibugyo","Uganda","UGA","admin",0],
[1800297508,"Yumbe","Yumbe","Uganda","UGA","admin",0],
[1031245091,"Laçın","Lacin","Azerbaijan","AZE","admin",2190],
[1470847062,"Kerċem","Kercem","Malta","MLT","admin",1938],
[1442533571,"Capellen","Capellen","Luxembourg","LUX","admin",1986],
[1800864322,"Mukono","Mukono","Uganda","UGA","admin",0],
[1116098692,"Sihanoukville","Sihanoukville","Cambodia","KHM","admin",0],
[1834469543,"Geita","Geita","Tanzania","TZA","admin",1536],
[1705637872,"Naklo","Naklo","Slovenia","SVN","admin",1776],
[1807080471,"Gradsko","Gradsko","Macedonia","MKD","admin",2219],
[1132073400,"Cidade Velha","Cidade Velha","Cabo Verde","CPV","admin",2148],
[1688522811,"Priboj","Priboj","Serbia","SRB","admin",0],
[1372974181,"Clonmel","Clonmel","Ireland","IRL","admin",0],
[1404478510,"Migori","Migori","Kenya","KEN","admin",0],
[1454510180,"Phalombe","Phalombe","Malawi","MWI","admin",0],
[1404000102,"Iten","Iten","Kenya","KEN","admin",0],
[1740007571,"Onverwacht","Onverwacht","Suriname","SUR","admin",2105],
[1454413713,"Chiradzulu","Chiradzulu","Malawi","MWI","admin",1580],
[1626402267,"Same","Same","Timor-Leste","TLS","admin",2100],
[1688452613,"Jagodina","Jagodina","Serbia","SRB","admin",0],
[1404597807,"Kerugoya","Kerugoya","Kenya","KEN","admin",0],
[1462464790,"Veymandoo","Veymandoo","Maldives","MDV","admin",0],
[1360431437,"Sofifi","Sofifi","Indonesia","IDN","admin",2000],
[1705329272,"Šentjernej","Sentjernej","Slovenia","SVN","admin",1441],
[1705864633,"Vipava","Vipava","Slovenia","SVN","admin",2049],
[1268370586,"Ambrolauri","Ambrolauri","Georgia","GEO","admin",2047],
[1705420341,"Radeče","Radece","Slovenia","SVN","admin",1993],
[1807423601,"Valandovo","Valandovo","Macedonia","MKD","admin",1992],
[1430478203,"Buchanan","Buchanan","Liberia","LBR","admin",0],
[1705413437,"Ormož","Ormoz","Slovenia","SVN","admin",1962],
[1705639122,"Vuzenica","Vuzenica","Slovenia","SVN","admin",1522],
[1470116785,"Munxar","Munxar","Malta","MLT","admin",1454],
[1807058849,"Kriva Palanka","Kriva Palanka","Macedonia","MKD","admin",1967],
[1462034411,"Viligili","Viligili","Maldives","MDV","admin",0],
[1807262234,"Kratovo","Kratovo","Macedonia","MKD","admin",1925],
[1800299361,"Kaabong","Kaabong","Uganda","UGA","admin",1137],
[1499125825,"Žabljak","Zabljak","Montenegro","MNE","admin",1937],
[1438568521,"Gamprin","Gamprin","Liechtenstein","LIE","admin",1663],
[1807293579,"Krivogaštani","Krivogastani","Macedonia","MKD","admin",1870],
[1807046032,"Zrnovci","Zrnovci","Macedonia","MKD","admin",1864],
[1404000104,"Nyamira","Nyamira","Kenya","KEN","admin",0],
[1807691189,"Sopište","Sopiste","Macedonia","MKD","admin",690],
[1372676556,"Trim","Trim","Ireland","IRL","admin",0],
[1470113453,"Għarb","Gharb","Malta","MLT","admin",1539],
[1800896564,"Lyantonde","Lyantonde","Uganda","UGA","admin",0],
[1705912877,"Odranci","Odranci","Slovenia","SVN","admin",1632],
[1591177082,"La Palma","La Palma","Panama","PAN","admin",1845],
[1462406280,"Hithadhoo","Hithadhoo","Maldives","MDV","admin",0],
[1090349580,"Kirakira","Kirakira","Solomon Islands","SLB","admin",0],
[1688640421,"Šabac","Sabac","Serbia","SRB","admin",0],
[1090993143,"Auki","Auki","Solomon Islands","SLB","admin",0],
[1478696248,"Dar Naim","Dar Naim","Mauritania","MRT","admin",0],
[1454566785,"Machinga","Machinga","Malawi","MWI","admin",1418],
[1372960774,"Carrick on Shannon","Carrick on Shannon","Ireland","IRL","admin",0],
[1428435689,"Varakļāni","Varaklani","Latvia","LVA","admin",1730],
[1478255260,"Aioun","Aioun","Mauritania","MRT","admin",1423],
[1704905946,"Vĩnh Yên","Vinh Yen","Vietnam","VNM","admin",0],
[1807666030,"Pehčevo","Pehcevo","Macedonia","MKD","admin",1687],
[1740738832,"Totness","Totness","Suriname","SUR","admin",1685],
[1428220999,"Ropaži","Ropazi","Latvia","LVA","admin",1661],
[1104530702,"Mawlamyine","Mawlamyine","Myanmar","MMR","admin",2],
[1706568226,"Xuddur","Xuddur","Somalia","SOM","admin",1639],
[1807030257,"Plasnica","Plasnica","Macedonia","MKD","admin",1584],
[1688344019,"Smederevo","Smederevo","Serbia","SRB","admin",0],
[1174539766,"Fomboni","Fomboni","Comoros","COM","admin",0],
[1800970850,"Bududa","Bududa","Uganda","UGA","admin",0],
[1688798017,"Arilje","Arilje","Serbia","SRB","admin",0],
[1807139125,"Tearce","Tearce","Macedonia","MKD","admin",1475],
[1688664018,"Vladičin Han","Vladicin Han","Serbia","SRB","admin",0],
[1404087664,"Sotik Post","Sotik Post","Kenya","KEN","admin",0],
[1462456773,"Felidhoo","Felidhoo","Maldives","MDV","admin",0],
[1705609781,"Bovec","Bovec","Slovenia","SVN","admin",1586],
[1688051556,"Nova Varoš","Nova Varos","Serbia","SRB","admin",0],
[1442118762,"Clervaux","Clervaux","Luxembourg","LUX","admin",1468],
[1372035774,"Tullamore","Tullamore","Ireland","IRL","admin",0],
[1800257696,"Manafwa","Manafwa","Uganda","UGA","admin",0],
[1404066738,"Murang’a","Murang'a","Kenya","KEN","admin",0],
[1462000002,"Foammulah","Foammulah","Maldives","MDV","admin",0],
[1706765820,"Bu’aale","Bu'aale","Somalia","SOM","admin",1490],
[1807583335,"Mogila","Mogila","Macedonia","MKD","admin",1480],
[1688343996,"Kuršumlija","Kursumlija","Serbia","SRB","admin",0],
[1688573505,"Aleksandrovac","Aleksandrovac","Serbia","SRB","admin",0],
[1418000082,"Xékong","Xekong","Laos","LAO","admin",0],
[1372066739,"Castlebar","Castlebar","Ireland","IRL","admin",0],
[1031237556,"Xocalı","Xocali","Azerbaijan","AZE","admin",1397],
[1462000005,"Nilandhoo","Nilandhoo","Maldives","MDV","admin",0],
[1418088090,"Pakxan","Pakxan","Laos","LAO","admin",0],
[1090931394,"Taro","Taro","Solomon Islands","SLB","admin",0],
[1438649917,"Schellenberg","Schellenberg","Liechtenstein","LIE","admin",1091],
[1144602660,"Kurunegala","Kurunegala","Sri Lanka","LKA","admin",0],
[1328178268,"Vreed-en-Hoop","Vreed-en-Hoop","Guyana","GUY","admin",0],
[1678729743,"Santo António","Santo Antonio","Sao Tome And Principe","STP","admin",1300],
[1688363978,"Gornji Milanovac","Gornji Milanovac","Serbia","SRB","admin",0],
[1688519603,"Svrljig","Svrljig","Serbia","SRB","admin",0],
[1807743098,"Novo Selo","Novo Selo","Macedonia","MKD","admin",1246],
[1704410655,"Tam Kỳ","Tam Ky","Vietnam","VNM","admin",0],
[1807936735,"Novaci","Novaci","Macedonia","MKD","admin",1283],
[1800067821,"Luwero","Luwero","Uganda","UGA","admin",0],
[1705488511,"Radovljica","Radovljica","Slovenia","SVN","admin",0],
[1807663389,"Rosoman","Rosoman","Macedonia","MKD","admin",1247],
[1090442496,"Lata","Lata","Solomon Islands","SLB","admin",553],
[1528346417,"Oranjestad","Oranjestad","Netherlands","NLD","admin",1021],
[1372969205,"Mullingar","Mullingar","Ireland","IRL","admin",0],
[1800300606,"Mayuge","Mayuge","Uganda","UGA","admin",0],
[1887433410,"‘Amrān","`Amran","Yemen","YEM","admin",0],
[1012763655,"Aïn Temouchent","Ain Temouchent","Algeria","DZA","admin",0],
[1688129790,"Raška","Raska","Serbia","SRB","admin",0],
[1372905339,"Longford","Longford","Ireland","IRL","admin",0],
[1688324137,"Pirot","Pirot","Serbia","SRB","admin",0],
[1674000000,"Serravalle","Serravalle","San Marino","SMR","admin",0],
[1688111468,"Prokuplje","Prokuplje","Serbia","SRB","admin",0],
[1688936225,"Brus","Brus","Serbia","SRB","admin",0],
[1688920744,"Surdulica","Surdulica","Serbia","SRB","admin",0],
[1807868218,"Bosilovo","Bosilovo","Macedonia","MKD","admin",1069],
[1705370010,"Trbovlje","Trbovlje","Slovenia","SVN","admin",0],
[1705930549,"Ivančna Gorica","Ivancna Gorica","Slovenia","SVN","admin",0],
[1372867922,"Nenagh","Nenagh","Ireland","IRL","admin",0],
[1688701954,"Ub","Ub","Serbia","SRB","admin",0],
[1688437278,"Lučani","Lucani","Serbia","SRB","admin",0],
[1462436531,"Muli","Muli","Maldives","MDV","admin",0],
[1705651680,"Kobarid","Kobarid","Slovenia","SVN","admin",1085],
[1458460967,"Labuan","Labuan","Malaysia","MYS","admin",0],
[1499379378,"Andrijevica","Andrijevica","Montenegro","MNE","admin",1073],
[1422962727,"Halba","Halba","Lebanon","LBN","admin",0],
[1688211541,"Požega","Pozega","Serbia","SRB","admin",0],
[1454089137,"Neno","Neno","Malawi","MWI","admin",0],
[1108407022,"Isale","Isale","Burundi","BDI","admin",0],
[1705373506,"Šmarje","Smarje","Slovenia","SVN","admin",0],
[1404162576,"Siaya","Siaya","Kenya","KEN","admin",0],
[1704081536,"Điện Biên Phủ","Dien Bien Phu","Vietnam","VNM","admin",0],
[1834907448,"Mahonda","Mahonda","Tanzania","TZA","admin",0],
[1705775604,"Štore","Store","Slovenia","SVN","admin",0],
[1807382770,"Konče","Konce","Macedonia","MKD","admin",966],
[1705796422,"Kostanjevica na Krki","Kostanjevica na Krki","Slovenia","SVN","admin",689],
[1688107292,"Smederevska Palanka","Smederevska Palanka","Serbia","SRB","admin",0],
[1705820033,"Cerklje na Gorenjskem","Cerklje na Gorenjskem","Slovenia","SVN","admin",0],
[1454117674,"Kasungu","Kasungu","Malawi","MWI","admin",0],
[1705772825,"Rogaška Slatina","Rogaska Slatina","Slovenia","SVN","admin",0],
[1454343925,"Chikwawa","Chikwawa","Malawi","MWI","admin",0],
[1470602161,"San Lawrenz","San Lawrenz","Malta","MLT","admin",748],
[1705376916,"Šoštanj","Sostanj","Slovenia","SVN","admin",0],
[1800673440,"Namutumba","Namutumba","Uganda","UGA","admin",0],
[1462000001,"Fonadhoo","Fonadhoo","Maldives","MDV","admin",0],
[1372726111,"Port Laoise","Port Laoise","Ireland","IRL","admin",0],
[1108641885,"Rumonge","Rumonge","Burundi","BDI","admin",0],
[1688685780,"Babušnica","Babusnica","Serbia","SRB","admin",0],
[1688116678,"Vlasotince","Vlasotince","Serbia","SRB","admin",0],
[1688274240,"Ljubovija","Ljubovija","Serbia","SRB","admin",0],
[1462220750,"Manadhoo","Manadhoo","Maldives","MDV","admin",0],
[1688900219,"Lajkovac","Lajkovac","Serbia","SRB","admin",0],
[1807907483,"Rostuša","Rostusa","Macedonia","MKD","admin",872],
[1780875399,"Scarborough","Scarborough","Trinidad And Tobago","TTO","admin",0],
[1372007853,"An Cabhán","An Cabhan","Ireland","IRL","admin",0],
[1688365764,"Kosjerić","Kosjeric","Serbia","SRB","admin",0],
[1688862283,"Mionica","Mionica","Serbia","SRB","admin",0],
[1634786937,"Al Khawr","Al Khawr","Qatar","QAT","admin",0],
[1800764757,"Kaliro","Kaliro","Uganda","UGA","admin",0],
[1688276422,"Bela Palanka","Bela Palanka","Serbia","SRB","admin",0],
[1566322425,"Asaba","Asaba","Nigeria","NGA","admin",0],
[1516685856,"Eenhana","Eenhana","Namibia","NAM","admin",0],
[1800886754,"Amudat","Amudat","Uganda","UGA","admin",0],
[1012656497,"Aïn Defla","Ain Defla","Algeria","DZA","admin",0],
[1800276050,"Bukwo","Bukwo","Uganda","UGA","admin",0],
[1780534918,"Diego Martin","Diego Martin","Trinidad And Tobago","TTO","admin",0],
[1705746627,"Prebold","Prebold","Slovenia","SVN","admin",0],
[1478575433,"Sélibaby","Selibaby","Mauritania","MRT","admin",460],
[1780702349,"Point Fortin","Point Fortin","Trinidad And Tobago","TTO","admin",0],
[1400962992,"Mādabā","Madaba","Jordan","JOR","admin",0],
[1807758244,"Obleševo","Oblesevo","Macedonia","MKD","admin",673],
[1090844311,"Tulagi","Tulagi","Solomon Islands","SLB","admin",0],
[1470959100,"Imdina","Imdina","Malta","MLT","admin",292],
[1404228137,"Kapenguria","Kapenguria","Kenya","KEN","admin",0],
[1440054141,"Širvintos","Sirvintos","Lithuania","LTU","admin",744],
[1800035606,"Kibiito","Kibiito","Uganda","UGA","admin",0],
[1807575395,"Rankovce","Rankovce","Macedonia","MKD","admin",744],
[1807236473,"Petrovec","Petrovec","Macedonia","MKD","admin",580],
[1566468984,"Yenagoa","Yenagoa","Nigeria","NGA","admin",0],
[1191291148,"Varaždin","Varazdin","Croatia","HRV","admin",0],
[1634646507,"Umm Şalāl ‘Alī","Umm Salal `Ali","Qatar","QAT","admin",0],
[1548761183,"Lakatoro","Lakatoro","Vanuatu","VUT","admin",705],
[1800098358,"Kibuku","Kibuku","Uganda","UGA","admin",0],
[1688974283,"Sremska Mitrovica","Sremska Mitrovica","Serbia","SRB","admin",0],
[1234381324,"Hvalba","Hvalba","Faroe Islands","FRO","admin",713],
[1705244140,"Miklavž na Dravskem Polju","Miklavz na Dravskem Polju","Slovenia","SVN","admin",0],
[1031526251,"Qubadlı","Qubadli","Azerbaijan","AZE","admin",672],
[1780000001,"Aranguez","Aranguez","Trinidad And Tobago","TTO","admin",0],
[1800799569,"Maracha","Maracha","Uganda","UGA","admin",0],
[1705239053,"Mozirje","Mozirje","Slovenia","SVN","admin",0],
[1688653137,"Požarevac","Pozarevac","Serbia","SRB","admin",0],
[1688954602,"Krupanj","Krupanj","Serbia","SRB","admin",0],
[1704983526,"Lai Châu","Lai Chau","Vietnam","VNM","admin",0],
[1807568669,"Karbinci","Karbinci","Macedonia","MKD","admin",673],
[1807855424,"Vasilevo","Vasilevo","Macedonia","MKD","admin",630],
[1705144123,"Polzela","Polzela","Slovenia","SVN","admin",0],
[1096321221,"Bangar","Bangar","Brunei","BRN","admin",626],
[1688849183,"Knjaževac","Knjazevac","Serbia","SRB","admin",0],
[1704845487,"Đồng Xoài","Dong Xoai","Vietnam","VNM","admin",0],
[1132670996,"Picos","Picos","Cabo Verde","CPV","admin",0],
[1688564835,"Zaječar","Zajecar","Serbia","SRB","admin",0],
[1688523885,"Paraćin","Paracin","Serbia","SRB","admin",0],
[1528203421,"The Bottom","The Bottom","Netherlands","NLD","admin",495],
[1688169172,"Lebane","Lebane","Serbia","SRB","admin",0],
[1454644071,"Dowa","Dowa","Malawi","MWI","admin",0],
[1108176356,"Cibitoke","Cibitoke","Burundi","BDI","admin",0],
[1800745891,"Buikwe","Buikwe","Uganda","UGA","admin",0],
[1800935733,"Kagadi","Kagadi","Uganda","UGA","admin",0],
[1674314187,"Borgo Maggiore","Borgo Maggiore","San Marino","SMR","admin",0],
[1704933464,"Đà Lạt","Da Lat","Vietnam","VNM","admin",0],
[1800440664,"Binyin","Binyin","Uganda","UGA","admin",0],
[1470127050,"Għasri","Ghasri","Malta","MLT","admin",525],
[1688403125,"Rača","Raca","Serbia","SRB","admin",0],
[1012656063,"Mila","Mila","Algeria","DZA","admin",0],
[1800071156,"Bulambuli","Bulambuli","Uganda","UGA","admin",0],
[1116319433,"Suong","Suong","Cambodia","KHM","admin",0],
[1626766880,"Aileu","Aileu","Timor-Leste","TLS","admin",0],
[1807831162,"Makedonski Brod","Makedonski Brod","Macedonia","MKD","admin",567],
[1688039133,"Aleksinac","Aleksinac","Serbia","SRB","admin",0],
[1834695780,"Vwawa","Vwawa","Tanzania","TZA","admin",0],
[1438419168,"Planken","Planken","Liechtenstein","LIE","admin",478],
[1512959921,"Al Buraymī","Al Buraymi","Oman","OMN","admin",0],
[1705158152,"Medvode","Medvode","Slovenia","SVN","admin",0],
[1807782793,"Staro Nagoričane","Staro Nagoricane","Macedonia","MKD","admin",555],
[1688862457,"Osečina","Osecina","Serbia","SRB","admin",0],
[1807908017,"Demir Hisar","Demir Hisar","Macedonia","MKD","admin",543],
[1583964118,"Weno","Weno","Federated States of Micronesia","FSM","admin",0],
[1705295612,"Komenda","Komenda","Slovenia","SVN","admin",0],
[1158376441,"Jincheng","Jincheng","Taiwan","TWN","admin",0],
[1705190624,"Brezovica","Brezovica","Slovenia","SVN","admin",0],
[1705164835,"Šmartno","Smartno","Slovenia","SVN","admin",0],
[1705291500,"Moravče","Moravce","Slovenia","SVN","admin",0],
[1688388893,"Despotovac","Despotovac","Serbia","SRB","admin",0],
[1688018668,"Čajetina","Cajetina","Serbia","SRB","admin",0],
[1800633600,"Namayingo","Namayingo","Uganda","UGA","admin",0],
[1807681577,"Lozovo","Lozovo","Macedonia","MKD","admin",521],
[1800174030,"Apac","Apac","Uganda","UGA","admin",0],
[1705067758,"Škofljica","Skofljica","Slovenia","SVN","admin",0],
[1608131481,"Santa Cruz","Santa Cruz","Philippines","PHL","admin",0],
[1807323094,"Centar Župa","Centar Zupa","Macedonia","MKD","admin",466],
[1674267133,"Domagnano","Domagnano","San Marino","SMR","admin",0],
[1688555007,"Ljig","Ljig","Serbia","SRB","admin",0],
[1688349740,"Inđija","Indija","Serbia","SRB","admin",0],
[1705286007,"Poljčane","Poljcane","Slovenia","SVN","admin",0],
[1807040114,"Jegunovce","Jegunovce","Macedonia","MKD","admin",369],
[1705274788,"Mengeš","Menges","Slovenia","SVN","admin",0],
[1800710436,"Butebo","Butebo","Uganda","UGA","admin",0],
[1834376215,"Koani","Koani","Tanzania","TZA","admin",0],
[1705602247,"Tolmin","Tolmin","Slovenia","SVN","admin",0],
[1688871979,"Varvarin","Varvarin","Serbia","SRB","admin",0],
[1234929032,"Skopun","Skopun","Faroe Islands","FRO","admin",446],
[1090726690,"Buala","Buala","Solomon Islands","SLB","admin",0],
[1408000543,"Ŏgujin","Ogujin","North Korea","PRK","admin",0],
[1408680975,"Samga-ri","Samga-ri","North Korea","PRK","admin",0],
[1705170234,"Gornji Petrovci","Gornji Petrovci","Slovenia","SVN","admin",411],
[1705403351,"Preddvor","Preddvor","Slovenia","SVN","admin",0],
[1634539520,"Ash Shīḩānīyah","Ash Shihaniyah","Qatar","QAT","admin",0],
[1800154303,"Kiryandongo","Kiryandongo","Uganda","UGA","admin",0],
[1705598784,"Nazarje","Nazarje","Slovenia","SVN","admin",0],
[1704988146,"Kon Tum","Kon Tum","Vietnam","VNM","admin",0],
[1705764665,"Zreče","Zrece","Slovenia","SVN","admin",0],
[1674696011,"Acquaviva","Acquaviva","San Marino","SMR","admin",0],
[1800175659,"Busesa","Busesa","Uganda","UGA","admin",0],
[1800859767,"Butaleja","Butaleja","Uganda","UGA","admin",0],
[1705762040,"Dragomer","Dragomer","Slovenia","SVN","admin",0],
[1706027824,"Dhuusamarreeb","Dhuusamarreeb","Somalia","SOM","admin",447],
[1705608129,"Miren","Miren","Slovenia","SVN","admin",0],
[1807009322,"Brvenica","Brvenica","Macedonia","MKD","admin",449],
[1148787282,"Fada","Fada","Chad","TCD","admin",448],
[1807953626,"Belčišta","Belcista","Macedonia","MKD","admin",437],
[1705609332,"Radenci","Radenci","Slovenia","SVN","admin",0],
[1705953692,"Spodnji Duplek","Spodnji Duplek","Slovenia","SVN","admin",0],
[1688208441,"Crna Trava","Crna Trava","Serbia","SRB","admin",434],
[1688513998,"Mali Zvornik","Mali Zvornik","Serbia","SRB","admin",0],
[1705955833,"Kanal","Kanal","Slovenia","SVN","admin",0],
[1234436400,"Hvannasund","Hvannasund","Faroe Islands","FRO","admin",414],
[1882284139,"Afega","Afega","Samoa","WSM","admin",0],
[1705811179,"Tišina","Tisina","Slovenia","SVN","admin",408],
[1705459961,"Muta","Muta","Slovenia","SVN","admin",0],
[1800146127,"Bukomansimbi","Bukomansimbi","Uganda","UGA","admin",0],
[1204497206,"Dogbo","Dogbo","Benin","BEN","admin",0],
[1705864774,"Selnica ob Dravi","Selnica ob Dravi","Slovenia","SVN","admin",0],
[1674000001,"Fiorentino","Fiorentino","San Marino","SMR","admin",0],
[1800000051,"Luuka Town","Luuka Town","Uganda","UGA","admin",0],
[1705379997,"Spodnje Hoče","Spodnje Hoce","Slovenia","SVN","admin",0],
[1705083565,"Šentrupert","Sentrupert","Slovenia","SVN","admin",0],
[1807169470,"Dolneni","Dolneni","Macedonia","MKD","admin",375],
[1566879878,"Abakaliki","Abakaliki","Nigeria","NGA","admin",0],
[1705303708,"Ljutomer","Ljutomer","Slovenia","SVN","admin",0],
[1408685966,"Namsan","Namsan","North Korea","PRK","admin",0],
[1688233004,"Blace","Blace","Serbia","SRB","admin",0],
[1705849784,"Stari Trg","Stari Trg","Slovenia","SVN","admin",0],
[1688037789,"Ruma","Ruma","Serbia","SRB","admin",0],
[1688354392,"Doljevac","Doljevac","Serbia","SRB","admin",0],
[1132720315,"Pombas","Pombas","Cabo Verde","CPV","admin",0],
[1634890537,"Az̧ Z̧a‘āyin","Az Za`ayin","Qatar","QAT","admin",0],
[1688299986,"Batočina","Batocina","Serbia","SRB","admin",0],
[1404648092,"Mwatate","Mwatate","Kenya","KEN","admin",0],
[1583511563,"Colonia","Colonia","Federated States of Micronesia","FSM","admin",0],
[1332665283,"Miragoâne","Miragoane","Haiti","HTI","admin",0],
[1901875540,"Ferizaj","Ferizaj","Kosovo","XKS","admin",0],
[1705643433,"Rače","Race","Slovenia","SVN","admin",0],
[1705968659,"Šenčur","Sencur","Slovenia","SVN","admin",0],
[1705182651,"Oplotnica","Oplotnica","Slovenia","SVN","admin",0],
[1780510715,"Debe","Debe","Trinidad And Tobago","TTO","admin",0],
[1404304549,"Wote","Wote","Kenya","KEN","admin",0],
[1800171092,"Serere","Serere","Uganda","UGA","admin",0],
[1800293674,"Zombo","Zombo","Uganda","UGA","admin",0],
[1800519756,"Nsiika","Nsiika","Uganda","UGA","admin",0],
[1478247793,"Akjoujt","Akjoujt","Mauritania","MRT","admin",370],
[1705804130,"Šmartno","Smartno","Slovenia","SVN","admin",0],
[1688309283,"Negotin","Negotin","Serbia","SRB","admin",0],
[1372149317,"Lifford","Lifford","Ireland","IRL","admin",0],
[1800066560,"Rubanda","Rubanda","Uganda","UGA","admin",0],
[1887607369,"Aḑ Ḑāli‘","Ad Dali`","Yemen","YEM","admin",0],
[1404265412,"Kajiado","Kajiado","Kenya","KEN","admin",0],
[1800001909,"Ntara","Ntara","Uganda","UGA","admin",0],
[1204601704,"Sakété","Sakete","Benin","BEN","admin",0],
[1705033855,"Mirna","Mirna","Slovenia","SVN","admin",0],
[1901360309,"Prizren","Prizren","Kosovo","XKS","admin",0],
[1548941443,"Isangel","Isangel","Vanuatu","VUT","admin",0],
[1705641346,"Bistrica ob Sotli","Bistrica ob Sotli","Slovenia","SVN","admin",235],
[1674000002,"Montegiardino","Montegiardino","San Marino","SMR","admin",0],
[1768366976,"Dapaong","Dapaong","Togo","TGO","admin",0],
[1234200740,"Toftir","Toftir","Faroe Islands","FRO","admin",0],
[1800770335,"Kalungu","Kalungu","Uganda","UGA","admin",0],
[1800982268,"Rukungiri","Rukungiri","Uganda","UGA","admin",0],
[1710114438,"Nelspruit","Nelspruit","South Africa","ZAF","admin",0],
[1705925648,"Vitanje","Vitanje","Slovenia","SVN","admin",0],
[1800740334,"Bushenyi","Bushenyi","Uganda","UGA","admin",0],
[1116989175,"Samraong","Samraong","Cambodia","KHM","admin",0],
[1191924250,"Koprivnica","Koprivnica","Croatia","HRV","admin",0],
[1800068643,"Gombe","Gombe","Uganda","UGA","admin",0],
[1800715667,"Kanungu","Kanungu","Uganda","UGA","admin",0],
[1800358976,"Bupoto","Bupoto","Uganda","UGA","admin",0],
[1807969277,"Čučer-Sandevo","Cucer-Sandevo","Macedonia","MKD","admin",274],
[1688050059,"Veliko Gradište","Veliko Gradiste","Serbia","SRB","admin",0],
[1234757268,"Porkeri","Porkeri","Faroe Islands","FRO","admin",297],
[1705579021,"Rogatec","Rogatec","Slovenia","SVN","admin",0],
[1705243858,"Horjul","Horjul","Slovenia","SVN","admin",0],
[1470880833,"Santa Luċija","Santa Lucija","Malta","MLT","admin",0],
[1688139023,"Dimitrovgrad","Dimitrovgrad","Serbia","SRB","admin",0],
[1887910100,"Al Jabīn","Al Jabin","Yemen","YEM","admin",0],
[1705709650,"Pivka","Pivka","Slovenia","SVN","admin",0],
[1800947890,"Rubirizi","Rubirizi","Uganda","UGA","admin",0],
[1688536735,"Velika Plana","Velika Plana","Serbia","SRB","admin",0],
[1688674789,"Petrovac na Mlavi","Petrovac na Mlavi","Serbia","SRB","admin",0],
[1688007802,"Svilajnac","Svilajnac","Serbia","SRB","admin",0],
[1688076013,"Boljevac","Boljevac","Serbia","SRB","admin",0],
[1800420914,"Kyenjojo","Kyenjojo","Uganda","UGA","admin",0],
[1807765797,"Zelenikovo","Zelenikovo","Macedonia","MKD","admin",272],
[1800719333,"Kyegegwa","Kyegegwa","Uganda","UGA","admin",0],
[1478607377,"Kaédi","Kaedi","Mauritania","MRT","admin",0],
[1705126731,"Braslovče","Braslovce","Slovenia","SVN","admin",0],
[1800826218,"Kole","Kole","Uganda","UGA","admin",0],
[1800636734,"Ibanda","Ibanda","Uganda","UGA","admin",0],
[1404459814,"Narok","Narok","Kenya","KEN","admin",0],
[1800842426,"Bulisa","Bulisa","Uganda","UGA","admin",0],
[1012109892,"Ouled Djellal","Ouled Djellal","Algeria","DZA","admin",0],
[1554847194,"Waitangi","Waitangi","New Zealand","NZL","admin",177],
[1499952005,"Tivat","Tivat","Montenegro","MNE","admin",0],
[1688823592,"Kladovo","Kladovo","Serbia","SRB","admin",0],
[1705353787,"Dobrna","Dobrna","Slovenia","SVN","admin",0],
[1705389455,"Pesnica","Pesnica","Slovenia","SVN","admin",0],
[1705561619,"Gorišnica","Gorisnica","Slovenia","SVN","admin",0],
[1705042629,"Luče","Luce","Slovenia","SVN","admin",0],
[1705681768,"Videm pri Ptuju","Videm pri Ptuju","Slovenia","SVN","admin",0],
[1800207938,"Mparo","Mparo","Uganda","UGA","admin",0],
[1688866909,"Stara Pazova","Stara Pazova","Serbia","SRB","admin",0],
[1180158365,"Kenge","Kenge","Congo (Kinshasa)","COD","admin",241],
[1800173507,"Mitoma","Mitoma","Uganda","UGA","admin",0],
[1688899483,"Šid","Sid","Serbia","SRB","admin",0],
[1705376318,"Lovrenc na Pohorju","Lovrenc na Pohorju","Slovenia","SVN","admin",0],
[1705275257,"Logatec","Logatec","Slovenia","SVN","admin",0],
[1705127725,"Črna na Koroškem","Crna na Koroskem","Slovenia","SVN","admin",0],
[1800687979,"Bukedea","Bukedea","Uganda","UGA","admin",0],
[1800458737,"Amolatar","Amolatar","Uganda","UGA","admin",0],
[1705675272,"Ribnica","Ribnica","Slovenia","SVN","admin",0],
[1404930645,"Ol Kalou","Ol Kalou","Kenya","KEN","admin",0],
[1800794590,"Kasanda","Kasanda","Uganda","UGA","admin",0],
[1705147774,"Majšperk","Majsperk","Slovenia","SVN","admin",0],
[1800217765,"Kasaali","Kasaali","Uganda","UGA","admin",0],
[1705616966,"Vransko","Vransko","Slovenia","SVN","admin",0],
[1705840723,"Šentilj","Sentilj","Slovenia","SVN","admin",0],
[1688559807,"Bojnik","Bojnik","Serbia","SRB","admin",0],
[1800478941,"Dokolo","Dokolo","Uganda","UGA","admin",0],
[1470804129,"Żebbuġ","Zebbug","Malta","MLT","admin",0],
[1800894285,"Kakumiro","Kakumiro","Uganda","UGA","admin",0],
[1807040075,"Želino","Zelino","Macedonia","MKD","admin",105],
[1705707595,"Trzin","Trzin","Slovenia","SVN","admin",0],
[1800497536,"Sembabule","Sembabule","Uganda","UGA","admin",0],
[1705226459,"Dobrovo","Dobrovo","Slovenia","SVN","admin",0],
[1800039440,"Rakai","Rakai","Uganda","UGA","admin",0],
[1901031751,"Gllogovc","Gllogovc","Kosovo","XKS","admin",0],
[1901235642,"Gjilan","Gjilan","Kosovo","XKS","admin",0],
[1901138430,"Mitrovicë","Mitrovice","Kosovo","XKS","admin",0],
[1031540160,"Heydərabad","Heydarabad","Azerbaijan","AZE","admin",0],
[1807279534,"Bogovinje","Bogovinje","Macedonia","MKD","admin",25],
[1705409266,"Ig","Ig","Slovenia","SVN","admin",0],
[1800009674,"Kinoni","Kinoni","Uganda","UGA","admin",0],
[1364501878,"Sārī","Sari","Iran","IRN","admin",0],
[1901102771,"Obiliq","Obiliq","Kosovo","XKS","admin",0],
[1901336358,"Rahovec","Rahovec","Kosovo","XKS","admin",0],
[1705554055,"Tržič","Trzic","Slovenia","SVN","admin",0],
[1608108139,"Koronadal","Koronadal","Philippines","PHL","admin",0],
[1800484853,"Kibingo","Kibingo","Uganda","UGA","admin",0],
[1705082644,"Rečica","Recica","Slovenia","SVN","admin",0],
[1516000004,"Omuthiya","Omuthiya","Namibia","NAM","admin",0],
[1705717325,"Dol","Dol","Slovenia","SVN","admin",0],
[1678998597,"Guadalupe","Guadalupe","Sao Tome And Principe","STP","admin",0],
[1116050327,"Pailin","Pailin","Cambodia","KHM","admin",0],
[1901107642,"Vushtrri","Vushtrri","Kosovo","XKS","admin",0],
[1807047160,"Studeničani","Studenicani","Macedonia","MKD","admin",59],
[1882782502,"Leulumoega","Leulumoega","Samoa","WSM","admin",0],
[1800583650,"Lwengo","Lwengo","Uganda","UGA","admin",0],
[1800001908,"Butalangu","Butalangu","Uganda","UGA","admin",0],
[1288222236,"Techiman","Techiman","Ghana","GHA","admin",0],
[1768768827,"Kara","Kara","Togo","TGO","admin",0],
[1800973979,"Kanoni","Kanoni","Uganda","UGA","admin",0],
[1704361005,"Gia Nghĩa","Gia Nghia","Vietnam","VNM","admin",0],
[1800244501,"Alebtong","Alebtong","Uganda","UGA","admin",0],
[1688000008,"Topola","Topola","Serbia","SRB","admin",0],
[1626458227,"Suai","Suai","Timor-Leste","TLS","admin",0],
[1705961189,"Gorenja Vas","Gorenja Vas","Slovenia","SVN","admin",0],
[1705023699,"Dornava","Dornava","Slovenia","SVN","admin",0],
[1626175417,"Pante Macassar","Pante Macassar","Timor-Leste","TLS","admin",0],
[1598823962,"Kokopo","Kokopo","Papua New Guinea","PNG","admin",0],
[1705885002,"Železniki","Zelezniki","Slovenia","SVN","admin",0],
[1072070629,"Ramotswa","Ramotswa","Botswana","BWA","admin",0],
[1800838006,"Amuria","Amuria","Uganda","UGA","admin",0],
[1800199589,"Abim","Abim","Uganda","UGA","admin",0],
[1800020551,"Ngora","Ngora","Uganda","UGA","admin",0],
[1705829201,"Lukovica","Lukovica","Slovenia","SVN","admin",0],
[1800972565,"Kalaki","Kalaki","Uganda","UGA","admin",0],
[1901682048,"Lipjan","Lipjan","Kosovo","XKS","admin",0],
[1705851676,"Turnišče","Turnisce","Slovenia","SVN","admin",0],
[1434450111,"Al ‘Azīzīyah","Al `Aziziyah","Libya","LBY","admin",0],
[1901918563,"Suharekë","Suhareke","Kosovo","XKS","admin",0],
[1705759580,"Cerkno","Cerkno","Slovenia","SVN","admin",0],
[1705361649,"Šmarješke Toplice","Smarjeske Toplice","Slovenia","SVN","admin",0],
[1674546686,"Chiesanuova","Chiesanuova","San Marino","SMR","admin",0],
[1234473077,"Saltangará","Saltangara","Faroe Islands","FRO","admin",0],
[1800010095,"Kamwenge","Kamwenge","Uganda","UGA","admin",0],
[1882029963,"Mulifanua","Mulifanua","Samoa","WSM","admin",0],
[1705083617,"Ljubno","Ljubno","Slovenia","SVN","admin",0],
[1626878399,"Lospalos","Lospalos","Timor-Leste","TLS","admin",0],
[1705094350,"Bohinjska Bistrica","Bohinjska Bistrica","Slovenia","SVN","admin",0],
[1705557844,"Starše","Starse","Slovenia","SVN","admin",0],
[1800843586,"Isingiro","Isingiro","Uganda","UGA","admin",0],
[1807767601,"Ilinden","Ilinden","Macedonia","MKD","admin",0],
[1705756002,"Tabor","Tabor","Slovenia","SVN","admin",0],
[1729452233,"Rabak","Rabak","Sudan","SDN","admin",0],
[1705321982,"Kidričevo","Kidricevo","Slovenia","SVN","admin",0],
[1064617460,"Tsirang","Tsirang","Bhutan","BTN","admin",0],
[1901089874,"Gjakovë","Gjakove","Kosovo","XKS","admin",0],
[1096181037,"Tutong","Tutong","Brunei","BRN","admin",0],
[1705065298,"Divača","Divaca","Slovenia","SVN","admin",0],
[1404769042,"Kwale","Kwale","Kenya","KEN","admin",0],
[1705832384,"Sveti Jurij","Sveti Jurij","Slovenia","SVN","admin",0],
[1678081464,"Santana","Santana","Sao Tome And Principe","STP","admin",0],
[1674994606,"Faetano","Faetano","San Marino","SMR","admin",0],
[1191353181,"Požega","Pozega","Croatia","HRV","admin",0],
[1705491164,"Straža","Straza","Slovenia","SVN","admin",0],
[1410002592,"Sejong","Sejong","South Korea","KOR","admin",0],
[1688733340,"Merošina","Merosina","Serbia","SRB","admin",0],
[1780714817,"Princes Town","Princes Town","Trinidad And Tobago","TTO","admin",0],
[1901339694,"Pejë","Peje","Kosovo","XKS","admin",0],
[1901328795,"Viti","Viti","Kosovo","XKS","admin",0],
[1688171551,"Temerin","Temerin","Serbia","SRB","admin",0],
[1705523597,"Benedikt","Benedikt","Slovenia","SVN","admin",0],
[1705653513,"Semič","Semic","Slovenia","SVN","admin",0],
[1705650900,"Cirkulane","Cirkulane","Slovenia","SVN","admin",0],
[1705728443,"Vodice","Vodice","Slovenia","SVN","admin",0],
[1516271813,"Nkurenkuru","Nkurenkuru","Namibia","NAM","admin",0],
[1288994228,"Sefwi Wiawso","Sefwi Wiawso","Ghana","GHA","admin",0],
[1705062986,"Sveta Ana","Sveta Ana","Slovenia","SVN","admin",0],
[1404005234,"Rumuruti","Rumuruti","Kenya","KEN","admin",0],
[1410822139,"Hongseong","Hongseong","South Korea","KOR","admin",0],
[1442283324,"Mersch","Mersch","Luxembourg","LUX","admin",0],
[1410001061,"Muan","Muan","South Korea","KOR","admin",0],
[1705701553,"Nova Vas","Nova Vas","Slovenia","SVN","admin",0],
[1705893552,"Zgornja Hajdina","Zgornja Hajdina","Slovenia","SVN","admin",0],
[1901200321,"Kaçanik","Kacanik","Kosovo","XKS","admin",0],
[1705096910,"Mirna Peč","Mirna Pec","Slovenia","SVN","admin",0],
[1800567800,"Buyende","Buyende","Uganda","UGA","admin",0],
[1499325970,"Tuzi","Tuzi","Montenegro","MNE","admin",0],
[1384048438,"Bangolo","Bangolo","Côte d'Ivoire","CIV","admin",0],
[1548907051,"Saratamata","Saratamata","Vanuatu","VUT","admin",0],
[1901259570,"Skenderaj","Skenderaj","Kosovo","XKS","admin",0],
[1234814533,"Strendur","Strendur","Faroe Islands","FRO","admin",0],
[1598000045,"Kurumul","Kurumul","Papua New Guinea","PNG","admin",0],
[1800679810,"Palenga","Palenga","Uganda","UGA","admin",0],
[1705659496,"Sveta Trojica v Slovenskih Goricah","Sveta Trojica v Slovenskih Goricah","Slovenia","SVN","admin",0],
[1705104301,"Zgornja Kungota","Zgornja Kungota","Slovenia","SVN","admin",0],
[1800495740,"Lamwo","Lamwo","Uganda","UGA","admin",0],
[1800867016,"Oyam","Oyam","Uganda","UGA","admin",0],
[1688477275,"Kula","Kula","Serbia","SRB","admin",0],
[1705579309,"Destrnik","Destrnik","Slovenia","SVN","admin",0],
[1132137257,"Ponta do Sol","Ponta do Sol","Cabo Verde","CPV","admin",0],
[1901550082,"Podujevë","Podujeve","Kosovo","XKS","admin",0],
[1740222585,"Lelydorp","Lelydorp","Suriname","SUR","admin",0],
[1688081748,"Apatin","Apatin","Serbia","SRB","admin",0],
[1705653264,"Dobrova","Dobrova","Slovenia","SVN","admin",0],
[1705304446,"Makole","Makole","Slovenia","SVN","admin",0],
[1688262057,"Žitorađa","Zitorada","Serbia","SRB","admin",0],
[1705493301,"Markovci","Markovci","Slovenia","SVN","admin",0],
[1705698578,"Črenšovci","Crensovci","Slovenia","SVN","admin",0],
[1901208362,"Zveçan","Zvecan","Kosovo","XKS","admin",0],
[1688830508,"Kovin","Kovin","Serbia","SRB","admin",0],
[1688585119,"Koceljeva","Koceljeva","Serbia","SRB","admin",0],
[1705529436,"Veržej","Verzej","Slovenia","SVN","admin",0],
[1705618557,"Velike Lašče","Velike Lasce","Slovenia","SVN","admin",0],
[1705138690,"Križevci","Krizevci","Slovenia","SVN","admin",0],
[1800321499,"Agago","Agago","Uganda","UGA","admin",0],
[1705276725,"Razkrižje","Razkrizje","Slovenia","SVN","admin",0],
[1705940381,"Škocjan","Skocjan","Slovenia","SVN","admin",0],
[1388124588,"Morant Bay","Morant Bay","Jamaica","JAM","admin",0],
[1807304153,"Star Dojran","Star Dojran","Macedonia","MKD","admin",105],
[1705027920,"Žužemberk","Zuzemberk","Slovenia","SVN","admin",0],
[1705677747,"Puconci","Puconci","Slovenia","SVN","admin",0],
[1634762661,"Madīnat ash Shamāl","Madinat ash Shamal","Qatar","QAT","admin",0],
[1688569895,"Gadžin Han","Gadzin Han","Serbia","SRB","admin",0],
[1705074870,"Videm","Videm","Slovenia","SVN","admin",0],
[1688834584,"Ćićevac","Cicevac","Serbia","SRB","admin",0],
[1688856329,"Pećinci","Pecinci","Serbia","SRB","admin",0],
[1705477555,"Zavrč","Zavrc","Slovenia","SVN","admin",0],
[1064208677,"Mongar","Mongar","Bhutan","BTN","admin",0],
[1364655025,"Īlām","Ilam","Iran","IRN","admin",0],
[1031240282,"Qazax","Qazax","Azerbaijan","AZE","admin",0],
[1807754347,"Lipkovo","Lipkovo","Macedonia","MKD","admin",0],
[1688870763,"Bosilegrad","Bosilegrad","Serbia","SRB","admin",0],
[1598669271,"Tari","Tari","Papua New Guinea","PNG","admin",0],
[1705627212,"Velika Polana","Velika Polana","Slovenia","SVN","admin",0],
[1705097170,"Cankova","Cankova","Slovenia","SVN","admin",0],
[1688070989,"Vladimirci","Vladimirci","Serbia","SRB","admin",0],
[1064717667,"Haa","Haa","Bhutan","BTN","admin",0],
[1729951108,"Singa","Singa","Sudan","SDN","admin",0],
[1688323517,"Ražanj","Razanj","Serbia","SRB","admin",0],
[1234871801,"Tvøroyri","Tvoroyri","Faroe Islands","FRO","admin",0],
[1694778676,"Port Loko","Port Loko","Sierra Leone","SLE","admin",0],
[1004180853,"Pul-e ‘Alam","Pul-e `Alam","Afghanistan","AFG","admin",0],
[1901445768,"Kllokot","Kllokot","Kosovo","XKS","admin",0],
[1688495771,"Kučevo","Kucevo","Serbia","SRB","admin",0],
[1706767209,"Boorama","Boorama","Somalia","SOM","admin",0],
[1705031068,"Komen","Komen","Slovenia","SVN","admin",0],
[1705285338,"Apače","Apace","Slovenia","SVN","admin",0],
[1705411351,"Kuzma","Kuzma","Slovenia","SVN","admin",0],
[1608435522,"San Jose","San Jose","Philippines","PHL","admin",0],
[1800784014,"Napak","Napak","Uganda","UGA","admin",0],
[1686807341,"Kaffrine","Kaffrine","Senegal","SEN","admin",0],
[1004273142,"Sharan","Sharan","Afghanistan","AFG","admin",0],
[1901248770,"Istog","Istog","Kosovo","XKS","admin",0],
[1705879741,"Gornji Grad","Gornji Grad","Slovenia","SVN","admin",0],
[1191389404,"Krapina","Krapina","Croatia","HRV","admin",0],
[1688176320,"Plandište","Plandiste","Serbia","SRB","admin",0],
[1288521614,"Dambai","Dambai","Ghana","GHA","admin",0],
[1705808302,"Cerkvenjak","Cerkvenjak","Slovenia","SVN","admin",0],
[1688014462,"Medveđa","Medveda","Serbia","SRB","admin",0],
[1288616024,"Goaso","Goaso","Ghana","GHA","admin",0],
[1512602960,"Şuḩār","Suhar","Oman","OMN","admin",0],
[1031386825,"Şərur","Sarur","Azerbaijan","AZE","admin",0],
[1705613407,"Središče ob Dravi","Sredisce ob Dravi","Slovenia","SVN","admin",0],
[1442099691,"Redange-sur-Attert","Redange-sur-Attert","Luxembourg","LUX","admin",0],
[1705262198,"Juršinci","Jursinci","Slovenia","SVN","admin",0],
[1854285570,"Gaoua","Gaoua","Burkina Faso","BFA","admin",0],
[1705395845,"Dolenjske Toplice","Dolenjske Toplice","Slovenia","SVN","admin",0],
[1705548274,"Kozje","Kozje","Slovenia","SVN","admin",0],
[1498580757,"Cocieri","Cocieri","Moldova","MDA","admin",0],
[1705261000,"Podčetrtek","Podcetrtek","Slovenia","SVN","admin",0],
[1705336506,"Mokronog","Mokronog","Slovenia","SVN","admin",0],
[1234308038,"Fuglafjørður","Fuglafjordhur","Faroe Islands","FRO","admin",0],
[1688492797,"Bečej","Becej","Serbia","SRB","admin",0],
[1882092632,"Lufilufi","Lufilufi","Samoa","WSM","admin",0],
[1288845503,"Nalerigu","Nalerigu","Ghana","GHA","admin",0],
[1780469686,"Sangre Grande","Sangre Grande","Trinidad And Tobago","TTO","admin",0],
[1234221310,"Fámjin","Famjin","Faroe Islands","FRO","admin",83],
[1528693863,"Kralendijk","Kralendijk","Netherlands","NLD","admin",0],
[1705342044,"Zgornje Gorje","Zgornje Gorje","Slovenia","SVN","admin",0],
[1705970248,"Rogašovci","Rogasovci","Slovenia","SVN","admin",0],
[1688371736,"Opovo","Opovo","Serbia","SRB","admin",0],
[1705830999,"Ribnica","Ribnica","Slovenia","SVN","admin",0],
[1499573612,"Kotor","Kotor","Montenegro","MNE","admin",0],
[1688955843,"Rekovac","Rekovac","Serbia","SRB","admin",0],
[1688545619,"Knić","Knic","Serbia","SRB","admin",0],
[1705352359,"Podlehnik","Podlehnik","Slovenia","SVN","admin",0],
[1705295579,"Sodražica","Sodrazica","Slovenia","SVN","admin",0],
[1748301792,"Nhlangano","Nhlangano","Swaziland","SWZ","admin",0],
[1004642532,"Nīlī","Nili","Afghanistan","AFG","admin",0],
[1705653481,"Vitomarci","Vitomarci","Slovenia","SVN","admin",0],
[1328483798,"Fort Wellington","Fort Wellington","Guyana","GUY","admin",0],
[1064656050,"Samdrup Jongkhar","Samdrup Jongkhar","Bhutan","BTN","admin",0],
[1705839708,"Osilnica","Osilnica","Slovenia","SVN","admin",0],
[1608980358,"Tabuk","Tabuk","Philippines","PHL","admin",0],
[1064362339,"Sarpang","Sarpang","Bhutan","BTN","admin",0],
[1800577877,"Nabilatuk","Nabilatuk","Uganda","UGA","admin",0],
[1678563060,"Neves","Neves","Sao Tome And Principe","STP","admin",0],
[1688633486,"Titel","Titel","Serbia","SRB","admin",0],
[1132634480,"Nova Sintra","Nova Sintra","Cabo Verde","CPV","admin",0],
[1901112530,"Dragash","Dragash","Kosovo","XKS","admin",0],
[1705288408,"Jurovski Dol","Jurovski Dol","Slovenia","SVN","admin",0],
[1729512354,"Ed Daein","Ed Daein","Sudan","SDN","admin",0],
[1064123227,"Trashigang","Trashigang","Bhutan","BTN","admin",0],
[1686107428,"Sédhiou","Sedhiou","Senegal","SEN","admin",0],
[1440724133,"Pagėgiai","Pagegiai","Lithuania","LTU","admin",57],
[1705654373,"Trnovska Vas","Trnovska Vas","Slovenia","SVN","admin",0],
[1031787201,"Qəbələ","Qabala","Azerbaijan","AZE","admin",0],
[1498087659,"Şoldăneşti","Soldanesti","Moldova","MDA","admin",0],
[1064215849,"Pemagatshel","Pemagatshel","Bhutan","BTN","admin",0],
[1705126489,"Moravske-Toplice","Moravske-Toplice","Slovenia","SVN","admin",0],
[1360687242,"Mamuju","Mamuju","Indonesia","IDN","admin",0],
[1132174768,"Igreja","Igreja","Cabo Verde","CPV","admin",0],
[1705523444,"Podvelka","Podvelka","Slovenia","SVN","admin",0],
[1204628914,"Savalou","Savalou","Benin","BEN","admin",0],
[1800198933,"Kiruhura","Kiruhura","Uganda","UGA","admin",0],
[1728713745,"Kuacjok","Kuacjok","South Sudan","SSD","admin",0],
[1688905613,"Sečanj","Secanj","Serbia","SRB","admin",0],
[1234642477,"Vágur","Vagur","Faroe Islands","FRO","admin",0],
[1430503114,"Tubmanburg","Tubmanburg","Liberia","LBR","admin",0],
[1031823379,"Göygöl","Goygol","Azerbaijan","AZE","admin",0],
[1706832021,"Hargeysa","Hargeysa","Somalia","SOM","admin",0],
[1882524892,"Safotulafai","Safotulafai","Samoa","WSM","admin",0],
[1426361264,"Qacha’s Nek","Qacha's Nek","Lesotho","LSO","admin",0],
[1705837424,"Tomaž pri Ormožu","Tomaz pri Ormozu","Slovenia","SVN","admin",0],
[1498766864,"Ştefan Vodă","Stefan Voda","Moldova","MDA","admin",0],
[1705033390,"Grad","Grad","Slovenia","SVN","admin",0],
[1686919750,"Matam","Matam","Senegal","SEN","admin",0],
[1688661944,"Žabari","Zabari","Serbia","SRB","admin",0],
[1688544172,"Malo Crniće","Malo Crnice","Serbia","SRB","admin",0],
[1688431448,"Srbobran","Srbobran","Serbia","SRB","admin",0],
[1800371285,"Kotido","Kotido","Uganda","UGA","admin",0],
[1064167489,"Tsimasham","Tsimasham","Bhutan","BTN","admin",0],
[1191654566,"Pazin","Pazin","Croatia","HRV","admin",0],
[1148687410,"Pala","Pala","Chad","TCD","admin",0],
[1901828239,"Shtërpcë","Shterpce","Kosovo","XKS","admin",0],
[1705204927,"Dobje","Dobje","Slovenia","SVN","admin",0],
[1800205431,"Nwoya","Nwoya","Uganda","UGA","admin",0],
[1705602796,"Dobrovnik","Dobrovnik","Slovenia","SVN","admin",0],
[1688501809,"Mali Iđoš","Mali Idos","Serbia","SRB","admin",0],
[1496141284,"Dalandzadgad","Dalandzadgad","Mongolia","MNG","admin",0],
[1004374554,"Bāzārak","Bazarak","Afghanistan","AFG","admin",0],
[1688363591,"Žitište","Zitiste","Serbia","SRB","admin",0],
[1800105199,"Pader","Pader","Uganda","UGA","admin",0],
[1688706489,"Novi Kneževac","Novi Knezevac","Serbia","SRB","admin",0],
[1800657796,"Otuke","Otuke","Uganda","UGA","admin",0],
[1780883666,"Rio Claro","Rio Claro","Trinidad And Tobago","TTO","admin",0],
[1031053363,"Dəvəçi","Davaci","Azerbaijan","AZE","admin",0],
[1012153214,"El Meghaïer","El Meghaier","Algeria","DZA","admin",0],
[1031050255,"Qıvraq","Qivraq","Azerbaijan","AZE","admin",0],
[1234729250,"Norðragøta","Nordhragota","Faroe Islands","FRO","admin",0],
[1901608808,"Zubin Potok","Zubin Potok","Kosovo","XKS","admin",0],
[1499532482,"Petnjica","Petnjica","Montenegro","MNE","admin",0],
[1876731744,"Leava","Leava","Wallis And Futuna","WLF","admin",0],
[1598000066,"Buka","Buka","Papua New Guinea","PNG","admin",0],
[1418294155,"Anouvông","Anouvong","Laos","LAO","admin",0],
[1705898157,"Mislinja","Mislinja","Slovenia","SVN","admin",0],
[1688588712,"Novi Bečej","Novi Becej","Serbia","SRB","admin",0],
[1499538261,"Danilovgrad","Danilovgrad","Montenegro","MNE","admin",0],
[1512376854,"Ar Rustāq","Ar Rustaq","Oman","OMN","admin",0],
[1800642608,"Amuru","Amuru","Uganda","UGA","admin",0],
[1882468874,"Samamea","Samamea","Samoa","WSM","admin",0],
[1800663685,"Nakapiripirit","Nakapiripirit","Uganda","UGA","admin",0]
]
